"use client";
var Xv = Object.defineProperty;
var Zv = (t, e, n) => e in t ? Xv(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var Re = (t, e, n) => Zv(t, typeof e != "symbol" ? e + "" : e, n);
import * as f from "react";
import q, { createElement as fr, forwardRef as jp, useState as Fn, useEffect as $n, useLayoutEffect as Jv, createContext as Qv, useMemo as ad, useRef as mn, useCallback as rn, useContext as Ki, useSyncExternalStore as Lp } from "react";
import * as Vt from "react-dom";
import $p from "react-dom";
var Ts = { exports: {} }, Pr = {};
var ld;
function ey() {
  if (ld) return Pr;
  ld = 1;
  var t = /* @__PURE__ */ Symbol.for("react.transitional.element"), e = /* @__PURE__ */ Symbol.for("react.fragment");
  function n(o, r, s) {
    var i = null;
    if (s !== void 0 && (i = "" + s), r.key !== void 0 && (i = "" + r.key), "key" in r) {
      s = {};
      for (var a in r)
        a !== "key" && (s[a] = r[a]);
    } else s = r;
    return r = s.ref, {
      $$typeof: t,
      type: o,
      key: i,
      ref: r !== void 0 ? r : null,
      props: s
    };
  }
  return Pr.Fragment = e, Pr.jsx = n, Pr.jsxs = n, Pr;
}
var Ar = {};
var cd;
function ty() {
  return cd || (cd = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(P) {
      if (P == null) return null;
      if (typeof P == "function")
        return P.$$typeof === F ? null : P.displayName || P.name || null;
      if (typeof P == "string") return P;
      switch (P) {
        case y:
          return "Fragment";
        case x:
          return "Profiler";
        case v:
          return "StrictMode";
        case C:
          return "Suspense";
        case _:
          return "SuspenseList";
        case j:
          return "Activity";
      }
      if (typeof P == "object")
        switch (typeof P.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), P.$$typeof) {
          case g:
            return "Portal";
          case E:
            return P.displayName || "Context";
          case w:
            return (P._context.displayName || "Context") + ".Consumer";
          case S:
            var V = P.render;
            return P = P.displayName, P || (P = V.displayName || V.name || "", P = P !== "" ? "ForwardRef(" + P + ")" : "ForwardRef"), P;
          case R:
            return V = P.displayName || null, V !== null ? V : t(P.type) || "Memo";
          case O:
            V = P._payload, P = P._init;
            try {
              return t(P(V));
            } catch {
            }
        }
      return null;
    }
    function e(P) {
      return "" + P;
    }
    function n(P) {
      try {
        e(P);
        var V = !1;
      } catch {
        V = !0;
      }
      if (V) {
        V = console;
        var I = V.error, D = typeof Symbol == "function" && Symbol.toStringTag && P[Symbol.toStringTag] || P.constructor.name || "Object";
        return I.call(
          V,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          D
        ), e(P);
      }
    }
    function o(P) {
      if (P === y) return "<>";
      if (typeof P == "object" && P !== null && P.$$typeof === O)
        return "<...>";
      try {
        var V = t(P);
        return V ? "<" + V + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function r() {
      var P = N.A;
      return P === null ? null : P.getOwner();
    }
    function s() {
      return Error("react-stack-top-frame");
    }
    function i(P) {
      if (T.call(P, "key")) {
        var V = Object.getOwnPropertyDescriptor(P, "key").get;
        if (V && V.isReactWarning) return !1;
      }
      return P.key !== void 0;
    }
    function a(P, V) {
      function I() {
        A || (A = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          V
        ));
      }
      I.isReactWarning = !0, Object.defineProperty(P, "key", {
        get: I,
        configurable: !0
      });
    }
    function l() {
      var P = t(this.type);
      return $[P] || ($[P] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), P = this.props.ref, P !== void 0 ? P : null;
    }
    function c(P, V, I, D, z, U) {
      var G = I.ref;
      return P = {
        $$typeof: h,
        type: P,
        key: V,
        props: I,
        _owner: D
      }, (G !== void 0 ? G : null) !== null ? Object.defineProperty(P, "ref", {
        enumerable: !1,
        get: l
      }) : Object.defineProperty(P, "ref", { enumerable: !1, value: null }), P._store = {}, Object.defineProperty(P._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(P, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(P, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: z
      }), Object.defineProperty(P, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: U
      }), Object.freeze && (Object.freeze(P.props), Object.freeze(P)), P;
    }
    function u(P, V, I, D, z, U) {
      var G = V.children;
      if (G !== void 0)
        if (D)
          if (L(G)) {
            for (D = 0; D < G.length; D++)
              d(G[D]);
            Object.freeze && Object.freeze(G);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else d(G);
      if (T.call(V, "key")) {
        G = t(P);
        var J = Object.keys(V).filter(function(Q) {
          return Q !== "key";
        });
        D = 0 < J.length ? "{key: someKey, " + J.join(": ..., ") + ": ...}" : "{key: someKey}", B[G + D] || (J = 0 < J.length ? "{" + J.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          D,
          G,
          J,
          G
        ), B[G + D] = !0);
      }
      if (G = null, I !== void 0 && (n(I), G = "" + I), i(V) && (n(V.key), G = "" + V.key), "key" in V) {
        I = {};
        for (var se in V)
          se !== "key" && (I[se] = V[se]);
      } else I = V;
      return G && a(
        I,
        typeof P == "function" ? P.displayName || P.name || "Unknown" : P
      ), c(
        P,
        G,
        I,
        r(),
        z,
        U
      );
    }
    function d(P) {
      p(P) ? P._store && (P._store.validated = 1) : typeof P == "object" && P !== null && P.$$typeof === O && (P._payload.status === "fulfilled" ? p(P._payload.value) && P._payload.value._store && (P._payload.value._store.validated = 1) : P._store && (P._store.validated = 1));
    }
    function p(P) {
      return typeof P == "object" && P !== null && P.$$typeof === h;
    }
    var m = q, h = /* @__PURE__ */ Symbol.for("react.transitional.element"), g = /* @__PURE__ */ Symbol.for("react.portal"), y = /* @__PURE__ */ Symbol.for("react.fragment"), v = /* @__PURE__ */ Symbol.for("react.strict_mode"), x = /* @__PURE__ */ Symbol.for("react.profiler"), w = /* @__PURE__ */ Symbol.for("react.consumer"), E = /* @__PURE__ */ Symbol.for("react.context"), S = /* @__PURE__ */ Symbol.for("react.forward_ref"), C = /* @__PURE__ */ Symbol.for("react.suspense"), _ = /* @__PURE__ */ Symbol.for("react.suspense_list"), R = /* @__PURE__ */ Symbol.for("react.memo"), O = /* @__PURE__ */ Symbol.for("react.lazy"), j = /* @__PURE__ */ Symbol.for("react.activity"), F = /* @__PURE__ */ Symbol.for("react.client.reference"), N = m.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, T = Object.prototype.hasOwnProperty, L = Array.isArray, M = console.createTask ? console.createTask : function() {
      return null;
    };
    m = {
      react_stack_bottom_frame: function(P) {
        return P();
      }
    };
    var A, $ = {}, k = m.react_stack_bottom_frame.bind(
      m,
      s
    )(), H = M(o(s)), B = {};
    Ar.Fragment = y, Ar.jsx = function(P, V, I) {
      var D = 1e4 > N.recentlyCreatedOwnerStacks++;
      return u(
        P,
        V,
        I,
        !1,
        D ? Error("react-stack-top-frame") : k,
        D ? M(o(P)) : H
      );
    }, Ar.jsxs = function(P, V, I) {
      var D = 1e4 > N.recentlyCreatedOwnerStacks++;
      return u(
        P,
        V,
        I,
        !0,
        D ? Error("react-stack-top-frame") : k,
        D ? M(o(P)) : H
      );
    };
  })()), Ar;
}
var ud;
function ny() {
  return ud || (ud = 1, process.env.NODE_ENV === "production" ? Ts.exports = ey() : Ts.exports = ty()), Ts.exports;
}
var b = ny(), Is = { exports: {} }, za = {};
var dd;
function oy() {
  if (dd) return za;
  dd = 1;
  var t = q.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  return za.c = function(e) {
    return t.H.useMemoCache(e);
  }, za;
}
var Ba = {};
var fd;
function ry() {
  return fd || (fd = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = q.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    Ba.c = function(e) {
      var n = t.H;
      return n === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), n.useMemoCache(e);
    };
  })()), Ba;
}
var pd;
function sy() {
  return pd || (pd = 1, process.env.NODE_ENV === "production" ? Is.exports = oy() : Is.exports = ry()), Is.exports;
}
var ee = sy();
function un({
  controlled: t,
  default: e,
  name: n,
  state: o = "value"
}) {
  const {
    current: r
  } = f.useRef(t !== void 0), [s, i] = f.useState(e), a = r ? t : s;
  if (process.env.NODE_ENV !== "production") {
    f.useEffect(() => {
      r !== (t !== void 0) && console.error([`Base UI: A component is changing the ${r ? "" : "un"}controlled ${o} state of ${n} to be ${r ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, t]);
    const {
      current: c
    } = f.useRef(e);
    f.useEffect(() => {
      !r && JSON.stringify(c) !== JSON.stringify(e) && console.error([`Base UI: A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(e)]);
  }
  const l = f.useCallback((c) => {
    r || i(c);
  }, []);
  return [a, l];
}
const md = {};
function jt(t, e) {
  const n = f.useRef(md);
  return n.current === md && (n.current = t(e)), n;
}
const Ha = f[`useInsertionEffect${Math.random().toFixed(1)}`.slice(0, -3)], iy = (
  // React 17 doesn't have useInsertionEffect.
  Ha && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  Ha !== f.useLayoutEffect ? Ha : (t) => t()
);
function fe(t) {
  const e = jt(ay).current;
  return e.next = t, iy(e.effect), e.trampoline;
}
function ay() {
  const t = {
    next: void 0,
    callback: ly,
    trampoline: (...e) => t.callback?.(...e),
    effect: () => {
      t.callback = t.next;
    }
  };
  return t;
}
function ly() {
  if (process.env.NODE_ENV !== "production")
    throw new Error("Base UI: Cannot call an event handler while rendering.");
}
const cy = () => {
}, he = typeof document < "u" ? f.useLayoutEffect : cy;
let Ol;
process.env.NODE_ENV !== "production" && (Ol = /* @__PURE__ */ new Set());
function cs(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    Ol.has(e) || (Ol.add(e), console.warn(`Base UI: ${e}`));
  }
}
const vc = /* @__PURE__ */ f.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (vc.displayName = "CompositeListContext");
function uy() {
  return f.useContext(vc);
}
function yr(t) {
  const {
    children: e,
    elementsRef: n,
    labelsRef: o,
    onMapChange: r
  } = t, s = fe(r), i = f.useRef(0), a = jt(fy).current, l = jt(dy).current, [c, u] = f.useState(0), d = f.useRef(c), p = fe((v, x) => {
    l.set(v, x ?? null), d.current += 1, u(d.current);
  }), m = fe((v) => {
    l.delete(v), d.current += 1, u(d.current);
  }), h = f.useMemo(() => {
    const v = /* @__PURE__ */ new Map();
    return Array.from(l.keys()).filter((w) => w.isConnected).sort(py).forEach((w, E) => {
      const S = l.get(w) ?? {};
      v.set(w, {
        ...S,
        index: E
      });
    }), v;
  }, [l, c]);
  he(() => {
    if (typeof MutationObserver != "function" || h.size === 0)
      return;
    const v = new MutationObserver((x) => {
      const w = /* @__PURE__ */ new Set(), E = (S) => w.has(S) ? w.delete(S) : w.add(S);
      x.forEach((S) => {
        S.removedNodes.forEach(E), S.addedNodes.forEach(E);
      }), w.size === 0 && (d.current += 1, u(d.current));
    });
    return h.forEach((x, w) => {
      w.parentElement && v.observe(w.parentElement, {
        childList: !0
      });
    }), () => {
      v.disconnect();
    };
  }, [h]), he(() => {
    d.current === c && (n.current.length !== h.size && (n.current.length = h.size), o && o.current.length !== h.size && (o.current.length = h.size), i.current = h.size), s(h);
  }, [s, h, n, o, c]), he(() => () => {
    n.current = [];
  }, [n]), he(() => () => {
    o && (o.current = []);
  }, [o]);
  const g = fe((v) => (a.add(v), () => {
    a.delete(v);
  }));
  he(() => {
    a.forEach((v) => v(h));
  }, [a, h]);
  const y = f.useMemo(() => ({
    register: p,
    unregister: m,
    subscribeMapChange: g,
    elementsRef: n,
    labelsRef: o,
    nextIndexRef: i
  }), [p, m, g, n, o, i]);
  return /* @__PURE__ */ b.jsx(vc.Provider, {
    value: y,
    children: e
  });
}
function dy() {
  return /* @__PURE__ */ new Map();
}
function fy() {
  return /* @__PURE__ */ new Set();
}
function py(t, e) {
  const n = t.compareDocumentPosition(e);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
const Fp = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Fp.displayName = "DirectionContext");
function jo() {
  return f.useContext(Fp)?.direction ?? "ltr";
}
function We(t, ...e) {
  const n = new URL("https://base-ui.com/production-error");
  return n.searchParams.set("code", t.toString()), e.forEach((o) => n.searchParams.append("args[]", o)), `Base UI error #${t}; visit ${n} for the full message.`;
}
const yc = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (yc.displayName = "AccordionRootContext");
function xc() {
  const t = f.useContext(yc);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: AccordionRootContext is missing. Accordion parts must be placed within <Accordion.Root>." : We(10));
  return t;
}
function zt(t, e, n, o) {
  const r = jt(Vp).current;
  return hy(r, t, e, n, o) && zp(r, [t, e, n, o]), r.callback;
}
function my(t) {
  const e = jt(Vp).current;
  return gy(e, t) && zp(e, t), e.callback;
}
function Vp() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function hy(t, e, n, o, r) {
  return t.refs[0] !== e || t.refs[1] !== n || t.refs[2] !== o || t.refs[3] !== r;
}
function gy(t, e) {
  return t.refs.length !== e.length || t.refs.some((n, o) => n !== e[o]);
}
function zp(t, e) {
  if (t.refs = e, e.every((n) => n == null)) {
    t.callback = null;
    return;
  }
  t.callback = (n) => {
    if (t.cleanup && (t.cleanup(), t.cleanup = null), n != null) {
      const o = Array(e.length).fill(null);
      for (let r = 0; r < e.length; r += 1) {
        const s = e[r];
        if (s != null)
          switch (typeof s) {
            case "function": {
              const i = s(n);
              typeof i == "function" && (o[r] = i);
              break;
            }
            case "object": {
              s.current = n;
              break;
            }
          }
      }
      t.cleanup = () => {
        for (let r = 0; r < e.length; r += 1) {
          const s = e[r];
          if (s != null)
            switch (typeof s) {
              case "function": {
                const i = o[r];
                typeof i == "function" ? i() : s(null);
                break;
              }
              case "object": {
                s.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const by = parseInt(f.version, 10);
function wc(t) {
  return by >= t;
}
function hd(t) {
  if (!/* @__PURE__ */ f.isValidElement(t))
    return null;
  const e = t, n = e.props;
  return (wc(19) ? n?.ref : e.ref) ?? null;
}
function Ml(t, e) {
  if (t && !e)
    return t;
  if (!t && e)
    return e;
  if (t || e)
    return {
      ...t,
      ...e
    };
}
function vy(t, e) {
  const n = {};
  for (const o in t) {
    const r = t[o];
    if (e?.hasOwnProperty(o)) {
      const s = e[o](r);
      s != null && Object.assign(n, s);
      continue;
    }
    r === !0 ? n[`data-${o.toLowerCase()}`] = "" : r && (n[`data-${o.toLowerCase()}`] = r.toString());
  }
  return n;
}
function yy(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function xy(t, e) {
  return typeof t == "function" ? t(e) : t;
}
const Jr = {};
function Qt(t, e, n, o, r) {
  let s = {
    ...Pl(t, Jr)
  };
  return e && (s = Gr(s, e)), n && (s = Gr(s, n)), o && (s = Gr(s, o)), r && (s = Gr(s, r)), s;
}
function wy(t) {
  if (t.length === 0)
    return Jr;
  if (t.length === 1)
    return Pl(t[0], Jr);
  let e = {
    ...Pl(t[0], Jr)
  };
  for (let n = 1; n < t.length; n += 1)
    e = Gr(e, t[n]);
  return e;
}
function Gr(t, e) {
  return Bp(e) ? e(t) : Sy(t, e);
}
function Sy(t, e) {
  if (!e)
    return t;
  for (const n in e) {
    const o = e[n];
    switch (n) {
      case "style": {
        t[n] = Ml(t.style, o);
        break;
      }
      case "className": {
        t[n] = Hp(t.className, o);
        break;
      }
      default:
        Ey(n, o) ? t[n] = Cy(t[n], o) : t[n] = o;
    }
  }
  return t;
}
function Ey(t, e) {
  const n = t.charCodeAt(0), o = t.charCodeAt(1), r = t.charCodeAt(2);
  return n === 111 && o === 110 && r >= 65 && r <= 90 && (typeof e == "function" || typeof e > "u");
}
function Bp(t) {
  return typeof t == "function";
}
function Pl(t, e) {
  return Bp(t) ? t(e) : t ?? Jr;
}
function Cy(t, e) {
  return e ? t ? (n) => {
    if (_y(n)) {
      const r = n;
      Al(r);
      const s = e(r);
      return r.baseUIHandlerPrevented || t?.(r), s;
    }
    const o = e(n);
    return t?.(n), o;
  } : e : t;
}
function Al(t) {
  return t.preventBaseUIHandler = () => {
    t.baseUIHandlerPrevented = !0;
  }, t;
}
function Hp(t, e) {
  return e ? t ? e + " " + t : e : t;
}
function _y(t) {
  return t != null && typeof t == "object" && "nativeEvent" in t;
}
function xt() {
}
const zn = Object.freeze([]), at = Object.freeze({}), Ry = 500, Up = 500, Ny = {
  style: {
    transition: "none"
  }
}, Sc = "data-base-ui-click-trigger", Wp = {
  fallbackAxisSide: "none"
}, Ec = {
  fallbackAxisSide: "end"
}, ky = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
};
function _e(t, e, n = {}) {
  const o = e.render, r = Ty(e, n);
  if (n.enabled === !1)
    return null;
  const s = n.state ?? at;
  return Iy(t, o, r, s);
}
function Ty(t, e = {}) {
  const {
    className: n,
    style: o,
    render: r
  } = t, {
    state: s = at,
    ref: i,
    props: a,
    stateAttributesMapping: l,
    enabled: c = !0
  } = e, u = c ? yy(n, s) : void 0, d = c ? xy(o, s) : void 0, p = c ? vy(s, l) : at, m = c ? Ml(p, Array.isArray(a) ? wy(a) : a) ?? at : at;
  return typeof document < "u" && (c ? Array.isArray(i) ? m.ref = my([m.ref, hd(r), ...i]) : m.ref = zt(m.ref, hd(r), i) : zt(null, null)), c ? (u !== void 0 && (m.className = Hp(m.className, u)), d !== void 0 && (m.style = Ml(m.style, d)), m) : at;
}
function Iy(t, e, n, o) {
  if (e) {
    if (typeof e == "function")
      return e(n, o);
    const r = Qt(n, e.props);
    return r.ref = n.ref, /* @__PURE__ */ f.cloneElement(e, r);
  }
  if (t && typeof t == "string")
    return Oy(t, n);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : We(8));
}
function Oy(t, e) {
  return t === "button" ? /* @__PURE__ */ fr("button", {
    type: "button",
    ...e,
    key: e.key
  }) : t === "img" ? /* @__PURE__ */ fr("img", {
    alt: "",
    ...e,
    key: e.key
  }) : /* @__PURE__ */ f.createElement(t, e);
}
const Ut = "none", ln = "trigger-press", Et = "trigger-hover", sr = "trigger-focus", Yi = "outside-press", No = "item-press", Gp = "close-press", gd = "track-press", My = "input-change", In = "focus-out", us = "escape-key", ci = "list-navigation", Py = "keyboard", Ay = "drag", Kp = "cancel-open", Kr = "sibling-open", Dy = "disabled", qi = "imperative-action", jy = "window-resize";
function ke(t, e, n, o) {
  let r = !1, s = !1;
  const i = o ?? at;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    cancel() {
      r = !0;
    },
    allowPropagation() {
      s = !0;
    },
    get isCanceled() {
      return r;
    },
    get isPropagationAllowed() {
      return s;
    },
    trigger: n,
    ...i
  };
}
function Yp(t, e, n) {
  const o = at;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    ...o
  };
}
const Ly = {
  value: () => null
}, qp = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    hiddenUntilFound: i,
    keepMounted: a,
    loopFocus: l = !0,
    onValueChange: c,
    multiple: u = !1,
    orientation: d = "vertical",
    value: p,
    defaultValue: m,
    ...h
  } = e, g = jo();
  process.env.NODE_ENV !== "production" && he(() => {
    i && a === !1 && cs("The `keepMounted={false}` prop on a Accordion.Root will be ignored when using `hiddenUntilFound` since it requires Panels to remain mounted when closed.");
  }, [i, a]);
  const y = f.useMemo(() => {
    if (p === void 0)
      return m ?? [];
  }, [p, m]), v = fe(c), x = f.useRef([]), [w, E] = un({
    controlled: p,
    default: y,
    name: "Accordion",
    state: "value"
  }), S = fe((O, j) => {
    const F = ke(Ut);
    if (u)
      if (j) {
        const N = w.slice();
        if (N.push(O), v(N, F), F.isCanceled)
          return;
        E(N);
      } else {
        const N = w.filter((T) => T !== O);
        if (v(N, F), F.isCanceled)
          return;
        E(N);
      }
    else {
      const N = w[0] === O ? [] : [O];
      if (v(N, F), F.isCanceled)
        return;
      E(N);
    }
  }), C = f.useMemo(() => ({
    value: w,
    disabled: s,
    orientation: d
  }), [w, s, d]), _ = f.useMemo(() => ({
    accordionItemRefs: x,
    direction: g,
    disabled: s,
    handleValueChange: S,
    hiddenUntilFound: i ?? !1,
    keepMounted: a ?? !1,
    loopFocus: l,
    orientation: d,
    state: C,
    value: w
  }), [g, s, S, i, a, l, d, C, w]), R = _e("div", e, {
    state: C,
    ref: n,
    props: [{
      dir: g,
      role: "region"
    }, h],
    stateAttributesMapping: Ly
  });
  return /* @__PURE__ */ b.jsx(yc.Provider, {
    value: _,
    children: /* @__PURE__ */ b.jsx(yr, {
      elementsRef: x,
      children: R
    })
  });
});
process.env.NODE_ENV !== "production" && (qp.displayName = "AccordionRoot");
const $y = {
  ...f
};
let bd = 0;
function Fy(t, e = "mui") {
  const [n, o] = f.useState(t), r = t || n;
  return f.useEffect(() => {
    n == null && (bd += 1, o(`${e}-${bd}`));
  }, [n, e]), r;
}
const vd = $y.useId;
function Lo(t, e) {
  if (vd !== void 0) {
    const n = vd();
    return t ?? (e ? `${e}-${n}` : n);
  }
  return Fy(t, e);
}
function lt(t) {
  return Lo(t, "base-ui");
}
const Vy = [];
function xr(t) {
  f.useEffect(t, Vy);
}
const Os = null;
let yd = globalThis.requestAnimationFrame;
class zy {
  constructor() {
    /* This implementation uses an array as a backing data-structure for frame callbacks.
     * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
     * never calls the native `cancelAnimationFrame` if there are no frames left. This can
     * be much more efficient if there is a call pattern that alterns as
     * "request-cancel-request-cancel-…".
     * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
     * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
    Re(this, "callbacks", []);
    Re(this, "callbacksCount", 0);
    Re(this, "nextId", 1);
    Re(this, "startId", 1);
    Re(this, "isScheduled", !1);
    Re(this, "tick", (e) => {
      this.isScheduled = !1;
      const n = this.callbacks, o = this.callbacksCount;
      if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, o > 0)
        for (let r = 0; r < n.length; r += 1)
          n[r]?.(e);
    });
  }
  request(e) {
    const n = this.nextId;
    this.nextId += 1, this.callbacks.push(e), this.callbacksCount += 1;
    const o = process.env.NODE_ENV === "test" && yd !== requestAnimationFrame && (yd = requestAnimationFrame, !0);
    return (!this.isScheduled || o) && (requestAnimationFrame(this.tick), this.isScheduled = !0), n;
  }
  cancel(e) {
    const n = e - this.startId;
    n < 0 || n >= this.callbacks.length || (this.callbacks[n] = null, this.callbacksCount -= 1);
  }
}
const Ms = new zy();
class dt {
  constructor() {
    Re(this, "currentId", Os);
    Re(this, "cancel", () => {
      this.currentId !== Os && (Ms.cancel(this.currentId), this.currentId = Os);
    });
    Re(this, "disposeEffect", () => this.cancel);
  }
  static create() {
    return new dt();
  }
  static request(e) {
    return Ms.request(e);
  }
  static cancel(e) {
    return Ms.cancel(e);
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(e) {
    this.cancel(), this.currentId = Ms.request(() => {
      this.currentId = Os, e();
    });
  }
}
function $o() {
  const t = jt(dt.create).current;
  return xr(t.disposeEffect), t;
}
function Ln(t) {
  return t == null ? t : "current" in t ? t.current : t;
}
let Io = /* @__PURE__ */ (function(t) {
  return t.startingStyle = "data-starting-style", t.endingStyle = "data-ending-style", t;
})({});
const By = {
  [Io.startingStyle]: ""
}, Hy = {
  [Io.endingStyle]: ""
}, tn = {
  transitionStatus(t) {
    return t === "starting" ? By : t === "ending" ? Hy : null;
  }
};
function Cc(t, e = !1, n = !0) {
  const o = $o();
  return fe((r, s = null) => {
    o.cancel();
    function i() {
      Vt.flushSync(r);
    }
    const a = Ln(t);
    if (a == null)
      return;
    const l = a;
    if (typeof l.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED)
      r();
    else {
      let c = function() {
        const d = Io.startingStyle;
        if (!l.hasAttribute(d)) {
          o.request(u);
          return;
        }
        const p = new MutationObserver(() => {
          l.hasAttribute(d) || (p.disconnect(), u());
        });
        p.observe(l, {
          attributes: !0,
          attributeFilter: [d]
        }), s?.addEventListener("abort", () => p.disconnect(), {
          once: !0
        });
      }, u = function() {
        Promise.all(l.getAnimations().map((d) => d.finished)).then(() => {
          s?.aborted || i();
        }).catch(() => {
          const d = l.getAnimations();
          if (n) {
            if (s?.aborted)
              return;
            i();
          } else d.length > 0 && d.some((p) => p.pending || p.playState !== "finished") && u();
        });
      };
      if (e) {
        c();
        return;
      }
      o.request(u);
    }
  });
}
function Kn(t, e = !1, n = !1) {
  const [o, r] = f.useState(t && e ? "idle" : void 0), [s, i] = f.useState(t);
  return t && !s && (i(!0), r("starting")), !t && s && o !== "ending" && !n && r("ending"), !t && !s && o === "ending" && r(void 0), he(() => {
    if (!t && s && o !== "ending" && n) {
      const a = dt.request(() => {
        r("ending");
      });
      return () => {
        dt.cancel(a);
      };
    }
  }, [t, s, o, n]), he(() => {
    if (!t || e)
      return;
    const a = dt.request(() => {
      r(void 0);
    });
    return () => {
      dt.cancel(a);
    };
  }, [e, t]), he(() => {
    if (!t || !e)
      return;
    t && s && o !== "idle" && r("starting");
    const a = dt.request(() => {
      r("idle");
    });
    return () => {
      dt.cancel(a);
    };
  }, [e, t, s, r, o]), f.useMemo(() => ({
    mounted: s,
    setMounted: i,
    transitionStatus: o
  }), [s, o]);
}
function Xp(t) {
  const {
    open: e,
    defaultOpen: n,
    onOpenChange: o,
    disabled: r
  } = t, s = e !== void 0, [i, a] = un({
    controlled: e,
    default: n,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: l,
    setMounted: c,
    transitionStatus: u
  } = Kn(i, !0, !0), [d, p] = f.useState(i), [{
    height: m,
    width: h
  }, g] = f.useState({
    height: void 0,
    width: void 0
  }), y = lt(), [v, x] = f.useState(), w = v ?? y, [E, S] = f.useState(!1), [C, _] = f.useState(!1), R = f.useRef(null), O = f.useRef(null), j = f.useRef(null), F = f.useRef(null), N = Cc(F, !1), T = fe((L) => {
    const M = !i, A = ke(ln, L.nativeEvent);
    if (o(M, A), A.isCanceled)
      return;
    const $ = F.current;
    O.current === "css-animation" && $ != null && $.style.removeProperty("animation-name"), !E && !C && (O.current != null && O.current !== "css-animation" && !l && M && c(!0), O.current === "css-animation" && (!d && M && p(!0), !l && M && c(!0))), a(M), O.current === "none" && l && !M && c(!1);
  });
  return he(() => {
    s && O.current === "none" && !C && !i && c(!1);
  }, [s, C, i, e, c]), f.useMemo(() => ({
    abortControllerRef: R,
    animationTypeRef: O,
    disabled: r,
    handleTrigger: T,
    height: m,
    mounted: l,
    open: i,
    panelId: w,
    panelRef: F,
    runOnceAnimationsFinish: N,
    setDimensions: g,
    setHiddenUntilFound: S,
    setKeepMounted: _,
    setMounted: c,
    setOpen: a,
    setPanelIdState: x,
    setVisible: p,
    transitionDimensionRef: j,
    transitionStatus: u,
    visible: d,
    width: h
  }), [R, O, r, T, m, l, i, w, F, N, g, S, _, c, a, p, j, u, d, h]);
}
const Xi = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Xi.displayName = "CollapsibleRootContext");
function Zi() {
  const t = f.useContext(Xi);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>." : We(15));
  return t;
}
let Zp = /* @__PURE__ */ (function(t) {
  return t[t.None = 0] = "None", t[t.GuessFromOrder = 1] = "GuessFromOrder", t;
})({});
function Yn(t = {}) {
  const {
    label: e,
    metadata: n,
    textRef: o,
    indexGuessBehavior: r,
    index: s
  } = t, {
    register: i,
    unregister: a,
    subscribeMapChange: l,
    elementsRef: c,
    labelsRef: u,
    nextIndexRef: d
  } = uy(), p = f.useRef(-1), [m, h] = f.useState(s ?? (r === Zp.GuessFromOrder ? () => {
    if (p.current === -1) {
      const v = d.current;
      d.current += 1, p.current = v;
    }
    return p.current;
  } : -1)), g = f.useRef(null), y = f.useCallback((v) => {
    if (g.current = v, m !== -1 && v !== null && (c.current[m] = v, u)) {
      const x = e !== void 0;
      u.current[m] = x ? e : o?.current?.textContent ?? v.textContent;
    }
  }, [m, c, u, e, o]);
  return he(() => {
    if (s != null)
      return;
    const v = g.current;
    if (v)
      return i(v, n), () => {
        a(v);
      };
  }, [s, i, a, n]), he(() => {
    if (s == null)
      return l((v) => {
        const x = g.current ? v.get(g.current)?.index : null;
        x != null && h(x);
      });
  }, [s, l, h]), f.useMemo(() => ({
    ref: y,
    index: m
  }), [m, y]);
}
const _c = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (_c.displayName = "AccordionItemContext");
function Rc() {
  const t = f.useContext(_c);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: AccordionItemContext is missing. Accordion parts must be placed within <Accordion.Item>." : We(9));
  return t;
}
let Qr = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = Io.startingStyle] = "startingStyle", t[t.endingStyle = Io.endingStyle] = "endingStyle", t;
})({}), Uy = /* @__PURE__ */ (function(t) {
  return t.panelOpen = "data-panel-open", t;
})({});
const Wy = {
  [Qr.open]: ""
}, Gy = {
  [Qr.closed]: ""
}, Jp = {
  open(t) {
    return t ? {
      [Uy.panelOpen]: ""
    } : null;
  }
}, Qp = {
  open(t) {
    return t ? Wy : Gy;
  }
};
let Ky = /* @__PURE__ */ (function(t) {
  return t.index = "data-index", t.disabled = "data-disabled", t.open = "data-open", t;
})({});
const Nc = {
  ...Qp,
  index: (t) => Number.isInteger(t) ? {
    [Ky.index]: String(t)
  } : null,
  ...tn,
  value: () => null
}, em = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    disabled: r = !1,
    onOpenChange: s,
    render: i,
    value: a,
    ...l
  } = e, {
    ref: c,
    index: u
  } = Yn(), d = zt(n, c), {
    disabled: p,
    handleValueChange: m,
    state: h,
    value: g
  } = xc(), y = lt(), v = a ?? y, x = r || p, w = f.useMemo(() => {
    if (!g)
      return !1;
    for (let T = 0; T < g.length; T += 1)
      if (g[T] === v)
        return !0;
    return !1;
  }, [g, v]), E = fe((T, L) => {
    s?.(T, L), !L.isCanceled && m(v, T);
  }), S = Xp({
    open: w,
    onOpenChange: E,
    disabled: x
  }), C = f.useMemo(() => ({
    open: S.open,
    disabled: S.disabled,
    hidden: !S.mounted,
    transitionStatus: S.transitionStatus
  }), [S.open, S.disabled, S.mounted, S.transitionStatus]), _ = f.useMemo(() => ({
    ...S,
    onOpenChange: E,
    state: C
  }), [S, C, E]), R = f.useMemo(() => ({
    ...h,
    index: u,
    disabled: x,
    open: w
  }), [x, u, w, h]), [O, j] = f.useState(lt()), F = f.useMemo(() => ({
    open: w,
    state: R,
    setTriggerId: j,
    triggerId: O
  }), [w, R, j, O]), N = _e("div", e, {
    state: R,
    ref: d,
    props: l,
    stateAttributesMapping: Nc
  });
  return /* @__PURE__ */ b.jsx(Xi.Provider, {
    value: _,
    children: /* @__PURE__ */ b.jsx(_c.Provider, {
      value: F,
      children: N
    })
  });
});
process.env.NODE_ENV !== "production" && (em.displayName = "AccordionItem");
const tm = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    ...s
  } = e, {
    state: i
  } = Rc();
  return _e("h3", e, {
    state: i,
    ref: n,
    props: s,
    stateAttributesMapping: Nc
  });
});
process.env.NODE_ENV !== "production" && (tm.displayName = "AccordionHeader");
function Dl(t) {
  return t == null || t.hasAttribute("disabled") || t.getAttribute("aria-disabled") === "true";
}
function Ji() {
  return typeof window < "u";
}
function mo(t) {
  return kc(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function mt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Mn(t) {
  var e;
  return (e = (kc(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function kc(t) {
  return Ji() ? t instanceof Node || t instanceof mt(t).Node : !1;
}
function Ze(t) {
  return Ji() ? t instanceof Element || t instanceof mt(t).Element : !1;
}
function ut(t) {
  return Ji() ? t instanceof HTMLElement || t instanceof mt(t).HTMLElement : !1;
}
function jl(t) {
  return !Ji() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof mt(t).ShadowRoot;
}
const Yy = /* @__PURE__ */ new Set(["inline", "contents"]);
function Fo(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = en(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !Yy.has(r);
}
const qy = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Xy(t) {
  return qy.has(mo(t));
}
const Zy = [":popover-open", ":modal"];
function Qi(t) {
  return Zy.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
const Jy = ["transform", "translate", "scale", "rotate", "perspective"], Qy = ["transform", "translate", "scale", "rotate", "perspective", "filter"], e1 = ["paint", "layout", "strict", "content"];
function Tc(t) {
  const e = ea(), n = Ze(t) ? en(t) : t;
  return Jy.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || Qy.some((o) => (n.willChange || "").includes(o)) || e1.some((o) => (n.contain || "").includes(o));
}
function t1(t) {
  let e = On(t);
  for (; ut(e) && !Rn(e); ) {
    if (Tc(e))
      return e;
    if (Qi(e))
      return null;
    e = On(e);
  }
  return null;
}
function ea() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const n1 = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Rn(t) {
  return n1.has(mo(t));
}
function en(t) {
  return mt(t).getComputedStyle(t);
}
function ta(t) {
  return Ze(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function On(t) {
  if (mo(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    jl(t) && t.host || // Fallback.
    Mn(t)
  );
  return jl(e) ? e.host : e;
}
function nm(t) {
  const e = On(t);
  return Rn(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : ut(e) && Fo(e) ? e : nm(e);
}
function ro(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = nm(t), s = r === ((o = t.ownerDocument) == null ? void 0 : o.body), i = mt(r);
  if (s) {
    const a = Ll(i);
    return e.concat(i, i.visualViewport || [], Fo(r) ? r : [], a && n ? ro(a) : []);
  }
  return e.concat(r, ro(r, [], n));
}
function Ll(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
let $l;
process.env.NODE_ENV !== "production" && ($l = /* @__PURE__ */ new Set());
function xd(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    $l.has(e) || ($l.add(e), console.error(`Base UI: ${e}`));
  }
}
const Ic = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ic.displayName = "CompositeRootContext");
function Oc(t = !1) {
  const e = f.useContext(Ic);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : We(16));
  return e;
}
function o1(t) {
  const {
    focusableWhenDisabled: e,
    disabled: n,
    composite: o = !1,
    tabIndex: r = 0,
    isNativeButton: s
  } = t, i = o && e !== !1, a = o && e === !1;
  return {
    props: f.useMemo(() => {
      const c = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(u) {
          n && e && u.key !== "Tab" && u.preventDefault();
        }
      };
      return o || (c.tabIndex = r, !s && n && (c.tabIndex = e ? r : -1)), (s && (e || i) || !s && n) && (c["aria-disabled"] = n), s && (!e || a) && (c.disabled = n), c;
    }, [o, n, e, i, a, s, r])
  };
}
function Wt(t = {}) {
  const {
    disabled: e = !1,
    focusableWhenDisabled: n,
    tabIndex: o = 0,
    native: r = !0
  } = t, s = f.useRef(null), i = Oc(!0) !== void 0, a = fe(() => {
    const p = s.current;
    return !!(p?.tagName === "A" && p?.href);
  }), {
    props: l
  } = o1({
    focusableWhenDisabled: n,
    disabled: e,
    composite: i,
    tabIndex: o,
    isNativeButton: r
  });
  process.env.NODE_ENV !== "production" && f.useEffect(() => {
    if (!s.current)
      return;
    const p = s.current.tagName === "BUTTON";
    r ? p || xd("A component that acts as a button was not rendered as a native <button>, which does not match the default. Ensure that the element passed to the `render` prop of the component is a real <button>, or set the `nativeButton` prop on the component to `false`.") : p && xd("A component that acts as a button was rendered as a native <button>, which does not match the default. Ensure that the element passed to the `render` prop of the component is not a real <button>, or set the `nativeButton` prop on the component to `true`.");
  }, [r]);
  const c = f.useCallback(() => {
    const p = s.current;
    r1(p) && i && e && l.disabled === void 0 && p.disabled && (p.disabled = !1);
  }, [e, l.disabled, i]);
  he(c, [c]);
  const u = f.useCallback((p = {}) => {
    const {
      onClick: m,
      onMouseDown: h,
      onKeyUp: g,
      onKeyDown: y,
      onPointerDown: v,
      ...x
    } = p;
    return Qt({
      type: r ? "button" : void 0,
      onClick(E) {
        if (e) {
          E.preventDefault();
          return;
        }
        m?.(E);
      },
      onMouseDown(E) {
        e || h?.(E);
      },
      onKeyDown(E) {
        if (e || (Al(E), y?.(E)), E.baseUIHandlerPrevented)
          return;
        const S = E.target === E.currentTarget && !r && !a() && !e, C = E.key === "Enter", _ = E.key === " ";
        S && ((_ || C) && E.preventDefault(), C && m?.(E));
      },
      onKeyUp(E) {
        e || (Al(E), g?.(E)), !E.baseUIHandlerPrevented && E.target === E.currentTarget && !r && !e && E.key === " " && m?.(E);
      },
      onPointerDown(E) {
        if (e) {
          E.preventDefault();
          return;
        }
        v?.(E);
      }
    }, r ? void 0 : {
      role: "button"
    }, l, x);
  }, [e, l, r, a]), d = fe((p) => {
    s.current = p, c();
  });
  return {
    getButtonProps: u,
    buttonRef: d
  };
}
function r1(t) {
  return ut(t) && t.tagName === "BUTTON";
}
const wr = typeof navigator < "u", Ua = i1(), om = l1(), rm = a1(), sm = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), im = (
  // iPads can claim to be MacIntel
  Ua.platform === "MacIntel" && Ua.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(Ua.platform)
), am = wr && /apple/i.test(navigator.vendor), Fl = wr && /android/i.test(om) || /android/i.test(rm), s1 = wr && om.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, lm = rm.includes("jsdom/");
function i1() {
  if (!wr)
    return {
      platform: "",
      maxTouchPoints: -1
    };
  const t = navigator.userAgentData;
  return t?.platform ? {
    platform: t.platform,
    maxTouchPoints: navigator.maxTouchPoints
  } : {
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? -1
  };
}
function a1() {
  if (!wr)
    return "";
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map(({
    brand: e,
    version: n
  }) => `${e}/${n}`).join(" ") : navigator.userAgent;
}
function l1() {
  if (!wr)
    return "";
  const t = navigator.userAgentData;
  return t?.platform ? t.platform : navigator.platform ?? "";
}
const Vl = "data-base-ui-focusable", cm = "active", um = "selected", dm = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", so = "ArrowLeft", io = "ArrowRight", Mc = "ArrowUp", ds = "ArrowDown";
function Jt(t) {
  let e = t.activeElement;
  for (; e?.shadowRoot?.activeElement != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
function Ue(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode?.();
  if (t.contains(e))
    return !0;
  if (n && jl(n)) {
    let o = e;
    for (; o; ) {
      if (t === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function $t(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function pn(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const n = t;
  return n.target != null && e.contains(n.target);
}
function c1(t) {
  return t.matches("html,body");
}
function vt(t) {
  return t?.ownerDocument || document;
}
function Pc(t) {
  return ut(t) && t.matches(dm);
}
function zl(t) {
  return t ? t.getAttribute("role") === "combobox" && Pc(t) : !1;
}
function u1(t) {
  if (!t || lm)
    return !0;
  try {
    return t.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function ts(t) {
  return t ? t.hasAttribute(Vl) ? t : t.querySelector(`[${Vl}]`) || t : null;
}
function ko(t, e, n = !0) {
  return t.filter((r) => r.parentId === e && (!n || r.context?.open)).flatMap((r) => [r, ...ko(t, r.id, n)]);
}
function wd(t, e) {
  let n = [], o = t.find((r) => r.id === e)?.parentId;
  for (; o; ) {
    const r = t.find((s) => s.id === o);
    o = r?.parentId, r && (n = n.concat(r));
  }
  return n;
}
function At(t) {
  t.preventDefault(), t.stopPropagation();
}
function d1(t) {
  return "nativeEvent" in t;
}
function fm(t) {
  return t.mozInputSource === 0 && t.isTrusted ? !0 : Fl && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function pm(t) {
  return lm ? !1 : !Fl && t.width === 0 && t.height === 0 || Fl && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function Oo(t, e) {
  const n = ["mouse", "pen"];
  return e || n.push("", void 0), n.includes(t);
}
function mm(t) {
  const e = t.type;
  return e === "click" || e === "mousedown" || e === "keydown" || e === "keyup";
}
const f1 = ["top", "right", "bottom", "left"], pr = Math.min, Zt = Math.max, wi = Math.round, or = Math.floor, Nn = (t) => ({
  x: t,
  y: t
}), p1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, m1 = {
  start: "end",
  end: "start"
};
function Bl(t, e, n) {
  return Zt(t, pr(e, n));
}
function Bn(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function qt(t) {
  return t.split("-")[0];
}
function ho(t) {
  return t.split("-")[1];
}
function Ac(t) {
  return t === "x" ? "y" : "x";
}
function Dc(t) {
  return t === "y" ? "height" : "width";
}
const h1 = /* @__PURE__ */ new Set(["top", "bottom"]);
function sn(t) {
  return h1.has(qt(t)) ? "y" : "x";
}
function jc(t) {
  return Ac(sn(t));
}
function g1(t, e, n) {
  n === void 0 && (n = !1);
  const o = ho(t), r = jc(t), s = Dc(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (i = Si(i)), [i, Si(i)];
}
function b1(t) {
  const e = Si(t);
  return [Hl(t), e, Hl(e)];
}
function Hl(t) {
  return t.replace(/start|end/g, (e) => m1[e]);
}
const Sd = ["left", "right"], Ed = ["right", "left"], v1 = ["top", "bottom"], y1 = ["bottom", "top"];
function x1(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? Ed : Sd : e ? Sd : Ed;
    case "left":
    case "right":
      return e ? v1 : y1;
    default:
      return [];
  }
}
function w1(t, e, n, o) {
  const r = ho(t);
  let s = x1(qt(t), n === "start", o);
  return r && (s = s.map((i) => i + "-" + r), e && (s = s.concat(s.map(Hl)))), s;
}
function Si(t) {
  return t.replace(/left|right|bottom|top/g, (e) => p1[e]);
}
function S1(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function hm(t) {
  return typeof t != "number" ? S1(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Ei(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function Ps(t, e, n) {
  return Math.floor(t / e) !== n;
}
function ir(t, e) {
  return e < 0 || e >= t.current.length;
}
function ui(t, e) {
  return Pt(t, {
    disabledIndices: e
  });
}
function Ul(t, e) {
  return Pt(t, {
    decrement: !0,
    startingIndex: t.current.length,
    disabledIndices: e
  });
}
function Pt(t, {
  startingIndex: e = -1,
  decrement: n = !1,
  disabledIndices: o,
  amount: r = 1
} = {}) {
  let s = e;
  do
    s += n ? -r : r;
  while (s >= 0 && s <= t.current.length - 1 && ao(t, s, o));
  return s;
}
function gm(t, {
  event: e,
  orientation: n,
  loopFocus: o,
  rtl: r,
  cols: s,
  disabledIndices: i,
  minIndex: a,
  maxIndex: l,
  prevIndex: c,
  stopEvent: u = !1
}) {
  let d = c;
  const p = [], m = {};
  let h = !1;
  {
    let v = null, x = -1;
    t.current.forEach((w, E) => {
      if (w == null)
        return;
      const S = w.closest('[role="row"]');
      S && (h = !0), (S !== v || x === -1) && (v = S, x += 1, p[x] = []), p[x].push(E), m[E] = x;
    });
  }
  const g = h && p.length > 0 && p.some((v) => v.length !== s);
  function y(v) {
    if (!g || c === -1)
      return;
    const x = m[c];
    if (x == null)
      return;
    const w = p[x].indexOf(c);
    let E = v === "up" ? x - 1 : x + 1;
    o && (E < 0 ? E = p.length - 1 : E >= p.length && (E = 0));
    const S = /* @__PURE__ */ new Set();
    for (; E >= 0 && E < p.length && !S.has(E); ) {
      S.add(E);
      const C = p[E];
      if (C.length === 0) {
        E = v === "up" ? E - 1 : E + 1;
        continue;
      }
      const _ = Math.min(w, C.length - 1);
      for (let R = _; R >= 0; R -= 1) {
        const O = C[R];
        if (!ao(t, O, i))
          return O;
      }
      E = v === "up" ? E - 1 : E + 1, o && (E < 0 ? E = p.length - 1 : E >= p.length && (E = 0));
    }
  }
  if (e.key === Mc) {
    const v = y("up");
    if (v !== void 0)
      u && At(e), d = v;
    else {
      if (u && At(e), c === -1)
        d = l;
      else if (d = Pt(t, {
        startingIndex: d,
        amount: s,
        decrement: !0,
        disabledIndices: i
      }), o && (c - s < a || d < 0)) {
        const x = c % s, w = l % s, E = l - (w - x);
        w === x ? d = l : d = w > x ? E : E - s;
      }
      ir(t, d) && (d = c);
    }
  }
  if (e.key === ds) {
    const v = y("down");
    v !== void 0 ? (u && At(e), d = v) : (u && At(e), c === -1 ? d = a : (d = Pt(t, {
      startingIndex: c,
      amount: s,
      disabledIndices: i
    }), o && c + s > l && (d = Pt(t, {
      startingIndex: c % s - s,
      amount: s,
      disabledIndices: i
    }))), ir(t, d) && (d = c));
  }
  if (n === "both") {
    const v = or(c / s);
    e.key === (r ? so : io) && (u && At(e), c % s !== s - 1 ? (d = Pt(t, {
      startingIndex: c,
      disabledIndices: i
    }), o && Ps(d, s, v) && (d = Pt(t, {
      startingIndex: c - c % s - 1,
      disabledIndices: i
    }))) : o && (d = Pt(t, {
      startingIndex: c - c % s - 1,
      disabledIndices: i
    })), Ps(d, s, v) && (d = c)), e.key === (r ? io : so) && (u && At(e), c % s !== 0 ? (d = Pt(t, {
      startingIndex: c,
      decrement: !0,
      disabledIndices: i
    }), o && Ps(d, s, v) && (d = Pt(t, {
      startingIndex: c + (s - c % s),
      decrement: !0,
      disabledIndices: i
    }))) : o && (d = Pt(t, {
      startingIndex: c + (s - c % s),
      decrement: !0,
      disabledIndices: i
    })), Ps(d, s, v) && (d = c));
    const x = or(l / s) === v;
    ir(t, d) && (o && x ? d = e.key === (r ? io : so) ? l : Pt(t, {
      startingIndex: c - c % s - 1,
      disabledIndices: i
    }) : d = c);
  }
  return d;
}
function bm(t, e, n) {
  const o = [];
  let r = 0;
  return t.forEach(({
    width: s,
    height: i
  }, a) => {
    if (s > e && process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `[Floating UI]: Invalid grid - item width at index ${a} is greater than grid columns` : We(29, a));
    let l = !1;
    for (n && (r = 0); !l; ) {
      const c = [];
      for (let u = 0; u < s; u += 1)
        for (let d = 0; d < i; d += 1)
          c.push(r + u + d * e);
      r % e + s <= e && c.every((u) => o[u] == null) ? (c.forEach((u) => {
        o[u] = a;
      }), l = !0) : r += 1;
    }
  }), [...o];
}
function vm(t, e, n, o, r) {
  if (t === -1)
    return -1;
  const s = n.indexOf(t), i = e[t];
  switch (r) {
    case "tl":
      return s;
    case "tr":
      return i ? s + i.width - 1 : s;
    case "bl":
      return i ? s + (i.height - 1) * o : s;
    case "br":
      return n.lastIndexOf(t);
    default:
      return -1;
  }
}
function ym(t, e) {
  return e.flatMap((n, o) => t.includes(n) ? [o] : []);
}
function ao(t, e, n) {
  if (typeof n == "function")
    return n(e);
  if (n)
    return n.includes(e);
  const o = t.current[e];
  return o ? o.hasAttribute("disabled") || o.getAttribute("aria-disabled") === "true" : !1;
}
var E1 = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Ci = /* @__PURE__ */ E1.join(","), xm = typeof Element > "u", mr = xm ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, _i = !xm && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t?.ownerDocument;
}, Ri = function(e, n) {
  var o;
  n === void 0 && (n = !0);
  var r = e == null || (o = e.getAttribute) === null || o === void 0 ? void 0 : o.call(e, "inert"), s = r === "" || r === "true", i = s || n && e && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof e.closest == "function" ? e.closest("[inert]") : Ri(e.parentNode));
  return i;
}, C1 = function(e) {
  var n, o = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
  return o === "" || o === "true";
}, wm = function(e, n, o) {
  if (Ri(e))
    return [];
  var r = Array.prototype.slice.apply(e.querySelectorAll(Ci));
  return n && mr.call(e, Ci) && r.unshift(e), r = r.filter(o), r;
}, Ni = function(e, n, o) {
  for (var r = [], s = Array.from(e); s.length; ) {
    var i = s.shift();
    if (!Ri(i, !1))
      if (i.tagName === "SLOT") {
        var a = i.assignedElements(), l = a.length ? a : i.children, c = Ni(l, !0, o);
        o.flatten ? r.push.apply(r, c) : r.push({
          scopeParent: i,
          candidates: c
        });
      } else {
        var u = mr.call(i, Ci);
        u && o.filter(i) && (n || !e.includes(i)) && r.push(i);
        var d = i.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(i), p = !Ri(d, !1) && (!o.shadowRootFilter || o.shadowRootFilter(i));
        if (d && p) {
          var m = Ni(d === !0 ? i.children : d.children, !0, o);
          o.flatten ? r.push.apply(r, m) : r.push({
            scopeParent: i,
            candidates: m
          });
        } else
          s.unshift.apply(s, i.children);
      }
  }
  return r;
}, Sm = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, Em = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || C1(e)) && !Sm(e) ? 0 : e.tabIndex;
}, _1 = function(e, n) {
  var o = Em(e);
  return o < 0 && n && !Sm(e) ? 0 : o;
}, R1 = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, Cm = function(e) {
  return e.tagName === "INPUT";
}, N1 = function(e) {
  return Cm(e) && e.type === "hidden";
}, k1 = function(e) {
  var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, T1 = function(e, n) {
  for (var o = 0; o < e.length; o++)
    if (e[o].checked && e[o].form === n)
      return e[o];
}, I1 = function(e) {
  if (!e.name)
    return !0;
  var n = e.form || _i(e), o = function(a) {
    return n.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = o(window.CSS.escape(e.name));
  else
    try {
      r = o(e.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
  var s = T1(r, e.form);
  return !s || s === e;
}, O1 = function(e) {
  return Cm(e) && e.type === "radio";
}, M1 = function(e) {
  return O1(e) && !I1(e);
}, P1 = function(e) {
  var n, o = e && _i(e), r = (n = o) === null || n === void 0 ? void 0 : n.host, s = !1;
  if (o && o !== e) {
    var i, a, l;
    for (s = !!((i = r) !== null && i !== void 0 && (a = i.ownerDocument) !== null && a !== void 0 && a.contains(r) || e != null && (l = e.ownerDocument) !== null && l !== void 0 && l.contains(e)); !s && r; ) {
      var c, u, d;
      o = _i(r), r = (c = o) === null || c === void 0 ? void 0 : c.host, s = !!((u = r) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(r));
    }
  }
  return s;
}, Cd = function(e) {
  var n = e.getBoundingClientRect(), o = n.width, r = n.height;
  return o === 0 && r === 0;
}, A1 = function(e, n) {
  var o = n.displayCheck, r = n.getShadowRoot;
  if (o === "full-native" && "checkVisibility" in e) {
    var s = e.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !s;
  }
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var i = mr.call(e, "details>summary:first-of-type"), a = i ? e.parentElement : e;
  if (mr.call(a, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  o === "full-native" || o === "legacy-full") {
    if (typeof r == "function") {
      for (var l = e; e; ) {
        var c = e.parentElement, u = _i(e);
        if (c && !c.shadowRoot && r(c) === !0)
          return Cd(e);
        e.assignedSlot ? e = e.assignedSlot : !c && u !== e.ownerDocument ? e = u.host : e = c;
      }
      e = l;
    }
    if (P1(e))
      return !e.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return Cd(e);
  return !1;
}, D1 = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var r = n.children.item(o);
          if (r.tagName === "LEGEND")
            return mr.call(n, "fieldset[disabled] *") ? !0 : !r.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Wl = function(e, n) {
  return !(n.disabled || N1(n) || A1(n, e) || // For a details element with a summary, the summary element gets the focus
  k1(n) || D1(n));
}, Gl = function(e, n) {
  return !(M1(n) || Em(n) < 0 || !Wl(e, n));
}, j1 = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, _m = function(e) {
  var n = [], o = [];
  return e.forEach(function(r, s) {
    var i = !!r.scopeParent, a = i ? r.scopeParent : r, l = _1(a, i), c = i ? _m(r.candidates) : a;
    l === 0 ? i ? n.push.apply(n, c) : n.push(a) : o.push({
      documentOrder: s,
      tabIndex: l,
      item: r,
      isScope: i,
      content: c
    });
  }), o.sort(R1).reduce(function(r, s) {
    return s.isScope ? r.push.apply(r, s.content) : r.push(s.content), r;
  }, []).concat(n);
}, fs = function(e, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = Ni([e], n.includeContainer, {
    filter: Gl.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: j1
  }) : o = wm(e, n.includeContainer, Gl.bind(null, n)), _m(o);
}, L1 = function(e, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = Ni([e], n.includeContainer, {
    filter: Wl.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = wm(e, n.includeContainer, Wl.bind(null, n)), o;
}, Rm = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return mr.call(e, Ci) === !1 ? !1 : Gl(n, e);
};
const Sr = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function Nm(t, e) {
  const n = fs(t, Sr()), o = n.length;
  if (o === 0)
    return;
  const r = Jt(vt(t)), s = n.indexOf(r), i = s === -1 ? e === 1 ? 0 : o - 1 : s + e;
  return n[i];
}
function na(t) {
  return Nm(vt(t).body, 1) || t;
}
function km(t) {
  return Nm(vt(t).body, -1) || t;
}
function Tm(t, e) {
  if (!t)
    return null;
  const n = fs(vt(t).body, Sr()), o = n.length;
  if (o === 0)
    return null;
  const r = n.indexOf(t);
  if (r === -1)
    return null;
  const s = (r + e + o) % o;
  return n[s];
}
function Im(t) {
  return Tm(t, 1);
}
function Om(t) {
  return Tm(t, -1);
}
function To(t, e) {
  const n = e || t.currentTarget, o = t.relatedTarget;
  return !o || !Ue(n, o);
}
function $1(t) {
  fs(t, Sr()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function _d(t) {
  t.querySelectorAll("[data-tabindex]").forEach((n) => {
    const o = n.dataset.tabindex;
    delete n.dataset.tabindex, o ? n.setAttribute("tabindex", o) : n.removeAttribute("tabindex");
  });
}
const kn = "ArrowUp", gn = "ArrowDown", Hn = "ArrowLeft", Tn = "ArrowRight", go = "Home", bo = "End", Mm = /* @__PURE__ */ new Set([Hn, Tn]), F1 = /* @__PURE__ */ new Set([Hn, Tn, go, bo]), Pm = /* @__PURE__ */ new Set([kn, gn]), V1 = /* @__PURE__ */ new Set([kn, gn, go, bo]), Am = /* @__PURE__ */ new Set([...Mm, ...Pm]), z1 = /* @__PURE__ */ new Set([...Am, go, bo]), ps = /* @__PURE__ */ new Set([kn, gn, Hn, Tn, go, bo]), Dm = "Shift", B1 = "Control", H1 = "Alt", U1 = "Meta", W1 = /* @__PURE__ */ new Set([Dm, B1, H1, U1]);
function G1(t) {
  return ut(t) && t.tagName === "INPUT";
}
function Rd(t) {
  return !!(G1(t) && t.selectionStart != null || ut(t) && t.tagName === "TEXTAREA");
}
function Nd(t, e, n, o) {
  if (!t || !e || !e.scrollTo)
    return;
  let r = t.scrollLeft, s = t.scrollTop;
  const i = t.clientWidth < t.scrollWidth, a = t.clientHeight < t.scrollHeight;
  if (i && o !== "vertical") {
    const l = kd(t, e, "left"), c = As(t), u = As(e);
    n === "ltr" && (l + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight ? r = l + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight : l - u.scrollMarginLeft < t.scrollLeft + c.scrollPaddingLeft && (r = l - u.scrollMarginLeft - c.scrollPaddingLeft)), n === "rtl" && (l - u.scrollMarginRight < t.scrollLeft + c.scrollPaddingLeft ? r = l - u.scrollMarginLeft - c.scrollPaddingLeft : l + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight && (r = l + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight));
  }
  if (a && o !== "horizontal") {
    const l = kd(t, e, "top"), c = As(t), u = As(e);
    l - u.scrollMarginTop < t.scrollTop + c.scrollPaddingTop ? s = l - u.scrollMarginTop - c.scrollPaddingTop : l + e.offsetHeight + u.scrollMarginBottom > t.scrollTop + t.clientHeight - c.scrollPaddingBottom && (s = l + e.offsetHeight + u.scrollMarginBottom - t.clientHeight + c.scrollPaddingBottom);
  }
  t.scrollTo({
    left: r,
    top: s,
    behavior: "auto"
  });
}
function kd(t, e, n) {
  const o = n === "left" ? "offsetLeft" : "offsetTop";
  let r = 0;
  for (; e.offsetParent && (r += e[o], e.offsetParent !== t); )
    e = e.offsetParent;
  return r;
}
function As(t) {
  const e = getComputedStyle(t);
  return {
    scrollMarginTop: parseFloat(e.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(e.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(e.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(e.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(e.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(e.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(e.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(e.scrollPaddingLeft) || 0
  };
}
const K1 = /* @__PURE__ */ new Set([gn, kn, Tn, Hn, go, bo]);
function Y1(t) {
  const {
    current: e
  } = t, n = [];
  for (let o = 0; o < e.length; o += 1) {
    const r = e[o];
    if (!Dl(r)) {
      const s = r?.querySelector('[type="button"], [role="button"]');
      s && !Dl(s) && n.push(s);
    }
  }
  return n;
}
const jm = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    disabled: o,
    className: r,
    id: s,
    render: i,
    nativeButton: a = !0,
    ...l
  } = e, {
    panelId: c,
    open: u,
    handleTrigger: d,
    disabled: p
  } = Zi(), m = o ?? p, {
    getButtonProps: h,
    buttonRef: g
  } = Wt({
    disabled: m,
    focusableWhenDisabled: !0,
    native: a
  }), {
    accordionItemRefs: y,
    direction: v,
    loopFocus: x,
    orientation: w
  } = xc(), E = v === "rtl", S = w === "horizontal", {
    state: C,
    setTriggerId: _,
    triggerId: R
  } = Rc();
  he(() => (s && _(s), () => {
    _(void 0);
  }), [s, _]);
  const O = f.useMemo(() => ({
    "aria-controls": u ? c : void 0,
    "aria-expanded": u,
    id: R,
    onClick: d,
    onKeyDown(F) {
      if (!K1.has(F.key))
        return;
      At(F);
      const N = Y1(y), L = N.length - 1;
      let M = -1;
      const A = N.indexOf(F.target);
      function $() {
        x ? M = A + 1 > L ? 0 : A + 1 : M = Math.min(A + 1, L);
      }
      function k() {
        x ? M = A === 0 ? L : A - 1 : M = A - 1;
      }
      switch (F.key) {
        case gn:
          S || $();
          break;
        case kn:
          S || k();
          break;
        case Tn:
          S && (E ? k() : $());
          break;
        case Hn:
          S && (E ? $() : k());
          break;
        case "Home":
          M = 0;
          break;
        case "End":
          M = L;
          break;
      }
      M > -1 && N[M].focus();
    }
  }), [y, d, R, S, E, x, u, c]);
  return _e("button", e, {
    state: C,
    ref: [n, g],
    props: [O, l, h],
    stateAttributesMapping: Jp
  });
});
process.env.NODE_ENV !== "production" && (jm.displayName = "AccordionTrigger");
let q1 = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.orientation = "data-orientation", t;
})({});
function Lm(t) {
  const {
    abortControllerRef: e,
    animationTypeRef: n,
    externalRef: o,
    height: r,
    hiddenUntilFound: s,
    keepMounted: i,
    id: a,
    mounted: l,
    onOpenChange: c,
    open: u,
    panelRef: d,
    runOnceAnimationsFinish: p,
    setDimensions: m,
    setMounted: h,
    setOpen: g,
    setVisible: y,
    transitionDimensionRef: v,
    visible: x,
    width: w
  } = t, E = f.useRef(!1), S = f.useRef(null), C = f.useRef(u), _ = f.useRef(u), R = $o(), O = f.useMemo(() => n.current === "css-animation" ? !x : !u && !l, [u, l, x, n]), j = fe((N) => {
    if (!N)
      return;
    if (n.current == null || v.current == null) {
      const M = getComputedStyle(N), A = M.animationName !== "none" && M.animationName !== "", $ = M.transitionDuration !== "0s" && M.transitionDuration !== "";
      A && $ ? process.env.NODE_ENV !== "production" && cs("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used.") : M.animationName === "none" && M.transitionDuration !== "0s" ? n.current = "css-transition" : M.animationName !== "none" && M.transitionDuration === "0s" ? n.current = "css-animation" : n.current = "none", N.getAttribute(q1.orientation) === "horizontal" || M.transitionProperty.indexOf("width") > -1 ? v.current = "width" : v.current = "height";
    }
    if (n.current !== "css-transition")
      return;
    (r === void 0 || w === void 0) && (m({
      height: N.scrollHeight,
      width: N.scrollWidth
    }), _.current && N.style.setProperty("transition-duration", "0s"));
    let T = -1, L = -1;
    return T = dt.request(() => {
      _.current = !1, L = dt.request(() => {
        setTimeout(() => {
          N.style.removeProperty("transition-duration");
        });
      });
    }), () => {
      dt.cancel(T), dt.cancel(L);
    };
  }), F = zt(o, d, j);
  return he(() => {
    if (n.current !== "css-transition")
      return;
    const N = d.current;
    if (!N)
      return;
    let T = -1;
    if (e.current != null && (e.current.abort(), e.current = null), u) {
      const L = {
        "justify-content": N.style.justifyContent,
        "align-items": N.style.alignItems,
        "align-content": N.style.alignContent,
        "justify-items": N.style.justifyItems
      };
      Object.keys(L).forEach((M) => {
        N.style.setProperty(M, "initial", "important");
      }), !_.current && !i && N.setAttribute(Qr.startingStyle, ""), m({
        height: N.scrollHeight,
        width: N.scrollWidth
      }), T = dt.request(() => {
        Object.entries(L).forEach(([M, A]) => {
          A === "" ? N.style.removeProperty(M) : N.style.setProperty(M, A);
        });
      });
    } else {
      if (N.scrollHeight === 0 && N.scrollWidth === 0)
        return;
      m({
        height: N.scrollHeight,
        width: N.scrollWidth
      });
      const L = new AbortController();
      e.current = L;
      const M = L.signal;
      let A = null;
      const $ = Qr.endingStyle;
      return A = new MutationObserver((k) => {
        k.some((B) => B.type === "attributes" && B.attributeName === $) && (A?.disconnect(), A = null, p(() => {
          m({
            height: 0,
            width: 0
          }), N.style.removeProperty("content-visibility"), h(!1), e.current === L && (e.current = null);
        }, M));
      }), A.observe(N, {
        attributes: !0,
        attributeFilter: [$]
      }), () => {
        A?.disconnect(), R.cancel(), e.current === L && (L.abort(), e.current = null);
      };
    }
    return () => {
      dt.cancel(T);
    };
  }, [e, n, R, s, i, l, u, d, p, m, h]), he(() => {
    if (n.current !== "css-animation")
      return;
    const N = d.current;
    N && (S.current = N.style.animationName || S.current, N.style.setProperty("animation-name", "none"), m({
      height: N.scrollHeight,
      width: N.scrollWidth
    }), !C.current && !E.current && N.style.removeProperty("animation-name"), u ? (e.current != null && (e.current.abort(), e.current = null), h(!0), y(!0)) : (e.current = new AbortController(), p(() => {
      h(!1), y(!1), e.current = null;
    }, e.current.signal)));
  }, [e, n, u, d, p, m, h, y, x]), xr(() => {
    const N = dt.request(() => {
      C.current = !1;
    });
    return () => dt.cancel(N);
  }), he(() => {
    if (!s)
      return;
    const N = d.current;
    if (!N)
      return;
    let T = -1, L = -1;
    return u && E.current && (N.style.transitionDuration = "0s", m({
      height: N.scrollHeight,
      width: N.scrollWidth
    }), T = dt.request(() => {
      E.current = !1, L = dt.request(() => {
        setTimeout(() => {
          N.style.removeProperty("transition-duration");
        });
      });
    })), () => {
      dt.cancel(T), dt.cancel(L);
    };
  }, [s, u, d, m]), he(() => {
    const N = d.current;
    N && s && O && (N.setAttribute("hidden", "until-found"), n.current === "css-transition" && N.setAttribute(Qr.startingStyle, ""));
  }, [s, O, n, d]), f.useEffect(function() {
    const T = d.current;
    if (!T)
      return;
    function L(M) {
      E.current = !0, g(!0), c(!0, ke(Ut, M));
    }
    return T.addEventListener("beforematch", L), () => {
      T.removeEventListener("beforematch", L);
    };
  }, [c, d, g]), f.useMemo(() => ({
    props: {
      hidden: O,
      id: a,
      ref: F
    }
  }), [O, a, F]);
}
let Td = /* @__PURE__ */ (function(t) {
  return t.accordionPanelHeight = "--accordion-panel-height", t.accordionPanelWidth = "--accordion-panel-width", t;
})({});
function Gt(t) {
  const {
    enabled: e = !0,
    open: n,
    ref: o,
    onComplete: r
  } = t, s = fe(r), i = Cc(o, n, !1);
  f.useEffect(() => {
    if (!e)
      return;
    const a = new AbortController();
    return i(s, a.signal), () => {
      a.abort();
    };
  }, [e, n, s, i]);
}
const $m = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    hiddenUntilFound: r,
    keepMounted: s,
    id: i,
    render: a,
    ...l
  } = e, {
    hiddenUntilFound: c,
    keepMounted: u
  } = xc(), {
    abortControllerRef: d,
    animationTypeRef: p,
    height: m,
    mounted: h,
    onOpenChange: g,
    open: y,
    panelId: v,
    panelRef: x,
    runOnceAnimationsFinish: w,
    setDimensions: E,
    setHiddenUntilFound: S,
    setKeepMounted: C,
    setMounted: _,
    setOpen: R,
    setVisible: O,
    transitionDimensionRef: j,
    visible: F,
    width: N,
    setPanelIdState: T,
    transitionStatus: L
  } = Zi(), M = r ?? c, A = s ?? u;
  process.env.NODE_ENV !== "production" && he(() => {
    s === !1 && M && cs("The `keepMounted={false}` prop on a Accordion.Panel will be ignored when using `contextHiddenUntilFound` on the Panel or the Root since it requires the panel to remain mounted when closed.");
  }, [M, s]), he(() => {
    if (i)
      return T(i), () => {
        T(void 0);
      };
  }, [i, T]), he(() => {
    S(M);
  }, [S, M]), he(() => {
    C(A);
  }, [C, A]), Gt({
    open: y && L === "idle",
    ref: x,
    onComplete() {
      y && E({
        width: void 0,
        height: void 0
      });
    }
  });
  const {
    props: $
  } = Lm({
    abortControllerRef: d,
    animationTypeRef: p,
    externalRef: n,
    height: m,
    hiddenUntilFound: M,
    id: i ?? v,
    keepMounted: A,
    mounted: h,
    onOpenChange: g,
    open: y,
    panelRef: x,
    runOnceAnimationsFinish: w,
    setDimensions: E,
    setMounted: _,
    setOpen: R,
    setVisible: O,
    transitionDimensionRef: j,
    visible: F,
    width: N
  }), {
    state: k,
    triggerId: H
  } = Rc(), B = f.useMemo(() => ({
    ...k,
    transitionStatus: L
  }), [k, L]), P = _e("div", e, {
    state: B,
    ref: [n, x],
    props: [$, {
      "aria-labelledby": H,
      role: "region",
      style: {
        [Td.accordionPanelHeight]: m === void 0 ? "auto" : `${m}px`,
        [Td.accordionPanelWidth]: N === void 0 ? "auto" : `${N}px`
      }
    }, l],
    stateAttributesMapping: Nc
  });
  return A || M || !A && h ? P : null;
});
process.env.NODE_ENV !== "production" && ($m.displayName = "AccordionPanel");
const X1 = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m6 9l6 6l6-6"/>'
}, Vo = X1, Z1 = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18 15l-6-6l-6 6"/>'
}, ns = Z1;
function J1(t, e) {
  const n = t.icons, o = t.aliases || /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  function s(i) {
    if (n[i]) return r[i] = [];
    if (!(i in r)) {
      r[i] = null;
      const a = o[i] && o[i].parent, l = a && s(a);
      l && (r[i] = [a].concat(l));
    }
    return r[i];
  }
  return Object.keys(n).concat(Object.keys(o)).forEach(s), r;
}
const Fm = Object.freeze({
  left: 0,
  top: 0,
  width: 16,
  height: 16
}), ki = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), Lc = Object.freeze({
  ...Fm,
  ...ki
}), Kl = Object.freeze({
  ...Lc,
  body: "",
  hidden: !1
});
function Q1(t, e) {
  const n = {};
  !t.hFlip != !e.hFlip && (n.hFlip = !0), !t.vFlip != !e.vFlip && (n.vFlip = !0);
  const o = ((t.rotate || 0) + (e.rotate || 0)) % 4;
  return o && (n.rotate = o), n;
}
function Id(t, e) {
  const n = Q1(t, e);
  for (const o in Kl) o in ki ? o in t && !(o in n) && (n[o] = ki[o]) : o in e ? n[o] = e[o] : o in t && (n[o] = t[o]);
  return n;
}
function ex(t, e, n) {
  const o = t.icons, r = t.aliases || /* @__PURE__ */ Object.create(null);
  let s = {};
  function i(a) {
    s = Id(o[a] || r[a], s);
  }
  return i(e), n.forEach(i), Id(t, s);
}
function Vm(t, e) {
  const n = [];
  if (typeof t != "object" || typeof t.icons != "object") return n;
  t.not_found instanceof Array && t.not_found.forEach((r) => {
    e(r, null), n.push(r);
  });
  const o = J1(t);
  for (const r in o) {
    const s = o[r];
    s && (e(r, ex(t, r, s)), n.push(r));
  }
  return n;
}
const tx = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Fm
};
function Wa(t, e) {
  for (const n in e) if (n in t && typeof t[n] != typeof e[n]) return !1;
  return !0;
}
function zm(t) {
  if (typeof t != "object" || t === null) return null;
  const e = t;
  if (typeof e.prefix != "string" || !t.icons || typeof t.icons != "object" || !Wa(t, tx)) return null;
  const n = e.icons;
  for (const r in n) {
    const s = n[r];
    if (!r || typeof s.body != "string" || !Wa(s, Kl)) return null;
  }
  const o = e.aliases || /* @__PURE__ */ Object.create(null);
  for (const r in o) {
    const s = o[r], i = s.parent;
    if (!r || typeof i != "string" || !n[i] && !o[i] || !Wa(s, Kl)) return null;
  }
  return e;
}
const Od = /* @__PURE__ */ Object.create(null);
function nx(t, e) {
  return {
    provider: t,
    prefix: e,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function hr(t, e) {
  const n = Od[t] || (Od[t] = /* @__PURE__ */ Object.create(null));
  return n[e] || (n[e] = nx(t, e));
}
function Bm(t, e) {
  return zm(e) ? Vm(e, (n, o) => {
    o ? t.icons[n] = o : t.missing.add(n);
  }) : [];
}
function ox(t, e, n) {
  try {
    if (typeof n.body == "string")
      return t.icons[e] = { ...n }, !0;
  } catch {
  }
  return !1;
}
const Hm = /^[a-z0-9]+(-[a-z0-9]+)*$/, oa = (t, e, n, o = "") => {
  const r = t.split(":");
  if (t.slice(0, 1) === "@") {
    if (r.length < 2 || r.length > 3) return null;
    o = r.shift().slice(1);
  }
  if (r.length > 3 || !r.length) return null;
  if (r.length > 1) {
    const a = r.pop(), l = r.pop(), c = {
      provider: r.length > 0 ? r[0] : o,
      prefix: l,
      name: a
    };
    return e && !di(c) ? null : c;
  }
  const s = r[0], i = s.split("-");
  if (i.length > 1) {
    const a = {
      provider: o,
      prefix: i.shift(),
      name: i.join("-")
    };
    return e && !di(a) ? null : a;
  }
  if (n && o === "") {
    const a = {
      provider: o,
      prefix: "",
      name: s
    };
    return e && !di(a, n) ? null : a;
  }
  return null;
}, di = (t, e) => t ? !!((e && t.prefix === "" || t.prefix) && t.name) : !1;
let os = !1;
function Um(t) {
  return typeof t == "boolean" && (os = t), os;
}
function Md(t) {
  const e = typeof t == "string" ? oa(t, !0, os) : t;
  if (e) {
    const n = hr(e.provider, e.prefix), o = e.name;
    return n.icons[o] || (n.missing.has(o) ? null : void 0);
  }
}
function rx(t, e) {
  const n = oa(t, !0, os);
  if (!n) return !1;
  const o = hr(n.provider, n.prefix);
  return e ? ox(o, n.name, e) : (o.missing.add(n.name), !0);
}
function sx(t, e) {
  if (typeof t != "object") return !1;
  if (typeof e != "string" && (e = t.provider || ""), os && !e && !t.prefix) {
    let r = !1;
    return zm(t) && (t.prefix = "", Vm(t, (s, i) => {
      rx(s, i) && (r = !0);
    })), r;
  }
  const n = t.prefix;
  if (!di({
    prefix: n,
    name: "a"
  })) return !1;
  const o = hr(e, n);
  return !!Bm(o, t);
}
const Wm = Object.freeze({
  width: null,
  height: null
}), Gm = Object.freeze({
  ...Wm,
  ...ki
}), ix = /(-?[0-9.]*[0-9]+[0-9.]*)/g, ax = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Pd(t, e, n) {
  if (e === 1) return t;
  if (n = n || 100, typeof t == "number") return Math.ceil(t * e * n) / n;
  if (typeof t != "string") return t;
  const o = t.split(ix);
  if (o === null || !o.length) return t;
  const r = [];
  let s = o.shift(), i = ax.test(s);
  for (; ; ) {
    if (i) {
      const a = parseFloat(s);
      isNaN(a) ? r.push(s) : r.push(Math.ceil(a * e * n) / n);
    } else r.push(s);
    if (s = o.shift(), s === void 0) return r.join("");
    i = !i;
  }
}
function lx(t, e = "defs") {
  let n = "";
  const o = t.indexOf("<" + e);
  for (; o >= 0; ) {
    const r = t.indexOf(">", o), s = t.indexOf("</" + e);
    if (r === -1 || s === -1) break;
    const i = t.indexOf(">", s);
    if (i === -1) break;
    n += t.slice(r + 1, s).trim(), t = t.slice(0, o).trim() + t.slice(i + 1);
  }
  return {
    defs: n,
    content: t
  };
}
function cx(t, e) {
  return t ? "<defs>" + t + "</defs>" + e : e;
}
function ux(t, e, n) {
  const o = lx(t);
  return cx(o.defs, e + o.content + n);
}
const dx = (t) => t === "unset" || t === "undefined" || t === "none";
function fx(t, e) {
  const n = {
    ...Lc,
    ...t
  }, o = {
    ...Gm,
    ...e
  }, r = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let s = n.body;
  [n, o].forEach((g) => {
    const y = [], v = g.hFlip, x = g.vFlip;
    let w = g.rotate;
    v ? x ? w += 2 : (y.push("translate(" + (r.width + r.left).toString() + " " + (0 - r.top).toString() + ")"), y.push("scale(-1 1)"), r.top = r.left = 0) : x && (y.push("translate(" + (0 - r.left).toString() + " " + (r.height + r.top).toString() + ")"), y.push("scale(1 -1)"), r.top = r.left = 0);
    let E;
    switch (w < 0 && (w -= Math.floor(w / 4) * 4), w = w % 4, w) {
      case 1:
        E = r.height / 2 + r.top, y.unshift("rotate(90 " + E.toString() + " " + E.toString() + ")");
        break;
      case 2:
        y.unshift("rotate(180 " + (r.width / 2 + r.left).toString() + " " + (r.height / 2 + r.top).toString() + ")");
        break;
      case 3:
        E = r.width / 2 + r.left, y.unshift("rotate(-90 " + E.toString() + " " + E.toString() + ")");
        break;
    }
    w % 2 === 1 && (r.left !== r.top && (E = r.left, r.left = r.top, r.top = E), r.width !== r.height && (E = r.width, r.width = r.height, r.height = E)), y.length && (s = ux(s, '<g transform="' + y.join(" ") + '">', "</g>"));
  });
  const i = o.width, a = o.height, l = r.width, c = r.height;
  let u, d;
  i === null ? (d = a === null ? "1em" : a === "auto" ? c : a, u = Pd(d, l / c)) : (u = i === "auto" ? l : i, d = a === null ? Pd(u, c / l) : a === "auto" ? c : a);
  const p = {}, m = (g, y) => {
    dx(y) || (p[g] = y.toString());
  };
  m("width", u), m("height", d);
  const h = [
    r.left,
    r.top,
    l,
    c
  ];
  return p.viewBox = h.join(" "), {
    attributes: p,
    viewBox: h,
    body: s
  };
}
const px = /\sid="(\S+)"/g, mx = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let hx = 0;
function gx(t, e = mx) {
  const n = [];
  let o;
  for (; o = px.exec(t); ) n.push(o[1]);
  if (!n.length) return t;
  const r = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return n.forEach((s) => {
    const i = typeof e == "function" ? e(s) : e + (hx++).toString(), a = s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    t = t.replace(new RegExp('([#;"])(' + a + ')([")]|\\.[a-z])', "g"), "$1" + i + r + "$3");
  }), t = t.replace(new RegExp(r, "g"), ""), t;
}
const Yl = /* @__PURE__ */ Object.create(null);
function bx(t, e) {
  Yl[t] = e;
}
function ql(t) {
  return Yl[t] || Yl[""];
}
function $c(t) {
  let e;
  if (typeof t.resources == "string") e = [t.resources];
  else if (e = t.resources, !(e instanceof Array) || !e.length) return null;
  return {
    resources: e,
    path: t.path || "/",
    maxURL: t.maxURL || 500,
    rotate: t.rotate || 750,
    timeout: t.timeout || 5e3,
    random: t.random === !0,
    index: t.index || 0,
    dataAfterTimeout: t.dataAfterTimeout !== !1
  };
}
const Fc = /* @__PURE__ */ Object.create(null), Dr = ["https://api.simplesvg.com", "https://api.unisvg.com"], fi = [];
for (; Dr.length > 0; ) Dr.length === 1 || Math.random() > 0.5 ? fi.push(Dr.shift()) : fi.push(Dr.pop());
Fc[""] = $c({ resources: ["https://api.iconify.design"].concat(fi) });
function vx(t, e) {
  const n = $c(e);
  return n === null ? !1 : (Fc[t] = n, !0);
}
function Vc(t) {
  return Fc[t];
}
const yx = () => {
  let t;
  try {
    if (t = fetch, typeof t == "function") return t;
  } catch {
  }
};
let Ad = yx();
function xx(t, e) {
  const n = Vc(t);
  if (!n) return 0;
  let o;
  if (!n.maxURL) o = 0;
  else {
    let r = 0;
    n.resources.forEach((i) => {
      r = Math.max(r, i.length);
    });
    const s = e + ".json?icons=";
    o = n.maxURL - r - n.path.length - s.length;
  }
  return o;
}
function wx(t) {
  return t === 404;
}
const Sx = (t, e, n) => {
  const o = [], r = xx(t, e), s = "icons";
  let i = {
    type: s,
    provider: t,
    prefix: e,
    icons: []
  }, a = 0;
  return n.forEach((l, c) => {
    a += l.length + 1, a >= r && c > 0 && (o.push(i), i = {
      type: s,
      provider: t,
      prefix: e,
      icons: []
    }, a = l.length), i.icons.push(l);
  }), o.push(i), o;
};
function Ex(t) {
  if (typeof t == "string") {
    const e = Vc(t);
    if (e) return e.path;
  }
  return "/";
}
const Cx = (t, e, n) => {
  if (!Ad) {
    n("abort", 424);
    return;
  }
  let o = Ex(e.provider);
  switch (e.type) {
    case "icons": {
      const s = e.prefix, a = e.icons.join(","), l = new URLSearchParams({ icons: a });
      o += s + ".json?" + l.toString();
      break;
    }
    case "custom": {
      const s = e.uri;
      o += s.slice(0, 1) === "/" ? s.slice(1) : s;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let r = 503;
  Ad(t + o).then((s) => {
    const i = s.status;
    if (i !== 200) {
      setTimeout(() => {
        n(wx(i) ? "abort" : "next", i);
      });
      return;
    }
    return r = 501, s.json();
  }).then((s) => {
    if (typeof s != "object" || s === null) {
      setTimeout(() => {
        s === 404 ? n("abort", s) : n("next", r);
      });
      return;
    }
    setTimeout(() => {
      n("success", s);
    });
  }).catch(() => {
    n("next", r);
  });
}, _x = {
  prepare: Sx,
  send: Cx
};
function Km(t, e) {
  t.forEach((n) => {
    const o = n.loaderCallbacks;
    o && (n.loaderCallbacks = o.filter((r) => r.id !== e));
  });
}
function Rx(t) {
  t.pendingCallbacksFlag || (t.pendingCallbacksFlag = !0, setTimeout(() => {
    t.pendingCallbacksFlag = !1;
    const e = t.loaderCallbacks ? t.loaderCallbacks.slice(0) : [];
    if (!e.length) return;
    let n = !1;
    const o = t.provider, r = t.prefix;
    e.forEach((s) => {
      const i = s.icons, a = i.pending.length;
      i.pending = i.pending.filter((l) => {
        if (l.prefix !== r) return !0;
        const c = l.name;
        if (t.icons[c]) i.loaded.push({
          provider: o,
          prefix: r,
          name: c
        });
        else if (t.missing.has(c)) i.missing.push({
          provider: o,
          prefix: r,
          name: c
        });
        else
          return n = !0, !0;
        return !1;
      }), i.pending.length !== a && (n || Km([t], s.id), s.callback(i.loaded.slice(0), i.missing.slice(0), i.pending.slice(0), s.abort));
    });
  }));
}
let Nx = 0;
function kx(t, e, n) {
  const o = Nx++, r = Km.bind(null, n, o);
  if (!e.pending.length) return r;
  const s = {
    id: o,
    icons: e,
    callback: t,
    abort: r
  };
  return n.forEach((i) => {
    (i.loaderCallbacks || (i.loaderCallbacks = [])).push(s);
  }), r;
}
function Tx(t) {
  const e = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  t.sort((r, s) => r.provider !== s.provider ? r.provider.localeCompare(s.provider) : r.prefix !== s.prefix ? r.prefix.localeCompare(s.prefix) : r.name.localeCompare(s.name));
  let o = {
    provider: "",
    prefix: "",
    name: ""
  };
  return t.forEach((r) => {
    if (o.name === r.name && o.prefix === r.prefix && o.provider === r.provider) return;
    o = r;
    const s = r.provider, i = r.prefix, a = r.name, l = n[s] || (n[s] = /* @__PURE__ */ Object.create(null)), c = l[i] || (l[i] = hr(s, i));
    let u;
    a in c.icons ? u = e.loaded : i === "" || c.missing.has(a) ? u = e.missing : u = e.pending;
    const d = {
      provider: s,
      prefix: i,
      name: a
    };
    u.push(d);
  }), e;
}
function Ix(t, e = !0, n = !1) {
  const o = [];
  return t.forEach((r) => {
    const s = typeof r == "string" ? oa(r, e, n) : r;
    s && o.push(s);
  }), o;
}
const Ox = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function Mx(t, e, n, o) {
  const r = t.resources.length, s = t.random ? Math.floor(Math.random() * r) : t.index;
  let i;
  if (t.random) {
    let C = t.resources.slice(0);
    for (i = []; C.length > 1; ) {
      const _ = Math.floor(Math.random() * C.length);
      i.push(C[_]), C = C.slice(0, _).concat(C.slice(_ + 1));
    }
    i = i.concat(C);
  } else i = t.resources.slice(s).concat(t.resources.slice(0, s));
  const a = Date.now();
  let l = "pending", c = 0, u, d = null, p = [], m = [];
  typeof o == "function" && m.push(o);
  function h() {
    d && (clearTimeout(d), d = null);
  }
  function g() {
    l === "pending" && (l = "aborted"), h(), p.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), p = [];
  }
  function y(C, _) {
    _ && (m = []), typeof C == "function" && m.push(C);
  }
  function v() {
    return {
      startTime: a,
      payload: e,
      status: l,
      queriesSent: c,
      queriesPending: p.length,
      subscribe: y,
      abort: g
    };
  }
  function x() {
    l = "failed", m.forEach((C) => {
      C(void 0, u);
    });
  }
  function w() {
    p.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), p = [];
  }
  function E(C, _, R) {
    const O = _ !== "success";
    switch (p = p.filter((j) => j !== C), l) {
      case "pending":
        break;
      case "failed":
        if (O || !t.dataAfterTimeout) return;
        break;
      default:
        return;
    }
    if (_ === "abort") {
      u = R, x();
      return;
    }
    if (O) {
      u = R, p.length || (i.length ? S() : x());
      return;
    }
    if (h(), w(), !t.random) {
      const j = t.resources.indexOf(C.resource);
      j !== -1 && j !== t.index && (t.index = j);
    }
    l = "completed", m.forEach((j) => {
      j(R);
    });
  }
  function S() {
    if (l !== "pending") return;
    h();
    const C = i.shift();
    if (C === void 0) {
      if (p.length) {
        d = setTimeout(() => {
          h(), l === "pending" && (w(), x());
        }, t.timeout);
        return;
      }
      x();
      return;
    }
    const _ = {
      status: "pending",
      resource: C,
      callback: (R, O) => {
        E(_, R, O);
      }
    };
    p.push(_), c++, d = setTimeout(S, t.rotate), n(C, e, _.callback);
  }
  return setTimeout(S), v;
}
function Ym(t) {
  const e = {
    ...Ox,
    ...t
  };
  let n = [];
  function o() {
    n = n.filter((a) => a().status === "pending");
  }
  function r(a, l, c) {
    const u = Mx(e, a, l, (d, p) => {
      o(), c && c(d, p);
    });
    return n.push(u), u;
  }
  function s(a) {
    return n.find((l) => a(l)) || null;
  }
  return {
    query: r,
    find: s,
    setIndex: (a) => {
      e.index = a;
    },
    getIndex: () => e.index,
    cleanup: o
  };
}
function Dd() {
}
const Ga = /* @__PURE__ */ Object.create(null);
function Px(t) {
  if (!Ga[t]) {
    const e = Vc(t);
    if (!e) return;
    const n = Ym(e), o = {
      config: e,
      redundancy: n
    };
    Ga[t] = o;
  }
  return Ga[t];
}
function Ax(t, e, n) {
  let o, r;
  if (typeof t == "string") {
    const s = ql(t);
    if (!s)
      return n(void 0, 424), Dd;
    r = s.send;
    const i = Px(t);
    i && (o = i.redundancy);
  } else {
    const s = $c(t);
    if (s) {
      o = Ym(s);
      const i = t.resources ? t.resources[0] : "", a = ql(i);
      a && (r = a.send);
    }
  }
  return !o || !r ? (n(void 0, 424), Dd) : o.query(e, r, n)().abort;
}
function jd() {
}
function Dx(t) {
  t.iconsLoaderFlag || (t.iconsLoaderFlag = !0, setTimeout(() => {
    t.iconsLoaderFlag = !1, Rx(t);
  }));
}
function jx(t) {
  const e = [], n = [];
  return t.forEach((o) => {
    (o.match(Hm) ? e : n).push(o);
  }), {
    valid: e,
    invalid: n
  };
}
function jr(t, e, n) {
  function o() {
    const r = t.pendingIcons;
    e.forEach((s) => {
      r && r.delete(s), t.icons[s] || t.missing.add(s);
    });
  }
  if (n && typeof n == "object") try {
    if (!Bm(t, n).length) {
      o();
      return;
    }
  } catch (r) {
    console.error(r);
  }
  o(), Dx(t);
}
function Ld(t, e) {
  t instanceof Promise ? t.then((n) => {
    e(n);
  }).catch(() => {
    e(null);
  }) : e(t);
}
function Lx(t, e) {
  t.iconsToLoad ? t.iconsToLoad = t.iconsToLoad.concat(e).sort() : t.iconsToLoad = e, t.iconsQueueFlag || (t.iconsQueueFlag = !0, setTimeout(() => {
    t.iconsQueueFlag = !1;
    const { provider: n, prefix: o } = t, r = t.iconsToLoad;
    if (delete t.iconsToLoad, !r || !r.length) return;
    const s = t.loadIcon;
    if (t.loadIcons && (r.length > 1 || !s)) {
      Ld(t.loadIcons(r, o, n), (u) => {
        jr(t, r, u);
      });
      return;
    }
    if (s) {
      r.forEach((u) => {
        const d = s(u, o, n);
        Ld(d, (p) => {
          const m = p ? {
            prefix: o,
            icons: { [u]: p }
          } : null;
          jr(t, [u], m);
        });
      });
      return;
    }
    const { valid: i, invalid: a } = jx(r);
    if (a.length && jr(t, a, null), !i.length) return;
    const l = o.match(Hm) ? ql(n) : null;
    if (!l) {
      jr(t, i, null);
      return;
    }
    l.prepare(n, o, i).forEach((u) => {
      Ax(n, u, (d) => {
        jr(t, u.icons, d);
      });
    });
  }));
}
const $x = (t, e) => {
  const n = Ix(t, !0, Um()), o = Tx(n);
  if (!o.pending.length) {
    let l = !0;
    return e && setTimeout(() => {
      l && e(o.loaded, o.missing, o.pending, jd);
    }), () => {
      l = !1;
    };
  }
  const r = /* @__PURE__ */ Object.create(null), s = [];
  let i, a;
  return o.pending.forEach((l) => {
    const { provider: c, prefix: u } = l;
    if (u === a && c === i) return;
    i = c, a = u, s.push(hr(c, u));
    const d = r[c] || (r[c] = /* @__PURE__ */ Object.create(null));
    d[u] || (d[u] = []);
  }), o.pending.forEach((l) => {
    const { provider: c, prefix: u, name: d } = l, p = hr(c, u), m = p.pendingIcons || (p.pendingIcons = /* @__PURE__ */ new Set());
    m.has(d) || (m.add(d), r[c][u].push(d));
  }), s.forEach((l) => {
    const c = r[l.provider][l.prefix];
    c.length && Lx(l, c);
  }), e ? kx(e, o, s) : jd;
};
function Fx(t, e) {
  const n = { ...t };
  for (const o in e) {
    const r = e[o], s = typeof r;
    o in Wm ? (r === null || r && (s === "string" || s === "number")) && (n[o] = r) : s === typeof n[o] && (n[o] = o === "rotate" ? r % 4 : r);
  }
  return n;
}
const Vx = /[\s,]+/;
function zx(t, e) {
  e.split(Vx).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        t.hFlip = !0;
        break;
      case "vertical":
        t.vFlip = !0;
        break;
    }
  });
}
function Bx(t, e = 0) {
  const n = t.replace(/^-?[0-9.]*/, "");
  function o(r) {
    for (; r < 0; ) r += 4;
    return r % 4;
  }
  if (n === "") {
    const r = parseInt(t);
    return isNaN(r) ? 0 : o(r);
  } else if (n !== t) {
    let r = 0;
    switch (n) {
      case "%":
        r = 25;
        break;
      case "deg":
        r = 90;
    }
    if (r) {
      let s = parseFloat(t.slice(0, t.length - n.length));
      return isNaN(s) ? 0 : (s = s / r, s % 1 === 0 ? o(s) : 0);
    }
  }
  return e;
}
function Hx(t, e) {
  let n = t.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const o in e) n += " " + o + '="' + e[o] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + t + "</svg>";
}
function Ux(t) {
  return t.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Wx(t) {
  return "data:image/svg+xml," + Ux(t);
}
function Gx(t) {
  return 'url("' + Wx(t) + '")';
}
let es;
function Kx() {
  try {
    es = window.trustedTypes.createPolicy("iconify", { createHTML: (t) => t });
  } catch {
    es = null;
  }
}
function Yx(t) {
  return es === void 0 && Kx(), es ? es.createHTML(t) : t;
}
const qm = {
  ...Gm,
  inline: !1
}, qx = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, Xx = {
  display: "inline-block"
}, Xl = {
  backgroundColor: "currentColor"
}, Xm = {
  backgroundColor: "transparent"
}, $d = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, Fd = {
  WebkitMask: Xl,
  mask: Xl,
  background: Xm
};
for (const t in Fd) {
  const e = Fd[t];
  for (const n in $d)
    e[t + n] = $d[n];
}
const Zx = {
  ...qm,
  inline: !0
};
function Vd(t) {
  return t + (t.match(/^[-0-9.]+$/) ? "px" : "");
}
const Jx = (t, e, n) => {
  const o = e.inline ? Zx : qm, r = Fx(o, e), s = e.mode || "svg", i = {}, a = e.style || {}, l = {
    ...s === "svg" ? qx : {}
  };
  if (n) {
    const y = oa(n, !1, !0);
    if (y) {
      const v = ["iconify"], x = [
        "provider",
        "prefix"
      ];
      for (const w of x)
        y[w] && v.push("iconify--" + y[w]);
      l.className = v.join(" ");
    }
  }
  for (let y in e) {
    const v = e[y];
    if (v !== void 0)
      switch (y) {
        // Properties to ignore
        case "icon":
        case "style":
        case "children":
        case "onLoad":
        case "mode":
        case "ssr":
        case "fallback":
          break;
        // Forward ref
        case "_ref":
          l.ref = v;
          break;
        // Merge class names
        case "className":
          l[y] = (l[y] ? l[y] + " " : "") + v;
          break;
        // Boolean attributes
        case "inline":
        case "hFlip":
        case "vFlip":
          r[y] = v === !0 || v === "true" || v === 1;
          break;
        // Flip as string: 'horizontal,vertical'
        case "flip":
          typeof v == "string" && zx(r, v);
          break;
        // Color: copy to style
        case "color":
          i.color = v;
          break;
        // Rotation as string
        case "rotate":
          typeof v == "string" ? r[y] = Bx(v) : typeof v == "number" && (r[y] = v);
          break;
        // Remove aria-hidden
        case "ariaHidden":
        case "aria-hidden":
          v !== !0 && v !== "true" && delete l["aria-hidden"];
          break;
        // Copy missing property if it does not exist in customisations
        default:
          o[y] === void 0 && (l[y] = v);
      }
  }
  const c = fx(t, r), u = c.attributes;
  if (r.inline && (i.verticalAlign = "-0.125em"), s === "svg") {
    l.style = {
      ...i,
      ...a
    }, Object.assign(l, u);
    let y = 0, v = e.id;
    return typeof v == "string" && (v = v.replace(/-/g, "_")), l.dangerouslySetInnerHTML = {
      __html: Yx(gx(c.body, v ? () => v + "ID" + y++ : "iconifyReact"))
    }, fr("svg", l);
  }
  const { body: d, width: p, height: m } = t, h = s === "mask" || (s === "bg" ? !1 : d.indexOf("currentColor") !== -1), g = Hx(d, {
    ...u,
    width: p + "",
    height: m + ""
  });
  return l.style = {
    ...i,
    "--svg": Gx(g),
    width: Vd(u.width),
    height: Vd(u.height),
    ...Xx,
    ...h ? Xl : Xm,
    ...a
  }, fr("span", l);
};
Um(!0);
bx("", _x);
if (typeof document < "u" && typeof window < "u") {
  const t = window;
  if (t.IconifyPreload !== void 0) {
    const e = t.IconifyPreload, n = "Invalid IconifyPreload syntax.";
    typeof e == "object" && e !== null && (e instanceof Array ? e : [e]).forEach((o) => {
      try {
        // Check if item is an object and not null/array
        (typeof o != "object" || o === null || o instanceof Array || // Check for 'icons' and 'prefix'
        typeof o.icons != "object" || typeof o.prefix != "string" || // Add icon set
        !sx(o)) && console.error(n);
      } catch {
        console.error(n);
      }
    });
  }
  if (t.IconifyProviders !== void 0) {
    const e = t.IconifyProviders;
    if (typeof e == "object" && e !== null)
      for (let n in e) {
        const o = "IconifyProviders[" + n + "] is invalid.";
        try {
          const r = e[n];
          if (typeof r != "object" || !r || r.resources === void 0)
            continue;
          vx(n, r) || console.error(o);
        } catch {
          console.error(o);
        }
      }
  }
}
function Zm(t) {
  const [e, n] = Fn(!!t.ssr), [o, r] = Fn({});
  function s(m) {
    if (m) {
      const h = t.icon;
      if (typeof h == "object")
        return {
          name: "",
          data: h
        };
      const g = Md(h);
      if (g)
        return {
          name: h,
          data: g
        };
    }
    return {
      name: ""
    };
  }
  const [i, a] = Fn(s(!!t.ssr));
  function l() {
    const m = o.callback;
    m && (m(), r({}));
  }
  function c(m) {
    if (JSON.stringify(i) !== JSON.stringify(m))
      return l(), a(m), !0;
  }
  function u() {
    var m;
    const h = t.icon;
    if (typeof h == "object") {
      c({
        name: "",
        data: h
      });
      return;
    }
    const g = Md(h);
    if (c({
      name: h,
      data: g
    }))
      if (g === void 0) {
        const y = $x([h], u);
        r({
          callback: y
        });
      } else g && ((m = t.onLoad) === null || m === void 0 || m.call(t, h));
  }
  $n(() => (n(!0), l), []), $n(() => {
    e && u();
  }, [t.icon, e]);
  const { name: d, data: p } = i;
  return p ? Jx({
    ...Lc,
    ...p
  }, t, d) : t.children ? t.children : t.fallback ? t.fallback : fr("span", {});
}
const Ve = jp((t, e) => Zm({
  ...t,
  _ref: e
}));
jp((t, e) => Zm({
  inline: !0,
  ...t,
  _ref: e
}));
function Jm(t) {
  var e, n, o = "";
  if (typeof t == "string" || typeof t == "number") o += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var r = t.length;
    for (e = 0; e < r; e++) t[e] && (n = Jm(t[e])) && (o && (o += " "), o += n);
  } else for (n in t) t[n] && (o && (o += " "), o += n);
  return o;
}
function Qm() {
  for (var t, e, n = 0, o = "", r = arguments.length; n < r; n++) (t = arguments[n]) && (e = Jm(t)) && (o && (o += " "), o += e);
  return o;
}
const Qx = (t, e) => {
  const n = new Array(t.length + e.length);
  for (let o = 0; o < t.length; o++)
    n[o] = t[o];
  for (let o = 0; o < e.length; o++)
    n[t.length + o] = e[o];
  return n;
}, e0 = (t, e) => ({
  classGroupId: t,
  validator: e
}), eh = (t = /* @__PURE__ */ new Map(), e = null, n) => ({
  nextPart: t,
  validators: e,
  classGroupId: n
}), Ti = "-", zd = [], t0 = "arbitrary..", n0 = (t) => {
  const e = r0(t), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: o
  } = t;
  return {
    getClassGroupId: (i) => {
      if (i.startsWith("[") && i.endsWith("]"))
        return o0(i);
      const a = i.split(Ti), l = a[0] === "" && a.length > 1 ? 1 : 0;
      return th(a, l, e);
    },
    getConflictingClassGroupIds: (i, a) => {
      if (a) {
        const l = o[i], c = n[i];
        return l ? c ? Qx(c, l) : l : c || zd;
      }
      return n[i] || zd;
    }
  };
}, th = (t, e, n) => {
  if (t.length - e === 0)
    return n.classGroupId;
  const r = t[e], s = n.nextPart.get(r);
  if (s) {
    const c = th(t, e + 1, s);
    if (c) return c;
  }
  const i = n.validators;
  if (i === null)
    return;
  const a = e === 0 ? t.join(Ti) : t.slice(e).join(Ti), l = i.length;
  for (let c = 0; c < l; c++) {
    const u = i[c];
    if (u.validator(a))
      return u.classGroupId;
  }
}, o0 = (t) => t.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const e = t.slice(1, -1), n = e.indexOf(":"), o = e.slice(0, n);
  return o ? t0 + o : void 0;
})(), r0 = (t) => {
  const {
    theme: e,
    classGroups: n
  } = t;
  return s0(n, e);
}, s0 = (t, e) => {
  const n = eh();
  for (const o in t) {
    const r = t[o];
    zc(r, n, o, e);
  }
  return n;
}, zc = (t, e, n, o) => {
  const r = t.length;
  for (let s = 0; s < r; s++) {
    const i = t[s];
    i0(i, e, n, o);
  }
}, i0 = (t, e, n, o) => {
  if (typeof t == "string") {
    a0(t, e, n);
    return;
  }
  if (typeof t == "function") {
    l0(t, e, n, o);
    return;
  }
  c0(t, e, n, o);
}, a0 = (t, e, n) => {
  const o = t === "" ? e : nh(e, t);
  o.classGroupId = n;
}, l0 = (t, e, n, o) => {
  if (u0(t)) {
    zc(t(o), e, n, o);
    return;
  }
  e.validators === null && (e.validators = []), e.validators.push(e0(n, t));
}, c0 = (t, e, n, o) => {
  const r = Object.entries(t), s = r.length;
  for (let i = 0; i < s; i++) {
    const [a, l] = r[i];
    zc(l, nh(e, a), n, o);
  }
}, nh = (t, e) => {
  let n = t;
  const o = e.split(Ti), r = o.length;
  for (let s = 0; s < r; s++) {
    const i = o[s];
    let a = n.nextPart.get(i);
    a || (a = eh(), n.nextPart.set(i, a)), n = a;
  }
  return n;
}, u0 = (t) => "isThemeGetter" in t && t.isThemeGetter === !0, d0 = (t) => {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, n = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  const r = (s, i) => {
    n[s] = i, e++, e > t && (e = 0, o = n, n = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(s) {
      let i = n[s];
      if (i !== void 0)
        return i;
      if ((i = o[s]) !== void 0)
        return r(s, i), i;
    },
    set(s, i) {
      s in n ? n[s] = i : r(s, i);
    }
  };
}, Zl = "!", Bd = ":", f0 = [], Hd = (t, e, n, o, r) => ({
  modifiers: t,
  hasImportantModifier: e,
  baseClassName: n,
  maybePostfixModifierPosition: o,
  isExternal: r
}), p0 = (t) => {
  const {
    prefix: e,
    experimentalParseClassName: n
  } = t;
  let o = (r) => {
    const s = [];
    let i = 0, a = 0, l = 0, c;
    const u = r.length;
    for (let g = 0; g < u; g++) {
      const y = r[g];
      if (i === 0 && a === 0) {
        if (y === Bd) {
          s.push(r.slice(l, g)), l = g + 1;
          continue;
        }
        if (y === "/") {
          c = g;
          continue;
        }
      }
      y === "[" ? i++ : y === "]" ? i-- : y === "(" ? a++ : y === ")" && a--;
    }
    const d = s.length === 0 ? r : r.slice(l);
    let p = d, m = !1;
    d.endsWith(Zl) ? (p = d.slice(0, -1), m = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      d.startsWith(Zl) && (p = d.slice(1), m = !0)
    );
    const h = c && c > l ? c - l : void 0;
    return Hd(s, m, p, h);
  };
  if (e) {
    const r = e + Bd, s = o;
    o = (i) => i.startsWith(r) ? s(i.slice(r.length)) : Hd(f0, !1, i, void 0, !0);
  }
  if (n) {
    const r = o;
    o = (s) => n({
      className: s,
      parseClassName: r
    });
  }
  return o;
}, m0 = (t) => {
  const e = /* @__PURE__ */ new Map();
  return t.orderSensitiveModifiers.forEach((n, o) => {
    e.set(n, 1e6 + o);
  }), (n) => {
    const o = [];
    let r = [];
    for (let s = 0; s < n.length; s++) {
      const i = n[s], a = i[0] === "[", l = e.has(i);
      a || l ? (r.length > 0 && (r.sort(), o.push(...r), r = []), o.push(i)) : r.push(i);
    }
    return r.length > 0 && (r.sort(), o.push(...r)), o;
  };
}, h0 = (t) => ({
  cache: d0(t.cacheSize),
  parseClassName: p0(t),
  sortModifiers: m0(t),
  ...n0(t)
}), g0 = /\s+/, b0 = (t, e) => {
  const {
    parseClassName: n,
    getClassGroupId: o,
    getConflictingClassGroupIds: r,
    sortModifiers: s
  } = e, i = [], a = t.trim().split(g0);
  let l = "";
  for (let c = a.length - 1; c >= 0; c -= 1) {
    const u = a[c], {
      isExternal: d,
      modifiers: p,
      hasImportantModifier: m,
      baseClassName: h,
      maybePostfixModifierPosition: g
    } = n(u);
    if (d) {
      l = u + (l.length > 0 ? " " + l : l);
      continue;
    }
    let y = !!g, v = o(y ? h.substring(0, g) : h);
    if (!v) {
      if (!y) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (v = o(h), !v) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      y = !1;
    }
    const x = p.length === 0 ? "" : p.length === 1 ? p[0] : s(p).join(":"), w = m ? x + Zl : x, E = w + v;
    if (i.indexOf(E) > -1)
      continue;
    i.push(E);
    const S = r(v, y);
    for (let C = 0; C < S.length; ++C) {
      const _ = S[C];
      i.push(w + _);
    }
    l = u + (l.length > 0 ? " " + l : l);
  }
  return l;
}, v0 = (...t) => {
  let e = 0, n, o, r = "";
  for (; e < t.length; )
    (n = t[e++]) && (o = oh(n)) && (r && (r += " "), r += o);
  return r;
}, oh = (t) => {
  if (typeof t == "string")
    return t;
  let e, n = "";
  for (let o = 0; o < t.length; o++)
    t[o] && (e = oh(t[o])) && (n && (n += " "), n += e);
  return n;
}, y0 = (t, ...e) => {
  let n, o, r, s;
  const i = (l) => {
    const c = e.reduce((u, d) => d(u), t());
    return n = h0(c), o = n.cache.get, r = n.cache.set, s = a, a(l);
  }, a = (l) => {
    const c = o(l);
    if (c)
      return c;
    const u = b0(l, n);
    return r(l, u), u;
  };
  return s = i, (...l) => s(v0(...l));
}, x0 = [], _t = (t) => {
  const e = (n) => n[t] || x0;
  return e.isThemeGetter = !0, e;
}, rh = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, sh = /^\((?:(\w[\w-]*):)?(.+)\)$/i, w0 = /^\d+\/\d+$/, S0 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, E0 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, C0 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, _0 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, R0 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Uo = (t) => w0.test(t), qe = (t) => !!t && !Number.isNaN(Number(t)), Jn = (t) => !!t && Number.isInteger(Number(t)), Ka = (t) => t.endsWith("%") && qe(t.slice(0, -1)), jn = (t) => S0.test(t), N0 = () => !0, k0 = (t) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  E0.test(t) && !C0.test(t)
), ih = () => !1, T0 = (t) => _0.test(t), I0 = (t) => R0.test(t), O0 = (t) => !Ie(t) && !Oe(t), M0 = (t) => Er(t, ch, ih), Ie = (t) => rh.test(t), wo = (t) => Er(t, uh, k0), Ya = (t) => Er(t, L0, qe), Ud = (t) => Er(t, ah, ih), P0 = (t) => Er(t, lh, I0), Ds = (t) => Er(t, dh, T0), Oe = (t) => sh.test(t), Lr = (t) => Cr(t, uh), A0 = (t) => Cr(t, $0), Wd = (t) => Cr(t, ah), D0 = (t) => Cr(t, ch), j0 = (t) => Cr(t, lh), js = (t) => Cr(t, dh, !0), Er = (t, e, n) => {
  const o = rh.exec(t);
  return o ? o[1] ? e(o[1]) : n(o[2]) : !1;
}, Cr = (t, e, n = !1) => {
  const o = sh.exec(t);
  return o ? o[1] ? e(o[1]) : n : !1;
}, ah = (t) => t === "position" || t === "percentage", lh = (t) => t === "image" || t === "url", ch = (t) => t === "length" || t === "size" || t === "bg-size", uh = (t) => t === "length", L0 = (t) => t === "number", $0 = (t) => t === "family-name", dh = (t) => t === "shadow", F0 = () => {
  const t = _t("color"), e = _t("font"), n = _t("text"), o = _t("font-weight"), r = _t("tracking"), s = _t("leading"), i = _t("breakpoint"), a = _t("container"), l = _t("spacing"), c = _t("radius"), u = _t("shadow"), d = _t("inset-shadow"), p = _t("text-shadow"), m = _t("drop-shadow"), h = _t("blur"), g = _t("perspective"), y = _t("aspect"), v = _t("ease"), x = _t("animate"), w = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], E = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], S = () => [...E(), Oe, Ie], C = () => ["auto", "hidden", "clip", "visible", "scroll"], _ = () => ["auto", "contain", "none"], R = () => [Oe, Ie, l], O = () => [Uo, "full", "auto", ...R()], j = () => [Jn, "none", "subgrid", Oe, Ie], F = () => ["auto", {
    span: ["full", Jn, Oe, Ie]
  }, Jn, Oe, Ie], N = () => [Jn, "auto", Oe, Ie], T = () => ["auto", "min", "max", "fr", Oe, Ie], L = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], M = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], A = () => ["auto", ...R()], $ = () => [Uo, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...R()], k = () => [t, Oe, Ie], H = () => [...E(), Wd, Ud, {
    position: [Oe, Ie]
  }], B = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], P = () => ["auto", "cover", "contain", D0, M0, {
    size: [Oe, Ie]
  }], V = () => [Ka, Lr, wo], I = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    c,
    Oe,
    Ie
  ], D = () => ["", qe, Lr, wo], z = () => ["solid", "dashed", "dotted", "double"], U = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], G = () => [qe, Ka, Wd, Ud], J = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    h,
    Oe,
    Ie
  ], se = () => ["none", qe, Oe, Ie], Q = () => ["none", qe, Oe, Ie], ce = () => [qe, Oe, Ie], W = () => [Uo, "full", ...R()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [jn],
      breakpoint: [jn],
      color: [N0],
      container: [jn],
      "drop-shadow": [jn],
      ease: ["in", "out", "in-out"],
      font: [O0],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [jn],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [jn],
      shadow: [jn],
      spacing: ["px", qe],
      text: [jn],
      "text-shadow": [jn],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Uo, Ie, Oe, y]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [qe, Ie, Oe, a]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": w()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": w()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: S()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: C()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": C()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": C()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: _()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": _()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": _()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: O()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": O()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": O()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: O()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: O()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: O()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: O()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: O()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: O()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Jn, "auto", Oe, Ie]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Uo, "full", "auto", a, ...R()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [qe, Uo, "auto", "initial", "none", Ie]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", qe, Oe, Ie]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", qe, Oe, Ie]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Jn, "first", "last", "none", Oe, Ie]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": j()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: F()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": N()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": N()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": j()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: F()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": N()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": N()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": T()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": T()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: R()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": R()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": R()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...L(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...M(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...M()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...L()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...M(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...M(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": L()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...M(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...M()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: R()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: R()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: R()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: R()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: R()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: R()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: R()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: R()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: R()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: A()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: A()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: A()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: A()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: A()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: A()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: A()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: A()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: A()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": R()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": R()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: $()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [a, "screen", ...$()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          a,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...$()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          a,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [i]
          },
          ...$()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...$()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...$()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...$()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, Lr, wo]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [o, Oe, Ya]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Ka, Ie]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [A0, Ie, e]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [r, Oe, Ie]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [qe, "none", Oe, Ya]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          s,
          ...R()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Oe, Ie]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", Oe, Ie]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: k()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: k()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...z(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [qe, "from-font", "auto", Oe, wo]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: k()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [qe, "auto", Oe, Ie]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: R()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Oe, Ie]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Oe, Ie]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: H()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: B()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: P()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Jn, Oe, Ie],
          radial: ["", Oe, Ie],
          conic: [Jn, Oe, Ie]
        }, j0, P0]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: k()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: V()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: V()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: V()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: k()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: k()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: k()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: I()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": I()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": I()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": I()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": I()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": I()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": I()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": I()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": I()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": I()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": I()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": I()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": I()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": I()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": I()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: D()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": D()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": D()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": D()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": D()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": D()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": D()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": D()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": D()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": D()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": D()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...z(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...z(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: k()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": k()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": k()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": k()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": k()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": k()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": k()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": k()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": k()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: k()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...z(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [qe, Oe, Ie]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", qe, Lr, wo]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: k()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          u,
          js,
          Ds
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: k()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", d, js, Ds]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": k()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: D()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: k()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [qe, wo]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": k()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": D()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": k()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", p, js, Ds]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": k()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [qe, Oe, Ie]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...U(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": U()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [qe]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": G()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": G()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": k()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": k()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": G()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": G()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": k()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": k()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": G()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": G()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": k()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": k()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": G()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": G()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": k()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": k()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": G()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": G()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": k()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": k()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": G()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": G()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": k()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": k()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": G()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": G()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": k()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": k()
      }],
      "mask-image-radial": [{
        "mask-radial": [Oe, Ie]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": G()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": G()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": k()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": k()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": E()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [qe]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": G()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": G()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": k()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": k()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: H()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: B()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: P()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", Oe, Ie]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          Oe,
          Ie
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: J()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [qe, Oe, Ie]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [qe, Oe, Ie]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          m,
          js,
          Ds
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": k()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", qe, Oe, Ie]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [qe, Oe, Ie]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", qe, Oe, Ie]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [qe, Oe, Ie]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", qe, Oe, Ie]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          Oe,
          Ie
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": J()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [qe, Oe, Ie]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [qe, Oe, Ie]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", qe, Oe, Ie]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [qe, Oe, Ie]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", qe, Oe, Ie]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [qe, Oe, Ie]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [qe, Oe, Ie]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", qe, Oe, Ie]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": R()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": R()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": R()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", Oe, Ie]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [qe, "initial", Oe, Ie]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", v, Oe, Ie]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [qe, Oe, Ie]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", x, Oe, Ie]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [g, Oe, Ie]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": S()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: se()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": se()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": se()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": se()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Q()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Q()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Q()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Q()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: ce()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": ce()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": ce()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [Oe, Ie, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: S()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: W()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": W()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": W()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": W()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: k()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: k()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Oe, Ie]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": R()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": R()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": R()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": R()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": R()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": R()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": R()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": R()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": R()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": R()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": R()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": R()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": R()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": R()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": R()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": R()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": R()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": R()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Oe, Ie]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...k()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [qe, Lr, wo, Ya]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...k()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, V0 = /* @__PURE__ */ y0(F0), ae = (...t) => V0(Qm(t)), ID = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("flex w-full flex-col", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(qp, { "data-slot": "accordion", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, OD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("not-last:border-b", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(em, { "data-slot": "accordion-item", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, MD = (t) => {
  const e = ee.c(12);
  let n, o, r;
  e[0] !== t ? ({
    className: o,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] !== o ? (s = ae("focus-visible:ring-ring-focus/50 focus-visible:border-ring-focus focus-visible:after:border-ring-focus **:data-[slot=accordion-trigger-icon]:text-muted rounded-lg py-2.5 text-left text-sm font-medium hover:underline focus-visible:ring-[3px] **:data-[slot=accordion-trigger-icon]:ml-auto **:data-[slot=accordion-trigger-icon]:size-4 group/accordion-trigger relative flex flex-1 items-start justify-between border border-transparent transition-all outline-none disabled:pointer-events-none disabled:opacity-50", o), e[4] = o, e[5] = s) : s = e[5];
  let i, a;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ b.jsx(Ve, { icon: Vo, "data-slot": "accordion-trigger-icon", className: "pointer-events-none shrink-0 group-aria-expanded/accordion-trigger:hidden" }), a = /* @__PURE__ */ b.jsx(Ve, { icon: ns, "data-slot": "accordion-trigger-icon", className: "pointer-events-none hidden shrink-0 group-aria-expanded/accordion-trigger:inline" }), e[6] = i, e[7] = a) : (i = e[6], a = e[7]);
  let l;
  return e[8] !== n || e[9] !== r || e[10] !== s ? (l = /* @__PURE__ */ b.jsx(tm, { className: "flex", children: /* @__PURE__ */ b.jsxs(jm, { "data-slot": "accordion-trigger", className: s, ...r, children: [
    n,
    i,
    a
  ] }) }), e[8] = n, e[9] = r, e[10] = s, e[11] = l) : l = e[11], l;
}, PD = (t) => {
  const e = ee.c(12);
  let n, o, r;
  e[0] !== t ? ({
    className: o,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] !== o ? (s = ae("pt-0 pb-2.5 [&_a]:hover:text-primary h-(--accordion-panel-height) data-ending-style:h-0 data-starting-style:h-0 [&_a]:underline [&_a]:underline-offset-3 [&_p:not(:last-child)]:mb-4", o), e[4] = o, e[5] = s) : s = e[5];
  let i;
  e[6] !== n || e[7] !== s ? (i = /* @__PURE__ */ b.jsx("div", { className: s, children: n }), e[6] = n, e[7] = s, e[8] = i) : i = e[8];
  let a;
  return e[9] !== r || e[10] !== i ? (a = /* @__PURE__ */ b.jsx($m, { "data-slot": "accordion-content", className: "data-open:animate-accordion-down data-closed:animate-accordion-up text-sm overflow-hidden", ...r, children: i }), e[9] = r, e[10] = i, e[11] = a) : a = e[11], a;
}, Gd = (t) => typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, Kd = Qm, ra = (t, e) => (n) => {
  var o;
  if (e?.variants == null) return Kd(t, n?.class, n?.className);
  const { variants: r, defaultVariants: s } = e, i = Object.keys(r).map((c) => {
    const u = n?.[c], d = s?.[c];
    if (u === null) return null;
    const p = Gd(u) || Gd(d);
    return r[c][p];
  }), a = n && Object.entries(n).reduce((c, u) => {
    let [d, p] = u;
    return p === void 0 || (c[d] = p), c;
  }, {}), l = e == null || (o = e.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((c, u) => {
    let { class: d, className: p, ...m } = u;
    return Object.entries(m).every((h) => {
      let [g, y] = h;
      return Array.isArray(y) ? y.includes({
        ...s,
        ...a
      }[g]) : {
        ...s,
        ...a
      }[g] === y;
    }) ? [
      ...c,
      d,
      p
    ] : c;
  }, []);
  return Kd(t, i, l, n?.class, n?.className);
}, z0 = ra("grid gap-0.5 rounded-lg border px-2.5 py-2 text-left text-sm has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:pr-18 has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-2 *:[svg]:row-span-2 *:[svg]:translate-y-0.5 *:[svg]:text-current *:[svg:not([class*='size-'])]:size-4 w-full relative group/alert", {
  defaultVariants: {
    variant: "default"
  },
  variants: {
    variant: {
      default: "bg-default text-primary",
      destructive: "text-feedback-danger bg-default *:data-[slot=alert-description]:text-feedback-danger/90 *:[svg]:text-current"
    }
  }
}), AD = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    variant: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] !== n || e[5] !== r ? (s = ae(z0({
    variant: r
  }), n), e[4] = n, e[5] = r, e[6] = s) : s = e[6];
  let i;
  return e[7] !== o || e[8] !== s ? (i = /* @__PURE__ */ b.jsx("div", { "data-slot": "alert", role: "alert", className: s, ...o }), e[7] = o, e[8] = s, e[9] = i) : i = e[9], i;
}, DD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("font-medium group-has-[>svg]/alert:col-start-2 [&_a]:hover:text-primary [&_a]:underline [&_a]:underline-offset-3", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "alert-title", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, jD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("text-muted text-sm text-balance md:text-pretty [&_p:not(:last-child)]:mb-4 [&_a]:hover:text-primary [&_a]:underline [&_a]:underline-offset-3", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "alert-description", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, LD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("absolute top-2 right-2", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "alert-action", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
};
function Ct(t) {
  return t?.ownerDocument || document;
}
const $r = 0;
class Un {
  constructor() {
    Re(this, "currentId", $r);
    Re(this, "clear", () => {
      this.currentId !== $r && (clearTimeout(this.currentId), this.currentId = $r);
    });
    Re(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new Un();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(e, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = $r, n();
    }, e);
  }
  isStarted() {
    return this.currentId !== $r;
  }
}
function ft() {
  const t = jt(Un.create).current;
  return xr(t.disposeEffect), t;
}
let Yd = {}, qd = {}, Xd = "";
function B0(t) {
  if (typeof document > "u")
    return !1;
  const e = Ct(t);
  return mt(e).innerWidth - e.documentElement.clientWidth > 0;
}
function H0(t) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u")
    return !1;
  const o = Ct(t).documentElement, r = {
    scrollbarGutter: o.style.scrollbarGutter,
    overflowY: o.style.overflowY
  };
  o.style.scrollbarGutter = "stable", o.style.overflowY = "scroll";
  const s = o.offsetWidth;
  o.style.overflowY = "hidden";
  const i = o.offsetWidth;
  return Object.assign(o.style, r), s === i;
}
function U0(t) {
  const e = Ct(t), n = e.documentElement, o = e.body, r = Fo(n) ? n : o, s = r.style.overflow;
  return r.style.overflow = "hidden", () => {
    r.style.overflow = s;
  };
}
function W0(t) {
  const e = Ct(t), n = e.documentElement, o = e.body, r = mt(n);
  let s = 0, i = 0, a = !1;
  const l = dt.create();
  if (sm && (r.visualViewport?.scale ?? 1) !== 1)
    return () => {
    };
  function c() {
    const p = r.getComputedStyle(n), m = r.getComputedStyle(o), y = (p.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    s = n.scrollTop, i = n.scrollLeft, Yd = {
      scrollbarGutter: n.style.scrollbarGutter,
      overflowY: n.style.overflowY,
      overflowX: n.style.overflowX
    }, Xd = n.style.scrollBehavior, qd = {
      position: o.style.position,
      height: o.style.height,
      width: o.style.width,
      boxSizing: o.style.boxSizing,
      overflowY: o.style.overflowY,
      overflowX: o.style.overflowX,
      scrollBehavior: o.style.scrollBehavior
    };
    const v = n.scrollHeight > n.clientHeight, x = n.scrollWidth > n.clientWidth, w = p.overflowY === "scroll" || m.overflowY === "scroll", E = p.overflowX === "scroll" || m.overflowX === "scroll", S = Math.max(0, r.innerWidth - o.clientWidth), C = Math.max(0, r.innerHeight - o.clientHeight), _ = parseFloat(m.marginTop) + parseFloat(m.marginBottom), R = parseFloat(m.marginLeft) + parseFloat(m.marginRight), O = Fo(n) ? n : o;
    if (a = H0(t), a) {
      n.style.scrollbarGutter = y, O.style.overflowY = "hidden", O.style.overflowX = "hidden";
      return;
    }
    Object.assign(n.style, {
      scrollbarGutter: y,
      overflowY: "hidden",
      overflowX: "hidden"
    }), (v || w) && (n.style.overflowY = "scroll"), (x || E) && (n.style.overflowX = "scroll"), Object.assign(o.style, {
      position: "relative",
      height: _ || C ? `calc(100dvh - ${_ + C}px)` : "100dvh",
      width: R || S ? `calc(100vw - ${R + S}px)` : "100vw",
      boxSizing: "border-box",
      overflow: "hidden",
      scrollBehavior: "unset"
    }), o.scrollTop = s, o.scrollLeft = i, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
  }
  function u() {
    Object.assign(n.style, Yd), Object.assign(o.style, qd), a || (n.scrollTop = s, n.scrollLeft = i, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = Xd);
  }
  function d() {
    u(), l.request(c);
  }
  return c(), r.addEventListener("resize", d), () => {
    l.cancel(), u(), typeof r.removeEventListener == "function" && r.removeEventListener("resize", d);
  };
}
class G0 {
  constructor() {
    Re(this, "lockCount", 0);
    Re(this, "restore", null);
    Re(this, "timeoutLock", Un.create());
    Re(this, "timeoutUnlock", Un.create());
    Re(this, "release", () => {
      this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
    });
    Re(this, "unlock", () => {
      this.lockCount === 0 && this.restore && (this.restore?.(), this.restore = null);
    });
  }
  acquire(e) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(e)), this.release;
  }
  lock(e) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const o = Ct(e).documentElement, r = mt(o).getComputedStyle(o).overflowY;
    if (r === "hidden" || r === "clip") {
      this.restore = xt;
      return;
    }
    const s = im || !B0(e);
    this.restore = s ? U0(e) : W0(e);
  }
}
const K0 = new G0();
function sa(t = !0, e = null) {
  he(() => {
    if (t)
      return K0.acquire(e);
  }, [t, e]);
}
function yt(t) {
  const e = jt(Y0, t).current;
  return e.next = t, he(e.effect), e;
}
function Y0(t) {
  const e = {
    current: t,
    next: t,
    effect: () => {
      e.current = e.next;
    }
  };
  return e;
}
function fh() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      t.get(e)?.forEach((o) => o(n));
    },
    on(e, n) {
      t.has(e) || t.set(e, /* @__PURE__ */ new Set()), t.get(e).add(n);
    },
    off(e, n) {
      t.get(e)?.delete(n);
    }
  };
}
class Bc {
  constructor() {
    Re(this, "nodesRef", {
      current: []
    });
    Re(this, "events", fh());
  }
  addNode(e) {
    this.nodesRef.current.push(e);
  }
  removeNode(e) {
    const n = this.nodesRef.current.findIndex((o) => o === e);
    n !== -1 && this.nodesRef.current.splice(n, 1);
  }
}
const Hc = /* @__PURE__ */ f.createContext(null);
process.env.NODE_ENV !== "production" && (Hc.displayName = "FloatingNodeContext");
const Uc = /* @__PURE__ */ f.createContext(null);
process.env.NODE_ENV !== "production" && (Uc.displayName = "FloatingTreeContext");
const Pn = () => f.useContext(Hc)?.id || null, vo = (t) => {
  const e = f.useContext(Uc);
  return t ?? e;
};
function Wc(t) {
  const e = Lo(), n = vo(t), o = Pn();
  return he(() => {
    if (!e)
      return;
    const r = {
      id: e,
      parentId: o
    };
    return n?.addNode(r), () => {
      n?.removeNode(r);
    };
  }, [n, e, o]), e;
}
function ph(t) {
  const {
    children: e,
    id: n
  } = t, o = Pn();
  return /* @__PURE__ */ b.jsx(Hc.Provider, {
    value: f.useMemo(() => ({
      id: n,
      parentId: o
    }), [n, o]),
    children: e
  });
}
function mh(t) {
  const {
    children: e,
    externalTree: n
  } = t, o = jt(() => n ?? new Bc()).current;
  return /* @__PURE__ */ b.jsx(Uc.Provider, {
    value: o,
    children: e
  });
}
function gr(t) {
  return `data-base-ui-${t}`;
}
function pi(t, e, n) {
  if (n && !Oo(n))
    return 0;
  if (typeof t == "number")
    return t;
  if (typeof t == "function") {
    const o = t();
    return typeof o == "number" ? o : o?.[e];
  }
  return t?.[e];
}
const Gc = /* @__PURE__ */ f.createContext({
  hasProvider: !1,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeout: new Un(),
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (Gc.displayName = "FloatingDelayGroupContext");
function q0(t) {
  const {
    children: e,
    delay: n,
    timeoutMs: o = 0
  } = t, r = f.useRef(n), s = f.useRef(n), i = f.useRef(null), a = f.useRef(null), l = ft();
  return /* @__PURE__ */ b.jsx(Gc.Provider, {
    value: f.useMemo(() => ({
      hasProvider: !0,
      delayRef: r,
      initialDelayRef: s,
      currentIdRef: i,
      timeoutMs: o,
      currentContextRef: a,
      timeout: l
    }), [o, l]),
    children: e
  });
}
function X0(t, e = {
  open: !1
}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("floatingId"), {
    enabled: r = !0,
    open: s
  } = e, i = f.useContext(Gc), {
    currentIdRef: a,
    delayRef: l,
    timeoutMs: c,
    initialDelayRef: u,
    currentContextRef: d,
    hasProvider: p,
    timeout: m
  } = i, [h, g] = f.useState(!1);
  return he(() => {
    function y() {
      g(!1), d.current?.setIsInstantPhase(!1), a.current = null, d.current = null, l.current = u.current;
    }
    if (r && a.current && !s && a.current === o) {
      if (g(!1), c) {
        const v = o;
        return m.start(c, () => {
          n.select("open") || a.current && a.current !== v || y();
        }), () => {
          m.clear();
        };
      }
      y();
    }
  }, [r, s, o, a, l, c, u, d, m, n]), he(() => {
    if (!r || !s)
      return;
    const y = d.current, v = a.current;
    m.clear(), d.current = {
      onOpenChange: n.setOpen,
      setIsInstantPhase: g
    }, a.current = o, l.current = {
      open: 0,
      close: pi(u.current, "close")
    }, v !== null && v !== o ? (g(!0), y?.setIsInstantPhase(!0), y?.onOpenChange(!1, ke(Ut))) : (g(!1), y?.setIsInstantPhase(!1));
  }, [r, s, o, n, a, l, c, u, d, m]), he(() => () => {
    d.current = null;
  }, [d]), f.useMemo(() => ({
    hasProvider: p,
    delayRef: l,
    isInstantPhase: h
  }), [p, l, h]);
}
const hh = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
}, Wn = {
  ...hh,
  position: "fixed",
  top: 0,
  left: 0
}, ms = {
  ...hh,
  position: "absolute"
}, Gn = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const [o, r] = f.useState();
  he(() => {
    am && r("button");
  }, []);
  const s = {
    tabIndex: 0,
    // Role is only for VoiceOver
    role: o
  };
  return /* @__PURE__ */ b.jsx("span", {
    ...e,
    ref: n,
    style: Wn,
    "aria-hidden": o ? void 0 : !0,
    ...s,
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (Gn.displayName = "FocusGuard");
let Zd = 0;
function mi(t, e = {}) {
  const {
    preventScroll: n = !1,
    cancelPrevious: o = !0,
    sync: r = !1
  } = e;
  o && cancelAnimationFrame(Zd);
  const s = () => t?.focus({
    preventScroll: n
  });
  r ? s() : Zd = requestAnimationFrame(s);
}
const ar = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function Jd(t) {
  return t === "inert" ? ar.inert : t === "aria-hidden" ? ar["aria-hidden"] : ar.none;
}
let Ls = /* @__PURE__ */ new WeakSet(), $s = {}, qa = 0;
const gh = (t) => t && (t.host || gh(t.parentNode)), Z0 = (t, e) => e.map((n) => {
  if (t.contains(n))
    return n;
  const o = gh(n);
  return t.contains(o) ? o : null;
}).filter((n) => n != null);
function J0(t, e, n, o) {
  const r = "data-base-ui-inert", s = o ? "inert" : n ? "aria-hidden" : null, i = Z0(e, t), a = /* @__PURE__ */ new Set(), l = new Set(i), c = [];
  $s[r] || ($s[r] = /* @__PURE__ */ new WeakMap());
  const u = $s[r];
  i.forEach(d), p(e), a.clear();
  function d(m) {
    !m || a.has(m) || (a.add(m), m.parentNode && d(m.parentNode));
  }
  function p(m) {
    !m || l.has(m) || [].forEach.call(m.children, (h) => {
      if (mo(h) !== "script")
        if (a.has(h))
          p(h);
        else {
          const g = s ? h.getAttribute(s) : null, y = g !== null && g !== "false", v = Jd(s), x = (v.get(h) || 0) + 1, w = (u.get(h) || 0) + 1;
          v.set(h, x), u.set(h, w), c.push(h), x === 1 && y && Ls.add(h), w === 1 && h.setAttribute(r, ""), !y && s && h.setAttribute(s, s === "inert" ? "" : "true");
        }
    });
  }
  return qa += 1, () => {
    c.forEach((m) => {
      const h = Jd(s), y = (h.get(m) || 0) - 1, v = (u.get(m) || 0) - 1;
      h.set(m, y), u.set(m, v), y || (!Ls.has(m) && s && m.removeAttribute(s), Ls.delete(m)), v || m.removeAttribute(r);
    }), qa -= 1, qa || (ar.inert = /* @__PURE__ */ new WeakMap(), ar["aria-hidden"] = /* @__PURE__ */ new WeakMap(), ar.none = /* @__PURE__ */ new WeakMap(), Ls = /* @__PURE__ */ new WeakSet(), $s = {});
  };
}
function Q0(t, e = !1, n = !1) {
  const o = vt(t[0]).body;
  return J0(t.concat(Array.from(o.querySelectorAll("[aria-live]"))), o, e, n);
}
const Kc = /* @__PURE__ */ f.createContext(null);
process.env.NODE_ENV !== "production" && (Kc.displayName = "PortalContext");
const bh = () => f.useContext(Kc), ew = gr("portal");
function vh(t = {}) {
  const {
    ref: e,
    container: n,
    componentProps: o = at,
    elementProps: r,
    elementState: s
  } = t, i = Lo(), l = bh()?.portalNode, [c, u] = f.useState(null), [d, p] = f.useState(null), m = fe((v) => {
    v !== null && p(v);
  }), h = f.useRef(null);
  he(() => {
    if (n === null) {
      h.current && (h.current = null, p(null), u(null));
      return;
    }
    if (i == null)
      return;
    const v = (n && (kc(n) ? n : n.current)) ?? l ?? document.body;
    if (v == null) {
      h.current && (h.current = null, p(null), u(null));
      return;
    }
    h.current !== v && (h.current = v, p(null), u(v));
  }, [n, l, i]);
  const g = _e("div", o, {
    ref: [e, m],
    state: s,
    props: [{
      id: i,
      [ew]: ""
    }, r]
  });
  return {
    portalNode: d,
    portalSubtree: c && g ? /* @__PURE__ */ Vt.createPortal(g, c) : null
  };
}
const hs = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: s,
    render: i,
    renderGuards: a,
    ...l
  } = e, {
    portalNode: c,
    portalSubtree: u
  } = vh({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: l
  }), d = f.useRef(null), p = f.useRef(null), m = f.useRef(null), h = f.useRef(null), [g, y] = f.useState(null), v = g?.modal, x = g?.open, w = typeof a == "boolean" ? a : !!g && !g.modal && g.open && !!c;
  f.useEffect(() => {
    if (!c || v)
      return;
    function S(C) {
      c && C.relatedTarget && To(C) && (C.type === "focusin" ? _d : $1)(c);
    }
    return c.addEventListener("focusin", S, !0), c.addEventListener("focusout", S, !0), () => {
      c.removeEventListener("focusin", S, !0), c.removeEventListener("focusout", S, !0);
    };
  }, [c, v]), f.useEffect(() => {
    !c || x || _d(c);
  }, [x, c]);
  const E = f.useMemo(() => ({
    beforeOutsideRef: d,
    afterOutsideRef: p,
    beforeInsideRef: m,
    afterInsideRef: h,
    portalNode: c,
    setFocusManagerState: y
  }), [c]);
  return /* @__PURE__ */ b.jsxs(f.Fragment, {
    children: [u, /* @__PURE__ */ b.jsxs(Kc.Provider, {
      value: E,
      children: [w && c && /* @__PURE__ */ b.jsx(Gn, {
        "data-type": "outside",
        ref: d,
        onFocus: (S) => {
          if (To(S, c))
            m.current?.focus();
          else {
            const C = g ? g.domReference : null;
            km(C)?.focus();
          }
        }
      }), w && c && /* @__PURE__ */ b.jsx("span", {
        "aria-owns": c.id,
        style: ky
      }), c && /* @__PURE__ */ Vt.createPortal(o, c), w && c && /* @__PURE__ */ b.jsx(Gn, {
        "data-type": "outside",
        ref: p,
        onFocus: (S) => {
          if (To(S, c))
            h.current?.focus();
          else {
            const C = g ? g.domReference : null;
            na(C)?.focus(), g?.closeOnFocusOut && g?.onOpenChange(!1, ke(In, S.nativeEvent));
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (hs.displayName = "FloatingPortal");
function tw(t, e) {
  const n = mt(t.target);
  return t instanceof n.KeyboardEvent ? "keyboard" : t instanceof n.FocusEvent ? e || "keyboard" : "pointerType" in t ? t.pointerType || "keyboard" : "touches" in t ? "touch" : t instanceof n.MouseEvent ? e || (t.detail === 0 ? "keyboard" : "mouse") : "";
}
const Qd = 20;
let oo = [];
function Yc() {
  oo = oo.filter((t) => t.isConnected);
}
function nw(t) {
  Yc(), t && mo(t) !== "body" && (oo.push(t), oo.length > Qd && (oo = oo.slice(-Qd)));
}
function Xa() {
  return Yc(), oo[oo.length - 1];
}
function ow(t) {
  if (!t)
    return null;
  const e = Sr();
  return Rm(t, e) ? t : fs(t, e)[0] || t;
}
function rw(t) {
  return !t || !t.isConnected ? !1 : typeof t.checkVisibility == "function" ? t.checkVisibility() : en(t).display !== "none";
}
function ef(t, e) {
  if (!e.current.includes("floating") && !t.getAttribute("role")?.includes("dialog"))
    return;
  const n = Sr(), r = L1(t, n).filter((i) => {
    const a = i.getAttribute("data-tabindex") || "";
    return Rm(i, n) || i.hasAttribute("data-tabindex") && !a.startsWith("-");
  }), s = t.getAttribute("tabindex");
  e.current.includes("floating") || r.length === 0 ? s !== "0" && t.setAttribute("tabindex", "0") : (s !== "-1" || t.hasAttribute("data-tabindex") && t.getAttribute("data-tabindex") !== "-1") && (t.setAttribute("tabindex", "-1"), t.setAttribute("data-tabindex", "-1"));
}
function ia(t) {
  const {
    context: e,
    children: n,
    disabled: o = !1,
    order: r = ["content"],
    initialFocus: s = !0,
    returnFocus: i = !0,
    restoreFocus: a = !1,
    modal: l = !0,
    closeOnFocusOut: c = !0,
    openInteractionType: u = "",
    getInsideElements: d = () => [],
    nextFocusableElement: p,
    previousFocusableElement: m,
    beforeContentFocusGuardRef: h,
    externalTree: g
  } = t, y = "rootStore" in e ? e.rootStore : e, v = y.useState("open"), x = y.useState("domReferenceElement"), w = y.useState("floatingElement"), {
    events: E,
    dataRef: S
  } = y.context, C = fe(() => S.current.floatingContext?.nodeId), _ = fe(d), R = s === !1, O = zl(x) && R, j = yt(r), F = yt(s), N = yt(i), T = yt(u), L = vo(g), M = bh(), A = f.useRef(null), $ = f.useRef(null), k = f.useRef(!1), H = f.useRef(!1), B = f.useRef(!1), P = f.useRef(-1), V = f.useRef(""), I = f.useRef(""), D = f.useRef(null), z = f.useRef(null), U = zt(D, h, M?.beforeInsideRef), G = zt(z, M?.afterInsideRef), J = ft(), se = ft(), Q = $o(), ce = M != null, W = ts(w), oe = fe((K = W) => K ? fs(K, Sr()) : []), Y = fe((K) => {
    const X = oe(K);
    return j.current.map(() => X).filter(Boolean).flat();
  });
  f.useEffect(() => {
    if (o || !l)
      return;
    function K(ne) {
      ne.key === "Tab" && Ue(W, Jt(vt(W))) && oe().length === 0 && !O && At(ne);
    }
    const X = vt(W);
    return X.addEventListener("keydown", K), () => {
      X.removeEventListener("keydown", K);
    };
  }, [o, x, W, l, j, O, oe, Y]), f.useEffect(() => {
    if (o || !w)
      return;
    function K(X) {
      const ne = $t(X), ie = oe().indexOf(ne);
      ie !== -1 && (P.current = ie);
    }
    return w.addEventListener("focusin", K), () => {
      w.removeEventListener("focusin", K);
    };
  }, [o, w, oe]), f.useEffect(() => {
    if (o || !v)
      return;
    const K = vt(W);
    function X() {
      B.current = !1;
    }
    function ne(ie) {
      const de = $t(ie), le = Ue(w, de) || Ue(x, de) || Ue(M?.portalNode, de);
      B.current = !le, I.current = ie.pointerType || "keyboard";
    }
    function re() {
      I.current = "keyboard";
    }
    return K.addEventListener("pointerdown", ne, !0), K.addEventListener("pointerup", X, !0), K.addEventListener("pointercancel", X, !0), K.addEventListener("keydown", re, !0), () => {
      K.removeEventListener("pointerdown", ne, !0), K.removeEventListener("pointerup", X, !0), K.removeEventListener("pointercancel", X, !0), K.removeEventListener("keydown", re, !0);
    };
  }, [o, w, x, W, v, M]), f.useEffect(() => {
    if (o || !c)
      return;
    function K() {
      H.current = !0, se.start(0, () => {
        H.current = !1;
      });
    }
    function X(de) {
      const le = de.relatedTarget, te = de.currentTarget, pe = $t(de);
      queueMicrotask(() => {
        const ue = C(), ye = y.context.triggerElements, ge = le?.hasAttribute(gr("focus-guard")) && [D.current, z.current, M?.beforeInsideRef.current, M?.afterInsideRef.current, M?.beforeOutsideRef.current, M?.afterOutsideRef.current, Ln(m), Ln(p)].includes(le), Te = !(Ue(x, le) || Ue(w, le) || Ue(le, w) || Ue(M?.portalNode, le) || le != null && ye.hasElement(le) || ye.hasMatchingElement((Se) => Ue(Se, le)) || ge || L && (ko(L.nodesRef.current, ue).find((Se) => Ue(Se.context?.elements.floating, le) || Ue(Se.context?.elements.domReference, le)) || wd(L.nodesRef.current, ue).find((Se) => [Se.context?.elements.floating, ts(Se.context?.elements.floating)].includes(le) || Se.context?.elements.domReference === le)));
        if (te === x && W && ef(W, j), a && te !== x && !rw(pe) && Jt(vt(W)) === vt(W).body) {
          if (ut(W) && (W.focus(), a === "popup")) {
            Q.request(() => {
              W.focus();
            });
            return;
          }
          const Se = P.current, xe = oe(), je = xe[Se] || xe[xe.length - 1] || W;
          ut(je) && je.focus();
        }
        if (S.current.insideReactTree) {
          S.current.insideReactTree = !1;
          return;
        }
        (O || !l) && le && Te && !H.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (O || le !== Xa()) && (k.current = !0, y.setOpen(!1, ke(In, de)));
      });
    }
    function ne() {
      B.current || (S.current.insideReactTree = !0, J.start(0, () => {
        S.current.insideReactTree = !1;
      }));
    }
    const re = ut(x) ? x : null, ie = [];
    if (!(!w && !re))
      return re && (re.addEventListener("focusout", X), re.addEventListener("pointerdown", K), ie.push(() => {
        re.removeEventListener("focusout", X), re.removeEventListener("pointerdown", K);
      })), w && (w.addEventListener("focusout", X), M && (w.addEventListener("focusout", ne, !0), ie.push(() => {
        w.removeEventListener("focusout", ne, !0);
      })), ie.push(() => {
        w.removeEventListener("focusout", X);
      })), () => {
        ie.forEach((de) => {
          de();
        });
      };
  }, [o, x, w, W, l, L, M, y, c, a, oe, O, C, j, S, J, se, Q, p, m]), f.useEffect(() => {
    if (o || !w || !v)
      return;
    const K = Array.from(M?.portalNode?.querySelectorAll(`[${gr("portal")}]`) || []), ne = (L ? wd(L.nodesRef.current, C()) : []).find((de) => zl(de.context?.elements.domReference || null))?.context?.elements.domReference, re = [w, ne, ...K, ..._(), A.current, $.current, D.current, z.current, M?.beforeOutsideRef.current, M?.afterOutsideRef.current, Ln(m), Ln(p), O ? x : null].filter((de) => de != null), ie = Q0(re, l || O);
    return () => {
      ie();
    };
  }, [v, o, x, w, l, j, M, O, L, C, _, p, m]), he(() => {
    if (!v || o || !ut(W))
      return;
    const K = vt(W), X = Jt(K);
    queueMicrotask(() => {
      const ne = Y(W), re = F.current, ie = typeof re == "function" ? re(T.current || "") : re;
      if (ie === void 0 || ie === !1)
        return;
      let de;
      ie === !0 || ie === null ? de = ne[0] || W : de = Ln(ie), de = de || ne[0] || W, !Ue(W, X) && mi(de, {
        preventScroll: de === W
      });
    });
  }, [o, v, W, R, Y, F, T]), he(() => {
    if (o || !W)
      return;
    const K = vt(W), X = Jt(K);
    nw(X);
    function ne(de) {
      if (de.open || (V.current = tw(de.nativeEvent, I.current)), de.reason === Et && de.nativeEvent.type === "mouseleave" && (k.current = !0), de.reason === Yi)
        if (de.nested)
          k.current = !1;
        else if (fm(de.nativeEvent) || pm(de.nativeEvent))
          k.current = !1;
        else {
          let le = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return le = !0, !1;
            }
          }), le ? k.current = !1 : k.current = !0;
        }
    }
    E.on("openchange", ne);
    const re = K.createElement("span");
    re.setAttribute("tabindex", "-1"), re.setAttribute("aria-hidden", "true"), Object.assign(re.style, Wn), ce && x && x.insertAdjacentElement("afterend", re);
    function ie() {
      const de = N.current;
      let le = typeof de == "function" ? de(V.current) : de;
      if (le === void 0 || le === !1)
        return null;
      if (le === null && (le = !0), typeof le == "boolean") {
        const pe = x || Xa();
        return pe && pe.isConnected ? pe : re;
      }
      const te = x || Xa() || re;
      return Ln(le) || te;
    }
    return () => {
      E.off("openchange", ne);
      const de = Jt(K), le = Ue(w, de) || L && ko(L.nodesRef.current, C(), !1).some((pe) => Ue(pe.context?.elements.floating, de)), te = ie();
      queueMicrotask(() => {
        const pe = ow(te), ue = typeof N.current != "boolean";
        // eslint-disable-next-line react-hooks/exhaustive-deps
        N.current && !k.current && ut(pe) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(!ue && pe !== de && de !== K.body) || le) && pe.focus({
          preventScroll: !0
        }), re.remove();
      });
    };
  }, [o, w, W, N, S, E, L, ce, x, C]), f.useEffect(() => {
    queueMicrotask(() => {
      k.current = !1;
    });
  }, [o]), f.useEffect(() => {
    if (o || !v)
      return;
    function K(ne) {
      $t(ne)?.closest(`[${Sc}]`) && (H.current = !0);
    }
    const X = vt(W);
    return X.addEventListener("pointerdown", K, !0), () => {
      X.removeEventListener("pointerdown", K, !0);
    };
  }, [o, v, W]), he(() => {
    if (!o && M)
      return M.setFocusManagerState({
        modal: l,
        closeOnFocusOut: c,
        open: v,
        onOpenChange: y.setOpen,
        domReference: x
      }), () => {
        M.setFocusManagerState(null);
      };
  }, [o, M, l, v, y, c, x]), he(() => {
    if (!(o || !W))
      return ef(W, j), () => {
        queueMicrotask(Yc);
      };
  }, [o, W, j]);
  const Z = !o && (l ? !O : !0) && (ce || l);
  return /* @__PURE__ */ b.jsxs(f.Fragment, {
    children: [Z && /* @__PURE__ */ b.jsx(Gn, {
      "data-type": "inside",
      ref: U,
      onFocus: (K) => {
        if (l) {
          const X = Y();
          mi(X[X.length - 1]);
        } else M?.portalNode && (k.current = !1, To(K, M.portalNode) ? na(x)?.focus() : Ln(m ?? M.beforeOutsideRef)?.focus());
      }
    }), n, Z && /* @__PURE__ */ b.jsx(Gn, {
      "data-type": "inside",
      ref: G,
      onFocus: (K) => {
        l ? mi(Y()[0]) : M?.portalNode && (c && (k.current = !0), To(K, M.portalNode) ? km(x)?.focus() : Ln(p ?? M.afterOutsideRef)?.focus());
      }
    })]
  });
}
function gs(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, {
    enabled: r = !0,
    event: s = "click",
    toggle: i = !0,
    ignoreMouse: a = !1,
    stickIfOpen: l = !0,
    touchOpenDelay: c = 0
  } = e, u = f.useRef(void 0), d = $o(), p = ft(), m = f.useMemo(() => ({
    onPointerDown(h) {
      u.current = h.pointerType;
    },
    onMouseDown(h) {
      const g = u.current, y = h.nativeEvent, v = n.select("open");
      if (h.button !== 0 || s === "click" || Oo(g, !0) && a)
        return;
      const x = o.current.openEvent, w = x?.type, E = n.select("domReferenceElement") !== h.currentTarget, S = v && E || !(v && i && (!(x && l) || w === "click" || w === "mousedown"));
      if (Pc(y.target)) {
        const _ = ke(ln, y, y.target);
        S && g === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, _);
        }) : n.setOpen(S, _);
        return;
      }
      const C = h.currentTarget;
      d.request(() => {
        const _ = ke(ln, y, C);
        S && g === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, _);
        }) : n.setOpen(S, _);
      });
    },
    onClick(h) {
      if (s === "mousedown-only")
        return;
      const g = u.current;
      if (s === "mousedown" && g) {
        u.current = void 0;
        return;
      }
      if (Oo(g, !0) && a)
        return;
      const y = n.select("open"), v = o.current.openEvent, x = n.select("domReferenceElement") !== h.currentTarget, w = y && x || !(y && i && (!(v && l) || mm(v))), E = ke(ln, h.nativeEvent, h.currentTarget);
      w && g === "touch" && c > 0 ? p.start(c, () => {
        n.setOpen(!0, E);
      }) : n.setOpen(w, E);
    },
    onKeyDown() {
      u.current = void 0;
    }
  }), [o, s, a, n, l, i, d, p, c]);
  return f.useMemo(() => r ? {
    reference: m
  } : at, [r, m]);
}
function sw(t, e) {
  let n = null, o = null, r = !1;
  return {
    contextElement: t || void 0,
    getBoundingClientRect() {
      const s = t?.getBoundingClientRect() || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, i = e.axis === "x" || e.axis === "both", a = e.axis === "y" || e.axis === "both", l = ["mouseenter", "mousemove"].includes(e.dataRef.current.openEvent?.type || "") && e.pointerType !== "touch";
      let c = s.width, u = s.height, d = s.x, p = s.y;
      return n == null && e.x && i && (n = s.x - e.x), o == null && e.y && a && (o = s.y - e.y), d -= n || 0, p -= o || 0, c = 0, u = 0, !r || l ? (c = e.axis === "y" ? s.width : 0, u = e.axis === "x" ? s.height : 0, d = i && e.x != null ? e.x : d, p = a && e.y != null ? e.y : p) : r && !l && (u = e.axis === "x" ? s.height : u, c = e.axis === "y" ? s.width : c), r = !0, {
        width: c,
        height: u,
        x: d,
        y: p,
        top: p,
        right: d + c,
        bottom: p + u,
        left: d
      };
    }
  };
}
function tf(t) {
  return t != null && t.clientX != null;
}
function iw(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), s = n.useState("domReferenceElement"), i = n.context.dataRef, {
    enabled: a = !0,
    axis: l = "both",
    x: c = null,
    y: u = null
  } = e, d = f.useRef(!1), p = f.useRef(null), [m, h] = f.useState(), [g, y] = f.useState([]), v = fe((C, _, R) => {
    d.current || i.current.openEvent && !tf(i.current.openEvent) || n.set("positionReference", sw(R ?? s, {
      x: C,
      y: _,
      axis: l,
      dataRef: i,
      pointerType: m
    }));
  }), x = fe((C) => {
    c != null || u != null || (o ? p.current || y([]) : v(C.clientX, C.clientY, C.currentTarget));
  }), w = Oo(m) ? r : o, E = f.useCallback(() => {
    if (!w || !a || c != null || u != null)
      return;
    const C = mt(r);
    function _(R) {
      const O = $t(R);
      Ue(r, O) ? (C.removeEventListener("mousemove", _), p.current = null) : v(R.clientX, R.clientY);
    }
    if (!i.current.openEvent || tf(i.current.openEvent)) {
      C.addEventListener("mousemove", _);
      const R = () => {
        C.removeEventListener("mousemove", _), p.current = null;
      };
      return p.current = R, R;
    }
    n.set("positionReference", s);
  }, [w, a, c, u, r, i, s, n, v]);
  f.useEffect(() => E(), [E, g]), f.useEffect(() => {
    a && !r && (d.current = !1);
  }, [a, r]), f.useEffect(() => {
    !a && o && (d.current = !0);
  }, [a, o]), he(() => {
    a && (c != null || u != null) && (d.current = !1, v(c, u));
  }, [a, c, u, v]);
  const S = f.useMemo(() => {
    function C(_) {
      h(_.pointerType);
    }
    return {
      onPointerDown: C,
      onPointerEnter: C,
      onMouseMove: x,
      onMouseEnter: x
    };
  }, [x]);
  return f.useMemo(() => a ? {
    reference: S,
    trigger: S
  } : {}, [a, S]);
}
function nf(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const s = sn(e), i = jc(e), a = Dc(i), l = qt(e), c = s === "y", u = o.x + o.width / 2 - r.width / 2, d = o.y + o.height / 2 - r.height / 2, p = o[a] / 2 - r[a] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      m = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      m = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      m = {
        x: o.x - r.width,
        y: d
      };
      break;
    default:
      m = {
        x: o.x,
        y: o.y
      };
  }
  switch (ho(e)) {
    case "start":
      m[i] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      m[i] += p * (n && c ? -1 : 1);
      break;
  }
  return m;
}
const aw = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: i
  } = n, a = s.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(e));
  let c = await i.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: u,
    y: d
  } = nf(c, o, l), p = o, m = {}, h = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: y,
      fn: v
    } = a[g], {
      x,
      y: w,
      data: E,
      reset: S
    } = await v({
      x: u,
      y: d,
      initialPlacement: o,
      placement: p,
      strategy: r,
      middlewareData: m,
      rects: c,
      platform: i,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = x ?? u, d = w ?? d, m = {
      ...m,
      [y]: {
        ...m[y],
        ...E
      }
    }, S && h <= 50 && (h++, typeof S == "object" && (S.placement && (p = S.placement), S.rects && (c = S.rects === !0 ? await i.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : S.rects), {
      x: u,
      y: d
    } = nf(c, p, l)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: p,
    strategy: r,
    middlewareData: m
  };
};
async function rs(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: s,
    rects: i,
    elements: a,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: m = 0
  } = Bn(e, t), h = hm(m), y = a[p ? d === "floating" ? "reference" : "floating" : d], v = Ei(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(y))) == null || n ? y : y.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), x = d === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, w = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), E = await (s.isElement == null ? void 0 : s.isElement(w)) ? await (s.getScale == null ? void 0 : s.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Ei(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: w,
    strategy: l
  }) : x);
  return {
    top: (v.top - S.top + h.top) / E.y,
    bottom: (S.bottom - v.bottom + h.bottom) / E.y,
    left: (v.left - S.left + h.left) / E.x,
    right: (S.right - v.right + h.right) / E.x
  };
}
const lw = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: s,
        rects: i,
        initialPlacement: a,
        platform: l,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...y
      } = Bn(t, e);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const v = qt(r), x = sn(a), w = qt(a) === a, E = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = p || (w || !g ? [Si(a)] : b1(a)), C = h !== "none";
      !p && C && S.push(...w1(a, g, h, E));
      const _ = [a, ...S], R = await rs(e, y), O = [];
      let j = ((o = s.flip) == null ? void 0 : o.overflows) || [];
      if (u && O.push(R[v]), d) {
        const L = g1(r, i, E);
        O.push(R[L[0]], R[L[1]]);
      }
      if (j = [...j, {
        placement: r,
        overflows: O
      }], !O.every((L) => L <= 0)) {
        var F, N;
        const L = (((F = s.flip) == null ? void 0 : F.index) || 0) + 1, M = _[L];
        if (M && (!(d === "alignment" ? x !== sn(M) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        j.every((k) => sn(k.placement) === x ? k.overflows[0] > 0 : !0)))
          return {
            data: {
              index: L,
              overflows: j
            },
            reset: {
              placement: M
            }
          };
        let A = (N = j.filter(($) => $.overflows[0] <= 0).sort(($, k) => $.overflows[1] - k.overflows[1])[0]) == null ? void 0 : N.placement;
        if (!A)
          switch (m) {
            case "bestFit": {
              var T;
              const $ = (T = j.filter((k) => {
                if (C) {
                  const H = sn(k.placement);
                  return H === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  H === "y";
                }
                return !0;
              }).map((k) => [k.placement, k.overflows.filter((H) => H > 0).reduce((H, B) => H + B, 0)]).sort((k, H) => k[1] - H[1])[0]) == null ? void 0 : T[0];
              $ && (A = $);
              break;
            }
            case "initialPlacement":
              A = a;
              break;
          }
        if (r !== A)
          return {
            reset: {
              placement: A
            }
          };
      }
      return {};
    }
  };
};
function of(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function rf(t) {
  return f1.some((e) => t[e] >= 0);
}
const cw = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: o = "referenceHidden",
        ...r
      } = Bn(t, e);
      switch (o) {
        case "referenceHidden": {
          const s = await rs(e, {
            ...r,
            elementContext: "reference"
          }), i = of(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: rf(i)
            }
          };
        }
        case "escaped": {
          const s = await rs(e, {
            ...r,
            altBoundary: !0
          }), i = of(s, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: rf(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, yh = /* @__PURE__ */ new Set(["left", "top"]);
async function uw(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, s = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = qt(n), a = ho(n), l = sn(n) === "y", c = yh.has(i) ? -1 : 1, u = s && l ? -1 : 1, d = Bn(e, t);
  let {
    mainAxis: p,
    crossAxis: m,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof h == "number" && (m = a === "end" ? h * -1 : h), l ? {
    x: m * u,
    y: p * c
  } : {
    x: p * c,
    y: m * u
  };
}
const dw = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: s,
        placement: i,
        middlewareData: a
      } = e, l = await uw(e, t);
      return i === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, fw = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r
      } = e, {
        mainAxis: s = !0,
        crossAxis: i = !1,
        limiter: a = {
          fn: (y) => {
            let {
              x: v,
              y: x
            } = y;
            return {
              x: v,
              y: x
            };
          }
        },
        ...l
      } = Bn(t, e), c = {
        x: n,
        y: o
      }, u = await rs(e, l), d = sn(qt(r)), p = Ac(d);
      let m = c[p], h = c[d];
      if (s) {
        const y = p === "y" ? "top" : "left", v = p === "y" ? "bottom" : "right", x = m + u[y], w = m - u[v];
        m = Bl(x, m, w);
      }
      if (i) {
        const y = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", x = h + u[y], w = h - u[v];
        h = Bl(x, h, w);
      }
      const g = a.fn({
        ...e,
        [p]: m,
        [d]: h
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - o,
          enabled: {
            [p]: s,
            [d]: i
          }
        }
      };
    }
  };
}, pw = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: s,
        middlewareData: i
      } = e, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = Bn(t, e), u = {
        x: n,
        y: o
      }, d = sn(r), p = Ac(d);
      let m = u[p], h = u[d];
      const g = Bn(a, e), y = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const w = p === "y" ? "height" : "width", E = s.reference[p] - s.floating[w] + y.mainAxis, S = s.reference[p] + s.reference[w] - y.mainAxis;
        m < E ? m = E : m > S && (m = S);
      }
      if (c) {
        var v, x;
        const w = p === "y" ? "width" : "height", E = yh.has(qt(r)), S = s.reference[d] - s.floating[w] + (E && ((v = i.offset) == null ? void 0 : v[d]) || 0) + (E ? 0 : y.crossAxis), C = s.reference[d] + s.reference[w] + (E ? 0 : ((x = i.offset) == null ? void 0 : x[d]) || 0) - (E ? y.crossAxis : 0);
        h < S ? h = S : h > C && (h = C);
      }
      return {
        [p]: m,
        [d]: h
      };
    }
  };
}, mw = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        rects: s,
        platform: i,
        elements: a
      } = e, {
        apply: l = () => {
        },
        ...c
      } = Bn(t, e), u = await rs(e, c), d = qt(r), p = ho(r), m = sn(r) === "y", {
        width: h,
        height: g
      } = s.floating;
      let y, v;
      d === "top" || d === "bottom" ? (y = d, v = p === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (v = d, y = p === "end" ? "top" : "bottom");
      const x = g - u.top - u.bottom, w = h - u.left - u.right, E = pr(g - u[y], x), S = pr(h - u[v], w), C = !e.middlewareData.shift;
      let _ = E, R = S;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (R = w), (o = e.middlewareData.shift) != null && o.enabled.y && (_ = x), C && !p) {
        const j = Zt(u.left, 0), F = Zt(u.right, 0), N = Zt(u.top, 0), T = Zt(u.bottom, 0);
        m ? R = h - 2 * (j !== 0 || F !== 0 ? j + F : Zt(u.left, u.right)) : _ = g - 2 * (N !== 0 || T !== 0 ? N + T : Zt(u.top, u.bottom));
      }
      await l({
        ...e,
        availableWidth: R,
        availableHeight: _
      });
      const O = await i.getDimensions(a.floating);
      return h !== O.width || g !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function xh(t) {
  const e = en(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = ut(t), s = r ? t.offsetWidth : n, i = r ? t.offsetHeight : o, a = wi(n) !== s || wi(o) !== i;
  return a && (n = s, o = i), {
    width: n,
    height: o,
    $: a
  };
}
function qc(t) {
  return Ze(t) ? t : t.contextElement;
}
function lr(t) {
  const e = qc(t);
  if (!ut(e))
    return Nn(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: s
  } = xh(e);
  let i = (s ? wi(n.width) : n.width) / o, a = (s ? wi(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const hw = /* @__PURE__ */ Nn(0);
function wh(t) {
  const e = mt(t);
  return !ea() || !e.visualViewport ? hw : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function gw(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== mt(t) ? !1 : e;
}
function Mo(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), s = qc(t);
  let i = Nn(1);
  e && (o ? Ze(o) && (i = lr(o)) : i = lr(t));
  const a = gw(s, n, o) ? wh(s) : Nn(0);
  let l = (r.left + a.x) / i.x, c = (r.top + a.y) / i.y, u = r.width / i.x, d = r.height / i.y;
  if (s) {
    const p = mt(s), m = o && Ze(o) ? mt(o) : o;
    let h = p, g = Ll(h);
    for (; g && o && m !== h; ) {
      const y = lr(g), v = g.getBoundingClientRect(), x = en(g), w = v.left + (g.clientLeft + parseFloat(x.paddingLeft)) * y.x, E = v.top + (g.clientTop + parseFloat(x.paddingTop)) * y.y;
      l *= y.x, c *= y.y, u *= y.x, d *= y.y, l += w, c += E, h = mt(g), g = Ll(h);
    }
  }
  return Ei({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function aa(t, e) {
  const n = ta(t).scrollLeft;
  return e ? e.left + n : Mo(Mn(t)).left + n;
}
function Sh(t, e) {
  const n = t.getBoundingClientRect(), o = n.left + e.scrollLeft - aa(t, n), r = n.top + e.scrollTop;
  return {
    x: o,
    y: r
  };
}
function bw(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const s = r === "fixed", i = Mn(o), a = e ? Qi(e.floating) : !1;
  if (o === i || a && s)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Nn(1);
  const u = Nn(0), d = ut(o);
  if ((d || !d && !s) && ((mo(o) !== "body" || Fo(i)) && (l = ta(o)), ut(o))) {
    const m = Mo(o);
    c = lr(o), u.x = m.x + o.clientLeft, u.y = m.y + o.clientTop;
  }
  const p = i && !d && !s ? Sh(i, l) : Nn(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + p.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + p.y
  };
}
function vw(t) {
  return Array.from(t.getClientRects());
}
function yw(t) {
  const e = Mn(t), n = ta(t), o = t.ownerDocument.body, r = Zt(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), s = Zt(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + aa(t);
  const a = -n.scrollTop;
  return en(o).direction === "rtl" && (i += Zt(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: a
  };
}
const sf = 25;
function xw(t, e) {
  const n = mt(t), o = Mn(t), r = n.visualViewport;
  let s = o.clientWidth, i = o.clientHeight, a = 0, l = 0;
  if (r) {
    s = r.width, i = r.height;
    const u = ea();
    (!u || u && e === "fixed") && (a = r.offsetLeft, l = r.offsetTop);
  }
  const c = aa(o);
  if (c <= 0) {
    const u = o.ownerDocument, d = u.body, p = getComputedStyle(d), m = u.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, h = Math.abs(o.clientWidth - d.clientWidth - m);
    h <= sf && (s -= h);
  } else c <= sf && (s += c);
  return {
    width: s,
    height: i,
    x: a,
    y: l
  };
}
const ww = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Sw(t, e) {
  const n = Mo(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, s = ut(t) ? lr(t) : Nn(1), i = t.clientWidth * s.x, a = t.clientHeight * s.y, l = r * s.x, c = o * s.y;
  return {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function af(t, e, n) {
  let o;
  if (e === "viewport")
    o = xw(t, n);
  else if (e === "document")
    o = yw(Mn(t));
  else if (Ze(e))
    o = Sw(e, n);
  else {
    const r = wh(t);
    o = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return Ei(o);
}
function Eh(t, e) {
  const n = On(t);
  return n === e || !Ze(n) || Rn(n) ? !1 : en(n).position === "fixed" || Eh(n, e);
}
function Ew(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = ro(t, [], !1).filter((a) => Ze(a) && mo(a) !== "body"), r = null;
  const s = en(t).position === "fixed";
  let i = s ? On(t) : t;
  for (; Ze(i) && !Rn(i); ) {
    const a = en(i), l = Tc(i);
    !l && a.position === "fixed" && (r = null), (s ? !l && !r : !l && a.position === "static" && !!r && ww.has(r.position) || Fo(i) && !l && Eh(t, i)) ? o = o.filter((u) => u !== i) : r = a, i = On(i);
  }
  return e.set(t, o), o;
}
function Cw(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const i = [...n === "clippingAncestors" ? Qi(e) ? [] : Ew(e, this._c) : [].concat(n), o], a = i[0], l = i.reduce((c, u) => {
    const d = af(e, u, r);
    return c.top = Zt(d.top, c.top), c.right = pr(d.right, c.right), c.bottom = pr(d.bottom, c.bottom), c.left = Zt(d.left, c.left), c;
  }, af(e, a, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function _w(t) {
  const {
    width: e,
    height: n
  } = xh(t);
  return {
    width: e,
    height: n
  };
}
function Rw(t, e, n) {
  const o = ut(e), r = Mn(e), s = n === "fixed", i = Mo(t, !0, s, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Nn(0);
  function c() {
    l.x = aa(r);
  }
  if (o || !o && !s)
    if ((mo(e) !== "body" || Fo(r)) && (a = ta(e)), o) {
      const m = Mo(e, !0, s, e);
      l.x = m.x + e.clientLeft, l.y = m.y + e.clientTop;
    } else r && c();
  s && !o && r && c();
  const u = r && !o && !s ? Sh(r, a) : Nn(0), d = i.left + a.scrollLeft - l.x - u.x, p = i.top + a.scrollTop - l.y - u.y;
  return {
    x: d,
    y: p,
    width: i.width,
    height: i.height
  };
}
function Za(t) {
  return en(t).position === "static";
}
function lf(t, e) {
  if (!ut(t) || en(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return Mn(t) === n && (n = n.ownerDocument.body), n;
}
function Ch(t, e) {
  const n = mt(t);
  if (Qi(t))
    return n;
  if (!ut(t)) {
    let r = On(t);
    for (; r && !Rn(r); ) {
      if (Ze(r) && !Za(r))
        return r;
      r = On(r);
    }
    return n;
  }
  let o = lf(t, e);
  for (; o && Xy(o) && Za(o); )
    o = lf(o, e);
  return o && Rn(o) && Za(o) && !Tc(o) ? n : o || t1(t) || n;
}
const Nw = async function(t) {
  const e = this.getOffsetParent || Ch, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: Rw(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function kw(t) {
  return en(t).direction === "rtl";
}
const Tw = {
  convertOffsetParentRelativeRectToViewportRelativeRect: bw,
  getDocumentElement: Mn,
  getClippingRect: Cw,
  getOffsetParent: Ch,
  getElementRects: Nw,
  getClientRects: vw,
  getDimensions: _w,
  getScale: lr,
  isElement: Ze,
  isRTL: kw
};
function _h(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function Iw(t, e) {
  let n = null, o;
  const r = Mn(t);
  function s() {
    var a;
    clearTimeout(o), (a = n) == null || a.disconnect(), n = null;
  }
  function i(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), s();
    const c = t.getBoundingClientRect(), {
      left: u,
      top: d,
      width: p,
      height: m
    } = c;
    if (a || e(), !p || !m)
      return;
    const h = or(d), g = or(r.clientWidth - (u + p)), y = or(r.clientHeight - (d + m)), v = or(u), w = {
      rootMargin: -h + "px " + -g + "px " + -y + "px " + -v + "px",
      threshold: Zt(0, pr(1, l)) || 1
    };
    let E = !0;
    function S(C) {
      const _ = C[0].intersectionRatio;
      if (_ !== l) {
        if (!E)
          return i();
        _ ? i(!1, _) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      _ === 1 && !_h(c, t.getBoundingClientRect()) && i(), E = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...w,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, w);
    }
    n.observe(t);
  }
  return i(!0), s;
}
function cf(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = qc(t), u = r || s ? [...c ? ro(c) : [], ...ro(e)] : [];
  u.forEach((v) => {
    r && v.addEventListener("scroll", n, {
      passive: !0
    }), s && v.addEventListener("resize", n);
  });
  const d = c && a ? Iw(c, n) : null;
  let p = -1, m = null;
  i && (m = new ResizeObserver((v) => {
    let [x] = v;
    x && x.target === c && m && (m.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var w;
      (w = m) == null || w.observe(e);
    })), n();
  }), c && !l && m.observe(c), m.observe(e));
  let h, g = l ? Mo(t) : null;
  l && y();
  function y() {
    const v = Mo(t);
    g && !_h(g, v) && n(), g = v, h = requestAnimationFrame(y);
  }
  return n(), () => {
    var v;
    u.forEach((x) => {
      r && x.removeEventListener("scroll", n), s && x.removeEventListener("resize", n);
    }), d?.(), (v = m) == null || v.disconnect(), m = null, l && cancelAnimationFrame(h);
  };
}
const Ow = dw, Mw = fw, Pw = lw, Aw = mw, Dw = cw, jw = pw, Lw = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Tw,
    ...n
  }, s = {
    ...r.platform,
    _c: o
  };
  return aw(t, e, {
    ...r,
    platform: s
  });
};
var $w = typeof document < "u", Fw = function() {
}, hi = $w ? Jv : Fw;
function Ii(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Ii(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const s = r[o];
      if (!(s === "_owner" && t.$$typeof) && !Ii(t[s], e[s]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Rh(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function uf(t, e) {
  const n = Rh(t);
  return Math.round(e * n) / n;
}
function Ja(t) {
  const e = f.useRef(t);
  return hi(() => {
    e.current = t;
  }), e;
}
function Vw(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = t, [u, d] = f.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [p, m] = f.useState(o);
  Ii(p, o) || m(o);
  const [h, g] = f.useState(null), [y, v] = f.useState(null), x = f.useCallback((k) => {
    k !== C.current && (C.current = k, g(k));
  }, []), w = f.useCallback((k) => {
    k !== _.current && (_.current = k, v(k));
  }, []), E = s || h, S = i || y, C = f.useRef(null), _ = f.useRef(null), R = f.useRef(u), O = l != null, j = Ja(l), F = Ja(r), N = Ja(c), T = f.useCallback(() => {
    if (!C.current || !_.current)
      return;
    const k = {
      placement: e,
      strategy: n,
      middleware: p
    };
    F.current && (k.platform = F.current), Lw(C.current, _.current, k).then((H) => {
      const B = {
        ...H,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: N.current !== !1
      };
      L.current && !Ii(R.current, B) && (R.current = B, Vt.flushSync(() => {
        d(B);
      }));
    });
  }, [p, e, n, F, N]);
  hi(() => {
    c === !1 && R.current.isPositioned && (R.current.isPositioned = !1, d((k) => ({
      ...k,
      isPositioned: !1
    })));
  }, [c]);
  const L = f.useRef(!1);
  hi(() => (L.current = !0, () => {
    L.current = !1;
  }), []), hi(() => {
    if (E && (C.current = E), S && (_.current = S), E && S) {
      if (j.current)
        return j.current(E, S, T);
      T();
    }
  }, [E, S, T, j, O]);
  const M = f.useMemo(() => ({
    reference: C,
    floating: _,
    setReference: x,
    setFloating: w
  }), [x, w]), A = f.useMemo(() => ({
    reference: E,
    floating: S
  }), [E, S]), $ = f.useMemo(() => {
    const k = {
      position: n,
      left: 0,
      top: 0
    };
    if (!A.floating)
      return k;
    const H = uf(A.floating, u.x), B = uf(A.floating, u.y);
    return a ? {
      ...k,
      transform: "translate(" + H + "px, " + B + "px)",
      ...Rh(A.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: H,
      top: B
    };
  }, [n, a, A.floating, u.x, u.y]);
  return f.useMemo(() => ({
    ...u,
    update: T,
    refs: M,
    elements: A,
    floatingStyles: $
  }), [u, T, M, A, $]);
}
const zw = (t, e) => ({
  ...Ow(t),
  options: [t, e]
}), Bw = (t, e) => ({
  ...Mw(t),
  options: [t, e]
}), Hw = (t, e) => ({
  ...jw(t),
  options: [t, e]
}), Uw = (t, e) => ({
  ...Pw(t),
  options: [t, e]
}), Ww = (t, e) => ({
  ...Aw(t),
  options: [t, e]
}), Gw = (t, e) => ({
  ...Dw(t),
  options: [t, e]
}), Kw = {
  intentional: "onClick",
  sloppy: "onPointerDown"
};
function Yw(t) {
  return {
    escapeKey: typeof t == "boolean" ? t : t?.escapeKey ?? !1,
    outsidePress: typeof t == "boolean" ? t : t?.outsidePress ?? !0
  };
}
function bs(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), s = n.useState("referenceElement"), i = n.useState("domReferenceElement"), {
    onOpenChange: a,
    dataRef: l
  } = n.context, {
    enabled: c = !0,
    escapeKey: u = !0,
    outsidePress: d = !0,
    outsidePressEvent: p = "sloppy",
    referencePress: m = !1,
    referencePressEvent: h = "sloppy",
    ancestorScroll: g = !1,
    bubbles: y,
    externalTree: v
  } = e, x = vo(v), w = fe(typeof d == "function" ? d : () => !1), E = typeof d == "function" ? w : d, S = f.useRef(!1), {
    escapeKey: C,
    outsidePress: _
  } = Yw(y), R = f.useRef(null), O = ft(), j = ft(), F = fe(() => {
    j.clear(), l.current.insideReactTree = !1;
  }), N = f.useRef(!1), T = f.useRef(""), L = fe((W) => {
    T.current = W.pointerType;
  }), M = fe(() => {
    const W = T.current, oe = W === "pen" || !W ? "mouse" : W, Y = typeof p == "function" ? p() : p;
    return typeof Y == "string" ? Y : Y[oe];
  }), A = fe((W) => {
    if (!o || !c || !u || W.key !== "Escape" || N.current)
      return;
    const oe = l.current.floatingContext?.nodeId, Y = x ? ko(x.nodesRef.current, oe) : [];
    if (!C && Y.length > 0) {
      let X = !0;
      if (Y.forEach((ne) => {
        ne.context?.open && !ne.context.dataRef.current.__escapeKeyBubbles && (X = !1);
      }), !X)
        return;
    }
    const Z = d1(W) ? W.nativeEvent : W, K = ke(us, Z);
    n.setOpen(!1, K), !C && !K.isPropagationAllowed && W.stopPropagation();
  }), $ = fe((W) => {
    const oe = M();
    return oe === "intentional" && W.type !== "click" || oe === "sloppy" && W.type === "click";
  }), k = fe(() => {
    l.current.insideReactTree = !0, j.start(0, F);
  }), H = fe((W, oe = !1) => {
    if ($(W)) {
      F();
      return;
    }
    if (l.current.insideReactTree) {
      F();
      return;
    }
    if (M() === "intentional" && oe || typeof E == "function" && !E(W))
      return;
    const Y = $t(W), Z = `[${gr("inert")}]`, K = vt(n.select("floatingElement")).querySelectorAll(Z), X = n.context.triggerElements;
    if (Y && (X.hasElement(Y) || X.hasMatchingElement((le) => Ue(le, Y))))
      return;
    let ne = Ze(Y) ? Y : null;
    for (; ne && !Rn(ne); ) {
      const le = On(ne);
      if (Rn(le) || !Ze(le))
        break;
      ne = le;
    }
    if (K.length && Ze(Y) && !c1(Y) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !Ue(Y, n.select("floatingElement")) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(K).every((le) => !Ue(ne, le)))
      return;
    if (ut(Y) && !("touches" in W)) {
      const le = Rn(Y), te = en(Y), pe = /auto|scroll/, ue = le || pe.test(te.overflowX), ye = le || pe.test(te.overflowY), ge = ue && Y.clientWidth > 0 && Y.scrollWidth > Y.clientWidth, Te = ye && Y.clientHeight > 0 && Y.scrollHeight > Y.clientHeight, Se = te.direction === "rtl", xe = Te && (Se ? W.offsetX <= Y.offsetWidth - Y.clientWidth : W.offsetX > Y.clientWidth), je = ge && W.offsetY > Y.clientHeight;
      if (xe || je)
        return;
    }
    const re = l.current.floatingContext?.nodeId, ie = x && ko(x.nodesRef.current, re).some((le) => pn(W, le.context?.elements.floating));
    if (pn(W, n.select("floatingElement")) || pn(W, n.select("domReferenceElement")) || ie)
      return;
    const de = x ? ko(x.nodesRef.current, re) : [];
    if (de.length > 0) {
      let le = !0;
      if (de.forEach((te) => {
        te.context?.open && !te.context.dataRef.current.__outsidePressBubbles && (le = !1);
      }), !le)
        return;
    }
    n.setOpen(!1, ke(Yi, W)), F();
  }), B = fe((W) => {
    M() !== "sloppy" || W.pointerType === "touch" || !n.select("open") || !c || pn(W, n.select("floatingElement")) || pn(W, n.select("domReferenceElement")) || H(W);
  }), P = fe((W) => {
    if (M() !== "sloppy" || !n.select("open") || !c || pn(W, n.select("floatingElement")) || pn(W, n.select("domReferenceElement")))
      return;
    const oe = W.touches[0];
    oe && (R.current = {
      startTime: Date.now(),
      startX: oe.clientX,
      startY: oe.clientY,
      dismissOnTouchEnd: !1,
      dismissOnMouseDown: !0
    }, O.start(1e3, () => {
      R.current && (R.current.dismissOnTouchEnd = !1, R.current.dismissOnMouseDown = !1);
    }));
  }), V = fe((W) => {
    const oe = $t(W);
    function Y() {
      P(W), oe?.removeEventListener(W.type, Y);
    }
    oe?.addEventListener(W.type, Y);
  }), I = fe((W) => {
    const oe = S.current;
    if (S.current = !1, O.clear(), W.type === "mousedown" && R.current && !R.current.dismissOnMouseDown)
      return;
    const Y = $t(W);
    function Z() {
      W.type === "pointerdown" ? B(W) : H(W, oe), Y?.removeEventListener(W.type, Z);
    }
    Y?.addEventListener(W.type, Z);
  }), D = fe((W) => {
    if (M() !== "sloppy" || !R.current || pn(W, n.select("floatingElement")) || pn(W, n.select("domReferenceElement")))
      return;
    const oe = W.touches[0];
    if (!oe)
      return;
    const Y = Math.abs(oe.clientX - R.current.startX), Z = Math.abs(oe.clientY - R.current.startY), K = Math.sqrt(Y * Y + Z * Z);
    K > 5 && (R.current.dismissOnTouchEnd = !0), K > 10 && (H(W), O.clear(), R.current = null);
  }), z = fe((W) => {
    const oe = $t(W);
    function Y() {
      D(W), oe?.removeEventListener(W.type, Y);
    }
    oe?.addEventListener(W.type, Y);
  }), U = fe((W) => {
    M() !== "sloppy" || !R.current || pn(W, n.select("floatingElement")) || pn(W, n.select("domReferenceElement")) || (R.current.dismissOnTouchEnd && H(W), O.clear(), R.current = null);
  }), G = fe((W) => {
    const oe = $t(W);
    function Y() {
      U(W), oe?.removeEventListener(W.type, Y);
    }
    oe?.addEventListener(W.type, Y);
  });
  f.useEffect(() => {
    if (!o || !c)
      return;
    l.current.__escapeKeyBubbles = C, l.current.__outsidePressBubbles = _;
    const W = new Un();
    function oe(ne) {
      n.setOpen(!1, ke(Ut, ne));
    }
    function Y() {
      W.clear(), N.current = !0;
    }
    function Z() {
      W.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        ea() ? 5 : 0,
        () => {
          N.current = !1;
        }
      );
    }
    const K = vt(r);
    K.addEventListener("pointerdown", L, !0), u && (K.addEventListener("keydown", A), K.addEventListener("compositionstart", Y), K.addEventListener("compositionend", Z)), E && (K.addEventListener("click", I, !0), K.addEventListener("pointerdown", I, !0), K.addEventListener("touchstart", V, !0), K.addEventListener("touchmove", z, !0), K.addEventListener("touchend", G, !0), K.addEventListener("mousedown", I, !0));
    let X = [];
    return g && (Ze(i) && (X = ro(i)), Ze(r) && (X = X.concat(ro(r))), !Ze(s) && s && s.contextElement && (X = X.concat(ro(s.contextElement)))), X = X.filter((ne) => ne !== K.defaultView?.visualViewport), X.forEach((ne) => {
      ne.addEventListener("scroll", oe, {
        passive: !0
      });
    }), () => {
      K.removeEventListener("pointerdown", L, !0), u && (K.removeEventListener("keydown", A), K.removeEventListener("compositionstart", Y), K.removeEventListener("compositionend", Z)), E && (K.removeEventListener("click", I, !0), K.removeEventListener("pointerdown", I, !0), K.removeEventListener("touchstart", V, !0), K.removeEventListener("touchmove", z, !0), K.removeEventListener("touchend", G, !0), K.removeEventListener("mousedown", I, !0)), X.forEach((ne) => {
        ne.removeEventListener("scroll", oe);
      }), W.clear(), S.current = !1;
    };
  }, [l, r, s, i, u, E, o, a, g, c, C, _, A, H, I, B, V, z, G, L, n]), f.useEffect(F, [E, F]);
  const J = f.useMemo(() => ({
    onKeyDown: A,
    ...m && {
      [Kw[h]]: (W) => {
        n.setOpen(!1, ke(ln, W.nativeEvent));
      },
      ...h !== "intentional" && {
        onClick(W) {
          n.setOpen(!1, ke(ln, W.nativeEvent));
        }
      }
    }
  }), [A, n, m, h]), se = fe((W) => {
    const oe = $t(W.nativeEvent);
    !Ue(n.select("floatingElement"), oe) || W.button !== 0 || (S.current = !0);
  }), Q = fe((W) => {
    !o || !c || W.button !== 0 || (S.current = !0);
  }), ce = f.useMemo(() => ({
    onKeyDown: A,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: se,
    onMouseDown: se,
    onMouseUp: se,
    onClickCapture: k,
    onMouseDownCapture(W) {
      k(), Q(W);
    },
    onPointerDownCapture(W) {
      k(), Q(W);
    },
    onMouseUpCapture: k,
    onTouchEndCapture: k,
    onTouchMoveCapture: k
  }), [A, se, k, Q]);
  return f.useMemo(() => c ? {
    reference: J,
    floating: ce,
    trigger: J
  } : {}, [c, J, ce]);
}
var qw = (t, e, n) => {
  if (e.length === 1 && e[0] === n) {
    let o = !1;
    try {
      const r = {};
      t(r) === r && (o = !0);
    } catch {
    }
    if (o) {
      let r;
      try {
        throw new Error();
      } catch (s) {
        ({ stack: r } = s);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: r }
      );
    }
  }
}, Xw = (t, e, n) => {
  const { memoize: o, memoizeOptions: r } = e, { inputSelectorResults: s, inputSelectorResultsCopy: i } = t, a = o(() => ({}), ...r);
  if (!(a.apply(null, s) === a.apply(null, i))) {
    let c;
    try {
      throw new Error();
    } catch (u) {
      ({ stack: c } = u);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: s,
        secondInputs: i,
        stack: c
      }
    );
  }
}, Zw = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, Oi = /* @__PURE__ */ Symbol("NOT_FOUND");
function Jw(t, e = `expected a function, instead received ${typeof t}`) {
  if (typeof t != "function")
    throw new TypeError(e);
}
function Qw(t, e = `expected an object, instead received ${typeof t}`) {
  if (typeof t != "object")
    throw new TypeError(e);
}
function eS(t, e = "expected all items to be functions, instead received the following types: ") {
  if (!t.every((n) => typeof n == "function")) {
    const n = t.map(
      (o) => typeof o == "function" ? `function ${o.name || "unnamed"}()` : typeof o
    ).join(", ");
    throw new TypeError(`${e}[${n}]`);
  }
}
var df = (t) => Array.isArray(t) ? t : [t];
function tS(t) {
  const e = Array.isArray(t[0]) ? t[0] : t;
  return eS(
    e,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), e;
}
function ff(t, e) {
  const n = [], { length: o } = t;
  for (let r = 0; r < o; r++)
    n.push(t[r].apply(null, e));
  return n;
}
var nS = (t, e) => {
  const { identityFunctionCheck: n, inputStabilityCheck: o } = {
    ...Zw,
    ...e
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && t,
      run: qw
    },
    inputStabilityCheck: {
      shouldRun: o === "always" || o === "once" && t,
      run: Xw
    }
  };
};
function oS(t) {
  let e;
  return {
    get(n) {
      return e && t(e.key, n) ? e.value : Oi;
    },
    put(n, o) {
      e = { key: n, value: o };
    },
    getEntries() {
      return e ? [e] : [];
    },
    clear() {
      e = void 0;
    }
  };
}
function rS(t, e) {
  let n = [];
  function o(a) {
    const l = n.findIndex((c) => e(a, c.key));
    if (l > -1) {
      const c = n[l];
      return l > 0 && (n.splice(l, 1), n.unshift(c)), c.value;
    }
    return Oi;
  }
  function r(a, l) {
    o(a) === Oi && (n.unshift({ key: a, value: l }), n.length > t && n.pop());
  }
  function s() {
    return n;
  }
  function i() {
    n = [];
  }
  return { get: o, put: r, getEntries: s, clear: i };
}
var sS = (t, e) => t === e;
function iS(t) {
  return function(n, o) {
    if (n === null || o === null || n.length !== o.length)
      return !1;
    const { length: r } = n;
    for (let s = 0; s < r; s++)
      if (!t(n[s], o[s]))
        return !1;
    return !0;
  };
}
function aS(t, e) {
  const n = typeof e == "object" ? e : { equalityCheck: e }, {
    equalityCheck: o = sS,
    maxSize: r = 1,
    resultEqualityCheck: s
  } = n, i = iS(o);
  let a = 0;
  const l = r <= 1 ? oS(i) : rS(r, i);
  function c() {
    let u = l.get(arguments);
    if (u === Oi) {
      if (u = t.apply(null, arguments), a++, s) {
        const p = l.getEntries().find(
          (m) => s(m.value, u)
        );
        p && (u = p.value, a !== 0 && a--);
      }
      l.put(arguments, u);
    }
    return u;
  }
  return c.clearCache = () => {
    l.clear(), c.resetResultsCount();
  }, c.resultsCount = () => a, c.resetResultsCount = () => {
    a = 0;
  }, c;
}
var lS = class {
  constructor(t) {
    this.value = t;
  }
  deref() {
    return this.value;
  }
}, cS = typeof WeakRef < "u" ? WeakRef : lS, uS = 0, pf = 1;
function Fs() {
  return {
    s: uS,
    v: void 0,
    o: null,
    p: null
  };
}
function Nh(t, e = {}) {
  let n = Fs();
  const { resultEqualityCheck: o } = e;
  let r, s = 0;
  function i() {
    let a = n;
    const { length: l } = arguments;
    for (let d = 0, p = l; d < p; d++) {
      const m = arguments[d];
      if (typeof m == "function" || typeof m == "object" && m !== null) {
        let h = a.o;
        h === null && (a.o = h = /* @__PURE__ */ new WeakMap());
        const g = h.get(m);
        g === void 0 ? (a = Fs(), h.set(m, a)) : a = g;
      } else {
        let h = a.p;
        h === null && (a.p = h = /* @__PURE__ */ new Map());
        const g = h.get(m);
        g === void 0 ? (a = Fs(), h.set(m, a)) : a = g;
      }
    }
    const c = a;
    let u;
    if (a.s === pf)
      u = a.v;
    else if (u = t.apply(null, arguments), s++, o) {
      const d = r?.deref?.() ?? r;
      d != null && o(d, u) && (u = d, s !== 0 && s--), r = typeof u == "object" && u !== null || typeof u == "function" ? new cS(u) : u;
    }
    return c.s = pf, c.v = u, u;
  }
  return i.clearCache = () => {
    n = Fs(), i.resetResultsCount();
  }, i.resultsCount = () => s, i.resetResultsCount = () => {
    s = 0;
  }, i;
}
function kh(t, ...e) {
  const n = typeof t == "function" ? {
    memoize: t,
    memoizeOptions: e
  } : t, o = (...r) => {
    let s = 0, i = 0, a, l = {}, c = r.pop();
    typeof c == "object" && (l = c, c = r.pop()), Jw(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const u = {
      ...n,
      ...l
    }, {
      memoize: d,
      memoizeOptions: p = [],
      argsMemoize: m = Nh,
      argsMemoizeOptions: h = [],
      devModeChecks: g = {}
    } = u, y = df(p), v = df(h), x = tS(r), w = d(function() {
      return s++, c.apply(
        null,
        arguments
      );
    }, ...y);
    let E = !0;
    const S = m(function() {
      i++;
      const _ = ff(
        x,
        arguments
      );
      if (a = w.apply(null, _), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: R, inputStabilityCheck: O } = nS(E, g);
        if (R.shouldRun && R.run(
          c,
          _,
          a
        ), O.shouldRun) {
          const j = ff(
            x,
            arguments
          );
          O.run(
            { inputSelectorResults: _, inputSelectorResultsCopy: j },
            { memoize: d, memoizeOptions: y },
            arguments
          );
        }
        E && (E = !1);
      }
      return a;
    }, ...v);
    return Object.assign(S, {
      resultFunc: c,
      memoizedResultFunc: w,
      dependencies: x,
      dependencyRecomputations: () => i,
      resetDependencyRecomputations: () => {
        i = 0;
      },
      lastResult: () => a,
      recomputations: () => s,
      resetRecomputations: () => {
        s = 0;
      },
      memoize: d,
      argsMemoize: m
    });
  };
  return Object.assign(o, {
    withTypes: () => o
  }), o;
}
var dS = /* @__PURE__ */ kh(Nh), fS = Object.assign(
  (t, e = dS) => {
    Qw(
      t,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof t}`
    );
    const n = Object.keys(t), o = n.map(
      (s) => t[s]
    );
    return e(
      o,
      (...s) => s.reduce((i, a, l) => (i[n[l]] = a, i), {})
    );
  },
  { withTypes: () => fS }
);
kh({
  memoize: aS,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
});
const be = (t, e, n, o, r, s, ...i) => {
  if (i.length > 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of selectors" : We(1));
  let a;
  if (t)
    a = t;
  else
    throw new Error("Missing arguments");
  return a;
};
var Vs = { exports: {} }, Qa = {};
var mf;
function pS() {
  if (mf) return Qa;
  mf = 1;
  var t = q;
  function e(d, p) {
    return d === p && (d !== 0 || 1 / d === 1 / p) || d !== d && p !== p;
  }
  var n = typeof Object.is == "function" ? Object.is : e, o = t.useState, r = t.useEffect, s = t.useLayoutEffect, i = t.useDebugValue;
  function a(d, p) {
    var m = p(), h = o({ inst: { value: m, getSnapshot: p } }), g = h[0].inst, y = h[1];
    return s(
      function() {
        g.value = m, g.getSnapshot = p, l(g) && y({ inst: g });
      },
      [d, m, p]
    ), r(
      function() {
        return l(g) && y({ inst: g }), d(function() {
          l(g) && y({ inst: g });
        });
      },
      [d]
    ), i(m), m;
  }
  function l(d) {
    var p = d.getSnapshot;
    d = d.value;
    try {
      var m = p();
      return !n(d, m);
    } catch {
      return !0;
    }
  }
  function c(d, p) {
    return p();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return Qa.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, Qa;
}
var el = {};
var hf;
function mS() {
  return hf || (hf = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(m, h) {
      return m === h && (m !== 0 || 1 / m === 1 / h) || m !== m && h !== h;
    }
    function e(m, h) {
      u || r.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = h();
      if (!d) {
        var y = h();
        s(g, y) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      y = i({
        inst: { value: g, getSnapshot: h }
      });
      var v = y[0].inst, x = y[1];
      return l(
        function() {
          v.value = g, v.getSnapshot = h, n(v) && x({ inst: v });
        },
        [m, g, h]
      ), a(
        function() {
          return n(v) && x({ inst: v }), m(function() {
            n(v) && x({ inst: v });
          });
        },
        [m]
      ), c(g), g;
    }
    function n(m) {
      var h = m.getSnapshot;
      m = m.value;
      try {
        var g = h();
        return !s(m, g);
      } catch {
        return !0;
      }
    }
    function o(m, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = q, s = typeof Object.is == "function" ? Object.is : t, i = r.useState, a = r.useEffect, l = r.useLayoutEffect, c = r.useDebugValue, u = !1, d = !1, p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : e;
    el.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : p, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), el;
}
var gf;
function Xc() {
  return gf || (gf = 1, process.env.NODE_ENV === "production" ? Vs.exports = pS() : Vs.exports = mS()), Vs.exports;
}
var hS = Xc(), zs = { exports: {} }, tl = {};
var bf;
function gS() {
  if (bf) return tl;
  bf = 1;
  var t = q, e = Xc();
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var o = typeof Object.is == "function" ? Object.is : n, r = e.useSyncExternalStore, s = t.useRef, i = t.useEffect, a = t.useMemo, l = t.useDebugValue;
  return tl.useSyncExternalStoreWithSelector = function(c, u, d, p, m) {
    var h = s(null);
    if (h.current === null) {
      var g = { hasValue: !1, value: null };
      h.current = g;
    } else g = h.current;
    h = a(
      function() {
        function v(C) {
          if (!x) {
            if (x = !0, w = C, C = p(C), m !== void 0 && g.hasValue) {
              var _ = g.value;
              if (m(_, C))
                return E = _;
            }
            return E = C;
          }
          if (_ = E, o(w, C)) return _;
          var R = p(C);
          return m !== void 0 && m(_, R) ? (w = C, _) : (w = C, E = R);
        }
        var x = !1, w, E, S = d === void 0 ? null : d;
        return [
          function() {
            return v(u());
          },
          S === null ? void 0 : function() {
            return v(S());
          }
        ];
      },
      [u, d, p, m]
    );
    var y = r(c, h[0], h[1]);
    return i(
      function() {
        g.hasValue = !0, g.value = y;
      },
      [y]
    ), l(y), y;
  }, tl;
}
var nl = {};
var vf;
function bS() {
  return vf || (vf = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = q, n = Xc(), o = typeof Object.is == "function" ? Object.is : t, r = n.useSyncExternalStore, s = e.useRef, i = e.useEffect, a = e.useMemo, l = e.useDebugValue;
    nl.useSyncExternalStoreWithSelector = function(c, u, d, p, m) {
      var h = s(null);
      if (h.current === null) {
        var g = { hasValue: !1, value: null };
        h.current = g;
      } else g = h.current;
      h = a(
        function() {
          function v(C) {
            if (!x) {
              if (x = !0, w = C, C = p(C), m !== void 0 && g.hasValue) {
                var _ = g.value;
                if (m(_, C))
                  return E = _;
              }
              return E = C;
            }
            if (_ = E, o(w, C))
              return _;
            var R = p(C);
            return m !== void 0 && m(_, R) ? (w = C, _) : (w = C, E = R);
          }
          var x = !1, w, E, S = d === void 0 ? null : d;
          return [
            function() {
              return v(u());
            },
            S === null ? void 0 : function() {
              return v(S());
            }
          ];
        },
        [u, d, p, m]
      );
      var y = r(c, h[0], h[1]);
      return i(
        function() {
          g.hasValue = !0, g.value = y;
        },
        [y]
      ), l(y), y;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), nl;
}
var yf;
function vS() {
  return yf || (yf = 1, process.env.NODE_ENV === "production" ? zs.exports = gS() : zs.exports = bS()), zs.exports;
}
var yS = vS();
const xS = wc(19), wS = xS ? SS : ES;
function Be(t, e, n, o, r) {
  return wS(t, e, n, o, r);
}
function SS(t, e, n, o, r) {
  const s = f.useCallback(() => e(t.getSnapshot(), n, o, r), [t, e, n, o, r]);
  return hS.useSyncExternalStore(t.subscribe, s, s);
}
function ES(t, e, n, o, r) {
  return yS.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getSnapshot, (s) => e(s, n, o, r));
}
class cr {
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(e) {
    /**
     * Registers a listener that will be called whenever the store's state changes.
     *
     * @param fn The listener function to be called on state changes.
     * @returns A function to unsubscribe the listener.
     */
    Re(this, "subscribe", (e) => (this.listeners.add(e), () => {
      this.listeners.delete(e);
    }));
    /**
     * Returns the current state of the store.
     */
    Re(this, "getSnapshot", () => this.state);
    this.state = e, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(e) {
    if (this.state === e)
      return;
    this.state = e, this.updateTick += 1;
    const n = this.updateTick;
    for (const o of this.listeners) {
      if (n !== this.updateTick)
        return;
      o(e);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(e) {
    for (const n in e)
      if (!Object.is(this.state[n], e[n])) {
        cr.prototype.setState.call(this, {
          ...this.state,
          ...e
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(e, n) {
    Object.is(this.state[e], n) || cr.prototype.setState.call(this, {
      ...this.state,
      [e]: n
    });
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const e = {
      ...this.state
    };
    cr.prototype.setState.call(this, e);
  }
}
class vs extends cr {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(n, o = {}, r) {
    super(n);
    /**
     * Non-reactive values such as refs, callbacks, etc.
     */
    /**
     * Keeps track of which properties are controlled.
     */
    Re(this, "controlledValues", /* @__PURE__ */ new Map());
    /** Gets the current value from the store using a selector with the provided key.
     *
     * @param key Key of the selector to use.
     */
    Re(this, "select", (n, o, r, s) => {
      const i = this.selectors[n];
      return i(this.state, o, r, s);
    });
    /**
     * Returns a value from the store's state using a selector function.
     * Used to subscribe to specific parts of the state.
     * This methods causes a rerender whenever the selected state changes.
     *
     * @param key Key of the selector to use.
     */
    Re(this, "useState", (n, o, r, s) => {
      f.useDebugValue(n);
      const i = this.selectors[n];
      return Be(this, i, o, r, s);
    });
    this.context = o, this.selectors = r;
  }
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(n, o) {
    f.useDebugValue(n), he(() => {
      this.state[n] !== o && this.set(n, o);
    }, [n, o]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(n, o) {
    const r = this;
    he(() => (r.state[n] !== o && r.set(n, o), () => {
      r.set(n, void 0);
    }), [r, n, o]);
  }
  /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */
  useSyncedValues(n) {
    const o = this;
    if (process.env.NODE_ENV !== "production") {
      f.useDebugValue(n, (a) => Object.keys(a));
      const s = f.useRef(Object.keys(n)).current, i = Object.keys(n);
      (s.length !== i.length || s.some((a, l) => a !== i[l])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
    }
    const r = Object.values(n);
    he(() => {
      o.update(n);
    }, [o, ...r]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key.
   * - If `controlled` is non-undefined, the key is marked as controlled and the store's
   *   state at `key` is updated to match `controlled`. Local writes to that key are ignored.
   * - If `controlled` is undefined, the key is marked as uncontrolled. The store's state
   *   is initialized to `defaultValue` on first render and can be updated with local writes.
   */
  useControlledProp(n, o, r) {
    f.useDebugValue(n);
    const s = this, i = o !== void 0;
    if (process.env.NODE_ENV !== "production") {
      const a = this.controlledValues.get(n);
      a !== void 0 && a !== i && console.error(`A component is changing the ${i ? "" : "un"}controlled state of ${n.toString()} to be ${i ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
    }
    this.controlledValues.has(n) || (this.controlledValues.set(n, i), !i && !Object.is(this.state[n], r) && super.setState({
      ...this.state,
      [n]: r
    })), he(() => {
      i && !Object.is(s.state[n], o) && super.setState({
        ...s.state,
        [n]: o
      });
    }, [s, n, o, r, i]);
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   * If the key is controlled (registered via {@link useControlledProp} with a non-undefined value),
   * the update is ignored and no listeners are notified.
   *
   * @param key The state key to update.
   * @param value The new value to set for the specified key.
   */
  set(n, o) {
    this.controlledValues.get(n) !== !0 && super.set(n, o);
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   * Controlled keys are filtered out and not updated.
   *
   * @param values An object containing the changes to apply to the current state.
   */
  update(n) {
    const o = {
      ...n
    };
    for (const r in o)
      if (Object.hasOwn(o, r) && this.controlledValues.get(r) === !0) {
        delete o[r];
        continue;
      }
    super.update(o);
  }
  /**
   * Updates the entire store's state and notifies all registered listeners.
   * Controlled keys are left unchanged; only uncontrolled keys from `newState` are applied.
   *
   * @param newState The new state to set for the store.
   */
  setState(n) {
    const o = {
      ...n
    };
    for (const r in o)
      if (Object.hasOwn(o, r) && this.controlledValues.get(r) === !0) {
        delete o[r];
        continue;
      }
    super.setState({
      ...this.state,
      ...o
    });
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(n, o) {
    f.useDebugValue(n);
    const r = fe(o ?? xt);
    this.context[n] = r;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(n) {
    const o = f.useRef(void 0);
    return o.current === void 0 && (o.current = (r) => {
      this.set(n, r);
    }), o.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(n, o) {
    let r;
    typeof n == "function" ? r = n : r = this.selectors[n];
    let s = r(this.state);
    return o(s, s, this), this.subscribe((i) => {
      const a = r(i);
      if (!Object.is(s, a)) {
        const l = s;
        s = a, o(a, l, this);
      }
    });
  }
}
const CS = {
  open: be((t) => t.open),
  domReferenceElement: be((t) => t.domReferenceElement),
  referenceElement: be((t) => t.positionReference ?? t.referenceElement),
  floatingElement: be((t) => t.floatingElement),
  floatingId: be((t) => t.floatingId)
};
class Zc extends vs {
  constructor(n) {
    const {
      nested: o,
      noEmit: r,
      onOpenChange: s,
      triggerElements: i,
      ...a
    } = n;
    super({
      ...a,
      positionReference: a.referenceElement,
      domReferenceElement: a.referenceElement
    }, {
      onOpenChange: s,
      dataRef: {
        current: {}
      },
      events: fh(),
      nested: o,
      noEmit: r,
      triggerElements: i
    }, CS);
    /**
     * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
     *
     * @param newOpen The new open state.
     * @param eventDetails Details about the event that triggered the open state change.
     */
    Re(this, "setOpen", (n, o) => {
      if ((!n || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
      // click events to upgrade a hover-open.
      mm(o.event)) && (this.context.dataRef.current.openEvent = n ? o.event : void 0), !this.context.noEmit) {
        const r = {
          open: n,
          reason: o.reason,
          nativeEvent: o.event,
          nested: this.context.nested,
          triggerElement: o.trigger
        };
        this.context.events.emit("openchange", r);
      }
      this.context.onOpenChange?.(n, o);
    });
  }
}
function Th(t, e) {
  const n = f.useRef(null), o = f.useRef(null);
  return f.useCallback((r) => {
    if (t !== void 0) {
      if (n.current !== null) {
        const s = n.current, i = o.current, a = e.context.triggerElements.getById(s);
        i && a === i && e.context.triggerElements.delete(s), n.current = null, o.current = null;
      }
      r !== null && (n.current = t, o.current = r, e.context.triggerElements.add(t, r));
    }
  }, [e, t]);
}
function la(t, e, n, o) {
  const r = n.useState("isMountedByTrigger", t), s = Th(t, n), i = fe((a) => {
    if (s(a), !a || !n.select("open"))
      return;
    const l = n.select("activeTriggerId");
    if (l === t) {
      n.update({
        activeTriggerElement: a,
        ...o
      });
      return;
    }
    l == null && n.update({
      activeTriggerId: t,
      activeTriggerElement: a,
      ...o
    });
  });
  return he(() => {
    r && n.update({
      activeTriggerElement: e.current,
      ...o
    });
  }, [r, n, e, ...Object.values(o)]), {
    registerTrigger: i,
    isMountedByThisTrigger: r
  };
}
function ca(t) {
  const e = t.useState("open");
  he(() => {
    if (e && !t.select("activeTriggerId") && t.context.triggerElements.size === 1) {
      const n = t.context.triggerElements.entries().next();
      if (!n.done) {
        const [o, r] = n.value;
        t.update({
          activeTriggerId: o,
          activeTriggerElement: r
        });
      }
    }
  }, [e, t]);
}
function ua(t, e, n) {
  const {
    mounted: o,
    setMounted: r,
    transitionStatus: s
  } = Kn(t);
  e.useSyncedValues({
    mounted: o,
    transitionStatus: s
  });
  const i = fe(() => {
    r(!1), e.update({
      activeTriggerId: null,
      activeTriggerElement: null,
      mounted: !1
    }), n?.(), e.context.onOpenChangeComplete?.(!1);
  }), a = e.useState("preventUnmountingOnClose");
  return Gt({
    enabled: !a,
    open: t,
    ref: e.context.popupRef,
    onComplete() {
      t || i();
    }
  }), {
    forceUnmount: i,
    transitionStatus: s
  };
}
class _r {
  constructor() {
    this.elements = /* @__PURE__ */ new Set(), this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(e, n) {
    const o = this.idMap.get(e);
    if (o !== n && (o !== void 0 && this.elements.delete(o), this.elements.add(n), this.idMap.set(e, n), process.env.NODE_ENV !== "production" && this.elements.size !== this.idMap.size))
      throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap." : We(87));
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(e) {
    const n = this.idMap.get(e);
    n && (this.elements.delete(n), this.idMap.delete(e));
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(e) {
    return this.elements.has(e);
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(e) {
    for (const n of this.elements)
      if (e(n))
        return !0;
    return !1;
  }
  getById(e) {
    return this.idMap.get(e);
  }
  entries() {
    return this.idMap.entries();
  }
  get size() {
    return this.idMap.size;
  }
}
function _S() {
  return new Zc({
    open: !1,
    floatingElement: null,
    referenceElement: null,
    triggerElements: new _r(),
    floatingId: "",
    nested: !1,
    noEmit: !1,
    onOpenChange: void 0
  });
}
function da() {
  return {
    open: !1,
    mounted: !1,
    transitionStatus: "idle",
    floatingRootContext: _S(),
    preventUnmountingOnClose: !1,
    payload: void 0,
    activeTriggerId: null,
    activeTriggerElement: null,
    popupElement: null,
    positionerElement: null,
    activeTriggerProps: at,
    inactiveTriggerProps: at,
    popupProps: at
  };
}
const fa = {
  open: be((t) => t.open),
  mounted: be((t) => t.mounted),
  transitionStatus: be((t) => t.transitionStatus),
  floatingRootContext: be((t) => t.floatingRootContext),
  preventUnmountingOnClose: be((t) => t.preventUnmountingOnClose),
  payload: be((t) => t.payload),
  activeTriggerId: be((t) => t.activeTriggerId),
  activeTriggerElement: be((t) => t.mounted ? t.activeTriggerElement : null),
  /**
   * Whether the trigger with the given ID was used to open the popup.
   */
  isTriggerActive: be((t, e) => e !== void 0 && t.activeTriggerId === e),
  /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */
  isOpenedByTrigger: be((t, e) => e !== void 0 && t.activeTriggerId === e && t.open),
  /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */
  isMountedByTrigger: be((t, e) => e !== void 0 && t.activeTriggerId === e && t.mounted),
  triggerProps: be((t, e) => e ? t.activeTriggerProps : t.inactiveTriggerProps),
  popupProps: be((t) => t.popupProps),
  popupElement: be((t) => t.popupElement),
  positionerElement: be((t) => t.positionerElement)
};
function Ih(t) {
  const {
    open: e = !1,
    onOpenChange: n,
    elements: o = {}
  } = t, r = Lo(), s = Pn() != null;
  if (process.env.NODE_ENV !== "production") {
    const a = o.reference;
    a && !Ze(a) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
  }
  const i = jt(() => new Zc({
    open: e,
    onOpenChange: n,
    referenceElement: o.reference ?? null,
    floatingElement: o.floating ?? null,
    triggerElements: o.triggers ?? new _r(),
    floatingId: r,
    nested: s,
    noEmit: t.noEmit || !1
  })).current;
  return he(() => {
    const a = {
      open: e,
      floatingId: r
    };
    o.reference !== void 0 && (a.referenceElement = o.reference, a.domReferenceElement = Ze(o.reference) ? o.reference : null), o.floating !== void 0 && (a.floatingElement = o.floating), i.update(a);
  }, [e, r, o.reference, o.floating, i]), i.context.onOpenChange = n, i.context.nested = s, i.context.noEmit = t.noEmit || !1, i;
}
function RS(t = {}) {
  const {
    nodeId: e,
    externalTree: n
  } = t, o = Ih(t), r = t.rootContext || o, s = {
    reference: r.useState("referenceElement"),
    floating: r.useState("floatingElement"),
    domReference: r.useState("domReferenceElement")
  }, [i, a] = f.useState(null), l = f.useRef(null), c = vo(n);
  he(() => {
    s.domReference && (l.current = s.domReference);
  }, [s.domReference]);
  const u = Vw({
    ...t,
    elements: {
      ...s,
      ...i && {
        reference: i
      }
    }
  }), d = f.useCallback((_) => {
    const R = Ze(_) ? {
      getBoundingClientRect: () => _.getBoundingClientRect(),
      getClientRects: () => _.getClientRects(),
      contextElement: _
    } : _;
    a(R), u.refs.setReference(R);
  }, [u.refs]), [p, m] = f.useState(null), [h, g] = f.useState(null);
  r.useSyncedValue("referenceElement", p), r.useSyncedValue("domReferenceElement", Ze(p) ? p : null), r.useSyncedValue("floatingElement", h);
  const y = f.useCallback((_) => {
    (Ze(_) || _ === null) && (l.current = _, m(_)), (Ze(u.refs.reference.current) || u.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    _ !== null && !Ze(_)) && u.refs.setReference(_);
  }, [u.refs, m]), v = f.useCallback((_) => {
    g(_), u.refs.setFloating(_);
  }, [u.refs]), x = f.useMemo(() => ({
    ...u.refs,
    setReference: y,
    setFloating: v,
    setPositionReference: d,
    domReference: l
  }), [u.refs, y, v, d]), w = f.useMemo(() => ({
    ...u.elements,
    domReference: s.domReference
  }), [u.elements, s.domReference]), E = r.useState("open"), S = r.useState("floatingId"), C = f.useMemo(() => ({
    ...u,
    dataRef: r.context.dataRef,
    open: E,
    onOpenChange: r.setOpen,
    events: r.context.events,
    floatingId: S,
    refs: x,
    elements: w,
    nodeId: e,
    rootStore: r
  }), [u, x, w, e, r, E, S]);
  return he(() => {
    r.context.dataRef.current.floatingContext = C;
    const _ = c?.nodesRef.current.find((R) => R.id === e);
    _ && (_.context = C);
  }), f.useMemo(() => ({
    ...u,
    context: C,
    refs: x,
    elements: w,
    rootStore: r
  }), [u, x, w, C, r]);
}
function pa(t) {
  const {
    popupStore: e,
    noEmit: n = !1,
    treatPopupAsFloatingElement: o = !1,
    onOpenChange: r
  } = t, s = Lo(), i = Pn() != null, a = e.useState("open"), l = e.useState("activeTriggerElement"), c = e.useState(o ? "popupElement" : "positionerElement"), u = e.context.triggerElements, d = jt(() => new Zc({
    open: a,
    referenceElement: l,
    floatingElement: c,
    triggerElements: u,
    onOpenChange: r,
    floatingId: s,
    nested: i,
    noEmit: n
  })).current;
  return he(() => {
    const p = {
      open: a,
      floatingId: s,
      referenceElement: l,
      floatingElement: c
    };
    Ze(l) && (p.domReferenceElement = l), d.state.positionReference === d.state.referenceElement && (p.positionReference = l), d.update(p);
  }, [a, s, l, c, d]), d.context.onOpenChange = r, d.context.nested = i, d.context.noEmit = n, d;
}
const ol = s1 && am;
function Oh(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    events: o,
    dataRef: r
  } = n.context, {
    enabled: s = !0,
    visibleOnly: i = !0,
    delay: a
  } = e, l = f.useRef(!1), c = f.useRef(null), u = ft(), d = f.useRef(!0);
  f.useEffect(() => {
    const m = n.select("domReferenceElement");
    if (!s)
      return;
    const h = mt(m);
    function g() {
      const x = n.select("domReferenceElement");
      !n.select("open") && ut(x) && x === Jt(vt(x)) && (l.current = !0);
    }
    function y() {
      d.current = !0;
    }
    function v() {
      d.current = !1;
    }
    return h.addEventListener("blur", g), ol && (h.addEventListener("keydown", y, !0), h.addEventListener("pointerdown", v, !0)), () => {
      h.removeEventListener("blur", g), ol && (h.removeEventListener("keydown", y, !0), h.removeEventListener("pointerdown", v, !0));
    };
  }, [n, s]), f.useEffect(() => {
    if (!s)
      return;
    function m(h) {
      if (h.reason === ln || h.reason === us) {
        const g = n.select("domReferenceElement");
        Ze(g) && (c.current = g, l.current = !0);
      }
    }
    return o.on("openchange", m), () => {
      o.off("openchange", m);
    };
  }, [o, s, n]);
  const p = f.useMemo(() => ({
    onMouseLeave() {
      l.current = !1, c.current = null;
    },
    onFocus(m) {
      const h = m.currentTarget;
      if (l.current) {
        if (c.current === h)
          return;
        l.current = !1, c.current = null;
      }
      const g = $t(m.nativeEvent);
      if (i && Ze(g)) {
        if (ol && !m.relatedTarget) {
          if (!d.current && !Pc(g))
            return;
        } else if (!u1(g))
          return;
      }
      const y = m.relatedTarget && n.context.triggerElements.hasElement(m.relatedTarget), {
        nativeEvent: v,
        currentTarget: x
      } = m, w = typeof a == "function" ? a() : a;
      if (n.select("open") && y || w === 0 || w === void 0) {
        n.setOpen(!0, ke(sr, v, x));
        return;
      }
      u.start(w, () => {
        l.current || n.setOpen(!0, ke(sr, v, x));
      });
    },
    onBlur(m) {
      l.current = !1, c.current = null;
      const h = m.relatedTarget, g = m.nativeEvent, y = Ze(h) && h.hasAttribute(gr("focus-guard")) && h.getAttribute("data-type") === "outside";
      u.start(0, () => {
        const v = n.select("domReferenceElement"), x = Jt(v ? v.ownerDocument : document);
        if (!h && x === v || Ue(r.current.floatingContext?.refs.floating.current, x) || Ue(v, x) || y)
          return;
        const w = h ?? x;
        if (Ze(w)) {
          const E = n.context.triggerElements;
          if (E.hasElement(w) || E.hasMatchingElement((S) => Ue(S, w)))
            return;
        }
        n.setOpen(!1, ke(sr, g));
      });
    }
  }), [r, n, i, u, a]);
  return f.useMemo(() => s ? {
    reference: p,
    trigger: p
  } : {}, [s, p]);
}
const Jl = gr("safe-polygon"), NS = `button,a,[role="button"],select,[tabindex]:not([tabindex="-1"]),${dm}`;
function kS(t) {
  return t ? !!t.closest(NS) : !1;
}
function Mh(t) {
  const e = f.useRef(void 0), n = f.useRef(!1), o = f.useRef(void 0), r = f.useRef(!0), s = f.useRef(!1), i = f.useRef(() => {
  }), a = f.useRef(!1), l = ft(), c = ft(), u = f.useRef(void 0);
  return f.useMemo(() => {
    const d = t.context.dataRef.current;
    return d.hoverInteractionState || (d.hoverInteractionState = {
      pointerTypeRef: e,
      interactedInsideRef: n,
      handlerRef: o,
      blockMouseMoveRef: r,
      performedPointerEventsMutationRef: s,
      unbindMouseMoveRef: i,
      restTimeoutPendingRef: a,
      openChangeTimeout: l,
      restTimeout: c,
      handleCloseOptionsRef: u
    }), d.hoverInteractionState;
  }, [t, e, n, o, r, s, i, a, l, c, u]);
}
const TS = /* @__PURE__ */ new Set(["click", "mousedown"]);
function Jc(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), s = n.useState("domReferenceElement"), {
    dataRef: i
  } = n.context, {
    enabled: a = !0,
    closeDelay: l = 0,
    externalTree: c
  } = e, {
    pointerTypeRef: u,
    interactedInsideRef: d,
    handlerRef: p,
    performedPointerEventsMutationRef: m,
    unbindMouseMoveRef: h,
    restTimeoutPendingRef: g,
    openChangeTimeout: y,
    handleCloseOptionsRef: v
  } = Mh(n), x = vo(c), w = Pn(), E = fe(() => d.current ? !0 : i.current.openEvent ? TS.has(i.current.openEvent.type) : !1), S = fe(() => {
    const j = i.current.openEvent?.type;
    return j?.includes("mouse") && j !== "mousedown";
  }), C = f.useCallback((j, F = !0) => {
    const N = IS(l, u.current);
    N && !p.current ? y.start(N, () => n.setOpen(!1, ke(Et, j))) : F && (y.clear(), n.setOpen(!1, ke(Et, j)));
  }, [l, p, n, u, y]), _ = fe(() => {
    h.current(), p.current = void 0;
  }), R = fe(() => {
    if (m.current) {
      const j = vt(r).body;
      j.style.pointerEvents = "", j.removeAttribute(Jl), m.current = !1;
    }
  }), O = fe((j) => {
    const F = $t(j);
    if (!kS(F)) {
      d.current = !1;
      return;
    }
    d.current = !0;
  });
  he(() => {
    o || (u.current = void 0, g.current = !1, d.current = !1, _(), R());
  }, [o, u, g, d, _, R]), f.useEffect(() => () => {
    _();
  }, [_]), f.useEffect(() => R, [R]), he(() => {
    if (a && o && v.current?.blockPointerEvents && S() && Ze(s) && r) {
      m.current = !0;
      const j = vt(r).body;
      j.setAttribute(Jl, "");
      const F = s, N = r, T = x?.nodesRef.current.find((L) => L.id === w)?.context?.elements.floating;
      return T && (T.style.pointerEvents = ""), j.style.pointerEvents = "none", F.style.pointerEvents = "auto", N.style.pointerEvents = "auto", () => {
        j.style.pointerEvents = "", F.style.pointerEvents = "", N.style.pointerEvents = "";
      };
    }
  }, [a, o, s, r, v, S, x, w, m]), f.useEffect(() => {
    if (!a)
      return;
    function j(L) {
      if (E() || !i.current.floatingContext || !n.select("open"))
        return;
      const M = n.context.triggerElements;
      L.relatedTarget && M.hasElement(L.relatedTarget) || (R(), _(), E() || C(L));
    }
    function F(L) {
      y.clear(), R(), p.current?.(L), _();
    }
    function N(L) {
      E() || C(L, !1);
    }
    const T = r;
    return T && (T.addEventListener("mouseleave", j), T.addEventListener("mouseenter", F), T.addEventListener("mouseleave", N), T.addEventListener("pointerdown", O, !0)), () => {
      T && (T.removeEventListener("mouseleave", j), T.removeEventListener("mouseenter", F), T.removeEventListener("mouseleave", N), T.removeEventListener("pointerdown", O, !0));
    };
  });
}
function IS(t, e) {
  return e && !Oo(e) ? 0 : typeof t == "function" ? t() : t;
}
function rl(t) {
  return typeof t == "function" ? t() : t;
}
const OS = {
  current: null
};
function ma(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    dataRef: o,
    events: r
  } = n.context, {
    enabled: s = !0,
    delay: i = 0,
    handleClose: a = null,
    mouseOnly: l = !1,
    restMs: c = 0,
    move: u = !0,
    triggerElementRef: d = OS,
    externalTree: p,
    isActiveTrigger: m = !0
  } = e, h = vo(p), {
    pointerTypeRef: g,
    interactedInsideRef: y,
    handlerRef: v,
    blockMouseMoveRef: x,
    performedPointerEventsMutationRef: w,
    unbindMouseMoveRef: E,
    restTimeoutPendingRef: S,
    openChangeTimeout: C,
    restTimeout: _,
    handleCloseOptionsRef: R
  } = Mh(n), O = yt(a), j = yt(i), F = yt(c);
  m && (R.current = O.current?.__options);
  const N = fe(() => y.current ? !0 : o.current.openEvent ? ["click", "mousedown"].includes(o.current.openEvent.type) : !1), T = f.useCallback(($, k = !0) => {
    const H = pi(j.current, "close", g.current);
    H && !v.current ? C.start(H, () => n.setOpen(!1, ke(Et, $))) : k && (C.clear(), n.setOpen(!1, ke(Et, $)));
  }, [j, v, n, g, C]), L = fe(() => {
    E.current(), v.current = void 0;
  }), M = fe(() => {
    if (w.current) {
      const $ = vt(n.select("domReferenceElement")).body;
      $.style.pointerEvents = "", $.removeAttribute(Jl), w.current = !1;
    }
  });
  f.useEffect(() => {
    if (!s)
      return;
    function $(k) {
      k.open || (C.clear(), _.clear(), x.current = !0, S.current = !1);
    }
    return r.on("openchange", $), () => {
      r.off("openchange", $);
    };
  }, [s, r, C, _, x, S]);
  const A = fe(($) => {
    if (N() || !o.current.floatingContext)
      return;
    const k = n.context.triggerElements;
    if ($.relatedTarget && k.hasElement($.relatedTarget))
      return;
    const H = d.current;
    O.current?.({
      ...o.current.floatingContext,
      tree: h,
      x: $.clientX,
      y: $.clientY,
      onClose() {
        M(), L(), !N() && H === n.select("domReferenceElement") && T($);
      }
    })($);
  });
  return f.useEffect(() => {
    if (!s)
      return;
    const $ = d.current ?? (m ? n.select("domReferenceElement") : null);
    if (!Ze($))
      return;
    function k(P) {
      if (C.clear(), x.current = !1, l && !Oo(g.current) || rl(F.current) > 0 && !pi(j.current, "open"))
        return;
      const V = pi(j.current, "open", g.current), I = n.select("domReferenceElement"), D = n.context.triggerElements, z = (D.hasElement(P.target) || D.hasMatchingElement((se) => Ue(se, P.target))) && (!I || !Ue(I, P.target)), U = P.currentTarget ?? null, G = n.select("open"), J = !G || z;
      z && G ? n.setOpen(!0, ke(Et, P, U)) : V ? C.start(V, () => {
        J && n.setOpen(!0, ke(Et, P, U));
      }) : J && n.setOpen(!0, ke(Et, P, U));
    }
    function H(P) {
      if (N()) {
        M();
        return;
      }
      E.current();
      const V = n.select("domReferenceElement"), I = vt(V);
      _.clear(), S.current = !1;
      const D = n.context.triggerElements;
      if (P.relatedTarget && D.hasElement(P.relatedTarget))
        return;
      if (O.current && o.current.floatingContext) {
        n.select("open") || C.clear();
        const U = d.current;
        v.current = O.current({
          ...o.current.floatingContext,
          tree: h,
          x: P.clientX,
          y: P.clientY,
          onClose() {
            M(), L(), !N() && U === n.select("domReferenceElement") && T(P, !0);
          }
        });
        const G = v.current;
        G(P), I.addEventListener("mousemove", G), E.current = () => {
          I.removeEventListener("mousemove", G);
        };
        return;
      }
      (g.current !== "touch" || !Ue(n.select("floatingElement"), P.relatedTarget)) && T(P);
    }
    function B(P) {
      A(P);
    }
    return n.select("open") && $.addEventListener("mouseleave", B), u && $.addEventListener("mousemove", k, {
      once: !0
    }), $.addEventListener("mouseenter", k), $.addEventListener("mouseleave", H), () => {
      $.removeEventListener("mouseleave", B), u && $.removeEventListener("mousemove", k), $.removeEventListener("mouseenter", k), $.removeEventListener("mouseleave", H);
    };
  }, [L, M, x, o, j, T, n, s, O, A, m, N, l, u, g, F, _, S, C, d, h, E, v]), f.useMemo(() => {
    function $(k) {
      g.current = k.pointerType;
    }
    return {
      onPointerDown: $,
      onPointerEnter: $,
      onMouseMove(k) {
        const {
          nativeEvent: H
        } = k, B = k.currentTarget, P = n.select("domReferenceElement"), V = n.context.triggerElements, I = n.select("open"), D = (V.hasElement(k.target) || V.hasMatchingElement((U) => Ue(U, k.target))) && (!P || !Ue(P, k.target));
        if (l && !Oo(g.current) || I && !D || rl(F.current) === 0 || !D && S.current && k.movementX ** 2 + k.movementY ** 2 < 2)
          return;
        _.clear();
        function z() {
          if (S.current = !1, N())
            return;
          const U = n.select("open");
          !x.current && (!U || D) && n.setOpen(!0, ke(Et, H, B));
        }
        g.current === "touch" ? Vt.flushSync(() => {
          z();
        }) : D && I ? z() : (S.current = !0, _.start(rl(F.current), z));
      }
    };
  }, [x, N, l, n, g, F, _, S]);
}
function qn(t = []) {
  const e = t.map((c) => c?.reference), n = t.map((c) => c?.floating), o = t.map((c) => c?.item), r = t.map((c) => c?.trigger), s = f.useCallback(
    (c) => Bs(c, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), i = f.useCallback(
    (c) => Bs(c, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), a = f.useCallback(
    (c) => Bs(c, t, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  ), l = f.useCallback(
    (c) => Bs(c, t, "trigger"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return f.useMemo(() => ({
    getReferenceProps: s,
    getFloatingProps: i,
    getItemProps: a,
    getTriggerProps: l
  }), [s, i, a, l]);
}
function Bs(t, e, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item", s = {};
  n === "floating" && (s.tabIndex = -1, s[Vl] = "");
  for (const i in t)
    r && t && (i === cm || i === um) || (s[i] = t[i]);
  for (let i = 0; i < e.length; i += 1) {
    let a;
    const l = e[i]?.[n];
    typeof l == "function" ? a = t ? l(t) : null : a = l, a && xf(s, a, r, o);
  }
  return xf(s, t, r, o), s;
}
function xf(t, e, n, o) {
  for (const r in e) {
    const s = e[r];
    n && (r === cm || r === um) || (r.startsWith("on") ? (o.has(r) || o.set(r, []), typeof s == "function" && (o.get(r)?.push(s), t[r] = (...i) => o.get(r)?.map((a) => a(...i)).find((a) => a !== void 0))) : t[r] = s);
  }
}
const MS = "Escape";
function ha(t, e, n) {
  switch (t) {
    case "vertical":
      return e;
    case "horizontal":
      return n;
    default:
      return e || n;
  }
}
function Hs(t, e) {
  return ha(e, t === Mc || t === ds, t === so || t === io);
}
function sl(t, e, n) {
  return ha(e, t === ds, n ? t === so : t === io) || t === "Enter" || t === " " || t === "";
}
function PS(t, e, n) {
  return ha(e, n ? t === so : t === io, t === ds);
}
function AS(t, e, n, o) {
  const r = n ? t === io : t === so, s = t === Mc;
  return e === "both" || e === "horizontal" && o && o > 1 ? t === MS : ha(e, r, s);
}
function Ph(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), s = n.useState("domReferenceElement"), i = n.context.dataRef, {
    listRef: a,
    activeIndex: l,
    onNavigate: c = () => {
    },
    enabled: u = !0,
    selectedIndex: d = null,
    allowEscape: p = !1,
    loopFocus: m = !1,
    nested: h = !1,
    rtl: g = !1,
    virtual: y = !1,
    focusItemOnOpen: v = "auto",
    focusItemOnHover: x = !0,
    openOnArrowKeyDown: w = !0,
    disabledIndices: E = void 0,
    orientation: S = "vertical",
    parentOrientation: C,
    cols: _ = 1,
    scrollItemIntoView: R = !0,
    itemSizes: O,
    dense: j = !1,
    id: F,
    resetOnPointerLeave: N = !0,
    externalTree: T
  } = e;
  process.env.NODE_ENV !== "production" && (p && (m || console.warn("`useListNavigation` looping must be enabled to allow escaping."), y || console.warn("`useListNavigation` must be virtual to allow escaping.")), S === "vertical" && _ > 1 && console.warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const L = ts(r), M = yt(L), A = Pn(), $ = vo(T);
  he(() => {
    i.current.orientation = S;
  }, [i, S]);
  const k = zl(s), H = f.useRef(v), B = f.useRef(d ?? -1), P = f.useRef(null), V = f.useRef(!0), I = fe((te) => {
    c(B.current === -1 ? null : B.current, te);
  }), D = f.useRef(I), z = f.useRef(!!r), U = f.useRef(o), G = f.useRef(!1), J = f.useRef(!1), se = yt(E), Q = yt(o), ce = yt(R), W = yt(d), oe = yt(N), Y = fe(() => {
    function te(ge) {
      y ? $?.events.emit("virtualfocus", ge) : mi(ge, {
        sync: G.current,
        preventScroll: !0
      });
    }
    const pe = a.current[B.current], ue = J.current;
    pe && te(pe), (G.current ? (ge) => ge() : requestAnimationFrame)(() => {
      const ge = a.current[B.current] || pe;
      if (!ge)
        return;
      pe || te(ge);
      const Te = ce.current;
      Te && // eslint-disable-next-line @typescript-eslint/no-use-before-define
      K && (ue || !V.current) && ge.scrollIntoView?.(typeof Te == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : Te);
    });
  });
  he(() => {
    u && (o && r ? (B.current = d ?? -1, H.current && d != null && (J.current = !0, I())) : z.current && (B.current = -1, D.current()));
  }, [u, o, r, d, I]), he(() => {
    if (u) {
      if (!o) {
        G.current = !1;
        return;
      }
      if (r)
        if (l == null) {
          if (G.current = !1, W.current != null)
            return;
          if (z.current && (B.current = -1, Y()), (!U.current || !z.current) && H.current && (P.current != null || H.current === !0 && P.current == null)) {
            let te = 0;
            const pe = () => {
              a.current[0] == null ? (te < 2 && (te ? requestAnimationFrame : queueMicrotask)(pe), te += 1) : (B.current = P.current == null || sl(P.current, S, g) || h ? ui(a) : Ul(a), P.current = null, I());
            };
            pe();
          }
        } else ir(a, l) || (B.current = l, Y(), J.current = !1);
    }
  }, [u, o, r, l, W, h, a, S, g, I, Y, se]), he(() => {
    if (!u || r || !$ || y || !z.current)
      return;
    const te = $.nodesRef.current, pe = te.find((ge) => ge.id === A)?.context?.elements.floating, ue = Jt(vt(r)), ye = te.some((ge) => ge.context && Ue(ge.context.elements.floating, ue));
    pe && !ye && V.current && pe.focus({
      preventScroll: !0
    });
  }, [u, r, $, A, y]), he(() => {
    D.current = I, U.current = o, z.current = !!r;
  }), he(() => {
    o || (P.current = null, H.current = v);
  }, [o, v]);
  const Z = l != null, K = f.useMemo(() => {
    function te(ue) {
      if (!Q.current)
        return;
      const ye = a.current.indexOf(ue.currentTarget);
      ye !== -1 && B.current !== ye && (B.current = ye, I(ue));
    }
    return {
      onFocus(ue) {
        G.current = !0, te(ue);
      },
      onClick: ({
        currentTarget: ue
      }) => ue.focus({
        preventScroll: !0
      }),
      // Safari
      onMouseMove(ue) {
        G.current = !0, J.current = !1, x && te(ue);
      },
      onPointerLeave(ue) {
        if (!Q.current || !V.current || ue.pointerType === "touch")
          return;
        G.current = !0;
        const ye = ue.relatedTarget;
        !x || a.current.includes(ye) || oe.current && (B.current = -1, I(ue), y || M.current?.focus({
          preventScroll: !0
        }));
      }
    };
  }, [Q, M, x, a, I, oe, y]), X = f.useCallback(() => C ?? $?.nodesRef.current.find((te) => te.id === A)?.context?.dataRef?.current.orientation, [A, $, C]), ne = fe((te) => {
    if (V.current = !1, G.current = !0, te.which === 229 || !Q.current && te.currentTarget === M.current)
      return;
    if (h && AS(te.key, S, g, _)) {
      Hs(te.key, X()) || At(te), n.setOpen(!1, ke(ci, te.nativeEvent)), ut(s) && (y ? $?.events.emit("virtualfocus", s) : s.focus());
      return;
    }
    const pe = B.current, ue = ui(a, E), ye = Ul(a, E);
    if (k || (te.key === "Home" && (At(te), B.current = ue, I(te)), te.key === "End" && (At(te), B.current = ye, I(te))), _ > 1) {
      const ge = O || Array.from({
        length: a.current.length
      }, () => ({
        width: 1,
        height: 1
      })), Te = bm(ge, _, j), Se = Te.findIndex((Me) => Me != null && !ao(a, Me, E)), xe = Te.reduce((Me, Pe, we) => Pe != null && !ao(a, Pe, E) ? we : Me, -1), je = Te[gm({
        current: Te.map((Me) => Me != null ? a.current[Me] : null)
      }, {
        event: te,
        orientation: S,
        loopFocus: m,
        rtl: g,
        cols: _,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: ym([...(typeof E != "function" ? E : null) || a.current.map((Me, Pe) => ao(a, Pe, E) ? Pe : void 0), void 0], Te),
        minIndex: Se,
        maxIndex: xe,
        prevIndex: vm(
          B.current > ye ? ue : B.current,
          ge,
          Te,
          _,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          // eslint-disable-next-line no-nested-ternary
          te.key === ds ? "bl" : te.key === (g ? so : io) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (je != null && (B.current = je, I(te)), S === "both")
        return;
    }
    if (Hs(te.key, S)) {
      if (At(te), o && !y && Jt(te.currentTarget.ownerDocument) === te.currentTarget) {
        B.current = sl(te.key, S, g) ? ue : ye, I(te);
        return;
      }
      sl(te.key, S, g) ? m ? pe >= ye ? p && pe !== a.current.length ? B.current = -1 : (G.current = !1, B.current = ue) : B.current = Pt(a, {
        startingIndex: pe,
        disabledIndices: E
      }) : B.current = Math.min(ye, Pt(a, {
        startingIndex: pe,
        disabledIndices: E
      })) : m ? pe <= ue ? p && pe !== -1 ? B.current = a.current.length : (G.current = !1, B.current = ye) : B.current = Pt(a, {
        startingIndex: pe,
        decrement: !0,
        disabledIndices: E
      }) : B.current = Math.max(ue, Pt(a, {
        startingIndex: pe,
        decrement: !0,
        disabledIndices: E
      })), ir(a, B.current) && (B.current = -1), I(te);
    }
  }), re = f.useMemo(() => y && o && Z && {
    "aria-activedescendant": `${F}-${l}`
  }, [y, o, Z, F, l]), ie = f.useMemo(() => ({
    "aria-orientation": S === "both" ? void 0 : S,
    ...k ? {} : re,
    onKeyDown(te) {
      if (te.key === "Tab" && te.shiftKey && o && !y) {
        const pe = $t(te.nativeEvent);
        if (pe && !Ue(M.current, pe))
          return;
        At(te), n.setOpen(!1, ke(In, te.nativeEvent)), ut(s) && s.focus();
        return;
      }
      ne(te);
    },
    onPointerMove() {
      V.current = !0;
    }
  }), [re, ne, M, S, k, n, o, y, s]), de = f.useMemo(() => {
    function te(ue) {
      v === "auto" && fm(ue.nativeEvent) && (H.current = !y);
    }
    function pe(ue) {
      H.current = v, v === "auto" && pm(ue.nativeEvent) && (H.current = !0);
    }
    return {
      onKeyDown(ue) {
        const ye = n.select("open");
        V.current = !1;
        const ge = ue.key.startsWith("Arrow"), Te = PS(ue.key, X(), g), Se = Hs(ue.key, S), xe = (h ? Te : Se) || ue.key === "Enter" || ue.key.trim() === "";
        if (y && ye)
          return ne(ue);
        if (!(!ye && !w && ge)) {
          if (xe) {
            const je = Hs(ue.key, X());
            P.current = h && je ? null : ue.key;
          }
          if (h) {
            Te && (At(ue), ye ? (B.current = ui(a, se.current), I(ue)) : n.setOpen(!0, ke(ci, ue.nativeEvent, ue.currentTarget)));
            return;
          }
          Se && (W.current != null && (B.current = W.current), At(ue), !ye && w ? n.setOpen(!0, ke(ci, ue.nativeEvent, ue.currentTarget)) : ne(ue), ye && I(ue));
        }
      },
      onFocus(ue) {
        n.select("open") && !y && (B.current = -1, I(ue));
      },
      onPointerDown: pe,
      onPointerEnter: pe,
      onMouseDown: te,
      onClick: te
    };
  }, [ne, se, v, a, h, I, n, w, S, X, g, W, y]), le = f.useMemo(() => ({
    ...re,
    ...de
  }), [re, de]);
  return f.useMemo(() => u ? {
    reference: le,
    floating: ie,
    item: K,
    trigger: de
  } : {}, [u, le, ie, de, K]);
}
const DS = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function Qc(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingId"), s = n.useState("domReferenceElement"), i = n.useState("floatingElement"), {
    enabled: a = !0,
    role: l = "dialog"
  } = e, c = Lo(), u = s?.id || c, d = f.useMemo(() => ts(i)?.id || r, [i, r]), p = DS.get(l) ?? l, h = Pn() != null, g = f.useMemo(() => p === "tooltip" || l === "label" ? at : {
    "aria-haspopup": p === "alertdialog" ? "dialog" : p,
    "aria-expanded": "false",
    ...p === "listbox" && {
      role: "combobox"
    },
    ...p === "menu" && h && {
      role: "menuitem"
    },
    ...l === "select" && {
      "aria-autocomplete": "none"
    },
    ...l === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [p, h, l]), y = f.useMemo(() => p === "tooltip" || l === "label" ? {
    [`aria-${l === "label" ? "labelledby" : "describedby"}`]: o ? d : void 0
  } : {
    ...g,
    "aria-expanded": o ? "true" : "false",
    "aria-controls": o ? d : void 0,
    ...p === "menu" && {
      id: u
    }
  }, [p, d, o, u, l, g]), v = f.useMemo(() => {
    const w = {
      id: d,
      ...p && {
        role: p
      }
    };
    return p === "tooltip" || l === "label" ? w : {
      ...w,
      ...p === "menu" && {
        "aria-labelledby": u
      }
    };
  }, [p, d, u, l]), x = f.useCallback(({
    active: w,
    selected: E
  }) => {
    const S = {
      role: "option",
      ...w && {
        id: `${d}-fui-option`
      }
    };
    switch (l) {
      case "select":
      case "combobox":
        return {
          ...S,
          "aria-selected": E
        };
    }
    return {};
  }, [d, l]);
  return f.useMemo(() => a ? {
    reference: y,
    floating: v,
    item: x,
    trigger: g
  } : {}, [a, y, v, g, x]);
}
function Ah(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.context.dataRef, {
    listRef: s,
    activeIndex: i,
    onMatch: a,
    onTypingChange: l,
    enabled: c = !0,
    findMatch: u = null,
    resetMs: d = 750,
    ignoreKeys: p = zn,
    selectedIndex: m = null
  } = e, h = ft(), g = f.useRef(""), y = f.useRef(m ?? i ?? -1), v = f.useRef(null);
  he(() => {
    o && (h.clear(), v.current = null, g.current = "");
  }, [o, h]), he(() => {
    o && g.current === "" && (y.current = m ?? i ?? -1);
  }, [o, m, i]);
  const x = fe((C) => {
    C ? r.current.typing || (r.current.typing = C, l?.(C)) : r.current.typing && (r.current.typing = C, l?.(C));
  }), w = fe((C) => {
    function _(N, T, L) {
      const M = u ? u(T, L) : T.find((A) => A?.toLocaleLowerCase().indexOf(L.toLocaleLowerCase()) === 0);
      return M ? N.indexOf(M) : -1;
    }
    const R = s.current;
    if (g.current.length > 0 && g.current[0] !== " " && (_(R, R, g.current) === -1 ? x(!1) : C.key === " " && At(C)), R == null || p.includes(C.key) || // Character key.
    C.key.length !== 1 || // Modifier key.
    C.ctrlKey || C.metaKey || C.altKey)
      return;
    o && C.key !== " " && (At(C), x(!0)), R.every((N) => N ? N[0]?.toLocaleLowerCase() !== N[1]?.toLocaleLowerCase() : !0) && g.current === C.key && (g.current = "", y.current = v.current), g.current += C.key, h.start(d, () => {
      g.current = "", y.current = v.current, x(!1);
    });
    const j = y.current, F = _(R, [...R.slice((j || 0) + 1), ...R.slice(0, (j || 0) + 1)], g.current);
    F !== -1 ? (a?.(F), v.current = F) : C.key !== " " && (g.current = "", x(!1));
  }), E = f.useMemo(() => ({
    onKeyDown: w
  }), [w]), S = f.useMemo(() => ({
    onKeyDown: w,
    onKeyUp(C) {
      C.key === " " && x(!1);
    }
  }), [w, x]);
  return f.useMemo(() => c ? {
    reference: E,
    floating: S
  } : {}, [c, E, S]);
}
function wf(t, e) {
  const [n, o] = t;
  let r = !1;
  const s = e.length;
  for (let i = 0, a = s - 1; i < s; a = i++) {
    const [l, c] = e[i] || [0, 0], [u, d] = e[a] || [0, 0];
    c >= o != d >= o && n <= (u - l) * (o - c) / (d - c) + l && (r = !r);
  }
  return r;
}
function jS(t, e) {
  return t[0] >= e.x && t[0] <= e.x + e.width && t[1] >= e.y && t[1] <= e.y + e.height;
}
function ga(t = {}) {
  const {
    buffer: e = 0.5,
    blockPointerEvents: n = !1,
    requireIntent: o = !0
  } = t, r = new Un();
  let s = !1, i = null, a = null, l = typeof performance < "u" ? performance.now() : 0;
  function c(d, p) {
    const m = performance.now(), h = m - l;
    if (i === null || a === null || h === 0)
      return i = d, a = p, l = m, null;
    const g = d - i, y = p - a, x = Math.sqrt(g * g + y * y) / h;
    return i = d, a = p, l = m, x;
  }
  const u = ({
    x: d,
    y: p,
    placement: m,
    elements: h,
    onClose: g,
    nodeId: y,
    tree: v
  }) => function(w) {
    function E() {
      r.clear(), g();
    }
    if (r.clear(), !h.domReference || !h.floating || m == null || d == null || p == null)
      return;
    const {
      clientX: S,
      clientY: C
    } = w, _ = [S, C], R = $t(w), O = w.type === "mouseleave", j = Ue(h.floating, R), F = Ue(h.domReference, R), N = h.domReference.getBoundingClientRect(), T = h.floating.getBoundingClientRect(), L = m.split("-")[0], M = d > T.right - T.width / 2, A = p > T.bottom - T.height / 2, $ = jS(_, N), k = T.width > N.width, H = T.height > N.height, B = (k ? N : T).left, P = (k ? N : T).right, V = (H ? N : T).top, I = (H ? N : T).bottom;
    if (j && (s = !0, !O))
      return;
    if (F && (s = !1), F && !O) {
      s = !0;
      return;
    }
    if (O && Ze(w.relatedTarget) && Ue(h.floating, w.relatedTarget) || v && ko(v.nodesRef.current, y).some(({
      context: U
    }) => U?.open))
      return;
    if (L === "top" && p >= N.bottom - 1 || L === "bottom" && p <= N.top + 1 || L === "left" && d >= N.right - 1 || L === "right" && d <= N.left + 1)
      return E();
    let D = [];
    switch (L) {
      case "top":
        D = [[B, N.top + 1], [B, T.bottom - 1], [P, T.bottom - 1], [P, N.top + 1]];
        break;
      case "bottom":
        D = [[B, T.top + 1], [B, N.bottom - 1], [P, N.bottom - 1], [P, T.top + 1]];
        break;
      case "left":
        D = [[T.right - 1, I], [T.right - 1, V], [N.left + 1, V], [N.left + 1, I]];
        break;
      case "right":
        D = [[N.right - 1, I], [N.right - 1, V], [T.left + 1, V], [T.left + 1, I]];
        break;
    }
    function z([U, G]) {
      switch (L) {
        case "top": {
          const J = [k ? U + e / 2 : M ? U + e * 4 : U - e * 4, G + e + 1], se = [k ? U - e / 2 : M ? U + e * 4 : U - e * 4, G + e + 1], Q = [[T.left, M || k ? T.bottom - e : T.top], [T.right, M ? k ? T.bottom - e : T.top : T.bottom - e]];
          return [J, se, ...Q];
        }
        case "bottom": {
          const J = [k ? U + e / 2 : M ? U + e * 4 : U - e * 4, G - e], se = [k ? U - e / 2 : M ? U + e * 4 : U - e * 4, G - e], Q = [[T.left, M || k ? T.top + e : T.bottom], [T.right, M ? k ? T.top + e : T.bottom : T.top + e]];
          return [J, se, ...Q];
        }
        case "left": {
          const J = [U + e + 1, H ? G + e / 2 : A ? G + e * 4 : G - e * 4], se = [U + e + 1, H ? G - e / 2 : A ? G + e * 4 : G - e * 4];
          return [...[[A || H ? T.right - e : T.left, T.top], [A ? H ? T.right - e : T.left : T.right - e, T.bottom]], J, se];
        }
        case "right": {
          const J = [U - e, H ? G + e / 2 : A ? G + e * 4 : G - e * 4], se = [U - e, H ? G - e / 2 : A ? G + e * 4 : G - e * 4], Q = [[A || H ? T.left + e : T.right, T.top], [A ? H ? T.left + e : T.right : T.left + e, T.bottom]];
          return [J, se, ...Q];
        }
        default:
          return [];
      }
    }
    if (!wf([S, C], D)) {
      if (s && !$)
        return E();
      if (!O && o) {
        const U = c(w.clientX, w.clientY);
        if (U !== null && U < 0.1)
          return E();
      }
      wf([S, C], z([d, p])) ? !s && o && r.start(40, E) : E();
    }
  };
  return u.__options = {
    blockPointerEvents: n
  }, u;
}
function LS(t) {
  const e = f.useRef(""), n = f.useCallback((r) => {
    r.defaultPrevented || (e.current = r.pointerType, t(r, r.pointerType));
  }, [t]);
  return {
    onClick: f.useCallback((r) => {
      if (r.detail === 0) {
        t(r, "keyboard");
        return;
      }
      "pointerType" in r && t(r, r.pointerType), t(r, e.current), e.current = "";
    }, [t]),
    onPointerDown: n
  };
}
function ba(t) {
  const [e, n] = f.useState(null), o = fe((a, l) => {
    t || n(l || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
    // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
    // will be "" in that case.
    (im ? "touch" : ""));
  }), r = f.useCallback(() => {
    n(null);
  }, []), {
    onClick: s,
    onPointerDown: i
  } = LS(o);
  return f.useMemo(() => ({
    openMethod: e,
    reset: r,
    triggerProps: {
      onClick: s,
      onPointerDown: i
    }
  }), [e, r, s, i]);
}
function Dh(t) {
  const {
    store: e,
    parentContext: n,
    actionsRef: o
  } = t, r = e.useState("open"), s = e.useState("disablePointerDismissal"), i = e.useState("modal"), a = e.useState("popupElement"), {
    openMethod: l,
    triggerProps: c,
    reset: u
  } = ba(r);
  ca(e);
  const {
    forceUnmount: d
  } = ua(r, e, () => {
    u();
  }), p = fe((j) => {
    const F = ke(j);
    return F.preventUnmountOnClose = () => {
      e.set("preventUnmountingOnClose", !0);
    }, F;
  }), m = f.useCallback(() => {
    e.setOpen(!1, p(qi));
  }, [e, p]);
  f.useImperativeHandle(o, () => ({
    unmount: d,
    close: m
  }), [d, m]);
  const h = pa({
    popupStore: e,
    onOpenChange: e.setOpen,
    treatPopupAsFloatingElement: !0,
    noEmit: !0
  }), [g, y] = f.useState(0), v = g === 0, x = Qc(h), w = bs(h, {
    outsidePressEvent() {
      return e.context.internalBackdropRef.current || e.context.backdropRef.current ? "intentional" : {
        mouse: i === "trap-focus" ? "sloppy" : "intentional",
        touch: "sloppy"
      };
    },
    outsidePress(j) {
      if ("button" in j && j.button !== 0 || "touches" in j && j.touches.length !== 1)
        return !1;
      const F = $t(j);
      if (v && !s) {
        const N = F;
        return i && (e.context.internalBackdropRef.current || e.context.backdropRef.current) ? e.context.internalBackdropRef.current === N || e.context.backdropRef.current === N || Ue(N, a) && !N?.hasAttribute("data-base-ui-portal") : !0;
      }
      return !1;
    },
    escapeKey: v
  });
  sa(r && i === !0, a);
  const {
    getReferenceProps: E,
    getFloatingProps: S,
    getTriggerProps: C
  } = qn([x, w]);
  e.useContextCallback("onNestedDialogOpen", (j) => {
    y(j + 1);
  }), e.useContextCallback("onNestedDialogClose", () => {
    y(0);
  }), f.useEffect(() => (n?.onNestedDialogOpen && r && n.onNestedDialogOpen(g), n?.onNestedDialogClose && !r && n.onNestedDialogClose(), () => {
    n?.onNestedDialogClose && r && n.onNestedDialogClose();
  }), [r, n, g]);
  const _ = f.useMemo(() => E(c), [E, c]), R = f.useMemo(() => C(c), [C, c]), O = f.useMemo(() => S(), [S]);
  e.useSyncedValues({
    openMethod: l,
    activeTriggerProps: _,
    inactiveTriggerProps: R,
    popupProps: O,
    floatingRootContext: h,
    nestedOpenDialogCount: g
  });
}
const va = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (va.displayName = "DialogRootContext");
function Xn(t) {
  const e = f.useContext(va);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>." : We(27));
  return e;
}
const $S = {
  ...fa,
  modal: be((t) => t.modal),
  nested: be((t) => t.nested),
  nestedOpenDialogCount: be((t) => t.nestedOpenDialogCount),
  disablePointerDismissal: be((t) => t.disablePointerDismissal),
  openMethod: be((t) => t.openMethod),
  descriptionElementId: be((t) => t.descriptionElementId),
  titleElementId: be((t) => t.titleElementId),
  viewportElement: be((t) => t.viewportElement),
  role: be((t) => t.role)
};
class jh extends vs {
  constructor(n) {
    super(FS(n), {
      popupRef: /* @__PURE__ */ f.createRef(),
      backdropRef: /* @__PURE__ */ f.createRef(),
      internalBackdropRef: /* @__PURE__ */ f.createRef(),
      triggerElements: new _r(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0
    }, $S);
    Re(this, "setOpen", (n, o) => {
      if (o.preventUnmountOnClose = () => {
        this.set("preventUnmountingOnClose", !0);
      }, !n && o.trigger == null && this.state.activeTriggerId != null && (o.trigger = this.state.activeTriggerElement ?? void 0), this.context.onOpenChange?.(n, o), o.isCanceled)
        return;
      const r = {
        open: n,
        nativeEvent: o.event,
        reason: o.reason,
        nested: this.state.nested
      };
      this.state.floatingRootContext.context.events?.emit("openchange", r);
      const s = {
        open: n
      }, i = o.trigger?.id ?? null;
      (i || n) && (s.activeTriggerId = i, s.activeTriggerElement = o.trigger ?? null), this.update(s);
    });
  }
}
function FS(t = {}) {
  return {
    ...da(),
    modal: !0,
    disablePointerDismissal: !1,
    popupElement: null,
    viewportElement: null,
    descriptionElementId: void 0,
    titleElementId: void 0,
    openMethod: null,
    nested: !1,
    nestedOpenDialogCount: 0,
    role: "dialog",
    ...t
  };
}
function VS(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: s,
    actionsRef: i,
    handle: a,
    triggerId: l,
    defaultTriggerId: c = null
  } = t, u = Xn(), d = !!u, p = jt(() => a?.store ?? new jh({
    open: n ?? o,
    activeTriggerId: l !== void 0 ? l : c,
    modal: !0,
    disablePointerDismissal: !0,
    nested: d,
    role: "alertdialog"
  })).current;
  p.useControlledProp("open", n, o), p.useControlledProp("activeTriggerId", l, c), p.useSyncedValue("nested", d), p.useContextCallback("onOpenChange", r), p.useContextCallback("onOpenChangeComplete", s);
  const m = p.useState("payload");
  Dh({
    store: p,
    actionsRef: i,
    parentContext: u?.store.context
  });
  const h = f.useMemo(() => ({
    store: p
  }), [p]);
  return /* @__PURE__ */ b.jsx(va.Provider, {
    value: h,
    children: typeof e == "function" ? e({
      payload: m
    }) : e
  });
}
let Co = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = Io.startingStyle] = "startingStyle", t[t.endingStyle = Io.endingStyle] = "endingStyle", t.anchorHidden = "data-anchor-hidden", t;
})({}), Ql = /* @__PURE__ */ (function(t) {
  return t.popupOpen = "data-popup-open", t.pressed = "data-pressed", t;
})({});
const zS = {
  [Ql.popupOpen]: ""
}, BS = {
  [Ql.popupOpen]: "",
  [Ql.pressed]: ""
}, HS = {
  [Co.open]: ""
}, US = {
  [Co.closed]: ""
}, WS = {
  [Co.anchorHidden]: ""
}, ys = {
  open(t) {
    return t ? zS : null;
  }
}, Mi = {
  open(t) {
    return t ? BS : null;
  }
}, bn = {
  open(t) {
    return t ? HS : US;
  },
  anchorHidden(t) {
    return t ? WS : null;
  }
}, GS = {
  ...bn,
  ...tn
}, ya = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    forceRender: s = !1,
    ...i
  } = e, {
    store: a
  } = Xn(), l = a.useState("open"), c = a.useState("nested"), u = a.useState("mounted"), d = a.useState("transitionStatus"), p = f.useMemo(() => ({
    open: l,
    transitionStatus: d
  }), [l, d]);
  return _e("div", e, {
    state: p,
    ref: [a.context.backdropRef, n],
    stateAttributesMapping: GS,
    props: [{
      role: "presentation",
      hidden: !u,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, i],
    enabled: s || !c
  });
});
process.env.NODE_ENV !== "production" && (ya.displayName = "DialogBackdrop");
const Rr = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    ...a
  } = e, {
    store: l
  } = Xn(), c = l.useState("open");
  function u(h) {
    c && l.setOpen(!1, ke(Gp, h.nativeEvent));
  }
  const {
    getButtonProps: d,
    buttonRef: p
  } = Wt({
    disabled: s,
    native: i
  }), m = f.useMemo(() => ({
    disabled: s
  }), [s]);
  return _e("button", e, {
    state: m,
    ref: [n, p],
    props: [{
      onClick: u
    }, a, d]
  });
});
process.env.NODE_ENV !== "production" && (Rr.displayName = "DialogClose");
const xa = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    ...i
  } = e, {
    store: a
  } = Xn(), l = lt(s);
  return a.useSyncedValueWithCleanup("descriptionElementId", l), _e("p", e, {
    ref: n,
    props: [{
      id: l
    }, i]
  });
});
process.env.NODE_ENV !== "production" && (xa.displayName = "DialogDescription");
let KS = /* @__PURE__ */ (function(t) {
  return t.nestedDialogs = "--nested-dialogs", t;
})({}), YS = (function(t) {
  return t[t.open = Co.open] = "open", t[t.closed = Co.closed] = "closed", t[t.startingStyle = Co.startingStyle] = "startingStyle", t[t.endingStyle = Co.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const eu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (eu.displayName = "DialogPortalContext");
function qS() {
  const t = f.useContext(eu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Portal> is missing." : We(26));
  return t;
}
const XS = {
  ...bn,
  ...tn,
  nestedDialogOpen(t) {
    return t ? {
      [YS.nestedDialogOpen]: ""
    } : null;
  }
}, wa = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: s,
    render: i,
    ...a
  } = e, {
    store: l
  } = Xn(), c = l.useState("descriptionElementId"), u = l.useState("disablePointerDismissal"), d = l.useState("floatingRootContext"), p = l.useState("popupProps"), m = l.useState("modal"), h = l.useState("mounted"), g = l.useState("nested"), y = l.useState("nestedOpenDialogCount"), v = l.useState("open"), x = l.useState("openMethod"), w = l.useState("titleElementId"), E = l.useState("transitionStatus"), S = l.useState("role");
  qS(), Gt({
    open: v,
    ref: l.context.popupRef,
    onComplete() {
      v && l.context.onOpenChangeComplete?.(!0);
    }
  });
  function C(F) {
    return F === "touch" ? l.context.popupRef.current : !0;
  }
  const _ = s === void 0 ? C : s, R = y > 0, O = f.useMemo(() => ({
    open: v,
    nested: g,
    transitionStatus: E,
    nestedDialogOpen: R
  }), [v, g, E, R]), j = _e("div", e, {
    state: O,
    props: [p, {
      "aria-labelledby": w ?? void 0,
      "aria-describedby": c ?? void 0,
      role: S,
      tabIndex: -1,
      hidden: !h,
      onKeyDown(F) {
        ps.has(F.key) && F.stopPropagation();
      },
      style: {
        [KS.nestedDialogs]: y
      }
    }, a],
    ref: [n, l.context.popupRef, l.useStateSetter("popupElement")],
    stateAttributesMapping: XS
  });
  return /* @__PURE__ */ b.jsx(ia, {
    context: d,
    openInteractionType: x,
    disabled: !h,
    closeOnFocusOut: !u,
    initialFocus: _,
    returnFocus: r,
    modal: m !== !1,
    restoreFocus: "popup",
    children: j
  });
});
process.env.NODE_ENV !== "production" && (wa.displayName = "DialogPopup");
function Sa(t) {
  return wc(19) ? t : t ? "true" : void 0;
}
const xs = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    cutout: o,
    ...r
  } = e;
  let s;
  if (o) {
    const i = o?.getBoundingClientRect();
    s = `polygon(
      0% 0%,
      100% 0%,
      100% 100%,
      0% 100%,
      0% 0%,
      ${i.left}px ${i.top}px,
      ${i.left}px ${i.bottom}px,
      ${i.right}px ${i.bottom}px,
      ${i.right}px ${i.top}px,
      ${i.left}px ${i.top}px
    )`;
  }
  return /* @__PURE__ */ b.jsx("div", {
    ref: n,
    role: "presentation",
    "data-base-ui-inert": "",
    ...r,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: s
    }
  });
});
process.env.NODE_ENV !== "production" && (xs.displayName = "InternalBackdrop");
const Ea = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: s
  } = Xn(), i = s.useState("mounted"), a = s.useState("modal"), l = s.useState("open");
  return i || o ? /* @__PURE__ */ b.jsx(eu.Provider, {
    value: o,
    children: /* @__PURE__ */ b.jsxs(hs, {
      ref: n,
      ...r,
      children: [i && a === !0 && /* @__PURE__ */ b.jsx(xs, {
        ref: s.context.internalBackdropRef,
        inert: Sa(!l)
      }), e.children]
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Ea.displayName = "DialogPortal");
const Ca = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    ...i
  } = e, {
    store: a
  } = Xn(), l = lt(s);
  return a.useSyncedValueWithCleanup("titleElementId", l), _e("h2", e, {
    ref: n,
    props: [{
      id: l
    }, i]
  });
});
process.env.NODE_ENV !== "production" && (Ca.displayName = "DialogTitle");
const _a = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    id: a,
    payload: l,
    handle: c,
    ...u
  } = e, d = Xn(!0), p = c?.store ?? d?.store;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Trigger> must be used within <Dialog.Root> or provided with a handle." : We(79));
  const m = lt(a), h = p.useState("floatingRootContext"), g = p.useState("isOpenedByTrigger", m), y = f.useRef(null), {
    registerTrigger: v,
    isMountedByThisTrigger: x
  } = la(m, y, p, {
    payload: l
  }), {
    getButtonProps: w,
    buttonRef: E
  } = Wt({
    disabled: s,
    native: i
  }), S = gs(h, {
    enabled: h != null
  }), C = qn([S]), _ = f.useMemo(() => ({
    disabled: s,
    open: g
  }), [s, g]), R = p.useState("triggerProps", x);
  return _e("button", e, {
    state: _,
    ref: [E, n, v, y],
    props: [C.getReferenceProps(), R, {
      [Sc]: "",
      id: m
    }, u, w],
    stateAttributesMapping: ys
  });
});
process.env.NODE_ENV !== "production" && (_a.displayName = "DialogTrigger");
const ZS = "_overlay_11kks_9", JS = {
  overlay: ZS
}, Lh = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    focusableWhenDisabled: i = !1,
    nativeButton: a = !0,
    ...l
  } = e, {
    getButtonProps: c,
    buttonRef: u
  } = Wt({
    disabled: s,
    focusableWhenDisabled: i,
    native: a
  }), d = f.useMemo(() => ({
    disabled: s
  }), [s]);
  return _e("button", e, {
    state: d,
    ref: [n, u],
    props: [l, c]
  });
});
process.env.NODE_ENV !== "production" && (Lh.displayName = "Button");
const QS = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 1 1-6.219-8.56"/>'
}, tu = QS, eE = "_button_10j2g_2", tE = "_content_10j2g_46", nE = "_loading_10j2g_56", oE = "_verified_10j2g_62", rE = "_spinner_10j2g_67", sE = "_denied_10j2g_86", iE = "_deniedBadge_10j2g_91", aE = "_deniedIcon_10j2g_106", lE = "_deniedX_10j2g_112", cE = "_check_10j2g_90", uE = "_checkIcon_10j2g_141", dE = "_srOnly_10j2g_158", fE = "_rippleContainer_10j2g_19", pE = "_ripple_10j2g_19", mE = "_destructive_10j2g_201", hE = "_ghost_10j2g_255", gE = "_link_10j2g_282", bE = "_outline_10j2g_309", vE = "_primary_10j2g_336", yE = "_secondary_10j2g_363", xE = "_tertiary_10j2g_390", wE = "_lg_10j2g_488", SE = "_sm_10j2g_493", EE = "_xs_10j2g_498", CE = "_icon_10j2g_503", _E = "_iconLg_10j2g_513", RE = "_iconSm_10j2g_523", NE = "_iconXs_10j2g_533", ot = {
  button: eE,
  content: tE,
  loading: nE,
  verified: oE,
  spinner: rE,
  denied: sE,
  deniedBadge: iE,
  deniedIcon: aE,
  deniedX: lE,
  check: cE,
  checkIcon: uE,
  srOnly: dE,
  rippleContainer: fE,
  ripple: pE,
  destructive: mE,
  "destructive-outline": "_destructive-outline_10j2g_228",
  ghost: hE,
  link: gE,
  outline: bE,
  primary: vE,
  secondary: yE,
  tertiary: xE,
  default: "_default_10j2g_483",
  lg: wE,
  sm: SE,
  xs: EE,
  icon: CE,
  iconLg: _E,
  iconSm: RE,
  iconXs: NE
}, kE = /* @__PURE__ */ new Set(["icon", "icon-lg", "icon-sm", "icon-xs"]), TE = {
  destructive: ot.destructive,
  "destructive-outline": ot["destructive-outline"],
  ghost: ot.ghost,
  link: ot.link,
  outline: ot.outline,
  primary: ot.primary,
  secondary: ot.secondary,
  tertiary: ot.tertiary
}, IE = {
  default: ot.default,
  icon: ot.icon,
  "icon-lg": ot.iconLg,
  "icon-sm": ot.iconSm,
  "icon-xs": ot.iconXs,
  lg: ot.lg,
  sm: ot.sm,
  xs: ot.xs
}, kt = (t) => {
  const e = ee.c(63);
  let n, o, r, s, i, a, l, c, u, d, p, m, h;
  e[0] !== t ? ({
    children: n,
    className: o,
    denied: l,
    deniedLabel: c,
    loading: u,
    onClick: r,
    onPointerDown: s,
    ripple: a,
    size: d,
    variant: p,
    verified: m,
    verifiedLabel: h,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = p, e[12] = m, e[13] = h) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], p = e[11], m = e[12], h = e[13]);
  const g = l === void 0 ? !1 : l, y = c === void 0 ? "Failed" : c, v = u === void 0 ? !1 : u, x = d === void 0 ? "default" : d, w = p === void 0 ? "primary" : p, E = m === void 0 ? !1 : m, S = h === void 0 ? "Verified" : h;
  let C;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = [], e[14] = C) : C = e[14];
  const [_, R] = f.useState(C), O = v || g || E;
  let j;
  e[15] !== a || e[16] !== x || e[17] !== w ? (j = a ?? (!kE.has(x) && w !== "ghost" && w !== "link" && w !== "outline"), e[15] = a, e[16] = x, e[17] = w, e[18] = j) : j = e[18];
  const F = j;
  let N;
  e[19] !== O || e[20] !== r ? (N = (oe) => {
    if (O) {
      oe.preventDefault();
      return;
    }
    r?.(oe);
  }, e[19] = O, e[20] = r, e[21] = N) : N = e[21];
  const T = N;
  let L;
  e[22] !== F || e[23] !== O || e[24] !== s ? (L = (oe) => {
    if (O)
      return;
    if (!F) {
      s?.(oe);
      return;
    }
    const Y = oe.currentTarget.getBoundingClientRect(), Z = Math.max(Y.width, Y.height) * 2, K = oe.clientX - Y.left - Z / 2, X = oe.clientY - Y.top - Z / 2, ne = Date.now() + Math.random();
    R((re) => [...re, {
      id: ne,
      size: Z,
      x: K,
      y: X
    }]), s?.(oe);
  }, e[22] = F, e[23] = O, e[24] = s, e[25] = L) : L = e[25];
  const M = L;
  let A;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (A = (oe) => {
    R((Y) => Y.filter((Z) => Z.id !== oe));
  }, e[26] = A) : A = e[26];
  const $ = A, k = v && !g && !E ? !0 : void 0, H = TE[w], B = IE[x], P = v && ot.loading, V = g && ot.denied, I = E && ot.verified;
  let D;
  e[27] !== o || e[28] !== H || e[29] !== B || e[30] !== P || e[31] !== V || e[32] !== I ? (D = ae(ot.button, H, B, P, V, I, o), e[27] = o, e[28] = H, e[29] = B, e[30] = P, e[31] = V, e[32] = I, e[33] = D) : D = e[33];
  let z;
  e[34] !== n ? (z = /* @__PURE__ */ b.jsx("span", { className: ot.content, children: n }), e[34] = n, e[35] = z) : z = e[35];
  let U;
  e[36] !== E ? (U = !E && /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", className: ot.spinner, children: /* @__PURE__ */ b.jsx(Ve, { icon: tu }) }), e[36] = E, e[37] = U) : U = e[37];
  let G;
  e[38] !== E ? (G = !E && /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", className: ot.deniedBadge, children: /* @__PURE__ */ b.jsx("svg", { className: ot.deniedIcon, fill: "none", viewBox: "0 0 24 24", children: /* @__PURE__ */ b.jsx("path", { className: ot.deniedX, d: "M7 7l10 10M17 7L7 17", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2.5 }) }) }), e[38] = E, e[39] = G) : G = e[39];
  let J;
  e[40] !== g || e[41] !== y || e[42] !== E ? (J = g && !E && /* @__PURE__ */ b.jsx("span", { className: ot.srOnly, role: "status", children: y }), e[40] = g, e[41] = y, e[42] = E, e[43] = J) : J = e[43];
  let se;
  e[44] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (se = /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", className: ot.check, children: /* @__PURE__ */ b.jsx("svg", { className: ot.checkIcon, fill: "none", viewBox: "0 0 24 24", children: /* @__PURE__ */ b.jsx("path", { d: "M5 13l4 4L19 7", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2.5 }) }) }), e[44] = se) : se = e[44];
  let Q;
  e[45] !== E || e[46] !== S ? (Q = E && /* @__PURE__ */ b.jsx("span", { className: ot.srOnly, role: "status", children: S }), e[45] = E, e[46] = S, e[47] = Q) : Q = e[47];
  let ce;
  e[48] !== F || e[49] !== _ ? (ce = F && /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", className: ot.rippleContainer, children: _.map((oe) => /* @__PURE__ */ b.jsx("span", { className: ot.ripple, onAnimationEnd: () => $(oe.id), style: {
    height: oe.size,
    left: oe.x,
    top: oe.y,
    width: oe.size
  } }, oe.id)) }), e[48] = F, e[49] = _, e[50] = ce) : ce = e[50];
  let W;
  return e[51] !== T || e[52] !== M || e[53] !== i || e[54] !== k || e[55] !== D || e[56] !== z || e[57] !== U || e[58] !== G || e[59] !== J || e[60] !== Q || e[61] !== ce ? (W = /* @__PURE__ */ b.jsxs(Lh, { "aria-busy": k, className: D, "data-slot": "button", onClick: T, onPointerDown: M, ...i, children: [
    z,
    U,
    G,
    J,
    se,
    Q,
    ce
  ] }), e[51] = T, e[52] = M, e[53] = i, e[54] = k, e[55] = D, e[56] = z, e[57] = U, e[58] = G, e[59] = J, e[60] = Q, e[61] = ce, e[62] = W) : W = e[62], W;
}, $D = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(VS, { "data-slot": "alert-dialog", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, FD = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(_a, { "data-slot": "alert-dialog-trigger", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, OE = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(Ea, { "data-slot": "alert-dialog-portal", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, ME = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    forceRender: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? !0 : r;
  let i;
  e[4] !== n ? (i = ae("data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 duration-100 fixed inset-0 isolate z-50", JS.overlay, n), e[4] = n, e[5] = i) : i = e[5];
  let a;
  return e[6] !== s || e[7] !== o || e[8] !== i ? (a = /* @__PURE__ */ b.jsx(ya, { "data-slot": "alert-dialog-overlay", forceRender: s, className: i, ...o }), e[6] = s, e[7] = o, e[8] = i, e[9] = a) : a = e[9], a;
}, VD = (t) => {
  const e = ee.c(11);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    size: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "default" : r;
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ b.jsx(ME, {}), e[4] = i) : i = e[4];
  let a;
  e[5] !== n ? (a = ae("data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 data-closed:zoom-out-95 data-open:zoom-in-95 bg-canvas ring-action-primary/10 gap-4 rounded-xl p-4 ring-1 duration-100 data-[size=default]:max-w-xs data-[size=sm]:max-w-xs data-[size=default]:sm:max-w-sm group/alert-dialog-content fixed top-1/2 left-1/2 z-50 grid w-full -translate-x-1/2 -translate-y-1/2 outline-none", n), e[5] = n, e[6] = a) : a = e[6];
  let l;
  return e[7] !== o || e[8] !== s || e[9] !== a ? (l = /* @__PURE__ */ b.jsxs(OE, { children: [
    i,
    /* @__PURE__ */ b.jsx(wa, { "data-slot": "alert-dialog-content", "data-size": s, className: a, ...o })
  ] }), e[7] = o, e[8] = s, e[9] = a, e[10] = l) : l = e[10], l;
}, zD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("grid grid-rows-[auto_1fr] place-items-center gap-1.5 text-center has-data-[slot=alert-dialog-media]:grid-rows-[auto_auto_1fr] has-data-[slot=alert-dialog-media]:gap-x-4 sm:group-data-[size=default]/alert-dialog-content:place-items-start sm:group-data-[size=default]/alert-dialog-content:text-left sm:group-data-[size=default]/alert-dialog-content:has-data-[slot=alert-dialog-media]:grid-rows-[auto_1fr]", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "alert-dialog-header", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, BD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("bg-sunken/50 -mx-4 -mb-4 rounded-b-xl border-t p-4 flex flex-col-reverse gap-2 group-data-[size=sm]/alert-dialog-content:grid group-data-[size=sm]/alert-dialog-content:grid-cols-2 sm:flex-row sm:justify-end", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "alert-dialog-footer", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, HD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("bg-sunken mb-2 inline-flex size-10 items-center justify-center rounded-md sm:group-data-[size=default]/alert-dialog-content:row-span-2 *:[svg:not([class*='size-'])]:size-6", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "alert-dialog-media", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, UD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("text-sm font-medium sm:group-data-[size=default]/alert-dialog-content:group-has-data-[slot=alert-dialog-media]/alert-dialog-content:col-start-2", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(Ca, { "data-slot": "alert-dialog-title", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, WD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("text-muted *:[a]:hover:text-primary text-sm text-balance md:text-pretty *:[a]:underline *:[a]:underline-offset-3", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(xa, { "data-slot": "alert-dialog-description", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, GD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae(n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(kt, { "data-slot": "alert-dialog-action", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, KD = (t) => {
  const e = ee.c(14);
  let n, o, r, s;
  e[0] !== t ? ({
    className: n,
    variant: r,
    size: s,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = r === void 0 ? "outline" : r, a = s === void 0 ? "default" : s;
  let l;
  e[5] !== n ? (l = ae(n), e[5] = n, e[6] = l) : l = e[6];
  let c;
  e[7] !== a || e[8] !== i ? (c = /* @__PURE__ */ b.jsx(kt, { variant: i, size: a }), e[7] = a, e[8] = i, e[9] = c) : c = e[9];
  let u;
  return e[10] !== o || e[11] !== l || e[12] !== c ? (u = /* @__PURE__ */ b.jsx(Rr, { "data-slot": "alert-dialog-cancel", className: l, render: c, ...o }), e[10] = o, e[11] = l, e[12] = c, e[13] = u) : u = e[13], u;
}, nu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (nu.displayName = "AvatarRootContext");
function $h() {
  const t = f.useContext(nu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: AvatarRootContext is missing. Avatar parts must be placed within <Avatar.Root>." : We(13));
  return t;
}
const ou = {
  imageLoadingStatus: () => null
}, Fh = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    ...s
  } = e, [i, a] = f.useState("idle"), l = f.useMemo(() => ({
    imageLoadingStatus: i
  }), [i]), c = f.useMemo(() => ({
    imageLoadingStatus: i,
    setImageLoadingStatus: a
  }), [i, a]), u = _e("span", e, {
    state: l,
    ref: n,
    props: s,
    stateAttributesMapping: ou
  });
  return /* @__PURE__ */ b.jsx(nu.Provider, {
    value: c,
    children: u
  });
});
process.env.NODE_ENV !== "production" && (Fh.displayName = "AvatarRoot");
function PE(t, {
  referrerPolicy: e,
  crossOrigin: n
}) {
  const [o, r] = f.useState("idle");
  return he(() => {
    if (!t)
      return r("error"), xt;
    let s = !0;
    const i = new window.Image(), a = (l) => () => {
      s && r(l);
    };
    return r("loading"), i.onload = a("loaded"), i.onerror = a("error"), e && (i.referrerPolicy = e), i.crossOrigin = n ?? null, i.src = t, () => {
      s = !1;
    };
  }, [t, n, e]), o;
}
const Vh = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    onLoadingStatusChange: s,
    referrerPolicy: i,
    crossOrigin: a,
    ...l
  } = e, c = $h(), u = PE(e.src, {
    referrerPolicy: i,
    crossOrigin: a
  }), d = fe((h) => {
    s?.(h), c.setImageLoadingStatus(h);
  });
  he(() => {
    u !== "idle" && d(u);
  }, [u, d]);
  const p = f.useMemo(() => ({
    imageLoadingStatus: u
  }), [u]);
  return _e("img", e, {
    state: p,
    ref: n,
    props: l,
    stateAttributesMapping: ou,
    enabled: u === "loaded"
  });
});
process.env.NODE_ENV !== "production" && (Vh.displayName = "AvatarImage");
const zh = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    delay: s,
    ...i
  } = e, {
    imageLoadingStatus: a
  } = $h(), [l, c] = f.useState(s === void 0), u = ft();
  f.useEffect(() => (s !== void 0 && u.start(s, () => c(!0)), u.clear), [u, s]);
  const d = f.useMemo(() => ({
    imageLoadingStatus: a
  }), [a]);
  return _e("span", e, {
    state: d,
    ref: n,
    props: i,
    stateAttributesMapping: ou,
    enabled: a !== "loaded" && l
  });
});
process.env.NODE_ENV !== "production" && (zh.displayName = "AvatarFallback");
const YD = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    size: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "default" : r;
  let i;
  e[4] !== n ? (i = ae("size-8 rounded-full after:rounded-full data-[size=lg]:size-10 data-[size=sm]:size-6 after:border-default group/avatar relative flex shrink-0 select-none after:absolute after:inset-0 after:border after:mix-blend-darken dark:after:mix-blend-lighten", n), e[4] = n, e[5] = i) : i = e[5];
  let a;
  return e[6] !== o || e[7] !== s || e[8] !== i ? (a = /* @__PURE__ */ b.jsx(Fh, { "data-slot": "avatar", "data-size": s, className: i, ...o }), e[6] = o, e[7] = s, e[8] = i, e[9] = a) : a = e[9], a;
}, qD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("rounded-full aspect-square size-full object-cover", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(Vh, { "data-slot": "avatar-image", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, XD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("bg-sunken text-muted rounded-full flex size-full items-center justify-center text-sm group-data-[size=sm]/avatar:text-xs", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(zh, { "data-slot": "avatar-fallback", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, ZD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("bg-action-primary text-on-primary ring-background absolute right-0 bottom-0 z-10 inline-flex items-center justify-center rounded-full bg-blend-color ring-2 select-none", "group-data-[size=sm]/avatar:size-2 group-data-[size=sm]/avatar:[&>svg]:hidden", "group-data-[size=default]/avatar:size-2.5 group-data-[size=default]/avatar:[&>svg]:size-2", "group-data-[size=lg]/avatar:size-3 group-data-[size=lg]/avatar:[&>svg]:size-2", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("span", { "data-slot": "avatar-badge", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, JD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("*:data-[slot=avatar]:ring-background group/avatar-group flex -space-x-2 *:data-[slot=avatar]:ring-2", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "avatar-group", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, QD = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("bg-sunken text-muted size-8 rounded-full text-sm group-has-data-[size=lg]/avatar-group:size-10 group-has-data-[size=sm]/avatar-group:size-6 [&>svg]:size-4 group-has-data-[size=lg]/avatar-group:[&>svg]:size-5 group-has-data-[size=sm]/avatar-group:[&>svg]:size-3 ring-background relative flex shrink-0 items-center justify-center ring-2", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "avatar-group-count", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
};
function Bh(t) {
  return _e(t.defaultTagName ?? "div", t, t);
}
const AE = ra("h-5 gap-1 rounded-4xl border border-transparent px-2 py-0.5 text-xs font-medium transition-all has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&>svg]:size-3! inline-flex items-center justify-center w-fit whitespace-nowrap shrink-0 [&>svg]:pointer-events-none focus-visible:border-ring-focus focus-visible:ring-ring-focus/50 focus-visible:ring-[3px] aria-invalid:ring-feedback-danger/20 dark:aria-invalid:ring-feedback-danger/40 aria-invalid:border-feedback-danger transition-colors overflow-hidden group/badge", {
  defaultVariants: {
    variant: "default"
  },
  variants: {
    variant: {
      default: "bg-action-primary text-on-primary [a]:hover:bg-action-primary/80",
      destructive: "bg-feedback-danger/10 [a]:hover:bg-feedback-danger/20 focus-visible:ring-feedback-danger/20 dark:focus-visible:ring-feedback-danger/40 text-feedback-danger dark:bg-feedback-danger/20",
      ghost: "hover:bg-sunken hover:text-muted dark:hover:bg-sunken/50",
      link: "text-link underline-offset-4 hover:underline",
      outline: "border-default text-primary [a]:hover:bg-sunken [a]:hover:text-muted",
      secondary: "bg-action-secondary text-on-secondary [a]:hover:bg-action-secondary/80"
    }
  }
}), ej = (t) => {
  const e = ee.c(13);
  let n, o, r, s, i;
  if (e[0] !== t) {
    const {
      className: c,
      variant: u,
      render: d,
      ...p
    } = t;
    n = d, i = u === void 0 ? "default" : u, s = Bh, o = "span", r = Qt({
      className: ae(AE({
        className: c,
        variant: i
      }))
    }, p), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i;
  } else
    n = e[1], o = e[2], r = e[3], s = e[4], i = e[5];
  let a;
  e[6] !== i ? (a = {
    slot: "badge",
    variant: i
  }, e[6] = i, e[7] = a) : a = e[7];
  let l;
  return e[8] !== n || e[9] !== o || e[10] !== r || e[11] !== a ? (l = {
    defaultTagName: o,
    props: r,
    render: n,
    state: a
  }, e[8] = n, e[9] = o, e[10] = r, e[11] = a, e[12] = l) : l = e[12], s(l);
}, DE = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 18l6-6l-6-6"/>'
}, Ra = DE, jE = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></g>'
}, LE = jE, tj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae(n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("nav", { "aria-label": "breadcrumb", "data-slot": "breadcrumb", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, nj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("text-muted gap-1.5 text-sm flex flex-wrap items-center break-words", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("ol", { "data-slot": "breadcrumb-list", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, oj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("gap-1 inline-flex items-center", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("li", { "data-slot": "breadcrumb-item", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, rj = (t) => {
  const e = ee.c(10);
  let n, o, r, s;
  if (e[0] !== t) {
    const {
      className: l,
      render: c,
      ...u
    } = t;
    n = c, s = Bh, o = "a", r = Qt({
      className: ae("hover:text-primary transition-colors", l)
    }, u), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s;
  } else
    n = e[1], o = e[2], r = e[3], s = e[4];
  let i;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = {
    slot: "breadcrumb-link"
  }, e[5] = i) : i = e[5];
  let a;
  return e[6] !== n || e[7] !== o || e[8] !== r ? (a = {
    defaultTagName: o,
    props: r,
    render: n,
    state: i
  }, e[6] = n, e[7] = o, e[8] = r, e[9] = a) : a = e[9], s(a);
}, sj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("text-primary font-normal", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("span", { "data-slot": "breadcrumb-page", role: "link", "aria-disabled": "true", "aria-current": "page", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, ij = (t) => {
  const e = ee.c(12);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    className: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] !== o ? (s = ae("[&>svg]:size-3.5", o), e[4] = o, e[5] = s) : s = e[5];
  let i;
  e[6] !== n ? (i = n ?? /* @__PURE__ */ b.jsx(Ve, { icon: Ra }), e[6] = n, e[7] = i) : i = e[7];
  let a;
  return e[8] !== r || e[9] !== s || e[10] !== i ? (a = /* @__PURE__ */ b.jsx("li", { "data-slot": "breadcrumb-separator", role: "presentation", "aria-hidden": "true", className: s, ...r, children: i }), e[8] = r, e[9] = s, e[10] = i, e[11] = a) : a = e[11], a;
}, aj = (t) => {
  const e = ee.c(10);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("size-5 [&>svg]:size-4 flex items-center justify-center", n), e[3] = n, e[4] = r) : r = e[4];
  let s, i;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b.jsx(Ve, { icon: LE }), i = /* @__PURE__ */ b.jsx("span", { className: "sr-only", children: "More" }), e[5] = s, e[6] = i) : (s = e[5], i = e[6]);
  let a;
  return e[7] !== o || e[8] !== r ? (a = /* @__PURE__ */ b.jsxs("span", { "data-slot": "breadcrumb-ellipsis", role: "presentation", "aria-hidden": "true", className: r, ...o, children: [
    s,
    i
  ] }), e[7] = o, e[8] = r, e[9] = a) : a = e[9], a;
}, lj = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    size: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "default" : r;
  let i;
  e[4] !== n ? (i = ae("ring-action-primary/10 bg-default text-primary gap-4 overflow-hidden rounded-xl py-4 text-sm ring-1 has-data-[slot=card-footer]:pb-0 has-[>img:first-child]:pt-0 data-[size=sm]:gap-3 data-[size=sm]:py-3 data-[size=sm]:has-data-[slot=card-footer]:pb-0 *:[img:first-child]:rounded-t-xl *:[img:last-child]:rounded-b-xl group/card flex flex-col", n), e[4] = n, e[5] = i) : i = e[5];
  let a;
  return e[6] !== o || e[7] !== s || e[8] !== i ? (a = /* @__PURE__ */ b.jsx("div", { "data-slot": "card", "data-size": s, className: i, ...o }), e[6] = o, e[7] = s, e[8] = i, e[9] = a) : a = e[9], a;
}, cj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("gap-1 rounded-t-xl px-4 group-data-[size=sm]/card:px-3 [.border-b]:pb-4 group-data-[size=sm]/card:[.border-b]:pb-3 group/card-header @container/card-header grid auto-rows-min items-start has-data-[slot=card-action]:grid-cols-[1fr_auto] has-data-[slot=card-description]:grid-rows-[auto_auto]", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "card-header", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, uj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("text-base leading-snug font-medium group-data-[size=sm]/card:text-sm", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "card-title", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, dj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("text-muted text-sm", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "card-description", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, fj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("col-start-2 row-span-2 row-start-1 self-start justify-self-end", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "card-action", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, pj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("px-4 group-data-[size=sm]/card:px-3", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "card-content", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, mj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("bg-sunken/50 rounded-b-xl border-t p-4 group-data-[size=sm]/card:p-3 flex items-center", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "card-footer", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
};
let Sf = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.indeterminate = "data-indeterminate", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({}), Ef = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const $E = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, zo = {
  valid(t) {
    return t === null ? null : t ? {
      [Ef.valid]: ""
    } : {
      [Ef.invalid]: ""
    };
  }
};
function Hh(t) {
  return f.useMemo(() => ({
    checked(e) {
      return t.indeterminate ? {} : e ? {
        [Sf.checked]: ""
      } : {
        [Sf.unchecked]: ""
      };
    },
    ...zo
  }), [t.indeterminate]);
}
const Uh = /* @__PURE__ */ f.createContext({
  invalid: void 0,
  name: void 0,
  validityData: {
    state: $E,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: xt,
  disabled: void 0,
  touched: !1,
  setTouched: xt,
  dirty: !1,
  setDirty: xt,
  filled: !1,
  setFilled: xt,
  focused: !1,
  setFocused: xt,
  validate: () => null,
  validationMode: "onSubmit",
  validationDebounceTime: 0,
  shouldValidateOnChange: () => !1,
  state: {
    disabled: !1,
    valid: null,
    touched: !1,
    dirty: !1,
    filled: !1,
    focused: !1
  },
  markedDirtyRef: {
    current: !1
  },
  validation: {
    getValidationProps: (t = at) => t,
    getInputValidationProps: (t = at) => t,
    inputRef: {
      current: null
    },
    commit: async () => {
    }
  }
});
process.env.NODE_ENV !== "production" && (Uh.displayName = "FieldRootContext");
function dn(t = !0) {
  const e = f.useContext(Uh);
  if (e.setValidityData === xt && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : We(28));
  return e;
}
const Wh = /* @__PURE__ */ f.createContext({
  disabled: !1
});
process.env.NODE_ENV !== "production" && (Wh.displayName = "FieldItemContext");
function Gh() {
  return f.useContext(Wh);
}
function FE(t, e) {
  return {
    ...t,
    state: {
      ...t.state,
      valid: !e && t.state.valid
    }
  };
}
const Kh = /* @__PURE__ */ f.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: xt,
  validationMode: "onSubmit",
  submitAttemptedRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (Kh.displayName = "FormContext");
function Nr() {
  return f.useContext(Kh);
}
function kr(t) {
  const {
    enabled: e = !0,
    value: n,
    id: o,
    name: r,
    controlRef: s,
    commit: i
  } = t, {
    formRef: a
  } = Nr(), {
    invalid: l,
    markedDirtyRef: c,
    validityData: u,
    setValidityData: d
  } = dn(), p = fe(t.getValue);
  he(() => {
    if (!e)
      return;
    let m = n;
    m === void 0 && (m = p()), u.initialValue === null && m !== null && d((h) => ({
      ...h,
      initialValue: m
    }));
  }, [e, d, n, u.initialValue, p]), he(() => {
    !e || !o || a.current.fields.set(o, {
      getValue: p,
      name: r,
      controlRef: s,
      validityData: FE(u, l),
      validate(m = !0) {
        let h = n;
        h === void 0 && (h = p()), c.current = !0, m ? Vt.flushSync(() => i(h)) : i(h);
      }
    });
  }, [i, s, e, a, p, o, l, c, r, u, n]), he(() => {
    const m = a.current.fields;
    return () => {
      o && m.delete(o);
    };
  }, [a, o]);
}
const Yh = /* @__PURE__ */ f.createContext({
  controlId: void 0,
  setControlId: xt,
  labelId: void 0,
  setLabelId: xt,
  messageIds: [],
  setMessageIds: xt,
  getDescriptionProps: (t) => t
});
process.env.NODE_ENV !== "production" && (Yh.displayName = "LabelableContext");
function yo() {
  return f.useContext(Yh);
}
const qh = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (qh.displayName = "CheckboxGroupContext");
function VE(t = !0) {
  const e = f.useContext(qh);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CheckboxGroupContext is missing. CheckboxGroup parts must be placed within <CheckboxGroup>." : We(3));
  return e;
}
const ru = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (ru.displayName = "CheckboxRootContext");
function zE() {
  const t = f.useContext(ru);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CheckboxRootContext is missing. Checkbox parts must be placed within <Checkbox.Root>." : We(14));
  return t;
}
function ws(t, e) {
  const n = f.useRef(t), o = fe(e);
  he(() => {
    n.current !== t && o(n.current);
  }, [t, o]), he(() => {
    n.current = t;
  }, [t]);
}
const BE = "data-parent", Xh = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: s = !1,
    disabled: i = !1,
    id: a,
    indeterminate: l = !1,
    inputRef: c,
    name: u,
    onCheckedChange: d,
    parent: p = !1,
    readOnly: m = !1,
    render: h,
    required: g = !1,
    uncheckedValue: y,
    value: v,
    nativeButton: x = !1,
    ...w
  } = e, {
    clearErrors: E
  } = Nr(), {
    disabled: S,
    name: C,
    setDirty: _,
    setFilled: R,
    setFocused: O,
    setTouched: j,
    state: F,
    validationMode: N,
    validityData: T,
    shouldValidateOnChange: L,
    validation: M
  } = dn(), A = Gh(), {
    labelId: $,
    controlId: k,
    setControlId: H,
    getDescriptionProps: B
  } = yo(), P = VE(), V = P?.parent, I = V && P.allValues, D = S || A.disabled || P?.disabled || i, z = C ?? u, U = v ?? z, G = lt(), J = lt();
  let se = k;
  I ? se = p ? J : `${V.id}-${U}` : a && (se = a);
  let Q = {};
  I && (p ? Q = P.parent.getParentProps() : U && (Q = P.parent.getChildProps(U)));
  const ce = fe(d), {
    checked: W = o,
    indeterminate: oe = l,
    onCheckedChange: Y,
    ...Z
  } = Q, K = P?.value, X = P?.setValue, ne = P?.defaultValue, re = f.useRef(null), {
    getButtonProps: ie,
    buttonRef: de
  } = Wt({
    disabled: D,
    native: x
  }), le = P?.validation ?? M, [te, pe] = un({
    controlled: U && K && !p ? K.includes(U) : W,
    default: U && ne && !p ? ne.includes(U) : s,
    name: "Checkbox",
    state: "checked"
  });
  he(() => {
    if (H !== xt)
      return H(se), () => {
        H(void 0);
      };
  }, [se, P, H, p]), kr({
    enabled: !P,
    id: G,
    commit: le.commit,
    value: te,
    controlRef: re,
    name: z,
    getValue: () => te
  });
  const ue = f.useRef(null), ye = zt(c, ue, le.inputRef);
  he(() => {
    ue.current && (ue.current.indeterminate = oe, te && R(!0));
  }, [te, oe, R]), ws(te, () => {
    P && !p || (E(z), R(te), _(te !== T.initialValue), L() ? le.commit(te) : le.commit(te, !0));
  });
  const ge = Qt(
    {
      checked: te,
      disabled: D,
      // parent checkboxes unset `name` to be excluded from form submission
      name: p ? void 0 : z,
      // Set `id` to stop Chrome warning about an unassociated input.
      // When using a native button, the `id` is applied to the button instead.
      id: x ? void 0 : se ?? void 0,
      required: g,
      ref: ye,
      style: z ? ms : Wn,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      onChange(Pe) {
        if (Pe.nativeEvent.defaultPrevented)
          return;
        const we = Pe.target.checked, ve = ke(Ut, Pe.nativeEvent);
        if (Y?.(we, ve), ce(we, ve), !ve.isCanceled && (pe(we), U && K && X && !p)) {
          const Ae = we ? [...K, U] : K.filter((Ne) => Ne !== U);
          X(Ae, ve);
        }
      },
      onFocus() {
        re.current?.focus();
      }
    },
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    v !== void 0 ? {
      value: (P ? te && v : v) || ""
    } : at,
    B,
    P ? le.getValidationProps : le.getInputValidationProps
  ), Te = I ? !!W : te, Se = I && oe || l;
  f.useEffect(() => {
    V && U && V.disabledStatesRef.current.set(U, D);
  }, [V, D, U]);
  const xe = f.useMemo(() => ({
    ...F,
    checked: Te,
    disabled: D,
    readOnly: m,
    required: g,
    indeterminate: Se
  }), [F, Te, D, m, g, Se]), je = Hh(xe), Me = _e("span", e, {
    state: xe,
    ref: [de, re, n, P?.registerControlRef],
    props: [{
      id: x ? se ?? void 0 : G,
      role: "checkbox",
      "aria-checked": oe ? "mixed" : te,
      "aria-readonly": m || void 0,
      "aria-required": g || void 0,
      "aria-labelledby": $,
      [BE]: p ? "" : void 0,
      onFocus() {
        O(!0);
      },
      onBlur() {
        const Pe = ue.current;
        Pe && (j(!0), O(!1), N === "onBlur" && le.commit(P ? K : Pe.checked));
      },
      onClick(Pe) {
        m || D || (Pe.preventDefault(), ue.current?.click());
      }
    }, B, le.getValidationProps, w, Z, ie],
    stateAttributesMapping: je
  });
  return /* @__PURE__ */ b.jsxs(ru.Provider, {
    value: xe,
    children: [Me, !te && !P && z && !p && y !== void 0 && /* @__PURE__ */ b.jsx("input", {
      type: "hidden",
      name: z,
      value: y
    }), /* @__PURE__ */ b.jsx("input", {
      ...ge
    })]
  });
});
process.env.NODE_ENV !== "production" && (Xh.displayName = "CheckboxRoot");
const Zh = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    keepMounted: s = !1,
    ...i
  } = e, a = zE(), l = a.checked || a.indeterminate, {
    transitionStatus: c,
    setMounted: u
  } = Kn(l), d = f.useRef(null), p = f.useMemo(() => ({
    ...a,
    transitionStatus: c
  }), [a, c]);
  Gt({
    open: l,
    ref: d,
    onComplete() {
      l || u(!1);
    }
  });
  const m = Hh(a), h = f.useMemo(() => ({
    ...m,
    ...tn,
    ...zo
  }), [m]), g = s || l, y = _e("span", e, {
    enabled: g,
    ref: [n, d],
    state: p,
    stateAttributesMapping: h,
    props: i
  });
  return g ? y : null;
});
process.env.NODE_ENV !== "production" && (Zh.displayName = "CheckboxIndicator");
const HE = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 6L9 17l-5-5"/>'
}, Tr = HE, UE = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14"/>'
}, Jh = UE, Po = (t) => {
  const e = ee.c(13);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    indeterminate: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] !== n ? (s = ae("border-[var(--gray-450)] dark:border-[var(--gray-400)] data-checked:bg-action-primary data-checked:text-on-primary dark:data-checked:bg-action-primary data-checked:border-action-primary data-indeterminate:bg-action-primary data-indeterminate:text-on-primary dark:data-indeterminate:bg-action-primary data-indeterminate:border-action-primary aria-invalid:data-checked:!border-action-primary aria-invalid:data-checked:!ring-0 aria-invalid:data-indeterminate:!border-action-primary aria-invalid:data-indeterminate:!ring-0 aria-invalid:border-feedback-danger dark:aria-invalid:border-feedback-danger/50 focus-visible:border-ring-focus focus-visible:ring-ring-focus/50 aria-invalid:ring-feedback-danger/20 dark:aria-invalid:ring-feedback-danger/40 flex size-[var(--density-checkbox-size)] items-center justify-center rounded-[4px] border transition-colors group-has-disabled/field:opacity-50 focus-visible:ring-[3px] aria-invalid:ring-[3px] peer relative shrink-0 outline-none cursor-pointer after:absolute after:-inset-x-3 after:-inset-y-2 data-disabled:cursor-not-allowed data-disabled:opacity-50", n), e[4] = n, e[5] = s) : s = e[5];
  let i;
  e[6] !== o ? (i = /* @__PURE__ */ b.jsx(Zh, { "data-slot": "checkbox-indicator", className: "[&>svg]:size-[var(--density-checkbox-icon-size)] grid place-content-center text-current transition-none", children: o ? /* @__PURE__ */ b.jsx(Ve, { icon: Jh }) : /* @__PURE__ */ b.jsx(Ve, { icon: Tr }) }), e[6] = o, e[7] = i) : i = e[7];
  let a;
  return e[8] !== o || e[9] !== r || e[10] !== s || e[11] !== i ? (a = /* @__PURE__ */ b.jsx(Xh, { "data-slot": "checkbox", indeterminate: o, className: s, ...r, children: i }), e[8] = o, e[9] = r, e[10] = s, e[11] = i, e[12] = a) : a = e[12], a;
};
let Cf = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const ec = {
  checked(t) {
    return t ? {
      [Cf.checked]: ""
    } : {
      [Cf.unchecked]: ""
    };
  },
  ...tn,
  ...zo
}, su = "data-composite-item-active";
function Qh(t = {}) {
  const {
    highlightItemOnHover: e,
    highlightedIndex: n,
    onHighlightedIndexChange: o
  } = Oc(), {
    ref: r,
    index: s
  } = Yn(t), i = n === s, a = f.useRef(null), l = zt(r, a);
  return {
    compositeProps: f.useMemo(() => ({
      tabIndex: i ? 0 : -1,
      onFocus() {
        o(s);
      },
      onMouseMove() {
        const u = a.current;
        if (!e || !u)
          return;
        const d = u.hasAttribute("disabled") || u.ariaDisabled === "true";
        !i && !d && u.focus();
      }
    }), [i, o, s, e]),
    compositeRef: l,
    index: s
  };
}
function eg(t) {
  const {
    render: e,
    className: n,
    state: o = at,
    props: r = zn,
    refs: s = zn,
    metadata: i,
    stateAttributesMapping: a,
    tag: l = "div",
    ...c
  } = t, {
    compositeProps: u,
    compositeRef: d
  } = Qh({
    metadata: i
  });
  return _e(l, t, {
    state: o,
    ref: [...s, d],
    props: [u, ...r, c],
    stateAttributesMapping: a
  });
}
function Ir(t = {}) {
  const {
    id: e,
    implicit: n = !1,
    controlRef: o
  } = t, {
    controlId: r,
    setControlId: s
  } = yo(), i = lt(e);
  return he(() => {
    if (!(!n && !e || s === xt)) {
      if (n) {
        const a = o?.current;
        Ze(a) && a.closest("label") != null ? s(e ?? null) : s(r ?? i);
      } else e && s(e);
      return () => {
        e && s(void 0);
      };
    }
  }, [e, o, r, s, n, i]), r ?? i;
}
const iu = /* @__PURE__ */ f.createContext({
  disabled: void 0,
  readOnly: void 0,
  required: void 0,
  name: void 0,
  checkedValue: "",
  setCheckedValue: xt,
  onValueChange: xt,
  touched: !1,
  setTouched: xt,
  registerControlRef: xt
});
process.env.NODE_ENV !== "production" && (iu.displayName = "RadioGroupContext");
function WE() {
  return f.useContext(iu);
}
const au = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (au.displayName = "RadioRootContext");
function GE() {
  const t = f.useContext(au);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: RadioRootContext is missing. Radio parts must be placed within <Radio.Root>." : We(52));
  return t;
}
const Na = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    readOnly: i = !1,
    required: a = !1,
    value: l,
    inputRef: c,
    nativeButton: u = !1,
    id: d,
    ...p
  } = e, {
    disabled: m,
    readOnly: h,
    required: g,
    checkedValue: y,
    setCheckedValue: v,
    touched: x,
    setTouched: w,
    validation: E,
    registerControlRef: S,
    name: C
  } = WE(), {
    setDirty: _,
    validityData: R,
    setTouched: O,
    setFilled: j,
    state: F,
    disabled: N
  } = dn(), T = Gh(), {
    labelId: L,
    getDescriptionProps: M
  } = yo(), A = N || T.disabled || m || s, $ = h || i, k = g || a, H = y === l, B = f.useRef(null), P = f.useRef(null), V = zt(c, P);
  he(() => {
    P.current?.checked && j(!0);
  }, [j]);
  const I = lt(), D = Ir({
    id: d,
    implicit: !1,
    controlRef: B
  }), z = u ? void 0 : D, U = {
    role: "radio",
    "aria-checked": H,
    "aria-required": k || void 0,
    "aria-readonly": $ || void 0,
    "aria-labelledby": L,
    [su]: H ? "" : void 0,
    id: u ? D : I,
    onKeyDown(K) {
      K.key === "Enter" && K.preventDefault();
    },
    onClick(K) {
      K.defaultPrevented || A || $ || (K.preventDefault(), P.current?.click());
    },
    onFocus(K) {
      K.defaultPrevented || A || $ || !x || (P.current?.click(), w(!1));
    }
  }, {
    getButtonProps: G,
    buttonRef: J
  } = Wt({
    disabled: A,
    native: u
  }), se = {
    type: "radio",
    ref: V,
    id: z,
    tabIndex: -1,
    style: C ? ms : Wn,
    "aria-hidden": !0,
    disabled: A,
    checked: H,
    required: k,
    readOnly: $,
    onChange(K) {
      if (K.nativeEvent.defaultPrevented || A || $ || l === void 0)
        return;
      const X = ke(Ut, K.nativeEvent);
      X.isCanceled || (O(!0), _(l !== R.initialValue), j(!0), v(l, X));
    },
    onFocus() {
      B.current?.focus();
    }
  }, Q = f.useMemo(() => ({
    ...F,
    required: k,
    disabled: A,
    readOnly: $,
    checked: H
  }), [F, A, $, H, k]), ce = f.useMemo(() => Q, [Q]), W = v !== xt, oe = [n, S, B, J], Y = [U, M, E?.getValidationProps ?? at, p, G], Z = _e("span", e, {
    enabled: !W,
    state: Q,
    ref: oe,
    props: Y,
    stateAttributesMapping: ec
  });
  return /* @__PURE__ */ b.jsxs(au.Provider, {
    value: ce,
    children: [W ? /* @__PURE__ */ b.jsx(eg, {
      tag: "span",
      render: o,
      className: r,
      state: Q,
      refs: oe,
      props: Y,
      stateAttributesMapping: ec
    }) : Z, /* @__PURE__ */ b.jsx("input", {
      ...se
    })]
  });
});
process.env.NODE_ENV !== "production" && (Na.displayName = "RadioRoot");
const tg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    keepMounted: s = !1,
    ...i
  } = e, a = GE(), l = a.checked, {
    transitionStatus: c,
    setMounted: u
  } = Kn(l), d = f.useMemo(() => ({
    ...a,
    transitionStatus: c
  }), [a, c]), p = f.useRef(null), m = s || l, h = _e("span", e, {
    enabled: m,
    ref: [n, p],
    state: d,
    props: i,
    stateAttributesMapping: ec
  });
  return Gt({
    open: l,
    ref: p,
    onComplete() {
      l || u(!1);
    }
  }), m ? h : null;
});
process.env.NODE_ENV !== "production" && (tg.displayName = "RadioIndicator");
const KE = [];
function YE(t) {
  const {
    itemSizes: e,
    cols: n = 1,
    loopFocus: o = !0,
    dense: r = !1,
    orientation: s = "both",
    direction: i,
    highlightedIndex: a,
    onHighlightedIndexChange: l,
    rootRef: c,
    enableHomeAndEndKeys: u = !1,
    stopEventPropagation: d = !1,
    disabledIndices: p,
    modifierKeys: m = KE
  } = t, [h, g] = f.useState(0), y = n > 1, v = f.useRef(null), x = zt(v, c), w = f.useRef([]), E = f.useRef(!1), S = a ?? h, C = fe((O, j = !1) => {
    if ((l ?? g)(O), j) {
      const F = w.current[O];
      Nd(v.current, F, i, s);
    }
  }), _ = fe((O) => {
    if (O.size === 0 || E.current)
      return;
    E.current = !0;
    const j = Array.from(O.keys()), F = j.find((T) => T?.hasAttribute(su)) ?? null, N = F ? j.indexOf(F) : -1;
    N !== -1 && C(N), Nd(v.current, F, i, s);
  }), R = f.useMemo(() => ({
    "aria-orientation": s === "both" ? void 0 : s,
    ref: x,
    onFocus(O) {
      !v.current || !Rd(O.target) || O.target.setSelectionRange(0, O.target.value.length ?? 0);
    },
    onKeyDown(O) {
      const j = u ? z1 : Am;
      if (!j.has(O.key) || qE(O, m) || !v.current)
        return;
      const N = i === "rtl", T = N ? Hn : Tn, L = {
        horizontal: T,
        vertical: gn,
        both: T
      }[s], M = N ? Tn : Hn, A = {
        horizontal: M,
        vertical: kn,
        both: M
      }[s];
      if (Rd(O.target) && !Dl(O.target)) {
        const I = O.target.selectionStart, D = O.target.selectionEnd, z = O.target.value ?? "";
        if (I == null || O.shiftKey || I !== D || O.key !== A && I < z.length || O.key !== L && I > 0)
          return;
      }
      let $ = S;
      const k = ui(w, p), H = Ul(w, p);
      if (y) {
        const I = e || Array.from({
          length: w.current.length
        }, () => ({
          width: 1,
          height: 1
        })), D = bm(I, n, r), z = D.findIndex((G) => G != null && !ao(w, G, p)), U = D.reduce((G, J, se) => J != null && !ao(w, J, p) ? se : G, -1);
        $ = D[gm({
          current: D.map((G) => G ? w.current[G] : null)
        }, {
          event: O,
          orientation: s,
          loopFocus: o,
          cols: n,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: ym([...p || w.current.map((G, J) => ao(w, J) ? J : void 0), void 0], D),
          minIndex: z,
          maxIndex: U,
          prevIndex: vm(
            S > H ? k : S,
            I,
            D,
            n,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            O.key === gn ? "bl" : O.key === Tn ? "tr" : "tl"
          ),
          rtl: N
        })];
      }
      const B = {
        horizontal: [T],
        vertical: [gn],
        both: [T, gn]
      }[s], P = {
        horizontal: [M],
        vertical: [kn],
        both: [M, kn]
      }[s], V = y ? j : {
        horizontal: u ? F1 : Mm,
        vertical: u ? V1 : Pm,
        both: j
      }[s];
      u && (O.key === go ? $ = k : O.key === bo && ($ = H)), $ === S && (B.includes(O.key) || P.includes(O.key)) && (o && $ === H && B.includes(O.key) ? $ = k : o && $ === k && P.includes(O.key) ? $ = H : $ = Pt(w, {
        startingIndex: $,
        decrement: P.includes(O.key),
        disabledIndices: p
      })), $ !== S && !ir(w, $) && (d && O.stopPropagation(), V.has(O.key) && O.preventDefault(), C($, !0), queueMicrotask(() => {
        w.current[$]?.focus();
      }));
    }
  }), [n, r, i, p, w, u, S, y, e, o, x, m, C, s, d]);
  return f.useMemo(() => ({
    props: R,
    highlightedIndex: S,
    onHighlightedIndexChange: C,
    elementsRef: w,
    disabledIndices: p,
    onMapChange: _,
    relayKeyboardEvent: R.onKeyDown
  }), [R, S, C, w, p, _]);
}
function qE(t, e) {
  for (const n of W1.values())
    if (!e.includes(n) && t.getModifierState(n))
      return !0;
  return !1;
}
function ng(t) {
  const {
    render: e,
    className: n,
    refs: o = zn,
    props: r = zn,
    state: s = at,
    stateAttributesMapping: i,
    highlightedIndex: a,
    onHighlightedIndexChange: l,
    orientation: c,
    dense: u,
    itemSizes: d,
    loopFocus: p,
    cols: m,
    enableHomeAndEndKeys: h,
    onMapChange: g,
    stopEventPropagation: y = !0,
    rootRef: v,
    disabledIndices: x,
    modifierKeys: w,
    highlightItemOnHover: E = !1,
    tag: S = "div",
    ...C
  } = t, _ = jo(), {
    props: R,
    highlightedIndex: O,
    onHighlightedIndexChange: j,
    elementsRef: F,
    onMapChange: N,
    relayKeyboardEvent: T
  } = YE({
    itemSizes: d,
    cols: m,
    loopFocus: p,
    dense: u,
    orientation: c,
    highlightedIndex: a,
    onHighlightedIndexChange: l,
    rootRef: v,
    stopEventPropagation: y,
    enableHomeAndEndKeys: h,
    direction: _,
    disabledIndices: x,
    modifierKeys: w
  }), L = _e(S, t, {
    state: s,
    ref: o,
    props: [R, ...r, C],
    stateAttributesMapping: i
  }), M = f.useMemo(() => ({
    highlightedIndex: O,
    onHighlightedIndexChange: j,
    highlightItemOnHover: E,
    relayKeyboardEvent: T
  }), [O, j, E, T]);
  return /* @__PURE__ */ b.jsx(Ic.Provider, {
    value: M,
    children: /* @__PURE__ */ b.jsx(yr, {
      elementsRef: F,
      onMapChange: (A) => {
        g?.(A), N(A);
      },
      children: L
    })
  });
}
const og = /* @__PURE__ */ f.createContext({
  legendId: void 0,
  setLegendId: () => {
  },
  disabled: void 0
});
process.env.NODE_ENV !== "production" && (og.displayName = "FieldsetRootContext");
function XE(t = !1) {
  const e = f.useContext(og);
  if (!e && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldsetRootContext is missing. Fieldset parts must be placed within <Fieldset.Root>." : We(86));
  return e;
}
const ZE = [Dm], ka = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s,
    readOnly: i,
    required: a,
    onValueChange: l,
    value: c,
    defaultValue: u,
    name: d,
    inputRef: p,
    id: m,
    ...h
  } = e, {
    setTouched: g,
    setFocused: y,
    shouldValidateOnChange: v,
    validationMode: x,
    name: w,
    disabled: E,
    state: S,
    validation: C,
    setDirty: _,
    setFilled: R,
    validityData: O
  } = dn(), {
    labelId: j
  } = yo(), {
    clearErrors: F
  } = Nr(), N = XE(!0), T = E || s, L = w ?? d, M = lt(m), [A, $] = un({
    controlled: c,
    default: u,
    name: "RadioGroup",
    state: "value"
  }), k = fe(l), H = fe((W, oe) => {
    k(W, oe), !oe.isCanceled && $(W);
  }), B = f.useRef(null), P = fe((W) => {
    B.current == null && W != null && (B.current = W);
  });
  kr({
    id: M,
    commit: C.commit,
    value: A,
    controlRef: B,
    name: L,
    getValue: () => A ?? null
  }), ws(A, () => {
    F(L), _(A !== O.initialValue), R(A != null), v() ? C.commit(A) : C.commit(A, !0);
  });
  const [V, I] = f.useState(!1), D = fe((W) => {
    Ue(W.currentTarget, W.relatedTarget) || (g(!0), y(!1), x === "onBlur" && C.commit(A));
  }), z = fe((W) => {
    W.key.startsWith("Arrow") && (g(!0), I(!0), y(!0));
  }), U = f.useMemo(() => A == null ? "" : typeof A == "string" ? A : JSON.stringify(A), [A]), G = zt(C.inputRef, p), J = Qt({
    value: U,
    ref: G,
    id: M,
    name: U ? L : void 0,
    disabled: T,
    readOnly: i,
    required: a,
    "aria-labelledby": h["aria-labelledby"] ?? N?.legendId,
    "aria-hidden": !0,
    tabIndex: -1,
    style: L ? ms : Wn,
    onChange: xt,
    // suppress a Next.js error
    onFocus() {
      B.current?.focus();
    }
  }, C.getInputValidationProps), se = f.useMemo(() => ({
    ...S,
    disabled: T ?? !1,
    required: a ?? !1,
    readOnly: i ?? !1
  }), [S, T, i, a]), Q = f.useMemo(() => ({
    ...S,
    checkedValue: A,
    disabled: T,
    validation: C,
    name: L,
    onValueChange: k,
    readOnly: i,
    registerControlRef: P,
    required: a,
    setCheckedValue: H,
    setTouched: I,
    touched: V
  }), [A, T, C, S, L, k, i, P, a, H, I, V]), ce = {
    role: "radiogroup",
    "aria-required": a || void 0,
    "aria-disabled": T || void 0,
    "aria-readonly": i || void 0,
    "aria-labelledby": j,
    onFocus() {
      y(!0);
    },
    onBlur: D,
    onKeyDownCapture: z
  };
  return /* @__PURE__ */ b.jsxs(iu.Provider, {
    value: Q,
    children: [/* @__PURE__ */ b.jsx(ng, {
      render: o,
      className: r,
      state: se,
      props: [ce, C.getValidationProps, h],
      refs: [n],
      stateAttributesMapping: zo,
      enableHomeAndEndKeys: !1,
      modifierKeys: ZE
    }), /* @__PURE__ */ b.jsx("input", {
      ...J
    })]
  });
});
process.env.NODE_ENV !== "production" && (ka.displayName = "RadioGroup");
const JE = "_group_1bv91_1", QE = "_row_1bv91_8", eC = "_check_1bv91_37", tC = "_leading_1bv91_45", nC = "_label_1bv91_50", Yr = {
  group: JE,
  row: QE,
  check: eC,
  leading: tC,
  label: nC
}, _n = {
  /**
   * Returns the Electron preload API (window.electronAPI) cast to T, or undefined if not in Electron.
   */
  getElectronApi: () => _n.isElectron() ? (typeof globalThis.window < "u" ? globalThis.window : void 0)?.electronAPI : void 0,
  /**
   * Returns a friendly runtime type: AppRuntimeType.Electron or AppRuntimeType.Web.
   */
  getRuntime: () => _n.isElectron() ? "electron" : "web",
  /**
   * Returns the OS-level color scheme preference ('dark' or 'light').
   * Falls back to 'light' when `window` or `matchMedia` is unavailable (eg: SSR).
   * TODO: Does this belong here?
   */
  getSystemThemePreference: () => typeof window > "u" ? "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light",
  /**
   * Returns true when running inside an Electron renderer process.
   * Relies on the Electron preload script exposing window.electronAPI via contextBridge.
   * See: modules/electron/src/preload/PreloadWrapperAlpha.ts
   */
  isElectron: () => {
    try {
      const t = typeof globalThis.window < "u" ? globalThis.window : void 0;
      return !!(t && t.electronAPI);
    } catch {
      return !1;
    }
  },
  /** Returns true when running on Linux (neither macOS nor Windows). */
  isLinux: () => !_n.isMacOS() && !_n.isWindows(),
  /**
   * Returns true when running on macOS. Uses the modern `userAgentData` API
   * with a fallback to the deprecated `navigator.platform`.
   */
  isMacOS: () => il().startsWith("mac") || il() === "macos",
  /**
   * Returns true when running on Windows.
   */
  isWindows: () => il().startsWith("win")
}, il = () => typeof navigator > "u" ? "" : (navigator.userAgentData?.platform ?? navigator.platform ?? "").toLowerCase(), oC = /* @__PURE__ */ new Set(["Alt", "Control", "Meta", "Mod", "Shift"]), rC = /* @__PURE__ */ new Set(["ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp", "Backspace", "Delete", "End", "Enter", "Escape", "Home", "PageDown", "PageUp", "Space", "Tab"]), sC = /* @__PURE__ */ new Set(["!", '"', "#", "$", "%", "&", "'", "(", ")", "*", "+", ",", "-", ".", "/", ":", ";", "<", "=", ">", "?", "@", "[", "\\", "]", "^", "_", "`", "{", "|", "}", "~", "£"]), iC = /* @__PURE__ */ new Set(["!", '"', "#", "$", "%", "&", "(", ")", "*", "+", ":", "<", ">", "?", "@", "^", "_", "{", "|", "}", "~", "£"]), lo = {
  /**
   * Renders a parsed shortcut as a non-glyph string for accessible help text.
   * eg: `{ modifiers: ['Mod','Shift'], key: 'K' }` → `'Mod+Shift+K'`.
   * Glyph rendering (⌘/⇧/⌥/⌃) lives in the menu surface.
   * @param parsed - The parsed shortcut.
   */
  format(t) {
    return t.modifiers.length === 0 ? t.key : `${t.modifiers.join("+")}+${t.key}`;
  },
  /**
   * Returns true when the keyboard event matches the parsed shortcut.
   * Rules:
   * - `Mod` resolves to Meta on macOS and Control elsewhere at match time.
   * - The event's modifier set must EXACTLY equal the parsed modifier set
   *   (extra modifiers held → no match), with one exception: when the parsed key
   *   is a symbol that requires Shift to produce on the standard layout
   *   (`?`, `!`, `@`, etc.), the matcher does NOT require Shift to appear in
   *   `parsed.modifiers` — the printable-character check on `event.key` is
   *   sufficient.
   * - Letter comparison is case-insensitive (`event.key` may be lower- or
   *   upper-case depending on Shift state).
   * @param parsed - The parsed shortcut to test against.
   * @param event - The DOM keyboard event.
   */
  matches(t, e) {
    const n = _n.isMacOS(), o = {
      alt: !1,
      control: !1,
      meta: !1,
      shift: !1
    };
    for (const a of t.modifiers)
      a === "Alt" ? o.alt = !0 : a === "Shift" ? o.shift = !0 : a === "Meta" ? o.meta = !0 : a === "Control" ? o.control = !0 : a === "Mod" && (n ? o.meta = !0 : o.control = !0);
    const r = t.key, s = iC.has(r);
    if (e.altKey !== o.alt || e.ctrlKey !== o.control || e.metaKey !== o.meta || !s && e.shiftKey !== o.shift) return !1;
    const i = e.key;
    return i === void 0 ? !1 : t.key.length === 1 && /[A-Za-z]/.test(t.key) ? i.toLowerCase() === t.key.toLowerCase() : t.key === "Space" ? i === " " || i === "Space" : i === t.key;
  },
  /**
   * Parses a strictly-typed shortcut string into its modifier set + key. Returns
   * `null` for unsupported tokens — meaning the binding never matches. The strict
   * `Shortcut` template-literal type is the primary contract; this parser exists
   * as defense-in-depth against `as Shortcut` casts and dynamic strings.
   * @param shortcut - The shortcut string.
   */
  parse(t) {
    if (typeof t != "string" || t.length === 0) return null;
    const e = t.split("+");
    if (e.length === 0) return null;
    const n = e[e.length - 1], o = e.slice(0, -1), r = [], s = /* @__PURE__ */ new Set();
    for (const a of o) {
      if (!oC.has(a)) return null;
      const l = a;
      if (s.has(l)) return null;
      s.add(l), r.push(l);
    }
    if (!aC(n)) return null;
    const i = ["Control", "Alt", "Shift", "Meta", "Mod"];
    return r.sort((a, l) => i.indexOf(a) - i.indexOf(l)), {
      key: n,
      modifiers: r
    };
  }
}, aC = (t) => t.length === 0 ? !1 : t.length === 1 ? /^[A-Za-z0-9]$/.test(t) ? !0 : sC.has(t) : !!(rC.has(t) || /^F([1-9]|1[0-2])$/.test(t)), Us = /* @__PURE__ */ new Map(), qr = /* @__PURE__ */ new Map(), _f = /* @__PURE__ */ new Map();
let Rf = null;
const lC = () => null, tc = /* @__PURE__ */ new Set(), Bt = {
  /**
   * Test-only helper. Resets all registry maps so tests can register fresh scope types
   * without leaking state between cases.
   */
  _clear() {
    Us.clear(), qr.clear(), _f.clear(), tc.clear();
  },
  /**
   * Internal: installs the React component factory used by `defineScope` to mint the typed
   * wrapper component. Phase 2's scope wrapper module calls this once at module load.
   * @param factory - The wrapper factory to install, or null to clear it.
   */
  _setScopeWrapperFactory(t) {
    Rf = t;
  },
  actionsById: qr,
  contextScopes: _f,
  /**
   * Registers a scope type and all its actions. Throws if any action id is already
   * registered (global uniqueness invariant). Returns the typed wrapper component
   * for this scope type; until Phase 2 installs the wrapper factory, the returned
   * component is a no-op placeholder (sufficient for unit tests against the registry).
   * @param spec - The scope type definition.
   */
  defineScope(t) {
    if (Us.has(t.id)) throw new Error(`ActionRegistry: scope type '${t.id}' is already registered. Each scope type must have a unique id.`);
    const e = rg(t.actions);
    for (const o of e) {
      const r = qr.get(o.id);
      if (r) throw new Error(`ActionRegistry: action id '${o.id}' is already registered (by scope type '${r.scopeTypeId}'). Action ids must be globally unique.`);
    }
    Us.set(t.id, t);
    for (const o of e)
      qr.set(o.id, {
        action: o,
        scopeTypeId: t.id
      });
    process.env.NODE_ENV !== "production" && cC(t.id, e);
    const n = Rf;
    return n ? n(t) : lC;
  },
  scopeTypes: Us
}, rg = (t) => {
  const e = [];
  for (const n of t)
    e.push(n), n.children && n.children.length > 0 && e.push(...rg(n.children));
  return e;
}, cC = (t, e) => {
  for (const n of e) {
    if (!n.shortcut) continue;
    const o = lo.parse(n.shortcut);
    if (!o) continue;
    const r = lo.format(o);
    qr.forEach((s) => {
      if (s.scopeTypeId === t || s.action.id === n.id || !s.action.shortcut) return;
      const i = lo.parse(s.action.shortcut);
      if (!i || i.key !== o.key || i.modifiers.length !== o.modifiers.length) return;
      for (let l = 0; l < i.modifiers.length; l++)
        if (i.modifiers[l] !== o.modifiers[l]) return;
      const a = `${r}::${t}::${s.scopeTypeId}`;
      tc.has(a) || (tc.add(a), console.warn(`[actions] shortcut ${r} on scope '${t}' shadows scope '${s.scopeTypeId}'`));
    });
  }
}, Nf = /* @__PURE__ */ new Set(), Eo = {
  /**
   * Walks `composedPath()` outermost → innermost and produces the resolved scope chain.
   * Reads `data-scope` (high-volume scopes) and `data-context-scope-id` (low-volume
   * scopes registered via `<ContextScope>`). Returns root → current order.
   * @param path - The result of `event.composedPath()`.
   */
  resolveChain(t) {
    const e = [...t].reverse(), n = [];
    for (const o of e) {
      if (!uC(o)) continue;
      const r = o, s = r.getAttribute("data-scope");
      if (s !== null) {
        const a = Bt.scopeTypes.get(s);
        if (!a) continue;
        const l = a.payloadFromDom(r);
        n.push({
          element: r,
          payload: l,
          scopeTypeId: s
        });
        continue;
      }
      const i = r.getAttribute("data-context-scope-id");
      if (i !== null) {
        const a = Bt.contextScopes.get(i);
        if (!a) continue;
        n.push({
          element: r,
          payload: a.payload,
          scopeTypeId: a.scopeTypeId ?? `__context:${i}`
        });
      }
    }
    return n;
  },
  /**
   * Looks up every selected payload of a given scope type via
   * `document.querySelectorAll('[data-scope=X][data-selected]')` and maps each
   * matching element through the scope type's `payloadFromDom`.
   * @param scopeTypeId - The scope type id whose selection to read.
   */
  resolveSelection(t) {
    const e = Bt.scopeTypes.get(t);
    if (!e) return [];
    if (typeof document > "u") return [];
    const n = pC(t), o = document.querySelectorAll(`[data-scope="${n}"][data-selected]`), r = [];
    return o.forEach((s) => {
      r.push(e.payloadFromDom(s));
    }), r;
  },
  /**
   * Computes a stable string key for a payload, used by the in-flight Map. Uses the
   * action's `key(payload)` if provided, otherwise a deterministic JSON serialization
   * with alphabetized keys (via `Objects.orderProperties`).
   * Non-serializable fallback (cycles, functions, Date, Map/Set, class instances):
   * - In dev (`process.env.NODE_ENV !== 'production'`): throws — surfaces the bug at
   *   first dispatch, before in-flight tracking silently collapses entries.
   * - In prod: emits `console.warn` once per actionId, falls back to
   *   `crypto.randomUUID()`. In-flight tracking degrades gracefully.
   * @param actionId - The action id (used for diagnostic messages and warn de-duping).
   * @param payload - The payload to key.
   * @param keyFn - Optional `Action.key` function.
   */
  stableKey(t, e, n) {
    if (n) return n(e);
    if (e == null) return String(e);
    if (typeof e != "object") return JSON.stringify(e);
    try {
      const o = nc(e), r = JSON.stringify(o, dC);
      if (r === void 0) throw new Error("serialization yielded undefined");
      return r;
    } catch (o) {
      if (!(process.env.NODE_ENV === "production"))
        throw new Error(`Action '${t}' received a non-serializable payload. Declare key(payload) on the action definition. (cause: ${o.message})`);
      return Nf.has(t) || (Nf.add(t), console.warn(`[actions] Action '${t}' received a non-serializable payload. In-flight tracking falls back to a per-dispatch random id. Declare key(payload) to fix.`)), fC();
    }
  }
}, uC = (t) => typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : t !== null && typeof t == "object" && "getAttribute" in t && "nodeType" in t && t.nodeType === 1, dC = (t, e) => {
  if (typeof e == "function") throw new Error("payload contains a function");
  if (typeof e == "symbol") throw new Error("payload contains a symbol");
  if (typeof e == "bigint") return e.toString();
  if (e instanceof Map) throw new Error("payload contains a Map");
  if (e instanceof Set) throw new Error("payload contains a Set");
  return e;
}, fC = () => typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : `__rand:${Math.random().toString(36).slice(2)}:${Date.now()}`, pC = (t) => t.replace(/\\/g, "\\\\").replace(/"/g, '\\"'), nc = (t) => {
  const e = {};
  return Object.keys(t).sort().forEach((n) => {
    const o = t[n];
    kf(o) ? e[n] = nc(o) : Array.isArray(o) ? e[n] = o.map((r) => kf(r) ? nc(r) : r) : e[n] = o;
  }), e;
}, kf = (t) => {
  if (t === null || typeof t != "object" || Array.isArray(t)) return !1;
  const e = Object.getPrototypeOf(t);
  return e === Object.prototype || e === null;
}, Ss = Qv(null);
class mC {
  constructor() {
    Re(this, "_listeners", /* @__PURE__ */ new Set());
    Re(this, "_map", /* @__PURE__ */ new Map());
    /**
     * Removes the entry at `key`, replaces the snapshot Map, and notifies subscribers.
     * No-op if the key is not present.
     * @param key - The in-flight key to remove.
     */
    Re(this, "delete", (e) => {
      if (!this._map.has(e)) return;
      const n = new Map(this._map);
      n.delete(e), this._map = n, this._emit();
    });
    /** Returns the current snapshot Map (identity is stable until a mutation occurs). */
    Re(this, "getSnapshot", () => this._map);
    /**
     * Sets the entry at `key`, replaces the snapshot Map, and notifies subscribers.
     * @param key - The in-flight key to set.
     * @param entry - The in-flight entry.
     */
    Re(this, "set", (e, n) => {
      const o = new Map(this._map);
      o.set(e, n), this._map = o, this._emit();
    });
    /**
     * Registers a subscriber. Returns an unsubscribe function.
     * @param listener - The subscriber callback.
     */
    Re(this, "subscribe", (e) => (this._listeners.add(e), () => {
      this._listeners.delete(e);
    }));
    Re(this, "_emit", () => {
      this._listeners.forEach((e) => e());
    });
  }
}
const al = {
  body: "",
  destructive: !1,
  open: !1,
  resolve: null
}, hC = {
  items: [],
  open: !1,
  position: {
    x: 0,
    y: 0
  }
}, Fr = "__app", gC = (t) => {
  if (!t || !(t instanceof HTMLElement)) return !1;
  if (t.isContentEditable) return !0;
  const e = t.tagName;
  return e === "INPUT" || e === "TEXTAREA" || e === "SELECT";
}, bC = (t) => {
  const {
    ConfirmDialog: e,
    Menu: n,
    children: o,
    commandPalette: r = !0,
    onError: s,
    shortcutHelp: i = !0,
    toast: a
  } = t, l = ad(() => new mC(), []), [c, u] = Fn(!1), [d, p] = Fn(!1), [m, h] = Fn(al), [g, y] = Fn(hC), v = mn([]), x = mn([]), w = mn(!1), E = mn(/* @__PURE__ */ new Set()), S = mn([]), C = mn(s);
  C.current = s;
  const _ = mn(a);
  _.current = a;
  const R = mn({});
  $n(() => {
    if (!r && !i) return;
    const I = [];
    if (r) {
      const D = {
        id: "app.openCommandPalette",
        label: "Open command palette",
        /** Built-in: opens the command palette overlay. */
        run: () => u(!0),
        shortcut: "Mod+K"
      };
      I.push(D), R.current.palette = D;
    }
    if (i) {
      const D = {
        id: "app.openShortcutHelp",
        label: "Open shortcut help",
        /** Built-in: opens the shortcut help overlay. */
        run: () => p(!0),
        shortcut: "?"
      };
      I.push(D), R.current.help = D;
    }
    return Bt.scopeTypes.has(Fr) || Bt.defineScope({
      actions: I,
      /** Synthetic scope: emits no DOM attributes (lives at the chain root). */
      attrs: () => ({}),
      id: Fr,
      /** Synthetic scope: payload is always the empty object. */
      payloadFromDom: () => ({})
    }), () => {
      Bt.scopeTypes.delete(Fr);
      for (const D of I) Bt.actionsById.delete(D.id);
      R.current = {};
    };
  }, [r, i]);
  const O = rn(() => {
    if (typeof document > "u") return [];
    const I = document.activeElement;
    if (I && I !== document.body && I instanceof HTMLElement) {
      const z = [];
      let U = I;
      for (; U; )
        z.push(U), U = U.parentElement;
      const G = Eo.resolveChain(z);
      if (G.length > 0) return G;
    }
    return Eo.resolveChain(v.current);
  }, []), j = rn((I) => {
    S.current = I, E.current.forEach((D) => D());
  }, []), F = rn((I) => new Promise((D) => {
    h({
      body: I.body,
      cancelLabel: I.cancelLabel,
      confirmLabel: I.confirmLabel,
      destructive: I.destructive ?? !1,
      open: !0,
      resolve: D,
      title: I.title
    });
  }), []), N = rn((I, D) => {
    if (_.current) {
      _.current(I, D);
      return;
    }
    process.env.NODE_ENV !== "production" && console.warn(`[actions] toast('${I}') called but no toast prop was provided to <ActionRootBase>.`);
  }, []), T = rn(() => {
    h((I) => (I.resolve?.(!0), al));
  }, []), L = rn(() => {
    h((I) => (I.resolve?.(!1), al));
  }, []), M = rn(async (I, D, z, U, G) => {
    const J = `${I.id}::${Eo.stableKey(I.id, D, I.key)}`, se = new AbortController();
    l.set(J, {
      abort: se,
      startedAt: Date.now()
    });
    const Q = {
      chain: z,
      confirm: F,
      dispatch: ((ce, W) => $.current(ce, W)),
      selection: G,
      signal: se.signal,
      toast: N
    };
    try {
      await I.run(D, Q);
    } catch (ce) {
      throw C.current && C.current(ce, {
        action: I,
        payload: D,
        surface: U
      }), ce;
    } finally {
      l.delete(J);
    }
  }, [F, N, l]), A = rn(async (I, D, z = "dispatch") => {
    const U = Bt.actionsById.get(I);
    if (!U) {
      const se = new Error(`Action '${I}' is not registered.`);
      throw C.current && C.current(se, {
        action: {
          id: I,
          label: I,
          /** Stub action used solely to populate the onError ctx for unregistered ids. */
          run: () => {
          }
        },
        payload: D,
        surface: z
      }), se;
    }
    const G = O(), J = Ws(G, U.scopeTypeId);
    await M(U.action, D, G, z, J);
  }, [O, M]), $ = mn(A);
  $.current = A, $n(() => {
    if (typeof document > "u") return;
    const I = (D) => {
      if (!w.current) return;
      const z = D.composedPath();
      let U = Eo.resolveChain(z);
      U.length === 0 && (U = O()), j(U);
      const G = gC(D.target), J = D.metaKey || D.ctrlKey || D.altKey, Q = [...[...U].reverse()];
      Bt.scopeTypes.get(Fr) && Q.push({
        element: document.documentElement,
        payload: {},
        scopeTypeId: Fr
      });
      for (const W of Q) {
        const oe = Bt.scopeTypes.get(W.scopeTypeId);
        if (oe)
          for (const Y of sg(oe.actions)) {
            if (!Y.shortcut) continue;
            const Z = lo.parse(Y.shortcut);
            if (!Z || !lo.matches(Z, D) || G && !J && Z.modifiers.length === 0) continue;
            const K = Ws(U, W.scopeTypeId), X = Tf(U, K, F, N, $);
            if (!(Y.hidden && Y.hidden(W.payload, X)) && !(Y.disabled && Y.disabled(W.payload, X))) {
              D.preventDefault(), D.stopPropagation(), M(Y, W.payload, U, "keyboard", K).catch(() => {
              });
              return;
            }
          }
      }
    };
    return document.addEventListener("keydown", I), () => {
      document.removeEventListener("keydown", I);
    };
  }, [F, j, O, M, N]), $n(() => {
    if (typeof document > "u") return;
    const I = (D) => {
      if (!w.current) return;
      const z = D.composedPath(), U = Eo.resolveChain(z);
      if (x.current = U, j(U), U.length === 0) return;
      const G = [], J = [...U].reverse();
      for (const se of J) {
        const Q = Bt.scopeTypes.get(se.scopeTypeId);
        if (!Q) continue;
        const ce = Ws(U, se.scopeTypeId), W = Tf(U, ce, F, N, $);
        for (const oe of Q.actions) {
          const Y = ig(oe, se.scopeTypeId, se.payload, W);
          Y && G.push(Y);
        }
      }
      G.length !== 0 && (D.preventDefault(), y({
        items: G,
        open: !0,
        position: {
          x: D.clientX,
          y: D.clientY
        }
      }));
    };
    return document.addEventListener("contextmenu", I), () => {
      document.removeEventListener("contextmenu", I);
    };
  }, [F, j, N]), $n(() => {
    if (typeof document > "u") return;
    const I = (D) => {
      const z = D.composedPath();
      v.current = z, j(Eo.resolveChain(z));
    };
    return document.addEventListener("pointerdown", I), () => {
      document.removeEventListener("pointerdown", I);
    };
  }, [j]), $n(() => (w.current = !0, () => {
    w.current = !1;
  }), []);
  const k = rn((I) => {
    y((U) => ({
      ...U,
      open: !1
    }));
    const D = x.current, z = Ws(D, I.scopeTypeId);
    M(I.action, I.payload, D, "menu", z).catch(() => {
    });
  }, [M]), H = rn(() => {
    y((I) => ({
      ...I,
      open: !1
    }));
  }, []), B = rn((I) => (E.current.add(I), () => {
    E.current.delete(I);
  }), []), P = rn(() => S.current, []), V = ad(() => ({
    confirm: F,
    dispatch: A,
    getActiveChain: P,
    helpOpen: d,
    inFlightStore: l,
    onError: s,
    paletteOpen: c,
    setHelpOpen: p,
    setPaletteOpen: u,
    subscribeToChain: B,
    toast: N
  }), [F, A, N, P, d, l, s, c, B]);
  return /* @__PURE__ */ b.jsxs(Ss.Provider, { value: V, children: [
    o,
    /* @__PURE__ */ b.jsx(e, { body: m.body, cancelLabel: m.cancelLabel, confirmLabel: m.confirmLabel, destructive: m.destructive, onCancel: L, onConfirm: T, open: m.open, title: m.title }),
    n ? /* @__PURE__ */ b.jsx(n, { items: g.items, onClose: H, onSelect: k, open: g.open, position: g.position }) : null
  ] });
}, sg = (t) => {
  const e = [];
  for (const n of t)
    e.push(n), n.children && n.children.length > 0 && e.push(...sg(n.children));
  return e;
}, Ws = (t, e) => Bt.scopeTypes.get(e)?.selectable ? t.some((o) => o.scopeTypeId === e) ? Eo.resolveSelection(e) : [] : [], ig = (t, e, n, o) => {
  if (t.hidden && t.hidden(n, o)) return null;
  const r = typeof t.label == "function" ? t.label(n, o) : t.label;
  let s = t.icon;
  typeof t.icon == "function" && t.icon.length === 2 && (s = t.icon(n, o));
  const i = {
    action: t,
    icon: s,
    iconColor: t.iconColor,
    label: r,
    payload: n,
    scopeTypeId: e,
    shortcut: t.shortcut
  };
  if (t.children && t.children.length > 0) {
    const l = [];
    for (const c of t.children) {
      const u = ig(c, e, n, o);
      u && l.push(u);
    }
    if (l.length > 0) return {
      ...i,
      children: l
    };
  }
  const a = t.disabled ? t.disabled(n, o) : !1;
  return t.destructive === !0 ? {
    ...i,
    destructive: !0,
    disabled: a
  } : {
    ...i,
    disabled: a,
    selected: !1
  };
}, Tf = (t, e, n, o, r) => ({
  chain: t,
  confirm: n,
  dispatch: ((s, i) => r.current(s, i)),
  selection: e,
  signal: new AbortController().signal,
  toast: o
}), If = /* @__PURE__ */ new Set(), vC = (t) => {
  const e = (n) => {
    const o = ee.c(3), {
      children: r,
      className: s,
      style: i,
      ...a
    } = n, l = Ki(Ss), c = mn(!1);
    let u, d;
    o[0] !== l ? (u = () => {
      c.current || (c.current = !0, process.env.NODE_ENV !== "production" && (l || If.has(t.id) || (If.add(t.id), console.warn(`[actions] Scope '${t.id}' rendered without an <ActionRoot> ancestor — keyboard shortcuts and right-click menus will not work.`))));
    }, d = [l], o[0] = l, o[1] = u, o[2] = d) : (u = o[1], d = o[2]), $n(u, d);
    const {
      selected: p,
      ...m
    } = a, h = p === !0, y = {
      ...t.attrs(m),
      "data-scope": t.id
    };
    return t.selectable && h && (y["data-selected"] = ""), s !== void 0 && (y.className = s), i !== void 0 && (y.style = i), fr("div", y, r);
  };
  return e.displayName = `Scope(${t.id})`, e;
};
Bt._setScopeWrapperFactory(vC);
const yC = [], ag = () => {
  const t = Ki(Ss);
  return Lp(t ? t.subscribeToChain : xC, t ? t.getActiveChain : Of, Of);
}, xC = () => () => {
}, Of = () => yC, wC = "_overlay_fuq4r_2", SC = "_card_fuq4r_13", EC = "_icon_fuq4r_28", CC = "_title_fuq4r_35", _C = "_description_fuq4r_43", RC = "_errorDetails_fuq4r_50", NC = "_button_fuq4r_69", So = {
  overlay: wC,
  card: SC,
  icon: EC,
  title: CC,
  description: _C,
  errorDetails: RC,
  button: NC
};
function Mf(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array" && "BYTES_PER_ELEMENT" in t && t.BYTES_PER_ELEMENT === 1;
}
const oc = (t) => t ? `"${t}" ` : "";
function Pf(t, e = "") {
  if (typeof t != "number")
    throw new TypeError(oc(e) + "expected number, got " + typeof t);
  if (!Number.isSafeInteger(t) || t < 0)
    throw new RangeError(oc(e) + "expected integer >= 0, got " + t);
  return t;
}
function Ta(t, e, n = "") {
  if (Mf(t) && e === void 0)
    return t;
  const o = Mf(t), r = "", s = o ? `length=${t.length}` : `type=${typeof t}`, i = oc(n) + "expected Uint8Array" + r + ", got " + s;
  throw o ? new RangeError(i) : new TypeError(i);
}
function kC(t) {
  if (typeof t != "function" || typeof t.create != "function")
    throw new TypeError("expected hash wrapped by utils.createHasher");
  if (Pf(t.outputLen), Pf(t.blockLen), t.outputLen < 1 || t.blockLen < 1)
    throw new Error("hash blockLen / outputLen must be >= 1");
}
const Af = (t, e) => {
  if (t === null || typeof t != "object" || Array.isArray(t))
    throw new TypeError((e === "object" ? "" : `"${e}" `) + "expected object, got type=" + typeof t);
};
function Pi(t, e = !0) {
  if (t.destroyed)
    throw new Error("hash was destroyed");
  if (e && t.finished)
    throw new Error("digest() was already called");
}
function lg(t, e) {
  Ta(t, void 0, "output");
  const n = e.outputLen;
  if (!(t.length >= n))
    throw new RangeError('"output" expected length >= ' + n);
}
function rc(...t) {
  for (let e = 0; e < t.length; e++)
    t[e].fill(0);
}
function ll(t) {
  return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
function Sn(t, e) {
  return t << 32 - e | t >>> e;
}
const TC = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", IC = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function Df(t) {
  if (Ta(t), TC)
    return t.toHex();
  let e = "";
  for (let n = 0; n < t.length; n++)
    e += IC[t[n]];
  return e;
}
function cl(t) {
  if (typeof t != "string")
    throw new TypeError("string expected");
  return new Uint8Array(new TextEncoder().encode(t));
}
function OC(t, e, n = "opts") {
  return Af(t, "defaults"), e !== void 0 && Af(e, n), Object.assign(t, e);
}
function MC(t, e = {}) {
  if (typeof t != "function")
    throw new TypeError('"hashCons" expected function, got type=' + typeof t);
  e = OC({}, e, "info");
  const n = (r, s) => t(s).update(r).digest(), o = t(void 0);
  return n.outputLen = o.outputLen, n.blockLen = o.blockLen, n.canXOF = o.canXOF, n.create = (r) => t(r), Object.assign(n, e), Object.freeze(n);
}
const PC = (t) => ({
  // Current NIST hashAlgs suffixes used here fit in one DER subidentifier octet.
  // Larger suffix values would need base-128 OID encoding and a different length byte.
  oid: Uint8Array.from([6, 9, 96, 134, 72, 1, 101, 3, 4, 2, t])
});
class jf {
  constructor(e, n) {
    Re(this, "oHash");
    Re(this, "iHash");
    Re(this, "blockLen");
    Re(this, "outputLen");
    Re(this, "canXOF", !1);
    Re(this, "finished", !1);
    Re(this, "destroyed", !1);
    if (kC(e), Ta(n, void 0, "key"), this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new Error("expected Hash instance");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const o = this.blockLen, r = new Uint8Array(o);
    r.set(n.length > o ? e.create().update(n).digest() : n);
    for (let s = 0; s < r.length; s++)
      r[s] ^= 54;
    this.iHash.update(r), this.oHash = e.create();
    for (let s = 0; s < r.length; s++)
      r[s] ^= 106;
    this.oHash.update(r), rc(r);
  }
  update(e) {
    return Pi(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    Pi(this), lg(e, this), this.finished = !0;
    const n = e.subarray(0, this.outputLen);
    this.iHash.digestInto(n), this.oHash.update(n), this.oHash.digestInto(n), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: n, iHash: o, finished: r, destroyed: s, blockLen: i, outputLen: a, canXOF: l } = this;
    return e = e, e.finished = r, e.destroyed = s, e.blockLen = i, e.outputLen = a, e.canXOF = l, e.oHash = n._cloneInto(e.oHash), e.iHash = o._cloneInto(e.iHash), e;
  }
  clone() {
    return this._cloneInto();
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const AC = /* @__PURE__ */ (() => {
  const t = ((e, n, o) => new jf(e, n).update(o).digest());
  return t.create = (e, n) => new jf(e, n), t;
})(), DC = (t) => t / 2 ** 32 | 0, jC = (t) => t >>> 0;
function LC(t, e, n, o) {
  const r = DC(n), s = jC(n);
  t.setUint32(e, o ? s : r, o), t.setUint32(e + 4, o ? r : s, o);
}
function $C(t, e, n) {
  return t & e ^ ~t & n;
}
function FC(t, e, n) {
  return t & e ^ t & n ^ e & n;
}
class VC {
  constructor(e, n, o, r) {
    Re(this, "blockLen");
    Re(this, "outputLen");
    Re(this, "canXOF", !1);
    Re(this, "padOffset");
    Re(this, "isLE");
    // For partial updates less than block size
    Re(this, "buffer");
    Re(this, "view");
    Re(this, "finished", !1);
    Re(this, "length", 0);
    Re(this, "pos", 0);
    Re(this, "destroyed", !1);
    this.blockLen = e, this.outputLen = n, this.padOffset = o, this.isLE = r, this.buffer = new Uint8Array(e), this.view = ll(this.buffer);
  }
  update(e) {
    Pi(this), Ta(e);
    const { view: n, buffer: o, blockLen: r } = this, s = e.length;
    let i = !1;
    for (let a = 0; a < s; ) {
      const l = Math.min(r - this.pos, s - a);
      if (l === r) {
        const c = ll(e);
        for (; r <= s - a; a += r)
          this.process(c, a);
        i = !0;
        continue;
      }
      o.set(a === 0 && l === s ? e : e.subarray(a, a + l), this.pos), this.pos += l, a += l, this.pos === r && (this.process(n, 0), this.pos = 0, i = !0);
    }
    return this.length += e.length, i && this.roundClean(), this;
  }
  digestInto(e) {
    Pi(this), lg(e, this), this.finished = !0;
    const { buffer: n, view: o, blockLen: r, isLE: s } = this;
    let { pos: i } = this;
    n[i++] = 128, n.fill(0, i), this.padOffset > r - i && (this.process(o, 0), n.fill(0)), LC(o, r - 8, this.length * 8, s), this.process(o, 0), this.roundClean();
    const a = e === n ? o : ll(e), l = this.outputLen, c = l / 4, u = this.get();
    if (l % 4 || c > u.length)
      throw new Error("invalid outputLen");
    for (let d = 0; d < c; d++)
      a.setUint32(4 * d, u[d], s);
  }
  digest() {
    const { buffer: e, outputLen: n } = this;
    this.digestInto(e);
    const o = e.slice(0, n);
    return this.destroy(), o;
  }
  _cloneIntoMeta(e) {
    const { buffer: n, length: o, finished: r, destroyed: s, pos: i } = this;
    return e.destroyed = s, e.finished = r, e.length = o, e.pos = i, i && e.buffer.set(n), e;
  }
  clone() {
    return this._cloneInto();
  }
}
const zC = /* @__PURE__ */ Uint32Array.from([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), BC = /* @__PURE__ */ Uint32Array.from([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Qn = /* @__PURE__ */ new Uint32Array(64);
class HC extends VC {
  constructor(n, o) {
    super(64, n, 8, !1);
    // We cannot use array here since array allows indexing by variable
    // which means optimizer/compiler cannot use registers.
    // Numeric initializers matter: starting the fields as `undefined` changes
    // V8's field representation and makes sha256 3x slower (measured).
    Re(this, "A", 0);
    Re(this, "B", 0);
    Re(this, "C", 0);
    Re(this, "D", 0);
    Re(this, "E", 0);
    Re(this, "F", 0);
    Re(this, "G", 0);
    Re(this, "H", 0);
    this.A = o[0] | 0, this.B = o[1] | 0, this.C = o[2] | 0, this.D = o[3] | 0, this.E = o[4] | 0, this.F = o[5] | 0, this.G = o[6] | 0, this.H = o[7] | 0;
  }
  get() {
    const { A: n, B: o, C: r, D: s, E: i, F: a, G: l, H: c } = this;
    return [n, o, r, s, i, a, l, c];
  }
  // prettier-ignore
  set(n, o, r, s, i, a, l, c) {
    this.A = n | 0, this.B = o | 0, this.C = r | 0, this.D = s | 0, this.E = i | 0, this.F = a | 0, this.G = l | 0, this.H = c | 0;
  }
  _cloneInto(n) {
    return (n || (n = new this.constructor())).set(...this.get()), this._cloneIntoMeta(n);
  }
  process(n, o) {
    for (let p = 0; p < 16; p++, o += 4)
      Qn[p] = n.getUint32(o, !1);
    for (let p = 16; p < 64; p++) {
      const m = Qn[p - 15], h = Qn[p - 2], g = Sn(m, 7) ^ Sn(m, 18) ^ m >>> 3, y = Sn(h, 17) ^ Sn(h, 19) ^ h >>> 10;
      Qn[p] = y + Qn[p - 7] + g + Qn[p - 16] | 0;
    }
    let { A: r, B: s, C: i, D: a, E: l, F: c, G: u, H: d } = this;
    for (let p = 0; p < 64; p++) {
      const m = Sn(l, 6) ^ Sn(l, 11) ^ Sn(l, 25), h = d + m + $C(l, c, u) + BC[p] + Qn[p] | 0, y = (Sn(r, 2) ^ Sn(r, 13) ^ Sn(r, 22)) + FC(r, s, i) | 0;
      d = u, u = c, c = l, l = a + h | 0, a = i, i = s, s = r, r = h + y | 0;
    }
    r = r + this.A | 0, s = s + this.B | 0, i = i + this.C | 0, a = a + this.D | 0, l = l + this.E | 0, c = c + this.F | 0, u = u + this.G | 0, d = d + this.H | 0, this.set(r, s, i, a, l, c, u, d);
  }
  roundClean() {
    rc(Qn);
  }
  destroy() {
    this.destroyed = !0, this.set(0, 0, 0, 0, 0, 0, 0, 0), rc(this.buffer);
  }
}
class UC extends HC {
  constructor() {
    super(32, zC);
  }
}
const Lf = /* @__PURE__ */ MC(
  () => new UC(),
  /* @__PURE__ */ PC(1)
), cg = {
  /**
   * Computes the SHA-256 hex digest of the given input.
   * @param input - The string or raw bytes to hash.
   * @returns The lowercase hex SHA-256 digest.
   */
  hash(t) {
    return Df(Lf(typeof t == "string" ? cl(t) : t));
  },
  /**
   * Computes the HMAC-SHA256 hex digest of the given message.
   * @param secret - The secret key; a string is read as UTF-8.
   * @param message - The message to sign.
   * @returns The lowercase hex HMAC-SHA256 digest.
   */
  hmac(t, e) {
    return Df(cg.hmacBytes(t, e));
  },
  /**
   * Computes the HMAC-SHA256 of the given message as raw bytes. Needed by key-derivation chains that feed
   * one HMAC's raw output in as the next one's key — notably AWS SigV4, where re-hexing each intermediate
   * would produce a different (wrong) signing key.
   * @param secret - The secret key; a string is read as UTF-8.
   * @param message - The message to sign.
   * @returns The 32-byte HMAC-SHA256 digest.
   */
  hmacBytes(t, e) {
    return AC(Lf, typeof t == "string" ? cl(t) : t, cl(e));
  }
}, WC = () => {
  if (typeof globalThis > "u") return !1;
  const e = globalThis.window?.location?.hostname;
  return e === "localhost" || e === "127.0.0.1";
}, hn = class hn {
  constructor() {
    Re(this, "config", null);
  }
  /**
   * Unregister the telemetry agent when its React host tears down (eg: the authenticated tree
   * unmounting on logout). Guarded: only clears when `agent` is the currently-registered
   * reference, so a newer agent already registered by a subsequent mount is never clobbered by a
   * late cleanup — a no-op otherwise. This is what lets a re-login register a fresh agent instead
   * of tripping the "already registered" guard in `setAgent`.
   * @param agent - The telemetry agent being torn down.
   */
  static clearAgent(e) {
    hn._registeredAgent === e && (hn._registeredAgent = null);
  }
  /** Returns the currently registered telemetry agent, or `null` if none. */
  static getAgent() {
    return hn._registeredAgent;
  }
  /**
   * Register the singleton telemetry agent at app boot.
   * - Same-reference calls are no-ops (idempotent).
   * - Different-reference calls throw, EXCEPT on localhost (where Vite HMR may rebuild the agent).
   * @param agent - The telemetry agent.
   */
  static setAgent(e) {
    if (hn._registeredAgent !== e) {
      if (hn._registeredAgent !== null) {
        if (WC()) {
          hn._registeredAgent = e;
          return;
        }
        throw new Error("TelemetryAgent is already registered. Replacing the agent is only permitted on localhost (for Vite HMR).");
      }
      hn._registeredAgent = e;
    }
  }
  /** Test-only: clear the registered agent. Production code must never call this. */
  static _resetAgentForTests() {
    hn._registeredAgent = null;
  }
  /**
   * Initialize the logger context with the provided configuration.
   * @param config - The logger context configuration.
   */
  init(e) {
    this.config || (this.config = e);
  }
  /**
   * Retrieves the logger context configuration.
   */
  getConfig() {
    return this.config;
  }
};
/**
 * Module-level singleton agent registry used by `LoggerType.APP` flush delegation.
 * The agent is registered via `LoggerContext.setAgent(...)` when its React host mounts and
 * unregistered via `LoggerContext.clearAgent(...)` when that host tears down (eg: the app
 * unmounting its authenticated tree on logout), so a subsequent mount can register a fresh
 * agent. Tests use `LoggerContext._resetAgentForTests()` between cases.
 */
Re(hn, "_registeredAgent", null);
let Ai = hn;
var lu = /* @__PURE__ */ ((t) => (t.DEBUG = "DEBUG", t.ERROR = "ERROR", t.INFO = "INFO", t.WARN = "WARN", t))(lu || {});
const GC = 16, KC = {
  /**
   * Report an unhandled React error exactly once, from either boundary mechanism: the console line a
   * developer reads, plus — when a telemetry agent is registered — the `app_error_total` counter and the
   * structured `app.error.thrown` event. This is a plain function rather than a hook because the class
   * `ErrorBoundaryAlpha.componentDidCatch` must call it, and React error boundaries must be classes.
   * The agent is resolved at call time via `LoggerContext.getAgent()`; no agent is a safe no-op.
   * @param options - What to report.
   * @param options.componentStack - React's component stack, when available. Console only.
   * @param options.error - The normalized error.
   * @param options.page - Current route path, when known.
   * @param options.raw - The raw pre-normalization value, when the caller had one. Console only.
   * @param options.source - Which boundary caught it.
   */
  report(t) {
    const {
      componentStack: e,
      error: n,
      page: o,
      raw: r,
      source: s
    } = t;
    try {
      const i = [];
      e !== void 0 && i.push({
        componentStack: e
      }), r !== void 0 && i.push({
        raw: r
      }), console.error(`[${s}] Unhandled error`, n, ...i);
      const a = Ai.getAgent();
      if (!a) return;
      const l = {
        stack_hash: YC(n)
      };
      o !== void 0 && (l.page = o), a.counter("app_error_total", 1), a.log({
        data: l,
        event: "app.error.thrown",
        level: lu.ERROR,
        message: n.message
      });
    } catch {
    }
  }
}, YC = (t) => cg.hash(t.stack ?? t.message ?? "").slice(0, GC), qC = {
  /**
   * Reloads the current page. Wrapped on a stable, mockable object so the
   * fallback UI's reload button can be unit-tested in a jsdom environment that
   * marks `window.location` as non-configurable.
   */
  reloadPage() {
    window.location.reload();
  }
}, XC = (t) => {
  const e = ee.c(8), {
    error: n
  } = t;
  let o, r, s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ b.jsxs("svg", { className: So.icon, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [
    /* @__PURE__ */ b.jsx("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ b.jsx("line", { x1: "12", y1: "8", x2: "12", y2: "12" }),
    /* @__PURE__ */ b.jsx("line", { x1: "12", y1: "16", x2: "12.01", y2: "16" })
  ] }), r = /* @__PURE__ */ b.jsx("h1", { className: So.title, children: "Something went wrong" }), s = /* @__PURE__ */ b.jsx("p", { className: So.description, children: "The application encountered an unexpected error. Please reload the page to continue." }), e[0] = o, e[1] = r, e[2] = s) : (o = e[0], r = e[1], s = e[2]);
  let i;
  e[3] !== n ? (i = n && /* @__PURE__ */ b.jsxs("pre", { className: So.errorDetails, children: [
    n.name,
    ": ",
    n.message
  ] }), e[3] = n, e[4] = i) : i = e[4];
  let a;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b.jsx("button", { type: "button", className: So.button, onClick: ZC, children: "Reload page" }), e[5] = a) : a = e[5];
  let l;
  return e[6] !== i ? (l = /* @__PURE__ */ b.jsx("div", { className: So.overlay, role: "alert", "aria-live": "assertive", children: /* @__PURE__ */ b.jsxs("div", { className: So.card, children: [
    o,
    r,
    s,
    i,
    a
  ] }) }), e[6] = i, e[7] = l) : l = e[7], l;
};
class hj extends q.Component {
  /**
   * Initialize the boundary in the non-error state.
   * @param props - Component props.
   */
  constructor(e) {
    super(e), this.state = {
      error: null,
      hasError: !1
    };
  }
  /**
   * React lifecycle hook invoked after a descendant throws during render.
   * Flips the boundary into the error state and captures the error so the
   * fallback UI can display its message.
   * @param error - The error thrown by a descendant component.
   * @returns The next state for the boundary.
   */
  static getDerivedStateFromError(e) {
    return {
      error: e,
      hasError: !0
    };
  }
  /**
   * React lifecycle hook invoked after an error has been caught. Delegates to the shared
   * `reportUnhandledError` so this class path and the router-level `RouteErrorBoundary` emit an
   * identical console line and structured telemetry record.
   * @param error - The error thrown by a descendant component.
   * @param errorInfo - React-provided info including the component stack.
   */
  componentDidCatch(e, n) {
    KC.report({
      componentStack: n.componentStack ?? void 0,
      error: e,
      source: "ErrorBoundaryAlpha"
    });
  }
  /**
   * Renders the fallback UI when an error has been caught, otherwise renders
   * the protected children unchanged.
   * @returns The fallback UI or the children.
   */
  render() {
    return this.state.hasError ? /* @__PURE__ */ b.jsx(XC, { error: this.state.error }) : this.props.children;
  }
}
function ZC() {
  return qC.reloadPage();
}
const ug = (t) => {
  let e = t;
  const n = /* @__PURE__ */ new Set(), o = (a) => (n.add(a), () => {
    n.delete(a);
  });
  return {
    getState: () => e,
    setState: (a) => {
      const l = typeof a == "function" ? a(e) : a;
      e = {
        ...e,
        ...l
      }, n.forEach((c) => c());
    },
    subscribe: o,
    use: (a) => Lp(o, () => a(e), () => a(e))
  };
}, JC = {
  appIsUnselectable: !1
}, ul = ug({
  ...JC
}), $f = {
  /** Returns the current selectability snapshot. */
  getState: ul.getState,
  /**
   * Set whether the app root should be unselectable. Components that initiate a drag call
   * this with `true` on pointer-down and `false` when the drag ends.
   * @param value - The new unselectable state.
   */
  setUnselectable: (t) => ul.setState({
    appIsUnselectable: t
  }),
  /** React hook that subscribes to a slice of state via `useSyncExternalStore`. */
  use: ul.use
}, QC = () => ({
  appIsUnselectable: $f.use((e) => e.appIsUnselectable),
  setAppIsUnselectable: $f.setUnselectable
}), e_ = {
  compact: {
    appHeaderHeight: "calc(var(--density-icon-rail-item-size) + 1.5rem)",
    checkboxIconSize: "14px",
    checkboxSize: "18px",
    controlHeight: "28px",
    controlPaddingY: "4px",
    iconRailItemSize: "31px",
    iconRailWidth: "41px",
    navLabelSize: "13px",
    rowHeight: "32px",
    switchH: "18px",
    switchSmH: "14px",
    switchSmW: "22px",
    switchW: "30px",
    textLeading: "var(--leading-tight)",
    textSize: "var(--text-sm)"
  },
  spacious: {
    appHeaderHeight: "calc(var(--density-icon-rail-item-size) + 1.5rem)",
    checkboxIconSize: "16px",
    checkboxSize: "24px",
    controlHeight: "44px",
    controlPaddingY: "12px",
    iconRailItemSize: "41px",
    iconRailWidth: "55px",
    navLabelSize: "15px",
    rowHeight: "48px",
    switchH: "24px",
    switchSmH: "18px",
    switchSmW: "30px",
    switchW: "40px",
    textLeading: "var(--leading-relaxed)",
    textSize: "var(--text-base)"
  },
  standard: {
    appHeaderHeight: "calc(var(--density-icon-rail-item-size) + 1.5rem)",
    checkboxIconSize: "14px",
    checkboxSize: "20px",
    controlHeight: "36px",
    controlPaddingY: "8px",
    iconRailItemSize: "36px",
    iconRailWidth: "48px",
    navLabelSize: "13px",
    rowHeight: "40px",
    switchH: "20px",
    switchSmH: "16px",
    switchSmW: "26px",
    switchW: "34px",
    textLeading: "var(--leading-normal)",
    textSize: "var(--text-base)"
  }
}, t_ = {
  presets: e_
}, n_ = {
  keyPrefix: ""
};
class dg {
  /**
   * Initializes the TypedLocalStorage service with optional configuration.
   * @param config - Partial configuration to override defaults.
   */
  constructor(e = {}) {
    Re(this, "config");
    this.config = {
      ...n_,
      ...e
    };
  }
  /**
   * Reads a raw string value from localStorage.
   * Returns null if unavailable, missing, or on error.
   * @param key - The key to retrieve.
   */
  get(e) {
    if (typeof window > "u") return null;
    try {
      return window.localStorage.getItem(this._getPrefixedKey(e));
    } catch {
      return null;
    }
  }
  /**
   * Reads and JSON-parses a value from localStorage.
   * Returns null if unavailable, missing, or unparseable.
   * @param key - The key to retrieve and parse.
   */
  getJSON(e) {
    if (typeof window > "u") return null;
    try {
      const n = window.localStorage.getItem(this._getPrefixedKey(e));
      return n === null ? null : JSON.parse(n);
    } catch {
      return null;
    }
  }
  /**
   * Checks if localStorage is available and functional.
   */
  isLocalStorageAvailable() {
    if (typeof window > "u") return !1;
    try {
      const e = "__localStorage_test__";
      return window.localStorage.setItem(e, "test"), window.localStorage.removeItem(e), !0;
    } catch {
      return !1;
    }
  }
  /**
   * Removes a key from localStorage. Silently ignores errors.
   * @param key - The key to remove.
   */
  remove(e) {
    if (!(typeof window > "u"))
      try {
        window.localStorage.removeItem(this._getPrefixedKey(e));
      } catch {
      }
  }
  /**
   * Writes a string value to localStorage. Silently ignores errors.
   * @param key - The key to write.
   * @param value - The string value to store.
   */
  set(e, n) {
    if (!(typeof window > "u"))
      try {
        window.localStorage.setItem(this._getPrefixedKey(e), n);
      } catch {
      }
  }
  /**
   * JSON-stringifies and writes a value to localStorage. Silently ignores errors.
   * @param key - The key to write.
   * @param value - The value to JSON-stringify and store.
   */
  setJSON(e, n) {
    if (!(typeof window > "u"))
      try {
        window.localStorage.setItem(this._getPrefixedKey(e), JSON.stringify(n));
      } catch {
      }
  }
  /**
   * Writes a string value to localStorage, propagating any error (eg: `QuotaExceededError`).
   * Use this when the caller needs to react to a failed write — most callers should use `set` instead.
   * SSR is still short-circuited to a no-op.
   * @param key - The key to write.
   * @param value - The string value to store.
   */
  setStrict(e, n) {
    typeof window > "u" || window.localStorage.setItem(this._getPrefixedKey(e), n);
  }
  /**
   * Generates a prefixed key to avoid collisions in localStorage.
   * Eg: If the key is "userSettings" and the prefix is "app_", the resulting key will be "app_userSettings".
   * @param key - The original key (non-prefixed).
   */
  _getPrefixedKey(e) {
    return `${this.config.keyPrefix}${e}`;
  }
}
const o_ = "app_", fg = new dg({
  keyPrefix: o_
}), pg = f.createContext(void 0), sc = /* @__PURE__ */ new Set(), mg = () => fg.get("debug") === "true", r_ = (t) => {
  for (const e of sc) e(t);
}, cu = () => {
  const t = ee.c(4), [e, n] = f.useState(mg);
  let o, r;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = () => {
    const a = (l) => n(l);
    return sc.add(a), () => {
      sc.delete(a);
    };
  }, r = [], t[0] = o, t[1] = r) : (o = t[0], r = t[1]), f.useEffect(o, r);
  const s = s_;
  let i;
  return t[2] !== e ? (i = {
    isDebug: e,
    toggleDebug: s
  }, t[2] = e, t[3] = i) : i = t[3], i;
};
function s_() {
  const t = !mg();
  fg.set("debug", String(t)), r_(t);
}
const dl = 768, gj = () => {
  const t = ee.c(2), [e, n] = f.useState(void 0);
  let o, r;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = () => {
    const s = window.matchMedia(`(max-width: ${dl - 1}px)`), i = () => {
      n(window.innerWidth < dl);
    };
    return s.addEventListener("change", i), n(window.innerWidth < dl), () => s.removeEventListener("change", i);
  }, r = [], t[0] = o, t[1] = r) : (o = t[0], r = t[1]), f.useEffect(o, r), !!e;
}, hg = {
  hasCustomLayout: !1,
  resetLayout: null
}, Di = ug({
  ...hg
}), ji = /* @__PURE__ */ new Map(), Ff = () => {
  if (ji.size === 0) {
    Di.setState({
      ...hg
    });
    return;
  }
  let t = !1;
  const e = [];
  for (const o of ji.values())
    o.hasCustomLayout && (t = !0), o.resetLayout && e.push(o.resetLayout);
  const n = e.length === 0 ? null : () => e.forEach((o) => o());
  Di.setState({
    hasCustomLayout: t,
    resetLayout: n
  });
}, Vf = {
  /** Returns the aggregated layout state snapshot across all registered splits. */
  getState: Di.getState,
  /**
   * Register (or replace) the entry for a given token. Called by each split component
   * on mount and on every layout change. Tokens are typically `React.useId()` values.
   * @param token - Stable per-instance token identifying this split.
   * @param entry - Current `hasCustomLayout` flag and optional `resetLayout` callback.
   */
  register: (t, e) => {
    ji.set(t, e), Ff();
  },
  /**
   * Remove the entry for a given token when its component unmounts.
   * @param token - Stable per-instance token identifying this split.
   */
  unregister: (t) => {
    ji.delete(t), Ff();
  },
  /** React hook that subscribes to a slice of the aggregated state via `useSyncExternalStore`. */
  use: Di.use
}, Lt = new dg(), i_ = {
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32
}, a_ = {
  compact: 0.85,
  standard: 1,
  spacious: 1.15
}, no = (t) => {
  const e = ee.c(12), {
    icon: n,
    size: o,
    className: r,
    "aria-label": s
  } = t, i = o === void 0 ? "md" : o, l = f.useContext(pg)?.density ?? "standard", c = typeof i == "number" ? i : i_[i];
  let u;
  e[0] !== c || e[1] !== l ? (u = Math.round(c * a_[l]), e[0] = c, e[1] = l, e[2] = u) : u = e[2];
  const d = u;
  let p;
  e[3] !== s ? (p = s ? {
    role: "img",
    "aria-label": s
  } : {
    "aria-hidden": !0
  }, e[3] = s, e[4] = p) : p = e[4];
  const m = p;
  let h;
  e[5] !== r ? (h = ae("shrink-0", r), e[5] = r, e[6] = h) : h = e[6];
  let g;
  return e[7] !== m || e[8] !== n || e[9] !== d || e[10] !== h ? (g = /* @__PURE__ */ b.jsx(Ve, { icon: n, width: d, height: d, color: "currentColor", className: h, ...m }), e[7] = m, e[8] = n, e[9] = d, e[10] = h, e[11] = g) : g = e[11], g;
}, bj = (t) => {
  const e = ee.c(15), {
    className: n,
    disabled: o,
    onValueChange: r,
    options: s,
    value: i,
    "aria-labelledby": a,
    "aria-describedby": l
  } = t;
  let c;
  e[0] !== r || e[1] !== i ? (c = (m) => {
    typeof m != "string" || m === i || r(m);
  }, e[0] = r, e[1] = i, e[2] = c) : c = e[2];
  let u;
  e[3] !== n ? (u = ae(Yr.group, n), e[3] = n, e[4] = u) : u = e[4];
  let d;
  e[5] !== s ? (d = s.map(l_), e[5] = s, e[6] = d) : d = e[6];
  let p;
  return e[7] !== l || e[8] !== a || e[9] !== o || e[10] !== c || e[11] !== u || e[12] !== d || e[13] !== i ? (p = /* @__PURE__ */ b.jsx(ka, { "data-slot": "choice-list", "aria-labelledby": a, "aria-describedby": l, disabled: o, value: i, onValueChange: c, className: u, children: d }), e[7] = l, e[8] = a, e[9] = o, e[10] = c, e[11] = u, e[12] = d, e[13] = i, e[14] = p) : p = e[14], p;
};
function l_(t) {
  return /* @__PURE__ */ b.jsxs(Na, { "data-slot": "choice-list-row", "aria-label": t.label, disabled: t.disabled, value: t.value, className: Yr.row, children: [
    t.leading === void 0 ? null : /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", className: Yr.leading, children: t.leading }),
    /* @__PURE__ */ b.jsx("span", { className: Yr.label, children: t.label }),
    /* @__PURE__ */ b.jsx("span", { className: Yr.check, children: /* @__PURE__ */ b.jsx(no, { icon: Tr, size: "sm" }) })
  ] }, t.value);
}
const gg = {
  ...Qp,
  ...tn
}, bg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    defaultOpen: s = !1,
    disabled: i = !1,
    onOpenChange: a,
    open: l,
    ...c
  } = e, u = fe(a), d = Xp({
    open: l,
    defaultOpen: s,
    onOpenChange: u,
    disabled: i
  }), p = f.useMemo(() => ({
    open: d.open,
    disabled: d.disabled,
    transitionStatus: d.transitionStatus
  }), [d.open, d.disabled, d.transitionStatus]), m = f.useMemo(() => ({
    ...d,
    onOpenChange: u,
    state: p
  }), [d, u, p]), h = _e("div", e, {
    state: p,
    ref: n,
    props: c,
    stateAttributesMapping: gg
  });
  return /* @__PURE__ */ b.jsx(Xi.Provider, {
    value: m,
    children: h
  });
});
process.env.NODE_ENV !== "production" && (bg.displayName = "CollapsibleRoot");
const c_ = {
  ...Jp,
  ...tn
}, vg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    panelId: o,
    open: r,
    handleTrigger: s,
    state: i,
    disabled: a
  } = Zi(), {
    className: l,
    disabled: c = a,
    id: u,
    render: d,
    nativeButton: p = !0,
    ...m
  } = e, {
    getButtonProps: h,
    buttonRef: g
  } = Wt({
    disabled: c,
    focusableWhenDisabled: !0,
    native: p
  }), y = f.useMemo(() => ({
    "aria-controls": r ? o : void 0,
    "aria-expanded": r,
    onClick: s
  }), [o, r, s]);
  return _e("button", e, {
    state: i,
    ref: [n, g],
    props: [y, m, h],
    stateAttributesMapping: c_
  });
});
process.env.NODE_ENV !== "production" && (vg.displayName = "CollapsibleTrigger");
let zf = /* @__PURE__ */ (function(t) {
  return t.collapsiblePanelHeight = "--collapsible-panel-height", t.collapsiblePanelWidth = "--collapsible-panel-width", t;
})({});
const yg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    hiddenUntilFound: r,
    keepMounted: s,
    render: i,
    id: a,
    ...l
  } = e;
  process.env.NODE_ENV !== "production" && he(() => {
    r && s === !1 && cs("The `keepMounted={false}` prop on a Collapsible will be ignored when using `hiddenUntilFound` since it requires the Panel to remain mounted even when closed.");
  }, [r, s]);
  const {
    abortControllerRef: c,
    animationTypeRef: u,
    height: d,
    mounted: p,
    onOpenChange: m,
    open: h,
    panelId: g,
    panelRef: y,
    runOnceAnimationsFinish: v,
    setDimensions: x,
    setHiddenUntilFound: w,
    setKeepMounted: E,
    setMounted: S,
    setPanelIdState: C,
    setOpen: _,
    setVisible: R,
    state: O,
    transitionDimensionRef: j,
    visible: F,
    width: N,
    transitionStatus: T
  } = Zi(), L = r ?? !1, M = s ?? !1;
  he(() => {
    if (a)
      return C(a), () => {
        C(void 0);
      };
  }, [a, C]), he(() => {
    w(L);
  }, [w, L]), he(() => {
    E(M);
  }, [E, M]);
  const {
    props: A
  } = Lm({
    abortControllerRef: c,
    animationTypeRef: u,
    externalRef: n,
    height: d,
    hiddenUntilFound: L,
    id: g,
    keepMounted: M,
    mounted: p,
    onOpenChange: m,
    open: h,
    panelRef: y,
    runOnceAnimationsFinish: v,
    setDimensions: x,
    setMounted: S,
    setOpen: _,
    setVisible: R,
    transitionDimensionRef: j,
    visible: F,
    width: N
  });
  Gt({
    open: h && T === "idle",
    ref: y,
    onComplete() {
      h && x({
        height: void 0,
        width: void 0
      });
    }
  });
  const $ = f.useMemo(() => ({
    ...O,
    transitionStatus: T
  }), [O, T]), k = _e("div", e, {
    state: $,
    ref: [n, y],
    props: [A, {
      style: {
        [zf.collapsiblePanelHeight]: d === void 0 ? "auto" : `${d}px`,
        [zf.collapsiblePanelWidth]: N === void 0 ? "auto" : `${N}px`
      }
    }, l],
    stateAttributesMapping: gg
  });
  return M || L || !M && p ? k : null;
});
process.env.NODE_ENV !== "production" && (yg.displayName = "CollapsiblePanel");
const vj = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(bg, { "data-slot": "collapsible", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, yj = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(vg, { "data-slot": "collapsible-trigger", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, xj = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(yg, { "data-slot": "collapsible-content", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, u_ = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></g>'
}, d_ = u_, f_ = "_copy_ppehz_1", p_ = "_glyphs_ppehz_29", m_ = "_copyIcon_ppehz_36", h_ = "_checkIcon_ppehz_37", g_ = "_copied_ppehz_66", b_ = "_srOnly_ppehz_79", Wo = {
  copy: f_,
  glyphs: p_,
  copyIcon: m_,
  checkIcon: h_,
  copied: g_,
  srOnly: b_
}, v_ = 1500, xg = ({
  className: t,
  copiedLabel: e = "Copied",
  label: n = "Copy",
  onClick: o,
  onCopied: r,
  value: s,
  ...i
}) => {
  const [a, l] = f.useState(!1), c = f.useRef(null);
  f.useEffect(() => () => {
    c.current && clearTimeout(c.current);
  }, []);
  const u = async (d) => {
    o?.(d);
    try {
      await navigator.clipboard.writeText(typeof s == "function" ? s() : s), l(!0), r?.(), c.current && clearTimeout(c.current), c.current = setTimeout(() => l(!1), v_);
    } catch {
    }
  };
  return /* @__PURE__ */ b.jsxs("button", { ...i, "aria-label": a ? e : n, className: ae(Wo.copy, a && Wo.copied, t), onClick: (d) => {
    u(d);
  }, type: "button", children: [
    /* @__PURE__ */ b.jsxs("span", { className: Wo.glyphs, children: [
      /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", className: Wo.copyIcon, children: /* @__PURE__ */ b.jsx(Ve, { icon: d_ }) }),
      /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", className: Wo.checkIcon, children: /* @__PURE__ */ b.jsx("svg", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, viewBox: "0 0 24 24", children: /* @__PURE__ */ b.jsx("path", { d: "M20 6 9 17l-5-5", pathLength: 1 }) }) })
    ] }),
    /* @__PURE__ */ b.jsx("span", { className: Wo.srOnly, role: "status", "aria-live": "polite", children: a ? e : "" })
  ] });
}, y_ = "_root_1su08_1", x_ = "_titleBand_1su08_9", w_ = "_filterBand_1su08_10", S_ = "_rootFill_1su08_14", E_ = "_scrollShell_1su08_19", C_ = "_scrollShellFill_1su08_28", __ = "_scrollAreaFill_1su08_33", R_ = "_progress_1su08_38", N_ = "_noSelect_1su08_45", k_ = "_headerCell_1su08_49", T_ = "_sortTrigger_1su08_55", I_ = "_headerLabel_1su08_77", O_ = "_headerCellEnd_1su08_85", M_ = "_dragBar_1su08_89", P_ = "_checkboxCell_1su08_140", Ot = {
  root: y_,
  titleBand: x_,
  filterBand: w_,
  rootFill: S_,
  scrollShell: E_,
  scrollShellFill: C_,
  scrollAreaFill: __,
  progress: R_,
  noSelect: N_,
  headerCell: k_,
  sortTrigger: T_,
  headerLabel: I_,
  headerCellEnd: O_,
  dragBar: M_,
  checkboxCell: P_
}, A_ = "_root_rb85q_1", D_ = "_indicator_rb85q_9", j_ = "_indeterminate_rb85q_18", fl = {
  root: A_,
  indicator: D_,
  indeterminate: j_
}, L_ = (t) => {
  const e = ee.c(22);
  let n, o, r, s, i;
  e[0] !== t ? ({
    active: r,
    className: n,
    label: s,
    value: i,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  const a = r === void 0 ? !1 : r, l = s === void 0 ? "Loading" : s;
  if (!a)
    return null;
  const c = i !== void 0, u = c ? Math.max(0, Math.min(100, i)) : void 0;
  let d;
  e[6] !== n ? (d = ae(fl.root, n), e[6] = n, e[7] = d) : d = e[7];
  const p = !c && fl.indeterminate;
  let m;
  e[8] !== p ? (m = ae(fl.indicator, p), e[8] = p, e[9] = m) : m = e[9];
  let h;
  e[10] !== u || e[11] !== c ? (h = c ? {
    inlineSize: `${u}%`
  } : void 0, e[10] = u, e[11] = c, e[12] = h) : h = e[12];
  let g;
  e[13] !== m || e[14] !== h ? (g = /* @__PURE__ */ b.jsx("span", { className: m, style: h }), e[13] = m, e[14] = h, e[15] = g) : g = e[15];
  let y;
  return e[16] !== u || e[17] !== l || e[18] !== o || e[19] !== d || e[20] !== g ? (y = /* @__PURE__ */ b.jsx("div", { ...o, "aria-label": l, "aria-valuemax": 100, "aria-valuemin": 0, "aria-valuenow": u, className: d, role: "progressbar", children: g }), e[16] = u, e[17] = l, e[18] = o, e[19] = d, e[20] = g, e[21] = y) : y = e[21], y;
}, $_ = "_scrollable_10p2u_1", F_ = "_fill_10p2u_8", V_ = "_viewport_10p2u_13", z_ = "_axisBoth_10p2u_36", B_ = "_axisHorizontal_10p2u_41", H_ = "_axisVertical_10p2u_46", U_ = "_barOverlay_10p2u_51", W_ = "_thumb_10p2u_58", G_ = "_thumbVertical_10p2u_73", K_ = "_thumbHorizontal_10p2u_79", Y_ = "_autoHide_10p2u_85", q_ = "_alwaysVisible_10p2u_86", X_ = "_gutterOverlay_10p2u_91", Z_ = "_gutterStable_10p2u_95", J_ = "_widthThin_10p2u_99", Q_ = "_widthMedium_10p2u_103", e2 = "_widthThick_10p2u_107", Tt = {
  scrollable: $_,
  fill: F_,
  viewport: V_,
  axisBoth: z_,
  axisHorizontal: B_,
  axisVertical: H_,
  barOverlay: U_,
  thumb: W_,
  thumbVertical: G_,
  thumbHorizontal: K_,
  autoHide: Y_,
  alwaysVisible: q_,
  gutterOverlay: X_,
  gutterStable: Z_,
  widthThin: J_,
  widthMedium: Q_,
  widthThick: e2
}, t2 = {
  both: Tt.axisBoth,
  horizontal: Tt.axisHorizontal,
  vertical: Tt.axisVertical
}, n2 = {
  overlay: Tt.gutterOverlay,
  stable: Tt.gutterStable
}, o2 = {
  medium: Tt.widthMedium,
  thick: Tt.widthThick,
  thin: Tt.widthThin
}, r2 = 700, s2 = 24, wg = 3, i2 = (t) => {
  const e = ee.c(72);
  let n, o, r, s, i, a, l, c, u, d, p, m, h;
  e[0] !== t ? ({
    axis: c,
    autoHide: u,
    bar: d,
    children: n,
    className: o,
    gutter: p,
    maxHeight: r,
    onScroll: s,
    overlayInsetBlockStart: m,
    ref: a,
    style: l,
    width: h,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = p, e[12] = m, e[13] = h) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], p = e[11], m = e[12], h = e[13]);
  const g = c === void 0 ? "vertical" : c, y = u === void 0 ? !0 : u, v = d === void 0 ? "native" : d, x = p === void 0 ? "stable" : p, w = m === void 0 ? 0 : m, E = h === void 0 ? "thin" : h, S = f.useRef(null), C = f.useRef(null), _ = f.useRef(null), R = f.useRef(null), O = f.useRef(null);
  let j, F;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (j = () => () => {
    _.current && clearTimeout(_.current);
  }, F = [], e[14] = j, e[15] = F) : (j = e[14], F = e[15]), f.useEffect(j, F);
  let N;
  e[16] !== w ? (N = () => {
    const k = C.current;
    k && (Hf(R.current, k, !0, w, 0), Hf(O.current, k, !1, 0, Bf(R.current)));
  }, e[16] = w, e[17] = N) : N = e[17];
  const T = N;
  let L;
  e[18] !== v || e[19] !== T ? (L = () => {
    v === "overlay" && T();
  }, e[18] = v, e[19] = T, e[20] = L) : L = e[20], f.useEffect(L);
  let M, A;
  e[21] !== v || e[22] !== T ? (M = () => {
    const k = C.current;
    if (v !== "overlay" || !k || typeof ResizeObserver > "u")
      return;
    const H = new ResizeObserver(T);
    return H.observe(k), k.firstElementChild && H.observe(k.firstElementChild), () => H.disconnect();
  }, A = [v, T], e[21] = v, e[22] = T, e[23] = M, e[24] = A) : (M = e[23], A = e[24]), f.useEffect(M, A);
  let $;
  if (e[25] !== y || e[26] !== g || e[27] !== v || e[28] !== n || e[29] !== o || e[30] !== x || e[31] !== r || e[32] !== s || e[33] !== w || e[34] !== i || e[35] !== a || e[36] !== l || e[37] !== T || e[38] !== E) {
    const k = (ie) => (de) => {
      const le = C.current;
      if (!le)
        return;
      const te = ie ? le.clientHeight : le.clientWidth, pe = ie ? le.scrollHeight : le.scrollWidth, ue = Eg(te, ie ? w : 0, ie ? 0 : Bf(R.current)), ye = Sg(ue, te, pe);
      if (ue - ye <= 0)
        return;
      de.preventDefault();
      const ge = de.currentTarget;
      ge.setPointerCapture?.(de.pointerId), S.current?.setAttribute("data-dragging", "");
      const Te = ie ? de.clientY : de.clientX, Se = ie ? le.scrollTop : le.scrollLeft, xe = (pe - te) / (ue - ye), je = (Pe) => {
        const we = ((ie ? Pe.clientY : Pe.clientX) - Te) * xe;
        ie ? le.scrollTop = Se + we : le.scrollLeft = Se + we;
      }, Me = () => {
        S.current?.removeAttribute("data-dragging"), ge.releasePointerCapture?.(de.pointerId), ge.removeEventListener("pointermove", je), ge.removeEventListener("pointerup", Me), ge.removeEventListener("pointercancel", Me);
      };
      ge.addEventListener("pointermove", je), ge.addEventListener("pointerup", Me), ge.addEventListener("pointercancel", Me);
    };
    let H;
    e[40] !== a ? (H = (ie) => {
      C.current = ie, typeof a == "function" ? a(ie) : a != null && (a.current = ie);
    }, e[40] = a, e[41] = H) : H = e[41];
    const B = H;
    let P;
    e[42] !== v || e[43] !== s || e[44] !== T ? (P = (ie) => {
      const de = S.current;
      de && (de.setAttribute("data-scrolling", ""), _.current && clearTimeout(_.current), _.current = setTimeout(() => de.removeAttribute("data-scrolling"), r2)), v === "overlay" && T(), s?.(ie);
    }, e[42] = v, e[43] = s, e[44] = T, e[45] = P) : P = e[45];
    const V = P, I = typeof E == "number" ? void 0 : o2[E];
    let D;
    e[46] !== E ? (D = typeof E == "number" ? {
      "--scrollable-size": `${E}px`
    } : void 0, e[46] = E, e[47] = D) : D = e[47];
    const z = D;
    let U;
    e[48] !== w ? (U = w > 0 ? {
      "--scrollable-overlay-inset": `${w}px`
    } : void 0, e[48] = w, e[49] = U) : U = e[49];
    const G = U;
    let J;
    e[50] !== r ? (J = r !== void 0 ? {
      maxHeight: r
    } : void 0, e[50] = r, e[51] = J) : J = e[51];
    const se = J;
    let Q;
    e[52] !== G || e[53] !== se || e[54] !== l || e[55] !== z ? (Q = l || z || G || se ? {
      ...z,
      ...G,
      ...se,
      ...l
    } : void 0, e[52] = G, e[53] = se, e[54] = l, e[55] = z, e[56] = Q) : Q = e[56];
    const ce = Q, W = y ? Tt.autoHide : Tt.alwaysVisible, oe = r === void 0 && Tt.fill;
    let Y;
    e[57] !== o || e[58] !== W || e[59] !== oe || e[60] !== I ? (Y = ae(Tt.scrollable, I, W, oe, o), e[57] = o, e[58] = W, e[59] = oe, e[60] = I, e[61] = Y) : Y = e[61];
    const Z = t2[g], K = n2[x], X = v === "overlay" && Tt.barOverlay;
    let ne;
    e[62] !== Z || e[63] !== K || e[64] !== X ? (ne = ae(Tt.viewport, Z, K, X), e[62] = Z, e[63] = K, e[64] = X, e[65] = ne) : ne = e[65];
    let re;
    e[66] !== n || e[67] !== V || e[68] !== i || e[69] !== B || e[70] !== ne ? (re = /* @__PURE__ */ b.jsx("div", { ref: B, className: ne, "data-slot": "scrollable-viewport", onScroll: V, ...i, children: n }), e[66] = n, e[67] = V, e[68] = i, e[69] = B, e[70] = ne, e[71] = re) : re = e[71], $ = /* @__PURE__ */ b.jsxs("div", { ref: S, className: Y, "data-slot": "scrollable", style: ce, children: [
      re,
      v === "overlay" && g !== "horizontal" && /* @__PURE__ */ b.jsx("div", { ref: R, "aria-hidden": "true", className: ae(Tt.thumb, Tt.thumbVertical), "data-slot": "scrollable-thumb", hidden: !0, onPointerDown: k(!0) }),
      v === "overlay" && g !== "vertical" && /* @__PURE__ */ b.jsx("div", { ref: O, "aria-hidden": "true", className: ae(Tt.thumb, Tt.thumbHorizontal), "data-slot": "scrollable-thumb", hidden: !0, onPointerDown: k(!1) })
    ] }), e[25] = y, e[26] = g, e[27] = v, e[28] = n, e[29] = o, e[30] = x, e[31] = r, e[32] = s, e[33] = w, e[34] = i, e[35] = a, e[36] = l, e[37] = T, e[38] = E, e[39] = $;
  } else
    $ = e[39];
  return $;
}, Bf = (t) => t && !t.hidden ? t.offsetWidth + wg : 0, Hf = (t, e, n, o, r) => {
  if (!t) return;
  const s = n ? e.clientHeight : e.clientWidth, i = n ? e.scrollHeight : e.scrollWidth, a = Eg(s, o, r), l = Sg(a, s, i);
  if (i - s <= 1 || a - l <= 0) {
    t.hidden = !0;
    return;
  }
  t.hidden = !1;
  const c = Math.min(Math.max(n ? e.scrollTop : e.scrollLeft, 0), i - s), u = (a - l) * c / (i - s);
  t.style[n ? "blockSize" : "inlineSize"] = `${l}px`, t.style.transform = n ? `translateY(${u}px)` : `translateX(${u}px)`;
}, Sg = (t, e, n) => Math.max(s2, t * e / n), Eg = (t, e, n) => t - e - wg * 2 - n, ur = {
  /**
   * The canonical page-size allow-list. Single source of truth for the pager's `limitOptions` default,
   * `TableLayoutStore.read`'s fallback when a caller omits `limitOptions` (a persisted `limit` outside
   * the list is dropped to `null`), and the `DataTableProps.limitOptions` default. Typed `readonly` so
   * a consumer cannot sort, push to, or otherwise mutate the list every table shares.
   */
  LIMIT_OPTIONS: [10, 25, 50, 100],
  /**
   * The min-width floor applied to any column that declares no `minWidth`. Shared by
   * `useColumnLayout`'s clamp, `TableLayoutStore`'s persisted-width clamp and `DataTable`'s
   * `minTableWidth` sum — all three must agree or a persisted width can differ from a live one.
   */
  MIN_WIDTH: 64
}, a2 = (t) => {
  const e = ee.c(48), {
    columns: n,
    defaultOrder: o,
    defaultVisibility: r,
    defaultWidths: s,
    onOrderChange: i,
    onVisibilityChange: a,
    onWidthsChange: l,
    order: c,
    visibility: u,
    widths: d
  } = t;
  let p;
  e[0] !== n ? (p = n.filter(l2).map(c2), e[0] = n, e[1] = p) : p = e[1];
  const m = p;
  let h;
  e[2] !== n ? (h = new Map(n.map(u2)), e[2] = n, e[3] = h) : h = e[3];
  const g = h;
  let y;
  e[4] !== m || e[5] !== o ? (y = () => o ?? m, e[4] = m, e[5] = o, e[6] = y) : y = e[6];
  const [v, x] = q.useState(y);
  let w;
  e[7] !== s ? (w = () => s ?? {}, e[7] = s, e[8] = w) : w = e[8];
  const [E, S] = q.useState(w);
  let C;
  e[9] !== r ? (C = () => r ?? {}, e[9] = r, e[10] = C) : C = e[10];
  const [_, R] = q.useState(C), O = c !== void 0, j = u !== void 0, F = d !== void 0, N = O ? c : v, T = j ? u : _, L = F ? d : E;
  let M;
  e[11] !== O || e[12] !== i ? (M = (W) => {
    O || x(W), i?.(W);
  }, e[11] = O, e[12] = i, e[13] = M) : M = e[13];
  const A = M;
  let $;
  e[14] !== j || e[15] !== a ? ($ = (W) => {
    j || R(W), a?.(W);
  }, e[14] = j, e[15] = a, e[16] = $) : $ = e[16];
  const k = $;
  let H;
  e[17] !== F || e[18] !== l ? (H = (W) => {
    F || S(W), l?.(W);
  }, e[17] = F, e[18] = l, e[19] = H) : H = e[19];
  const B = H;
  let P;
  e[20] !== g || e[21] !== A || e[22] !== m || e[23] !== N ? (P = (W) => {
    const oe = W.filter((Z) => {
      const K = g.get(Z);
      return K !== void 0 && K.reorderable !== !1;
    }), Y = [...oe, ...m.filter((Z) => !oe.includes(Z))];
    Y.length === N.length && Y.every((Z, K) => Z === N[K]) || A(Y);
  }, e[20] = g, e[21] = A, e[22] = m, e[23] = N, e[24] = P) : P = e[24];
  const V = P;
  let I;
  e[25] !== g || e[26] !== k ? (I = (W) => {
    const oe = Object.fromEntries(Object.entries(W).filter((Y) => {
      const [Z] = Y, K = g.get(Z);
      return K !== void 0 && K.hideable !== !1;
    }));
    k(oe);
  }, e[25] = g, e[26] = k, e[27] = I) : I = e[27];
  const D = I;
  let z;
  e[28] !== g || e[29] !== B || e[30] !== L ? (z = (W) => {
    const oe = {
      ...L
    };
    let Y = !1;
    for (const [Z, K] of Object.entries(W)) {
      const X = g.get(Z);
      if (!X)
        continue;
      const ne = X.minWidth ?? ur.MIN_WIDTH, re = X.maxWidth ?? 1 / 0;
      oe[Z] = Math.max(ne, Math.min(re, K)), Y = !0;
    }
    Y && B(oe);
  }, e[28] = g, e[29] = B, e[30] = L, e[31] = z) : z = e[31];
  const U = z;
  let G;
  e[32] !== U ? (G = (W, oe) => U({
    [W]: oe
  }), e[32] = U, e[33] = G) : G = e[33];
  const J = G;
  let se;
  e[34] !== A || e[35] !== k || e[36] !== B || e[37] !== m ? (se = () => {
    A(m), B({}), k({});
  }, e[34] = A, e[35] = k, e[36] = B, e[37] = m, e[38] = se) : se = e[38];
  const Q = se;
  let ce;
  return e[39] !== N || e[40] !== Q || e[41] !== V || e[42] !== D || e[43] !== J || e[44] !== U || e[45] !== T || e[46] !== L ? (ce = {
    order: N,
    reset: Q,
    setOrder: V,
    setVisibility: D,
    setWidth: J,
    setWidths: U,
    visibility: T,
    widths: L
  }, e[39] = N, e[40] = Q, e[41] = V, e[42] = D, e[43] = J, e[44] = U, e[45] = T, e[46] = L, e[47] = ce) : ce = e[47], ce;
};
function l2(t) {
  return t.reorderable !== !1;
}
function c2(t) {
  return t.id;
}
function u2(t) {
  return [t.id, t];
}
const d2 = (t) => {
  const e = ee.c(33), {
    defaultLimit: n,
    onQuery: o,
    pagination: r
  } = t;
  let s;
  e[0] !== r ? (s = f2(r), e[0] = r, e[1] = s) : s = e[1];
  const i = s, [a, l] = q.useState(null);
  let c;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = [], e[2] = c) : c = e[2];
  const [u, d] = q.useState(c), p = r?.limit ?? n, m = i === "offset" ? r.hasPreviousPage : i === "cursor" ? u.length > 0 : !1, h = i === "offset" ? r.hasNextPage : i === "cursor" ? r.hasMore : !1;
  let g;
  e[3] !== p || e[4] !== i || e[5] !== o ? (g = (j) => {
    i === "offset" && o({
      limit: p,
      page: j
    });
  }, e[3] = p, e[4] = i, e[5] = o, e[6] = g) : g = e[6];
  const y = g;
  let v;
  e[7] !== a || e[8] !== p || e[9] !== i || e[10] !== o || e[11] !== r ? (v = () => {
    if (i === "offset") {
      const j = r;
      if (!j.hasNextPage)
        return;
      o({
        limit: p,
        page: j.page + 1
      });
      return;
    }
    if (i === "cursor") {
      const j = r;
      if (!j.hasMore)
        return;
      d((F) => [...F, a]), l(j.cursor), o({
        cursor: j.cursor,
        limit: p
      });
    }
  }, e[7] = a, e[8] = p, e[9] = i, e[10] = o, e[11] = r, e[12] = v) : v = e[12];
  const x = v;
  let w;
  e[13] !== u || e[14] !== p || e[15] !== i || e[16] !== o || e[17] !== r ? (w = () => {
    if (i === "offset") {
      const j = r;
      if (!j.hasPreviousPage)
        return;
      o({
        limit: p,
        page: j.page - 1
      });
      return;
    }
    if (i === "cursor") {
      if (u.length === 0)
        return;
      const j = u[u.length - 1];
      d(p2), l(j), o({
        cursor: j,
        limit: p
      });
    }
  }, e[13] = u, e[14] = p, e[15] = i, e[16] = o, e[17] = r, e[18] = w) : w = e[18];
  const E = w;
  let S;
  e[19] !== i || e[20] !== o ? (S = (j) => {
    if (i === "cursor") {
      d([]), l(null), o({
        cursor: null,
        limit: j
      });
      return;
    }
    o({
      limit: j,
      page: 1
    });
  }, e[19] = i, e[20] = o, e[21] = S) : S = e[21];
  const C = S;
  let _;
  e[22] !== i ? (_ = () => {
    i === "cursor" && (d([]), l(null));
  }, e[22] = i, e[23] = _) : _ = e[23];
  const R = _;
  let O;
  return e[24] !== h || e[25] !== m || e[26] !== y || e[27] !== i || e[28] !== x || e[29] !== E || e[30] !== R || e[31] !== C ? (O = {
    canNext: h,
    canPrev: m,
    goToPage: y,
    mode: i,
    next: x,
    prev: E,
    reset: R,
    setLimit: C
  }, e[24] = h, e[25] = m, e[26] = y, e[27] = i, e[28] = x, e[29] = E, e[30] = R, e[31] = C, e[32] = O) : O = e[32], O;
}, f2 = (t) => t ? "page" in t ? "offset" : "cursor" in t ? "cursor" : "none" : "none";
function p2(t) {
  return t.slice(0, -1);
}
const m2 = ({
  defaultSelectedIds: t,
  onSelectionChange: e,
  orderedPageIds: n,
  selectedIds: o
}) => {
  const [r, s] = q.useState(() => t ?? /* @__PURE__ */ new Set()), i = o !== void 0, a = i ? o : r, l = q.useRef(null), c = q.useRef(n);
  c.current !== n && (c.current = n, l.current = null);
  const u = q.useCallback((v) => {
    i || s(v), e?.(v);
  }, [i, e]), d = q.useCallback((v) => a.has(v), [a]), p = q.useCallback((v) => {
    l.current = v;
    const x = new Set(a);
    x.has(v) ? x.delete(v) : x.add(v), u(x);
  }, [a, u]), m = q.useCallback((v) => {
    const x = l.current;
    if (x === null) {
      l.current = v;
      const R = new Set(a);
      R.has(v) ? R.delete(v) : R.add(v), u(R);
      return;
    }
    const w = n.indexOf(x), E = n.indexOf(v);
    if (w === -1 || E === -1) return;
    const [S, C] = w <= E ? [w, E] : [E, w], _ = new Set(a);
    for (let R = S; R <= C; R += 1) _.add(n[R]);
    u(_);
  }, [n, a, u]), h = q.useCallback((v) => {
    const x = new Set(a);
    v ? n.forEach((w) => x.add(w)) : n.forEach((w) => x.delete(w)), u(x);
  }, [n, a, u]), g = q.useCallback(() => {
    l.current = null, u(/* @__PURE__ */ new Set());
  }, [u]), y = h2(n, a);
  return {
    clear: g,
    isSelected: d,
    pageState: y,
    selectedIds: a,
    setPage: h,
    toggle: p,
    toggleRange: m
  };
}, h2 = (t, e) => {
  if (t.length === 0) return "none";
  let n = 0;
  for (const o of t) e.has(o) && (n += 1);
  return n === 0 ? "none" : n === t.length ? "all" : "some";
}, g2 = (t, e) => !t || t.columnId !== e ? {
  columnId: e,
  direction: "asc"
} : t.direction === "asc" ? {
  columnId: e,
  direction: "desc"
} : null, b2 = (t) => {
  const e = ee.c(9);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  const {
    sort: o,
    defaultSort: r,
    onSortChange: s
  } = n, i = r === void 0 ? null : r, [a, l] = q.useState(i), c = o !== void 0, u = c ? o : a;
  let d;
  e[2] !== c || e[3] !== s || e[4] !== u ? (d = (h) => {
    const g = g2(u, h);
    return c || l(g), s?.(g), g;
  }, e[2] = c, e[3] = s, e[4] = u, e[5] = d) : d = e[5];
  const p = d;
  let m;
  return e[6] !== p || e[7] !== u ? (m = {
    cycleSort: p,
    sort: u
  }, e[6] = p, e[7] = u, e[8] = m) : m = e[8], m;
}, v2 = 300, y2 = ({
  defaultSearch: t = "",
  onSearch: e
}) => {
  const [n, o] = q.useState(t), r = q.useRef(n), s = q.useRef(t.trim()), i = q.useRef(e);
  i.current = e;
  const a = q.useRef(null), l = q.useCallback((d) => {
    o(d), r.current = d, a.current !== null && window.clearTimeout(a.current), a.current = window.setTimeout(() => Uf(r, s, i), v2);
  }, []), c = q.useCallback(() => {
    a.current !== null && (window.clearTimeout(a.current), a.current = null), Uf(r, s, i);
  }, []), u = q.useCallback(() => {
    o(""), r.current = "", c();
  }, [c]);
  return q.useEffect(() => () => {
    a.current !== null && window.clearTimeout(a.current);
  }, []), q.useMemo(() => ({
    clear: u,
    flush: c,
    onChange: l,
    value: n
  }), [u, c, l, n]);
}, Uf = (t, e, n) => {
  const o = t.current.trim();
  o !== e.current && (e.current = o, n.current(o));
}, x2 = "_handle_1ekau_1", w2 = "_flush_1ekau_13", Wf = {
  handle: x2,
  flush: w2
}, S2 = 16, E2 = 64, C2 = ({
  className: t,
  flush: e,
  label: n,
  onResize: o,
  onResizeEnd: r,
  onAutoFit: s,
  onResizeStart: i,
  onHoverChange: a,
  ...l
}) => {
  const c = f.useRef(o), u = f.useRef(r), d = f.useRef(i), p = f.useRef(a);
  c.current = o, u.current = r, d.current = i, p.current = a;
  const m = f.useRef(null), h = f.useCallback(() => {
    m.current?.(), m.current = null;
  }, []);
  f.useEffect(() => () => h(), [h]);
  const g = f.useCallback((v) => {
    if (v.button > 0) return;
    m.current?.(), d.current?.();
    const x = v.currentTarget, w = v.clientX, E = v.pointerId;
    x.setPointerCapture?.(E);
    const S = (O) => c.current(O.clientX - w), C = () => {
      window.removeEventListener("pointermove", S), window.removeEventListener("pointerup", _), window.removeEventListener("keydown", R), x.releasePointerCapture?.(E), m.current = null;
    }, _ = () => {
      C(), u.current();
    }, R = (O) => {
      O.key === "Escape" && (c.current(0), C());
    };
    window.addEventListener("pointermove", S), window.addEventListener("pointerup", _), window.addEventListener("keydown", R), m.current = C;
  }, []), y = f.useCallback((v) => {
    const x = v.key === "ArrowRight" ? 1 : v.key === "ArrowLeft" ? -1 : 0;
    if (x === 0) return;
    v.preventDefault();
    const w = v.shiftKey ? E2 : S2;
    c.current(x * w), u.current();
  }, []);
  return /* @__PURE__ */ b.jsx("span", { role: "separator", "aria-orientation": "vertical", "aria-label": n, "data-slot": "table-resize-handle", tabIndex: 0, className: ae(Wf.handle, e && Wf.flush, t), onKeyDown: y, onPointerDown: g, onDoubleClick: s, onPointerEnter: () => p.current?.(!0), onPointerLeave: () => p.current?.(!1), onFocus: () => p.current?.(!0), onBlur: () => p.current?.(!1), ...l });
}, _2 = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v14m7-7l-7 7l-7-7"/>'
}, Cg = _2, R2 = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 12l7-7l7 7m-7 7V5"/>'
}, _g = R2, N2 = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m7 15l5 5l5-5M7 9l5-5l5 5"/>'
}, k2 = N2, T2 = "_indicator_he853_1", I2 = "_inactive_he853_12", Gf = {
  indicator: T2,
  inactive: I2
}, O2 = (t) => {
  const e = ee.c(14);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    direction: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = o ?? "none", i = o === null && Gf.inactive;
  let a;
  e[4] !== n || e[5] !== i ? (a = ae(Gf.indicator, i, n), e[4] = n, e[5] = i, e[6] = a) : a = e[6];
  let l;
  e[7] !== o ? (l = o === "asc" ? /* @__PURE__ */ b.jsx(Ve, { icon: _g }) : o === "desc" ? /* @__PURE__ */ b.jsx(Ve, { icon: Cg }) : /* @__PURE__ */ b.jsx(Ve, { icon: k2 }), e[7] = o, e[8] = l) : l = e[8];
  let c;
  return e[9] !== r || e[10] !== s || e[11] !== a || e[12] !== l ? (c = /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", "data-slot": "table-sort-indicator", "data-direction": s, className: a, ...r, children: l }), e[9] = r, e[10] = s, e[11] = a, e[12] = l, e[13] = c) : c = e[13], c;
}, M2 = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 18l-6-6l6-6"/>'
}, P2 = M2, A2 = "_pager_55eb8_1", D2 = "_pages_55eb8_8", j2 = "_page_55eb8_1", L2 = "_arrow_55eb8_21", $2 = "_ellipsis_55eb8_26", Go = {
  pager: A2,
  pages: D2,
  page: j2,
  arrow: L2,
  ellipsis: $2
}, ic = 5, F2 = 12, V2 = 32, z2 = (t) => {
  const e = ee.c(38);
  let n, o, r, s, i, a, l, c, u, d;
  e[0] !== t ? ({
    className: r,
    mode: s,
    page: c,
    totalPages: d,
    canPrev: o,
    canNext: n,
    onPage: a,
    onNext: i,
    onPrev: l,
    ...u
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10]);
  const p = c ?? 1, m = Math.max(1, d ?? 1), h = f.useRef(null), g = f.useRef(null), [y, v] = f.useState(ic);
  let x;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (x = () => {
    const L = h.current;
    if (!L || typeof ResizeObserver > "u")
      return;
    const M = () => v(B2(L, g.current));
    M();
    const A = new ResizeObserver(M);
    return A.observe(L), () => A.disconnect();
  }, e[11] = x) : x = e[11];
  let w;
  e[12] !== m ? (w = [m], e[12] = m, e[13] = w) : w = e[13], f.useLayoutEffect(x, w);
  let E;
  e[14] !== r ? (E = ae(Go.pager, r), e[14] = r, e[15] = E) : E = e[15];
  const S = !o;
  let C;
  e[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = /* @__PURE__ */ b.jsx(Ve, { icon: P2, width: 24, height: 24 }), e[16] = C) : C = e[16];
  let _;
  e[17] !== l || e[18] !== S ? (_ = /* @__PURE__ */ b.jsx(kt, { className: Go.arrow, variant: "ghost", size: "icon-sm", disabled: S, onClick: l, "aria-label": "Previous page", children: C }), e[17] = l, e[18] = S, e[19] = _) : _ = e[19];
  let R;
  e[20] !== p || e[21] !== s || e[22] !== a || e[23] !== m || e[24] !== y ? (R = s === "offset" && H2(p, m, y).map((L, M) => L === "ellipsis" ? /* @__PURE__ */ b.jsx("span", { className: Go.ellipsis, "aria-hidden": "true", children: "…" }, `gap-${M}`) : /* @__PURE__ */ b.jsx(kt, { className: Go.page, variant: L === p ? "primary" : "outline", size: "sm", "aria-current": L === p ? "page" : void 0, "aria-label": `Page ${L}`, onClick: () => a(L), children: L }, L)), e[20] = p, e[21] = s, e[22] = a, e[23] = m, e[24] = y, e[25] = R) : R = e[25];
  const O = !n;
  let j;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (j = /* @__PURE__ */ b.jsx(Ve, { icon: Ra, width: 24, height: 24 }), e[26] = j) : j = e[26];
  let F;
  e[27] !== i || e[28] !== O ? (F = /* @__PURE__ */ b.jsx(kt, { className: Go.arrow, variant: "ghost", size: "icon-sm", disabled: O, onClick: i, "aria-label": "Next page", children: j }), e[27] = i, e[28] = O, e[29] = F) : F = e[29];
  let N;
  e[30] !== F || e[31] !== _ || e[32] !== R ? (N = /* @__PURE__ */ b.jsxs("div", { className: Go.pages, ref: g, role: "group", "aria-label": "Pages", children: [
    _,
    R,
    F
  ] }), e[30] = F, e[31] = _, e[32] = R, e[33] = N) : N = e[33];
  let T;
  return e[34] !== u || e[35] !== N || e[36] !== E ? (T = /* @__PURE__ */ b.jsx("nav", { "aria-label": "Pagination", "data-slot": "table-compact-pager", className: E, ref: h, ...u, children: N }), e[34] = u, e[35] = N, e[36] = E, e[37] = T) : T = e[37], T;
}, B2 = (t, e) => {
  const n = t.getBoundingClientRect().width;
  if (n <= 0 || !e) return ic;
  const o = Number.parseFloat(getComputedStyle(e).columnGap) || 0, r = Array.from(e.querySelectorAll("button")), i = (r.length >= 2 ? [r[0], r[r.length - 1]] : []).reduce((c, u) => c + u.getBoundingClientRect().width, 0), a = r.slice(1, -1).reduce((c, u) => Math.max(c, u.getBoundingClientRect().width), 0) || V2, l = n - i - o * 2;
  return Math.max(ic, Math.min(F2, Math.floor((l + o) / (a + o))));
}, H2 = (t, e, n) => {
  if (e <= n) return Gs(1, e);
  if (t <= n - 2) return [...Gs(1, n - 2), "ellipsis", e];
  if (t >= e - (n - 3)) return [1, "ellipsis", ...Gs(e - n + 3, e)];
  const o = n - 4, r = t - Math.floor((o - 1) / 2);
  return [1, "ellipsis", ...Gs(r, r + o - 1), "ellipsis", e];
}, Gs = (t, e) => Array.from({
  length: Math.max(0, e - t + 1)
}, (n, o) => t + o), U2 = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m21.73 18l-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3ZM12 9v4m0 4h.01"/>'
}, Rg = U2, W2 = "_empty_10vw1_1", G2 = "_title_10vw1_13", K2 = "_description_10vw1_20", Y2 = "_action_10vw1_26", q2 = "_error_10vw1_30", X2 = "_icon_10vw1_30", Ko = {
  empty: W2,
  title: G2,
  description: K2,
  action: Y2,
  error: q2,
  icon: X2
}, Z2 = (t) => {
  const e = ee.c(26);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    className: o,
    title: i,
    description: r,
    action: n,
    variant: a,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = i === void 0 ? "No results" : i, c = a === void 0 ? "default" : a, u = c === "error" && Ko.error;
  let d;
  e[7] !== o || e[8] !== u ? (d = ae(Ko.empty, u, o), e[7] = o, e[8] = u, e[9] = d) : d = e[9];
  let p;
  e[10] !== c ? (p = c === "error" && /* @__PURE__ */ b.jsx(no, { icon: Rg, size: "lg", className: Ko.icon }), e[10] = c, e[11] = p) : p = e[11];
  let m;
  e[12] !== l ? (m = l != null && /* @__PURE__ */ b.jsx("p", { className: Ko.title, children: l }), e[12] = l, e[13] = m) : m = e[13];
  let h;
  e[14] !== r ? (h = r != null && /* @__PURE__ */ b.jsx("p", { className: Ko.description, children: r }), e[14] = r, e[15] = h) : h = e[15];
  let g;
  e[16] !== n ? (g = n != null && /* @__PURE__ */ b.jsx("div", { className: Ko.action, children: n }), e[16] = n, e[17] = g) : g = e[17];
  let y;
  return e[18] !== s || e[19] !== d || e[20] !== p || e[21] !== m || e[22] !== h || e[23] !== g || e[24] !== c ? (y = /* @__PURE__ */ b.jsxs("div", { "data-slot": "table-empty-state", "data-variant": c, className: d, ...s, children: [
    p,
    m,
    h,
    g
  ] }), e[18] = s, e[19] = d, e[20] = p, e[21] = m, e[22] = h, e[23] = g, e[24] = c, e[25] = y) : y = e[25], y;
}, J2 = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></g>'
}, Q2 = J2, eR = "_bar_fcukw_1", tR = "_search_fcukw_10", nR = "_filterSlot_fcukw_47", oR = "_barEnd_fcukw_54", rR = "_pipe_fcukw_63", sR = "_gear_fcukw_71", Yo = {
  bar: eR,
  search: tR,
  filterSlot: nR,
  barEnd: oR,
  pipe: rR,
  gear: sR
}, Ng = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    name: i,
    value: a,
    disabled: l = !1,
    onValueChange: c,
    defaultValue: u,
    ...d
  } = e, {
    state: p,
    name: m,
    disabled: h
  } = dn(), g = h || l, y = m ?? i, v = f.useMemo(() => ({
    ...p,
    disabled: g
  }), [p, g]), {
    setTouched: x,
    setDirty: w,
    validityData: E,
    setFocused: S,
    setFilled: C,
    validationMode: _,
    validation: R
  } = dn(), {
    labelId: O
  } = yo(), j = Ir({
    id: s
  });
  he(() => {
    const A = a != null;
    R.inputRef.current?.value || A && a !== "" ? C(!0) : A && a === "" && C(!1);
  }, [R.inputRef, C, a]);
  const [F, N] = un({
    controlled: a,
    default: u,
    name: "FieldControl",
    state: "value"
  }), T = a !== void 0, L = fe((A, $) => {
    c?.(A, $), !$.isCanceled && N(A);
  });
  return kr({
    id: j,
    name: y,
    commit: R.commit,
    value: F,
    getValue: () => R.inputRef.current?.value,
    controlRef: R.inputRef
  }), _e("input", e, {
    ref: n,
    state: v,
    props: [{
      id: j,
      disabled: g,
      name: y,
      ref: R.inputRef,
      "aria-labelledby": O,
      ...T ? {
        value: F
      } : {
        defaultValue: u
      },
      onChange(A) {
        const $ = A.currentTarget.value;
        L($, ke(Ut, A.nativeEvent)), w($ !== E.initialValue), C($ !== "");
      },
      onFocus() {
        S(!0);
      },
      onBlur(A) {
        x(!0), S(!1), _ === "onBlur" && R.commit(A.currentTarget.value);
      },
      onKeyDown(A) {
        A.currentTarget.tagName === "INPUT" && A.key === "Enter" && (x(!0), R.commit(A.currentTarget.value));
      }
    }, R.getInputValidationProps(), d],
    stateAttributesMapping: zo
  });
});
process.env.NODE_ENV !== "production" && (Ng.displayName = "FieldControl");
const kg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  return /* @__PURE__ */ b.jsx(Ng, {
    ref: n,
    ...e
  });
});
process.env.NODE_ENV !== "production" && (kg.displayName = "Input");
const iR = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 6L6 18M6 6l12 12"/>'
}, Ia = iR, aR = "_wrapper_1i573_1", lR = "_stateReadonly_1i573_32", cR = "_stateDisabled_1i573_39", uR = "_stateInvalid_1i573_45", dR = "_input_1i573_57", fR = "_fileChosen_1i573_105", pR = "_readOnly_1i573_135", mR = "_widthSm_1i573_140", hR = "_widthMd_1i573_145", gR = "_widthLg_1i573_150", bR = "_widthFull_1i573_155", vR = "_reserveTrailing_1i573_160", yR = "_reserveNumber_1i573_164", xR = "_reserveNumberClear_1i573_168", wR = "_reserveHint_1i573_172", SR = "_reserveAction_1i573_176", ER = "_reserveLeading_1i573_180", CR = "_leadingIcon_1i573_184", _R = "_shortcutHint_1i573_199", RR = "_action_1i573_214", NR = "_spinner_1i573_223", kR = "_spinnerShift_1i573_233", TR = "_spinnerButton_1i573_240", IR = "_clear_1i573_277", OR = "_copy_1i573_309", MR = "_passwordField_1i573_316", PR = "_toggleRow_1i573_323", it = {
  wrapper: aR,
  stateReadonly: lR,
  stateDisabled: cR,
  stateInvalid: uR,
  input: dR,
  fileChosen: fR,
  readOnly: pR,
  widthSm: mR,
  widthMd: hR,
  widthLg: gR,
  widthFull: bR,
  reserveTrailing: vR,
  reserveNumber: yR,
  reserveNumberClear: xR,
  reserveHint: wR,
  reserveAction: SR,
  reserveLeading: ER,
  leadingIcon: CR,
  shortcutHint: _R,
  action: RR,
  spinner: NR,
  spinnerShift: kR,
  spinnerButton: TR,
  clear: IR,
  copy: OR,
  passwordField: MR,
  toggleRow: PR
}, AR = {
  full: it.widthFull,
  lg: it.widthLg,
  md: it.widthMd,
  sm: it.widthSm
}, Tg = (t) => {
  const e = ee.c(118);
  let n, o, r, s, i, a, l, c, u, d, p, m, h, g, y, v, x, w, E, S, C, _;
  e[0] !== t ? ({
    action: n,
    "aria-invalid": o,
    autoComplete: r,
    className: s,
    clearable: v,
    copyable: x,
    copyLabel: w,
    defaultValue: i,
    disabled: a,
    leadingIcon: l,
    onChange: c,
    onClear: u,
    readOnly: p,
    ref: m,
    shortcutHint: h,
    showPasswordToggle: g,
    style: y,
    title: S,
    type: C,
    value: _,
    width: E,
    ...d
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = p, e[12] = m, e[13] = h, e[14] = g, e[15] = y, e[16] = v, e[17] = x, e[18] = w, e[19] = E, e[20] = S, e[21] = C, e[22] = _) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], p = e[11], m = e[12], h = e[13], g = e[14], y = e[15], v = e[16], x = e[17], w = e[18], E = e[19], S = e[20], C = e[21], _ = e[22]);
  const R = v === void 0 ? !1 : v, O = x === void 0 ? !1 : x, j = w === void 0 ? "Copy" : w, F = E === void 0 ? "md" : E, N = f.useRef(null), T = f.useId(), L = _ !== void 0;
  let M;
  e[23] !== i ? (M = () => String(i ?? "").length > 0, e[23] = i, e[24] = M) : M = e[24];
  const [A, $] = f.useState(M), k = L ? String(_ ?? "").length > 0 : A, [H, B] = f.useState(!1);
  let P;
  e[25] !== m ? (P = (gt) => {
    N.current = gt, typeof m == "function" ? m(gt) : m != null && (m.current = gt);
  }, e[25] = m, e[26] = P) : P = e[26];
  const V = P;
  let I;
  e[27] !== L || e[28] !== c ? (I = (gt) => {
    L || $(gt.target.value.length > 0), c?.(gt);
  }, e[27] = L, e[28] = c, e[29] = I) : I = e[29];
  const D = I;
  let z;
  e[30] !== L || e[31] !== u ? (z = () => {
    const gt = N.current;
    if (!gt)
      return;
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")?.set?.call(gt, ""), gt.dispatchEvent(new Event("input", {
      bubbles: !0
    })), L || $(!1), gt.focus(), u?.();
  }, e[30] = L, e[31] = u, e[32] = z) : z = e[32];
  const U = z;
  let G;
  e[33] !== a || e[34] !== L ? (G = (gt) => {
    const Dn = N.current;
    !Dn || a || (gt === 1 ? Dn.stepUp() : Dn.stepDown(), Dn.dispatchEvent(new Event("input", {
      bubbles: !0
    })), L || $(Dn.value.length > 0), Dn.focus());
  }, e[33] = a, e[34] = L, e[35] = G) : G = e[35];
  const J = G, se = C === "number", Q = C === "file", ce = C === "password", W = l !== void 0 && !Q, oe = h !== void 0 && !se && !Q, Y = se || Q ? void 0 : n, Z = Y !== void 0, K = R && !Z, X = O && !!p && !R && !Z, ne = ce && (g ?? !0);
  process.env.NODE_ENV !== "production" && (g !== void 0 && !ce && console.warn("Input: `showPasswordToggle` has no effect on a non-password field."), l !== void 0 && Q && console.warn("Input: `leadingIcon` has no effect on a file field — the file chip owns the leading edge."), h !== void 0 && (se || Q) && console.warn("Input: `shortcutHint` has no effect on a number or file field — the spinner / file chip owns the trailing edge."), n !== void 0 && (se || Q) && console.warn("Input: `action` has no effect on a number or file field — the spinner / file chip owns the trailing edge."), Z && (R || O) && console.warn("Input: `action` is mutually exclusive with `clearable` / `copyable` — the action takes the trailing slot and the other props are ignored."));
  const re = K || X || Q || oe, ie = o !== void 0 && o !== !1 && o !== "false", de = typeof F == "number" ? void 0 : AR[F];
  let le;
  e[36] !== F ? (le = typeof F == "number" ? {
    maxWidth: "100%",
    width: `${F}px`
  } : void 0, e[36] = F, e[37] = le) : le = e[37];
  const te = le;
  let pe;
  e[38] !== te || e[39] !== y ? (pe = y || te ? {
    ...y,
    ...te
  } : void 0, e[38] = te, e[39] = y, e[40] = pe) : pe = e[40];
  const ue = pe, ye = se ? R ? it.reserveNumberClear : it.reserveNumber : Y !== void 0 ? "icon" in Y ? it.reserveTrailing : it.reserveAction : oe ? it.reserveHint : K || X ? it.reserveTrailing : void 0, ge = Z && !ce, Te = ce ? r ?? "current-password" : ge ? r ?? "off" : r;
  let Se;
  e[41] !== ge ? (Se = ge ? {
    "data-1p-ignore": !0,
    "data-bwignore": !0,
    "data-form-type": "other",
    "data-lpignore": "true"
  } : void 0, e[41] = ge, e[42] = Se) : Se = e[42];
  const xe = Se;
  let je;
  e[43] !== a ? (je = (gt) => {
    gt.target !== gt.currentTarget || a || (gt.preventDefault(), N.current?.focus());
  }, e[43] = a, e[44] = je) : je = e[44];
  const Me = je, Pe = ne && H ? "text" : C, we = p && it.readOnly, ve = Q && k && it.fileChosen;
  let Ae;
  e[45] !== s || e[46] !== we || e[47] !== ve ? (Ae = ae(it.input, we, ve, s), e[45] = s, e[46] = we, e[47] = ve, e[48] = Ae) : Ae = e[48];
  const Ne = re ? D : c, De = Q && S === void 0 ? "" : S;
  let ze;
  e[49] !== o || e[50] !== i || e[51] !== a || e[52] !== xe || e[53] !== d || e[54] !== p || e[55] !== Te || e[56] !== V || e[57] !== Pe || e[58] !== Ae || e[59] !== Ne || e[60] !== De || e[61] !== _ ? (ze = /* @__PURE__ */ b.jsx(kg, { ref: V, type: Pe, "aria-invalid": o, autoComplete: Te, "data-slot": "input", ...xe, className: Ae, defaultValue: i, disabled: a, onChange: Ne, readOnly: p, title: De, value: _, ...d }), e[49] = o, e[50] = i, e[51] = a, e[52] = xe, e[53] = d, e[54] = p, e[55] = Te, e[56] = V, e[57] = Pe, e[58] = Ae, e[59] = Ne, e[60] = De, e[61] = _, e[62] = ze) : ze = e[62];
  const et = ze, ct = W && it.reserveLeading, Le = p && it.stateReadonly, Ge = a && it.stateDisabled, Ee = ie && it.stateInvalid;
  let Ke;
  e[63] !== ye || e[64] !== ct || e[65] !== Le || e[66] !== Ge || e[67] !== Ee || e[68] !== de ? (Ke = ae(it.wrapper, de, ye, ct, Le, Ge, Ee), e[63] = ye, e[64] = ct, e[65] = Le, e[66] = Ge, e[67] = Ee, e[68] = de, e[69] = Ke) : Ke = e[69];
  let Xe;
  e[70] !== l || e[71] !== W ? (Xe = W ? /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", className: it.leadingIcon, "data-slot": "input-leading-icon", children: l }) : null, e[70] = l, e[71] = W, e[72] = Xe) : Xe = e[72];
  let Je;
  e[73] !== k || e[74] !== h || e[75] !== oe ? (Je = oe && !k ? /* @__PURE__ */ b.jsx("kbd", { "aria-hidden": "true", className: it.shortcutHint, "data-slot": "input-shortcut-hint", children: h }) : null, e[73] = k, e[74] = h, e[75] = oe, e[76] = Je) : Je = e[76];
  let wt;
  e[77] !== Y || e[78] !== a ? (wt = Y !== void 0 && !a ? /* @__PURE__ */ b.jsx("span", { className: it.action, "data-slot": "input-action", children: "icon" in Y ? /* @__PURE__ */ b.jsx(kt, { "aria-label": Y.ariaLabel, onClick: Y.onAction, size: "icon-xs", type: "button", variant: Y.variant ?? "ghost", children: Y.icon }) : /* @__PURE__ */ b.jsx(kt, { onClick: Y.onAction, size: "xs", type: "button", variant: Y.variant ?? "ghost", children: Y.label }) }) : null, e[77] = Y, e[78] = a, e[79] = wt) : wt = e[79];
  let Ce;
  e[80] !== R || e[81] !== a || e[82] !== J || e[83] !== se ? (Ce = se && !a ? /* @__PURE__ */ b.jsxs("span", { className: ae(it.spinner, R && it.spinnerShift), "data-slot": "input-spinner", children: [
    /* @__PURE__ */ b.jsx("button", { "aria-label": "Increment", className: it.spinnerButton, onClick: () => J(1), onMouseDown: DR, tabIndex: -1, type: "button", children: /* @__PURE__ */ b.jsx(Ve, { icon: ns, "aria-hidden": "true" }) }),
    /* @__PURE__ */ b.jsx("button", { "aria-label": "Decrement", className: it.spinnerButton, onClick: () => J(-1), onMouseDown: jR, tabIndex: -1, type: "button", children: /* @__PURE__ */ b.jsx(Ve, { icon: Vo, "aria-hidden": "true" }) })
  ] }) : null, e[80] = R, e[81] = a, e[82] = J, e[83] = se, e[84] = Ce) : Ce = e[84];
  let $e;
  e[85] !== a || e[86] !== U || e[87] !== k || e[88] !== K ? ($e = K && k && !a ? /* @__PURE__ */ b.jsx("button", { "aria-label": "Clear", className: it.clear, onClick: U, tabIndex: -1, type: "button", children: /* @__PURE__ */ b.jsx(Ve, { icon: Ia, "aria-hidden": "true" }) }) : null, e[85] = a, e[86] = U, e[87] = k, e[88] = K, e[89] = $e) : $e = e[89];
  let st;
  e[90] !== j || e[91] !== a || e[92] !== k || e[93] !== X ? (st = X && k && !a ? /* @__PURE__ */ b.jsx(xg, { className: it.copy, label: j, tabIndex: -1, value: () => N.current?.value ?? "" }) : null, e[90] = j, e[91] = a, e[92] = k, e[93] = X, e[94] = st) : st = e[94];
  let tt;
  e[95] !== Me || e[96] !== et || e[97] !== Ke || e[98] !== Xe || e[99] !== Je || e[100] !== wt || e[101] !== Ce || e[102] !== $e || e[103] !== st || e[104] !== ue ? (tt = /* @__PURE__ */ b.jsxs("span", { className: Ke, "data-slot": "input-wrapper", onMouseDown: Me, style: ue, children: [
    et,
    Xe,
    Je,
    wt,
    Ce,
    $e,
    st
  ] }), e[95] = Me, e[96] = et, e[97] = Ke, e[98] = Xe, e[99] = Je, e[100] = wt, e[101] = Ce, e[102] = $e, e[103] = st, e[104] = ue, e[105] = tt) : tt = e[105];
  const Qe = tt;
  if (!ne)
    return Qe;
  let ht;
  e[106] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ht = (gt) => B(gt === !0), e[106] = ht) : ht = e[106];
  let St;
  e[107] !== a || e[108] !== H || e[109] !== T ? (St = /* @__PURE__ */ b.jsx(Po, { "aria-label": "Show password", checked: H, disabled: a, id: T, onCheckedChange: ht }), e[107] = a, e[108] = H, e[109] = T, e[110] = St) : St = e[110];
  let xn;
  e[111] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (xn = /* @__PURE__ */ b.jsx("span", { children: "Show password" }), e[111] = xn) : xn = e[111];
  let wn;
  e[112] !== St || e[113] !== T ? (wn = /* @__PURE__ */ b.jsxs("label", { className: it.toggleRow, htmlFor: T, children: [
    St,
    xn
  ] }), e[112] = St, e[113] = T, e[114] = wn) : wn = e[114];
  let Ho;
  return e[115] !== Qe || e[116] !== wn ? (Ho = /* @__PURE__ */ b.jsxs("span", { className: it.passwordField, children: [
    Qe,
    wn
  ] }), e[115] = Qe, e[116] = wn, e[117] = Ho) : Ho = e[117], Ho;
};
function DR(t) {
  return t.preventDefault();
}
function jR(t) {
  return t.preventDefault();
}
const LR = (t) => {
  const e = ee.c(38);
  let n, o, r, s, i, a, l, c, u, d, p;
  e[0] !== t ? ({
    className: n,
    filters: o,
    onOpenPreferences: r,
    onSearchClear: s,
    onSearchFlush: i,
    onSearchInput: a,
    pager: l,
    searchPlaceholder: u,
    searchValue: d,
    searchable: p,
    ...c
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = p) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], p = e[11]);
  let m;
  e[12] !== n ? (m = ae(Yo.bar, n), e[12] = n, e[13] = m) : m = e[13];
  let h;
  e[14] !== s || e[15] !== i || e[16] !== a || e[17] !== u || e[18] !== d || e[19] !== p ? (h = p ? /* @__PURE__ */ b.jsx("div", { className: Yo.search, children: /* @__PURE__ */ b.jsx(Tg, { "aria-label": u, clearable: !0, onChange: (S) => a(S.target.value), onClear: s, onKeyDown: (S) => {
    S.key === "Enter" && (S.preventDefault(), i());
  }, placeholder: u, type: "search", value: d, width: "md" }) }) : null, e[14] = s, e[15] = i, e[16] = a, e[17] = u, e[18] = d, e[19] = p, e[20] = h) : h = e[20];
  let g;
  e[21] !== o ? (g = o != null ? /* @__PURE__ */ b.jsx("div", { className: Yo.filterSlot, children: o }) : null, e[21] = o, e[22] = g) : g = e[22];
  let y;
  e[23] !== l ? (y = l != null ? /* @__PURE__ */ b.jsx("span", { className: Yo.pipe, "aria-hidden": !0 }) : null, e[23] = l, e[24] = y) : y = e[24];
  let v;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /* @__PURE__ */ b.jsx(Ve, { icon: Q2, width: 24, height: 24 }), e[25] = v) : v = e[25];
  let x;
  e[26] !== r ? (x = /* @__PURE__ */ b.jsx(kt, { "aria-haspopup": "dialog", "aria-label": "Table preferences", className: Yo.gear, onClick: r, size: "icon-sm", variant: "ghost", children: v }), e[26] = r, e[27] = x) : x = e[27];
  let w;
  e[28] !== l || e[29] !== y || e[30] !== x ? (w = /* @__PURE__ */ b.jsxs("div", { className: Yo.barEnd, children: [
    l,
    y,
    x
  ] }), e[28] = l, e[29] = y, e[30] = x, e[31] = w) : w = e[31];
  let E;
  return e[32] !== c || e[33] !== m || e[34] !== h || e[35] !== g || e[36] !== w ? (E = /* @__PURE__ */ b.jsxs("div", { "data-slot": "table-filter-bar", className: m, ...c, children: [
    h,
    g,
    w
  ] }), e[32] = c, e[33] = m, e[34] = h, e[35] = g, e[36] = w, e[37] = E) : E = e[37], E;
}, $R = "_panel_4yupm_1", FR = "_sections_4yupm_5", VR = "_section_4yupm_5", zR = "_sectionLabel_4yupm_17", BR = "_list_4yupm_23", HR = "_row_4yupm_28", UR = "_rowLabel_4yupm_36", WR = "_rowDropTarget_4yupm_44", GR = "_fixedGroup_4yupm_54", KR = "_groupLabel_4yupm_60", YR = "_switchRow_4yupm_66", qR = "_footerLead_4yupm_73", XR = "_srOnly_4yupm_77", Rt = {
  panel: $R,
  sections: FR,
  section: VR,
  sectionLabel: zR,
  list: BR,
  row: HR,
  rowLabel: UR,
  rowDropTarget: WR,
  fixedGroup: GR,
  groupLabel: KR,
  switchRow: YR,
  footerLead: qR,
  srOnly: XR
};
function Ig(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: s,
    disablePointerDismissal: i = !1,
    modal: a = !0,
    actionsRef: l,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null
  } = t, p = Xn(!0), m = !!p, h = jt(() => c?.store ?? new jh({
    open: n ?? o,
    activeTriggerId: u !== void 0 ? u : d,
    modal: a,
    disablePointerDismissal: i,
    nested: m
  })).current;
  h.useControlledProp("open", n, o), h.useControlledProp("activeTriggerId", u, d), h.useSyncedValues({
    disablePointerDismissal: i,
    nested: m,
    modal: a
  }), h.useContextCallback("onOpenChange", r), h.useContextCallback("onOpenChangeComplete", s);
  const g = h.useState("payload");
  Dh({
    store: h,
    actionsRef: l,
    parentContext: p?.store.context
  });
  const y = f.useMemo(() => ({
    store: h
  }), [h]);
  return /* @__PURE__ */ b.jsx(va.Provider, {
    value: y,
    children: typeof e == "function" ? e({
      payload: g
    }) : e
  });
}
const ZR = "_overlay_1fc0m_1", JR = "_popup_1fc0m_20", QR = "_sm_1fc0m_44", eN = "_md_1fc0m_48", tN = "_lg_1fc0m_52", nN = "_xl_1fc0m_56", oN = "_full_1fc0m_60", rN = "_header_1fc0m_68", sN = "_headerText_1fc0m_78", iN = "_title_1fc0m_85", aN = "_description_1fc0m_93", lN = "_headerActions_1fc0m_100", cN = "_closeButton_1fc0m_107", uN = "_floatingClose_1fc0m_121", dN = "_body_1fc0m_128", fN = "_bodyPadded_1fc0m_148", pN = "_footer_1fc0m_152", mN = "_srOnly_1fc0m_162", hN = "_fullScreenOnMobile_1fc0m_175", Nt = {
  overlay: ZR,
  popup: JR,
  sm: QR,
  md: eN,
  lg: tN,
  xl: nN,
  full: oN,
  header: rN,
  headerText: sN,
  title: iN,
  description: aN,
  headerActions: lN,
  closeButton: cN,
  floatingClose: uN,
  body: dN,
  bodyPadded: fN,
  footer: pN,
  srOnly: mN,
  fullScreenOnMobile: hN
}, gN = "_dragRegion_1i8bi_16", bN = "_mac_1i8bi_34", pl = {
  dragRegion: gN,
  mac: bN
}, Og = () => {
  const t = ee.c(1);
  if (!_n.isElectron())
    return null;
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ b.jsx("div", { "aria-hidden": "true", className: _n.isMacOS() ? `${pl.dragRegion} ${pl.mac}` : pl.dragRegion, "data-slot": "overlay-drag-region" }), t[0] = e) : e = t[0], e;
}, vN = {
  full: Nt.full,
  lg: Nt.lg,
  md: Nt.md,
  sm: Nt.sm,
  xl: Nt.xl
}, Kf = () => {
  const t = ee.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ b.jsxs(Rr, { "data-slot": "modal-close", render: /* @__PURE__ */ b.jsx(kt, { className: Nt.closeButton, size: "icon-sm", type: "button", variant: "ghost" }), children: [
    /* @__PURE__ */ b.jsx(Ve, { icon: Ia, width: 24, height: 24, "aria-hidden": "true" }),
    /* @__PURE__ */ b.jsx("span", { className: Nt.srOnly, children: "Close" })
  ] }), t[0] = e) : e = t[0], e;
}, yN = (t) => {
  const e = ee.c(42), {
    "aria-label": n,
    children: o,
    className: r,
    defaultOpen: s,
    description: i,
    dismissible: a,
    footer: l,
    fullScreenOnMobile: c,
    headerActions: u,
    initialFocus: d,
    onOpenChange: p,
    open: m,
    padded: h,
    showCloseButton: g,
    size: y,
    style: v,
    title: x,
    trigger: w
  } = t, E = a === void 0 ? !0 : a, S = c === void 0 ? !0 : c, C = h === void 0 ? !0 : h, _ = g === void 0 ? !0 : g, R = y === void 0 ? "md" : y, O = x != null || i != null || u != null;
  let j;
  e[0] !== E || e[1] !== p ? (j = (G, J) => {
    if (!G && !E && (J.reason === "escape-key" || J.reason === "outside-press")) {
      J.cancel();
      return;
    }
    p?.(G);
  }, e[0] = E, e[1] = p, e[2] = j) : j = e[2];
  const F = j;
  let N;
  e[3] !== w ? (N = w && /* @__PURE__ */ b.jsx(_a, { "data-slot": "modal-trigger", render: w }), e[3] = w, e[4] = N) : N = e[4];
  let T, L;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ b.jsx(ya, { className: Nt.overlay, "data-slot": "modal-overlay" }), L = /* @__PURE__ */ b.jsx(Og, {}), e[5] = T, e[6] = L) : (T = e[5], L = e[6]);
  const M = x == null ? n : void 0, A = vN[R], $ = S && Nt.fullScreenOnMobile;
  let k;
  e[7] !== r || e[8] !== A || e[9] !== $ ? (k = ae(Nt.popup, A, $, r), e[7] = r, e[8] = A, e[9] = $, e[10] = k) : k = e[10];
  let H;
  e[11] !== i || e[12] !== O || e[13] !== u || e[14] !== _ || e[15] !== x ? (H = O && /* @__PURE__ */ b.jsxs("header", { className: Nt.header, "data-slot": "modal-header", children: [
    /* @__PURE__ */ b.jsxs("div", { className: Nt.headerText, children: [
      x != null && /* @__PURE__ */ b.jsx(Ca, { className: Nt.title, "data-slot": "modal-title", children: x }),
      i != null && /* @__PURE__ */ b.jsx(xa, { className: Nt.description, "data-slot": "modal-description", children: i })
    ] }),
    (u != null || _) && /* @__PURE__ */ b.jsxs("div", { className: Nt.headerActions, "data-slot": "modal-header-actions", children: [
      u,
      _ && /* @__PURE__ */ b.jsx(Kf, {})
    ] })
  ] }), e[11] = i, e[12] = O, e[13] = u, e[14] = _, e[15] = x, e[16] = H) : H = e[16];
  let B;
  e[17] !== O || e[18] !== _ ? (B = !O && _ && /* @__PURE__ */ b.jsx("div", { className: Nt.floatingClose, "data-slot": "modal-header-actions", children: /* @__PURE__ */ b.jsx(Kf, {}) }), e[17] = O, e[18] = _, e[19] = B) : B = e[19];
  const P = C && Nt.bodyPadded;
  let V;
  e[20] !== P ? (V = ae(Nt.body, P), e[20] = P, e[21] = V) : V = e[21];
  let I;
  e[22] !== o || e[23] !== V ? (I = /* @__PURE__ */ b.jsx("div", { className: V, "data-slot": "modal-body", children: o }), e[22] = o, e[23] = V, e[24] = I) : I = e[24];
  let D;
  e[25] !== l ? (D = l != null && /* @__PURE__ */ b.jsx("footer", { className: Nt.footer, "data-slot": "modal-footer", children: l }), e[25] = l, e[26] = D) : D = e[26];
  let z;
  e[27] !== d || e[28] !== v || e[29] !== M || e[30] !== k || e[31] !== H || e[32] !== B || e[33] !== I || e[34] !== D ? (z = /* @__PURE__ */ b.jsxs(Ea, { children: [
    T,
    L,
    /* @__PURE__ */ b.jsxs(wa, { "aria-label": M, className: k, "data-slot": "modal-content", initialFocus: d, style: v, children: [
      H,
      B,
      I,
      D
    ] })
  ] }), e[27] = d, e[28] = v, e[29] = M, e[30] = k, e[31] = H, e[32] = B, e[33] = I, e[34] = D, e[35] = z) : z = e[35];
  let U;
  return e[36] !== s || e[37] !== F || e[38] !== m || e[39] !== z || e[40] !== N ? (U = /* @__PURE__ */ b.jsxs(Ig, { defaultOpen: s, onOpenChange: F, open: m, children: [
    N,
    z
  ] }), e[36] = s, e[37] = F, e[38] = m, e[39] = z, e[40] = N, e[41] = U) : U = e[41], U;
}, uu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (uu.displayName = "SwitchRootContext");
function xN() {
  const t = f.useContext(uu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SwitchRootContext is missing. Switch parts must be placed within <Switch.Root>." : We(63));
  return t;
}
let Yf = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const Mg = {
  ...zo,
  checked(t) {
    return t ? {
      [Yf.checked]: ""
    } : {
      [Yf.unchecked]: ""
    };
  }
}, Pg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: s,
    id: i,
    inputRef: a,
    name: l,
    nativeButton: c = !1,
    onCheckedChange: u,
    readOnly: d = !1,
    required: p = !1,
    disabled: m = !1,
    render: h,
    uncheckedValue: g,
    value: y,
    ...v
  } = e, {
    clearErrors: x
  } = Nr(), {
    state: w,
    setTouched: E,
    setDirty: S,
    validityData: C,
    setFilled: _,
    setFocused: R,
    shouldValidateOnChange: O,
    validationMode: j,
    disabled: F,
    name: N,
    validation: T
  } = dn(), {
    labelId: L
  } = yo(), M = F || m, A = N ?? l, $ = fe(u), k = f.useRef(null), H = zt(k, a, T.inputRef), B = f.useRef(null), P = lt(), V = Ir({
    id: i,
    implicit: !1,
    controlRef: B
  }), I = c ? void 0 : V, [D, z] = un({
    controlled: o,
    default: !!s,
    name: "Switch",
    state: "checked"
  });
  kr({
    id: P,
    commit: T.commit,
    value: D,
    controlRef: B,
    name: A,
    getValue: () => D
  }), he(() => {
    k.current && _(k.current.checked);
  }, [k, _]), ws(D, () => {
    x(A), S(D !== C.initialValue), _(D), O() ? T.commit(D) : T.commit(D, !0);
  });
  const {
    getButtonProps: U,
    buttonRef: G
  } = Wt({
    disabled: M,
    native: c
  }), J = {
    id: c ? V : P,
    role: "switch",
    "aria-checked": D,
    "aria-readonly": d || void 0,
    "aria-required": p || void 0,
    "aria-labelledby": L,
    onFocus() {
      M || R(!0);
    },
    onBlur() {
      const W = k.current;
      !W || M || (E(!0), R(!1), j === "onBlur" && T.commit(W.checked));
    },
    onClick(W) {
      d || M || (W.preventDefault(), k?.current?.click());
    }
  }, se = f.useMemo(() => Qt(
    {
      checked: D,
      disabled: M,
      id: I,
      name: A,
      required: p,
      style: A ? ms : Wn,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      ref: H,
      onChange(W) {
        if (W.nativeEvent.defaultPrevented)
          return;
        const oe = W.target.checked, Y = ke(Ut, W.nativeEvent);
        $?.(oe, Y), !Y.isCanceled && z(oe);
      },
      onFocus() {
        B.current?.focus();
      }
    },
    T.getInputValidationProps,
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    y !== void 0 ? {
      value: y
    } : at
  ), [D, M, H, I, A, $, p, z, T, y]), Q = f.useMemo(() => ({
    ...w,
    checked: D,
    disabled: M,
    readOnly: d,
    required: p
  }), [w, D, M, d, p]), ce = _e("span", e, {
    state: Q,
    ref: [n, B, G],
    props: [J, T.getValidationProps, v, U],
    stateAttributesMapping: Mg
  });
  return /* @__PURE__ */ b.jsxs(uu.Provider, {
    value: Q,
    children: [ce, !D && A && g !== void 0 && /* @__PURE__ */ b.jsx("input", {
      type: "hidden",
      name: A,
      value: g
    }), /* @__PURE__ */ b.jsx("input", {
      ...se
    })]
  });
});
process.env.NODE_ENV !== "production" && (Pg.displayName = "SwitchRoot");
const Ag = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    ...s
  } = e, {
    state: i
  } = dn(), a = xN(), l = {
    ...i,
    ...a
  };
  return _e("span", e, {
    state: l,
    ref: n,
    stateAttributesMapping: Mg,
    props: s
  });
});
process.env.NODE_ENV !== "production" && (Ag.displayName = "SwitchThumb");
const wN = (t) => {
  const e = ee.c(11);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    size: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "default" : r;
  let i;
  e[4] !== n ? (i = ae("group/switch peer relative inline-flex shrink-0 cursor-pointer items-center rounded-full p-[2px] outline-none", "data-[size=default]:h-[var(--density-switch-h)] data-[size=default]:w-[var(--density-switch-w)] data-[size=sm]:h-[var(--density-switch-sm-h)] data-[size=sm]:w-[var(--density-switch-sm-w)]", "data-unchecked:bg-[var(--gray-300)] dark:data-unchecked:bg-[var(--gray-400)] data-checked:bg-action-primary", "transition-colors duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)]", "focus-visible:ring-ring-focus/50 focus-visible:ring-[3px]", "aria-invalid:ring-feedback-danger aria-invalid:ring-[2px]", "after:absolute after:-inset-x-[12px] after:-inset-y-[8px]", "data-disabled:cursor-not-allowed data-disabled:opacity-50", n), e[4] = n, e[5] = i) : i = e[5];
  let a;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b.jsx(Ag, { "data-slot": "switch-thumb", className: ae("bg-on-primary pointer-events-none block rounded-full ring-0", "group-data-[size=default]/switch:size-[calc(var(--density-switch-h)-4px)] group-data-[size=sm]/switch:size-[calc(var(--density-switch-sm-h)-4px)]", "data-unchecked:translate-x-0", "group-data-[size=default]/switch:data-checked:translate-x-[calc(var(--density-switch-w)-var(--density-switch-h))] group-data-[size=sm]/switch:data-checked:translate-x-[calc(var(--density-switch-sm-w)-var(--density-switch-sm-h))]", "transition-transform duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)]") }), e[6] = a) : a = e[6];
  let l;
  return e[7] !== o || e[8] !== s || e[9] !== i ? (l = /* @__PURE__ */ b.jsx(Pg, { "data-slot": "switch", "data-size": s, className: i, ...o, children: a }), e[7] = o, e[8] = s, e[9] = i, e[10] = l) : l = e[10], l;
}, SN = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M3 12a9 9 0 1 0 9-9a9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></g>'
}, EN = SN, CN = (t) => {
  const e = ee.c(3), {
    onClick: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ b.jsx(Ve, { icon: EN, width: 16, height: 16 }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ b.jsxs(kt, { variant: "ghost", size: "sm", onClick: n, "aria-label": "Reset to defaults", title: "Reset to defaults", "data-slot": "table-layout-reset", children: [
    o,
    "Reset"
  ] }), e[1] = n, e[2] = r) : r = e[2], r;
}, _N = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><circle cx="9" cy="12" r="1"/><circle cx="9" cy="5" r="1"/><circle cx="9" cy="19" r="1"/><circle cx="15" cy="12" r="1"/><circle cx="15" cy="5" r="1"/><circle cx="15" cy="19" r="1"/></g>'
}, RN = _N, NN = "_grip_1wamo_1", kN = "_dragging_1wamo_26", qf = {
  grip: NN,
  dragging: kN
}, TN = ({
  className: t,
  label: e,
  onMove: n,
  onDragStart: o,
  onDragMove: r,
  onDragEnd: s,
  orientation: i = "horizontal",
  ...a
}) => {
  const [l, c] = f.useState(!1), u = f.useRef(r), d = f.useRef(s);
  u.current = r, d.current = s;
  const p = f.useRef(null), m = f.useCallback(() => {
    p.current?.(), p.current = null;
  }, []);
  f.useEffect(() => () => m(), [m]);
  const h = f.useCallback((y) => {
    const v = i === "vertical" ? "ArrowUp" : "ArrowLeft", x = i === "vertical" ? "ArrowDown" : "ArrowRight";
    y.key === v ? (y.preventDefault(), n(-1)) : y.key === x && (y.preventDefault(), n(1));
  }, [n, i]), g = f.useCallback((y) => {
    if (y.button > 0) return;
    p.current?.();
    const v = y.currentTarget, x = y.pointerId;
    v.setPointerCapture?.(x), c(!0);
    const w = (_) => u.current(_), E = () => {
      window.removeEventListener("pointermove", w), window.removeEventListener("pointerup", S), window.removeEventListener("keydown", C), v.releasePointerCapture?.(x), p.current = null, c(!1);
    }, S = (_) => {
      E(), d.current(_);
    }, C = (_) => {
      _.key === "Escape" && (E(), d.current(_));
    };
    window.addEventListener("pointermove", w), window.addEventListener("pointerup", S), window.addEventListener("keydown", C), p.current = E, o(y);
  }, [o]);
  return /* @__PURE__ */ b.jsx("button", { type: "button", "aria-label": e, "data-slot": "table-reorder-grip", "data-dragging": l ? "" : void 0, className: ae(qf.grip, l && qf.dragging, t), onKeyDown: h, onPointerDown: g, ...a, children: /* @__PURE__ */ b.jsx(Ve, { icon: RN, "aria-hidden": "true" }) });
}, IN = "_track_1vxex_1", ON = "_segment_1vxex_10", Xf = {
  track: IN,
  segment: ON
}, MN = (t) => {
  const e = ee.c(18);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    className: n,
    labelledBy: o,
    onValueChange: r,
    options: s,
    value: a,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = f.useRef(null);
  let c;
  e[7] !== s || e[8] !== a ? (c = s.indexOf(a), e[7] = s, e[8] = a, e[9] = c) : c = e[9];
  const u = c, d = u === -1 ? 0 : u, p = (x) => (w) => {
    const E = PN[w.key];
    if (E === void 0 || s.length === 0)
      return;
    w.preventDefault();
    const S = (x + E + s.length) % s.length;
    r(s[S]), l.current?.querySelectorAll("button")[S]?.focus();
  };
  let m;
  e[10] !== n ? (m = ae(Xf.track, n), e[10] = n, e[11] = m) : m = e[11];
  const h = "table-page-size", g = "radiogroup", y = s.map((x, w) => /* @__PURE__ */ b.jsx("button", { "aria-checked": x === a, className: Xf.segment, onClick: () => r(x), onKeyDown: p(w), role: "radio", tabIndex: w === d ? 0 : -1, type: "button", children: x }, x));
  let v;
  return e[12] !== o || e[13] !== i || e[14] !== m || e[15] !== y || e[16] !== l ? (v = /* @__PURE__ */ b.jsx("div", { "aria-labelledby": o, className: m, "data-slot": h, ref: l, role: g, ...i, children: y }), e[12] = o, e[13] = i, e[14] = m, e[15] = y, e[16] = l, e[17] = v) : v = e[17], v;
}, PN = {
  ArrowDown: 1,
  ArrowLeft: -1,
  ArrowRight: 1,
  ArrowUp: -1
}, AN = ({
  columns: t,
  fixedColumns: e,
  limit: n,
  limitOptions: o,
  onLimitChange: r,
  onOpenChange: s,
  onOrderChange: i,
  onReset: a,
  onVisibilityChange: l,
  onWrapLinesChange: c,
  open: u,
  reorderable: d = !0,
  wrapLines: p
}) => {
  const m = f.useId(), h = `${m}-page-size`, g = `${m}-wrap`, [y, v] = f.useState(""), [x, w] = f.useState(null), E = f.useRef(null), S = f.useRef(!1), C = f.useRef(null), _ = f.useRef(null);
  _.current = x;
  const R = t.map((B) => B.id), O = new Map(t.map((B) => [B.id, B])), j = jN(t, e), F = (B, P, V) => {
    v(`${O.get(B)?.label ?? B}, position ${P + 1} of ${V}`);
  }, N = f.useCallback(() => {
    C.current = null, w(null);
  }, []), T = (B) => {
    const P = C.current, V = _.current;
    if (N(), B || P === null || V === null) return;
    const I = R.indexOf(P);
    if (I === -1 || I === V) return;
    const D = Zf(R, I, V);
    i(D), F(P, V, D.length);
  }, L = (B) => {
    C.current !== null && w(DN(E.current, R, B));
  }, M = (B) => {
    C.current = B, w(R.indexOf(B));
  }, A = (B) => {
    !B && S.current || s(B);
  }, $ = (B, P) => {
    const V = R.indexOf(B);
    if (V === -1) return;
    const I = Math.max(0, Math.min(R.length - 1, V + P));
    I !== V && i(Zf(R, V, I)), F(B, I, R.length);
  }, k = (B, P) => {
    const V = LN(t, e);
    P ? delete V[B] : V[B] = !1, l(V);
  };
  f.useEffect(() => {
    if (!u) return;
    const B = (P) => {
      P.key !== "Escape" || !S.current || (P.stopPropagation(), S.current = !1, N());
    };
    return document.addEventListener("keydown", B, !0), () => document.removeEventListener("keydown", B, !0);
  }, [N, u]), f.useEffect(() => {
    u && (S.current = !1, C.current = null, v(""), w(null));
  }, [u]);
  const H = a ? /* @__PURE__ */ b.jsx("div", { className: Rt.footerLead, children: /* @__PURE__ */ b.jsx(CN, { onClick: a }) }) : null;
  return /* @__PURE__ */ b.jsxs(yN, { className: Rt.panel, footer: H, onOpenChange: A, open: u, size: "sm", title: "Preferences", children: [
    /* @__PURE__ */ b.jsxs("div", { className: Rt.sections, "data-slot": "table-preferences", children: [
      /* @__PURE__ */ b.jsxs("section", { className: Rt.section, children: [
        /* @__PURE__ */ b.jsx("span", { className: Rt.sectionLabel, id: h, children: "Rows per page" }),
        /* @__PURE__ */ b.jsx(MN, { labelledBy: h, onValueChange: r, options: o, value: n })
      ] }),
      /* @__PURE__ */ b.jsxs("section", { className: Rt.section, children: [
        /* @__PURE__ */ b.jsx("span", { className: Rt.sectionLabel, children: "Columns" }),
        /* @__PURE__ */ b.jsx("div", { className: Rt.list, ref: E, children: t.map((B, P) => /* @__PURE__ */ b.jsxs("div", { className: ae(Rt.row, x === P && Rt.rowDropTarget), "data-column-row": B.id, "data-drop-target": x === P ? "" : void 0, children: [
          d ? /* @__PURE__ */ b.jsx(TN, { label: `Reorder ${B.label} column`, onDragEnd: (V) => {
            S.current = !1, T(V instanceof KeyboardEvent);
          }, onDragMove: (V) => L(V.clientY), onDragStart: () => {
            S.current = !0, M(B.id);
          }, onMove: (V) => $(B.id, V), orientation: "vertical" }) : null,
          /* @__PURE__ */ b.jsx("span", { className: Rt.rowLabel, children: B.label }),
          /* @__PURE__ */ b.jsx(Po, { "aria-label": `Show ${B.label} column`, checked: B.visible, disabled: !B.hideable || B.id === j, onCheckedChange: (V) => k(B.id, V) })
        ] }, B.id)) }),
        e.length > 0 ? /* @__PURE__ */ b.jsxs("div", { className: Rt.fixedGroup, "data-slot": "table-preferences-fixed", children: [
          /* @__PURE__ */ b.jsx("span", { className: Rt.groupLabel, children: "Fixed columns" }),
          e.map((B) => /* @__PURE__ */ b.jsxs("div", { className: Rt.row, children: [
            /* @__PURE__ */ b.jsx("span", { className: Rt.rowLabel, children: B.label }),
            /* @__PURE__ */ b.jsx(Po, { "aria-label": `Show ${B.label} column`, checked: B.visible, disabled: !B.hideable || B.id === j, onCheckedChange: (P) => k(B.id, P) })
          ] }, B.id))
        ] }) : null
      ] }),
      /* @__PURE__ */ b.jsx("section", { className: Rt.section, children: /* @__PURE__ */ b.jsxs("div", { className: Rt.switchRow, children: [
        /* @__PURE__ */ b.jsx("span", { className: Rt.sectionLabel, id: g, children: "Wrap lines" }),
        /* @__PURE__ */ b.jsx(wN, { "aria-labelledby": g, checked: p, onCheckedChange: c })
      ] }) })
    ] }),
    /* @__PURE__ */ b.jsx("div", { "aria-live": "polite", className: Rt.srOnly, "data-slot": "table-preferences-live", role: "status", children: y })
  ] });
}, DN = (t, e, n) => {
  if (!t || e.length === 0) return 0;
  let o = e.length - 1;
  for (let r = 0; r < e.length; r++) {
    const s = t.querySelector(`[data-column-row="${CSS.escape(e[r])}"]`);
    if (!s) continue;
    const i = s.getBoundingClientRect();
    if (n < i.top + i.height / 2) {
      o = r;
      break;
    }
  }
  return Math.max(0, Math.min(e.length - 1, o));
}, jN = (t, e) => {
  const n = [...t, ...e].filter((o) => o.visible);
  return n.length === 1 ? n[0].id : null;
}, Zf = (t, e, n) => {
  const o = t.slice(), [r] = o.splice(e, 1);
  return o.splice(n, 0, r), o;
}, LN = (t, e) => Object.fromEntries([...t, ...e].filter((n) => !n.visible).map((n) => [n.id, !1])), $N = "_row_1jd7i_1", FN = "_cell_1jd7i_5", VN = "_bar_1jd7i_10", ac = {
  row: $N,
  cell: FN,
  bar: VN
}, zN = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("bg-skeleton rounded-md animate-pulse", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "skeleton", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, BN = (t) => {
  const e = ee.c(16);
  let n, o, r, s;
  e[0] !== t ? ({
    className: n,
    rows: s,
    columns: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  let i;
  e[5] !== n ? (i = ae(n), e[5] = n, e[6] = i) : i = e[6];
  let a;
  if (e[7] !== o || e[8] !== s) {
    let c;
    e[10] !== o ? (c = (u, d) => /* @__PURE__ */ b.jsx("tr", { className: ac.row, children: Array.from({
      length: o
    }, HN) }, d), e[10] = o, e[11] = c) : c = e[11], a = Array.from({
      length: s
    }, c), e[7] = o, e[8] = s, e[9] = a;
  } else
    a = e[9];
  let l;
  return e[12] !== r || e[13] !== i || e[14] !== a ? (l = /* @__PURE__ */ b.jsx("tbody", { "data-slot": "table-skeleton-rows", "aria-hidden": "true", className: i, ...r, children: a }), e[12] = r, e[13] = i, e[14] = a, e[15] = l) : l = e[15], l;
};
function HN(t, e) {
  return /* @__PURE__ */ b.jsx("td", { className: ac.cell, children: /* @__PURE__ */ b.jsx(zN, { className: ac.bar }) }, e);
}
const UN = "_bar_1sfy5_1", WN = "_barBulk_1sfy5_11", GN = "_title_1sfy5_15", KN = "_count_1sfy5_26", YN = "_titleActions_1sfy5_32", qo = {
  bar: UN,
  barBulk: WN,
  title: GN,
  count: KN,
  titleActions: YN
}, qN = "_bar_hfgpl_1", XN = "_count_hfgpl_13", ZN = "_actions_hfgpl_18", ml = {
  bar: qN,
  count: XN,
  actions: ZN
}, JN = (t) => {
  const e = ee.c(21);
  let n, o, r, s, i;
  e[0] !== t ? ({
    className: o,
    count: r,
    onClear: s,
    children: n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  let a;
  e[6] !== o ? (a = ae(ml.bar, o), e[6] = o, e[7] = a) : a = e[7];
  let l;
  e[8] !== r ? (l = /* @__PURE__ */ b.jsxs("span", { className: ml.count, children: [
    r,
    " selected"
  ] }), e[8] = r, e[9] = l) : l = e[9];
  let c;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ b.jsx(Ve, { icon: Ia, width: 24, height: 24 }), e[10] = c) : c = e[10];
  let u;
  e[11] !== s ? (u = /* @__PURE__ */ b.jsxs(kt, { variant: "ghost", size: "sm", onClick: s, children: [
    c,
    "Clear"
  ] }), e[11] = s, e[12] = u) : u = e[12];
  let d;
  e[13] !== n ? (d = /* @__PURE__ */ b.jsx("div", { className: ml.actions, children: n }), e[13] = n, e[14] = d) : d = e[14];
  let p;
  return e[15] !== i || e[16] !== a || e[17] !== l || e[18] !== u || e[19] !== d ? (p = /* @__PURE__ */ b.jsxs("div", { "data-slot": "table-bulk-actions", className: a, ...i, children: [
    l,
    u,
    d
  ] }), e[15] = i, e[16] = a, e[17] = l, e[18] = u, e[19] = d, e[20] = p) : p = e[20], p;
}, QN = (t) => {
  const e = ee.c(33);
  let n, o, r, s, i, a, l, c, u;
  e[0] !== t ? ({
    actions: n,
    bulkActions: o,
    className: r,
    count: s,
    headingLevel: c,
    onClearSelection: i,
    selectedCount: l,
    title: u,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9]);
  const d = c === void 0 ? 2 : c, p = o != null && l > 0, m = `h${d}`;
  if (p) {
    let x;
    e[10] !== r ? (x = ae(qo.bar, qo.barBulk, r), e[10] = r, e[11] = x) : x = e[11];
    let w;
    e[12] !== o || e[13] !== i || e[14] !== l ? (w = /* @__PURE__ */ b.jsx(JN, { count: l, onClear: i, children: o }), e[12] = o, e[13] = i, e[14] = l, e[15] = w) : w = e[15];
    let E;
    return e[16] !== a || e[17] !== x || e[18] !== w ? (E = /* @__PURE__ */ b.jsx("div", { "data-slot": "table-title-bar", className: x, ...a, children: w }), e[16] = a, e[17] = x, e[18] = w, e[19] = E) : E = e[19], E;
  }
  let h;
  e[20] !== r ? (h = ae(qo.bar, r), e[20] = r, e[21] = h) : h = e[21];
  let g;
  e[22] !== m || e[23] !== s || e[24] !== u ? (g = u != null ? /* @__PURE__ */ b.jsxs(m, { className: qo.title, children: [
    u,
    s !== void 0 ? /* @__PURE__ */ b.jsx("span", { className: qo.count, children: ` (${s})` }) : null
  ] }) : null, e[22] = m, e[23] = s, e[24] = u, e[25] = g) : g = e[25];
  let y;
  e[26] !== n ? (y = n != null ? /* @__PURE__ */ b.jsx("div", { className: qo.titleActions, children: n }) : null, e[26] = n, e[27] = y) : y = e[27];
  let v;
  return e[28] !== a || e[29] !== h || e[30] !== g || e[31] !== y ? (v = /* @__PURE__ */ b.jsxs("div", { "data-slot": "table-title-bar", className: h, ...a, children: [
    g,
    y
  ] }), e[28] = a, e[29] = h, e[30] = g, e[31] = y, e[32] = v) : v = e[32], v;
}, Dg = 2, Xr = {
  /**
   * Order-independent signature of a column set: the sorted ids JSON-encoded. Reorder-stable;
   * add/remove-sensitive. JSON encoding (not a plain `join`) so an id containing the delimiter can't collide
   * (`['a,b']` vs `['a','b']`).
   */
  columnSig(t) {
    return JSON.stringify(t.map((e) => e.id).sort());
  },
  /**
   * Read + reconcile the persisted layout for `tableId`, returning a fully reconciled blob whose
   * `columnSig` has been rewritten to the CURRENT signature — or `undefined`. A `columnSig` mismatch
   * merges instead of discarding, an unhonorable `sort` drops to `null` alone, a v1 blob migrates,
   * and every width is validated + clamped before it can reach an inline `<col>` style. The
   * reconciled blob is NOT written back eagerly — the next `write` persists it.
   * @param options.tableId Table identity → storage key.
   * @param options.columns Current columns — every persisted field is reconciled against them.
   * @param options.limitOptions Page-size allow-list; defaults to `TableDefaults.LIMIT_OPTIONS`.
   * @param options.storage Storage surface; defaults to `window.localStorage`.
   */
  read({
    columns: t,
    limitOptions: e,
    storage: n,
    tableId: o
  }) {
    const r = n ?? hl();
    if (!r) return;
    const s = gl(o), i = ck(r, s);
    if (i === null) return;
    const a = nk(i);
    if (!a) {
      Ks(r, s);
      return;
    }
    const l = a.version;
    if (typeof l != "number" || l < 1) {
      Ks(r, s);
      return;
    }
    if (l > Dg) return;
    if (l !== 1 && l !== 2) {
      Ks(r, s);
      return;
    }
    const c = ok(a, l);
    if (!c) {
      Ks(r, s);
      return;
    }
    const u = l === 1 ? tk(c) : c;
    return rk(u, t, e ?? ur.LIMIT_OPTIONS);
  },
  /**
   * Serialize + persist the layout under `blufin:table:<tableId>`.
   * @param options.tableId Table identity → storage key.
   * @param options.layout The blob to persist.
   * @param options.storage Storage surface; defaults to `window.localStorage`.
   */
  write({
    layout: t,
    storage: e,
    tableId: n
  }) {
    const o = e ?? hl();
    if (o)
      try {
        o.setItem(gl(n), JSON.stringify(t));
      } catch {
      }
  },
  /**
   * Remove the persisted layout for `tableId`.
   * @param options.tableId Table identity → storage key.
   * @param options.storage Storage surface; defaults to `window.localStorage`.
   */
  clear({
    storage: t,
    tableId: e
  }) {
    const n = t ?? hl();
    if (n)
      try {
        n.removeItem(gl(e));
      } catch {
      }
  }
}, hl = () => typeof window > "u" ? void 0 : window.localStorage, ek = (t, e) => t === null ? !0 : e.find((o) => o.id === t.columnId)?.sortable === !0, gl = (t) => `blufin:table:${t}`, tk = (t) => ({
  columnSig: t.columnSig,
  limit: null,
  order: t.order,
  sort: t.sort,
  version: 2,
  visibility: {},
  widths: t.widths,
  wrapLines: !1
}), nk = (t) => {
  let e;
  try {
    e = JSON.parse(t);
  } catch {
    return;
  }
  if (!(typeof e != "object" || e === null))
    return e;
}, ok = (t, e) => {
  if (typeof t.columnSig == "string" && !(!Array.isArray(t.order) || !t.order.every((n) => typeof n == "string")) && !(typeof t.widths != "object" || t.widths === null) && Object.values(t.widths).every((n) => typeof n == "number" && Number.isFinite(n))) {
    if (t.sort !== null) {
      if (typeof t.sort != "object") return;
      const n = t.sort;
      if (typeof n.columnId != "string" || n.direction !== "asc" && n.direction !== "desc") return;
    }
    if (!(e === 2 && (typeof t.visibility != "object" || t.visibility === null || !Object.values(t.visibility).every((n) => typeof n == "boolean") || t.limit !== null && typeof t.limit != "number" || typeof t.wrapLines != "boolean")))
      return t;
  }
}, rk = (t, e, n) => ({
  columnSig: Xr.columnSig(e),
  limit: sk(t.limit, n),
  order: ik(t.order, e),
  /** The single most important v2 change: an unhonorable sort drops to `null` and the blob SURVIVES. */
  sort: ek(t.sort, e) ? t.sort : null,
  version: Dg,
  visibility: ak(t.visibility, e),
  widths: lk(t.widths, e),
  /** `_parseShape` already guarantees a boolean here; this normalises anything else to `false`. */
  wrapLines: t.wrapLines === !0
}), sk = (t, e) => t !== null && Number.isInteger(t) && t > 0 && e.includes(t) ? t : null, ik = (t, e) => {
  const n = e.filter((r) => r.reorderable !== !1).map((r) => r.id), o = t.filter((r) => n.includes(r));
  return [...o, ...n.filter((r) => !o.includes(r))];
}, ak = (t, e) => {
  const n = new Set(e.filter((o) => o.hideable !== !1).map((o) => o.id));
  return Object.fromEntries(Object.entries(t).filter(([o]) => n.has(o)));
}, lk = (t, e) => {
  const n = {};
  for (const [o, r] of Object.entries(t)) {
    const s = e.find((i) => i.id === o);
    !s || s.resizable === !1 || !Number.isFinite(r) || r <= 0 || (n[o] = Math.max(s.minWidth ?? ur.MIN_WIDTH, Math.min(s.maxWidth ?? 1 / 0, r)));
  }
  return n;
}, ck = (t, e) => {
  try {
    return t.getItem(e);
  } catch {
    return null;
  }
}, Ks = (t, e) => {
  try {
    t.removeItem(e);
  } catch {
  }
}, uk = 150, dk = ({
  columns: t,
  limitOptions: e,
  tableId: n
}) => {
  const [o] = q.useState(() => Xr.read({
    columns: t,
    limitOptions: e,
    tableId: n
  })), r = q.useRef(t);
  r.current = t;
  const s = q.useRef(n);
  s.current = n;
  const i = q.useRef({
    limit: o?.limit ?? null,
    order: o?.order ?? [],
    sort: o?.sort ?? null,
    visibility: o?.visibility ?? {},
    widths: o?.widths ?? {},
    wrapLines: o?.wrapLines ?? !1
  }), a = q.useRef(void 0), l = q.useCallback(() => {
    Xr.write({
      layout: {
        columnSig: Xr.columnSig(r.current),
        limit: i.current.limit,
        order: i.current.order,
        sort: i.current.sort,
        version: 2,
        visibility: i.current.visibility,
        widths: i.current.widths,
        wrapLines: i.current.wrapLines
      },
      tableId: s.current
    });
  }, []), c = q.useCallback((v) => {
    i.current.sort = v, l();
  }, [l]), u = q.useCallback((v) => {
    i.current.order = v, l();
  }, [l]), d = q.useCallback((v) => {
    i.current.visibility = v, l();
  }, [l]), p = q.useCallback((v) => {
    i.current.limit = v, l();
  }, [l]), m = q.useCallback((v) => {
    i.current.wrapLines = v, l();
  }, [l]), h = q.useCallback((v) => {
    i.current.widths = v, a.current !== void 0 && clearTimeout(a.current), a.current = setTimeout(() => {
      a.current = void 0, l();
    }, uk);
  }, [l]), g = q.useCallback(() => {
    a.current !== void 0 && (clearTimeout(a.current), a.current = void 0), i.current = {
      limit: null,
      order: [],
      sort: null,
      visibility: {},
      widths: {},
      wrapLines: !1
    }, Xr.clear({
      tableId: s.current
    });
  }, []);
  q.useEffect(() => () => {
    a.current !== void 0 && clearTimeout(a.current);
  }, []);
  const y = q.useMemo(() => ({
    onLimitChange: p,
    onOrderChange: u,
    onSortChange: c,
    onVisibilityChange: d,
    onWidthsChange: h,
    onWrapLinesChange: m
  }), [p, u, c, d, h, m]);
  return q.useMemo(() => ({
    handlers: y,
    initial: {
      limit: o?.limit,
      order: o?.order,
      sort: o?.sort,
      visibility: o?.visibility,
      widths: o?.widths,
      wrapLines: o?.wrapLines
    },
    reset: g
  }), [y, o, g]);
}, fk = "_table_1rwri_1", pk = "_layoutFixed_1rwri_9", mk = "_striped_1rwri_13", hk = "_tbody_1rwri_13", gk = "_tr_1rwri_13", bk = "_thead_1rwri_17", vk = "_th_1rwri_17", yk = "_sticky_1rwri_43", xk = "_interactive_1rwri_61", wk = "_selected_1rwri_75", Sk = "_active_1rwri_86", Ek = "_thSorted_1rwri_99", Ck = "_td_1rwri_113", _k = "_wrap_1rwri_123", Rk = "_caption_1rwri_130", Nk = "_captionHidden_1rwri_136", kk = "_alignStart_1rwri_147", Tk = "_alignEnd_1rwri_151", Ik = "_numeric_1rwri_155", pt = {
  table: fk,
  layoutFixed: pk,
  striped: mk,
  tbody: hk,
  tr: gk,
  thead: bk,
  th: vk,
  sticky: yk,
  interactive: xk,
  selected: wk,
  active: Sk,
  thSorted: Ek,
  td: Ck,
  wrap: _k,
  caption: Rk,
  captionHidden: Nk,
  alignStart: kk,
  alignEnd: Tk,
  numeric: Ik
}, jg = {
  end: pt.alignEnd,
  start: pt.alignStart
}, Ok = {
  asc: "ascending",
  desc: "descending"
}, Mk = (t) => {
  const e = ee.c(14);
  let n, o, r, s, i;
  e[0] !== t ? ({
    className: n,
    layout: o,
    striped: s,
    wrap: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  const a = o === "fixed" && pt.layoutFixed, l = s && pt.striped, c = i && pt.wrap;
  let u;
  e[6] !== n || e[7] !== a || e[8] !== l || e[9] !== c ? (u = ae(pt.table, a, l, c, n), e[6] = n, e[7] = a, e[8] = l, e[9] = c, e[10] = u) : u = e[10];
  let d;
  return e[11] !== r || e[12] !== u ? (d = /* @__PURE__ */ b.jsx("table", { "data-slot": "table", className: u, ...r }), e[11] = r, e[12] = u, e[13] = d) : d = e[13], d;
}, Pk = (t) => {
  const e = ee.c(12);
  let n, o, r, s;
  e[0] !== t ? ({
    className: n,
    scrolled: r,
    sticky: s,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = r ? "" : void 0, a = s && pt.sticky;
  let l;
  e[5] !== n || e[6] !== a ? (l = ae(pt.thead, a, n), e[5] = n, e[6] = a, e[7] = l) : l = e[7];
  let c;
  return e[8] !== o || e[9] !== i || e[10] !== l ? (c = /* @__PURE__ */ b.jsx("thead", { "data-slot": "table-head", "data-scrolled": i, className: l, ...o }), e[8] = o, e[9] = i, e[10] = l, e[11] = c) : c = e[11], c;
}, bl = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae(pt.tbody, n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("tbody", { "data-slot": "table-body", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, Ak = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    visible: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = !r && pt.captionHidden;
  let i;
  e[4] !== n || e[5] !== s ? (i = ae(pt.caption, s, n), e[4] = n, e[5] = s, e[6] = i) : i = e[6];
  let a;
  return e[7] !== o || e[8] !== i ? (a = /* @__PURE__ */ b.jsx("caption", { "data-slot": "table-caption", className: i, ...o }), e[7] = o, e[8] = i, e[9] = a) : a = e[9], a;
}, Ys = (t) => {
  const e = ee.c(16);
  let n, o, r, s, i;
  e[0] !== t ? ({
    className: o,
    selected: i,
    active: n,
    interactive: r,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  const a = i ? "" : void 0, l = n ? "" : void 0, c = r && pt.interactive, u = i && pt.selected, d = n && pt.active;
  let p;
  e[6] !== o || e[7] !== c || e[8] !== u || e[9] !== d ? (p = ae(pt.tr, c, u, d, o), e[6] = o, e[7] = c, e[8] = u, e[9] = d, e[10] = p) : p = e[10];
  let m;
  return e[11] !== s || e[12] !== a || e[13] !== l || e[14] !== p ? (m = /* @__PURE__ */ b.jsx("tr", { "data-slot": "table-row", "data-selected": a, "data-active": l, className: p, ...s }), e[11] = s, e[12] = a, e[13] = l, e[14] = p, e[15] = m) : m = e[15], m;
}, Jf = (t) => {
  const e = ee.c(15);
  let n, o, r, s, i;
  e[0] !== t ? ({
    className: o,
    align: n,
    numeric: r,
    sorted: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  const a = i === void 0 ? void 0 : i ? Ok[i] : "none", l = (i === "asc" || i === "desc") && pt.thSorted, c = r ? pt.numeric : n && jg[n], u = r && pt.alignEnd;
  let d;
  e[6] !== o || e[7] !== l || e[8] !== c || e[9] !== u ? (d = ae(pt.th, l, c, u, o), e[6] = o, e[7] = l, e[8] = c, e[9] = u, e[10] = d) : d = e[10];
  let p;
  return e[11] !== s || e[12] !== a || e[13] !== d ? (p = /* @__PURE__ */ b.jsx("th", { "data-slot": "table-column-header", scope: "col", "aria-sort": a, className: d, ...s }), e[11] = s, e[12] = a, e[13] = d, e[14] = p) : p = e[14], p;
}, qs = (t) => {
  const e = ee.c(12);
  let n, o, r, s;
  e[0] !== t ? ({
    className: o,
    align: n,
    numeric: r,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = r ? pt.numeric : n && jg[n], a = r && pt.alignEnd;
  let l;
  e[5] !== o || e[6] !== i || e[7] !== a ? (l = ae(pt.td, i, a, o), e[5] = o, e[6] = i, e[7] = a, e[8] = l) : l = e[8];
  let c;
  return e[9] !== s || e[10] !== l ? (c = /* @__PURE__ */ b.jsx("td", { "data-slot": "table-cell", className: l, ...s }), e[9] = s, e[10] = l, e[11] = c) : c = e[11], c;
}, Dk = 24, Vr = 3, wj = (t) => {
  const {
    actions: e,
    activeRowId: n,
    bulkActions: o,
    caption: r,
    columns: s,
    defaultLimit: i = 25,
    defaultSearch: a = "",
    defaultSort: l,
    defaultWrapLines: c = !1,
    emptyState: u,
    enableColumnReorder: d = !0,
    enableColumnResize: p = !0,
    error: m,
    filterState: h,
    filters: g,
    getRowId: y,
    getRowLabel: v,
    headingLevel: x,
    height: w = "auto",
    isRowSelectable: E,
    limitOptions: S = ur.LIMIT_OPTIONS,
    loading: C,
    onActiveRowChange: _,
    onQueryChange: R,
    onSearchChange: O,
    onSelectionChange: j,
    onSortChange: F,
    pagination: N,
    rowAction: T,
    rows: L,
    searchPlaceholder: M = "Filter results",
    searchable: A = !0,
    selectable: $,
    selectedIds: k,
    showCount: H = !0,
    sort: B,
    striped: P,
    tableId: V,
    title: I
  } = t, D = dk({
    columns: s,
    limitOptions: S,
    tableId: V ?? ""
  }), z = V !== void 0 && V !== "", [U, G] = f.useState(() => z ? D.initial.limit ?? i : i), [J, se] = f.useState(() => z ? D.initial.wrapLines ?? c : c), {
    cycleSort: Q,
    sort: ce
  } = b2({
    defaultSort: z ? D.initial.sort ?? l : l,
    onSortChange: f.useCallback((me) => {
      F?.(me), z && D.handlers.onSortChange(me);
    }, [F, z, D.handlers]),
    sort: B
  }), W = a2({
    columns: s,
    defaultOrder: z ? D.initial.order : void 0,
    defaultVisibility: z ? D.initial.visibility : void 0,
    defaultWidths: z ? D.initial.widths : void 0,
    onOrderChange: z ? D.handlers.onOrderChange : void 0,
    onVisibilityChange: z ? D.handlers.onVisibilityChange : void 0,
    onWidthsChange: z ? D.handlers.onWidthsChange : void 0
  }), oe = f.useMemo(() => Lk(s, W.order), [s, W.order]), Y = f.useMemo(() => oe.filter((me) => W.visibility[me.id] !== !1), [oe, W.visibility]), Z = f.useMemo(() => (Y.findLast((Ye) => Ye.resizable !== !1) ?? Y[Y.length - 1])?.id, [Y]), K = f.useMemo(() => Y.reduce((me, Ye) => me + (W.widths[Ye.id] ?? Ye.width ?? Ye.minWidth ?? ur.MIN_WIDTH), 0), [Y, W.widths]), X = zk(L, y, E), ne = m2({
    onSelectionChange: j,
    orderedPageIds: X,
    selectedIds: k
  }), [re, ie] = f.useState(null), de = n !== void 0 ? n : re, le = f.useCallback((me) => {
    n === void 0 && ie(me), _?.(me);
  }, [n, _]), te = f.useRef(a.trim()), pe = f.useCallback((me) => {
    R?.(Lg(me, ce, te.current, h));
  }, [R, ce, h]), ue = d2({
    defaultLimit: U,
    onQuery: pe,
    pagination: N
  }), ye = f.useRef(!1), ge = y2({
    defaultSearch: a,
    onSearch: f.useCallback((me) => {
      O?.(me), ye.current = !0, ue.reset(), R?.(Xs(N, U, ce, me, h));
    }, [O, ue, R, N, U, ce, h])
  });
  te.current = ge.value.trim();
  const [Te, Se] = f.useState(""), xe = f.useRef(null), je = f.useRef(null), [Me, Pe] = f.useState(null), we = f.useRef(null), ve = f.useRef(null), [Ae, Ne] = f.useState(0);
  f.useEffect(() => {
    const me = xe.current?.querySelector("thead");
    if (!me) return;
    const Ye = () => Ne(Math.round(me.getBoundingClientRect().height));
    if (Ye(), typeof ResizeObserver > "u") return;
    const nt = new ResizeObserver(Ye);
    return nt.observe(me), () => nt.disconnect();
  }, []);
  const [De, ze] = f.useState(!1), et = f.useCallback((me) => {
    const Ye = we.current;
    if (Ye !== null && ve.current === null && Pe({
      state: "hover",
      x: vl(je.current, xe.current, Ye) - Vr
    }), w !== "fill") return;
    const nt = me.currentTarget.scrollTop > 0;
    ze((on) => on === nt ? on : nt);
  }, [w]), [ct, Le] = f.useState(!1), [Ge, Ee] = f.useState(!1), Ke = Y.length + ($ ? 1 : 0), Xe = f.useCallback((me) => {
    const Ye = Q(me);
    ue.reset(), R?.(Xs(N, U, Ye, te.current, h));
  }, [Q, ue, R, N, U, h]), Je = f.useRef(null), wt = f.useCallback((me, Ye) => {
    if (Je.current?.id !== me) {
      const ks = ep(xe.current, Y, W.widths);
      Je.current = {
        id: me,
        width: W.widths[me] ?? ks[me] ?? Fk(xe.current, me)
      }, W.setWidths({
        ...ks,
        [me]: Je.current.width + Ye
      });
    } else W.setWidth(me, Je.current.width + Ye);
    const nt = ve.current;
    if (nt?.columnId !== me) return;
    const on = s.find((ks) => ks.id === me), fn = Math.max(on?.minWidth ?? ur.MIN_WIDTH, Math.min(on?.maxWidth ?? 1 / 0, nt.startWidth + Ye));
    Pe({
      state: "active",
      x: nt.leadingEdge + fn - Vr
    });
  }, [s, W, Y]), Ce = f.useCallback(() => {
    ve.current = null;
    const me = we.current;
    Pe(me === null ? null : {
      state: "hover",
      x: vl(je.current, xe.current, me) - Vr
    });
  }, []), $e = f.useCallback(() => {
    Je.current = null, Ce();
  }, [Ce]), st = f.useCallback((me, Ye) => {
    we.current = Ye ? me : null, ve.current === null && Pe(Ye ? {
      state: "hover",
      x: vl(je.current, xe.current, me) - Vr
    } : null);
  }, []), tt = f.useCallback((me) => {
    const Ye = je.current, nt = $g(xe.current, me);
    if (!Ye || !nt) return;
    const on = nt.left - Ye.getBoundingClientRect().left;
    ve.current = {
      columnId: me,
      leadingEdge: on,
      startWidth: nt.width
    }, Pe({
      state: "active",
      x: on + nt.width - Vr
    });
  }, []);
  f.useEffect(() => {
    if (Me?.state === "active")
      return window.addEventListener("pointerup", Ce), () => window.removeEventListener("pointerup", Ce);
  }, [Me?.state, Ce]);
  const Qe = f.useCallback((me) => {
    const Ye = $k(xe.current, me);
    if (Ye === 0) return;
    const nt = ep(xe.current, Y, W.widths);
    W.setWidths({
      ...nt,
      [me]: Ye + Dk
    });
  }, [W, Y]), ht = f.useRef(!1);
  f.useEffect(() => {
    if (!ht.current) {
      ht.current = !0;
      return;
    }
    Se(`${ne.selectedIds.size} ${ne.selectedIds.size === 1 ? "row" : "rows"} selected`);
  }, [ne.selectedIds]);
  const St = f.useRef(!1);
  f.useEffect(() => {
    St.current || (St.current = !0, R?.(Xs(N, U, ce, a.trim(), h)));
  }, []);
  const xn = f.useRef(h?.key);
  f.useEffect(() => {
    h !== void 0 && xn.current !== h.key && (xn.current = h.key, ye.current = !0, ue.reset(), R?.(Xs(N, U, ce, te.current, h)));
  }, [h?.key]), f.useEffect(() => {
    ye.current && C !== !0 && (ye.current = !1, Se(N && "totalItems" in N ? `${L.length} of ${N.totalItems} results` : `${L.length} results`));
  });
  const wn = f.useCallback(() => {
    W.reset(), se(c), i !== U && (G(i), ue.setLimit(i)), z && D.reset();
  }, [W, i, c, U, ue, z, D]), Ho = f.useMemo(() => oe.filter((me) => me.reorderable !== !1).map((me) => Qf(me, W.visibility)), [oe, W.visibility]), gt = f.useMemo(() => oe.filter((me) => me.reorderable === !1).map((me) => Qf(me, W.visibility)), [oe, W.visibility]), Dn = f.useCallback((me) => {
    se(me), z && D.handlers.onWrapLinesChange(me);
  }, [z, D.handlers]), Kv = f.useCallback((me) => {
    me !== U && (G(me), z && D.handlers.onLimitChange(me), ue.setLimit(me));
  }, [U, z, D.handlers, ue]), Yv = (me, Ye) => (nt) => {
    if (Ye && nt.shiftKey) {
      ne.toggleRange(me);
      return;
    }
    if (Ye && (nt.metaKey || nt.ctrlKey)) {
      ne.toggle(me);
      return;
    }
    T && le(me);
  }, qv = (me) => (Ye) => {
    T && Ye.key === "Enter" && (Ye.preventDefault(), T.onActivate(me));
  };
  return /* @__PURE__ */ b.jsxs("div", { "aria-busy": C ? !0 : void 0, className: ae(Ot.root, w === "fill" && Ot.rootFill), "data-slot": "data-table", children: [
    (I != null || e != null || o != null && ne.selectedIds.size > 0) && /* @__PURE__ */ b.jsx(QN, { actions: e, bulkActions: o, className: Ot.titleBand, count: Vk(H, N), headingLevel: x, onClearSelection: ne.clear, selectedCount: ne.selectedIds.size, title: I }),
    /* @__PURE__ */ b.jsx(LR, { className: Ot.filterBand, filters: g, onOpenPreferences: () => Ee(!0), onSearchClear: ge.clear, onSearchFlush: ge.flush, onSearchInput: ge.onChange, pager: ue.mode === "none" ? void 0 : /* @__PURE__ */ b.jsx(z2, { canNext: ue.canNext, canPrev: ue.canPrev, mode: ue.mode, onNext: ue.next, onPage: ue.goToPage, onPrev: ue.prev, page: N && "page" in N ? N.page : void 0, totalPages: N && "totalPages" in N ? N.totalPages : void 0 }), searchPlaceholder: M, searchValue: ge.value, searchable: A }),
    /* @__PURE__ */ b.jsxs("div", { className: ae(Ot.scrollShell, w === "fill" && Ot.scrollShellFill), ref: je, style: {
      "--table-header-height": `${Ae}px`
    }, children: [
      /* @__PURE__ */ b.jsx(L_, { active: !!C, className: Ot.progress, label: `Loading ${r}` }),
      /* @__PURE__ */ b.jsx(i2, { axis: w === "fill" ? "both" : "horizontal", bar: "overlay", className: ae(w === "fill" && Ot.scrollAreaFill, ct && Ot.noSelect), onScroll: et, overlayInsetBlockStart: w === "fill" ? Ae : 0, ref: xe, children: /* @__PURE__ */ b.jsxs(Mk, { layout: "fixed", striped: P, wrap: J, style: {
        minWidth: $ ? `calc(${K}px + var(--density-checkbox-size) + var(--spacing) * 6)` : K
      }, children: [
        /* @__PURE__ */ b.jsx(Ak, { children: r }),
        /* @__PURE__ */ b.jsxs("colgroup", { children: [
          $ && /* @__PURE__ */ b.jsx("col", { style: {
            width: "calc(var(--density-checkbox-size) + var(--spacing) * 6)"
          } }),
          Y.map((me) => {
            const Ye = me.id === Z ? void 0 : W.widths[me.id] ?? me.width;
            return /* @__PURE__ */ b.jsx("col", { style: Ye ? {
              width: Ye
            } : void 0 }, me.id);
          })
        ] }),
        /* @__PURE__ */ b.jsx(Pk, { scrolled: De, sticky: !0, children: /* @__PURE__ */ b.jsxs(Ys, { children: [
          $ && /* @__PURE__ */ b.jsx(Jf, { className: Ot.checkboxCell, children: /* @__PURE__ */ b.jsx(Po, { checked: ne.pageState === "all", indeterminate: ne.pageState === "some", onCheckedChange: (me) => ne.setPage(me === !0), "aria-label": "Select all rows on this page" }) }),
          Y.map((me, Ye) => /* @__PURE__ */ b.jsx(Jf, { align: me.align, numeric: me.numeric, sorted: me.sortable ? ce?.columnId === me.id ? ce.direction : null : void 0, "data-col": me.id, children: /* @__PURE__ */ b.jsxs("div", { className: ae(Ot.headerCell, me.numeric && Ot.headerCellEnd), children: [
            me.sortable ? /* @__PURE__ */ b.jsxs("button", { type: "button", className: Ot.sortTrigger, onClick: () => Xe(me.id), children: [
              /* @__PURE__ */ b.jsx("span", { className: Ot.headerLabel, children: me.header }),
              /* @__PURE__ */ b.jsx(O2, { direction: ce?.columnId === me.id ? ce.direction : null })
            ] }) : /* @__PURE__ */ b.jsx("span", { className: Ot.headerLabel, children: me.header }),
            p && me.resizable !== !1 && /* @__PURE__ */ b.jsx(
              C2,
              {
                flush: Ye === Y.length - 1,
                label: `Resize ${typeof me.header == "string" ? me.header : me.id} column`,
                onAutoFit: () => Qe(me.id),
                onHoverChange: (nt) => st(me.id, nt),
                onResize: (nt) => wt(me.id, nt),
                onResizeEnd: $e,
                onResizeStart: () => tt(me.id)
              }
            )
          ] }) }, me.id))
        ] }) }),
        m != null ? /* @__PURE__ */ b.jsx(bl, { children: /* @__PURE__ */ b.jsx(Ys, { children: /* @__PURE__ */ b.jsx(qs, { colSpan: Ke, children: m }) }) }) : C === !0 && L.length === 0 ? /* @__PURE__ */ b.jsx(BN, { rows: U, columns: Ke }) : L.length === 0 ? /* @__PURE__ */ b.jsx(bl, { children: /* @__PURE__ */ b.jsx(Ys, { children: /* @__PURE__ */ b.jsx(qs, { colSpan: Ke, children: u ?? /* @__PURE__ */ b.jsx(Z2, {}) }) }) }) : /* @__PURE__ */ b.jsx(bl, { children: L.map((me, Ye) => {
          const nt = y(me), on = !!$ && (E?.(me) ?? !0);
          return /* @__PURE__ */ b.jsxs(Ys, { selected: on ? ne.isSelected(nt) : void 0, active: T ? de === nt : void 0, tabIndex: T ? 0 : void 0, onClick: Yv(nt, on), onDoubleClick: () => T?.onActivate(me), onKeyDown: qv(me), onMouseDown: (fn) => Le(fn.shiftKey), onMouseUp: () => Le(!1), children: [
            $ && /* @__PURE__ */ b.jsx(qs, { className: Ot.checkboxCell, children: on && /* @__PURE__ */ b.jsx(Po, { checked: ne.isSelected(nt), onClick: (fn) => fn.stopPropagation(), onCheckedChange: () => ne.toggle(nt), "aria-label": v ? `Select ${v(me)}` : `Select row ${Ye + 1}` }) }),
            Y.map((fn) => /* @__PURE__ */ b.jsx(qs, { align: fn.align, numeric: fn.numeric, "data-col": fn.id, children: jk(fn, me) }, fn.id))
          ] }, nt);
        }) })
      ] }) }),
      Me && /* @__PURE__ */ b.jsx("div", { "aria-hidden": "true", className: Ot.dragBar, "data-separator": Me.state, "data-slot": "table-drag-bar", style: {
        transform: `translateX(${Me.x}px)`
      } })
    ] }),
    /* @__PURE__ */ b.jsx("div", { "aria-live": "polite", role: "status", "data-slot": "data-table-live", style: {
      clipPath: "inset(50%)",
      height: 1,
      overflow: "hidden",
      position: "absolute",
      whiteSpace: "nowrap",
      width: 1
    }, children: Te }),
    /* @__PURE__ */ b.jsx(AN, { columns: Ho, fixedColumns: gt, limit: U, limitOptions: S, onLimitChange: Kv, onOpenChange: Ee, onOrderChange: W.setOrder, onReset: wn, onVisibilityChange: W.setVisibility, onWrapLinesChange: Dn, open: Ge, reorderable: d, wrapLines: J })
  ] });
}, Lg = (t, e, n, o) => ({
  ...t,
  ...e ? {
    sortBy: e.columnId,
    sortDirection: e.direction
  } : {},
  ...n === "" ? {} : {
    search: n
  },
  ...o === void 0 || o.value === void 0 ? {} : {
    filters: o.value
  }
}), jk = (t, e) => {
  if (t.cell) return t.cell(e);
  const n = t.value?.(e);
  return n == null ? "" : n instanceof Date ? n.toISOString() : String(n);
}, $g = (t, e) => {
  const n = t?.querySelector(`th[data-col="${CSS.escape(e)}"]`);
  return n ? n.getBoundingClientRect() : null;
}, Lk = (t, e) => {
  const n = new Map(t.map((s) => [s.id, s])), o = e.map((s) => n.get(s)).filter((s) => s !== void 0);
  let r = 0;
  return t.map((s) => s.reorderable === !1 ? s : o[r++] ?? s);
}, $k = (t, e) => {
  if (!t) return 0;
  const n = t.querySelectorAll(`td[data-col="${CSS.escape(e)}"]`);
  let o = 0;
  return n.forEach((r) => {
    r.scrollWidth > o && (o = r.scrollWidth);
  }), o;
}, Qf = (t, e) => ({
  hideable: t.hideable !== !1,
  id: t.id,
  label: typeof t.header == "string" && t.header !== "" ? t.header : t.id,
  visible: e[t.id] !== !1
}), Xs = (t, e, n, o, r) => {
  const s = t && "cursor" in t ? {
    cursor: null,
    limit: e
  } : {
    limit: e,
    page: 1
  };
  return Lg(s, n, o, r);
}, vl = (t, e, n) => {
  const o = $g(e, n);
  return !t || !o ? 0 : o.right - t.getBoundingClientRect().left;
}, ep = (t, e, n) => {
  if (!t) return {};
  const o = {};
  for (const r of e) {
    if (n[r.id] !== void 0) continue;
    const s = t.querySelector(`th[data-col="${CSS.escape(r.id)}"]`), i = s ? Math.round(s.getBoundingClientRect().width) : 0;
    i > 0 && (o[r.id] = i);
  }
  return o;
}, Fk = (t, e) => {
  if (!t) return 0;
  const n = t.querySelector(`td[data-col="${CSS.escape(e)}"], th[data-col="${CSS.escape(e)}"]`);
  return n ? n.getBoundingClientRect().width : 0;
}, Vk = (t, e) => t && e && "totalItems" in e ? e.totalItems : void 0, zk = (t, e, n) => {
  const o = f.useRef([]), r = (n ? t.filter((a) => n(a)) : t).map((a) => e(a)), s = o.current;
  return r.length === s.length && r.every((a, l) => a === s[l]) ? s : (o.current = r, r);
}, Bk = "_overlay_tpy95_1", Hk = "_popup_tpy95_20", Uk = "_content_tpy95_44", Wk = "_notPadded_tpy95_50", Gk = "_body_tpy95_54", Kk = "_sm_tpy95_75", Yk = "_md_tpy95_79", qk = "_lg_tpy95_83", Xk = "_xl_tpy95_87", Zk = "_closeButton_tpy95_91", Jk = "_header_tpy95_110", Qk = "_footer_tpy95_119", eT = "_title_tpy95_134", tT = "_description_tpy95_142", nT = "_srOnly_tpy95_156", Ht = {
  overlay: Bk,
  popup: Hk,
  content: Uk,
  notPadded: Wk,
  body: Gk,
  sm: Kk,
  md: Yk,
  lg: qk,
  xl: Xk,
  closeButton: Zk,
  header: Jk,
  footer: Qk,
  title: eT,
  description: tT,
  srOnly: nT
}, oT = {
  lg: Ht.lg,
  md: Ht.md,
  sm: Ht.sm,
  xl: Ht.xl
}, du = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(Ig, { "data-slot": "dialog", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, Sj = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(_a, { "data-slot": "dialog-trigger", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, rT = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(Ea, { "data-slot": "dialog-portal", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, Ej = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(Rr, { "data-slot": "dialog-close", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, sT = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    forceRender: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? !0 : r;
  let i;
  e[4] !== n ? (i = ae(Ht.overlay, n), e[4] = n, e[5] = i) : i = e[5];
  let a;
  return e[6] !== s || e[7] !== o || e[8] !== i ? (a = /* @__PURE__ */ b.jsx(ya, { "data-slot": "dialog-overlay", forceRender: s, className: i, ...o }), e[6] = s, e[7] = o, e[8] = i, e[9] = a) : a = e[9], a;
}, fu = (t) => {
  const e = ee.c(20);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    className: o,
    children: n,
    showCloseButton: s,
    size: i,
    padded: a,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = s === void 0 ? !0 : s, c = i === void 0 ? "sm" : i, u = a === void 0 ? !0 : a;
  let d, p;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = /* @__PURE__ */ b.jsx(sT, {}), p = /* @__PURE__ */ b.jsx(Og, {}), e[7] = d, e[8] = p) : (d = e[7], p = e[8]);
  const m = oT[c], h = !u && Ht.notPadded;
  let g;
  e[9] !== o || e[10] !== m || e[11] !== h ? (g = ae(Ht.popup, Ht.content, m, h, o), e[9] = o, e[10] = m, e[11] = h, e[12] = g) : g = e[12];
  let y;
  e[13] !== l ? (y = l && /* @__PURE__ */ b.jsxs(Rr, { "data-slot": "dialog-close", render: /* @__PURE__ */ b.jsx(kt, { variant: "ghost", className: Ht.closeButton, size: "icon-sm" }), children: [
    /* @__PURE__ */ b.jsx(Ve, { icon: Ia, width: 24, height: 24 }),
    /* @__PURE__ */ b.jsx("span", { className: Ht.srOnly, children: "Close" })
  ] }), e[13] = l, e[14] = y) : y = e[14];
  let v;
  return e[15] !== n || e[16] !== r || e[17] !== g || e[18] !== y ? (v = /* @__PURE__ */ b.jsxs(rT, { children: [
    d,
    p,
    /* @__PURE__ */ b.jsxs(wa, { "data-slot": "dialog-content", className: g, ...r, children: [
      n,
      y
    ] })
  ] }), e[15] = n, e[16] = r, e[17] = g, e[18] = y, e[19] = v) : v = e[19], v;
}, Fg = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae(Ht.header, n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "dialog-header", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, Cj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae(Ht.body, n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "dialog-body", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, iT = (t) => {
  const e = ee.c(14);
  let n, o, r, s;
  e[0] !== t ? ({
    className: o,
    showCloseButton: s,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = s === void 0 ? !1 : s;
  let a;
  e[5] !== o ? (a = ae(Ht.footer, o), e[5] = o, e[6] = a) : a = e[6];
  let l;
  e[7] !== i ? (l = i && /* @__PURE__ */ b.jsx(Rr, { render: /* @__PURE__ */ b.jsx(kt, { variant: "outline" }), children: "Close" }), e[7] = i, e[8] = l) : l = e[8];
  let c;
  return e[9] !== n || e[10] !== r || e[11] !== a || e[12] !== l ? (c = /* @__PURE__ */ b.jsxs("div", { "data-slot": "dialog-footer", className: a, ...r, children: [
    n,
    l
  ] }), e[9] = n, e[10] = r, e[11] = a, e[12] = l, e[13] = c) : c = e[13], c;
}, pu = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae(Ht.title, n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(Ca, { "data-slot": "dialog-title", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, mu = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae(Ht.description, n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(xa, { "data-slot": "dialog-description", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, hu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (hu.displayName = "MenuPositionerContext");
function Es(t) {
  const e = f.useContext(hu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>." : We(33));
  return e;
}
const gu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (gu.displayName = "MenuRootContext");
function vn(t) {
  const e = f.useContext(gu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRootContext is missing. Menu parts must be placed within <Menu.Root>." : We(36));
  return e;
}
const Vg = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Vg.displayName = "ContextMenuRootContext");
function Oa(t = !0) {
  const e = f.useContext(Vg);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ContextMenuRootContext is missing. ContextMenu parts must be placed within <ContextMenu.Root>." : We(25));
  return e;
}
const bu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (bu.displayName = "MenuCheckboxItemContext");
function aT() {
  const t = f.useContext(bu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuCheckboxItemContext is missing. MenuCheckboxItem parts must be placed within <Menu.CheckboxItem>." : We(30));
  return t;
}
const vu = {
  type: "regular-item"
};
function Ma(t) {
  const {
    closeOnClick: e,
    disabled: n = !1,
    highlighted: o,
    id: r,
    store: s,
    nativeButton: i,
    itemMetadata: a,
    nodeId: l
  } = t, c = f.useRef(null), u = Oa(!0), d = u !== void 0, {
    events: p
  } = s.useState("floatingTreeRoot"), {
    getButtonProps: m,
    buttonRef: h
  } = Wt({
    disabled: n,
    focusableWhenDisabled: !0,
    native: i
  }), g = f.useCallback((v) => Qt({
    id: r,
    role: "menuitem",
    tabIndex: o ? 0 : -1,
    onMouseMove(x) {
      l && p.emit("itemhover", {
        nodeId: l,
        target: x.currentTarget
      });
    },
    onMouseEnter() {
      a.type === "submenu-trigger" && a.setActive();
    },
    onKeyUp(x) {
      x.key === " " && s.context.typingRef.current && x.preventBaseUIHandler();
    },
    onClick(x) {
      e && p.emit("close", {
        domEvent: x,
        reason: No
      });
    },
    onMouseUp(x) {
      if (u) {
        const w = u.initialCursorPointRef.current;
        if (u.initialCursorPointRef.current = null, d && w && Math.abs(x.clientX - w.x) <= 1 && Math.abs(x.clientY - w.y) <= 1)
          return;
      }
      c.current && s.context.allowMouseUpTriggerRef.current && (!d || x.button === 2) && a.type === "regular-item" && c.current.click();
    }
  }, v, m), [r, o, m, e, p, s, d, u, a, l]), y = zt(c, h);
  return f.useMemo(() => ({
    getItemProps: g,
    itemRef: y
  }), [g, y]);
}
let tp = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.highlighted = "data-highlighted", t;
})({});
const Pa = {
  checked(t) {
    return t ? {
      [tp.checked]: ""
    } : {
      [tp.unchecked]: ""
    };
  },
  ...tn
}, zg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !1,
    checked: u,
    defaultChecked: d,
    onCheckedChange: p,
    ...m
  } = e, h = Yn({
    label: i
  }), g = Es(!0), y = lt(s), {
    store: v
  } = vn(), x = v.useState("isActive", h.index), w = v.useState("itemProps"), [E, S] = un({
    controlled: u,
    default: d ?? !1,
    name: "MenuCheckboxItem",
    state: "checked"
  }), {
    getItemProps: C,
    itemRef: _
  } = Ma({
    closeOnClick: c,
    disabled: l,
    highlighted: x,
    id: y,
    store: v,
    nativeButton: a,
    nodeId: g?.nodeId,
    itemMetadata: vu
  }), R = f.useMemo(() => ({
    disabled: l,
    highlighted: x,
    checked: E
  }), [l, x, E]), O = fe((F) => {
    const N = {
      ...ke(No, F.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    p?.(!E, N), !N.isCanceled && S((T) => !T);
  }), j = _e("div", e, {
    state: R,
    stateAttributesMapping: Pa,
    props: [w, {
      role: "menuitemcheckbox",
      "aria-checked": E,
      onClick: O
    }, m, C],
    ref: [_, n, h.ref]
  });
  return /* @__PURE__ */ b.jsx(bu.Provider, {
    value: R,
    children: j
  });
});
process.env.NODE_ENV !== "production" && (zg.displayName = "MenuCheckboxItem");
const Bg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    keepMounted: s = !1,
    ...i
  } = e, a = aT(), l = f.useRef(null), {
    transitionStatus: c,
    setMounted: u
  } = Kn(a.checked);
  Gt({
    open: a.checked,
    ref: l,
    onComplete() {
      a.checked || u(!1);
    }
  });
  const d = f.useMemo(() => ({
    checked: a.checked,
    disabled: a.disabled,
    highlighted: a.highlighted,
    transitionStatus: c
  }), [a.checked, a.disabled, a.highlighted, c]);
  return _e("span", e, {
    state: d,
    ref: [n, l],
    stateAttributesMapping: Pa,
    props: {
      "aria-hidden": !0,
      ...i
    },
    enabled: s || a.checked
  });
});
process.env.NODE_ENV !== "production" && (Bg.displayName = "MenuCheckboxItemIndicator");
const yu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (yu.displayName = "MenuGroupContext");
function lT() {
  const t = f.useContext(yu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuGroupRootContext is missing. Menu group parts must be used within <Menu.Group>." : We(31));
  return t;
}
const Hg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    ...s
  } = e, [i, a] = f.useState(void 0), l = f.useMemo(() => ({
    setLabelId: a
  }), [a]), c = _e("div", e, {
    ref: n,
    props: {
      role: "group",
      "aria-labelledby": i,
      ...s
    }
  });
  return /* @__PURE__ */ b.jsx(yu.Provider, {
    value: l,
    children: c
  });
});
process.env.NODE_ENV !== "production" && (Hg.displayName = "MenuGroup");
const Ug = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    id: s,
    ...i
  } = e, a = lt(s), {
    setLabelId: l
  } = lT();
  return he(() => (l(a), () => {
    l(void 0);
  }), [l, a]), _e("div", e, {
    ref: n,
    props: {
      id: a,
      role: "presentation",
      ...i
    }
  });
});
process.env.NODE_ENV !== "production" && (Ug.displayName = "MenuGroupLabel");
const xu = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !0,
    ...u
  } = e, d = Yn({
    label: i
  }), p = Es(!0), m = lt(s), {
    store: h
  } = vn(), g = h.useState("isActive", d.index), y = h.useState("itemProps"), {
    getItemProps: v,
    itemRef: x
  } = Ma({
    closeOnClick: c,
    disabled: l,
    highlighted: g,
    id: m,
    store: h,
    nativeButton: a,
    nodeId: p?.nodeId,
    itemMetadata: vu
  }), w = f.useMemo(() => ({
    disabled: l,
    highlighted: g
  }), [l, g]);
  return _e("div", e, {
    state: w,
    props: [y, u, v],
    ref: [x, n, d.ref]
  });
});
process.env.NODE_ENV !== "production" && (xu.displayName = "MenuItem");
const Wg = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Wg.displayName = "ToolbarRootContext");
function wu(t) {
  return f.useContext(Wg);
}
function Or(t) {
  return t === "starting" ? Ny : at;
}
const cT = {
  ...bn,
  ...tn
}, Li = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    finalFocus: s,
    ...i
  } = e, {
    store: a
  } = vn(), {
    side: l,
    align: c
  } = Es(), u = wu() != null, d = a.useState("open"), p = a.useState("transitionStatus"), m = a.useState("popupProps"), h = a.useState("mounted"), g = a.useState("instantType"), y = a.useState("activeTriggerElement"), v = a.useState("parent"), x = a.useState("lastOpenChangeReason"), w = a.useState("rootId"), E = a.useState("floatingRootContext"), S = a.useState("floatingTreeRoot"), C = a.useState("closeDelay"), _ = a.useState("activeTriggerElement"), R = v.type === "context-menu";
  Gt({
    open: d,
    ref: a.context.popupRef,
    onComplete() {
      d && a.context.onOpenChangeComplete?.(!0);
    }
  }), f.useEffect(() => {
    function L(M) {
      a.setOpen(!1, ke(M.reason, M.domEvent));
    }
    return S.events.on("close", L), () => {
      S.events.off("close", L);
    };
  }, [S.events, a]);
  const O = a.useState("hoverEnabled"), j = a.useState("disabled");
  Jc(E, {
    enabled: O && !j && !R && v.type !== "menubar",
    closeDelay: C
  });
  const F = f.useMemo(() => ({
    transitionStatus: p,
    side: l,
    align: c,
    open: d,
    nested: v.type === "menu",
    instant: g
  }), [p, l, c, d, v.type, g]), N = _e("div", e, {
    state: F,
    ref: [n, a.context.popupRef],
    stateAttributesMapping: cT,
    props: [m, {
      onKeyDown(L) {
        u && ps.has(L.key) && L.stopPropagation();
      }
    }, Or(p), i, {
      "data-rootownerid": w
    }]
  });
  let T = v.type === void 0 || R;
  return (y || v.type === "menubar" && x !== Yi) && (T = !0), /* @__PURE__ */ b.jsx(ia, {
    context: E,
    modal: R,
    disabled: !h,
    returnFocus: s === void 0 ? T : s,
    initialFocus: v.type !== "menu",
    restoreFocus: !0,
    externalTree: v.type !== "menubar" ? S : void 0,
    previousFocusableElement: _,
    nextFocusableElement: v.type === void 0 ? a.context.triggerFocusTargetRef : void 0,
    beforeContentFocusGuardRef: v.type === void 0 ? a.context.beforeContentFocusGuardRef : void 0,
    children: N
  });
});
process.env.NODE_ENV !== "production" && (Li.displayName = "MenuPopup");
const Su = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Su.displayName = "MenuPortalContext");
function uT() {
  const t = f.useContext(Su);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Portal> is missing." : We(32));
  return t;
}
const ss = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: s
  } = vn();
  return s.useState("mounted") || o ? /* @__PURE__ */ b.jsx(Su.Provider, {
    value: o,
    children: /* @__PURE__ */ b.jsx(hs, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (ss.displayName = "MenuPortal");
const dT = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: s,
      platform: i,
      elements: a,
      middlewareData: l
    } = e, {
      element: c,
      padding: u = 0,
      offsetParent: d = "real"
    } = Bn(t, e) || {};
    if (c == null)
      return {};
    const p = hm(u), m = {
      x: n,
      y: o
    }, h = jc(r), g = Dc(h), y = await i.getDimensions(c), v = h === "y", x = v ? "top" : "left", w = v ? "bottom" : "right", E = v ? "clientHeight" : "clientWidth", S = s.reference[g] + s.reference[h] - m[h] - s.floating[g], C = m[h] - s.reference[h], _ = d === "real" ? await i.getOffsetParent?.(c) : a.floating;
    let R = a.floating[E] || s.floating[g];
    (!R || !await i.isElement?.(_)) && (R = a.floating[E] || s.floating[g]);
    const O = S / 2 - C / 2, j = R / 2 - y[g] / 2 - 1, F = Math.min(p[x], j), N = Math.min(p[w], j), T = F, L = R - y[g] - N, M = R / 2 - y[g] / 2 + O, A = Bl(T, M, L), $ = !l.arrow && ho(r) != null && M !== A && s.reference[g] / 2 - (M < T ? F : N) - y[g] / 2 < 0, k = $ ? M < T ? M - T : M - L : 0;
    return {
      [h]: m[h] + k,
      data: {
        [h]: A,
        centerOffset: M - A - k,
        ...$ && {
          alignmentOffset: k
        }
      },
      reset: $
    };
  }
}), fT = (t, e) => ({
  ...dT(t),
  options: [t, e]
}), pT = {
  name: "hide",
  async fn(t) {
    const {
      width: e,
      height: n,
      x: o,
      y: r
    } = t.rects.reference, s = e === 0 && n === 0 && o === 0 && r === 0;
    return {
      data: {
        referenceHidden: (await Gw().fn(t)).data?.referenceHidden || s
      }
    };
  }
}, gi = {
  sideX: "left",
  sideY: "top"
}, Gg = {
  name: "adaptiveOrigin",
  async fn(t) {
    const {
      x: e,
      y: n,
      rects: {
        floating: o
      },
      elements: {
        floating: r
      },
      platform: s,
      strategy: i,
      placement: a
    } = t, l = mt(r), c = l.getComputedStyle(r);
    if (!(c.transitionDuration !== "0s" && c.transitionDuration !== ""))
      return {
        x: e,
        y: n,
        data: gi
      };
    const d = await s.getOffsetParent?.(r);
    let p = {
      width: 0,
      height: 0
    };
    if (i === "fixed" && l?.visualViewport)
      p = {
        width: l.visualViewport.width,
        height: l.visualViewport.height
      };
    else if (d === l) {
      const x = Ct(r);
      p = {
        width: x.documentElement.clientWidth,
        height: x.documentElement.clientHeight
      };
    } else await s.isElement?.(d) && (p = await s.getDimensions(d));
    const m = qt(a);
    let h = e, g = n;
    m === "left" && (h = p.width - (e + o.width)), m === "top" && (g = p.height - (n + o.height));
    const y = m === "left" ? "right" : gi.sideX, v = m === "top" ? "bottom" : gi.sideY;
    return {
      x: h,
      y: g,
      data: {
        sideX: y,
        sideY: v
      }
    };
  }
};
function Kg(t, e, n) {
  const o = t === "inline-start" || t === "inline-end";
  return {
    top: "top",
    right: o ? n ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: o ? n ? "inline-end" : "inline-start" : "left"
  }[e];
}
function np(t, e, n) {
  const {
    rects: o,
    placement: r
  } = t;
  return {
    side: Kg(e, qt(r), n),
    align: ho(r) || "center",
    anchor: {
      width: o.reference.width,
      height: o.reference.height
    },
    positioner: {
      width: o.floating.width,
      height: o.floating.height
    }
  };
}
function Aa(t) {
  const {
    // Public parameters
    anchor: e,
    positionMethod: n = "absolute",
    side: o = "bottom",
    sideOffset: r = 0,
    align: s = "center",
    alignOffset: i = 0,
    collisionBoundary: a,
    collisionPadding: l = 5,
    sticky: c = !1,
    arrowPadding: u = 5,
    disableAnchorTracking: d = !1,
    // Private parameters
    keepMounted: p = !1,
    floatingRootContext: m,
    mounted: h,
    collisionAvoidance: g,
    shiftCrossAxis: y = !1,
    nodeId: v,
    adaptiveOrigin: x,
    lazyFlip: w = !1,
    externalTree: E
  } = t, [S, C] = f.useState(null);
  !h && S !== null && C(null);
  const _ = g.side || "flip", R = g.align || "flip", O = g.fallbackAxisSide || "end", j = typeof e == "function" ? e : void 0, F = fe(j), N = j ? F : e, T = yt(e), M = jo() === "rtl", A = S || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": M ? "left" : "right",
    "inline-start": M ? "right" : "left"
  }[o], $ = s === "center" ? A : `${A}-${s}`;
  let k = l;
  const H = 1, B = o === "bottom" ? H : 0, P = o === "top" ? H : 0, V = o === "right" ? H : 0, I = o === "left" ? H : 0;
  typeof k == "number" ? k = {
    top: k + B,
    right: k + I,
    bottom: k + P,
    left: k + V
  } : k && (k = {
    top: (k.top || 0) + B,
    right: (k.right || 0) + I,
    bottom: (k.bottom || 0) + P,
    left: (k.left || 0) + V
  });
  const D = {
    boundary: a === "clipping-ancestors" ? "clippingAncestors" : a,
    padding: k
  }, z = f.useRef(null), U = yt(r), G = yt(i), Q = [zw((Ne) => {
    const De = np(Ne, o, M), ze = typeof U.current == "function" ? U.current(De) : U.current, et = typeof G.current == "function" ? G.current(De) : G.current;
    return {
      mainAxis: ze,
      crossAxis: et,
      alignmentAxis: et
    };
  }, [typeof r != "function" ? r : 0, typeof i != "function" ? i : 0, M, o])], ce = R === "none" && _ !== "shift", W = !ce && (c || y || _ === "shift"), oe = _ === "none" ? null : Uw({
    ...D,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: k.top + H,
      right: k.right + H,
      bottom: k.bottom + H,
      left: k.left + H
    },
    mainAxis: !y && _ === "flip",
    crossAxis: R === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: O
  }), Y = ce ? null : Bw((Ne) => {
    const De = Ct(Ne.elements.floating).documentElement;
    return {
      ...D,
      // Use the Layout Viewport to avoid shifting around when pinch-zooming
      // for context menus.
      rootBoundary: y ? {
        x: 0,
        y: 0,
        width: De.clientWidth,
        height: De.clientHeight
      } : void 0,
      mainAxis: R !== "none",
      crossAxis: W,
      limiter: c || y ? void 0 : Hw((ze) => {
        if (!z.current)
          return {};
        const {
          width: et,
          height: ct
        } = z.current.getBoundingClientRect(), Le = sn(qt(ze.placement)), Ge = Le === "y" ? et : ct, Ee = Le === "y" ? k.left + k.right : k.top + k.bottom;
        return {
          offset: Ge / 2 + Ee / 2
        };
      })
    };
  }, [D, c, y, k, R]);
  _ === "shift" || R === "shift" || s === "center" ? Q.push(Y, oe) : Q.push(oe, Y), Q.push(Ww({
    ...D,
    apply({
      elements: {
        floating: Ne
      },
      rects: {
        reference: De
      },
      availableWidth: ze,
      availableHeight: et
    }) {
      Object.entries({
        "--available-width": `${ze}px`,
        "--available-height": `${et}px`,
        "--anchor-width": `${De.width}px`,
        "--anchor-height": `${De.height}px`
      }).forEach(([ct, Le]) => {
        Ne.style.setProperty(ct, Le);
      });
    }
  }), fT(() => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: z.current || document.createElement("div"),
    padding: u,
    offsetParent: "floating"
  }), [u]), {
    name: "transformOrigin",
    fn(Ne) {
      const {
        elements: De,
        middlewareData: ze,
        placement: et,
        rects: ct,
        y: Le
      } = Ne, Ge = qt(et), Ee = sn(Ge), Ke = z.current, Xe = ze.arrow?.x || 0, Je = ze.arrow?.y || 0, wt = Ke?.clientWidth || 0, Ce = Ke?.clientHeight || 0, $e = Xe + wt / 2, st = Je + Ce / 2, tt = Math.abs(ze.shift?.y || 0), Qe = ct.reference.height / 2, ht = typeof r == "function" ? r(np(Ne, o, M)) : r, St = tt > ht, xn = {
        top: `${$e}px calc(100% + ${ht}px)`,
        bottom: `${$e}px ${-ht}px`,
        left: `calc(100% + ${ht}px) ${st}px`,
        right: `${-ht}px ${st}px`
      }[Ge], wn = `${$e}px ${ct.reference.y + Qe - Le}px`;
      return De.floating.style.setProperty("--transform-origin", W && Ee === "y" && St ? wn : xn), {};
    }
  }, pT, x), he(() => {
    !h && m && m.update({
      referenceElement: null,
      floatingElement: null,
      domReferenceElement: null
    });
  }, [h, m]);
  const Z = f.useMemo(() => ({
    elementResize: !d && typeof ResizeObserver < "u",
    layoutShift: !d && typeof IntersectionObserver < "u"
  }), [d]), {
    refs: K,
    elements: X,
    x: ne,
    y: re,
    middlewareData: ie,
    update: de,
    placement: le,
    context: te,
    isPositioned: pe,
    floatingStyles: ue
  } = RS({
    rootContext: m,
    placement: $,
    middleware: Q,
    strategy: n,
    whileElementsMounted: p ? void 0 : (...Ne) => cf(...Ne, Z),
    nodeId: v,
    externalTree: E
  }), {
    sideX: ye,
    sideY: ge
  } = ie.adaptiveOrigin || gi, Te = pe ? n : "fixed", Se = f.useMemo(() => x ? {
    position: Te,
    [ye]: ne,
    [ge]: re
  } : {
    position: Te,
    ...ue
  }, [x, Te, ye, ne, ge, re, ue]), xe = f.useRef(null);
  he(() => {
    if (!h)
      return;
    const Ne = T.current, De = typeof Ne == "function" ? Ne() : Ne, et = (op(De) ? De.current : De) || null || null;
    et !== xe.current && (K.setPositionReference(et), xe.current = et);
  }, [h, K, N, T]), f.useEffect(() => {
    if (!h)
      return;
    const Ne = T.current;
    typeof Ne != "function" && op(Ne) && Ne.current !== xe.current && (K.setPositionReference(Ne.current), xe.current = Ne.current);
  }, [h, K, N, T]), f.useEffect(() => {
    if (p && h && X.domReference && X.floating)
      return cf(X.domReference, X.floating, de, Z);
  }, [p, h, X, de, Z]);
  const je = qt(le), Me = Kg(o, je, M), Pe = ho(le) || "center", we = !!ie.hide?.referenceHidden;
  he(() => {
    w && h && pe && C(je);
  }, [w, h, pe, je]);
  const ve = f.useMemo(() => ({
    position: "absolute",
    top: ie.arrow?.y,
    left: ie.arrow?.x
  }), [ie.arrow]), Ae = ie.arrow?.centerOffset !== 0;
  return f.useMemo(() => ({
    positionerStyles: Se,
    arrowStyles: ve,
    arrowRef: z,
    arrowUncentered: Ae,
    side: Me,
    align: Pe,
    physicalSide: je,
    anchorHidden: we,
    refs: K,
    context: te,
    isPositioned: pe,
    update: de
  }), [Se, ve, z, Ae, Me, Pe, je, we, K, te, pe, de]);
}
function op(t) {
  return t != null && "current" in t;
}
const $i = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: s,
    render: i,
    side: a,
    align: l,
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: p = 5,
    arrowPadding: m = 5,
    sticky: h = !1,
    disableAnchorTracking: g = !1,
    collisionAvoidance: y = Wp,
    ...v
  } = e, {
    store: x
  } = vn(), w = uT(), E = Oa(!0), S = x.useState("parent"), C = x.useState("floatingRootContext"), _ = x.useState("floatingTreeRoot"), R = x.useState("mounted"), O = x.useState("open"), j = x.useState("modal"), F = x.useState("activeTriggerElement"), N = x.useState("lastOpenChangeReason"), T = x.useState("floatingNodeId"), L = x.useState("floatingParentNodeId");
  let M = o, A = c, $ = u, k = l, H = y;
  S.type === "context-menu" && (M = o ?? S.context?.anchor, k = k ?? "start", !a && k !== "center" && ($ = e.alignOffset ?? 2, A = e.sideOffset ?? -5));
  let B = a, P = k;
  S.type === "menu" ? (B = B ?? "inline-end", P = P ?? "start", H = e.collisionAvoidance ?? Ec) : S.type === "menubar" && (B = B ?? "bottom", P = P ?? "start");
  const V = S.type === "context-menu", I = Aa({
    anchor: M,
    floatingRootContext: C,
    positionMethod: E ? "fixed" : r,
    mounted: R,
    side: B,
    sideOffset: A,
    align: P,
    alignOffset: $,
    arrowPadding: V ? 0 : m,
    collisionBoundary: d,
    collisionPadding: p,
    sticky: h,
    nodeId: T,
    keepMounted: w,
    disableAnchorTracking: g,
    collisionAvoidance: H,
    shiftCrossAxis: V,
    externalTree: _
  }), D = f.useMemo(() => {
    const Q = {};
    return O || (Q.pointerEvents = "none"), {
      role: "presentation",
      hidden: !R,
      style: {
        ...I.positionerStyles,
        ...Q
      }
    };
  }, [O, R, I.positionerStyles]);
  f.useEffect(() => {
    function Q(ce) {
      ce.open ? (ce.parentNodeId === T && x.set("hoverEnabled", !1), ce.nodeId !== T && ce.parentNodeId === x.select("floatingParentNodeId") && x.setOpen(!1, ke(Kr))) : ce.parentNodeId === T && ce.reason !== Kr && x.set("hoverEnabled", !0);
    }
    return _.events.on("menuopenchange", Q), () => {
      _.events.off("menuopenchange", Q);
    };
  }, [x, _.events, T]), f.useEffect(() => {
    if (x.select("floatingParentNodeId") == null)
      return;
    function Q(ce) {
      if (ce.open || ce.nodeId !== x.select("floatingParentNodeId"))
        return;
      const W = ce.reason ?? Kr;
      x.setOpen(!1, ke(W));
    }
    return _.events.on("menuopenchange", Q), () => {
      _.events.off("menuopenchange", Q);
    };
  }, [_.events, x]), f.useEffect(() => {
    function Q(ce) {
      !O || ce.nodeId !== x.select("floatingParentNodeId") || ce.target && F && F !== ce.target && x.setOpen(!1, ke(Kr));
    }
    return _.events.on("itemhover", Q), () => {
      _.events.off("itemhover", Q);
    };
  }, [_.events, O, F, x]), f.useEffect(() => {
    const Q = {
      open: O,
      nodeId: T,
      parentNodeId: L,
      reason: x.select("lastOpenChangeReason")
    };
    _.events.emit("menuopenchange", Q);
  }, [_.events, O, x, T, L]);
  const z = f.useMemo(() => ({
    open: O,
    side: I.side,
    align: I.align,
    anchorHidden: I.anchorHidden,
    nested: S.type === "menu"
  }), [O, I.side, I.align, I.anchorHidden, S.type]), U = f.useMemo(() => ({
    side: I.side,
    align: I.align,
    arrowRef: I.arrowRef,
    arrowUncentered: I.arrowUncentered,
    arrowStyles: I.arrowStyles,
    nodeId: I.context.nodeId
  }), [I.side, I.align, I.arrowRef, I.arrowUncentered, I.arrowStyles, I.context.nodeId]), G = _e("div", e, {
    state: z,
    stateAttributesMapping: bn,
    ref: [n, x.useStateSetter("positionerElement")],
    props: [D, v]
  }), J = R && S.type !== "menu" && (S.type !== "menubar" && j && N !== Et || S.type === "menubar" && S.context.modal);
  let se = null;
  return S.type === "menubar" ? se = S.context.contentElement : S.type === void 0 && (se = F), /* @__PURE__ */ b.jsxs(hu.Provider, {
    value: U,
    children: [J && /* @__PURE__ */ b.jsx(xs, {
      ref: S.type === "context-menu" || S.type === "nested-context-menu" ? S.context.internalBackdropRef : null,
      inert: Sa(!O),
      cutout: se
    }), /* @__PURE__ */ b.jsx(ph, {
      id: T,
      children: /* @__PURE__ */ b.jsx(yr, {
        elementsRef: x.context.itemDomElements,
        labelsRef: x.context.itemLabels,
        children: G
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && ($i.displayName = "MenuPositioner");
const Eu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Eu.displayName = "MenuRadioGroupContext");
function mT() {
  const t = f.useContext(Eu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioGroupContext is missing. MenuRadioGroup parts must be placed within <Menu.RadioGroup>." : We(34));
  return t;
}
const Yg = /* @__PURE__ */ f.memo(/* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: s,
    defaultValue: i,
    onValueChange: a,
    disabled: l = !1,
    ...c
  } = e, [u, d] = un({
    controlled: s,
    default: i,
    name: "MenuRadioGroup"
  }), p = fe(a), m = fe((v, x) => {
    p?.(v, x), !x.isCanceled && d(v);
  }), h = f.useMemo(() => ({
    disabled: l
  }), [l]), g = _e("div", e, {
    state: h,
    ref: n,
    props: {
      role: "group",
      "aria-disabled": l || void 0,
      ...c
    }
  }), y = f.useMemo(() => ({
    value: u,
    setValue: m,
    disabled: l
  }), [u, m, l]);
  return /* @__PURE__ */ b.jsx(Eu.Provider, {
    value: y,
    children: g
  });
}));
process.env.NODE_ENV !== "production" && (Yg.displayName = "MenuRadioGroup");
const Cu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Cu.displayName = "MenuRadioItemContext");
function hT() {
  const t = f.useContext(Cu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioItemContext is missing. MenuRadioItem parts must be placed within <Menu.RadioItem>." : We(35));
  return t;
}
const qg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !1,
    value: u,
    ...d
  } = e, p = Yn({
    label: i
  }), m = Es(!0), h = lt(s), {
    store: g
  } = vn(), y = g.useState("isActive", p.index), v = g.useState("itemProps"), {
    value: x,
    setValue: w,
    disabled: E
  } = mT(), S = E || l, C = x === u, {
    getItemProps: _,
    itemRef: R
  } = Ma({
    closeOnClick: c,
    disabled: S,
    highlighted: y,
    id: h,
    store: g,
    nativeButton: a,
    nodeId: m?.nodeId,
    itemMetadata: vu
  }), O = f.useMemo(() => ({
    disabled: S,
    highlighted: y,
    checked: C
  }), [S, y, C]), j = fe((N) => {
    const T = {
      ...ke(No, N.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    w(u, T);
  }), F = _e("div", e, {
    state: O,
    stateAttributesMapping: Pa,
    props: [v, {
      role: "menuitemradio",
      "aria-checked": C,
      onClick: j
    }, d, _],
    ref: [R, n, p.ref]
  });
  return /* @__PURE__ */ b.jsx(Cu.Provider, {
    value: O,
    children: F
  });
});
process.env.NODE_ENV !== "production" && (qg.displayName = "MenuRadioItem");
const Xg = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    keepMounted: s = !1,
    ...i
  } = e, a = hT(), l = f.useRef(null), {
    transitionStatus: c,
    setMounted: u
  } = Kn(a.checked);
  Gt({
    open: a.checked,
    ref: l,
    onComplete() {
      a.checked || u(!1);
    }
  });
  const d = f.useMemo(() => ({
    checked: a.checked,
    disabled: a.disabled,
    highlighted: a.highlighted,
    transitionStatus: c
  }), [a.checked, a.disabled, a.highlighted, c]);
  return _e("span", e, {
    state: d,
    stateAttributesMapping: Pa,
    ref: [n, l],
    props: {
      "aria-hidden": !0,
      ...i
    },
    enabled: s || a.checked
  });
});
process.env.NODE_ENV !== "production" && (Xg.displayName = "MenuRadioItemIndicator");
const Zg = /* @__PURE__ */ f.createContext(null);
process.env.NODE_ENV !== "production" && (Zg.displayName = "MenubarContext");
function Jg(t) {
  return f.useContext(Zg);
}
const gT = {
  ...fa,
  disabled: be((t) => t.parent.type === "menubar" && t.parent.context.disabled || t.disabled),
  modal: be((t) => (t.parent.type === void 0 || t.parent.type === "context-menu") && (t.modal ?? !0)),
  allowMouseEnter: be((t) => t.parent.type === "menu" ? t.parent.store.select("allowMouseEnter") : t.allowMouseEnter),
  stickIfOpen: be((t) => t.stickIfOpen),
  parent: be((t) => t.parent),
  rootId: be((t) => t.parent.type === "menu" ? t.parent.store.select("rootId") : t.parent.type !== void 0 ? t.parent.context.rootId : t.rootId),
  activeIndex: be((t) => t.activeIndex),
  isActive: be((t, e) => t.activeIndex === e),
  hoverEnabled: be((t) => t.hoverEnabled),
  instantType: be((t) => t.instantType),
  lastOpenChangeReason: be((t) => t.openChangeReason),
  floatingTreeRoot: be((t) => t.parent.type === "menu" ? t.parent.store.select("floatingTreeRoot") : t.floatingTreeRoot),
  floatingNodeId: be((t) => t.floatingNodeId),
  floatingParentNodeId: be((t) => t.floatingParentNodeId),
  itemProps: be((t) => t.itemProps),
  closeDelay: be((t) => t.closeDelay),
  keyboardEventRelay: be((t) => {
    if (t.keyboardEventRelay)
      return t.keyboardEventRelay;
    if (t.parent.type === "menu")
      return t.parent.store.select("keyboardEventRelay");
  })
};
class _u extends vs {
  constructor(n) {
    super({
      ...bT(),
      ...n
    }, {
      positionerRef: /* @__PURE__ */ f.createRef(),
      popupRef: /* @__PURE__ */ f.createRef(),
      typingRef: {
        current: !1
      },
      itemDomElements: {
        current: []
      },
      itemLabels: {
        current: []
      },
      allowMouseUpTriggerRef: {
        current: !1
      },
      triggerFocusTargetRef: /* @__PURE__ */ f.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ f.createRef(),
      onOpenChangeComplete: void 0,
      triggerElements: new _r()
    }, gT);
    Re(this, "unsubscribeParentListener", null);
    this.observe(be((o) => o.allowMouseEnter), (o, r) => {
      this.state.parent.type === "menu" && o !== r && this.state.parent.store.set("allowMouseEnter", o);
    }), this.unsubscribeParentListener = this.observe("parent", (o) => {
      if (this.unsubscribeParentListener?.(), o.type === "menu") {
        this.unsubscribeParentListener = o.store.subscribe(() => {
          this.notifyAll();
        }), this.context.allowMouseUpTriggerRef = o.store.context.allowMouseUpTriggerRef;
        return;
      }
      o.type !== void 0 && (this.context.allowMouseUpTriggerRef = o.context.allowMouseUpTriggerRef), this.unsubscribeParentListener = null;
    });
  }
  setOpen(n, o) {
    this.state.floatingRootContext.context.events.emit("setOpen", {
      open: n,
      eventDetails: o
    });
  }
  static useStore(n, o) {
    const r = jt(() => new _u(o)).current;
    return n ?? r;
  }
}
function bT() {
  return {
    ...da(),
    disabled: !1,
    modal: !0,
    allowMouseEnter: !0,
    stickIfOpen: !0,
    parent: {
      type: void 0
    },
    rootId: void 0,
    activeIndex: null,
    hoverEnabled: !0,
    instantType: void 0,
    openChangeReason: null,
    floatingTreeRoot: new Bc(),
    floatingNodeId: void 0,
    floatingParentNodeId: null,
    itemProps: at,
    keyboardEventRelay: void 0,
    closeDelay: 0
  };
}
const Ru = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ru.displayName = "MenuSubmenuRootContext");
function Qg() {
  return f.useContext(Ru);
}
function Nu(t) {
  const {
    children: e,
    open: n,
    onOpenChange: o,
    onOpenChangeComplete: r,
    defaultOpen: s = !1,
    disabled: i = !1,
    modal: a,
    loopFocus: l = !0,
    orientation: c = "vertical",
    actionsRef: u,
    closeParentOnEsc: d = !1,
    handle: p,
    triggerId: m,
    defaultTriggerId: h = null,
    highlightItemOnHover: g = !0
  } = t, y = Oa(!0), v = vn(!0), x = Jg(), w = Qg(), E = f.useMemo(() => w && v ? {
    type: "menu",
    store: v.store
  } : x ? {
    type: "menubar",
    context: x
  } : y && !v ? {
    type: "context-menu",
    context: y
  } : {
    type: void 0
  }, [y, v, x, w]), S = _u.useStore(p?.store, {
    parent: E
  }), C = S.useState("floatingTreeRoot"), _ = Wc(C), R = Pn();
  he(() => {
    y && !v ? S.update({
      parent: {
        type: "context-menu",
        context: y
      },
      floatingNodeId: _,
      floatingParentNodeId: R
    }) : v && S.update({
      floatingNodeId: _,
      floatingParentNodeId: R
    });
  }, [y, v, _, R, S]), S.useControlledProp("open", n, s), S.useControlledProp("activeTriggerId", m, h), S.useContextCallback("onOpenChangeComplete", r);
  const O = S.useState("open"), j = S.useState("activeTriggerElement"), F = S.useState("positionerElement"), N = S.useState("hoverEnabled"), T = S.useState("modal"), L = S.useState("disabled"), M = S.useState("lastOpenChangeReason"), A = S.useState("parent"), $ = S.useState("activeIndex"), k = S.useState("payload"), H = S.useState("floatingParentNodeId"), B = f.useRef(null), P = H != null;
  let V;
  process.env.NODE_ENV !== "production" && A.type !== void 0 && a !== void 0 && console.warn("Base UI: The `modal` prop is not supported on nested menus. It will be ignored."), S.useSyncedValues({
    disabled: i,
    modal: A.type === void 0 ? a : void 0,
    rootId: Lo()
  });
  const {
    openMethod: I,
    triggerProps: D,
    reset: z
  } = ba(O);
  ca(S);
  const {
    forceUnmount: U
  } = ua(O, S, () => {
    S.update({
      allowMouseEnter: !1,
      stickIfOpen: !0
    }), z();
  }), G = f.useRef(A.type !== "context-menu"), J = ft();
  f.useEffect(() => {
    if (O || (B.current = null), A.type === "context-menu") {
      if (!O) {
        J.clear(), G.current = !1;
        return;
      }
      J.start(500, () => {
        G.current = !0;
      });
    }
  }, [J, O, A.type]), sa(O && T && M !== Et && I !== "touch", F), he(() => {
    !O && !N && S.set("hoverEnabled", !0);
  }, [O, N, S]);
  const se = f.useRef(!0), Q = ft(), ce = fe((we, ve) => {
    const Ae = ve.reason;
    if (O === we && ve.trigger === j && M === Ae || (ve.preventUnmountOnClose = () => {
      S.set("preventUnmountingOnClose", !0);
    }, !we && ve.trigger == null && (ve.trigger = j ?? void 0), o?.(we, ve), ve.isCanceled))
      return;
    const Ne = {
      open: we,
      nativeEvent: ve.event,
      reason: ve.reason,
      nested: P
    };
    V?.emit("openchange", Ne);
    const De = ve.event;
    if (we === !1 && De?.type === "click" && De.pointerType === "touch" && !se.current)
      return;
    if (!we && $ !== null) {
      const Le = S.context.itemDomElements.current[$];
      queueMicrotask(() => {
        Le?.setAttribute("tabindex", "-1");
      });
    }
    we && Ae === sr ? (se.current = !1, Q.start(300, () => {
      se.current = !0;
    })) : (se.current = !0, Q.clear());
    const ze = (Ae === ln || Ae === No) && De.detail === 0 && De?.isTrusted, et = !we && (Ae === us || Ae == null);
    function ct() {
      const Le = {
        open: we,
        openChangeReason: Ae
      };
      B.current = ve.event ?? null;
      const Ge = ve.trigger?.id ?? null;
      (Ge || we) && (Le.activeTriggerId = Ge, Le.activeTriggerElement = ve.trigger ?? null), S.update(Le);
    }
    Ae === Et ? Vt.flushSync(ct) : ct(), A.type === "menubar" && (Ae === sr || Ae === In || Ae === Et || Ae === ci || Ae === Kr) ? S.set("instantType", "group") : ze || et ? S.set("instantType", ze ? "click" : "dismiss") : S.set("instantType", void 0);
  }), W = f.useCallback((we) => {
    const ve = ke(we);
    return ve.preventUnmountOnClose = () => {
      S.set("preventUnmountingOnClose", !0);
    }, ve;
  }, [S]), oe = f.useCallback(() => {
    S.setOpen(!1, W(qi));
  }, [S, W]);
  f.useImperativeHandle(u, () => ({
    unmount: U,
    close: oe
  }), [U, oe]);
  let Y;
  A.type === "context-menu" && (Y = A.context), f.useImperativeHandle(Y?.positionerRef, () => F, [F]), f.useImperativeHandle(Y?.actionsRef, () => ({
    setOpen: ce
  }), [ce]);
  const Z = pa({
    popupStore: S,
    onOpenChange: ce
  });
  V = Z.context.events, f.useEffect(() => {
    const we = ({
      open: ve,
      eventDetails: Ae
    }) => ce(ve, Ae);
    return V.on("setOpen", we), () => {
      V?.off("setOpen", we);
    };
  }, [V, ce]);
  const K = bs(Z, {
    enabled: !L,
    bubbles: {
      escapeKey: d && A.type === "menu"
    },
    outsidePress() {
      return A.type !== "context-menu" || B.current?.type === "contextmenu" ? !0 : G.current;
    },
    externalTree: P ? C : void 0
  }), X = Qc(Z, {
    role: "menu"
  }), ne = jo(), re = f.useCallback((we) => {
    S.select("activeIndex") !== we && S.set("activeIndex", we);
  }, [S]), ie = Ph(Z, {
    enabled: !L,
    listRef: S.context.itemDomElements,
    activeIndex: $,
    nested: A.type !== void 0,
    loopFocus: l,
    orientation: c,
    parentOrientation: A.type === "menubar" ? A.context.orientation : void 0,
    rtl: ne === "rtl",
    disabledIndices: zn,
    onNavigate: re,
    openOnArrowKeyDown: A.type !== "context-menu",
    externalTree: P ? C : void 0,
    focusItemOnHover: g
  }), de = f.useCallback((we) => {
    S.context.typingRef.current = we;
  }, [S]), le = Ah(Z, {
    listRef: S.context.itemLabels,
    activeIndex: $,
    resetMs: Ry,
    onMatch: (we) => {
      O && we !== $ && S.set("activeIndex", we);
    },
    onTypingChange: de
  }), {
    getReferenceProps: te,
    getFloatingProps: pe,
    getItemProps: ue,
    getTriggerProps: ye
  } = qn([K, X, ie, le]), ge = f.useMemo(() => {
    const we = Qt(te(), {
      onMouseEnter() {
        S.set("hoverEnabled", !0);
      },
      onMouseMove() {
        S.set("allowMouseEnter", !0);
      }
    }, D);
    return delete we.role, we;
  }, [te, S, D]), Te = f.useMemo(() => {
    const we = ye();
    if (!we)
      return we;
    const ve = Qt(we, D);
    return delete ve.role, delete ve["aria-controls"], ve;
  }, [ye, D]), Se = $o(), xe = f.useMemo(() => pe({
    onMouseEnter() {
      A.type === "menu" && Se.request(() => S.set("hoverEnabled", !1));
    },
    onMouseMove() {
      S.set("allowMouseEnter", !0);
    },
    onClick() {
      S.select("hoverEnabled") && S.set("hoverEnabled", !1);
    },
    onKeyDown(we) {
      const ve = S.select("keyboardEventRelay");
      ve && !we.isPropagationStopped() && ve(we);
    }
  }), [pe, A.type, Se, S]), je = f.useMemo(() => ue(), [ue]);
  S.useSyncedValues({
    floatingRootContext: Z,
    activeTriggerProps: ge,
    inactiveTriggerProps: Te,
    popupProps: xe,
    itemProps: je
  });
  const Me = f.useMemo(() => ({
    store: S,
    parent: E
  }), [S, E]), Pe = /* @__PURE__ */ b.jsx(gu.Provider, {
    value: Me,
    children: typeof e == "function" ? e({
      payload: k
    }) : e
  });
  return A.type === void 0 || A.type === "context-menu" ? /* @__PURE__ */ b.jsx(mh, {
    externalTree: C,
    children: Pe
  }) : Pe;
}
function eb(t) {
  const e = vn().store, n = f.useMemo(() => ({
    parentMenu: e
  }), [e]);
  return /* @__PURE__ */ b.jsx(Ru.Provider, {
    value: n,
    children: /* @__PURE__ */ b.jsx(Nu, {
      ...t
    })
  });
}
function tb(t) {
  const e = t.getBoundingClientRect();
  if (process.env.NODE_ENV === "test")
    return e;
  const n = window.getComputedStyle(t, "::before"), o = window.getComputedStyle(t, "::after");
  if (!(n.content !== "none" || o.content !== "none"))
    return e;
  const s = parseFloat(n.width) || 0, i = parseFloat(n.height) || 0, a = parseFloat(o.width) || 0, l = parseFloat(o.height) || 0, c = Math.max(e.width, s, a), u = Math.max(e.height, i, l), d = c - e.width, p = u - e.height;
  return {
    left: e.left - d / 2,
    right: e.right + d / 2,
    top: e.top - p / 2,
    bottom: e.bottom + p / 2
  };
}
function nb(t) {
  if (ut(t) && t.hasAttribute("data-rootownerid"))
    return t.getAttribute("data-rootownerid") ?? void 0;
  if (!Rn(t))
    return nb(On(t));
}
function vT(t) {
  const {
    enabled: e = !0,
    mouseDownAction: n,
    open: o
  } = t, r = f.useRef(!1);
  return f.useMemo(() => e ? {
    onMouseDown: (s) => {
      (n === "open" && !o || n === "close" && o) && (r.current = !0, Ct(s.currentTarget).addEventListener("click", () => {
        r.current = !1;
      }, {
        once: !0
      }));
    },
    onClick: (s) => {
      r.current && (r.current = !1, s.preventBaseUIHandler());
    }
  } : at, [e, n, o]);
}
const Zs = 2, ob = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    id: a,
    openOnHover: l,
    delay: c = 100,
    closeDelay: u = 0,
    handle: d,
    payload: p,
    ...m
  } = e, h = vn(!0), g = d?.store ?? h?.store;
  if (!g)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Trigger> must be either used within a <Menu.Root> component or provided with a handle." : We(85));
  const y = lt(a), v = g.useState("isTriggerActive", y), x = g.useState("floatingRootContext"), w = g.useState("isOpenedByTrigger", y), E = f.useRef(null), S = xT(), C = Oc(!0), _ = vo(), R = f.useMemo(() => _ ?? new Bc(), [_]), O = Wc(R), j = Pn(), {
    registerTrigger: F,
    isMountedByThisTrigger: N
  } = la(y, E, g, {
    payload: p,
    closeDelay: u,
    parent: S,
    floatingTreeRoot: R,
    floatingNodeId: O,
    floatingParentNodeId: j,
    keyboardEventRelay: C?.relayKeyboardEvent
  }), T = S.type === "menubar", L = g.useState("disabled"), M = s || L || T && S.context.disabled, {
    getButtonProps: A,
    buttonRef: $
  } = Wt({
    disabled: M,
    native: i
  });
  f.useEffect(() => {
    !w && S.type === void 0 && (g.context.allowMouseUpTriggerRef.current = !1);
  }, [g, w, S.type]);
  const k = f.useRef(null), H = ft(), B = fe((X) => {
    if (!k.current)
      return;
    H.clear(), g.context.allowMouseUpTriggerRef.current = !1;
    const ne = X.target;
    if (Ue(k.current, ne) || Ue(g.select("positionerElement"), ne) || ne === k.current || ne != null && nb(ne) === g.select("rootId"))
      return;
    const re = tb(k.current);
    X.clientX >= re.left - Zs && X.clientX <= re.right + Zs && X.clientY >= re.top - Zs && X.clientY <= re.bottom + Zs || R.events.emit("close", {
      domEvent: X,
      reason: Kp
    });
  });
  f.useEffect(() => {
    w && g.select("lastOpenChangeReason") === Et && Ct(k.current).addEventListener("mouseup", B, {
      once: !0
    });
  }, [w, B, g]);
  const P = T && S.context.hasSubmenuOpen, I = ma(x, {
    enabled: (l ?? P) && !M && S.type !== "context-menu" && (!T || P && !N),
    handleClose: ga({
      blockPointerEvents: !T
    }),
    mouseOnly: !0,
    move: !1,
    restMs: S.type === void 0 ? c : void 0,
    delay: {
      close: u
    },
    triggerElementRef: E,
    externalTree: R,
    isActiveTrigger: v
  }), D = yT(w, g.select("lastOpenChangeReason")), z = gs(x, {
    enabled: !M && S.type !== "context-menu",
    event: w && T ? "click" : "mousedown",
    toggle: !0,
    ignoreMouse: !1,
    stickIfOpen: S.type === void 0 ? D : !1
  }), U = Oh(x, {
    enabled: !M && P
  }), G = vT({
    open: w,
    enabled: T,
    mouseDownAction: "open"
  }), J = qn([z, U]), se = f.useMemo(() => ({
    disabled: M,
    open: w
  }), [M, w]), Q = g.useState("triggerProps", N), ce = [k, n, $, F, E], W = [J.getReferenceProps(), I ?? at, Q, {
    "aria-haspopup": "menu",
    id: y,
    onMouseDown: (X) => {
      if (g.select("open"))
        return;
      H.start(200, () => {
        g.context.allowMouseUpTriggerRef.current = !0;
      }), Ct(X.currentTarget).addEventListener("mouseup", B, {
        once: !0
      });
    }
  }, T ? {
    role: "menuitem"
  } : {}, G, m, A], oe = f.useRef(null), Y = fe((X) => {
    Vt.flushSync(() => {
      g.setOpen(!1, ke(In, X.nativeEvent, X.currentTarget));
    }), Om(oe.current)?.focus();
  }), Z = fe((X) => {
    const ne = g.select("positionerElement");
    if (ne && To(X, ne))
      g.context.beforeContentFocusGuardRef.current?.focus();
    else {
      Vt.flushSync(() => {
        g.setOpen(!1, ke(In, X.nativeEvent, X.currentTarget));
      });
      let re = Im(g.context.triggerFocusTargetRef.current || E.current);
      for (; re !== null && Ue(ne, re); ) {
        const ie = re;
        if (re = na(re), re === ie)
          break;
      }
      re?.focus();
    }
  }), K = _e("button", e, {
    enabled: !T,
    stateAttributesMapping: Mi,
    state: se,
    ref: ce,
    props: W
  });
  return T ? /* @__PURE__ */ b.jsx(eg, {
    tag: "button",
    render: o,
    className: r,
    state: se,
    refs: ce,
    props: W,
    stateAttributesMapping: Mi
  }) : w ? /* @__PURE__ */ b.jsxs(f.Fragment, {
    children: [/* @__PURE__ */ b.jsx(Gn, {
      ref: oe,
      onFocus: Y
    }, `${y}-pre-focus-guard`), /* @__PURE__ */ b.jsx(f.Fragment, {
      children: K
    }, y), /* @__PURE__ */ b.jsx(Gn, {
      ref: g.context.triggerFocusTargetRef,
      onFocus: Z
    }, `${y}-post-focus-guard`)]
  }) : /* @__PURE__ */ b.jsx(f.Fragment, {
    children: K
  }, y);
});
process.env.NODE_ENV !== "production" && (ob.displayName = "MenuTrigger");
function yT(t, e) {
  const n = ft(), [o, r] = f.useState(!1);
  return he(() => {
    t && e === "trigger-hover" ? (r(!0), n.start(Up, () => {
      r(!1);
    })) : t || (n.clear(), r(!1));
  }, [t, e, n]), o;
}
function xT() {
  const t = Oa(!0), e = vn(!0), n = Jg();
  return f.useMemo(() => n ? {
    type: "menubar",
    context: n
  } : t && !e ? {
    type: "context-menu",
    context: t
  } : {
    type: void 0
  }, [t, e, n]);
}
const Cs = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    orientation: s = "horizontal",
    ...i
  } = e, a = f.useMemo(() => ({
    orientation: s
  }), [s]);
  return _e("div", e, {
    state: a,
    ref: n,
    props: [{
      role: "separator",
      "aria-orientation": s
    }, i]
  });
});
process.env.NODE_ENV !== "production" && (Cs.displayName = "Separator");
const ku = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    label: s,
    id: i,
    nativeButton: a = !1,
    openOnHover: l = !0,
    delay: c = 100,
    closeDelay: u = 0,
    disabled: d = !1,
    ...p
  } = e, m = Yn(), h = Es(), {
    store: g
  } = vn(), y = lt(i), v = g.useState("open"), x = g.useState("floatingRootContext"), w = g.useState("floatingTreeRoot"), E = Th(y, g), S = f.useCallback((z) => {
    const U = E(z);
    return z !== null && g.select("open") && g.select("activeTriggerId") == null && g.update({
      activeTriggerId: y,
      activeTriggerElement: z,
      closeDelay: u
    }), U;
  }, [E, u, g, y]), C = f.useRef(null), _ = f.useCallback((z) => {
    C.current = z, g.set("activeTriggerElement", z);
  }, [g]), R = Qg();
  if (!R?.parentMenu)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.SubmenuTrigger> must be placed in <Menu.SubmenuRoot>." : We(37));
  g.useSyncedValue("closeDelay", u);
  const O = R.parentMenu, j = O.useState("itemProps"), F = O.useState("isActive", m.index), N = f.useMemo(() => ({
    type: "submenu-trigger",
    setActive: () => O.set("activeIndex", m.index)
  }), [O, m.index]), T = g.useState("disabled"), L = d || T, {
    getItemProps: M,
    itemRef: A
  } = Ma({
    closeOnClick: !1,
    disabled: L,
    highlighted: F,
    id: y,
    store: g,
    nativeButton: a,
    itemMetadata: N,
    nodeId: h?.nodeId
  }), $ = g.useState("hoverEnabled"), k = g.useState("allowMouseEnter"), H = ma(x, {
    enabled: $ && l && !L && k,
    handleClose: ga({
      blockPointerEvents: !0
    }),
    mouseOnly: !0,
    move: !0,
    restMs: c,
    delay: {
      open: c,
      close: u
    },
    triggerElementRef: C,
    externalTree: w
  }), B = gs(x, {
    enabled: !L,
    event: "mousedown",
    toggle: !l,
    ignoreMouse: l,
    stickIfOpen: !1
  }), P = qn([B]), V = g.useState("triggerProps", !0);
  delete V.id;
  const I = f.useMemo(() => ({
    disabled: L,
    highlighted: F,
    open: v
  }), [L, F, v]);
  return _e("div", e, {
    state: I,
    stateAttributesMapping: ys,
    props: [P.getReferenceProps(), H, V, j, {
      tabIndex: v || F ? 0 : -1,
      onBlur() {
        F && O.set("activeIndex", null);
      }
    }, p, M],
    ref: [n, m.ref, A, S, _]
  });
});
process.env.NODE_ENV !== "production" && (ku.displayName = "MenuSubmenuTrigger");
const wT = "_positioner_5hu14_1", ST = "_content_5hu14_7", ET = "_subContent_5hu14_40", CT = "_item_5hu14_46", _T = "_subTrigger_5hu14_90", RT = "_chevron_5hu14_95", NT = "_checkboxItem_5hu14_99", kT = "_radioItem_5hu14_100", TT = "_indicator_5hu14_104", IT = "_label_5hu14_113", OT = "_separator_5hu14_124", MT = "_shortcut_5hu14_130", Ft = {
  positioner: wT,
  content: ST,
  subContent: ET,
  item: CT,
  subTrigger: _T,
  chevron: RT,
  checkboxItem: NT,
  radioItem: kT,
  indicator: TT,
  label: IT,
  separator: OT,
  shortcut: MT
}, _j = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(Nu, { "data-slot": "dropdown-menu", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, Rj = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(ss, { "data-slot": "dropdown-menu-portal", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, Nj = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(ob, { "data-slot": "dropdown-menu-trigger", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, PT = (t) => {
  const e = ee.c(22);
  let n, o, r, s, i, a, l, c;
  e[0] !== t ? ({
    align: i,
    alignOffset: a,
    anchor: n,
    collisionPadding: r,
    side: l,
    sideOffset: c,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8]);
  const u = i === void 0 ? "start" : i, d = a === void 0 ? 0 : a, p = l === void 0 ? "bottom" : l, m = c === void 0 ? 4 : c;
  let h;
  e[9] !== o ? (h = ae(Ft.content, o), e[9] = o, e[10] = h) : h = e[10];
  let g;
  e[11] !== s || e[12] !== h ? (g = /* @__PURE__ */ b.jsx(Li, { "data-slot": "dropdown-menu-content", className: h, ...s }), e[11] = s, e[12] = h, e[13] = g) : g = e[13];
  let y;
  return e[14] !== u || e[15] !== d || e[16] !== n || e[17] !== r || e[18] !== p || e[19] !== m || e[20] !== g ? (y = /* @__PURE__ */ b.jsx(ss, { children: /* @__PURE__ */ b.jsx($i, { className: Ft.positioner, align: u, alignOffset: d, anchor: n, collisionPadding: r, side: p, sideOffset: m, children: g }) }), e[14] = u, e[15] = d, e[16] = n, e[17] = r, e[18] = p, e[19] = m, e[20] = g, e[21] = y) : y = e[21], y;
}, kj = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(Hg, { "data-slot": "dropdown-menu-group", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, Tj = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    inset: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] !== n ? (s = ae(Ft.label, n), e[4] = n, e[5] = s) : s = e[5];
  let i;
  return e[6] !== o || e[7] !== r || e[8] !== s ? (i = /* @__PURE__ */ b.jsx(Ug, { "data-slot": "dropdown-menu-label", "data-inset": o, className: s, ...r }), e[6] = o, e[7] = r, e[8] = s, e[9] = i) : i = e[9], i;
}, Ij = (t) => {
  const e = ee.c(12);
  let n, o, r, s;
  e[0] !== t ? ({
    className: n,
    inset: o,
    variant: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = s === void 0 ? "default" : s;
  let a;
  e[5] !== n ? (a = ae(Ft.item, n), e[5] = n, e[6] = a) : a = e[6];
  let l;
  return e[7] !== o || e[8] !== r || e[9] !== a || e[10] !== i ? (l = /* @__PURE__ */ b.jsx(xu, { "data-slot": "dropdown-menu-item", "data-inset": o, "data-variant": i, className: a, ...r }), e[7] = o, e[8] = r, e[9] = a, e[10] = i, e[11] = l) : l = e[11], l;
}, Oj = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(eb, { "data-slot": "dropdown-menu-sub", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, Mj = (t) => {
  const e = ee.c(13);
  let n, o, r, s;
  e[0] !== t ? ({
    className: o,
    inset: r,
    children: n,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  let i;
  e[5] !== o ? (i = ae(Ft.item, Ft.subTrigger, o), e[5] = o, e[6] = i) : i = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b.jsx(Ve, { icon: Ra, className: Ft.chevron, width: 24, height: 24 }), e[7] = a) : a = e[7];
  let l;
  return e[8] !== n || e[9] !== r || e[10] !== s || e[11] !== i ? (l = /* @__PURE__ */ b.jsxs(ku, { "data-slot": "dropdown-menu-sub-trigger", "data-inset": r, className: i, ...s, children: [
    n,
    a
  ] }), e[8] = n, e[9] = r, e[10] = s, e[11] = i, e[12] = l) : l = e[12], l;
}, Pj = (t) => {
  const e = ee.c(16);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    align: r,
    alignOffset: s,
    side: i,
    sideOffset: a,
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const l = r === void 0 ? "start" : r, c = s === void 0 ? -3 : s, u = i === void 0 ? "right" : i, d = a === void 0 ? 0 : a;
  let p;
  e[7] !== n ? (p = ae(Ft.subContent, n), e[7] = n, e[8] = p) : p = e[8];
  let m;
  return e[9] !== l || e[10] !== c || e[11] !== o || e[12] !== u || e[13] !== d || e[14] !== p ? (m = /* @__PURE__ */ b.jsx(PT, { "data-slot": "dropdown-menu-sub-content", className: p, align: l, alignOffset: c, side: u, sideOffset: d, ...o }), e[9] = l, e[10] = c, e[11] = o, e[12] = u, e[13] = d, e[14] = p, e[15] = m) : m = e[15], m;
}, Aj = (t) => {
  const e = ee.c(13);
  let n, o, r, s;
  e[0] !== t ? ({
    className: r,
    children: o,
    checked: n,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  let i;
  e[5] !== r ? (i = ae(Ft.item, Ft.checkboxItem, r), e[5] = r, e[6] = i) : i = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b.jsx("span", { className: Ft.indicator, "data-slot": "dropdown-menu-checkbox-item-indicator", children: /* @__PURE__ */ b.jsx(Bg, { children: /* @__PURE__ */ b.jsx(Ve, { icon: Tr, width: 24, height: 24 }) }) }), e[7] = a) : a = e[7];
  let l;
  return e[8] !== n || e[9] !== o || e[10] !== s || e[11] !== i ? (l = /* @__PURE__ */ b.jsxs(zg, { "data-slot": "dropdown-menu-checkbox-item", className: i, checked: n, ...s, children: [
    a,
    o
  ] }), e[8] = n, e[9] = o, e[10] = s, e[11] = i, e[12] = l) : l = e[12], l;
}, Dj = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx(Yg, { "data-slot": "dropdown-menu-radio-group", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, jj = (t) => {
  const e = ee.c(11);
  let n, o, r;
  e[0] !== t ? ({
    className: o,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] !== o ? (s = ae(Ft.item, Ft.radioItem, o), e[4] = o, e[5] = s) : s = e[5];
  let i;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ b.jsx("span", { className: Ft.indicator, "data-slot": "dropdown-menu-radio-item-indicator", children: /* @__PURE__ */ b.jsx(Xg, { children: /* @__PURE__ */ b.jsx(Ve, { icon: Tr, width: 24, height: 24 }) }) }), e[6] = i) : i = e[6];
  let a;
  return e[7] !== n || e[8] !== r || e[9] !== s ? (a = /* @__PURE__ */ b.jsxs(qg, { "data-slot": "dropdown-menu-radio-item", className: s, ...r, children: [
    i,
    n
  ] }), e[7] = n, e[8] = r, e[9] = s, e[10] = a) : a = e[10], a;
}, Lj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae(Ft.separator, n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(Cs, { "data-slot": "dropdown-menu-separator", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, $j = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae(Ft.shortcut, n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("span", { "data-slot": "dropdown-menu-shortcut", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, AT = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    htmlFor: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] !== n ? (s = ae("gap-2 text-sm leading-none font-medium group-data-[disabled=true]:opacity-50 peer-disabled:opacity-50 flex items-center select-none group-data-[disabled=true]:pointer-events-none cursor-pointer peer-disabled:cursor-not-allowed", n), e[4] = n, e[5] = s) : s = e[5];
  let i;
  return e[6] !== o || e[7] !== r || e[8] !== s ? (i = /* @__PURE__ */ b.jsx("label", { htmlFor: o, "data-slot": "label", className: s, ...r }), e[6] = o, e[7] = r, e[8] = s, e[9] = i) : i = e[9], i;
}, DT = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    orientation: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "horizontal" : r;
  let i;
  e[4] !== n ? (i = ae("bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px data-[orientation=vertical]:self-stretch", n), e[4] = n, e[5] = i) : i = e[5];
  let a;
  return e[6] !== s || e[7] !== o || e[8] !== i ? (a = /* @__PURE__ */ b.jsx(Cs, { "data-slot": "separator", orientation: s, className: i, ...o }), e[6] = s, e[7] = o, e[8] = i, e[9] = a) : a = e[9], a;
}, Fj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("gap-4 has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3 flex flex-col", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("fieldset", { "data-slot": "field-set", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, Vj = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    variant: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "legend" : r;
  let i;
  e[4] !== n ? (i = ae("mb-1.5 font-medium data-[variant=label]:text-sm data-[variant=legend]:text-base", n), e[4] = n, e[5] = i) : i = e[5];
  let a;
  return e[6] !== o || e[7] !== i || e[8] !== s ? (a = /* @__PURE__ */ b.jsx("legend", { "data-slot": "field-legend", "data-variant": s, className: i, ...o }), e[6] = o, e[7] = i, e[8] = s, e[9] = a) : a = e[9], a;
}, zj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("gap-5 data-[slot=checkbox-group]:gap-3 [&>[data-slot=field-group]]:gap-4 group/field-group @container/field-group flex w-full flex-col", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "field-group", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, jT = ra("data-[invalid=true]:text-feedback-danger gap-2 group/field flex w-full", {
  defaultVariants: {
    orientation: "vertical"
  },
  variants: {
    orientation: {
      horizontal: "flex-row items-center [&>[data-slot=field-label]]:flex-auto has-[>[data-slot=field-content]]:items-start has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
      responsive: "flex-col [&>*]:w-full [&>.sr-only]:w-auto @md/field-group:flex-row @md/field-group:items-center @md/field-group:[&>*]:w-auto @md/field-group:[&>[data-slot=field-label]]:flex-auto @md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
      vertical: "flex-col [&>*]:w-full [&>.sr-only]:w-auto"
    }
  }
}), Bj = (t) => {
  const e = ee.c(11);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    orientation: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "vertical" : r;
  let i;
  e[4] !== n || e[5] !== s ? (i = ae(jT({
    orientation: s
  }), n), e[4] = n, e[5] = s, e[6] = i) : i = e[6];
  let a;
  return e[7] !== s || e[8] !== o || e[9] !== i ? (a = /* @__PURE__ */ b.jsx("div", { role: "group", "data-slot": "field", "data-orientation": s, className: i, ...o }), e[7] = s, e[8] = o, e[9] = i, e[10] = a) : a = e[10], a;
}, Hj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("gap-0.5 group/field-content flex flex-1 flex-col leading-snug", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "field-content", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, Uj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("has-data-checked:bg-action-primary/5 has-data-checked:border-action-primary dark:has-data-checked:bg-action-primary/10 gap-2 group-data-[disabled=true]/field:opacity-50 has-[>[data-slot=field]]:rounded-lg has-[>[data-slot=field]]:border [&>*]:data-[slot=field]:p-2.5 group/field-label peer/field-label flex w-fit leading-snug", "has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(AT, { "data-slot": "field-label", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, Wj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("gap-2 text-sm font-medium group-data-[disabled=true]/field:opacity-50 flex w-fit items-center leading-snug", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "field-label", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, Gj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("text-muted text-left text-sm [[data-variant=legend]+&]:-mt-1.5 leading-normal font-normal group-has-[[data-orientation=horizontal]]/field:text-balance", "last:mt-0 nth-last-2:-mt-1", "[&>a:hover]:text-link-hover [&>a]:underline [&>a]:underline-offset-4", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("p", { "data-slot": "field-description", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, Kj = (t) => {
  const e = ee.c(14);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    className: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = !!n;
  let i;
  e[4] !== o ? (i = ae("-my-2 h-5 text-sm group-data-[variant=outline]/field-group:-mb-2 relative", o), e[4] = o, e[5] = i) : i = e[5];
  let a;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b.jsx(DT, { className: "absolute inset-0 top-1/2" }), e[6] = a) : a = e[6];
  let l;
  e[7] !== n ? (l = n && /* @__PURE__ */ b.jsx("span", { className: "text-muted px-2 bg-canvas relative mx-auto block w-fit", "data-slot": "field-separator-content", children: n }), e[7] = n, e[8] = l) : l = e[8];
  let c;
  return e[9] !== r || e[10] !== s || e[11] !== i || e[12] !== l ? (c = /* @__PURE__ */ b.jsxs("div", { "data-slot": "field-separator", "data-content": s, className: i, ...r, children: [
    a,
    l
  ] }), e[9] = r, e[10] = s, e[11] = i, e[12] = l, e[13] = c) : c = e[13], c;
}, Yj = (t) => {
  const e = ee.c(15);
  let n, o, r, s;
  e[0] !== t ? ({
    className: o,
    children: n,
    errors: r,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  let i;
  e: {
    if (n) {
      i = n;
      break e;
    }
    if (!r?.length) {
      i = null;
      break e;
    }
    let u;
    e[5] !== r ? (u = [...new Map(r.map(LT)).values()], e[5] = r, e[6] = u) : u = e[6];
    const d = u;
    if (d?.length == 1) {
      i = d[0]?.message;
      break e;
    }
    let p;
    e[7] !== d ? (p = /* @__PURE__ */ b.jsx("ul", { className: "ml-4 flex list-disc flex-col gap-1", children: d.map($T) }), e[7] = d, e[8] = p) : p = e[8], i = p;
  }
  const a = i;
  if (!a)
    return null;
  let l;
  e[9] !== o ? (l = ae("text-feedback-danger text-sm font-normal", o), e[9] = o, e[10] = l) : l = e[10];
  let c;
  return e[11] !== a || e[12] !== s || e[13] !== l ? (c = /* @__PURE__ */ b.jsx("div", { role: "alert", "data-slot": "field-error", className: l, ...s, children: a }), e[11] = a, e[12] = s, e[13] = l, e[14] = c) : c = e[14], c;
};
function LT(t) {
  return [t?.message, t];
}
function $T(t, e) {
  return t?.message && /* @__PURE__ */ b.jsx("li", { children: t.message }, e);
}
const Tu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Tu.displayName = "PopoverRootContext");
function Mr(t) {
  const e = f.useContext(Tu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>." : We(47));
  return e;
}
function FT() {
  return {
    ...da(),
    disabled: !1,
    modal: !1,
    instantType: void 0,
    openMethod: null,
    openChangeReason: null,
    titleElementId: void 0,
    descriptionElementId: void 0,
    stickIfOpen: !0,
    nested: !1,
    openOnHover: !1,
    closeDelay: 0,
    hasViewport: !1
  };
}
const VT = {
  ...fa,
  disabled: be((t) => t.disabled),
  instantType: be((t) => t.instantType),
  openMethod: be((t) => t.openMethod),
  openChangeReason: be((t) => t.openChangeReason),
  modal: be((t) => t.modal),
  stickIfOpen: be((t) => t.stickIfOpen),
  titleElementId: be((t) => t.titleElementId),
  descriptionElementId: be((t) => t.descriptionElementId),
  openOnHover: be((t) => t.openOnHover),
  closeDelay: be((t) => t.closeDelay),
  hasViewport: be((t) => t.hasViewport)
};
class Iu extends vs {
  constructor(n) {
    const o = {
      ...FT(),
      ...n
    };
    o.open && n?.mounted === void 0 && (o.mounted = !0);
    super(o, {
      popupRef: /* @__PURE__ */ f.createRef(),
      backdropRef: /* @__PURE__ */ f.createRef(),
      internalBackdropRef: /* @__PURE__ */ f.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerFocusTargetRef: /* @__PURE__ */ f.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ f.createRef(),
      stickIfOpenTimeout: new Un(),
      triggerElements: new _r()
    }, VT);
    Re(this, "setOpen", (n, o) => {
      const r = o.reason === Et, s = o.reason === ln && o.event.detail === 0, i = !n && (o.reason === us || o.reason == null);
      if (o.preventUnmountOnClose = () => {
        this.set("preventUnmountingOnClose", !0);
      }, this.context.onOpenChange?.(n, o), o.isCanceled)
        return;
      const a = {
        open: n,
        nativeEvent: o.event,
        reason: o.reason,
        nested: this.state.nested,
        triggerElement: o.trigger
      };
      this.state.floatingRootContext.context.events?.emit("openchange", a);
      const c = () => {
        const u = {
          open: n,
          openChangeReason: o.reason
        }, d = o.trigger?.id ?? null;
        (d || n) && (u.activeTriggerId = d, u.activeTriggerElement = o.trigger ?? null), this.update(u);
      };
      r ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(Up, () => {
        this.set("stickIfOpen", !1);
      }), Vt.flushSync(c)) : c(), s || i ? this.set("instantType", s ? "click" : "dismiss") : o.reason === In ? this.set("instantType", "focus") : this.set("instantType", void 0);
    });
    Re(this, "disposeEffect", () => this.context.stickIfOpenTimeout.disposeEffect());
  }
  static useStore(n, o) {
    const r = jt(() => new Iu(o)).current, s = n ?? r;
    return xr(r.disposeEffect), s;
  }
}
function rp({
  props: t
}) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: s,
    modal: i = !1,
    handle: a,
    triggerId: l,
    defaultTriggerId: c = null
  } = t, u = Iu.useStore(a?.store, {
    open: n ?? o,
    modal: i,
    activeTriggerId: l !== void 0 ? l : c
  });
  u.useControlledProp("open", n, o), u.useControlledProp("activeTriggerId", l, c);
  const d = u.useState("open"), p = u.useState("positionerElement"), m = u.useState("payload"), h = u.useState("openChangeReason");
  u.useContextCallback("onOpenChange", r), u.useContextCallback("onOpenChangeComplete", s);
  const {
    openMethod: g,
    triggerProps: y,
    reset: v
  } = ba(d);
  ca(u);
  const {
    forceUnmount: x
  } = ua(d, u, () => {
    u.update({
      stickIfOpen: !0,
      openChangeReason: null
    }), v();
  });
  sa(d && i === !0 && h !== Et && g !== "touch", p), f.useEffect(() => {
    d || u.context.stickIfOpenTimeout.clear();
  }, [u, d]);
  const w = f.useCallback((M) => {
    const A = ke(M);
    return A.preventUnmountOnClose = () => {
      u.set("preventUnmountingOnClose", !0);
    }, A;
  }, [u]), E = f.useCallback(() => {
    u.setOpen(!1, w(qi));
  }, [u, w]);
  f.useImperativeHandle(t.actionsRef, () => ({
    unmount: x,
    close: E
  }), [x, E]);
  const S = pa({
    popupStore: u,
    onOpenChange: u.setOpen
  }), C = bs(S, {
    outsidePressEvent: {
      // Ensure `aria-hidden` on outside elements is removed immediately
      // on outside press when trapping focus.
      mouse: i === "trap-focus" ? "sloppy" : "intentional",
      touch: "sloppy"
    }
  }), _ = Qc(S), {
    getReferenceProps: R,
    getFloatingProps: O,
    getTriggerProps: j
  } = qn([C, _]), F = f.useMemo(() => R(y), [R, y]), N = f.useMemo(() => j(y), [j, y]), T = f.useMemo(() => O(), [O]);
  u.useSyncedValues({
    modal: i,
    openMethod: g,
    activeTriggerProps: F,
    inactiveTriggerProps: N,
    popupProps: T,
    floatingRootContext: S,
    nested: Pn() != null
  });
  const L = f.useMemo(() => ({
    store: u
  }), [u]);
  return /* @__PURE__ */ b.jsx(Tu.Provider, {
    value: L,
    children: typeof e == "function" ? e({
      payload: m
    }) : e
  });
}
function rb(t) {
  return Mr(!0) ? /* @__PURE__ */ b.jsx(rp, {
    props: t
  }) : /* @__PURE__ */ b.jsx(mh, {
    children: /* @__PURE__ */ b.jsx(rp, {
      props: t
    })
  });
}
const zT = 300, Ou = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    handle: a,
    payload: l,
    openOnHover: c = !1,
    delay: u = zT,
    closeDelay: d = 0,
    id: p,
    ...m
  } = e, h = Mr(!0), g = a?.store ?? h?.store;
  if (!g)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle." : We(74));
  const y = lt(p), v = g.useState("isTriggerActive", y), x = g.useState("floatingRootContext"), w = g.useState("isOpenedByTrigger", y), E = f.useRef(null), {
    registerTrigger: S,
    isMountedByThisTrigger: C
  } = la(y, E, g, {
    payload: l,
    disabled: s,
    openOnHover: c,
    closeDelay: d
  }), _ = g.useState("openChangeReason"), R = g.useState("stickIfOpen"), O = g.useState("openMethod"), j = ma(x, {
    enabled: x != null && c && (O !== "touch" || _ !== ln),
    mouseOnly: !0,
    move: !1,
    handleClose: ga(),
    restMs: u,
    delay: {
      close: d
    },
    triggerElementRef: E,
    isActiveTrigger: v
  }), F = gs(x, {
    enabled: x != null,
    stickIfOpen: R
  }), N = qn([F]), T = g.useState("triggerProps", C), L = f.useMemo(() => ({
    disabled: s,
    open: w
  }), [s, w]), {
    getButtonProps: M,
    buttonRef: A
  } = Wt({
    disabled: s,
    native: i
  }), $ = f.useMemo(() => ({
    open(V) {
      return V && _ === ln ? Mi.open(V) : ys.open(V);
    }
  }), [_]), k = _e("button", e, {
    state: L,
    ref: [A, n, S, E],
    props: [N.getReferenceProps(), j, T, {
      [Sc]: "",
      id: y
    }, m, M],
    stateAttributesMapping: $
  }), H = f.useRef(null), B = fe((V) => {
    Vt.flushSync(() => {
      g.setOpen(!1, ke(In, V.nativeEvent, V.currentTarget));
    }), Om(H.current)?.focus();
  }), P = fe((V) => {
    const I = g.select("positionerElement");
    if (I && To(V, I))
      g.context.beforeContentFocusGuardRef.current?.focus();
    else {
      Vt.flushSync(() => {
        g.setOpen(!1, ke(In, V.nativeEvent, V.currentTarget));
      });
      let D = Im(g.context.triggerFocusTargetRef.current || E.current);
      for (; D !== null && Ue(I, D); ) {
        const z = D;
        if (D = na(D), D === z)
          break;
      }
      D?.focus();
    }
  });
  return v ? /* @__PURE__ */ b.jsxs(f.Fragment, {
    children: [/* @__PURE__ */ b.jsx(Gn, {
      ref: H,
      onFocus: B
    }), /* @__PURE__ */ b.jsx(f.Fragment, {
      children: k
    }, y), /* @__PURE__ */ b.jsx(Gn, {
      ref: g.context.triggerFocusTargetRef,
      onFocus: P
    })]
  }) : /* @__PURE__ */ b.jsx(f.Fragment, {
    children: k
  }, y);
});
process.env.NODE_ENV !== "production" && (Ou.displayName = "PopoverTrigger");
const Mu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Mu.displayName = "PopoverPortalContext");
function BT() {
  const t = f.useContext(Mu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Portal> is missing." : We(45));
  return t;
}
const Pu = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: s
  } = Mr();
  return s.useState("mounted") || o ? /* @__PURE__ */ b.jsx(Mu.Provider, {
    value: o,
    children: /* @__PURE__ */ b.jsx(hs, {
      ref: n,
      ...r,
      renderGuards: !1
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Pu.displayName = "PopoverPortal");
const Au = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Au.displayName = "PopoverPositionerContext");
function HT() {
  const t = f.useContext(Au);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>." : We(46));
  return t;
}
const Du = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: s,
    positionMethod: i = "absolute",
    side: a = "bottom",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: p = 5,
    arrowPadding: m = 5,
    sticky: h = !1,
    disableAnchorTracking: g = !1,
    collisionAvoidance: y = Ec,
    ...v
  } = e, {
    store: x
  } = Mr(), w = BT(), E = Wc(), S = x.useState("floatingRootContext"), C = x.useState("mounted"), _ = x.useState("open"), R = x.useState("openChangeReason"), O = x.useState("activeTriggerElement"), j = x.useState("modal"), F = x.useState("positionerElement"), N = x.useState("instantType"), T = x.useState("transitionStatus"), L = x.useState("hasViewport"), M = f.useRef(null), A = Cc(F, !1, !1), $ = Aa({
    anchor: s,
    floatingRootContext: S,
    positionMethod: i,
    mounted: C,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    arrowPadding: m,
    collisionBoundary: d,
    collisionPadding: p,
    sticky: h,
    disableAnchorTracking: g,
    keepMounted: w,
    nodeId: E,
    collisionAvoidance: y,
    adaptiveOrigin: L ? Gg : void 0
  }), k = f.useMemo(() => {
    const D = {};
    return _ || (D.pointerEvents = "none"), {
      role: "presentation",
      hidden: !C,
      style: {
        ...$.positionerStyles,
        ...D
      }
    };
  }, [_, C, $.positionerStyles]), H = f.useMemo(() => ({
    props: k,
    ...$
  }), [k, $]), B = S?.select("domReferenceElement");
  he(() => {
    const D = B, z = M.current;
    if (D && (M.current = D), z && D && D !== z) {
      x.set("instantType", void 0);
      const U = new AbortController();
      return A(() => {
        x.set("instantType", "trigger-change");
      }, U.signal), () => {
        U.abort();
      };
    }
  }, [B, A, x]);
  const P = f.useMemo(() => ({
    open: _,
    side: H.side,
    align: H.align,
    anchorHidden: H.anchorHidden,
    instant: N
  }), [_, H.side, H.align, H.anchorHidden, N]), V = f.useCallback((D) => {
    x.set("positionerElement", D);
  }, [x]), I = _e("div", e, {
    state: P,
    props: [H.props, Or(T), v],
    ref: [n, V],
    stateAttributesMapping: bn
  });
  return /* @__PURE__ */ b.jsxs(Au.Provider, {
    value: H,
    children: [C && j === !0 && R !== Et && /* @__PURE__ */ b.jsx(xs, {
      ref: x.context.internalBackdropRef,
      inert: Sa(!_),
      cutout: O
    }), /* @__PURE__ */ b.jsx(ph, {
      id: E,
      children: I
    })]
  });
});
process.env.NODE_ENV !== "production" && (Du.displayName = "PopoverPositioner");
const UT = {
  ...bn,
  ...tn
}, ju = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    initialFocus: s,
    finalFocus: i,
    ...a
  } = e, {
    store: l
  } = Mr(), c = HT(), u = wu() != null, d = l.useState("open"), p = l.useState("openMethod"), m = l.useState("instantType"), h = l.useState("transitionStatus"), g = l.useState("popupProps"), y = l.useState("titleElementId"), v = l.useState("descriptionElementId"), x = l.useState("modal"), w = l.useState("mounted"), E = l.useState("openChangeReason"), S = l.useState("activeTriggerElement"), C = l.useState("floatingRootContext");
  Gt({
    open: d,
    ref: l.context.popupRef,
    onComplete() {
      d && l.context.onOpenChangeComplete?.(!0);
    }
  });
  const _ = l.useState("disabled"), R = l.useState("openOnHover"), O = l.useState("closeDelay");
  Jc(C, {
    enabled: R && !_,
    closeDelay: O
  });
  function j(M) {
    return M === "touch" ? l.context.popupRef.current : !0;
  }
  const F = s === void 0 ? j : s, N = f.useMemo(() => ({
    open: d,
    side: c.side,
    align: c.align,
    instant: m,
    transitionStatus: h
  }), [d, c.side, c.align, m, h]), T = f.useCallback((M) => {
    l.set("popupElement", M);
  }, [l]), L = _e("div", e, {
    state: N,
    ref: [n, l.context.popupRef, T],
    props: [g, {
      "aria-labelledby": y,
      "aria-describedby": v,
      onKeyDown(M) {
        u && ps.has(M.key) && M.stopPropagation();
      }
    }, Or(h), a],
    stateAttributesMapping: UT
  });
  return /* @__PURE__ */ b.jsx(ia, {
    context: C,
    openInteractionType: p,
    modal: x === "trap-focus",
    disabled: !w || E === Et,
    initialFocus: F,
    returnFocus: i,
    restoreFocus: "popup",
    previousFocusableElement: ut(S) ? S : void 0,
    nextFocusableElement: l.context.triggerFocusTargetRef,
    beforeContentFocusGuardRef: l.context.beforeContentFocusGuardRef,
    children: L
  });
});
process.env.NODE_ENV !== "production" && (ju.displayName = "PopoverPopup");
const sb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: s = !1,
    nativeButton: i = !0,
    ...a
  } = e, {
    buttonRef: l,
    getButtonProps: c
  } = Wt({
    disabled: s,
    focusableWhenDisabled: !1,
    native: i
  }), {
    store: u
  } = Mr();
  return _e("button", e, {
    ref: [n, l],
    props: [{
      onClick(p) {
        u.setOpen(!1, ke(Gp, p.nativeEvent, p.currentTarget));
      }
    }, a, c]
  });
});
process.env.NODE_ENV !== "production" && (sb.displayName = "PopoverClose");
const WT = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21l-4.3-4.3"/></g>'
}, GT = WT, KT = "_trigger_1xdwm_1", YT = "_triggerValue_1xdwm_60", qT = "_triggerPlaceholder_1xdwm_68", XT = "_icon_1xdwm_75", ZT = "_widthSm_1xdwm_83", JT = "_widthMd_1xdwm_88", QT = "_widthLg_1xdwm_93", eI = "_widthFull_1xdwm_98", tI = "_positioner_1xdwm_103", nI = "_popup_1xdwm_109", oI = "_search_1xdwm_147", rI = "_optionList_1xdwm_151", sI = "_option_1xdwm_151", iI = "_optionSelected_1xdwm_176", aI = "_optionDisabled_1xdwm_184", lI = "_optionCheckbox_1xdwm_192", cI = "_optionText_1xdwm_193", uI = "_empty_1xdwm_216", dI = "_footer_1xdwm_224", fI = "_footerStatus_1xdwm_234", pI = "_footerActions_1xdwm_240", bt = {
  trigger: KT,
  triggerValue: YT,
  triggerPlaceholder: qT,
  icon: XT,
  widthSm: ZT,
  widthMd: JT,
  widthLg: QT,
  widthFull: eI,
  positioner: tI,
  popup: nI,
  search: oI,
  optionList: rI,
  option: sI,
  optionSelected: iI,
  optionDisabled: aI,
  optionCheckbox: lI,
  optionText: cI,
  empty: uI,
  footer: dI,
  footerStatus: fI,
  footerActions: pI
}, mI = {
  full: bt.widthFull,
  lg: bt.widthLg,
  md: bt.widthMd,
  sm: bt.widthSm
}, qj = (t) => {
  const e = ee.c(97), {
    "aria-describedby": n,
    "aria-invalid": o,
    className: r,
    clearLabel: s,
    defaultOpen: i,
    disabled: a,
    emptyFilterLabel: l,
    id: c,
    label: u,
    maxSummaryItems: d,
    onOpenChange: p,
    onValueChange: m,
    options: h,
    placeholder: g,
    searchPlaceholder: y,
    selectAllLabel: v,
    value: x,
    width: w
  } = t, E = s === void 0 ? "Clear" : s, S = l === void 0 ? "No matches." : l, C = d === void 0 ? 2 : d, _ = g === void 0 ? "Select…" : g, R = y === void 0 ? "Filter…" : y, O = v === void 0 ? "Select all" : v, j = w === void 0 ? "md" : w, [F, N] = f.useState(!!i), [T, L] = f.useState(""), M = f.useId();
  let A;
  e[0] !== x ? (A = new Set(x), e[0] = x, e[1] = A) : A = e[1];
  const $ = A;
  let k;
  e[2] !== h || e[3] !== T ? (k = hI(h, T), e[2] = h, e[3] = T, e[4] = k) : k = e[4];
  const H = k, B = typeof j == "number" ? void 0 : mI[j];
  let P;
  e[5] !== j ? (P = typeof j == "number" ? {
    maxWidth: "100%",
    width: `${j}px`
  } : void 0, e[5] = j, e[6] = P) : P = e[6];
  const V = P;
  let I;
  e[7] !== m || e[8] !== h ? (I = (Ne) => m(gI(Ne, h)), e[7] = m, e[8] = h, e[9] = I) : I = e[9];
  const D = I;
  let z;
  e[10] !== D || e[11] !== $ || e[12] !== x ? (z = (Ne) => D($.has(Ne) ? x.filter((De) => De !== Ne) : [...x, Ne]), e[10] = D, e[11] = $, e[12] = x, e[13] = z) : z = e[13];
  const U = z;
  let G;
  e[14] !== D || e[15] !== x || e[16] !== H ? (G = () => D([...x, ...H.filter(vI).map(yI)]), e[14] = D, e[15] = x, e[16] = H, e[17] = G) : G = e[17];
  const J = G;
  let se;
  e[18] !== D || e[19] !== m || e[20] !== T.length || e[21] !== x || e[22] !== H ? (se = () => {
    if (T.length === 0)
      return m([]);
    const Ne = new Set(H.filter(xI).map(wI));
    D(x.filter((De) => !Ne.has(De)));
  }, e[18] = D, e[19] = m, e[20] = T.length, e[21] = x, e[22] = H, e[23] = se) : se = e[23];
  const Q = se;
  let ce;
  e[24] !== p ? (ce = (Ne) => {
    N(Ne), Ne || L(""), p?.(Ne);
  }, e[24] = p, e[25] = ce) : ce = e[25];
  const W = o || void 0;
  let oe;
  e[26] !== r || e[27] !== B ? (oe = ae(bt.trigger, B, r), e[26] = r, e[27] = B, e[28] = oe) : oe = e[28];
  const Y = x.length === 0 && bt.triggerPlaceholder;
  let Z;
  e[29] !== Y ? (Z = ae(bt.triggerValue, Y), e[29] = Y, e[30] = Z) : Z = e[30];
  let K;
  e[31] !== C || e[32] !== h || e[33] !== _ || e[34] !== x ? (K = bI(x, h, C, _), e[31] = C, e[32] = h, e[33] = _, e[34] = x, e[35] = K) : K = e[35];
  let X;
  e[36] !== Z || e[37] !== K ? (X = /* @__PURE__ */ b.jsx("span", { className: Z, children: K }), e[36] = Z, e[37] = K, e[38] = X) : X = e[38];
  let ne;
  e[39] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ne = /* @__PURE__ */ b.jsx(Ve, { "aria-hidden": !0, className: bt.icon, icon: Vo }), e[39] = ne) : ne = e[39];
  let re;
  e[40] !== n || e[41] !== a || e[42] !== c || e[43] !== V || e[44] !== W || e[45] !== oe || e[46] !== X ? (re = /* @__PURE__ */ b.jsxs(Ou, { "aria-describedby": n, "aria-invalid": W, className: oe, disabled: a, id: c, style: V, children: [
    X,
    ne
  ] }), e[40] = n, e[41] = a, e[42] = c, e[43] = V, e[44] = W, e[45] = oe, e[46] = X, e[47] = re) : re = e[47];
  const ie = i ? !1 : void 0;
  let de, le;
  e[48] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (de = /* @__PURE__ */ b.jsx(Ve, { icon: GT, width: 24, height: 24 }), le = (Ne) => L(Ne.target.value), e[48] = de, e[49] = le) : (de = e[48], le = e[49]);
  let te;
  e[50] !== T || e[51] !== R ? (te = /* @__PURE__ */ b.jsx("div", { className: bt.search, children: /* @__PURE__ */ b.jsx(Tg, { "aria-label": R, leadingIcon: de, onChange: le, placeholder: R, value: T, width: "full" }) }), e[50] = T, e[51] = R, e[52] = te) : te = e[52];
  let pe;
  if (e[53] !== M || e[54] !== $ || e[55] !== U || e[56] !== H) {
    let Ne;
    e[58] !== M || e[59] !== $ || e[60] !== U ? (Ne = (De) => {
      const ze = $.has(De.value), et = `${M}-${De.value}`;
      return /* @__PURE__ */ b.jsxs("div", { className: ae(bt.option, ze && bt.optionSelected, De.disabled && bt.optionDisabled), children: [
        /* @__PURE__ */ b.jsx(Po, { "aria-label": De.label, checked: ze, className: bt.optionCheckbox, disabled: De.disabled, id: et, onCheckedChange: () => U(De.value) }),
        /* @__PURE__ */ b.jsx("label", { className: bt.optionText, htmlFor: et, children: De.label })
      ] }, De.value);
    }, e[58] = M, e[59] = $, e[60] = U, e[61] = Ne) : Ne = e[61], pe = H.map(Ne), e[53] = M, e[54] = $, e[55] = U, e[56] = H, e[57] = pe;
  } else
    pe = e[57];
  let ue;
  e[62] !== S || e[63] !== H.length ? (ue = H.length === 0 ? /* @__PURE__ */ b.jsx("p", { className: bt.empty, children: S }) : null, e[62] = S, e[63] = H.length, e[64] = ue) : ue = e[64];
  let ye;
  e[65] !== u || e[66] !== M || e[67] !== pe || e[68] !== ue ? (ye = /* @__PURE__ */ b.jsxs("div", { "aria-label": u, className: bt.optionList, id: M, role: "group", children: [
    pe,
    ue
  ] }), e[65] = u, e[66] = M, e[67] = pe, e[68] = ue, e[69] = ye) : ye = e[69];
  const ge = `${x.length} of ${h.length} selected`;
  let Te;
  e[70] !== ge ? (Te = /* @__PURE__ */ b.jsx("span", { className: bt.footerStatus, children: ge }), e[70] = ge, e[71] = Te) : Te = e[71];
  const Se = H.length === 0;
  let xe;
  e[72] !== O || e[73] !== J || e[74] !== Se ? (xe = /* @__PURE__ */ b.jsx(kt, { disabled: Se, onClick: J, size: "xs", variant: "outline", children: O }), e[72] = O, e[73] = J, e[74] = Se, e[75] = xe) : xe = e[75];
  const je = x.length === 0;
  let Me;
  e[76] !== E || e[77] !== Q || e[78] !== je ? (Me = /* @__PURE__ */ b.jsx(kt, { disabled: je, onClick: Q, size: "xs", variant: "outline", children: E }), e[76] = E, e[77] = Q, e[78] = je, e[79] = Me) : Me = e[79];
  let Pe;
  e[80] !== xe || e[81] !== Me ? (Pe = /* @__PURE__ */ b.jsxs("div", { className: bt.footerActions, children: [
    xe,
    Me
  ] }), e[80] = xe, e[81] = Me, e[82] = Pe) : Pe = e[82];
  let we;
  e[83] !== Te || e[84] !== Pe ? (we = /* @__PURE__ */ b.jsxs("div", { className: bt.footer, children: [
    Te,
    Pe
  ] }), e[83] = Te, e[84] = Pe, e[85] = we) : we = e[85];
  let ve;
  e[86] !== u || e[87] !== ie || e[88] !== te || e[89] !== ye || e[90] !== we ? (ve = /* @__PURE__ */ b.jsx(Pu, { children: /* @__PURE__ */ b.jsx(Du, { align: "start", className: bt.positioner, side: "bottom", sideOffset: 4, children: /* @__PURE__ */ b.jsxs(ju, { "aria-label": u, className: bt.popup, initialFocus: ie, children: [
    te,
    ye,
    we
  ] }) }) }), e[86] = u, e[87] = ie, e[88] = te, e[89] = ye, e[90] = we, e[91] = ve) : ve = e[91];
  let Ae;
  return e[92] !== F || e[93] !== ce || e[94] !== re || e[95] !== ve ? (Ae = /* @__PURE__ */ b.jsxs(rb, { open: F, onOpenChange: ce, children: [
    re,
    ve
  ] }), e[92] = F, e[93] = ce, e[94] = re, e[95] = ve, e[96] = Ae) : Ae = e[96], Ae;
}, hI = (t, e) => {
  const n = e.trim().toLowerCase();
  return n.length === 0 ? t : t.filter((o) => o.label.toLowerCase().includes(n) || o.value.toLowerCase().includes(n));
}, gI = (t, e) => {
  const n = new Set(t), o = new Set(e.map((r) => r.value));
  return [...e.filter((r) => n.has(r.value)).map((r) => r.value), ...t.filter((r, s) => !o.has(r) && t.indexOf(r) === s)];
}, bI = (t, e, n, o) => {
  if (t.length === 0) return o;
  const r = t.map((s) => e.find((i) => i.value === s)?.label ?? s);
  return r.length <= n ? r.join(", ") : `${r.slice(0, n).join(", ")} +${r.length - n}`;
};
function vI(t) {
  return !t.disabled;
}
function yI(t) {
  return t.value;
}
function xI(t) {
  return !t.disabled;
}
function wI(t) {
  return t.value;
}
const SI = "_trigger_1jzc7_1", EI = "_triggerLabel_1jzc7_30", CI = "_triggerValue_1jzc7_43", _I = "_triggerChevron_1jzc7_54", RI = "_chevronOpen_1jzc7_67", NI = "_chevronClosed_1jzc7_71", kI = "_triggerInvalid_1jzc7_78", TI = "_triggerDisabled_1jzc7_103", II = "_widthSm_1jzc7_114", OI = "_widthMd_1jzc7_119", MI = "_widthLg_1jzc7_124", PI = "_widthFull_1jzc7_129", AI = "_positioner_1jzc7_134", DI = "_popup_1jzc7_140", jI = "_anchorHeader_1jzc7_175", LI = "_anchorHeaderUp_1jzc7_202", $I = "_header_1jzc7_225", FI = "_headerIcon_1jzc7_233", VI = "_headerTitle_1jzc7_239", zI = "_allCard_1jzc7_249", BI = "_allCardActive_1jzc7_271", HI = "_allIndicator_1jzc7_279", UI = "_allIndicatorActive_1jzc7_301", WI = "_allText_1jzc7_309", GI = "_allTitle_1jzc7_316", KI = "_allSubtitle_1jzc7_323", YI = "_divider_1jzc7_329", qI = "_dividerCaption_1jzc7_342", XI = "_optionList_1jzc7_349", ZI = "_optionListLocked_1jzc7_355", JI = "_optionCheckbox_1jzc7_359", QI = "_option_1jzc7_349", eO = "_optionSelected_1jzc7_381", tO = "_optionDisabled_1jzc7_389", nO = "_optionCustom_1jzc7_398", oO = "_optionText_1jzc7_399", rO = "_optionLabel_1jzc7_415", sO = "_optionSubtitle_1jzc7_428", iO = "_footer_1jzc7_441", aO = "_footerStatus_1jzc7_453", lO = "_footerStatusDanger_1jzc7_462", cO = "_footerActions_1jzc7_466", He = {
  trigger: SI,
  triggerLabel: EI,
  triggerValue: CI,
  triggerChevron: _I,
  chevronOpen: RI,
  chevronClosed: NI,
  triggerInvalid: kI,
  triggerDisabled: TI,
  widthSm: II,
  widthMd: OI,
  widthLg: MI,
  widthFull: PI,
  positioner: AI,
  popup: DI,
  anchorHeader: jI,
  anchorHeaderUp: LI,
  header: $I,
  headerIcon: FI,
  headerTitle: VI,
  allCard: zI,
  allCardActive: BI,
  allIndicator: HI,
  allIndicatorActive: UI,
  allText: WI,
  allTitle: GI,
  allSubtitle: KI,
  divider: YI,
  dividerCaption: qI,
  optionList: XI,
  optionListLocked: ZI,
  optionCheckbox: JI,
  option: QI,
  optionSelected: eO,
  optionDisabled: tO,
  optionCustom: nO,
  optionText: oO,
  optionLabel: rO,
  optionSubtitle: sO,
  footer: iO,
  footerStatus: aO,
  footerStatusDanger: lO,
  footerActions: cO
}, uO = {
  full: He.widthFull,
  lg: He.widthLg,
  md: He.widthMd,
  sm: He.widthSm
}, Xj = ({
  align: t = "end",
  allLabel: e = "All",
  allOption: n = !1,
  allSubtitle: o,
  checkAllLabel: r = "Check all",
  className: s,
  defaultOpen: i,
  disabled: a,
  icon: l,
  label: c,
  maxOpenWidth: u = 320,
  noneLabel: d = "None",
  onValueChange: p,
  options: m,
  requireAtLeastOneSelected: h,
  uncheckAllLabel: g = "Uncheck all",
  value: y,
  width: v = "md"
}) => {
  const x = f.useId(), [w, E] = f.useState("bottom"), [S, C] = f.useState({
    height: 0,
    width: 0
  }), _ = f.useCallback((z) => {
    if (!z) return;
    const U = () => C({
      height: z.offsetHeight,
      width: z.offsetWidth
    });
    U();
    const G = new ResizeObserver(U);
    return G.observe(z), () => G.disconnect();
  }, []), R = f.useCallback((z) => {
    if (!z) return;
    const U = () => {
      const J = z.getAttribute("data-side");
      (J === "bottom" || J === "top") && E(J);
    };
    U();
    const G = new MutationObserver(U);
    return G.observe(z, {
      attributeFilter: ["data-side"],
      attributes: !0
    }), () => G.disconnect();
  }, []), O = f.useRef([]);
  Array.isArray(y) && (O.current = y);
  const j = Array.isArray(y) ? y : [], F = y === "all", N = F ? O.current : j, T = !!h && Array.isArray(y) && y.length === 0, L = typeof v == "number" ? void 0 : uO[v], M = typeof v == "number" ? {
    maxWidth: "100%",
    width: `${v}px`
  } : void 0, A = fO(y, m, e, d), $ = dO(y, m, h, O.current.length), k = Math.max(S.width, u), H = t === "start" ? 0 : t === "center" ? (k - S.width) / 2 : k - S.width, B = /* @__PURE__ */ b.jsxs(sb, { "aria-label": c, className: ae(He.anchorHeader, w === "top" && He.anchorHeaderUp), children: [
    /* @__PURE__ */ b.jsx("span", { className: He.triggerLabel, children: c }),
    /* @__PURE__ */ b.jsx("span", { className: He.triggerValue, children: A }),
    /* @__PURE__ */ b.jsx("span", { "aria-hidden": !0, className: He.triggerChevron, children: /* @__PURE__ */ b.jsx(Ve, { icon: ns }) })
  ] }), P = (z) => {
    p(j.includes(z) ? j.filter((U) => U !== z) : [...j, z]);
  }, V = () => {
    p(y === "all" ? O.current : "all");
  }, I = () => {
    const z = m.filter((G) => G.disabled && j.includes(G.value)).map((G) => G.value), U = m.filter((G) => !G.disabled).map((G) => G.value);
    p([...U, ...z]);
  }, D = () => {
    p(m.filter((z) => z.disabled && j.includes(z.value)).map((z) => z.value));
  };
  return /* @__PURE__ */ b.jsxs(rb, { defaultOpen: i, children: [
    /* @__PURE__ */ b.jsxs(Ou, { "aria-invalid": T || void 0, className: ae(He.trigger, L, T && He.triggerInvalid, a && He.triggerDisabled, s), disabled: a, ref: _, style: M, children: [
      /* @__PURE__ */ b.jsx("span", { className: He.triggerLabel, children: c }),
      /* @__PURE__ */ b.jsx("span", { className: He.triggerValue, children: A }),
      /* @__PURE__ */ b.jsxs("span", { "aria-hidden": !0, className: He.triggerChevron, children: [
        /* @__PURE__ */ b.jsx(Ve, { className: He.chevronClosed, icon: Vo }),
        /* @__PURE__ */ b.jsx(Ve, { className: He.chevronOpen, icon: ns })
      ] })
    ] }),
    /* @__PURE__ */ b.jsx(Pu, { children: /* @__PURE__ */ b.jsx(Du, { align: t, className: He.positioner, collisionAvoidance: i ? {
      align: "none",
      fallbackAxisSide: "none",
      side: "none"
    } : void 0, side: "bottom", sideOffset: -S.height, children: /* @__PURE__ */ b.jsxs(ju, { "aria-labelledby": x, className: He.popup, initialFocus: i ? !1 : void 0, ref: R, style: {
      "--panel-shift": `${H}px`,
      "--trigger-height": `${S.height}px`,
      maxWidth: "calc(100vw - 1rem)",
      width: `${k}px`
    }, children: [
      w === "bottom" ? B : null,
      /* @__PURE__ */ b.jsxs("div", { className: He.header, children: [
        l ? /* @__PURE__ */ b.jsx(Ve, { "aria-hidden": !0, className: He.headerIcon, icon: l }) : null,
        /* @__PURE__ */ b.jsx("span", { className: He.headerTitle, id: x, children: c })
      ] }),
      n ? /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
        /* @__PURE__ */ b.jsxs("button", { "aria-pressed": y === "all", className: ae(He.allCard, y === "all" && He.allCardActive), onClick: V, type: "button", children: [
          /* @__PURE__ */ b.jsx("span", { "aria-hidden": !0, className: ae(He.allIndicator, y === "all" && He.allIndicatorActive), children: y === "all" ? /* @__PURE__ */ b.jsx(Ve, { icon: Tr }) : null }),
          /* @__PURE__ */ b.jsxs("span", { className: He.allText, children: [
            /* @__PURE__ */ b.jsx("span", { className: He.allTitle, children: e }),
            o ? /* @__PURE__ */ b.jsx("span", { className: He.allSubtitle, children: o }) : null
          ] })
        ] }),
        /* @__PURE__ */ b.jsx("div", { "aria-hidden": !0, className: He.divider, children: /* @__PURE__ */ b.jsx("span", { className: He.dividerCaption, children: "OR SELECT" }) })
      ] }) : null,
      /* @__PURE__ */ b.jsx("div", { className: ae(He.optionList, F && He.optionListLocked), children: m.map((z) => {
        const U = N.includes(z.value), G = `${x}-${z.value}`;
        return /* @__PURE__ */ b.jsxs("div", { className: ae(He.option, U && He.optionSelected, z.disabled && He.optionDisabled), children: [
          /* @__PURE__ */ b.jsx(Po, { "aria-label": "label" in z ? z.label : z.value, checked: U, className: He.optionCheckbox, disabled: z.disabled || F, id: G, onCheckedChange: () => P(z.value) }),
          "content" in z ? /* @__PURE__ */ b.jsx("label", { className: He.optionCustom, htmlFor: G, children: z.content }) : /* @__PURE__ */ b.jsxs("label", { className: He.optionText, htmlFor: G, children: [
            /* @__PURE__ */ b.jsx("span", { className: He.optionLabel, children: z.label }),
            z.subtitle ? /* @__PURE__ */ b.jsx("span", { className: He.optionSubtitle, children: z.subtitle }) : null
          ] })
        ] }, z.value);
      }) }),
      /* @__PURE__ */ b.jsxs("div", { className: He.footer, children: [
        /* @__PURE__ */ b.jsx("span", { className: ae(He.footerStatus, T && He.footerStatusDanger), children: $ }),
        /* @__PURE__ */ b.jsxs("div", { className: He.footerActions, children: [
          /* @__PURE__ */ b.jsx(kt, { onClick: I, size: "xs", variant: "outline", children: r }),
          /* @__PURE__ */ b.jsx(kt, { onClick: D, size: "xs", variant: "outline", children: g })
        ] })
      ] }),
      w === "top" ? B : null
    ] }) }) })
  ] });
}, dO = (t, e, n, o) => t === "all" ? o > 0 ? `Filter off — ${o} kept` : "Filter off — showing all" : n && t.length === 0 ? "Pick at least one option" : `${t.length} of ${e.length} selected`, fO = (t, e, n, o) => {
  if (t === "all") return n;
  if (t.length === 0) return o;
  if (t.length === 1) {
    const r = e.find((s) => s.value === t[0]);
    return r && "label" in r ? r.label : t[0];
  }
  return `${t.length} selected`;
}, pO = "_frame_1tprt_1", mO = "_label_1tprt_22", hO = "_pillRow_1tprt_34", gO = "_pill_1tprt_34", bO = "_pillLabel_1tprt_75", vO = "_pillSelected_1tprt_79", yO = "_frameDisabled_1tprt_86", xO = "_frameInvalid_1tprt_98", eo = {
  frame: pO,
  label: mO,
  pillRow: hO,
  pill: gO,
  pillLabel: bO,
  pillSelected: vO,
  frameDisabled: yO,
  frameInvalid: xO
}, Zj = (t) => {
  const e = ee.c(39), {
    className: n,
    disabled: o,
    label: r,
    options: s,
    requireAtLeastOneSelected: i
  } = t, a = f.useId();
  let l;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = [], e[0] = l) : l = e[0];
  const c = f.useRef(l);
  let u, d, p, m, h, g, y;
  if (e[1] !== n || e[2] !== o || e[3] !== r || e[4] !== a || e[5] !== s || e[6] !== t || e[7] !== i) {
    const w = t.multiple ? t.value : t.value === null ? [] : [t.value], E = !!i && w.length === 0;
    let S;
    e[15] !== s || e[16] !== t.multiple || e[17] !== t.value ? (S = t.multiple ? -1 : (() => {
      const N = s.findIndex((T) => !T.disabled && T.value === t.value);
      return N === -1 ? s.findIndex(wO) : N;
    })(), e[15] = s, e[16] = t.multiple, e[17] = t.value, e[18] = S) : S = e[18];
    const C = S;
    let _;
    e[19] !== o || e[20] !== t ? (_ = (N) => {
      if (!(o || N.disabled)) {
        if (t.multiple) {
          t.onValueChange(t.value.includes(N.value) ? t.value.filter((T) => T !== N.value) : [...t.value, N.value]);
          return;
        }
        t.value !== N.value && t.onValueChange(N.value);
      }
    }, e[19] = o, e[20] = t, e[21] = _) : _ = e[21];
    const R = _, O = (N, T) => {
      if (t.multiple)
        return;
      const L = s.map(SO).filter(EO);
      if (L.length === 0)
        return;
      if (N.key === " " || N.key === "Enter") {
        N.preventDefault(), R(s[T]);
        return;
      }
      const M = L.indexOf(T);
      let A;
      if (N.key === "ArrowRight" || N.key === "ArrowDown")
        A = L[(M + 1) % L.length];
      else if (N.key === "ArrowLeft" || N.key === "ArrowUp")
        A = L[(M - 1 + L.length) % L.length];
      else if (N.key === "Home")
        A = L[0];
      else if (N.key === "End")
        A = L[L.length - 1];
      else
        return;
      N.preventDefault(), c.current[A]?.focus(), R(s[A]);
    };
    p = E || void 0, m = a;
    const j = o && eo.frameDisabled, F = E && eo.frameInvalid;
    e[22] !== n || e[23] !== j || e[24] !== F ? (h = ae(eo.frame, j, F, n), e[22] = n, e[23] = j, e[24] = F, e[25] = h) : h = e[25], g = t.multiple ? "group" : "radiogroup", e[26] !== r || e[27] !== a ? (y = /* @__PURE__ */ b.jsx("span", { className: eo.label, id: a, children: r }), e[26] = r, e[27] = a, e[28] = y) : y = e[28], u = eo.pillRow, d = s.map((N, T) => {
      const L = w.includes(N.value), M = !!o || !!N.disabled;
      return /* @__PURE__ */ b.jsx("button", { "aria-checked": t.multiple ? void 0 : L, "aria-pressed": t.multiple ? L : void 0, className: ae(eo.pill, L && eo.pillSelected), "data-label": N.label, disabled: M, onClick: () => R(N), onKeyDown: (A) => O(A, T), ref: (A) => {
        c.current[T] = A;
      }, role: t.multiple ? void 0 : "radio", tabIndex: t.multiple ? void 0 : T === C ? 0 : -1, type: "button", children: /* @__PURE__ */ b.jsx("span", { className: eo.pillLabel, children: N.label }) }, N.value);
    }), e[1] = n, e[2] = o, e[3] = r, e[4] = a, e[5] = s, e[6] = t, e[7] = i, e[8] = u, e[9] = d, e[10] = p, e[11] = m, e[12] = h, e[13] = g, e[14] = y;
  } else
    u = e[8], d = e[9], p = e[10], m = e[11], h = e[12], g = e[13], y = e[14];
  let v;
  e[29] !== u || e[30] !== d ? (v = /* @__PURE__ */ b.jsx("div", { className: u, children: d }), e[29] = u, e[30] = d, e[31] = v) : v = e[31];
  let x;
  return e[32] !== p || e[33] !== m || e[34] !== h || e[35] !== g || e[36] !== y || e[37] !== v ? (x = /* @__PURE__ */ b.jsxs("div", { "aria-invalid": p, "aria-labelledby": m, className: h, role: g, children: [
    y,
    v
  ] }), e[32] = p, e[33] = m, e[34] = h, e[35] = g, e[36] = y, e[37] = v, e[38] = x) : x = e[38], x;
};
function wO(t) {
  return !t.disabled;
}
function SO(t, e) {
  return t.disabled ? -1 : e;
}
function EO(t) {
  return t !== -1;
}
var CO = Object.defineProperty, _O = Object.defineProperties, RO = Object.getOwnPropertyDescriptors, Fi = Object.getOwnPropertySymbols, ib = Object.prototype.hasOwnProperty, ab = Object.prototype.propertyIsEnumerable, sp = (t, e, n) => e in t ? CO(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, NO = (t, e) => {
  for (var n in e || (e = {})) ib.call(e, n) && sp(t, n, e[n]);
  if (Fi) for (var n of Fi(e)) ab.call(e, n) && sp(t, n, e[n]);
  return t;
}, kO = (t, e) => _O(t, RO(e)), TO = (t, e) => {
  var n = {};
  for (var o in t) ib.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
  if (t != null && Fi) for (var o of Fi(t)) e.indexOf(o) < 0 && ab.call(t, o) && (n[o] = t[o]);
  return n;
};
function IO(t) {
  let e = setTimeout(t, 0), n = setTimeout(t, 10), o = setTimeout(t, 50);
  return [e, n, o];
}
function OO(t) {
  let e = f.useRef();
  return f.useEffect(() => {
    e.current = t;
  }), e.current;
}
var MO = 18, lb = 40, PO = `${lb}px`, AO = ["[data-lastpass-icon-root]", "com-1password-button", "[data-dashlanecreated]", '[style$="2147483647 !important;"]'].join(",");
function DO({ containerRef: t, inputRef: e, pushPasswordManagerStrategy: n, isFocused: o }) {
  let [r, s] = f.useState(!1), [i, a] = f.useState(!1), [l, c] = f.useState(!1), u = f.useMemo(() => n === "none" ? !1 : (n === "increase-width" || n === "experimental-no-flickering") && r && i, [r, i, n]), d = f.useCallback(() => {
    let p = t.current, m = e.current;
    if (!p || !m || l || n === "none") return;
    let h = p, g = h.getBoundingClientRect().left + h.offsetWidth, y = h.getBoundingClientRect().top + h.offsetHeight / 2, v = g - MO, x = y;
    document.querySelectorAll(AO).length === 0 && document.elementFromPoint(v, x) === p || (s(!0), c(!0));
  }, [t, e, l, n]);
  return f.useEffect(() => {
    let p = t.current;
    if (!p || n === "none") return;
    function m() {
      let g = window.innerWidth - p.getBoundingClientRect().right;
      a(g >= lb);
    }
    m();
    let h = setInterval(m, 1e3);
    return () => {
      clearInterval(h);
    };
  }, [t, n]), f.useEffect(() => {
    let p = o || document.activeElement === e.current;
    if (n === "none" || !p) return;
    let m = setTimeout(d, 0), h = setTimeout(d, 2e3), g = setTimeout(d, 5e3), y = setTimeout(() => {
      c(!0);
    }, 6e3);
    return () => {
      clearTimeout(m), clearTimeout(h), clearTimeout(g), clearTimeout(y);
    };
  }, [e, o, n, d]), { hasPWMBadge: r, willPushPWMBadge: u, PWM_BADGE_SPACE_WIDTH: PO };
}
var cb = f.createContext({}), ub = f.forwardRef((t, e) => {
  var n = t, { value: o, onChange: r, maxLength: s, textAlign: i = "left", pattern: a, placeholder: l, inputMode: c = "numeric", onComplete: u, pushPasswordManagerStrategy: d = "increase-width", pasteTransformer: p, containerClassName: m, noScriptCSSFallback: h = jO, render: g, children: y } = n, v = TO(n, ["value", "onChange", "maxLength", "textAlign", "pattern", "placeholder", "inputMode", "onComplete", "pushPasswordManagerStrategy", "pasteTransformer", "containerClassName", "noScriptCSSFallback", "render", "children"]), x, w, E, S, C;
  let [_, R] = f.useState(typeof v.defaultValue == "string" ? v.defaultValue : ""), O = o ?? _, j = OO(O), F = f.useCallback((Y) => {
    r?.(Y), R(Y);
  }, [r]), N = f.useMemo(() => a ? typeof a == "string" ? new RegExp(a) : a : null, [a]), T = f.useRef(null), L = f.useRef(null), M = f.useRef({ value: O, onChange: F, isIOS: typeof window < "u" && ((w = (x = window?.CSS) == null ? void 0 : x.supports) == null ? void 0 : w.call(x, "-webkit-touch-callout", "none")) }), A = f.useRef({ prev: [(E = T.current) == null ? void 0 : E.selectionStart, (S = T.current) == null ? void 0 : S.selectionEnd, (C = T.current) == null ? void 0 : C.selectionDirection] });
  f.useImperativeHandle(e, () => T.current, []), f.useEffect(() => {
    let Y = T.current, Z = L.current;
    if (!Y || !Z) return;
    M.current.value !== Y.value && M.current.onChange(Y.value), A.current.prev = [Y.selectionStart, Y.selectionEnd, Y.selectionDirection];
    function K() {
      if (document.activeElement !== Y) {
        V(null), D(null);
        return;
      }
      let re = Y.selectionStart, ie = Y.selectionEnd, de = Y.selectionDirection, le = Y.maxLength, te = Y.value, pe = A.current.prev, ue = -1, ye = -1, ge;
      if (te.length !== 0 && re !== null && ie !== null) {
        let je = re === ie, Me = re === te.length && te.length < le;
        if (je && !Me) {
          let Pe = re;
          if (Pe === 0) ue = 0, ye = 1, ge = "forward";
          else if (Pe === le) ue = Pe - 1, ye = Pe, ge = "backward";
          else if (le > 1 && te.length > 1) {
            let we = 0;
            if (pe[0] !== null && pe[1] !== null) {
              ge = Pe < pe[1] ? "backward" : "forward";
              let ve = pe[0] === pe[1] && pe[0] < le;
              ge === "backward" && !ve && (we = -1);
            }
            ue = we + Pe, ye = we + Pe + 1;
          }
        }
        ue !== -1 && ye !== -1 && ue !== ye && T.current.setSelectionRange(ue, ye, ge);
      }
      let Te = ue !== -1 ? ue : re, Se = ye !== -1 ? ye : ie, xe = ge ?? de;
      V(Te), D(Se), A.current.prev = [Te, Se, xe];
    }
    if (document.addEventListener("selectionchange", K, { capture: !0 }), K(), document.activeElement === Y && B(!0), !document.getElementById("input-otp-style")) {
      let re = document.createElement("style");
      if (re.id = "input-otp-style", document.head.appendChild(re), re.sheet) {
        let ie = "background: transparent !important; color: transparent !important; border-color: transparent !important; opacity: 0 !important; box-shadow: none !important; -webkit-box-shadow: none !important; -webkit-text-fill-color: transparent !important;";
        zr(re.sheet, "[data-input-otp]::selection { background: transparent !important; color: transparent !important; }"), zr(re.sheet, `[data-input-otp]:autofill { ${ie} }`), zr(re.sheet, `[data-input-otp]:-webkit-autofill { ${ie} }`), zr(re.sheet, "@supports (-webkit-touch-callout: none) { [data-input-otp] { letter-spacing: -.6em !important; font-weight: 100 !important; font-stretch: ultra-condensed; font-optical-sizing: none !important; left: -1px !important; right: 1px !important; } }"), zr(re.sheet, "[data-input-otp] + * { pointer-events: all !important; }");
      }
    }
    let X = () => {
      Z && Z.style.setProperty("--root-height", `${Y.clientHeight}px`);
    };
    X();
    let ne = new ResizeObserver(X);
    return ne.observe(Y), () => {
      document.removeEventListener("selectionchange", K, { capture: !0 }), ne.disconnect();
    };
  }, []);
  let [$, k] = f.useState(!1), [H, B] = f.useState(!1), [P, V] = f.useState(null), [I, D] = f.useState(null);
  f.useEffect(() => {
    IO(() => {
      var Y, Z, K, X;
      (Y = T.current) == null || Y.dispatchEvent(new Event("input"));
      let ne = (Z = T.current) == null ? void 0 : Z.selectionStart, re = (K = T.current) == null ? void 0 : K.selectionEnd, ie = (X = T.current) == null ? void 0 : X.selectionDirection;
      ne !== null && re !== null && (V(ne), D(re), A.current.prev = [ne, re, ie]);
    });
  }, [O, H]), f.useEffect(() => {
    j !== void 0 && O !== j && j.length < s && O.length === s && u?.(O);
  }, [s, u, j, O]);
  let z = DO({ containerRef: L, inputRef: T, pushPasswordManagerStrategy: d, isFocused: H }), U = f.useCallback((Y) => {
    let Z = Y.currentTarget.value.slice(0, s);
    if (Z.length > 0 && N && !N.test(Z)) {
      Y.preventDefault();
      return;
    }
    typeof j == "string" && Z.length < j.length && document.dispatchEvent(new Event("selectionchange")), F(Z);
  }, [s, F, j, N]), G = f.useCallback(() => {
    var Y;
    if (T.current) {
      let Z = Math.min(T.current.value.length, s - 1), K = T.current.value.length;
      (Y = T.current) == null || Y.setSelectionRange(Z, K), V(Z), D(K);
    }
    B(!0);
  }, [s]), J = f.useCallback((Y) => {
    var Z, K;
    let X = T.current;
    if (!p && (!M.current.isIOS || !Y.clipboardData || !X)) return;
    let ne = Y.clipboardData.getData("text/plain"), re = p ? p(ne) : ne;
    Y.preventDefault();
    let ie = (Z = T.current) == null ? void 0 : Z.selectionStart, de = (K = T.current) == null ? void 0 : K.selectionEnd, le = (ie !== de ? O.slice(0, ie) + re + O.slice(de) : O.slice(0, ie) + re + O.slice(ie)).slice(0, s);
    if (le.length > 0 && N && !N.test(le)) return;
    X.value = le, F(le);
    let te = Math.min(le.length, s - 1), pe = le.length;
    X.setSelectionRange(te, pe), V(te), D(pe);
  }, [s, F, N, O]), se = f.useMemo(() => ({ position: "relative", cursor: v.disabled ? "default" : "text", userSelect: "none", WebkitUserSelect: "none", pointerEvents: "none" }), [v.disabled]), Q = f.useMemo(() => ({ position: "absolute", inset: 0, width: z.willPushPWMBadge ? `calc(100% + ${z.PWM_BADGE_SPACE_WIDTH})` : "100%", clipPath: z.willPushPWMBadge ? `inset(0 ${z.PWM_BADGE_SPACE_WIDTH} 0 0)` : void 0, height: "100%", display: "flex", textAlign: i, opacity: "1", color: "transparent", pointerEvents: "all", background: "transparent", caretColor: "transparent", border: "0 solid transparent", outline: "0 solid transparent", boxShadow: "none", lineHeight: "1", letterSpacing: "-.5em", fontSize: "var(--root-height)", fontFamily: "monospace", fontVariantNumeric: "tabular-nums" }), [z.PWM_BADGE_SPACE_WIDTH, z.willPushPWMBadge, i]), ce = f.useMemo(() => f.createElement("input", kO(NO({ autoComplete: v.autoComplete || "one-time-code" }, v), { "data-input-otp": !0, "data-input-otp-placeholder-shown": O.length === 0 || void 0, "data-input-otp-mss": P, "data-input-otp-mse": I, inputMode: c, pattern: N?.source, "aria-placeholder": l, style: Q, maxLength: s, value: O, ref: T, onPaste: (Y) => {
    var Z;
    J(Y), (Z = v.onPaste) == null || Z.call(v, Y);
  }, onChange: U, onMouseOver: (Y) => {
    var Z;
    k(!0), (Z = v.onMouseOver) == null || Z.call(v, Y);
  }, onMouseLeave: (Y) => {
    var Z;
    k(!1), (Z = v.onMouseLeave) == null || Z.call(v, Y);
  }, onFocus: (Y) => {
    var Z;
    G(), (Z = v.onFocus) == null || Z.call(v, Y);
  }, onBlur: (Y) => {
    var Z;
    B(!1), (Z = v.onBlur) == null || Z.call(v, Y);
  } })), [U, G, J, c, Q, s, I, P, v, N?.source, O]), W = f.useMemo(() => ({ slots: Array.from({ length: s }).map((Y, Z) => {
    var K;
    let X = H && P !== null && I !== null && (P === I && Z === P || Z >= P && Z < I), ne = O[Z] !== void 0 ? O[Z] : null, re = O[0] !== void 0 ? null : (K = l?.[Z]) != null ? K : null;
    return { char: ne, placeholderChar: re, isActive: X, hasFakeCaret: X && ne === null };
  }), isFocused: H, isHovering: !v.disabled && $ }), [H, $, s, I, P, v.disabled, O]), oe = f.useMemo(() => g ? g(W) : f.createElement(cb.Provider, { value: W }, y), [y, W, g]);
  return f.createElement(f.Fragment, null, h !== null && f.createElement("noscript", null, f.createElement("style", null, h)), f.createElement("div", { ref: L, "data-input-otp-container": !0, style: se, className: m }, oe, f.createElement("div", { style: { position: "absolute", inset: 0, pointerEvents: "none" } }, ce)));
});
ub.displayName = "Input";
function zr(t, e) {
  try {
    t.insertRule(e);
  } catch {
    console.error("input-otp could not insert CSS rule:", e);
  }
}
var jO = `
[data-input-otp] {
  --nojs-bg: white !important;
  --nojs-fg: black !important;

  background-color: var(--nojs-bg) !important;
  color: var(--nojs-fg) !important;
  caret-color: var(--nojs-fg) !important;
  letter-spacing: .25em !important;
  text-align: center !important;
  border: 1px solid var(--nojs-fg) !important;
  border-radius: 4px !important;
  width: 100% !important;
}
@media (prefers-color-scheme: dark) {
  [data-input-otp] {
    --nojs-bg: black !important;
    --nojs-fg: white !important;
  }
}`;
const Jj = (t) => {
  const e = ee.c(19);
  let n, o, r, s, i, a;
  e[0] !== t ? ({
    className: n,
    containerClassName: o,
    defaultValue: r,
    onChange: s,
    value: a,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6]);
  const [l, c] = f.useState(typeof r == "string" ? r : "");
  let u;
  e[7] !== s ? (u = (y) => {
    c(y), s?.(y);
  }, e[7] = s, e[8] = u) : u = e[8];
  const d = u;
  let p;
  e[9] !== o ? (p = ae("cn-input-otp flex items-center has-disabled:opacity-50", o), e[9] = o, e[10] = p) : p = e[10];
  let m;
  e[11] !== n ? (m = ae("disabled:cursor-not-allowed", n), e[11] = n, e[12] = m) : m = e[12];
  const h = a ?? l;
  let g;
  return e[13] !== d || e[14] !== i || e[15] !== p || e[16] !== m || e[17] !== h ? (g = /* @__PURE__ */ b.jsx(ub, { "data-slot": "input-otp", containerClassName: p, spellCheck: !1, className: m, onChange: d, value: h, ...i }), e[13] = d, e[14] = i, e[15] = p, e[16] = m, e[17] = h, e[18] = g) : g = e[18], g;
}, Qj = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("has-aria-invalid:ring-feedback-danger/20 dark:has-aria-invalid:ring-feedback-danger/40 has-aria-invalid:border-feedback-danger rounded-lg has-aria-invalid:ring-[3px] flex items-center", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("div", { "data-slot": "input-otp-group", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, eL = (t) => {
  const e = ee.c(17);
  let n, o, r;
  e[0] !== t ? ({
    index: o,
    className: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = f.useContext(cb);
  let i;
  e[4] !== o || e[5] !== s?.slots ? (i = s?.slots[o] ?? {}, e[4] = o, e[5] = s?.slots, e[6] = i) : i = e[6];
  const {
    char: a,
    hasFakeCaret: l,
    isActive: c
  } = i;
  let u;
  e[7] !== n ? (u = ae("dark:bg-sunken/30 border-default data-[active=true]:border-ring-focus data-[active=true]:ring-ring-focus/50 data-[active=true]:aria-invalid:ring-feedback-danger/20 dark:data-[active=true]:aria-invalid:ring-feedback-danger/40 aria-invalid:border-feedback-danger data-[active=true]:aria-invalid:border-feedback-danger size-8 border-y border-r text-sm transition-all outline-none first:rounded-l-lg first:border-l last:rounded-r-lg data-[active=true]:ring-[3px] relative flex items-center justify-center data-[active=true]:z-10", n), e[7] = n, e[8] = u) : u = e[8];
  let d;
  e[9] !== l ? (d = l && /* @__PURE__ */ b.jsx("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ b.jsx("div", { className: "animate-caret-blink bg-action-primary h-4 w-px duration-1000" }) }), e[9] = l, e[10] = d) : d = e[10];
  let p;
  return e[11] !== a || e[12] !== c || e[13] !== r || e[14] !== u || e[15] !== d ? (p = /* @__PURE__ */ b.jsxs("div", { "data-slot": "input-otp-slot", "data-active": c, className: u, ...r, children: [
    a,
    d
  ] }), e[11] = a, e[12] = c, e[13] = r, e[14] = u, e[15] = d, e[16] = p) : p = e[16], p;
}, tL = (t) => {
  const e = ee.c(5);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ b.jsx(Ve, { icon: Jh, width: 24, height: 24 }), e[2] = o) : o = e[2];
  let r;
  return e[3] !== n ? (r = /* @__PURE__ */ b.jsx("div", { "data-slot": "input-otp-separator", className: "[&_svg:not([class*='size-'])]:size-4 flex items-center", role: "separator", ...n, children: o }), e[3] = n, e[4] = r) : r = e[4], r;
}, LO = "_wrapper_6xkyh_1", $O = "_select_6xkyh_11", FO = "_icon_6xkyh_65", VO = "_widthSm_6xkyh_76", zO = "_widthMd_6xkyh_81", BO = "_widthLg_6xkyh_86", HO = "_widthFull_6xkyh_91", _o = {
  wrapper: LO,
  select: $O,
  icon: FO,
  widthSm: VO,
  widthMd: zO,
  widthLg: BO,
  widthFull: HO
}, UO = {
  full: _o.widthFull,
  lg: _o.widthLg,
  md: _o.widthMd,
  sm: _o.widthSm
}, nL = (t) => {
  const e = ee.c(22);
  let n, o, r, s;
  e[0] !== t ? ({
    className: n,
    style: r,
    width: s,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = s === void 0 ? "md" : s, a = typeof i == "number" ? void 0 : UO[i];
  let l;
  e[5] !== i ? (l = typeof i == "number" ? {
    maxWidth: "100%",
    width: `${i}px`
  } : void 0, e[5] = i, e[6] = l) : l = e[6];
  const c = l;
  let u;
  e[7] !== c || e[8] !== r ? (u = r || c ? {
    ...r,
    ...c
  } : void 0, e[7] = c, e[8] = r, e[9] = u) : u = e[9];
  const d = u;
  let p;
  e[10] !== a ? (p = ae(_o.wrapper, a), e[10] = a, e[11] = p) : p = e[11];
  let m;
  e[12] !== n ? (m = ae(_o.select, n), e[12] = n, e[13] = m) : m = e[13];
  let h;
  e[14] !== o || e[15] !== m ? (h = /* @__PURE__ */ b.jsx("select", { "data-slot": "native-select", className: m, ...o }), e[14] = o, e[15] = m, e[16] = h) : h = e[16];
  let g;
  e[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ b.jsx(Ve, { icon: Vo, "aria-hidden": "true", className: _o.icon, "data-slot": "native-select-icon" }), e[17] = g) : g = e[17];
  let y;
  return e[18] !== p || e[19] !== h || e[20] !== d ? (y = /* @__PURE__ */ b.jsxs("div", { className: p, "data-slot": "native-select-wrapper", style: d, children: [
    h,
    g
  ] }), e[18] = p, e[19] = h, e[20] = d, e[21] = y) : y = e[21], y;
}, oL = (t) => {
  const e = ee.c(4);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  return e[2] !== n ? (o = /* @__PURE__ */ b.jsx("option", { "data-slot": "native-select-option", ...n }), e[2] = n, e[3] = o) : o = e[3], o;
}, rL = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae(n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx("optgroup", { "data-slot": "native-select-optgroup", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, WO = {
  width: 24,
  height: 24,
  body: '<circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>'
}, GO = WO, sL = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("grid gap-2 w-full", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(ka, { "data-slot": "radio-group", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, iL = (t) => {
  const e = ee.c(9);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("border-default text-action-primary dark:bg-sunken/30 focus-visible:border-ring-focus focus-visible:ring-ring-focus/50 aria-invalid:ring-feedback-danger/20 dark:aria-invalid:ring-feedback-danger/40 aria-invalid:border-feedback-danger dark:aria-invalid:border-feedback-danger/50 flex size-4 rounded-full focus-visible:ring-[3px] aria-invalid:ring-[3px] group/radio-group-item peer relative aspect-square shrink-0 border outline-none after:absolute after:-inset-x-3 after:-inset-y-2 data-disabled:cursor-not-allowed data-disabled:opacity-50", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b.jsx(tg, { "data-slot": "radio-group-indicator", className: "group-aria-invalid/radio-group-item:text-feedback-danger text-action-primary flex size-4 items-center justify-center", children: /* @__PURE__ */ b.jsx(Ve, { icon: GO, className: "absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 fill-current" }) }), e[5] = s) : s = e[5];
  let i;
  return e[6] !== o || e[7] !== r ? (i = /* @__PURE__ */ b.jsx(Na, { "data-slot": "radio-group-item", className: r, ...o, children: s }), e[6] = o, e[7] = r, e[8] = i) : i = e[8], i;
}, KO = "_group_1gm3s_1", YO = "_tile_1gm3s_14", qO = "_icon_1gm3s_45", XO = "_label_1gm3s_58", bi = {
  group: KO,
  tile: YO,
  icon: qO,
  label: XO
}, aL = (t) => {
  const e = ee.c(15), {
    className: n,
    disabled: o,
    onValueChange: r,
    options: s,
    value: i,
    "aria-labelledby": a,
    "aria-describedby": l
  } = t;
  let c;
  e[0] !== r || e[1] !== i ? (c = (m) => {
    typeof m != "string" || m === i || r(m);
  }, e[0] = r, e[1] = i, e[2] = c) : c = e[2];
  let u;
  e[3] !== n ? (u = ae(bi.group, n), e[3] = n, e[4] = u) : u = e[4];
  let d;
  e[5] !== s ? (d = s.map(ZO), e[5] = s, e[6] = d) : d = e[6];
  let p;
  return e[7] !== l || e[8] !== a || e[9] !== o || e[10] !== c || e[11] !== u || e[12] !== d || e[13] !== i ? (p = /* @__PURE__ */ b.jsx(ka, { "data-slot": "segmented-control", "aria-labelledby": a, "aria-describedby": l, disabled: o, value: i, onValueChange: c, className: u, children: d }), e[7] = l, e[8] = a, e[9] = o, e[10] = c, e[11] = u, e[12] = d, e[13] = i, e[14] = p) : p = e[14], p;
};
function ZO(t) {
  return /* @__PURE__ */ b.jsxs(Na, { "data-slot": "segmented-control-tile", "aria-label": t.label, disabled: t.disabled, value: t.value, className: bi.tile, children: [
    /* @__PURE__ */ b.jsx("span", { className: bi.icon, children: /* @__PURE__ */ b.jsx(no, { icon: t.icon, size: "lg" }) }),
    /* @__PURE__ */ b.jsx("span", { className: bi.label, children: t.label })
  ] }, t.value);
}
function JO(t) {
  const e = f.useRef(!0);
  e.current && (e.current = !1, t());
}
const Lu = /* @__PURE__ */ f.createContext(null);
process.env.NODE_ENV !== "production" && (Lu.displayName = "SelectRootContext");
const $u = /* @__PURE__ */ f.createContext(null);
process.env.NODE_ENV !== "production" && ($u.displayName = "SelectFloatingContext");
function An() {
  const t = f.useContext(Lu);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectRootContext is missing. Select parts must be placed within <Select.Root>." : We(60));
  return t;
}
function db() {
  const t = f.useContext($u);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectFloatingContext is missing. Select parts must be placed within <Select.Root>." : We(61));
  return t;
}
const QO = (t, e) => Object.is(t, e);
function br(t, e, n) {
  return t == null || e == null ? Object.is(t, e) : n(t, e);
}
function yl(t, e, n) {
  return !t || t.length === 0 ? !1 : t.some((o) => o === void 0 ? !1 : br(o, e, n));
}
function lc(t, e, n) {
  return !t || t.length === 0 ? -1 : t.findIndex((o) => o === void 0 ? !1 : br(o, e, n));
}
function eM(t, e, n) {
  return t.filter((o) => !br(o, e, n));
}
function cc(t) {
  if (t == null)
    return "";
  if (typeof t == "string")
    return t;
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
}
function fb(t) {
  return t != null && t.length > 0 && typeof t[0] == "object" && t[0] != null && "items" in t[0];
}
function tM(t) {
  if (!Array.isArray(t))
    return t != null && !("null" in t);
  if (fb(t)) {
    for (const e of t)
      for (const n of e.items)
        if (n && n.value == null && n.label != null)
          return !0;
    return !1;
  }
  for (const e of t)
    if (e && e.value == null && e.label != null)
      return !0;
  return !1;
}
function nM(t, e) {
  if (e && t != null)
    return e(t) ?? "";
  if (t && typeof t == "object") {
    if ("label" in t && t.label != null)
      return String(t.label);
    if ("value" in t)
      return String(t.value);
  }
  return cc(t);
}
function er(t, e) {
  return e && t != null ? e(t) ?? "" : t && typeof t == "object" && "value" in t && "label" in t ? cc(t.value) : cc(t);
}
function pb(t, e, n) {
  function o() {
    return nM(t, n);
  }
  if (n && t != null)
    return n(t);
  if (t && typeof t == "object" && "label" in t && t.label != null)
    return t.label;
  if (e && !Array.isArray(e))
    return e[t] ?? o();
  if (Array.isArray(e)) {
    const r = fb(e) ? e.flatMap((s) => s.items) : e;
    if (t == null || typeof t != "object") {
      const s = r.find((i) => i.value === t);
      return s && s.label != null ? s.label : o();
    }
    if ("value" in t) {
      const s = r.find((i) => i && i.value === t.value);
      if (s && s.label != null)
        return s.label;
    }
  }
  return o();
}
function oM(t, e, n) {
  return t.reduce((o, r, s) => (s > 0 && o.push(", "), o.push(/* @__PURE__ */ b.jsx(f.Fragment, {
    children: pb(r, e, n)
  }, s)), o), []);
}
const Fe = {
  id: be((t) => t.id),
  modal: be((t) => t.modal),
  multiple: be((t) => t.multiple),
  items: be((t) => t.items),
  itemToStringLabel: be((t) => t.itemToStringLabel),
  itemToStringValue: be((t) => t.itemToStringValue),
  isItemEqualToValue: be((t) => t.isItemEqualToValue),
  value: be((t) => t.value),
  hasSelectedValue: be((t) => {
    const {
      value: e,
      multiple: n,
      itemToStringValue: o
    } = t;
    return e == null ? !1 : n && Array.isArray(e) ? e.length > 0 : er(e, o) !== "";
  }),
  hasNullItemLabel: be((t, e) => e ? tM(t.items) : !1),
  open: be((t) => t.open),
  mounted: be((t) => t.mounted),
  forceMount: be((t) => t.forceMount),
  transitionStatus: be((t) => t.transitionStatus),
  openMethod: be((t) => t.openMethod),
  activeIndex: be((t) => t.activeIndex),
  selectedIndex: be((t) => t.selectedIndex),
  isActive: be((t, e) => t.activeIndex === e),
  isSelected: be((t, e, n) => {
    const o = t.isItemEqualToValue, r = t.value;
    return t.multiple ? Array.isArray(r) && r.some((s) => br(s, n, o)) : t.selectedIndex === e && t.selectedIndex !== null ? !0 : br(r, n, o);
  }),
  isSelectedByFocus: be((t, e) => t.selectedIndex === e),
  popupProps: be((t) => t.popupProps),
  triggerProps: be((t) => t.triggerProps),
  triggerElement: be((t) => t.triggerElement),
  positionerElement: be((t) => t.positionerElement),
  listElement: be((t) => t.listElement),
  scrollUpArrowVisible: be((t) => t.scrollUpArrowVisible),
  scrollDownArrowVisible: be((t) => t.scrollDownArrowVisible),
  hasScrollArrows: be((t) => t.hasScrollArrows)
};
function rM(t) {
  const {
    id: e,
    value: n,
    defaultValue: o = null,
    onValueChange: r,
    open: s,
    defaultOpen: i = !1,
    onOpenChange: a,
    name: l,
    disabled: c = !1,
    readOnly: u = !1,
    required: d = !1,
    modal: p = !0,
    actionsRef: m,
    inputRef: h,
    onOpenChangeComplete: g,
    items: y,
    multiple: v = !1,
    itemToStringLabel: x,
    itemToStringValue: w,
    isItemEqualToValue: E = QO,
    highlightItemOnHover: S = !0,
    children: C
  } = t, {
    clearErrors: _
  } = Nr(), {
    setDirty: R,
    setTouched: O,
    setFocused: j,
    shouldValidateOnChange: F,
    validityData: N,
    setFilled: T,
    name: L,
    disabled: M,
    validation: A,
    validationMode: $
  } = dn(), k = Ir({
    id: e
  }), H = M || c, B = L ?? l, [P, V] = un({
    controlled: n,
    default: v ? o ?? zn : o,
    name: "Select",
    state: "value"
  }), [I, D] = un({
    controlled: s,
    default: i,
    name: "Select",
    state: "open"
  }), z = f.useRef([]), U = f.useRef([]), G = f.useRef(null), J = f.useRef(null), se = f.useRef(0), Q = f.useRef(null), ce = f.useRef([]), W = f.useRef(!1), oe = f.useRef(!1), Y = f.useRef(null), Z = f.useRef({
    allowSelectedMouseUp: !1,
    allowUnselectedMouseUp: !1
  }), K = f.useRef(!1), {
    mounted: X,
    setMounted: ne,
    transitionStatus: re
  } = Kn(I), {
    openMethod: ie,
    triggerProps: de,
    reset: le
  } = ba(I), te = jt(() => new cr({
    id: k,
    modal: p,
    multiple: v,
    itemToStringLabel: x,
    itemToStringValue: w,
    isItemEqualToValue: E,
    value: P,
    open: I,
    mounted: X,
    transitionStatus: re,
    items: y,
    forceMount: !1,
    openMethod: null,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    triggerProps: {},
    triggerElement: null,
    positionerElement: null,
    listElement: null,
    scrollUpArrowVisible: !1,
    scrollDownArrowVisible: !1,
    hasScrollArrows: !1
  })).current, pe = Be(te, Fe.activeIndex), ue = Be(te, Fe.selectedIndex), ye = Be(te, Fe.triggerElement), ge = Be(te, Fe.positionerElement), Te = f.useMemo(() => v && Array.isArray(P) && P.length === 0 ? "" : er(P, w), [v, P, w]), Se = f.useMemo(() => v && Array.isArray(P) ? P.map((Ce) => er(Ce, w)) : er(P, w), [v, P, w]), xe = yt(te.state.triggerElement);
  kr({
    id: k,
    commit: A.commit,
    value: P,
    controlRef: xe,
    name: B,
    getValue: () => Se
  });
  const je = f.useRef(P);
  he(() => {
    P !== je.current && te.set("forceMount", !0);
  }, [te, P]), he(() => {
    T(v ? Array.isArray(P) && P.length > 0 : P != null);
  }, [v, P, T]), he(function() {
    if (I)
      return;
    const $e = ce.current;
    if (v) {
      const tt = Array.isArray(P) ? P : [];
      if (tt.length === 0) {
        te.set("selectedIndex", null);
        return;
      }
      const Qe = tt[tt.length - 1], ht = lc($e, Qe, E);
      te.set("selectedIndex", ht === -1 ? null : ht);
      return;
    }
    const st = lc($e, P, E);
    te.set("selectedIndex", st === -1 ? null : st);
  }, [v, I, P, ce, E, te]), ws(P, () => {
    _(B), R(P !== N.initialValue), F() ? A.commit(P) : A.commit(P, !0);
  });
  const Me = fe((Ce, $e) => {
    if (a?.(Ce, $e), !$e.isCanceled && (D(Ce), !Ce && ($e.reason === In || $e.reason === Yi) && (O(!0), j(!1), $ === "onBlur" && A.commit(P)), !Ce && te.state.activeIndex !== null)) {
      const st = z.current[te.state.activeIndex];
      queueMicrotask(() => {
        st?.setAttribute("tabindex", "-1");
      });
    }
  }), Pe = fe(() => {
    ne(!1), te.set("activeIndex", null), le(), g?.(!1);
  });
  Gt({
    enabled: !m,
    open: I,
    ref: G,
    onComplete() {
      I || Pe();
    }
  }), f.useImperativeHandle(m, () => ({
    unmount: Pe
  }), [Pe]);
  const we = fe((Ce, $e) => {
    r?.(Ce, $e), !$e.isCanceled && V(Ce);
  }), ve = fe(() => {
    const Ce = te.state.listElement || G.current;
    if (!Ce)
      return;
    const $e = Ce.scrollTop, st = Ce.scrollTop + Ce.clientHeight, tt = $e > 1, Qe = st < Ce.scrollHeight - 1;
    te.state.scrollUpArrowVisible !== tt && te.set("scrollUpArrowVisible", tt), te.state.scrollDownArrowVisible !== Qe && te.set("scrollDownArrowVisible", Qe);
  }), Ae = Ih({
    open: I,
    onOpenChange: Me,
    elements: {
      reference: ye,
      floating: ge
    }
  }), Ne = gs(Ae, {
    enabled: !u && !H,
    event: "mousedown"
  }), De = bs(Ae, {
    bubbles: !1
  }), ze = Ph(Ae, {
    enabled: !u && !H,
    listRef: z,
    activeIndex: pe,
    selectedIndex: ue,
    disabledIndices: zn,
    onNavigate(Ce) {
      Ce === null && !I || te.set("activeIndex", Ce);
    },
    // Implement our own listeners since `onPointerLeave` on each option fires while scrolling with
    // the `alignItemWithTrigger=true`, causing a performance issue on Chrome.
    focusItemOnHover: !1
  }), et = Ah(Ae, {
    enabled: !u && !H && (I || !v),
    listRef: U,
    activeIndex: pe,
    selectedIndex: ue,
    onMatch(Ce) {
      I ? te.set("activeIndex", Ce) : we(ce.current[Ce], ke("none"));
    },
    onTypingChange(Ce) {
      W.current = Ce;
    }
  }), {
    getReferenceProps: ct,
    getFloatingProps: Le,
    getItemProps: Ge
  } = qn([Ne, De, ze, et]), Ee = f.useMemo(() => Qt(ct(), de, k ? {
    id: k
  } : at), [ct, de, k]);
  JO(() => {
    te.update({
      popupProps: Le(),
      triggerProps: Ee
    });
  }), he(() => {
    te.update({
      id: k,
      modal: p,
      multiple: v,
      value: P,
      open: I,
      mounted: X,
      transitionStatus: re,
      popupProps: Le(),
      triggerProps: Ee,
      items: y,
      itemToStringLabel: x,
      itemToStringValue: w,
      isItemEqualToValue: E,
      openMethod: ie
    });
  }, [te, k, p, v, P, I, X, re, Le, Ee, y, x, w, E, ie]);
  const Ke = f.useMemo(() => ({
    store: te,
    name: B,
    required: d,
    disabled: H,
    readOnly: u,
    multiple: v,
    itemToStringLabel: x,
    itemToStringValue: w,
    highlightItemOnHover: S,
    setValue: we,
    setOpen: Me,
    listRef: z,
    popupRef: G,
    scrollHandlerRef: J,
    handleScrollArrowVisibility: ve,
    scrollArrowsMountedCountRef: se,
    getItemProps: Ge,
    events: Ae.context.events,
    valueRef: Q,
    valuesRef: ce,
    labelsRef: U,
    typingRef: W,
    selectionRef: Z,
    selectedItemTextRef: Y,
    validation: A,
    onOpenChangeComplete: g,
    keyboardActiveRef: oe,
    alignItemWithTriggerActiveRef: K,
    initialValueRef: je
  }), [te, B, d, H, u, v, x, w, S, we, Me, Ge, Ae.context.events, A, g, ve]), Xe = zt(h, A.inputRef), Je = v && Array.isArray(P) && P.length > 0, wt = f.useMemo(() => !v || !Array.isArray(P) || !B ? null : P.map((Ce) => {
    const $e = er(Ce, w);
    return /* @__PURE__ */ b.jsx("input", {
      type: "hidden",
      name: B,
      value: $e
    }, $e);
  }), [v, P, B, w]);
  return /* @__PURE__ */ b.jsx(Lu.Provider, {
    value: Ke,
    children: /* @__PURE__ */ b.jsxs($u.Provider, {
      value: Ae,
      children: [C, /* @__PURE__ */ b.jsx("input", {
        ...A.getInputValidationProps({
          onFocus() {
            te.state.triggerElement?.focus({
              // Supported in Chrome from 144 (January 2026)
              // @ts-expect-error - focusVisible is not yet in the lib.dom.d.ts
              focusVisible: !0
            });
          },
          // Handle browser autofill.
          onChange(Ce) {
            if (Ce.nativeEvent.defaultPrevented)
              return;
            const $e = Ce.target.value, st = ke(Ut, Ce.nativeEvent);
            function tt() {
              if (v)
                return;
              const Qe = ce.current.find((ht) => er(ht, w).toLowerCase() === $e.toLowerCase());
              Qe != null && (R(Qe !== N.initialValue), we(Qe, st), F() && A.commit(Qe));
            }
            te.set("forceMount", !0), queueMicrotask(tt);
          }
        }),
        name: v ? void 0 : B,
        value: Te,
        disabled: H,
        required: d && !Je,
        readOnly: u,
        ref: Xe,
        style: B ? ms : Wn,
        tabIndex: -1,
        "aria-hidden": !0
      }), wt]
    })
  });
}
const Js = 2, sM = 400, ip = 200, iM = {
  ...Mi,
  ...zo,
  value: () => null
}, mb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: s,
    disabled: i = !1,
    nativeButton: a = !0,
    ...l
  } = e, {
    setTouched: c,
    setFocused: u,
    validationMode: d,
    state: p,
    disabled: m
  } = dn(), {
    labelId: h
  } = yo(), {
    store: g,
    setOpen: y,
    selectionRef: v,
    validation: x,
    readOnly: w,
    required: E,
    alignItemWithTriggerActiveRef: S,
    disabled: C,
    keyboardActiveRef: _
  } = An(), R = m || C || i, O = Be(g, Fe.open), j = Be(g, Fe.value), F = Be(g, Fe.triggerProps), N = Be(g, Fe.positionerElement), T = Be(g, Fe.listElement), L = Be(g, Fe.id), M = Be(g, Fe.hasSelectedValue), A = !M && O, $ = Be(g, Fe.hasNullItemLabel, A), k = s ?? L;
  Ir({
    id: k
  });
  const H = yt(N), B = f.useRef(null), {
    getButtonProps: P,
    buttonRef: V
  } = Wt({
    disabled: R,
    native: a
  }), I = fe((W) => {
    g.set("triggerElement", W);
  }), D = zt(n, B, V, I), z = ft(), U = ft(), G = ft(), J = ft();
  f.useEffect(() => {
    if (O)
      return !(M || $) ? G.start(sM, () => {
        v.current.allowUnselectedMouseUp = !0, v.current.allowSelectedMouseUp = !0;
      }) : J.start(ip, () => {
        v.current.allowUnselectedMouseUp = !0, G.start(ip, () => {
          v.current.allowSelectedMouseUp = !0;
        });
      }), () => {
        G.clear(), J.clear();
      };
    v.current = {
      allowSelectedMouseUp: !1,
      allowUnselectedMouseUp: !1
    }, U.clear();
  }, [O, M, $, v, U, G, J]);
  const se = f.useMemo(() => T?.id ?? ts(N)?.id, [T, N]), Q = Qt(F, {
    id: k,
    role: "combobox",
    "aria-expanded": O ? "true" : "false",
    "aria-haspopup": "listbox",
    "aria-controls": O ? se : void 0,
    "aria-labelledby": h,
    "aria-readonly": w || void 0,
    "aria-required": E || void 0,
    tabIndex: R ? -1 : 0,
    ref: D,
    onFocus(W) {
      u(!0), O && S.current && y(!1, ke(Ut, W.nativeEvent)), z.start(0, () => {
        g.set("forceMount", !0);
      });
    },
    onBlur(W) {
      Ue(N, W.relatedTarget) || (c(!0), u(!1), d === "onBlur" && x.commit(j));
    },
    onPointerMove() {
      _.current = !1;
    },
    onKeyDown() {
      _.current = !0;
    },
    onMouseDown(W) {
      if (O)
        return;
      const oe = Ct(W.currentTarget);
      function Y(Z) {
        if (!B.current)
          return;
        const K = Z.target;
        if (Ue(B.current, K) || Ue(H.current, K) || K === B.current)
          return;
        const X = tb(B.current);
        Z.clientX >= X.left - Js && Z.clientX <= X.right + Js && Z.clientY >= X.top - Js && Z.clientY <= X.bottom + Js || y(!1, ke(Kp, Z));
      }
      U.start(0, () => {
        oe.addEventListener("mouseup", Y, {
          once: !0
        });
      });
    }
  }, x.getValidationProps, l, P);
  Q.role = "combobox";
  const ce = f.useMemo(() => ({
    ...p,
    open: O,
    disabled: R,
    value: j,
    readOnly: w,
    placeholder: !M
  }), [p, O, R, j, w, M]);
  return _e("button", e, {
    ref: [n, B],
    state: ce,
    stateAttributesMapping: iM,
    props: Q
  });
});
process.env.NODE_ENV !== "production" && (mb.displayName = "SelectTrigger");
const aM = {
  value: () => null
}, hb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: s,
    placeholder: i,
    ...a
  } = e, {
    store: l,
    valueRef: c
  } = An(), u = Be(l, Fe.value), d = Be(l, Fe.items), p = Be(l, Fe.itemToStringLabel), m = Be(l, Fe.hasSelectedValue), h = !m && i != null && s == null, g = Be(l, Fe.hasNullItemLabel, h), y = f.useMemo(() => ({
    value: u,
    placeholder: !m
  }), [u, m]);
  let v = null;
  return typeof s == "function" ? v = s(u) : s != null ? v = s : !m && i != null && !g ? v = i : Array.isArray(u) ? v = oM(u, d, p) : v = pb(u, d, p), _e("span", e, {
    state: y,
    ref: [n, c],
    props: [{
      children: v
    }, a],
    stateAttributesMapping: aM
  });
});
process.env.NODE_ENV !== "production" && (hb.displayName = "SelectValue");
const gb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    ...s
  } = e, {
    store: i
  } = An(), a = Be(i, Fe.open), l = f.useMemo(() => ({
    open: a
  }), [a]);
  return _e("span", e, {
    state: l,
    ref: n,
    props: [{
      "aria-hidden": !0,
      children: "▼"
    }, s],
    stateAttributesMapping: ys
  });
});
process.env.NODE_ENV !== "production" && (gb.displayName = "SelectIcon");
const bb = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (bb.displayName = "SelectPortalContext");
const vb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    store: o
  } = An(), r = Be(o, Fe.mounted), s = Be(o, Fe.forceMount);
  return r || s ? /* @__PURE__ */ b.jsx(bb.Provider, {
    value: !0,
    children: /* @__PURE__ */ b.jsx(hs, {
      ref: n,
      ...e
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (vb.displayName = "SelectPortal");
const Fu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Fu.displayName = "SelectPositionerContext");
function Vu() {
  const t = f.useContext(Fu);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectPositionerContext is missing. SelectPositioner parts must be placed within <Select.Positioner>." : We(59));
  return t;
}
function Vi(t, e) {
  t && Object.assign(t.style, e);
}
const yb = {
  position: "relative",
  maxHeight: "100%",
  overflowX: "hidden",
  overflowY: "auto"
}, lM = {
  position: "fixed"
}, xb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: s,
    render: i,
    side: a = "bottom",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: p,
    arrowPadding: m = 5,
    sticky: h = !1,
    disableAnchorTracking: g,
    alignItemWithTrigger: y = !0,
    collisionAvoidance: v = Wp,
    ...x
  } = e, {
    store: w,
    listRef: E,
    labelsRef: S,
    alignItemWithTriggerActiveRef: C,
    selectedItemTextRef: _,
    valuesRef: R,
    initialValueRef: O,
    popupRef: j,
    setValue: F
  } = An(), N = db(), T = Be(w, Fe.open), L = Be(w, Fe.mounted), M = Be(w, Fe.modal), A = Be(w, Fe.value), $ = Be(w, Fe.openMethod), k = Be(w, Fe.positionerElement), H = Be(w, Fe.triggerElement), B = Be(w, Fe.isItemEqualToValue), P = f.useRef(null), V = f.useRef(null), [I, D] = f.useState(y), z = L && I && $ !== "touch";
  !L && I !== y && D(y), he(() => {
    L || (Fe.scrollUpArrowVisible(w.state) && w.set("scrollUpArrowVisible", !1), Fe.scrollDownArrowVisible(w.state) && w.set("scrollDownArrowVisible", !1));
  }, [w, L]), f.useImperativeHandle(C, () => z), sa((z || M) && T && $ !== "touch", H);
  const U = Aa({
    anchor: o,
    floatingRootContext: N,
    positionMethod: r,
    mounted: L,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    arrowPadding: m,
    collisionBoundary: d,
    collisionPadding: p,
    sticky: h,
    disableAnchorTracking: g ?? z,
    collisionAvoidance: v,
    keepMounted: !0
  }), G = z ? "none" : U.side, J = z ? lM : U.positionerStyles, se = f.useMemo(() => {
    const K = {};
    return T || (K.pointerEvents = "none"), {
      role: "presentation",
      hidden: !L,
      style: {
        ...J,
        ...K
      }
    };
  }, [T, L, J]), Q = f.useMemo(() => ({
    open: T,
    side: G,
    align: U.align,
    anchorHidden: U.anchorHidden
  }), [T, G, U.align, U.anchorHidden]), ce = fe((K) => {
    w.set("positionerElement", K);
  }), W = _e("div", e, {
    ref: [n, ce],
    state: Q,
    stateAttributesMapping: bn,
    props: [se, x]
  }), oe = f.useRef(0), Y = fe((K) => {
    if (K.size === 0 && oe.current === 0 || R.current.length === 0)
      return;
    const X = oe.current;
    if (oe.current = K.size, K.size === X)
      return;
    const ne = ke(Ut);
    if (X !== 0 && !w.state.multiple && A !== null && lc(R.current, A, B) === -1) {
      const ie = O.current, le = ie != null && yl(R.current, ie, B) ? ie : null;
      F(le, ne), le === null && (w.set("selectedIndex", null), _.current = null);
    }
    if (X !== 0 && w.state.multiple && Array.isArray(A)) {
      const re = A.filter((ie) => yl(R.current, ie, B));
      (re.length !== A.length || re.some((ie) => !yl(A, ie, B))) && (F(re, ne), re.length === 0 && (w.set("selectedIndex", null), _.current = null));
    }
    if (T && z) {
      w.update({
        scrollUpArrowVisible: !1,
        scrollDownArrowVisible: !1
      });
      const re = {
        height: ""
      };
      Vi(k, re), Vi(j.current, re);
    }
  }), Z = f.useMemo(() => ({
    ...U,
    side: G,
    alignItemWithTriggerActive: z,
    setControlledAlignItemWithTrigger: D,
    scrollUpArrowRef: P,
    scrollDownArrowRef: V
  }), [U, G, z, D]);
  return /* @__PURE__ */ b.jsx(yr, {
    elementsRef: E,
    labelsRef: S,
    onMapChange: Y,
    children: /* @__PURE__ */ b.jsxs(Fu.Provider, {
      value: Z,
      children: [L && M && /* @__PURE__ */ b.jsx(xs, {
        inert: Sa(!T),
        cutout: H
      }), W]
    })
  });
});
process.env.NODE_ENV !== "production" && (xb.displayName = "SelectPositioner");
function wb(t) {
  const e = t.currentTarget.getBoundingClientRect();
  return e.top + 1 <= t.clientY && t.clientY <= e.bottom - 1 && e.left + 1 <= t.clientX && t.clientX <= e.right - 1;
}
const Qs = "base-ui-disable-scrollbar", zi = {
  className: Qs,
  getElement(t) {
    return /* @__PURE__ */ b.jsx("style", {
      nonce: t,
      href: Qs,
      precedence: "base-ui:low",
      children: `.${Qs}{scrollbar-width:none}.${Qs}::-webkit-scrollbar{display:none}`
    });
  }
};
process.env.NODE_ENV !== "production" && (zi.getElement.displayName = "styleDisableScrollbar.getElement");
function cn(t, e = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(e, Math.min(t, n));
}
const Sb = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Sb.displayName = "CSPContext");
const cM = {
  disableStyleElements: !1
};
function Eb() {
  return f.useContext(Sb) ?? cM;
}
const uM = {
  ...bn,
  ...tn
}, Cb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    ...s
  } = e, {
    store: i,
    popupRef: a,
    onOpenChangeComplete: l,
    setOpen: c,
    valueRef: u,
    selectedItemTextRef: d,
    keyboardActiveRef: p,
    multiple: m,
    handleScrollArrowVisibility: h,
    scrollHandlerRef: g,
    highlightItemOnHover: y
  } = An(), {
    side: v,
    align: x,
    alignItemWithTriggerActive: w,
    setControlledAlignItemWithTrigger: E,
    scrollDownArrowRef: S,
    scrollUpArrowRef: C
  } = Vu(), _ = wu() != null, R = db(), {
    nonce: O,
    disableStyleElements: j
  } = Eb(), F = ft(), N = Be(i, Fe.id), T = Be(i, Fe.open), L = Be(i, Fe.mounted), M = Be(i, Fe.popupProps), A = Be(i, Fe.transitionStatus), $ = Be(i, Fe.triggerElement), k = Be(i, Fe.positionerElement), H = Be(i, Fe.listElement), B = f.useRef(0), P = f.useRef(!1), V = f.useRef(0), I = f.useRef(!1), D = f.useRef({}), z = $o(), U = fe((Q) => {
    if (!k || !a.current || !I.current)
      return;
    if (P.current || !w) {
      h();
      return;
    }
    const ce = k.style.top === "0px", W = k.style.bottom === "0px", oe = k.getBoundingClientRect().height, Y = Ct(k), Z = getComputedStyle(k), K = parseFloat(Z.marginTop), X = parseFloat(Z.marginBottom), ne = ap(getComputedStyle(a.current)), re = Y.documentElement.clientHeight - K - X, ie = Q.scrollTop, de = Q.scrollHeight, le = Q.clientHeight, te = de - le;
    let pe = 0, ue = null, ye = !1;
    if (ce) {
      const ge = te - ie, Te = oe + ge, Se = Math.min(Te, re);
      pe = Se, Se !== re ? ue = te : ye = !0;
    } else if (W) {
      const ge = ie - 0, Te = oe + ge, Se = Math.min(Te, re), xe = Te - re;
      pe = Se, Se !== re ? ue = 0 : (ye = !0, ie < te && (ue = ie - (ge - xe)));
    }
    pe !== 0 && (k.style.height = `${pe}px`), ue != null && (Q.scrollTop = ue), (ye || pe >= ne) && (P.current = !0), h();
  });
  f.useImperativeHandle(g, () => U, [U]), Gt({
    open: T,
    ref: a,
    onComplete() {
      T && l?.(!0);
    }
  });
  const G = f.useMemo(() => ({
    open: T,
    transitionStatus: A,
    side: v,
    align: x
  }), [T, A, v, x]);
  he(() => {
    !k || !a.current || Object.keys(D.current).length || (D.current = {
      top: k.style.top || "0",
      left: k.style.left || "0",
      right: k.style.right,
      height: k.style.height,
      bottom: k.style.bottom,
      minHeight: k.style.minHeight,
      maxHeight: k.style.maxHeight,
      marginTop: k.style.marginTop,
      marginBottom: k.style.marginBottom
    });
  }, [a, k]), he(() => {
    T || w || (I.current = !1, P.current = !1, B.current = 0, V.current = 0, Vi(k, D.current));
  }, [T, w, k, a]), he(() => {
    const Q = a.current;
    if (!(!T || !$ || !k || !Q || i.state.transitionStatus === "ending")) {
      if (!w) {
        I.current = !0, z.request(h), Q.style.removeProperty("--transform-origin");
        return;
      }
      queueMicrotask(() => {
        const ce = fM(Q);
        Q.style.removeProperty("--transform-origin");
        try {
          const W = getComputedStyle(k), oe = getComputedStyle(Q), Y = Ct($), Z = mt(k), K = $.getBoundingClientRect(), X = k.getBoundingClientRect(), ne = K.left, re = K.height, ie = H || Q, de = ie.scrollHeight, le = parseFloat(oe.borderBottomWidth), te = parseFloat(W.marginTop) || 10, pe = parseFloat(W.marginBottom) || 10, ue = parseFloat(W.minHeight) || 100, ye = ap(oe), ge = 5, Te = 5, Se = 20, xe = Y.documentElement.clientHeight - te - pe, je = Y.documentElement.clientWidth, Me = xe - K.bottom + re, Pe = d.current, we = u.current;
          let ve, Ae = 0, Ne = 0;
          if (Pe && we) {
            const Ce = we.getBoundingClientRect();
            ve = Pe.getBoundingClientRect();
            const $e = Ce.left - ne, st = ve.left - X.left, tt = Ce.top - K.top + Ce.height / 2, Qe = ve.top - X.top + ve.height / 2;
            Ae = $e - st, Ne = Qe - tt;
          }
          const De = Me + Ne + pe + le;
          let ze = Math.min(xe, De);
          const et = xe - te - pe, ct = De - ze, Le = Math.max(ge, ne + Ae), Ge = je - Te, Ee = Math.max(0, Le + X.width - Ge);
          k.style.left = `${Le - Ee}px`, k.style.height = `${ze}px`, k.style.maxHeight = "auto", k.style.marginTop = `${te}px`, k.style.marginBottom = `${pe}px`, Q.style.height = "100%";
          const Ke = ie.scrollHeight - ie.clientHeight, Xe = ct >= Ke;
          Xe && (ze = Math.min(xe, X.height) - (ct - Ke));
          const Je = K.top < Se || K.bottom > xe - Se || ze < Math.min(de, ue), wt = (Z.visualViewport?.scale ?? 1) !== 1 && sm;
          if (Je || wt) {
            I.current = !0, Vi(k, D.current), Vt.flushSync(() => E(!1));
            return;
          }
          if (Xe) {
            const Ce = Math.max(0, xe - De);
            k.style.top = X.height >= et ? "0" : `${Ce}px`, k.style.height = `${ze}px`, ie.scrollTop = ie.scrollHeight - ie.clientHeight, B.current = Math.max(ue, ze);
          } else
            k.style.bottom = "0", B.current = Math.max(ue, ze), ie.scrollTop = ct;
          if (ve) {
            const Ce = X.top, $e = X.height, st = ve.top + ve.height / 2, tt = $e > 0 ? (st - Ce) / $e * 100 : 50, Qe = cn(tt, 0, 100);
            Q.style.setProperty("--transform-origin", `50% ${Qe}%`);
          }
          (B.current === xe || ze >= ye) && (P.current = !0), h(), setTimeout(() => {
            I.current = !0;
          });
        } finally {
          ce();
        }
      });
    }
  }, [i, T, k, $, u, d, a, h, w, E, z, S, C, H]), f.useEffect(() => {
    if (!w || !k || !T)
      return;
    const Q = mt(k);
    function ce(W) {
      c(!1, ke(jy, W));
    }
    return Q.addEventListener("resize", ce), () => {
      Q.removeEventListener("resize", ce);
    };
  }, [c, w, k, T]);
  const J = {
    ...H ? {
      role: "presentation",
      "aria-orientation": void 0
    } : {
      role: "listbox",
      "aria-multiselectable": m || void 0,
      id: `${N}-list`
    },
    onKeyDown(Q) {
      p.current = !0, _ && ps.has(Q.key) && Q.stopPropagation();
    },
    onMouseMove() {
      p.current = !1;
    },
    onPointerLeave(Q) {
      if (!y || wb(Q) || Q.pointerType === "touch")
        return;
      const ce = Q.currentTarget;
      F.start(0, () => {
        i.set("activeIndex", null), ce.focus({
          preventScroll: !0
        });
      });
    },
    onScroll(Q) {
      H || g.current?.(Q.currentTarget);
    },
    ...w && {
      style: H ? {
        height: "100%"
      } : yb
    }
  }, se = _e("div", e, {
    ref: [n, a],
    state: G,
    stateAttributesMapping: uM,
    props: [M, J, Or(A), {
      className: !H && w ? zi.className : void 0
    }, s]
  });
  return /* @__PURE__ */ b.jsxs(f.Fragment, {
    children: [!j && zi.getElement(O), /* @__PURE__ */ b.jsx(ia, {
      context: R,
      modal: !1,
      disabled: !L,
      restoreFocus: !0,
      children: se
    })]
  });
});
process.env.NODE_ENV !== "production" && (Cb.displayName = "SelectPopup");
function ap(t) {
  const e = t.maxHeight || "";
  return e.endsWith("px") && parseFloat(e) || 1 / 0;
}
const lp = {
  transform: "none",
  scale: "1",
  translate: "0 0"
};
function dM(t, e, n) {
  n ? t.setProperty(e, n) : t.removeProperty(e);
}
function fM(t) {
  const {
    style: e
  } = t, n = {}, o = Object.keys(lp);
  for (const r of o)
    n[r] = e.getPropertyValue(r), e.setProperty(r, lp[r]);
  return () => {
    for (const r of o)
      dM(e, r, n[r]);
  };
}
const _b = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    ...s
  } = e, {
    store: i,
    scrollHandlerRef: a
  } = An(), {
    alignItemWithTriggerActive: l
  } = Vu(), c = Be(i, Fe.hasScrollArrows), u = Be(i, Fe.openMethod), d = Be(i, Fe.multiple), m = {
    id: `${Be(i, Fe.id)}-list`,
    role: "listbox",
    "aria-multiselectable": d || void 0,
    onScroll(g) {
      a.current?.(g.currentTarget);
    },
    ...l && {
      style: yb
    },
    className: c && u !== "touch" ? zi.className : void 0
  }, h = fe((g) => {
    i.set("listElement", g);
  });
  return _e("div", e, {
    ref: [n, h],
    props: [m, s]
  });
});
process.env.NODE_ENV !== "production" && (_b.displayName = "SelectList");
const zu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (zu.displayName = "SelectItemContext");
function Bu() {
  const t = f.useContext(zu);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectItemContext is missing. SelectItem parts must be placed within <Select.Item>." : We(57));
  return t;
}
const Rb = /* @__PURE__ */ f.memo(/* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: s = null,
    label: i,
    disabled: a = !1,
    nativeButton: l = !1,
    ...c
  } = e, u = f.useRef(null), d = Yn({
    label: i,
    textRef: u,
    indexGuessBehavior: Zp.GuessFromOrder
  }), {
    store: p,
    getItemProps: m,
    setOpen: h,
    setValue: g,
    selectionRef: y,
    typingRef: v,
    valuesRef: x,
    keyboardActiveRef: w,
    multiple: E,
    highlightItemOnHover: S
  } = An(), C = ft(), _ = Be(p, Fe.isActive, d.index), R = Be(p, Fe.isSelected, d.index, s), O = Be(p, Fe.isSelectedByFocus, d.index), j = Be(p, Fe.isItemEqualToValue), F = d.index, N = F !== -1, T = f.useRef(null), L = yt(F);
  he(() => {
    if (!N)
      return;
    const U = x.current;
    return U[F] = s, () => {
      delete U[F];
    };
  }, [N, F, s, x]), he(() => {
    if (!N)
      return;
    const U = p.state.value;
    let G = U;
    E && Array.isArray(U) && U.length > 0 && (G = U[U.length - 1]), G !== void 0 && br(G, s, j) && p.set("selectedIndex", F);
  }, [N, F, E, j, p, s]);
  const M = f.useMemo(() => ({
    disabled: a,
    selected: R,
    highlighted: _
  }), [a, R, _]), A = m({
    active: _,
    selected: R
  });
  A.onFocus = void 0, A.id = void 0;
  const $ = f.useRef(null), k = f.useRef("mouse"), H = f.useRef(!1), {
    getButtonProps: B,
    buttonRef: P
  } = Wt({
    disabled: a,
    focusableWhenDisabled: !0,
    native: l
  });
  function V(U) {
    const G = p.state.value;
    if (E) {
      const J = Array.isArray(G) ? G : [], se = R ? eM(J, s, j) : [...J, s];
      g(se, ke(No, U));
    } else
      g(s, ke(No, U)), h(!1, ke(No, U));
  }
  const I = {
    role: "option",
    "aria-selected": R,
    tabIndex: _ ? 0 : -1,
    onFocus() {
      p.set("activeIndex", F);
    },
    onMouseEnter() {
      !w.current && p.state.selectedIndex === null && p.set("activeIndex", F);
    },
    onMouseMove() {
      S && p.set("activeIndex", F);
    },
    onMouseLeave(U) {
      !S || w.current || wb(U) || C.start(0, () => {
        p.state.activeIndex === F && p.set("activeIndex", null);
      });
    },
    onTouchStart() {
      y.current = {
        allowSelectedMouseUp: !1,
        allowUnselectedMouseUp: !1
      };
    },
    onKeyDown(U) {
      $.current = U.key, p.set("activeIndex", F);
    },
    onClick(U) {
      H.current = !1, !(U.type === "keydown" && $.current === null) && (a || $.current === " " && v.current || k.current !== "touch" && !_ || ($.current = null, V(U.nativeEvent)));
    },
    onPointerEnter(U) {
      k.current = U.pointerType;
    },
    onPointerDown(U) {
      k.current = U.pointerType, H.current = !0;
    },
    onMouseUp(U) {
      if (a)
        return;
      if (H.current) {
        H.current = !1;
        return;
      }
      const G = !y.current.allowSelectedMouseUp && R, J = !y.current.allowUnselectedMouseUp && !R;
      G || J || k.current !== "touch" && !_ || V(U.nativeEvent);
    }
  }, D = _e("div", e, {
    ref: [P, n, d.ref, T],
    state: M,
    props: [A, I, c, B]
  }), z = f.useMemo(() => ({
    selected: R,
    indexRef: L,
    textRef: u,
    selectedByFocus: O,
    hasRegistered: N
  }), [R, L, u, O, N]);
  return /* @__PURE__ */ b.jsx(zu.Provider, {
    value: z,
    children: D
  });
}));
process.env.NODE_ENV !== "production" && (Rb.displayName = "SelectItem");
const Nb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const o = e.keepMounted ?? !1, {
    selected: r
  } = Bu();
  return o || r ? /* @__PURE__ */ b.jsx(kb, {
    ...e,
    ref: n
  }) : null;
});
process.env.NODE_ENV !== "production" && (Nb.displayName = "SelectItemIndicator");
const kb = /* @__PURE__ */ f.memo(/* @__PURE__ */ f.forwardRef((t, e) => {
  const {
    render: n,
    className: o,
    keepMounted: r,
    ...s
  } = t, {
    selected: i
  } = Bu(), a = f.useRef(null), {
    transitionStatus: l,
    setMounted: c
  } = Kn(i), u = f.useMemo(() => ({
    selected: i,
    transitionStatus: l
  }), [i, l]), d = _e("span", t, {
    ref: [e, a],
    state: u,
    props: [{
      "aria-hidden": !0,
      children: "✔️"
    }, s],
    stateAttributesMapping: tn
  });
  return Gt({
    open: i,
    ref: a,
    onComplete() {
      i || c(!1);
    }
  }), d;
}));
process.env.NODE_ENV !== "production" && (kb.displayName = "Inner");
const Tb = /* @__PURE__ */ f.memo(/* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    indexRef: o,
    textRef: r,
    selectedByFocus: s,
    hasRegistered: i
  } = Bu(), {
    selectedItemTextRef: a
  } = An(), {
    className: l,
    render: c,
    ...u
  } = e, d = f.useCallback((m) => {
    if (!m || !i)
      return;
    const h = a.current === null || !a.current.isConnected;
    (s || h && o.current === 0) && (a.current = m);
  }, [a, o, s, i]);
  return _e("div", e, {
    ref: [d, n, r],
    props: u
  });
}));
process.env.NODE_ENV !== "production" && (Tb.displayName = "SelectItemText");
const Hu = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    direction: s,
    keepMounted: i = !1,
    ...a
  } = e, {
    store: l,
    popupRef: c,
    listRef: u,
    handleScrollArrowVisibility: d,
    scrollArrowsMountedCountRef: p
  } = An(), {
    side: m,
    scrollDownArrowRef: h,
    scrollUpArrowRef: g
  } = Vu(), y = s === "up" ? Fe.scrollUpArrowVisible : Fe.scrollDownArrowVisible, v = Be(l, y), x = Be(l, Fe.openMethod), w = v && x !== "touch", E = ft(), S = s === "up" ? g : h, {
    transitionStatus: C,
    setMounted: _
  } = Kn(w);
  he(() => (p.current += 1, l.state.hasScrollArrows || l.set("hasScrollArrows", !0), () => {
    p.current = Math.max(0, p.current - 1), p.current === 0 && l.state.hasScrollArrows && l.set("hasScrollArrows", !1);
  }), [l, p]), Gt({
    open: w,
    ref: S,
    onComplete() {
      w || _(!1);
    }
  });
  const R = f.useMemo(() => ({
    direction: s,
    visible: w,
    side: m,
    transitionStatus: C
  }), [s, w, m, C]), j = _e("div", e, {
    ref: [n, S],
    state: R,
    props: [{
      "aria-hidden": !0,
      children: s === "up" ? "▲" : "▼",
      style: {
        position: "absolute"
      },
      onMouseMove(N) {
        if (N.movementX === 0 && N.movementY === 0 || E.isStarted())
          return;
        l.set("activeIndex", null);
        function T() {
          const L = l.state.listElement ?? c.current;
          if (!L)
            return;
          l.set("activeIndex", null), d();
          const M = L.scrollTop === 0, A = Math.round(L.scrollTop + L.clientHeight) >= L.scrollHeight;
          if (u.current.length === 0 && (s === "up" ? l.set("scrollUpArrowVisible", !M) : l.set("scrollDownArrowVisible", !A)), s === "up" && M || s === "down" && A) {
            E.clear();
            return;
          }
          if ((l.state.listElement || c.current) && u.current && u.current.length > 0) {
            const k = u.current, H = S.current?.offsetHeight || 0;
            if (s === "up") {
              let B = 0;
              const P = L.scrollTop + H;
              for (let I = 0; I < k.length; I += 1) {
                const D = k[I];
                if (D && D.offsetTop >= P) {
                  B = I;
                  break;
                }
              }
              const V = Math.max(0, B - 1);
              if (V < B) {
                const I = k[V];
                I && (L.scrollTop = Math.max(0, I.offsetTop - H));
              } else
                L.scrollTop = 0;
            } else {
              let B = k.length - 1;
              const P = L.scrollTop + L.clientHeight - H;
              for (let I = 0; I < k.length; I += 1) {
                const D = k[I];
                if (D && D.offsetTop + D.offsetHeight > P) {
                  B = Math.max(0, I - 1);
                  break;
                }
              }
              const V = Math.min(k.length - 1, B + 1);
              if (V > B) {
                const I = k[V];
                I && (L.scrollTop = I.offsetTop + I.offsetHeight - L.clientHeight + H);
              } else
                L.scrollTop = L.scrollHeight - L.clientHeight;
            }
          }
          E.start(40, T);
        }
        E.start(40, T);
      },
      onMouseLeave() {
        E.clear();
      }
    }, a]
  });
  return w || i ? j : null;
});
process.env.NODE_ENV !== "production" && (Hu.displayName = "SelectScrollArrow");
const Ib = /* @__PURE__ */ f.forwardRef(function(e, n) {
  return /* @__PURE__ */ b.jsx(Hu, {
    ...e,
    ref: n,
    direction: "down"
  });
});
process.env.NODE_ENV !== "production" && (Ib.displayName = "SelectScrollDownArrow");
const Ob = /* @__PURE__ */ f.forwardRef(function(e, n) {
  return /* @__PURE__ */ b.jsx(Hu, {
    ...e,
    ref: n,
    direction: "up"
  });
});
process.env.NODE_ENV !== "production" && (Ob.displayName = "SelectScrollUpArrow");
const Uu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Uu.displayName = "SelectGroupContext");
function pM() {
  const t = f.useContext(Uu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectGroupContext is missing. SelectGroup parts must be placed within <Select.Group>." : We(56));
  return t;
}
const Mb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    ...s
  } = e, [i, a] = f.useState(), l = f.useMemo(() => ({
    labelId: i,
    setLabelId: a
  }), [i, a]), c = _e("div", e, {
    ref: n,
    props: [{
      role: "group",
      "aria-labelledby": i
    }, s]
  });
  return /* @__PURE__ */ b.jsx(Uu.Provider, {
    value: l,
    children: c
  });
});
process.env.NODE_ENV !== "production" && (Mb.displayName = "SelectGroup");
const Pb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    id: s,
    ...i
  } = e, {
    setLabelId: a
  } = pM(), l = lt(s);
  return he(() => {
    a(l);
  }, [l, a]), _e("div", e, {
    ref: n,
    props: [{
      id: l
    }, i]
  });
});
process.env.NODE_ENV !== "production" && (Pb.displayName = "SelectGroupLabel");
const mM = "_trigger_9jhgd_1", hM = "_icon_9jhgd_64", gM = "_widthSm_9jhgd_72", bM = "_widthMd_9jhgd_77", vM = "_widthLg_9jhgd_82", yM = "_widthFull_9jhgd_87", rr = {
  trigger: mM,
  icon: hM,
  widthSm: gM,
  widthMd: bM,
  widthLg: vM,
  widthFull: yM
}, xM = {
  full: rr.widthFull,
  lg: rr.widthLg,
  md: rr.widthMd,
  sm: rr.widthSm
}, lL = rM, cL = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("scroll-my-1 p-1", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(Mb, { "data-slot": "select-group", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, uL = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("flex flex-1 min-w-0 items-center gap-1.5 overflow-hidden text-left whitespace-nowrap", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(hb, { "data-slot": "select-value", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, dL = (t) => {
  const e = ee.c(19);
  let n, o, r, s;
  e[0] !== t ? ({
    className: o,
    children: n,
    width: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = s === void 0 ? "md" : s, a = typeof i == "number" ? void 0 : xM[i];
  let l;
  e[5] !== i ? (l = typeof i == "number" ? {
    maxWidth: "100%",
    width: `${i}px`
  } : void 0, e[5] = i, e[6] = l) : l = e[6];
  const c = l;
  let u;
  e[7] !== c || e[8] !== r.style ? (u = c ? {
    ...r.style,
    ...c
  } : r.style, e[7] = c, e[8] = r.style, e[9] = u) : u = e[9];
  const d = u;
  let p;
  e[10] !== o || e[11] !== a ? (p = ae(rr.trigger, a, o), e[10] = o, e[11] = a, e[12] = p) : p = e[12];
  let m;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ b.jsx(gb, { render: /* @__PURE__ */ b.jsx(Ve, { icon: Vo, className: rr.icon }) }), e[13] = m) : m = e[13];
  let h;
  return e[14] !== n || e[15] !== r || e[16] !== d || e[17] !== p ? (h = /* @__PURE__ */ b.jsxs(mb, { "data-slot": "select-trigger", className: p, ...r, style: d, children: [
    n,
    m
  ] }), e[14] = n, e[15] = r, e[16] = d, e[17] = p, e[18] = h) : h = e[18], h;
}, fL = (t) => {
  const e = ee.c(26);
  let n, o, r, s, i, a, l, c;
  e[0] !== t ? ({
    className: o,
    children: n,
    side: s,
    sideOffset: i,
    align: a,
    alignOffset: l,
    alignItemWithTrigger: c,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8]);
  const u = s === void 0 ? "bottom" : s, d = i === void 0 ? 4 : i, p = a === void 0 ? "start" : a, m = l === void 0 ? 0 : l, h = c === void 0 ? !1 : c;
  let g;
  e[9] !== o ? (g = ae("bg-overlay text-primary data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 data-closed:zoom-out-95 data-open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ring-action-primary/10 rounded-lg shadow-md ring-1 duration-100 relative isolate z-50 max-h-(--available-height) min-w-(--anchor-width) w-max max-w-(--available-width) origin-(--transform-origin) overflow-x-hidden overflow-y-auto", o), e[9] = o, e[10] = g) : g = e[10];
  let y;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = /* @__PURE__ */ b.jsx(wM, {}), e[11] = y) : y = e[11];
  let v;
  e[12] !== n ? (v = /* @__PURE__ */ b.jsx(_b, { children: n }), e[12] = n, e[13] = v) : v = e[13];
  let x;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (x = /* @__PURE__ */ b.jsx(SM, {}), e[14] = x) : x = e[14];
  let w;
  e[15] !== r || e[16] !== g || e[17] !== v ? (w = /* @__PURE__ */ b.jsxs(Cb, { "data-slot": "select-content", className: g, ...r, children: [
    y,
    v,
    x
  ] }), e[15] = r, e[16] = g, e[17] = v, e[18] = w) : w = e[18];
  let E;
  return e[19] !== p || e[20] !== h || e[21] !== m || e[22] !== u || e[23] !== d || e[24] !== w ? (E = /* @__PURE__ */ b.jsx(vb, { children: /* @__PURE__ */ b.jsx(xb, { side: u, sideOffset: d, align: p, alignOffset: m, alignItemWithTrigger: h, className: "isolate z-50", children: w }) }), e[19] = p, e[20] = h, e[21] = m, e[22] = u, e[23] = d, e[24] = w, e[25] = E) : E = e[25], E;
}, pL = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("text-muted px-1.5 py-1 text-xs", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(Pb, { "data-slot": "select-label", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, mL = (t) => {
  const e = ee.c(13);
  let n, o, r;
  e[0] !== t ? ({
    className: o,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  e[4] !== o ? (s = ae("focus:bg-action-secondary focus:text-primary not-data-[variant=destructive]:focus:**:text-primary gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2 relative flex w-full cursor-default items-center outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0", o), e[4] = o, e[5] = s) : s = e[5];
  let i;
  e[6] !== n ? (i = /* @__PURE__ */ b.jsx(Tb, { className: "flex flex-1 gap-2 shrink-0 whitespace-nowrap", children: n }), e[6] = n, e[7] = i) : i = e[7];
  let a;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b.jsx(Nb, { render: /* @__PURE__ */ b.jsx("span", { className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center" }), children: /* @__PURE__ */ b.jsx(Ve, { icon: Tr, width: 24, height: 24, className: "pointer-events-none" }) }), e[8] = a) : a = e[8];
  let l;
  return e[9] !== r || e[10] !== s || e[11] !== i ? (l = /* @__PURE__ */ b.jsxs(Rb, { "data-slot": "select-item", className: s, ...r, children: [
    i,
    a
  ] }), e[9] = r, e[10] = s, e[11] = i, e[12] = l) : l = e[12], l;
}, hL = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("bg-border -mx-1 my-1 h-px pointer-events-none", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(Cs, { "data-slot": "select-separator", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, wM = (t) => {
  const e = ee.c(9);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("bg-overlay z-10 flex cursor-default items-center justify-center py-1 [&_svg:not([class*='size-'])]:size-4 top-0 w-full", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b.jsx(Ve, { icon: ns }), e[5] = s) : s = e[5];
  let i;
  return e[6] !== o || e[7] !== r ? (i = /* @__PURE__ */ b.jsx(Ob, { "data-slot": "select-scroll-up-button", className: r, ...o, children: s }), e[6] = o, e[7] = r, e[8] = i) : i = e[8], i;
}, SM = (t) => {
  const e = ee.c(9);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("bg-overlay z-10 flex cursor-default items-center justify-center py-1 [&_svg:not([class*='size-'])]:size-4 bottom-0 w-full", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b.jsx(Ve, { icon: Vo }), e[5] = s) : s = e[5];
  let i;
  return e[6] !== o || e[7] !== r ? (i = /* @__PURE__ */ b.jsx(Ib, { "data-slot": "select-scroll-down-button", className: r, ...o, children: s }), e[6] = o, e[7] = r, e[8] = i) : i = e[8], i;
};
function Ab(t, e, n = (o, r) => o === r) {
  return t.length === e.length && t.every((o, r) => n(o, e[r]));
}
function Db(t, e) {
  return t - e;
}
function EM(t, e, n) {
  const o = t.slice();
  return o[e] = n, o.sort(Db);
}
function jb(t, e, n, o, r, s) {
  let i = t;
  return i = cn(i, n, o), r && (i = EM(
    s,
    e,
    // Bound the new value to the thumb's neighbours.
    cn(i, s[e - 1] || -1 / 0, s[e + 1] || 1 / 0)
  )), i;
}
function Lb(t, e, n) {
  if (!Array.isArray(t))
    return !0;
  const o = t.reduce((r, s, i, a) => (i === a.length - 1 || r.push(Math.abs(s - a[i + 1])), r), []);
  return Math.min(...o) >= e * n;
}
const _s = {
  activeThumbIndex: () => null,
  max: () => null,
  min: () => null,
  minStepsBetweenValues: () => null,
  step: () => null,
  values: () => null
}, Wu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Wu.displayName = "SliderRootContext");
function Da() {
  const t = f.useContext(Wu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SliderRootContext is missing. Slider parts must be placed within <Slider.Root>." : We(62));
  return t;
}
function CM(t) {
  return "key" in t ? Py : My;
}
function _M(t, e) {
  return typeof t == "number" && typeof e == "number" ? t === e : Array.isArray(t) && Array.isArray(e) ? Ab(t, e) : !1;
}
const $b = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    "aria-labelledby": o,
    className: r,
    defaultValue: s,
    disabled: i = !1,
    id: a,
    format: l,
    largeStep: c = 10,
    locale: u,
    render: d,
    max: p = 100,
    min: m = 0,
    minStepsBetweenValues: h = 0,
    name: g,
    onValueChange: y,
    onValueCommitted: v,
    orientation: x = "horizontal",
    step: w = 1,
    thumbCollisionBehavior: E = "push",
    thumbAlignment: S = "center",
    value: C,
    ..._
  } = e, R = lt(a), O = fe(y), j = fe(v), {
    clearErrors: F
  } = Nr(), {
    state: N,
    disabled: T,
    name: L,
    setTouched: M,
    setDirty: A,
    validityData: $,
    shouldValidateOnChange: k,
    validation: H
  } = dn(), {
    labelId: B
  } = yo(), P = o ?? B, V = T || i, I = L ?? g, [D, z] = un({
    controlled: C,
    default: s ?? m,
    name: "Slider"
  }), U = f.useRef(null), G = f.useRef(null), J = f.useRef([]), se = f.useRef(null), Q = f.useRef(null), ce = f.useRef(-1), W = f.useRef(null), oe = f.useRef(null), Y = f.useRef("none"), Z = yt(l), [K, X] = f.useState(-1), [ne, re] = f.useState(-1), [ie, de] = f.useState(!1), [le, te] = f.useState(() => /* @__PURE__ */ new Map()), [pe, ue] = f.useState([void 0, void 0]), ye = fe((ve) => {
    X(ve), ve !== -1 && re(ve);
  });
  kr({
    id: R,
    commit: H.commit,
    value: D,
    controlRef: G,
    name: I,
    getValue: () => D
  }), ws(D, () => {
    F(I), k() ? H.commit(D) : H.commit(D, !0);
    const ve = $.initialValue;
    let Ae;
    Array.isArray(D) && Array.isArray(ve) ? Ae = !Ab(D, ve) : Ae = D !== ve, A(Ae);
  });
  const ge = fe((ve) => {
    ve && (G.current = ve);
  }), Te = Array.isArray(D), Se = f.useMemo(() => Te ? D.slice().sort(Db) : [cn(D, m, p)], [p, m, Te, D]), xe = fe((ve, Ae) => {
    if (Number.isNaN(ve) || _M(ve, D))
      return;
    const Ne = Ae ?? ke(Ut, void 0, void 0, {
      activeThumbIndex: -1
    });
    Y.current = Ne.reason;
    const De = new event.constructor(event.type, event);
    Object.defineProperty(De, "target", {
      writable: !0,
      value: {
        value: ve,
        name: I
      }
    }), Ne.event = De, oe.current = ve, O(ve, Ne), !Ne.isCanceled && z(ve);
  }), je = fe((ve, Ae, Ne) => {
    const De = jb(ve, Ae, m, p, Te, Se);
    if (Lb(De, w, h)) {
      const ze = CM(Ne);
      xe(De, ke(ze, Ne.nativeEvent, void 0, {
        activeThumbIndex: Ae
      })), M(!0);
      const et = oe.current ?? De;
      j(et, Yp(ze, Ne.nativeEvent));
    }
  });
  process.env.NODE_ENV !== "production" && m >= p && cs("Slider `max` must be greater than `min`."), he(() => {
    const ve = Jt(Ct(U.current));
    V && ve && U.current?.contains(ve) && ve.blur();
  }, [V]), V && K !== -1 && ye(-1);
  const Me = f.useMemo(() => ({
    ...N,
    activeThumbIndex: K,
    disabled: V,
    dragging: ie,
    orientation: x,
    max: p,
    min: m,
    minStepsBetweenValues: h,
    step: w,
    values: Se
  }), [N, K, V, ie, p, m, h, x, w, Se]), Pe = f.useMemo(() => ({
    active: K,
    controlRef: G,
    disabled: V,
    dragging: ie,
    validation: H,
    formatOptionsRef: Z,
    handleInputChange: je,
    indicatorPosition: pe,
    inset: S !== "center",
    labelId: P,
    largeStep: c,
    lastUsedThumbIndex: ne,
    lastChangedValueRef: oe,
    lastChangeReasonRef: Y,
    locale: u,
    max: p,
    min: m,
    minStepsBetweenValues: h,
    name: I,
    onValueCommitted: j,
    orientation: x,
    pressedInputRef: se,
    pressedThumbCenterOffsetRef: Q,
    pressedThumbIndexRef: ce,
    pressedValuesRef: W,
    registerFieldControlRef: ge,
    renderBeforeHydration: S === "edge",
    setActive: ye,
    setDragging: de,
    setIndicatorPosition: ue,
    setValue: xe,
    state: Me,
    step: w,
    thumbCollisionBehavior: E,
    thumbMap: le,
    thumbRefs: J,
    values: Se
  }), [K, G, P, V, ie, H, Z, je, pe, c, ne, oe, Y, u, p, m, h, I, j, x, se, Q, ce, W, ge, ye, de, ue, xe, Me, w, E, S, le, J, Se]), we = _e("div", e, {
    state: Me,
    ref: [n, U],
    props: [{
      "aria-labelledby": P,
      id: R,
      role: "group"
    }, H.getValidationProps, _],
    stateAttributesMapping: _s
  });
  return /* @__PURE__ */ b.jsx(Wu.Provider, {
    value: Pe,
    children: /* @__PURE__ */ b.jsx(yr, {
      elementsRef: J,
      onMapChange: te,
      children: we
    })
  });
});
process.env.NODE_ENV !== "production" && ($b.displayName = "SliderRoot");
const cp = /* @__PURE__ */ new Map();
function RM(t, e) {
  const n = JSON.stringify({
    locale: t,
    options: e
  }), o = cp.get(n);
  if (o)
    return o;
  const r = new Intl.NumberFormat(t, e);
  return cp.set(n, r), r;
}
function vi(t, e, n) {
  return t == null ? "" : RM(e, n).format(t);
}
function Fb(t) {
  const e = t.getBoundingClientRect();
  return {
    x: (e.left + e.right) / 2,
    y: (e.top + e.bottom) / 2
  };
}
function NM(t) {
  if (Math.abs(t) < 1) {
    const n = t.toExponential().split("e-"), o = n[0].split(".")[1];
    return (o ? o.length : 0) + parseInt(n[1], 10);
  }
  const e = t.toString().split(".")[1];
  return e ? e.length : 0;
}
function Vb(t, e, n) {
  const o = Math.round((t - n) / e) * e + n;
  return Number(o.toFixed(NM(e)));
}
function up({
  values: t,
  index: e,
  nextValue: n,
  min: o,
  max: r,
  step: s,
  minStepsBetweenValues: i,
  initialValues: a
}) {
  if (t.length === 0)
    return [];
  const l = t.slice(), c = s * i, u = l.length - 1, d = a ?? t, p = o + e * c, m = r - (u - e) * c;
  l[e] = cn(n, p, m);
  for (let h = e + 1; h <= u; h += 1) {
    const g = l[h - 1] + c, y = r - (u - h) * c, v = d[h] ?? l[h];
    let x = Math.max(l[h], g);
    v < x && (x = Math.max(v, g)), l[h] = cn(x, g, y);
  }
  for (let h = e - 1; h >= 0; h -= 1) {
    const g = l[h + 1] - c, y = o + h * c, v = d[h] ?? l[h];
    let x = Math.min(l[h], g);
    v > x && (x = Math.min(v, g)), l[h] = cn(x, y, g);
  }
  for (let h = 0; h <= u; h += 1)
    l[h] = Number(l[h].toFixed(12));
  return l;
}
function kM({
  behavior: t,
  values: e,
  currentValues: n,
  initialValues: o,
  pressedIndex: r,
  nextValue: s,
  min: i,
  max: a,
  step: l,
  minStepsBetweenValues: c
}) {
  const u = n ?? e, d = o ?? e;
  if (!(u.length > 1))
    return {
      value: s,
      thumbIndex: 0,
      didSwap: !1
    };
  const m = l * c;
  switch (t) {
    case "swap": {
      const h = u[r], g = 1e-7, y = u.slice(), v = y[r - 1], x = y[r + 1], w = v != null ? v + m : i, E = x != null ? x - m : a, S = cn(s, w, E), C = Number(S.toFixed(12));
      y[r] = C;
      const _ = s > h, R = s < h, O = _ && x != null && s >= x - g, j = R && v != null && s <= v + g;
      if (!O && !j)
        return {
          value: y,
          thumbIndex: r,
          didSwap: !1
        };
      const F = O ? r + 1 : r - 1, N = y.map((A, $) => {
        if ($ === r)
          return C;
        const k = d[$];
        return k ?? u[$];
      });
      let T = s;
      O ? T = Math.max(s, y[F]) : T = Math.min(s, y[F]);
      const L = up({
        values: y,
        index: F,
        nextValue: T,
        min: i,
        max: a,
        step: l,
        minStepsBetweenValues: c,
        initialValues: N
      }), M = O ? F - 1 : F + 1;
      if (M >= 0 && M < L.length) {
        const A = L[M - 1], $ = L[M + 1];
        let k = A != null ? A + m : i;
        k = Math.max(k, i + M * m);
        let H = $ != null ? $ - m : a;
        H = Math.min(H, a - (L.length - 1 - M) * m);
        const B = cn(C, k, H);
        L[M] = Number(B.toFixed(12));
      }
      return {
        value: L,
        thumbIndex: F,
        didSwap: !0
      };
    }
    case "push":
      return {
        value: up({
          values: u,
          index: r,
          nextValue: s,
          min: i,
          max: a,
          step: l,
          minStepsBetweenValues: c
        }),
        thumbIndex: r,
        didSwap: !1
      };
    default: {
      const h = u.slice(), g = h[r - 1], y = h[r + 1], v = g != null ? g + m : i, x = y != null ? y - m : a, w = cn(s, v, x);
      return h[r] = Number(w.toFixed(12)), {
        value: h,
        thumbIndex: r,
        didSwap: !1
      };
    }
  }
}
const TM = 2;
function IM(t, e) {
  if (!t)
    return {
      start: 0,
      end: 0
    };
  function n(s) {
    const i = s != null ? parseFloat(s) : 0;
    return Number.isNaN(i) ? 0 : i;
  }
  const o = e ? "Top" : "InlineStart", r = e ? "Bottom" : "InlineEnd";
  return {
    start: n(t[`border${o}Width`]) + n(t[`padding${o}`]),
    end: n(t[`border${r}Width`]) + n(t[`padding${r}`])
  };
}
function ei(t, e) {
  if (e.current != null && t.changedTouches) {
    const n = t;
    for (let o = 0; o < n.changedTouches.length; o += 1) {
      const r = n.changedTouches[o];
      if (r.identifier === e.current)
        return {
          x: r.clientX,
          y: r.clientY
        };
    }
    return null;
  }
  return {
    x: t.clientX,
    y: t.clientY
  };
}
const zb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    ...s
  } = e, {
    disabled: i,
    dragging: a,
    validation: l,
    inset: c,
    lastChangedValueRef: u,
    lastChangeReasonRef: d,
    max: p,
    min: m,
    minStepsBetweenValues: h,
    onValueCommitted: g,
    orientation: y,
    pressedInputRef: v,
    pressedThumbCenterOffsetRef: x,
    pressedThumbIndexRef: w,
    pressedValuesRef: E,
    registerFieldControlRef: S,
    renderBeforeHydration: C,
    setActive: _,
    setDragging: R,
    setValue: O,
    state: j,
    step: F,
    thumbCollisionBehavior: N,
    thumbRefs: T,
    values: L
  } = Da(), M = jo(), A = L.length > 1, $ = y === "vertical", k = f.useRef(null), H = f.useRef(null), B = fe((Z) => {
    Z && H.current == null && H.current == null && (H.current = getComputedStyle(Z));
  }), P = f.useRef(null), V = f.useRef(0), I = f.useRef(0), D = yt(L), z = fe((Z) => {
    w.current !== Z && (w.current = Z);
    const K = T.current[Z];
    if (!K) {
      x.current = null, v.current = null;
      return;
    }
    v.current = K.querySelector('input[type="range"]');
  }), U = fe((Z) => {
    const K = k.current;
    if (!K)
      return null;
    const {
      width: X,
      height: ne,
      bottom: re,
      left: ie,
      right: de
    } = K.getBoundingClientRect(), le = IM(H.current, $), te = I.current, pe = ($ ? ne : X) - le.start - le.end - te * 2, ue = x.current ?? 0, ye = Z.x - ue, ge = Z.y - ue, Te = $ ? re - ge - le.end : (M === "rtl" ? de - ye : ye - ie) - le.start, Se = cn((Te - te) / pe, 0, 1);
    let xe = (p - m) * Se + m;
    if (xe = Vb(xe, F, m), xe = cn(xe, m, p), !A)
      return {
        value: xe,
        thumbIndex: 0,
        didSwap: !1
      };
    const je = w.current;
    if (je < 0)
      return null;
    const Me = kM({
      behavior: N,
      values: L,
      currentValues: D.current ?? L,
      initialValues: E.current,
      pressedIndex: je,
      nextValue: xe,
      min: m,
      max: p,
      step: F,
      minStepsBetweenValues: h
    });
    return N === "swap" && Me.didSwap ? z(Me.thumbIndex) : w.current = Me.thumbIndex, Me;
  }), G = fe((Z) => {
    E.current = A ? L.slice() : null, D.current = L;
    const K = w.current;
    let X = K;
    if (K > -1 && K < L.length) {
      if (L[K] === p) {
        let ne = K;
        for (; ne > 0 && L[ne - 1] === p; )
          ne -= 1;
        X = ne;
      }
    } else {
      const ne = $ ? "y" : "x";
      let re;
      X = -1;
      for (let ie = 0; ie < T.current.length; ie += 1) {
        const de = T.current[ie];
        if (Ze(de)) {
          const le = Fb(de), te = Math.abs(Z[ne] - le[ne]);
          (re === void 0 || te <= re) && (X = ie, re = te);
        }
      }
    }
    if (X > -1 && X !== K && z(X), c) {
      const ne = T.current[X];
      if (Ze(ne)) {
        const re = ne.getBoundingClientRect(), ie = $ ? "height" : "width";
        I.current = re[ie] / 2;
      }
    }
  }), J = fe((Z) => {
    T.current?.[Z]?.querySelector('input[type="range"]')?.focus({
      preventScroll: !0
    });
  }), se = fe((Z) => {
    const K = ei(Z, P);
    if (K == null)
      return;
    if (V.current += 1, Z.type === "pointermove" && Z.buttons === 0) {
      Q(Z);
      return;
    }
    const X = U(K);
    X != null && Lb(X.value, F, h) && (!a && V.current > TM && R(!0), O(X.value, ke(Ay, Z, void 0, {
      activeThumbIndex: X.thumbIndex
    })), D.current = Array.isArray(X.value) ? X.value : [X.value], X.didSwap && J(X.thumbIndex));
  });
  function Q(Z) {
    _(-1), R(!1), v.current = null, x.current = null;
    const K = ei(Z, P), X = K != null ? U(K) : null;
    if (X != null) {
      const ne = d.current;
      l.commit(u.current ?? X.value), g(u.current ?? X.value, Yp(ne, Z));
    }
    "pointerType" in Z && k.current?.hasPointerCapture(Z.pointerId) && k.current?.releasePointerCapture(Z.pointerId), w.current = -1, P.current = null, E.current = null, W();
  }
  const ce = fe((Z) => {
    if (i)
      return;
    const K = Z.changedTouches[0];
    K != null && (P.current = K.identifier);
    const X = ei(Z, P);
    if (X != null) {
      G(X);
      const re = U(X);
      if (re == null)
        return;
      J(re.thumbIndex), O(re.value, ke(gd, Z, void 0, {
        activeThumbIndex: re.thumbIndex
      })), D.current = Array.isArray(re.value) ? re.value : [re.value], re.didSwap && J(re.thumbIndex);
    }
    V.current = 0;
    const ne = Ct(k.current);
    ne.addEventListener("touchmove", se, {
      passive: !0
    }), ne.addEventListener("touchend", Q, {
      passive: !0
    });
  }), W = fe(() => {
    const Z = Ct(k.current);
    Z.removeEventListener("pointermove", se), Z.removeEventListener("pointerup", Q), Z.removeEventListener("touchmove", se), Z.removeEventListener("touchend", Q), E.current = null;
  }), oe = $o();
  return f.useEffect(() => {
    const Z = k.current;
    return Z ? (Z.addEventListener("touchstart", ce, {
      passive: !0
    }), () => {
      Z.removeEventListener("touchstart", ce), oe.cancel(), W();
    }) : () => W();
  }, [W, ce, k, oe]), f.useEffect(() => {
    i && W();
  }, [i, W]), _e("div", e, {
    state: j,
    ref: [n, S, k, B],
    props: [{
      "data-base-ui-slider-control": C ? "" : void 0,
      onPointerDown(Z) {
        const K = k.current;
        if (!K || i || Z.defaultPrevented || !Ze(Z.target) || // Only handle left clicks
        Z.button !== 0)
          return;
        const X = ei(Z, P);
        if (X != null) {
          G(X);
          const re = U(X);
          if (re == null)
            return;
          Ue(T.current[re.thumbIndex], Jt(Ct(K))) ? Z.preventDefault() : oe.request(() => {
            J(re.thumbIndex);
          }), R(!0), x.current != null || (O(re.value, ke(gd, Z.nativeEvent, void 0, {
            activeThumbIndex: re.thumbIndex
          })), D.current = Array.isArray(re.value) ? re.value : [re.value], re.didSwap && J(re.thumbIndex));
        }
        Z.nativeEvent.pointerId && K.setPointerCapture(Z.nativeEvent.pointerId), V.current = 0;
        const ne = Ct(k.current);
        ne.addEventListener("pointermove", se, {
          passive: !0
        }), ne.addEventListener("pointerup", Q, {
          once: !0
        });
      },
      tabIndex: -1
    }, s],
    stateAttributesMapping: _s
  });
});
process.env.NODE_ENV !== "production" && (zb.displayName = "SliderControl");
const Bb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    ...s
  } = e, {
    state: i
  } = Da();
  return _e("div", e, {
    state: i,
    ref: n,
    props: [{
      style: {
        position: "relative"
      }
    }, s],
    stateAttributesMapping: _s
  });
});
process.env.NODE_ENV !== "production" && (Bb.displayName = "SliderTrack");
function uc(t, e, n) {
  return (t - e) * 100 / (n - e);
}
let OM = /* @__PURE__ */ (function(t) {
  return t.index = "data-index", t.dragging = "data-dragging", t.orientation = "data-orientation", t.disabled = "data-disabled", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.focused = "data-focused", t;
})({});
const MM = '!function(){const t=document.currentScript?.parentElement;if(!t)return;const e=t.closest("[data-base-ui-slider-control]");if(!e)return;const r=e.querySelector("[data-base-ui-slider-indicator]"),i=e.getBoundingClientRect(),n="vertical"===e.getAttribute("data-orientation")?"height":"width",o=e.querySelectorAll(\'input[type="range"]\'),l=o.length>1,s=o.length-1;let a=null,u=null;for(let t=0;t<o.length;t+=1){const e=o[t],y=parseFloat(e.getAttribute("value")??"");if(Number.isNaN(y))return;const c=e.parentElement;if(!c)return;const p=parseFloat(e.getAttribute("max")??"100"),g=parseFloat(e.getAttribute("min")??"0"),b=c?.getBoundingClientRect(),d=i[n]-b[n],m=100*(y-g)/(p-g),v=(b[n]/2+d*m/100)/i[n]*100;c.style.setProperty("--position",`${v}%`),Number.isFinite(v)&&(c.style.removeProperty("visibility"),r&&(0===t?(a=v,r.style.setProperty("--start-position",`${v}%`),l||r.style.removeProperty("visibility")):t===s&&(u=v-(a??0),r.style.setProperty("--end-position",`${v}%`),r.style.setProperty("--relative-size",`${u}%`),r.style.removeProperty("visibility"))))}}();', Hb = "PageUp", Ub = "PageDown", PM = /* @__PURE__ */ new Set([kn, gn, Hn, Tn, go, bo, Hb, Ub]);
function AM(t, e, n, o) {
  if (!(e < 0))
    return t.length === 2 ? e === 0 ? `${vi(t[e], o, n)} start range` : `${vi(t[e], o, n)} end range` : n ? vi(t[e], o, n) : void 0;
}
function Xo(t, e, n, o, r) {
  return n === 1 ? Math.min(t + e, r) : Math.max(t - e, o);
}
const Wb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    children: r,
    className: s,
    "aria-describedby": i,
    "aria-label": a,
    "aria-labelledby": l,
    disabled: c = !1,
    getAriaLabel: u,
    getAriaValueText: d,
    id: p,
    index: m,
    inputRef: h,
    onBlur: g,
    onFocus: y,
    onKeyDown: v,
    tabIndex: x,
    ...w
  } = e, {
    nonce: E
  } = Eb(), S = lt(p), {
    active: C,
    lastUsedThumbIndex: _,
    controlRef: R,
    disabled: O,
    validation: j,
    formatOptionsRef: F,
    handleInputChange: N,
    inset: T,
    labelId: L,
    largeStep: M,
    locale: A,
    max: $,
    min: k,
    minStepsBetweenValues: H,
    name: B,
    orientation: P,
    pressedInputRef: V,
    pressedThumbCenterOffsetRef: I,
    pressedThumbIndexRef: D,
    renderBeforeHydration: z,
    setActive: U,
    setIndicatorPosition: G,
    state: J,
    step: se,
    values: Q
  } = Da(), ce = jo(), W = c || O, oe = Q.length > 1, Y = P === "vertical", Z = ce === "rtl", {
    setTouched: K,
    setFocused: X,
    validationMode: ne
  } = dn(), re = f.useRef(null), ie = f.useRef(null), de = lt(), le = Ir(), te = oe ? de : le, pe = f.useMemo(() => ({
    inputId: te
  }), [te]), {
    ref: ue,
    index: ye
  } = Yn({
    metadata: pe
  }), ge = oe ? m ?? ye : 0, Te = ge === Q.length - 1, Se = Q[ge], xe = uc(Se, k, $), [je, Me] = f.useState(!1), [Pe, we] = f.useState();
  xr(() => Me(!0));
  const ve = _ >= 0 && _ < Q.length ? _ : -1, Ae = fe(() => {
    const Le = R.current, Ge = re.current;
    if (!Le || !Ge)
      return;
    const Ee = Ge.getBoundingClientRect(), Ke = Le.getBoundingClientRect(), Xe = Y ? "height" : "width", Je = Ke[Xe] - Ee[Xe], Ce = (Ee[Xe] / 2 + Je * xe / 100) / Ke[Xe] * 100;
    we(Ce), ge === 0 ? G(($e) => [Ce, $e[1]]) : Te && G(($e) => [$e[0], Ce]);
  });
  he(() => {
    T && queueMicrotask(Ae);
  }, [Ae, T]), he(() => {
    T && Ae();
  }, [Ae, T, xe]);
  const Ne = f.useCallback(() => {
    const Le = Y ? "bottom" : "insetInlineStart", Ge = Y ? "left" : "top";
    let Ee;
    return oe ? C === ge ? Ee = 2 : ve === ge && (Ee = 1) : C === ge && (Ee = 1), T ? {
      "--position": `${Pe}%`,
      visibility: z && !je || Pe === void 0 ? "hidden" : void 0,
      position: "absolute",
      [Le]: "var(--position)",
      [Ge]: "50%",
      translate: `${(Y || !Z ? -1 : 1) * 50}% ${(Y ? 1 : -1) * 50}%`,
      zIndex: Ee
    } : Number.isFinite(xe) ? {
      position: "absolute",
      [Le]: `${xe}%`,
      [Ge]: "50%",
      translate: `${(Y || !Z ? -1 : 1) * 50}% ${(Y ? 1 : -1) * 50}%`,
      zIndex: Ee
    } : Wn;
  }, [C, ge, T, je, Pe, oe, z, Z, ve, xe, Y]);
  let De;
  P === "vertical" && (De = Z ? "vertical-rl" : "vertical-lr");
  const ze = Qt({
    "aria-label": typeof u == "function" ? u(ge) : a,
    "aria-labelledby": l ?? L,
    "aria-describedby": i,
    "aria-orientation": P,
    "aria-valuenow": Se,
    "aria-valuetext": typeof d == "function" ? d(vi(Se, A, F.current ?? void 0), Se, ge) : AM(Q, ge, F.current ?? void 0, A),
    disabled: W,
    id: te,
    max: $,
    min: k,
    name: B,
    onChange(Le) {
      N(Le.target.valueAsNumber, ge, Le);
    },
    onFocus() {
      U(ge), X(!0);
    },
    onBlur() {
      re.current && (U(-1), K(!0), X(!1), ne === "onBlur" && j.commit(jb(Se, ge, k, $, oe, Q)));
    },
    onKeyDown(Le) {
      if (!PM.has(Le.key))
        return;
      ps.has(Le.key) && Le.stopPropagation();
      let Ge = null;
      const Ee = Vb(Se, se, k);
      switch (Le.key) {
        case kn:
          Ge = Xo(Ee, Le.shiftKey ? M : se, 1, k, $);
          break;
        case Tn:
          Ge = Xo(Ee, Le.shiftKey ? M : se, Z ? -1 : 1, k, $);
          break;
        case gn:
          Ge = Xo(Ee, Le.shiftKey ? M : se, -1, k, $);
          break;
        case Hn:
          Ge = Xo(Ee, Le.shiftKey ? M : se, Z ? 1 : -1, k, $);
          break;
        case Hb:
          Ge = Xo(Ee, M, 1, k, $);
          break;
        case Ub:
          Ge = Xo(Ee, M, -1, k, $);
          break;
        case bo:
          Ge = $, oe && (Ge = Number.isFinite(Q[ge + 1]) ? Q[ge + 1] - se * H : $);
          break;
        case go:
          Ge = k, oe && (Ge = Number.isFinite(Q[ge - 1]) ? Q[ge - 1] + se * H : k);
          break;
      }
      Ge !== null && (N(Ge, ge, Le), Le.preventDefault());
    },
    step: se,
    style: {
      ...Wn,
      // So that VoiceOver's focus indicator matches the thumb's dimensions
      width: "100%",
      height: "100%",
      writingMode: De
    },
    tabIndex: x ?? void 0,
    type: "range",
    value: Se ?? ""
  }, j.getInputValidationProps), et = zt(ie, j.inputRef, h);
  return _e("div", e, {
    state: J,
    ref: [n, ue, re],
    props: [{
      [OM.index]: ge,
      children: /* @__PURE__ */ b.jsxs(f.Fragment, {
        children: [r, /* @__PURE__ */ b.jsx("input", {
          ref: et,
          ...ze
        }), T && !je && z && // this must be rendered with the last thumb to ensure all
        // preceding thumbs are already rendered in the DOM
        Te && /* @__PURE__ */ b.jsx("script", {
          nonce: E,
          dangerouslySetInnerHTML: {
            __html: MM
          },
          suppressHydrationWarning: !0
        })]
      }),
      id: S,
      onBlur: g,
      onFocus: y,
      onPointerDown(Le) {
        if (D.current = ge, re.current != null) {
          const Ge = P === "horizontal" ? "x" : "y", Ee = Fb(re.current), Ke = (P === "horizontal" ? Le.clientX : Le.clientY) - Ee[Ge];
          I.current = Ke;
        }
        ie.current != null && V.current !== ie.current && (V.current = ie.current);
      },
      style: Ne(),
      suppressHydrationWarning: z || void 0,
      tabIndex: -1
    }, w],
    stateAttributesMapping: _s
  });
});
process.env.NODE_ENV !== "production" && (Wb.displayName = "SliderThumb");
function DM(t, e, n, o, r, s) {
  const i = n === void 0 || e && o === void 0 ? "hidden" : void 0, a = t ? "bottom" : "insetInlineStart", l = t ? "height" : "width", u = {
    visibility: r && !s ? "hidden" : i,
    position: t ? "absolute" : "relative",
    [t ? "width" : "height"]: "inherit"
  };
  return u["--start-position"] = `${n ?? 0}%`, e ? (u["--relative-size"] = `${(o ?? 0) - (n ?? 0)}%`, u[a] = "var(--start-position)", u[l] = "var(--relative-size)", u) : (u[a] = 0, u[l] = "var(--start-position)", u);
}
function jM(t, e, n, o) {
  const r = t ? "bottom" : "insetInlineStart", s = t ? "height" : "width", a = {
    position: t ? "absolute" : "relative",
    [t ? "width" : "height"]: "inherit"
  };
  if (!e)
    return a[r] = 0, a[s] = `${n}%`, a;
  const l = o - n;
  return a[r] = `${n}%`, a[s] = `${l}%`, a;
}
const Gb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    ...s
  } = e, {
    indicatorPosition: i,
    inset: a,
    max: l,
    min: c,
    orientation: u,
    renderBeforeHydration: d,
    state: p,
    values: m
  } = Da(), [h, g] = f.useState(!1);
  xr(() => g(!0));
  const y = u === "vertical", v = m.length > 1, x = a ? DM(y, v, i[0], i[1], d, h) : jM(y, v, uc(m[0], c, l), uc(m[m.length - 1], c, l));
  return _e("div", e, {
    state: p,
    ref: n,
    props: [{
      "data-base-ui-slider-indicator": d ? "" : void 0,
      style: x,
      suppressHydrationWarning: d || void 0
    }, s],
    stateAttributesMapping: _s
  });
});
process.env.NODE_ENV !== "production" && (Gb.displayName = "SliderIndicator");
const LM = 20, $M = {
  lg: "max-w-full w-[var(--field-width-lg)]",
  md: "max-w-full w-[var(--field-width-md)]",
  sm: "max-w-full w-[var(--field-width-sm)]"
}, gL = (t) => {
  const e = ee.c(91);
  let n, o, r, s, i, a, l, c, u, d, p, m, h;
  e[0] !== t ? ({
    "aria-label": n,
    className: o,
    defaultValue: r,
    disabled: s,
    max: u,
    min: d,
    onValueChange: i,
    orientation: p,
    step: l,
    style: c,
    value: h,
    width: m,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = p, e[12] = m, e[13] = h) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], p = e[11], m = e[12], h = e[13]);
  const g = u === void 0 ? 100 : u, y = d === void 0 ? 0 : d, v = p === void 0 ? "horizontal" : p, x = m === void 0 ? "full" : m, w = v === "vertical";
  let E;
  e: {
    if (!i) {
      E = void 0;
      break e;
    }
    let G;
    e[14] !== i ? (G = (J, se) => i(Array.isArray(J) ? J : [J], se), e[14] = i, e[15] = G) : G = e[15], E = G;
  }
  const S = E;
  let C, _, R, O, j, F, N, T, L, M, A, $, k, H, B, P, V, I, D;
  if (e[16] !== n || e[17] !== o || e[18] !== r || e[19] !== s || e[20] !== S || e[21] !== w || e[22] !== g || e[23] !== y || e[24] !== v || e[25] !== a || e[26] !== l || e[27] !== c || e[28] !== h || e[29] !== x) {
    const G = typeof h == "number" ? [h] : h, J = typeof r == "number" ? [r] : r, se = G ?? J ?? [y];
    let Q;
    e: {
      if (!l || (g - y) / l > LM) {
        let ne;
        e[49] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ne = [], e[49] = ne) : ne = e[49], Q = ne;
        break e;
      }
      let X;
      if (e[50] !== g || e[51] !== y || e[52] !== l) {
        X = [];
        for (let ne = y + l; ne < g; ne = ne + l, ne)
          X.push((ne - y) / (g - y) * 100);
        e[50] = g, e[51] = y, e[52] = l, e[53] = X;
      } else
        X = e[53];
      Q = X;
    }
    const ce = Q, W = w ? void 0 : x === "full" ? "w-full" : typeof x == "string" ? $M[x] : void 0;
    let oe;
    e[54] !== w || e[55] !== x ? (oe = !w && typeof x == "number" ? {
      maxWidth: "100%",
      width: `${x}px`
    } : void 0, e[54] = w, e[55] = x, e[56] = oe) : oe = e[56];
    const Y = oe;
    _ = $b, R = n, O = "slider", j = J, F = s, N = g, T = y, L = S, M = v, A = l, $ = G, e[57] !== o || e[58] !== W ? (k = ae("relative flex touch-none items-center select-none data-disabled:pointer-events-none data-disabled:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col", W, o), e[57] = o, e[58] = W, e[59] = k) : k = e[59], e[60] !== c || e[61] !== Y ? (H = Y ? {
      ...c,
      ...Y
    } : c, e[60] = c, e[61] = Y, e[62] = H) : H = e[62], B = a, C = zb, P = "slider-control", V = "flex w-full cursor-pointer touch-none items-center select-none data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col";
    let Z;
    e[63] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Z = /* @__PURE__ */ b.jsx(Gb, { "data-slot": "slider-indicator", className: "bg-action-primary-hover data-disabled:bg-border-strong data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full" }), e[63] = Z) : Z = e[63], e[64] !== w || e[65] !== ce ? (I = /* @__PURE__ */ b.jsxs(Bb, { "data-slot": "slider-track", className: "relative grow overflow-hidden rounded-full bg-default data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5", children: [
      Z,
      ce.map((X) => /* @__PURE__ */ b.jsx("span", { "aria-hidden": "true", className: "absolute size-[3px] rounded-full bg-muted", style: w ? {
        bottom: `${X}%`,
        left: "50%",
        transform: "translate(-50%, 50%)"
      } : {
        left: `${X}%`,
        top: "50%",
        transform: "translate(-50%, -50%)"
      } }, X))
    ] }), e[64] = w, e[65] = ce, e[66] = I) : I = e[66];
    let K;
    e[67] !== n ? (K = (X, ne) => /* @__PURE__ */ b.jsx(Wb, { "aria-label": n, "data-slot": "slider-thumb", index: ne, className: "border-action-primary-hover bg-canvas has-focus-visible:ring-ring-focus/50 block size-4 shrink-0 cursor-pointer rounded-full border-2 shadow-sm transition-[color,box-shadow] outline-none has-focus-visible:ring-[3px] data-disabled:size-3 data-disabled:border-border-strong data-disabled:bg-border-strong data-disabled:shadow-none" }, ne), e[67] = n, e[68] = K) : K = e[68], D = Array.from({
      length: se.length
    }, K), e[16] = n, e[17] = o, e[18] = r, e[19] = s, e[20] = S, e[21] = w, e[22] = g, e[23] = y, e[24] = v, e[25] = a, e[26] = l, e[27] = c, e[28] = h, e[29] = x, e[30] = C, e[31] = _, e[32] = R, e[33] = O, e[34] = j, e[35] = F, e[36] = N, e[37] = T, e[38] = L, e[39] = M, e[40] = A, e[41] = $, e[42] = k, e[43] = H, e[44] = B, e[45] = P, e[46] = V, e[47] = I, e[48] = D;
  } else
    C = e[30], _ = e[31], R = e[32], O = e[33], j = e[34], F = e[35], N = e[36], T = e[37], L = e[38], M = e[39], A = e[40], $ = e[41], k = e[42], H = e[43], B = e[44], P = e[45], V = e[46], I = e[47], D = e[48];
  let z;
  e[69] !== C || e[70] !== P || e[71] !== V || e[72] !== I || e[73] !== D ? (z = /* @__PURE__ */ b.jsxs(C, { "data-slot": P, className: V, children: [
    I,
    D
  ] }), e[69] = C, e[70] = P, e[71] = V, e[72] = I, e[73] = D, e[74] = z) : z = e[74];
  let U;
  return e[75] !== _ || e[76] !== R || e[77] !== O || e[78] !== j || e[79] !== F || e[80] !== N || e[81] !== T || e[82] !== L || e[83] !== M || e[84] !== A || e[85] !== $ || e[86] !== k || e[87] !== H || e[88] !== B || e[89] !== z ? (U = /* @__PURE__ */ b.jsx(_, { "aria-label": R, "data-slot": O, defaultValue: j, disabled: F, max: N, min: T, onValueChange: L, orientation: M, step: A, value: $, className: k, style: H, ...B, children: z }), e[75] = _, e[76] = R, e[77] = O, e[78] = j, e[79] = F, e[80] = N, e[81] = T, e[82] = L, e[83] = M, e[84] = A, e[85] = $, e[86] = k, e[87] = H, e[88] = B, e[89] = z, e[90] = U) : U = e[90], U;
}, bL = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("size-4 animate-spin", n), e[3] = n, e[4] = r) : r = e[4];
  const s = o;
  let i;
  return e[5] !== r || e[6] !== s ? (i = /* @__PURE__ */ b.jsx(Ve, { icon: tu, role: "status", "aria-label": "Loading", className: r, ...s }), e[5] = r, e[6] = s, e[7] = i) : i = e[7], i;
}, Gu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Gu.displayName = "TabsRootContext");
function Ku() {
  const t = f.useContext(Gu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : We(64));
  return t;
}
let FM = /* @__PURE__ */ (function(t) {
  return t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t;
})({});
const Yu = {
  tabActivationDirection: (t) => ({
    [FM.activationDirection]: t
  })
}, Kb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    defaultValue: r = 0,
    onValueChange: s,
    orientation: i = "horizontal",
    render: a,
    value: l,
    ...c
  } = e, u = jo(), d = Object.hasOwn(e, "defaultValue"), p = f.useRef([]), [m, h] = f.useState(() => /* @__PURE__ */ new Map()), [g, y] = un({
    controlled: l,
    default: r,
    name: "Tabs",
    state: "value"
  }), v = l !== void 0, [x, w] = f.useState(() => /* @__PURE__ */ new Map()), [E, S] = f.useState("none"), C = fe(($, k) => {
    s?.($, k), !k.isCanceled && (y($), S(k.activationDirection));
  }), _ = fe(($, k) => {
    h((H) => {
      if (H.get($) === k)
        return H;
      const B = new Map(H);
      return B.set($, k), B;
    });
  }), R = fe(($, k) => {
    h((H) => {
      if (!H.has($) || H.get($) !== k)
        return H;
      const B = new Map(H);
      return B.delete($), B;
    });
  }), O = f.useCallback(($) => m.get($), [m]), j = f.useCallback(($) => {
    for (const k of x.values())
      if ($ === k?.value)
        return k?.id;
  }, [x]), F = f.useCallback(($) => {
    if ($ === void 0)
      return null;
    for (const [k, H] of x.entries())
      if (H != null && $ === (H.value ?? H.index))
        return k;
    return null;
  }, [x]), N = f.useMemo(() => ({
    direction: u,
    getTabElementBySelectedValue: F,
    getTabIdByPanelValue: j,
    getTabPanelIdByValue: O,
    onValueChange: C,
    orientation: i,
    registerMountedTabPanel: _,
    setTabMap: w,
    unregisterMountedTabPanel: R,
    tabActivationDirection: E,
    value: g
  }), [u, F, j, O, C, i, _, w, R, E, g]), T = f.useMemo(() => {
    for (const $ of x.values())
      if ($ != null && $.value === g)
        return $;
  }, [x, g]), L = f.useMemo(() => {
    for (const $ of x.values())
      if ($ != null && !$.disabled)
        return $.value;
  }, [x]);
  he(() => {
    if (v || x.size === 0)
      return;
    const $ = T?.disabled, k = T == null && g !== null;
    if (d && $ && g === r || !$ && !k)
      return;
    const B = L ?? null;
    g !== B && (y(B), S("none"));
  }, [r, L, d, v, T, S, y, x, g]);
  const A = _e("div", e, {
    state: {
      orientation: i,
      tabActivationDirection: E
    },
    ref: n,
    props: c,
    stateAttributesMapping: Yu
  });
  return /* @__PURE__ */ b.jsx(Gu.Provider, {
    value: N,
    children: /* @__PURE__ */ b.jsx(yr, {
      elementsRef: p,
      children: A
    })
  });
});
process.env.NODE_ENV !== "production" && (Kb.displayName = "TabsRoot");
const qu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (qu.displayName = "TabsListContext");
function VM() {
  const t = f.useContext(qu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : We(65));
  return t;
}
const Yb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    disabled: r = !1,
    render: s,
    value: i,
    id: a,
    nativeButton: l = !0,
    ...c
  } = e, {
    value: u,
    getTabPanelIdByValue: d,
    orientation: p
  } = Ku(), {
    activateOnFocus: m,
    highlightedTabIndex: h,
    onTabActivation: g,
    setHighlightedTabIndex: y,
    tabsListElement: v
  } = VM(), x = lt(a), w = f.useMemo(() => ({
    disabled: r,
    id: x,
    value: i
  }), [r, x, i]), {
    compositeProps: E,
    compositeRef: S,
    index: C
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = Qh({
    metadata: w
  }), _ = i === u, R = f.useRef(!1);
  he(() => {
    if (R.current) {
      R.current = !1;
      return;
    }
    if (!(_ && C > -1 && h !== C))
      return;
    const H = v;
    if (H != null) {
      const B = Jt(Ct(H));
      if (B && Ue(H, B))
        return;
    }
    r || y(C);
  }, [_, C, h, y, r, v]);
  const {
    getButtonProps: O,
    buttonRef: j
  } = Wt({
    disabled: r,
    native: l,
    focusableWhenDisabled: !0
  }), F = d(i), N = f.useRef(!1), T = f.useRef(!1);
  function L(H) {
    _ || r || g(i, ke(Ut, H.nativeEvent, void 0, {
      activationDirection: "none"
    }));
  }
  function M(H) {
    _ || (C > -1 && !r && y(C), !r && m && (!N.current || // keyboard or touch focus
    N.current && T.current) && g(i, ke(Ut, H.nativeEvent, void 0, {
      activationDirection: "none"
    })));
  }
  function A(H) {
    if (_ || r)
      return;
    N.current = !0;
    function B() {
      N.current = !1, T.current = !1;
    }
    (!H.button || H.button === 0) && (T.current = !0, Ct(H.currentTarget).addEventListener("pointerup", B, {
      once: !0
    }));
  }
  const $ = f.useMemo(() => ({
    disabled: r,
    active: _,
    orientation: p
  }), [r, _, p]);
  return _e("button", e, {
    state: $,
    ref: [n, j, S],
    props: [E, {
      role: "tab",
      "aria-controls": F,
      "aria-selected": _,
      id: x,
      onClick: L,
      onFocus: M,
      onPointerDown: A,
      [su]: _ ? "" : void 0,
      onKeyDownCapture() {
        R.current = !0;
      }
    }, c, O]
  });
});
process.env.NODE_ENV !== "production" && (Yb.displayName = "TabsTab");
let zM = /* @__PURE__ */ (function(t) {
  return t.index = "data-index", t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t.hidden = "data-hidden", t;
})({});
const qb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    value: r,
    render: s,
    keepMounted: i = !1,
    ...a
  } = e, {
    value: l,
    getTabIdByPanelValue: c,
    orientation: u,
    tabActivationDirection: d,
    registerMountedTabPanel: p,
    unregisterMountedTabPanel: m
  } = Ku(), h = lt(), g = f.useMemo(() => ({
    id: h,
    value: r
  }), [h, r]), {
    ref: y,
    index: v
  } = Yn({
    metadata: g
  }), x = r !== l, w = c(r), E = f.useMemo(() => ({
    hidden: x,
    orientation: u,
    tabActivationDirection: d
  }), [x, u, d]), S = _e("div", e, {
    state: E,
    ref: [n, y],
    props: [{
      "aria-labelledby": w,
      hidden: x,
      id: h ?? void 0,
      role: "tabpanel",
      tabIndex: x ? -1 : 0,
      [zM.index]: v
    }, a],
    stateAttributesMapping: Yu
  });
  return he(() => {
    if (!(x && !i) && h != null)
      return p(r, h), () => {
        m(r, h);
      };
  }, [x, i, r, h, p, m]), !x || i ? S : null;
});
process.env.NODE_ENV !== "production" && (qb.displayName = "TabsPanel");
const Xb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    activateOnFocus: o = !1,
    className: r,
    loopFocus: s = !0,
    render: i,
    ...a
  } = e, {
    getTabElementBySelectedValue: l,
    onValueChange: c,
    orientation: u,
    value: d,
    setTabMap: p,
    tabActivationDirection: m
  } = Ku(), [h, g] = f.useState(0), [y, v] = f.useState(null), x = BM(
    d,
    // the old value
    u,
    y,
    l
  ), w = fe((_, R) => {
    if (_ !== d) {
      const O = x(_);
      R.activationDirection = O, c(_, R);
    }
  }), E = f.useMemo(() => ({
    orientation: u,
    tabActivationDirection: m
  }), [u, m]), S = {
    "aria-orientation": u === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, C = f.useMemo(() => ({
    activateOnFocus: o,
    highlightedTabIndex: h,
    onTabActivation: w,
    setHighlightedTabIndex: g,
    tabsListElement: y,
    value: d
  }), [o, h, w, g, y, d]);
  return /* @__PURE__ */ b.jsx(qu.Provider, {
    value: C,
    children: /* @__PURE__ */ b.jsx(ng, {
      render: i,
      className: r,
      state: E,
      refs: [n, v],
      props: [S, a],
      stateAttributesMapping: Yu,
      highlightedIndex: h,
      enableHomeAndEndKeys: !0,
      loopFocus: s,
      orientation: u,
      onHighlightedIndexChange: g,
      onMapChange: p,
      disabledIndices: zn
    })
  });
});
process.env.NODE_ENV !== "production" && (Xb.displayName = "TabsList");
function dp(t, e) {
  const {
    left: n,
    top: o
  } = t.getBoundingClientRect(), {
    left: r,
    top: s
  } = e.getBoundingClientRect(), i = n - r, a = o - s;
  return {
    left: i,
    top: a
  };
}
function BM(t, e, n, o) {
  const [r, s] = f.useState(null);
  return he(() => {
    if (t == null || n == null) {
      s(null);
      return;
    }
    const i = o(t);
    if (i == null) {
      s(null);
      return;
    }
    const {
      left: a,
      top: l
    } = dp(i, n);
    s(e === "horizontal" ? a : l);
  }, [e, o, n, t]), f.useCallback((i) => {
    if (i === t)
      return "none";
    if (i == null)
      return s(null), "none";
    if (i != null && n != null) {
      const a = o(i);
      if (a != null) {
        const {
          left: l,
          top: c
        } = dp(a, n);
        if (r == null)
          return s(e === "horizontal" ? l : c), "none";
        if (e === "horizontal") {
          if (l < r)
            return s(l), "left";
          if (l > r)
            return s(l), "right";
        } else {
          if (c < r)
            return s(c), "up";
          if (c > r)
            return s(c), "down";
        }
      }
    }
    return "none";
  }, [o, e, r, n, t]);
}
const vL = (t) => {
  const e = ee.c(10);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    orientation: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "horizontal" : r;
  let i;
  e[4] !== n ? (i = ae("gap-2 group/tabs flex data-[orientation=horizontal]:flex-col", n), e[4] = n, e[5] = i) : i = e[5];
  let a;
  return e[6] !== s || e[7] !== o || e[8] !== i ? (a = /* @__PURE__ */ b.jsx(Kb, { "data-slot": "tabs", "data-orientation": s, className: i, ...o }), e[6] = s, e[7] = o, e[8] = i, e[9] = a) : a = e[9], a;
}, HM = ra("rounded-lg p-[3px] group-data-horizontal/tabs:h-8 data-[variant=line]:rounded-none group/tabs-list text-muted inline-flex w-fit items-center justify-center group-data-[orientation=vertical]/tabs:h-fit group-data-[orientation=vertical]/tabs:flex-col", {
  defaultVariants: {
    variant: "default"
  },
  variants: {
    variant: {
      default: "bg-sunken",
      line: "gap-1 bg-transparent"
    }
  }
}), yL = (t) => {
  const e = ee.c(11);
  let n, o, r;
  e[0] !== t ? ({
    className: n,
    variant: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const s = r === void 0 ? "default" : r;
  let i;
  e[4] !== n || e[5] !== s ? (i = ae(HM({
    variant: s
  }), n), e[4] = n, e[5] = s, e[6] = i) : i = e[6];
  let a;
  return e[7] !== o || e[8] !== i || e[9] !== s ? (a = /* @__PURE__ */ b.jsx(Xb, { "data-slot": "tabs-list", "data-variant": s, className: i, ...o }), e[7] = o, e[8] = i, e[9] = s, e[10] = a) : a = e[10], a;
}, xL = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("gap-1.5 rounded-md border border-transparent px-1.5 py-0.5 text-sm font-medium group-data-[variant=default]/tabs-list:data-active:shadow-sm group-data-[variant=line]/tabs-list:data-active:shadow-none [&_svg:not([class*='size-'])]:size-4 focus-visible:border-ring-focus focus-visible:ring-ring-focus/50 focus-visible:outline-ring-focus text-primary/60 hover:text-primary dark:text-muted dark:hover:text-primary relative inline-flex h-[calc(100%-1px)] flex-1 cursor-pointer items-center justify-center whitespace-nowrap transition-all group-data-[orientation=vertical]/tabs:w-full group-data-[orientation=vertical]/tabs:justify-start focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0", "group-data-[variant=line]/tabs-list:bg-transparent group-data-[variant=line]/tabs-list:data-active:bg-transparent dark:group-data-[variant=line]/tabs-list:data-active:border-transparent dark:group-data-[variant=line]/tabs-list:data-active:bg-transparent", "data-active:bg-canvas dark:data-active:text-primary dark:data-active:border-default dark:data-active:bg-default/30 data-active:text-primary", "after:bg-action-primary after:absolute after:opacity-0 after:transition-opacity group-data-[orientation=horizontal]/tabs:after:inset-x-0 group-data-[orientation=horizontal]/tabs:after:bottom-[-5px] group-data-[orientation=horizontal]/tabs:after:h-0.5 group-data-[orientation=vertical]/tabs:after:inset-y-0 group-data-[orientation=vertical]/tabs:after:-right-1 group-data-[orientation=vertical]/tabs:after:w-0.5 group-data-[variant=line]/tabs-list:data-active:after:opacity-100", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(Yb, { "data-slot": "tabs-trigger", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, wL = (t) => {
  const e = ee.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ae("text-sm flex-1 outline-none", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(qb, { "data-slot": "tabs-content", className: r, ...o }), e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, UM = "_textarea_12cvt_1", WM = "_readOnly_12cvt_58", GM = "_copyable_12cvt_64", KM = "_resizeNone_12cvt_68", YM = "_resizeVertical_12cvt_72", qM = "_resizeBoth_12cvt_76", XM = "_wrapper_12cvt_80", ZM = "_widthSm_12cvt_88", JM = "_widthMd_12cvt_93", QM = "_widthLg_12cvt_98", eP = "_widthFull_12cvt_103", tP = "_copy_12cvt_64", nP = "_count_12cvt_114", oP = "_countDanger_12cvt_121", Yt = {
  textarea: UM,
  readOnly: WM,
  copyable: GM,
  resizeNone: KM,
  resizeVertical: YM,
  resizeBoth: qM,
  wrapper: XM,
  widthSm: ZM,
  widthMd: JM,
  widthLg: QM,
  widthFull: eP,
  copy: tP,
  count: nP,
  countDanger: oP
}, rP = {
  both: Yt.resizeBoth,
  none: Yt.resizeNone,
  vertical: Yt.resizeVertical
}, sP = {
  full: Yt.widthFull,
  lg: Yt.widthLg,
  md: Yt.widthMd,
  sm: Yt.widthSm
}, SL = (t) => {
  const e = ee.c(62);
  let n, o, r, s, i, a, l, c, u, d, p, m, h, g, y;
  e[0] !== t ? ({
    className: n,
    copyable: d,
    copyLabel: p,
    defaultValue: o,
    disabled: r,
    maxLength: s,
    onChange: i,
    readOnly: l,
    ref: c,
    resize: m,
    showCount: h,
    style: u,
    value: y,
    width: g,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u, e[10] = d, e[11] = p, e[12] = m, e[13] = h, e[14] = g, e[15] = y) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9], d = e[10], p = e[11], m = e[12], h = e[13], g = e[14], y = e[15]);
  const v = d === void 0 ? !1 : d, x = p === void 0 ? "Copy" : p, w = m === void 0 ? "vertical" : m, E = h === void 0 ? !1 : h, S = g === void 0 ? "full" : g, C = f.useRef(null), _ = y !== void 0;
  let R;
  e[16] !== o ? (R = () => String(o ?? "").length, e[16] = o, e[17] = R) : R = e[17];
  const [O, j] = f.useState(R), F = _ ? String(y ?? "").length : O, N = F > 0;
  let T;
  e[18] !== c ? (T = (ne) => {
    C.current = ne, typeof c == "function" ? c(ne) : c != null && (c.current = ne);
  }, e[18] = c, e[19] = T) : T = e[19];
  const L = T;
  let M;
  e[20] !== _ || e[21] !== i ? (M = (ne) => {
    _ || j(ne.target.value.length), i?.(ne);
  }, e[20] = _, e[21] = i, e[22] = M) : M = e[22];
  const A = M, $ = v && !!l, k = E || v, H = !$ && !E, B = typeof S == "number" ? void 0 : sP[S];
  let P;
  e[23] !== S ? (P = typeof S == "number" ? {
    maxWidth: "100%",
    width: `${S}px`
  } : void 0, e[23] = S, e[24] = P) : P = e[24];
  const V = P;
  let I;
  e[25] !== u || e[26] !== V ? (I = u || V ? {
    ...u,
    ...V
  } : void 0, e[25] = u, e[26] = V, e[27] = I) : I = e[27];
  const D = I, z = rP[w], U = l && Yt.readOnly, G = $ && Yt.copyable, J = H && B;
  let se;
  e[28] !== n || e[29] !== z || e[30] !== U || e[31] !== G || e[32] !== J ? (se = ae(Yt.textarea, z, U, G, J, n), e[28] = n, e[29] = z, e[30] = U, e[31] = G, e[32] = J, e[33] = se) : se = e[33];
  const Q = k ? A : i, ce = H ? D : void 0;
  let W;
  e[34] !== o || e[35] !== r || e[36] !== s || e[37] !== a || e[38] !== l || e[39] !== L || e[40] !== se || e[41] !== Q || e[42] !== ce || e[43] !== y ? (W = /* @__PURE__ */ b.jsx("textarea", { ref: L, "data-slot": "textarea", className: se, defaultValue: o, disabled: r, maxLength: s, onChange: Q, readOnly: l, style: ce, value: y, ...a }), e[34] = o, e[35] = r, e[36] = s, e[37] = a, e[38] = l, e[39] = L, e[40] = se, e[41] = Q, e[42] = ce, e[43] = y, e[44] = W) : W = e[44];
  const oe = W;
  if (H)
    return oe;
  let Y;
  e[45] !== B ? (Y = ae(Yt.wrapper, B), e[45] = B, e[46] = Y) : Y = e[46];
  let Z;
  e[47] !== x || e[48] !== r || e[49] !== N || e[50] !== $ ? (Z = $ && N && !r ? /* @__PURE__ */ b.jsx(xg, { className: Yt.copy, label: x, tabIndex: -1, value: () => C.current?.value ?? "" }) : null, e[47] = x, e[48] = r, e[49] = N, e[50] = $, e[51] = Z) : Z = e[51];
  let K;
  e[52] !== F || e[53] !== s || e[54] !== E ? (K = E ? /* @__PURE__ */ b.jsx("span", { className: ae(Yt.count, s !== void 0 && F >= s && Yt.countDanger), "data-slot": "textarea-count", children: s !== void 0 ? `${F} / ${s}` : F }) : null, e[52] = F, e[53] = s, e[54] = E, e[55] = K) : K = e[55];
  let X;
  return e[56] !== D || e[57] !== Y || e[58] !== Z || e[59] !== K || e[60] !== oe ? (X = /* @__PURE__ */ b.jsxs("span", { className: Y, "data-slot": "textarea-wrapper", style: D, children: [
    oe,
    Z,
    K
  ] }), e[56] = D, e[57] = Y, e[58] = Z, e[59] = K, e[60] = oe, e[61] = X) : X = e[61], X;
}, iP = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></g>'
}, aP = iP, lP = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4m0-4h.01"/></g>'
}, cP = lP, uP = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2zM15 9l-6 6m0-6l6 6"/>'
}, dP = uP;
var fP = (t, e, n, o, r, s, i, a) => {
  let l = document.documentElement, c = ["light", "dark"];
  function u(m) {
    (Array.isArray(t) ? t : [t]).forEach((h) => {
      let g = h === "class", y = g && s ? r.map((v) => s[v] || v) : r;
      g ? (l.classList.remove(...y), l.classList.add(s && s[m] ? s[m] : m)) : l.setAttribute(h, m);
    }), d(m);
  }
  function d(m) {
    a && c.includes(m) && (l.style.colorScheme = m);
  }
  function p() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  if (o) u(o);
  else try {
    let m = localStorage.getItem(e) || n, h = i && m === "system" ? p() : m;
    u(h);
  } catch {
  }
}, pP = f.createContext(void 0), mP = { setTheme: (t) => {
}, themes: [] }, hP = () => {
  var t;
  return (t = f.useContext(pP)) != null ? t : mP;
};
f.memo(({ forcedTheme: t, storageKey: e, attribute: n, enableSystem: o, enableColorScheme: r, defaultTheme: s, value: i, themes: a, nonce: l, scriptProps: c }) => {
  let u = JSON.stringify([n, e, s, t, a, i, o, r]).slice(1, -1);
  return f.createElement("script", { ...c, suppressHydrationWarning: !0, nonce: typeof window > "u" ? l : "", dangerouslySetInnerHTML: { __html: `(${fP.toString()})(${u})` } });
});
function gP(t) {
  if (typeof document > "u") return;
  let e = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", e.appendChild(n), n.styleSheet ? n.styleSheet.cssText = t : n.appendChild(document.createTextNode(t));
}
const bP = (t) => {
  switch (t) {
    case "success":
      return xP;
    case "info":
      return SP;
    case "warning":
      return wP;
    case "error":
      return EP;
    default:
      return null;
  }
}, vP = Array(12).fill(0), yP = ({ visible: t, className: e }) => /* @__PURE__ */ q.createElement("div", {
  className: [
    "sonner-loading-wrapper",
    e
  ].filter(Boolean).join(" "),
  "data-visible": t
}, /* @__PURE__ */ q.createElement("div", {
  className: "sonner-spinner"
}, vP.map((n, o) => /* @__PURE__ */ q.createElement("div", {
  className: "sonner-loading-bar",
  key: `spinner-bar-${o}`
})))), xP = /* @__PURE__ */ q.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ q.createElement("path", {
  fillRule: "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  clipRule: "evenodd"
})), wP = /* @__PURE__ */ q.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ q.createElement("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
})), SP = /* @__PURE__ */ q.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ q.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  clipRule: "evenodd"
})), EP = /* @__PURE__ */ q.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ q.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  clipRule: "evenodd"
})), CP = /* @__PURE__ */ q.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /* @__PURE__ */ q.createElement("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /* @__PURE__ */ q.createElement("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})), _P = () => {
  const [t, e] = q.useState(document.hidden);
  return q.useEffect(() => {
    const n = () => {
      e(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), t;
};
let dc = 1;
class RP {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      const n = this.subscribers.indexOf(e);
      this.subscribers.splice(n, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((n) => n(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [
        ...this.toasts,
        e
      ];
    }, this.create = (e) => {
      var n;
      const { message: o, ...r } = e, s = typeof e?.id == "number" || ((n = e.id) == null ? void 0 : n.length) > 0 ? e.id : dc++, i = this.toasts.find((l) => l.id === s), a = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(s) && this.dismissedToasts.delete(s), i ? this.toasts = this.toasts.map((l) => l.id === s ? (this.publish({
        ...l,
        ...e,
        id: s,
        title: o
      }), {
        ...l,
        ...e,
        id: s,
        dismissible: a,
        title: o
      }) : l) : this.addToast({
        title: o,
        ...r,
        dismissible: a,
        id: s
      }), s;
    }, this.dismiss = (e) => (e ? (this.dismissedToasts.add(e), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: e,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((o) => o({
        id: n.id,
        dismiss: !0
      }));
    }), e), this.message = (e, n) => this.create({
      ...n,
      message: e
    }), this.error = (e, n) => this.create({
      ...n,
      message: e,
      type: "error"
    }), this.success = (e, n) => this.create({
      ...n,
      type: "success",
      message: e
    }), this.info = (e, n) => this.create({
      ...n,
      type: "info",
      message: e
    }), this.warning = (e, n) => this.create({
      ...n,
      type: "warning",
      message: e
    }), this.loading = (e, n) => this.create({
      ...n,
      type: "loading",
      message: e
    }), this.promise = (e, n) => {
      if (!n)
        return;
      let o;
      n.loading !== void 0 && (o = this.create({
        ...n,
        promise: e,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const r = Promise.resolve(e instanceof Function ? e() : e);
      let s = o !== void 0, i;
      const a = r.then(async (c) => {
        if (i = [
          "resolve",
          c
        ], q.isValidElement(c))
          s = !1, this.create({
            id: o,
            type: "default",
            message: c
          });
        else if (kP(c) && !c.ok) {
          s = !1;
          const d = typeof n.error == "function" ? await n.error(`HTTP error! status: ${c.status}`) : n.error, p = typeof n.description == "function" ? await n.description(`HTTP error! status: ${c.status}`) : n.description, h = typeof d == "object" && !q.isValidElement(d) ? d : {
            message: d
          };
          this.create({
            id: o,
            type: "error",
            description: p,
            ...h
          });
        } else if (c instanceof Error) {
          s = !1;
          const d = typeof n.error == "function" ? await n.error(c) : n.error, p = typeof n.description == "function" ? await n.description(c) : n.description, h = typeof d == "object" && !q.isValidElement(d) ? d : {
            message: d
          };
          this.create({
            id: o,
            type: "error",
            description: p,
            ...h
          });
        } else if (n.success !== void 0) {
          s = !1;
          const d = typeof n.success == "function" ? await n.success(c) : n.success, p = typeof n.description == "function" ? await n.description(c) : n.description, h = typeof d == "object" && !q.isValidElement(d) ? d : {
            message: d
          };
          this.create({
            id: o,
            type: "success",
            description: p,
            ...h
          });
        }
      }).catch(async (c) => {
        if (i = [
          "reject",
          c
        ], n.error !== void 0) {
          s = !1;
          const u = typeof n.error == "function" ? await n.error(c) : n.error, d = typeof n.description == "function" ? await n.description(c) : n.description, m = typeof u == "object" && !q.isValidElement(u) ? u : {
            message: u
          };
          this.create({
            id: o,
            type: "error",
            description: d,
            ...m
          });
        }
      }).finally(() => {
        s && (this.dismiss(o), o = void 0), n.finally == null || n.finally.call(n);
      }), l = () => new Promise((c, u) => a.then(() => i[0] === "reject" ? u(i[1]) : c(i[1])).catch(u));
      return typeof o != "string" && typeof o != "number" ? {
        unwrap: l
      } : Object.assign(o, {
        unwrap: l
      });
    }, this.custom = (e, n) => {
      const o = n?.id || dc++;
      return this.create({
        jsx: e(o),
        id: o,
        ...n
      }), o;
    }, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}
const Kt = new RP(), NP = (t, e) => {
  const n = e?.id || dc++;
  return Kt.addToast({
    title: t,
    ...e,
    id: n
  }), n;
}, kP = (t) => t && typeof t == "object" && "ok" in t && typeof t.ok == "boolean" && "status" in t && typeof t.status == "number", TP = NP, IP = () => Kt.toasts, OP = () => Kt.getActiveToasts(), Zr = Object.assign(TP, {
  success: Kt.success,
  info: Kt.info,
  warning: Kt.warning,
  error: Kt.error,
  custom: Kt.custom,
  message: Kt.message,
  promise: Kt.promise,
  dismiss: Kt.dismiss,
  loading: Kt.loading
}, {
  getHistory: IP,
  getToasts: OP
});
gP("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function ti(t) {
  return t.label !== void 0;
}
const MP = 3, PP = "24px", AP = "16px", fp = 4e3, DP = 356, jP = 14, LP = 45, $P = 200;
function En(...t) {
  return t.filter(Boolean).join(" ");
}
function FP(t) {
  const [e, n] = t.split("-"), o = [];
  return e && o.push(e), n && o.push(n), o;
}
const VP = (t) => {
  var e, n, o, r, s, i, a, l, c;
  const { invert: u, toast: d, unstyled: p, interacting: m, setHeights: h, visibleToasts: g, heights: y, index: v, toasts: x, expanded: w, removeToast: E, defaultRichColors: S, closeButton: C, style: _, cancelButtonStyle: R, actionButtonStyle: O, className: j = "", descriptionClassName: F = "", duration: N, position: T, gap: L, expandByDefault: M, classNames: A, icons: $, closeButtonAriaLabel: k = "Close toast" } = t, [H, B] = q.useState(null), [P, V] = q.useState(null), [I, D] = q.useState(!1), [z, U] = q.useState(!1), [G, J] = q.useState(!1), [se, Q] = q.useState(!1), [ce, W] = q.useState(!1), [oe, Y] = q.useState(0), [Z, K] = q.useState(0), X = q.useRef(d.duration || N || fp), ne = q.useRef(null), re = q.useRef(null), ie = v === 0, de = v + 1 <= g, le = d.type, te = d.dismissible !== !1, pe = d.className || "", ue = d.descriptionClassName || "", ye = q.useMemo(() => y.findIndex((Ee) => Ee.toastId === d.id) || 0, [
    y,
    d.id
  ]), ge = q.useMemo(() => {
    var Ee;
    return (Ee = d.closeButton) != null ? Ee : C;
  }, [
    d.closeButton,
    C
  ]), Te = q.useMemo(() => d.duration || N || fp, [
    d.duration,
    N
  ]), Se = q.useRef(0), xe = q.useRef(0), je = q.useRef(0), Me = q.useRef(null), [Pe, we] = T.split("-"), ve = q.useMemo(() => y.reduce((Ee, Ke, Xe) => Xe >= ye ? Ee : Ee + Ke.height, 0), [
    y,
    ye
  ]), Ae = _P(), Ne = d.invert || u, De = le === "loading";
  xe.current = q.useMemo(() => ye * L + ve, [
    ye,
    ve
  ]), q.useEffect(() => {
    X.current = Te;
  }, [
    Te
  ]), q.useEffect(() => {
    D(!0);
  }, []), q.useEffect(() => {
    const Ee = re.current;
    if (Ee) {
      const Ke = Ee.getBoundingClientRect().height;
      return K(Ke), h((Xe) => [
        {
          toastId: d.id,
          height: Ke,
          position: d.position
        },
        ...Xe
      ]), () => h((Xe) => Xe.filter((Je) => Je.toastId !== d.id));
    }
  }, [
    h,
    d.id
  ]), q.useLayoutEffect(() => {
    if (!I) return;
    const Ee = re.current, Ke = Ee.style.height;
    Ee.style.height = "auto";
    const Xe = Ee.getBoundingClientRect().height;
    Ee.style.height = Ke, K(Xe), h((Je) => Je.find((Ce) => Ce.toastId === d.id) ? Je.map((Ce) => Ce.toastId === d.id ? {
      ...Ce,
      height: Xe
    } : Ce) : [
      {
        toastId: d.id,
        height: Xe,
        position: d.position
      },
      ...Je
    ]);
  }, [
    I,
    d.title,
    d.description,
    h,
    d.id,
    d.jsx,
    d.action,
    d.cancel
  ]);
  const ze = q.useCallback(() => {
    U(!0), Y(xe.current), h((Ee) => Ee.filter((Ke) => Ke.toastId !== d.id)), setTimeout(() => {
      E(d);
    }, $P);
  }, [
    d,
    E,
    h,
    xe
  ]);
  q.useEffect(() => {
    if (d.promise && le === "loading" || d.duration === 1 / 0 || d.type === "loading") return;
    let Ee;
    return w || m || Ae ? (() => {
      if (je.current < Se.current) {
        const Je = (/* @__PURE__ */ new Date()).getTime() - Se.current;
        X.current = X.current - Je;
      }
      je.current = (/* @__PURE__ */ new Date()).getTime();
    })() : X.current !== 1 / 0 && (Se.current = (/* @__PURE__ */ new Date()).getTime(), Ee = setTimeout(() => {
      d.onAutoClose == null || d.onAutoClose.call(d, d), ze();
    }, X.current)), () => clearTimeout(Ee);
  }, [
    w,
    m,
    d,
    le,
    Ae,
    ze
  ]), q.useEffect(() => {
    d.delete && (ze(), d.onDismiss == null || d.onDismiss.call(d, d));
  }, [
    ze,
    d.delete
  ]);
  function et() {
    var Ee;
    if ($?.loading) {
      var Ke;
      return /* @__PURE__ */ q.createElement("div", {
        className: En(A?.loader, d == null || (Ke = d.classNames) == null ? void 0 : Ke.loader, "sonner-loader"),
        "data-visible": le === "loading"
      }, $.loading);
    }
    return /* @__PURE__ */ q.createElement(yP, {
      className: En(A?.loader, d == null || (Ee = d.classNames) == null ? void 0 : Ee.loader),
      visible: le === "loading"
    });
  }
  const ct = d.icon || $?.[le] || bP(le);
  var Le, Ge;
  return /* @__PURE__ */ q.createElement("li", {
    tabIndex: 0,
    ref: re,
    className: En(j, pe, A?.toast, d == null || (e = d.classNames) == null ? void 0 : e.toast, A?.default, A?.[le], d == null || (n = d.classNames) == null ? void 0 : n[le]),
    "data-sonner-toast": "",
    "data-rich-colors": (Le = d.richColors) != null ? Le : S,
    "data-styled": !(d.jsx || d.unstyled || p),
    "data-mounted": I,
    "data-promise": !!d.promise,
    "data-swiped": ce,
    "data-removed": z,
    "data-visible": de,
    "data-y-position": Pe,
    "data-x-position": we,
    "data-index": v,
    "data-front": ie,
    "data-swiping": G,
    "data-dismissible": te,
    "data-type": le,
    "data-invert": Ne,
    "data-swipe-out": se,
    "data-swipe-direction": P,
    "data-expanded": !!(w || M && I),
    "data-testid": d.testId,
    style: {
      "--index": v,
      "--toasts-before": v,
      "--z-index": x.length - v,
      "--offset": `${z ? oe : xe.current}px`,
      "--initial-height": M ? "auto" : `${Z}px`,
      ..._,
      ...d.style
    },
    onDragEnd: () => {
      J(!1), B(null), Me.current = null;
    },
    onPointerDown: (Ee) => {
      Ee.button !== 2 && (De || !te || (ne.current = /* @__PURE__ */ new Date(), Y(xe.current), Ee.target.setPointerCapture(Ee.pointerId), Ee.target.tagName !== "BUTTON" && (J(!0), Me.current = {
        x: Ee.clientX,
        y: Ee.clientY
      })));
    },
    onPointerUp: () => {
      var Ee, Ke, Xe;
      if (se || !te) return;
      Me.current = null;
      const Je = Number(((Ee = re.current) == null ? void 0 : Ee.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), wt = Number(((Ke = re.current) == null ? void 0 : Ke.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Ce = (/* @__PURE__ */ new Date()).getTime() - ((Xe = ne.current) == null ? void 0 : Xe.getTime()), $e = H === "x" ? Je : wt, st = Math.abs($e) / Ce;
      if (Math.abs($e) >= LP || st > 0.11) {
        Y(xe.current), d.onDismiss == null || d.onDismiss.call(d, d), V(H === "x" ? Je > 0 ? "right" : "left" : wt > 0 ? "down" : "up"), ze(), Q(!0);
        return;
      } else {
        var tt, Qe;
        (tt = re.current) == null || tt.style.setProperty("--swipe-amount-x", "0px"), (Qe = re.current) == null || Qe.style.setProperty("--swipe-amount-y", "0px");
      }
      W(!1), J(!1), B(null);
    },
    onPointerMove: (Ee) => {
      var Ke, Xe, Je;
      if (!Me.current || !te || ((Ke = window.getSelection()) == null ? void 0 : Ke.toString().length) > 0) return;
      const Ce = Ee.clientY - Me.current.y, $e = Ee.clientX - Me.current.x;
      var st;
      const tt = (st = t.swipeDirections) != null ? st : FP(T);
      !H && (Math.abs($e) > 1 || Math.abs(Ce) > 1) && B(Math.abs($e) > Math.abs(Ce) ? "x" : "y");
      let Qe = {
        x: 0,
        y: 0
      };
      const ht = (St) => 1 / (1.5 + Math.abs(St) / 20);
      if (H === "y") {
        if (tt.includes("top") || tt.includes("bottom"))
          if (tt.includes("top") && Ce < 0 || tt.includes("bottom") && Ce > 0)
            Qe.y = Ce;
          else {
            const St = Ce * ht(Ce);
            Qe.y = Math.abs(St) < Math.abs(Ce) ? St : Ce;
          }
      } else if (H === "x" && (tt.includes("left") || tt.includes("right")))
        if (tt.includes("left") && $e < 0 || tt.includes("right") && $e > 0)
          Qe.x = $e;
        else {
          const St = $e * ht($e);
          Qe.x = Math.abs(St) < Math.abs($e) ? St : $e;
        }
      (Math.abs(Qe.x) > 0 || Math.abs(Qe.y) > 0) && W(!0), (Xe = re.current) == null || Xe.style.setProperty("--swipe-amount-x", `${Qe.x}px`), (Je = re.current) == null || Je.style.setProperty("--swipe-amount-y", `${Qe.y}px`);
    }
  }, ge && !d.jsx && le !== "loading" ? /* @__PURE__ */ q.createElement("button", {
    "aria-label": k,
    "data-disabled": De,
    "data-close-button": !0,
    onClick: De || !te ? () => {
    } : () => {
      ze(), d.onDismiss == null || d.onDismiss.call(d, d);
    },
    className: En(A?.closeButton, d == null || (o = d.classNames) == null ? void 0 : o.closeButton)
  }, (Ge = $?.close) != null ? Ge : CP) : null, (le || d.icon || d.promise) && d.icon !== null && ($?.[le] !== null || d.icon) ? /* @__PURE__ */ q.createElement("div", {
    "data-icon": "",
    className: En(A?.icon, d == null || (r = d.classNames) == null ? void 0 : r.icon)
  }, d.promise || d.type === "loading" && !d.icon ? d.icon || et() : null, d.type !== "loading" ? ct : null) : null, /* @__PURE__ */ q.createElement("div", {
    "data-content": "",
    className: En(A?.content, d == null || (s = d.classNames) == null ? void 0 : s.content)
  }, /* @__PURE__ */ q.createElement("div", {
    "data-title": "",
    className: En(A?.title, d == null || (i = d.classNames) == null ? void 0 : i.title)
  }, d.jsx ? d.jsx : typeof d.title == "function" ? d.title() : d.title), d.description ? /* @__PURE__ */ q.createElement("div", {
    "data-description": "",
    className: En(F, ue, A?.description, d == null || (a = d.classNames) == null ? void 0 : a.description)
  }, typeof d.description == "function" ? d.description() : d.description) : null), /* @__PURE__ */ q.isValidElement(d.cancel) ? d.cancel : d.cancel && ti(d.cancel) ? /* @__PURE__ */ q.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: d.cancelButtonStyle || R,
    onClick: (Ee) => {
      ti(d.cancel) && te && (d.cancel.onClick == null || d.cancel.onClick.call(d.cancel, Ee), ze());
    },
    className: En(A?.cancelButton, d == null || (l = d.classNames) == null ? void 0 : l.cancelButton)
  }, d.cancel.label) : null, /* @__PURE__ */ q.isValidElement(d.action) ? d.action : d.action && ti(d.action) ? /* @__PURE__ */ q.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: d.actionButtonStyle || O,
    onClick: (Ee) => {
      ti(d.action) && (d.action.onClick == null || d.action.onClick.call(d.action, Ee), !Ee.defaultPrevented && ze());
    },
    className: En(A?.actionButton, d == null || (c = d.classNames) == null ? void 0 : c.actionButton)
  }, d.action.label) : null);
};
function pp() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const t = document.documentElement.getAttribute("dir");
  return t === "auto" || !t ? window.getComputedStyle(document.documentElement).direction : t;
}
function zP(t, e) {
  const n = {};
  return [
    t,
    e
  ].forEach((o, r) => {
    const s = r === 1, i = s ? "--mobile-offset" : "--offset", a = s ? AP : PP;
    function l(c) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((u) => {
        n[`${i}-${u}`] = typeof c == "number" ? `${c}px` : c;
      });
    }
    typeof o == "number" || typeof o == "string" ? l(o) : typeof o == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((c) => {
      o[c] === void 0 ? n[`${i}-${c}`] = a : n[`${i}-${c}`] = typeof o[c] == "number" ? `${o[c]}px` : o[c];
    }) : l(a);
  }), n;
}
const BP = /* @__PURE__ */ q.forwardRef(function(e, n) {
  const { id: o, invert: r, position: s = "bottom-right", hotkey: i = [
    "altKey",
    "KeyT"
  ], expand: a, closeButton: l, className: c, offset: u, mobileOffset: d, theme: p = "light", richColors: m, duration: h, style: g, visibleToasts: y = MP, toastOptions: v, dir: x = pp(), gap: w = jP, icons: E, containerAriaLabel: S = "Notifications" } = e, [C, _] = q.useState([]), R = q.useMemo(() => o ? C.filter((I) => I.toasterId === o) : C.filter((I) => !I.toasterId), [
    C,
    o
  ]), O = q.useMemo(() => Array.from(new Set([
    s
  ].concat(R.filter((I) => I.position).map((I) => I.position)))), [
    R,
    s
  ]), [j, F] = q.useState([]), [N, T] = q.useState(!1), [L, M] = q.useState(!1), [A, $] = q.useState(p !== "system" ? p : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), k = q.useRef(null), H = i.join("+").replace(/Key/g, "").replace(/Digit/g, ""), B = q.useRef(null), P = q.useRef(!1), V = q.useCallback((I) => {
    _((D) => {
      var z;
      return (z = D.find((U) => U.id === I.id)) != null && z.delete || Kt.dismiss(I.id), D.filter(({ id: U }) => U !== I.id);
    });
  }, []);
  return q.useEffect(() => Kt.subscribe((I) => {
    if (I.dismiss) {
      requestAnimationFrame(() => {
        _((D) => D.map((z) => z.id === I.id ? {
          ...z,
          delete: !0
        } : z));
      });
      return;
    }
    setTimeout(() => {
      $p.flushSync(() => {
        _((D) => {
          const z = D.findIndex((U) => U.id === I.id);
          return z !== -1 ? [
            ...D.slice(0, z),
            {
              ...D[z],
              ...I
            },
            ...D.slice(z + 1)
          ] : [
            I,
            ...D
          ];
        });
      });
    });
  }), [
    C
  ]), q.useEffect(() => {
    if (p !== "system") {
      $(p);
      return;
    }
    if (p === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? $("dark") : $("light")), typeof window > "u") return;
    const I = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      I.addEventListener("change", ({ matches: D }) => {
        $(D ? "dark" : "light");
      });
    } catch {
      I.addListener(({ matches: z }) => {
        try {
          $(z ? "dark" : "light");
        } catch (U) {
          console.error(U);
        }
      });
    }
  }, [
    p
  ]), q.useEffect(() => {
    C.length <= 1 && T(!1);
  }, [
    C
  ]), q.useEffect(() => {
    const I = (D) => {
      var z;
      if (i.every((J) => D[J] || D.code === J)) {
        var G;
        T(!0), (G = k.current) == null || G.focus();
      }
      D.code === "Escape" && (document.activeElement === k.current || (z = k.current) != null && z.contains(document.activeElement)) && T(!1);
    };
    return document.addEventListener("keydown", I), () => document.removeEventListener("keydown", I);
  }, [
    i
  ]), q.useEffect(() => {
    if (k.current)
      return () => {
        B.current && (B.current.focus({
          preventScroll: !0
        }), B.current = null, P.current = !1);
      };
  }, [
    k.current
  ]), // Remove item from normal navigation flow, only available via hotkey
  /* @__PURE__ */ q.createElement("section", {
    ref: n,
    "aria-label": `${S} ${H}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, O.map((I, D) => {
    var z;
    const [U, G] = I.split("-");
    return R.length ? /* @__PURE__ */ q.createElement("ol", {
      key: I,
      dir: x === "auto" ? pp() : x,
      tabIndex: -1,
      ref: k,
      className: c,
      "data-sonner-toaster": !0,
      "data-sonner-theme": A,
      "data-y-position": U,
      "data-x-position": G,
      style: {
        "--front-toast-height": `${((z = j[0]) == null ? void 0 : z.height) || 0}px`,
        "--width": `${DP}px`,
        "--gap": `${w}px`,
        ...g,
        ...zP(u, d)
      },
      onBlur: (J) => {
        P.current && !J.currentTarget.contains(J.relatedTarget) && (P.current = !1, B.current && (B.current.focus({
          preventScroll: !0
        }), B.current = null));
      },
      onFocus: (J) => {
        J.target instanceof HTMLElement && J.target.dataset.dismissible === "false" || P.current || (P.current = !0, B.current = J.relatedTarget);
      },
      onMouseEnter: () => T(!0),
      onMouseMove: () => T(!0),
      onMouseLeave: () => {
        L || T(!1);
      },
      onDragEnd: () => T(!1),
      onPointerDown: (J) => {
        J.target instanceof HTMLElement && J.target.dataset.dismissible === "false" || M(!0);
      },
      onPointerUp: () => M(!1)
    }, R.filter((J) => !J.position && D === 0 || J.position === I).map((J, se) => {
      var Q, ce;
      return /* @__PURE__ */ q.createElement(VP, {
        key: J.id,
        icons: E,
        index: se,
        toast: J,
        defaultRichColors: m,
        duration: (Q = v?.duration) != null ? Q : h,
        className: v?.className,
        descriptionClassName: v?.descriptionClassName,
        invert: r,
        visibleToasts: y,
        closeButton: (ce = v?.closeButton) != null ? ce : l,
        interacting: L,
        position: I,
        style: v?.style,
        unstyled: v?.unstyled,
        classNames: v?.classNames,
        cancelButtonStyle: v?.cancelButtonStyle,
        actionButtonStyle: v?.actionButtonStyle,
        closeButtonAriaLabel: v?.closeButtonAriaLabel,
        removeToast: V,
        toasts: R.filter((W) => W.position == J.position),
        heights: j.filter((W) => W.position == J.position),
        setHeights: F,
        expandByDefault: a,
        gap: w,
        expanded: N,
        swipeDirections: e.swipeDirections
      });
    })) : null;
  }));
}), HP = "calc(var(--dev-footer-height, 0px) + 24px)", UP = "calc(var(--dev-footer-height, 0px) + 16px)", WP = (t) => {
  const e = ee.c(10);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  const {
    theme: o
  } = hP(), s = o === void 0 ? "system" : o;
  let i, a, l, c;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = {
    bottom: HP
  }, a = {
    bottom: UP
  }, l = {
    error: /* @__PURE__ */ b.jsx(Ve, { icon: dP, className: "size-4" }),
    info: /* @__PURE__ */ b.jsx(Ve, { icon: cP, className: "size-4" }),
    loading: /* @__PURE__ */ b.jsx(Ve, { icon: tu, className: "size-4 animate-spin" }),
    success: /* @__PURE__ */ b.jsx(Ve, { icon: aP, className: "size-4" }),
    warning: /* @__PURE__ */ b.jsx(Ve, { icon: Rg, className: "size-4" })
  }, c = {
    "--border-radius": "var(--radius)",
    "--normal-bg": "var(--surface-overlay)",
    "--normal-border": "var(--border-default)",
    "--normal-text": "var(--text-primary)"
  }, e[2] = i, e[3] = a, e[4] = l, e[5] = c) : (i = e[2], a = e[3], l = e[4], c = e[5]);
  let u;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    classNames: {
      toast: "cn-toast"
    }
  }, e[6] = u) : u = e[6];
  let d;
  return e[7] !== n || e[8] !== s ? (d = /* @__PURE__ */ b.jsx(BP, { theme: s, className: "toaster group", offset: i, mobileOffset: a, icons: l, style: c, toastOptions: u, ...n }), e[7] = n, e[8] = s, e[9] = d) : d = e[9], d;
}, Xu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Xu.displayName = "TooltipRootContext");
function Rs(t) {
  const e = f.useContext(Xu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : We(72));
  return e;
}
const GP = {
  ...fa,
  disabled: be((t) => t.disabled),
  instantType: be((t) => t.instantType),
  isInstantPhase: be((t) => t.isInstantPhase),
  trackCursorAxis: be((t) => t.trackCursorAxis),
  disableHoverablePopup: be((t) => t.disableHoverablePopup),
  lastOpenChangeReason: be((t) => t.openChangeReason),
  closeDelay: be((t) => t.closeDelay),
  hasViewport: be((t) => t.hasViewport)
};
class Zu extends vs {
  constructor(n) {
    super({
      ...KP(),
      ...n
    }, {
      popupRef: /* @__PURE__ */ f.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new _r()
    }, GP);
    Re(this, "setOpen", (n, o) => {
      const r = o.reason, s = r === Et, i = n && r === sr, a = !n && (r === ln || r === us);
      if (o.preventUnmountOnClose = () => {
        this.set("preventUnmountingOnClose", !0);
      }, this.context.onOpenChange?.(n, o), o.isCanceled)
        return;
      const l = () => {
        const c = {
          open: n,
          openChangeReason: r
        };
        i ? c.instantType = "focus" : a ? c.instantType = "dismiss" : r === Et && (c.instantType = void 0);
        const u = o.trigger?.id ?? null;
        (u || n) && (c.activeTriggerId = u, c.activeTriggerElement = o.trigger ?? null), this.update(c);
      };
      s ? Vt.flushSync(l) : l();
    });
  }
  static useStore(n, o) {
    const r = jt(() => new Zu(o)).current, s = n ?? r, i = pa({
      popupStore: s,
      onOpenChange: s.setOpen
    });
    return s.state.floatingRootContext = i, s;
  }
}
function KP() {
  return {
    ...da(),
    disabled: !1,
    instantType: void 0,
    isInstantPhase: !1,
    trackCursorAxis: "none",
    disableHoverablePopup: !1,
    openChangeReason: null,
    closeDelay: 0,
    hasViewport: !1
  };
}
function YP(t) {
  const {
    disabled: e = !1,
    defaultOpen: n = !1,
    open: o,
    disableHoverablePopup: r = !1,
    trackCursorAxis: s = "none",
    actionsRef: i,
    onOpenChange: a,
    onOpenChangeComplete: l,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null,
    children: p
  } = t, m = Zu.useStore(c?.store, {
    open: o ?? n,
    activeTriggerId: u !== void 0 ? u : d
  });
  m.useControlledProp("open", o, n), m.useControlledProp("activeTriggerId", u, d), m.useContextCallback("onOpenChange", a), m.useContextCallback("onOpenChangeComplete", l);
  const h = m.useState("open"), g = !e && h, y = m.useState("activeTriggerId"), v = m.useState("payload");
  m.useSyncedValues({
    trackCursorAxis: s,
    disableHoverablePopup: r
  }), he(() => {
    h && e && m.setOpen(!1, ke(Dy));
  }, [h, e, m]), m.useSyncedValue("disabled", e), ca(m);
  const {
    forceUnmount: x,
    transitionStatus: w
  } = ua(g, m), E = m.useState("isInstantPhase"), S = m.useState("instantType"), C = m.useState("lastOpenChangeReason"), _ = f.useRef(null);
  he(() => {
    w === "ending" && C === Ut || w !== "ending" && E ? (S !== "delay" && (_.current = S), m.set("instantType", "delay")) : _.current !== null && (m.set("instantType", _.current), _.current = null);
  }, [w, E, C, S, m]), he(() => {
    g && y == null && m.set("payload", void 0);
  }, [m, y, g]);
  const R = f.useCallback(() => {
    m.setOpen(!1, qP(m, qi));
  }, [m]);
  f.useImperativeHandle(i, () => ({
    unmount: x,
    close: R
  }), [x, R]);
  const O = m.useState("floatingRootContext"), j = Oh(O, {
    enabled: !e
  }), F = bs(O, {
    enabled: !e,
    referencePress: !0
  }), N = iw(O, {
    enabled: !e && s !== "none",
    axis: s === "none" ? void 0 : s
  }), {
    getReferenceProps: T,
    getFloatingProps: L,
    getTriggerProps: M
  } = qn([j, F, N]), A = f.useMemo(() => T(), [T]), $ = f.useMemo(() => M(), [M]), k = f.useMemo(() => L(), [L]);
  return m.useSyncedValues({
    activeTriggerProps: A,
    inactiveTriggerProps: $,
    popupProps: k
  }), /* @__PURE__ */ b.jsx(Xu.Provider, {
    value: m,
    children: typeof p == "function" ? p({
      payload: v
    }) : p
  });
}
function qP(t, e) {
  const n = ke(e);
  return n.preventUnmountOnClose = () => {
    t.set("preventUnmountingOnClose", !0);
  }, n;
}
const Ju = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ju.displayName = "TooltipProviderContext");
function XP() {
  return f.useContext(Ju);
}
const ZP = 600, Zb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    handle: s,
    payload: i,
    disabled: a,
    delay: l,
    closeDelay: c,
    id: u,
    ...d
  } = e, p = Rs(!0), m = s?.store ?? p;
  if (!m)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle." : We(82));
  const h = lt(u), g = m.useState("isTriggerActive", h), y = m.useState("isOpenedByTrigger", h), v = m.useState("floatingRootContext"), x = f.useRef(null), w = l ?? ZP, E = c ?? 0, {
    registerTrigger: S,
    isMountedByThisTrigger: C
  } = la(h, x, m, {
    payload: i,
    closeDelay: E
  }), _ = XP(), {
    delayRef: R,
    isInstantPhase: O,
    hasProvider: j
  } = X0(v, {
    open: y
  });
  m.useSyncedValue("isInstantPhase", O);
  const F = m.useState("disabled"), N = a ?? F, T = m.useState("trackCursorAxis"), L = m.useState("disableHoverablePopup"), M = ma(v, {
    enabled: !N,
    mouseOnly: !0,
    move: !1,
    handleClose: !L && T !== "both" ? ga() : null,
    restMs() {
      const H = _?.delay, B = typeof R.current == "object" ? R.current.open : void 0;
      let P = w;
      return j && (B !== 0 ? P = l ?? H ?? w : P = 0), P;
    },
    delay() {
      const H = typeof R.current == "object" ? R.current.close : void 0;
      let B = E;
      return c == null && j && (B = H), {
        close: B
      };
    },
    triggerElementRef: x,
    isActiveTrigger: g
  }), A = f.useMemo(() => ({
    open: y
  }), [y]), $ = m.useState("triggerProps", C);
  return _e("button", e, {
    state: A,
    ref: [n, S, x],
    props: [M, $, {
      id: h
    }, d],
    stateAttributesMapping: ys
  });
});
process.env.NODE_ENV !== "production" && (Zb.displayName = "TooltipTrigger");
const Qu = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qu.displayName = "TooltipPortalContext");
function JP() {
  const t = f.useContext(Qu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : We(70));
  return t;
}
const Jb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: s,
    render: i,
    ...a
  } = e, {
    portalNode: l,
    portalSubtree: c
  } = vh({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: a
  });
  return !c && !l ? null : /* @__PURE__ */ b.jsxs(f.Fragment, {
    children: [c, l && /* @__PURE__ */ Vt.createPortal(o, l)]
  });
});
process.env.NODE_ENV !== "production" && (Jb.displayName = "FloatingPortalLite");
const Qb = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return Rs().useState("mounted") || o ? /* @__PURE__ */ b.jsx(Qu.Provider, {
    value: o,
    children: /* @__PURE__ */ b.jsx(Jb, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Qb.displayName = "TooltipPortal");
const ed = /* @__PURE__ */ f.createContext(void 0);
process.env.NODE_ENV !== "production" && (ed.displayName = "TooltipPositionerContext");
function ev() {
  const t = f.useContext(ed);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : We(71));
  return t;
}
const tv = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: s,
    positionMethod: i = "absolute",
    side: a = "top",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: p = 5,
    arrowPadding: m = 5,
    sticky: h = !1,
    disableAnchorTracking: g = !1,
    collisionAvoidance: y = Ec,
    ...v
  } = e, x = Rs(), w = JP(), E = x.useState("open"), S = x.useState("mounted"), C = x.useState("trackCursorAxis"), _ = x.useState("disableHoverablePopup"), R = x.useState("floatingRootContext"), O = x.useState("instantType"), j = x.useState("transitionStatus"), F = x.useState("hasViewport"), N = Aa({
    anchor: s,
    positionMethod: i,
    floatingRootContext: R,
    mounted: S,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    collisionBoundary: d,
    collisionPadding: p,
    sticky: h,
    arrowPadding: m,
    disableAnchorTracking: g,
    keepMounted: w,
    collisionAvoidance: y,
    adaptiveOrigin: F ? Gg : void 0
  }), T = f.useMemo(() => {
    const $ = {};
    return (!E || C === "both" || _) && ($.pointerEvents = "none"), {
      role: "presentation",
      hidden: !S,
      style: {
        ...N.positionerStyles,
        ...$
      }
    };
  }, [E, C, _, S, N.positionerStyles]), L = f.useMemo(() => ({
    open: E,
    side: N.side,
    align: N.align,
    anchorHidden: N.anchorHidden,
    instant: C !== "none" ? "tracking-cursor" : O
  }), [E, N.side, N.align, N.anchorHidden, C, O]), M = f.useMemo(() => ({
    ...L,
    arrowRef: N.arrowRef,
    arrowStyles: N.arrowStyles,
    arrowUncentered: N.arrowUncentered
  }), [L, N.arrowRef, N.arrowStyles, N.arrowUncentered]), A = _e("div", e, {
    state: L,
    props: [T, Or(j), v],
    ref: [n, x.useStateSetter("positionerElement")],
    stateAttributesMapping: bn
  });
  return /* @__PURE__ */ b.jsx(ed.Provider, {
    value: M,
    children: A
  });
});
process.env.NODE_ENV !== "production" && (tv.displayName = "TooltipPositioner");
const QP = {
  ...bn,
  ...tn
}, nv = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    ...s
  } = e, i = Rs(), {
    side: a,
    align: l
  } = ev(), c = i.useState("open"), u = i.useState("instantType"), d = i.useState("transitionStatus"), p = i.useState("popupProps"), m = i.useState("floatingRootContext");
  Gt({
    open: c,
    ref: i.context.popupRef,
    onComplete() {
      c && i.context.onOpenChangeComplete?.(!0);
    }
  });
  const h = i.useState("disabled"), g = i.useState("closeDelay");
  Jc(m, {
    enabled: !h,
    closeDelay: g
  });
  const y = f.useMemo(() => ({
    open: c,
    side: a,
    align: l,
    instant: u,
    transitionStatus: d
  }), [c, a, l, u, d]);
  return _e("div", e, {
    state: y,
    ref: [n, i.context.popupRef, i.useStateSetter("popupElement")],
    props: [p, Or(d), s],
    stateAttributesMapping: QP
  });
});
process.env.NODE_ENV !== "production" && (nv.displayName = "TooltipPopup");
const ov = /* @__PURE__ */ f.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    ...s
  } = e, a = Rs().useState("instantType"), {
    open: l,
    arrowRef: c,
    side: u,
    align: d,
    arrowUncentered: p,
    arrowStyles: m
  } = ev(), h = f.useMemo(() => ({
    open: l,
    side: u,
    align: d,
    uncentered: p,
    instant: a
  }), [l, u, d, p, a]);
  return _e("div", e, {
    state: h,
    ref: [n, c],
    props: [{
      style: m,
      "aria-hidden": !0
    }, s],
    stateAttributesMapping: bn
  });
});
process.env.NODE_ENV !== "production" && (ov.displayName = "TooltipArrow");
const rv = function(e) {
  const {
    delay: n,
    closeDelay: o,
    timeout: r = 400
  } = e, s = f.useMemo(() => ({
    delay: n,
    closeDelay: o
  }), [n, o]), i = f.useMemo(() => ({
    open: n,
    close: o
  }), [n, o]);
  return /* @__PURE__ */ b.jsx(Ju.Provider, {
    value: s,
    children: /* @__PURE__ */ b.jsx(q0, {
      delay: i,
      timeoutMs: r,
      children: e.children
    })
  });
};
process.env.NODE_ENV !== "production" && (rv.displayName = "TooltipProvider");
const e3 = "_positioner_17grq_2", t3 = "_popup_17grq_8", n3 = "_sizeSm_17grq_34", o3 = "_sizeMd_17grq_38", r3 = "_sizeLg_17grq_42", s3 = "_sizeFit_17grq_46", i3 = "_arrow_17grq_50", Ro = {
  positioner: e3,
  popup: t3,
  sizeSm: n3,
  sizeMd: o3,
  sizeLg: r3,
  sizeFit: s3,
  arrow: i3
}, a3 = {
  fit: Ro.sizeFit,
  lg: Ro.sizeLg,
  md: Ro.sizeMd,
  sm: Ro.sizeSm
}, sv = f.createContext(!1), l3 = (t) => {
  const e = ee.c(12);
  let n, o, r, s;
  e[0] !== t ? ({
    delay: r,
    closeDelay: s,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s) : (n = e[1], o = e[2], r = e[3], s = e[4]);
  const i = r === void 0 ? 80 : r, a = s === void 0 ? 150 : s;
  let l;
  e[5] !== n ? (l = /* @__PURE__ */ b.jsx(sv.Provider, { value: !0, children: n }), e[5] = n, e[6] = l) : l = e[6];
  let c;
  return e[7] !== a || e[8] !== i || e[9] !== o || e[10] !== l ? (c = /* @__PURE__ */ b.jsx(rv, { "data-slot": "tooltip-provider", delay: i, closeDelay: a, ...o, children: l }), e[7] = a, e[8] = i, e[9] = o, e[10] = l, e[11] = c) : c = e[11], c;
}, EL = (t) => {
  const e = ee.c(7);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  const o = f.useContext(sv);
  let r;
  e[2] !== n ? (r = /* @__PURE__ */ b.jsx(YP, { "data-slot": "tooltip", ...n }), e[2] = n, e[3] = r) : r = e[3];
  const s = r;
  let i;
  return e[4] !== o || e[5] !== s ? (i = o ? s : /* @__PURE__ */ b.jsx(l3, { children: s }), e[4] = o, e[5] = s, e[6] = i) : i = e[6], i;
}, CL = (t) => {
  const e = ee.c(8);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    render: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let s;
  return e[4] !== n || e[5] !== o || e[6] !== r ? (s = /* @__PURE__ */ b.jsx(Zb, { "data-slot": "tooltip-trigger", render: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = r, e[7] = s) : s = e[7], s;
}, _L = (t) => {
  const e = ee.c(26);
  let n, o, r, s, i, a, l, c, u;
  e[0] !== t ? ({
    className: o,
    side: s,
    sideOffset: i,
    align: a,
    alignOffset: l,
    size: c,
    showArrow: u,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i, e[6] = a, e[7] = l, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5], a = e[6], l = e[7], c = e[8], u = e[9]);
  const d = s === void 0 ? "top" : s, p = i === void 0 ? 6 : i, m = a === void 0 ? "center" : a, h = l === void 0 ? 0 : l, g = c === void 0 ? "md" : c, y = u === void 0 ? !0 : u, v = a3[g];
  let x;
  e[10] !== o || e[11] !== v ? (x = ae(Ro.popup, v, o), e[10] = o, e[11] = v, e[12] = x) : x = e[12];
  let w;
  e[13] !== y ? (w = y && /* @__PURE__ */ b.jsx(ov, { className: Ro.arrow }), e[13] = y, e[14] = w) : w = e[14];
  let E;
  e[15] !== n || e[16] !== r || e[17] !== x || e[18] !== w ? (E = /* @__PURE__ */ b.jsxs(nv, { "data-slot": "tooltip-content", className: x, ...r, children: [
    n,
    w
  ] }), e[15] = n, e[16] = r, e[17] = x, e[18] = w, e[19] = E) : E = e[19];
  let S;
  return e[20] !== m || e[21] !== h || e[22] !== d || e[23] !== p || e[24] !== E ? (S = /* @__PURE__ */ b.jsx(Qb, { children: /* @__PURE__ */ b.jsx(tv, { align: m, alignOffset: h, side: d, sideOffset: p, className: Ro.positioner, children: E }) }), e[20] = m, e[21] = h, e[22] = d, e[23] = p, e[24] = E, e[25] = S) : S = e[25], S;
}, RL = (t, e) => {
  const n = ee.c(25), {
    columns: o,
    defaultLimit: r
  } = e, s = r === void 0 ? 25 : r, [i, a] = q.useState(1), [l, c] = q.useState(s), [u, d] = q.useState(null), [p, m] = q.useState("");
  let h;
  n[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = (M) => {
    c(M.limit), a(M.page ?? 1), d(M.sortBy ? {
      columnId: M.sortBy,
      direction: M.sortDirection ?? "asc"
    } : null), m(M.search ?? "");
  }, n[0] = h) : h = n[0];
  const g = h;
  let y;
  if (n[1] !== t || n[2] !== o || n[3] !== p) {
    e: {
      const M = p.trim().toLocaleLowerCase();
      if (M === "") {
        y = t;
        break e;
      }
      const A = o.filter(d3);
      y = t.filter(($) => A.some((k) => {
        const H = k.value($);
        return H == null ? !1 : (H instanceof Date ? H.toISOString() : String(H)).toLocaleLowerCase().includes(M);
      }));
    }
    n[1] = t, n[2] = o, n[3] = p, n[4] = y;
  } else
    y = n[4];
  const v = y;
  let x;
  if (n[5] !== o || n[6] !== v || n[7] !== u) {
    e: {
      if (!u) {
        x = v;
        break e;
      }
      let M;
      n[9] !== u ? (M = (k) => k.id === u.columnId, n[9] = u, n[10] = M) : M = n[10];
      const A = o.find(M);
      if (!A?.value) {
        x = v;
        break e;
      }
      const $ = c3(A, u.direction);
      x = [...v].sort($);
    }
    n[5] = o, n[6] = v, n[7] = u, n[8] = x;
  } else
    x = n[8];
  const w = x, E = w.length, S = Math.max(1, Math.ceil(E / l)), C = Math.min(Math.max(1, i), S), _ = (C - 1) * l;
  let R;
  n[11] !== l || n[12] !== w || n[13] !== _ ? (R = w.slice(_, _ + l), n[11] = l, n[12] = w, n[13] = _, n[14] = R) : R = n[14];
  const O = R, j = C < S, F = C > 1;
  let N;
  n[15] !== C || n[16] !== l || n[17] !== j || n[18] !== F || n[19] !== E || n[20] !== S ? (N = {
    hasNextPage: j,
    hasPreviousPage: F,
    limit: l,
    page: C,
    totalItems: E,
    totalPages: S
  }, n[15] = C, n[16] = l, n[17] = j, n[18] = F, n[19] = E, n[20] = S, n[21] = N) : N = n[21];
  const T = N;
  let L;
  return n[22] !== T || n[23] !== O ? (L = {
    onQueryChange: g,
    pagination: T,
    rows: O
  }, n[22] = T, n[23] = O, n[24] = L) : L = n[24], L;
}, c3 = (t, e) => {
  const n = e === "asc" ? 1 : -1, o = t.value, r = !!t.numeric;
  return (s, i) => {
    const a = o(s), l = o(i), c = a == null, u = l == null;
    return c && u ? 0 : c ? 1 : u ? -1 : u3(a, l, r) * n;
  };
}, u3 = (t, e, n) => {
  if (t instanceof Date || e instanceof Date) {
    const o = t instanceof Date ? t.getTime() : Number(t), r = e instanceof Date ? e.getTime() : Number(e);
    return o < r ? -1 : o > r ? 1 : 0;
  }
  if (n || typeof t == "number" && typeof e == "number") {
    const o = Number(t), r = Number(e);
    return o < r ? -1 : o > r ? 1 : 0;
  }
  return String(t).localeCompare(String(e));
};
function d3(t) {
  return t.value !== void 0;
}
const NL = (t) => {
  const [e, n] = q.useState([]), [o, r] = q.useState(void 0), [s, i] = q.useState(!1), [a, l] = q.useState(void 0), c = q.useRef(t);
  c.current = t;
  const u = q.useRef(0), d = q.useRef(null), p = q.useCallback((g) => {
    d.current = g;
    const y = ++u.current;
    i(!0), l(void 0), c.current(g).then((v) => {
      y === u.current && (n(v.data), r(v.pagination), i(!1));
    }, (v) => {
      y === u.current && (l(v), i(!1));
    });
  }, []), m = q.useCallback((g) => p(g), [p]), h = q.useCallback(() => {
    d.current && p(d.current);
  }, [p]);
  return {
    error: a,
    loading: s,
    onQueryChange: m,
    pagination: o,
    refetch: h,
    rows: e
  };
}, f3 = "_root_10ybi_2", p3 = "_rootElectronMac_10ybi_26", m3 = "_rootElectronFlush_10ybi_23", h3 = "_header_10ybi_32", g3 = "_headerFlush_10ybi_32", b3 = "_headerNoDivider_10ybi_86", v3 = "_headerElectronMac_10ybi_103", y3 = "_headerElectronWin_10ybi_107", x3 = "_headerDebug_10ybi_111", w3 = "_dragExtension_10ybi_33", S3 = "_dragExtensionDebug_10ybi_150", E3 = "_headerContent_10ybi_155", C3 = "_main_10ybi_3", _3 = "_hasHeader_10ybi_167", R3 = "_hasFooter_10ybi_170", N3 = "_footer_10ybi_174", k3 = "_footerNoDivider_10ybi_191", Mt = {
  root: f3,
  rootElectronMac: p3,
  rootElectronFlush: m3,
  header: h3,
  headerFlush: g3,
  headerNoDivider: b3,
  headerElectronMac: v3,
  headerElectronWin: y3,
  headerDebug: x3,
  dragExtension: w3,
  dragExtensionDebug: S3,
  headerContent: E3,
  main: C3,
  hasHeader: _3,
  hasFooter: R3,
  footer: N3,
  footerNoDivider: k3
}, kL = (t) => {
  const e = ee.c(31), {
    children: n,
    className: o,
    footer: r,
    header: s,
    showDividers: i
  } = t, a = i === void 0 ? !0 : i;
  let l;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = _n.isElectron(), e[0] = l) : l = e[0];
  const c = l;
  let u;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = _n.isMacOS(), e[1] = u) : u = e[1];
  const d = u, {
    isDebug: p
  } = cu(), m = !!s || c, h = !s && c, g = h && d, y = !!s && c;
  let v;
  e[2] !== r || e[3] !== m ? (v = [Mt.main], m && v.push(Mt.hasHeader), r && v.push(Mt.hasFooter), e[2] = r, e[3] = m, e[4] = v) : v = e[4];
  let x;
  e[5] !== g || e[6] !== o || e[7] !== y ? (x = [Mt.root], g && x.push(Mt.rootElectronMac), y && x.push(Mt.rootElectronFlush), o && x.push(o), e[5] = g, e[6] = o, e[7] = y, e[8] = x) : x = e[8];
  const w = x.join(" ");
  let E;
  e[9] !== h || e[10] !== s || e[11] !== y || e[12] !== p || e[13] !== a || e[14] !== m ? (E = m && /* @__PURE__ */ b.jsx("div", { className: `${Mt.header}${h ? d ? ` ${Mt.headerElectronMac}` : ` ${Mt.headerElectronWin}` : ""}${y ? ` ${Mt.headerFlush}` : ""}${(h || y) && p ? ` ${Mt.headerDebug}` : ""}${a ? "" : ` ${Mt.headerNoDivider}`}`, style: h ? {
    WebkitAppRegion: "drag",
    appRegion: "drag"
  } : void 0, children: s && /* @__PURE__ */ b.jsx("div", { className: Mt.headerContent, children: s }) }), e[9] = h, e[10] = s, e[11] = y, e[12] = p, e[13] = a, e[14] = m, e[15] = E) : E = e[15];
  let S;
  e[16] !== h || e[17] !== p ? (S = h && /* @__PURE__ */ b.jsx("div", { className: `${Mt.dragExtension}${p ? ` ${Mt.dragExtensionDebug}` : ""}` }), e[16] = h, e[17] = p, e[18] = S) : S = e[18];
  const C = v.join(" ");
  let _;
  e[19] !== n || e[20] !== C ? (_ = /* @__PURE__ */ b.jsx("div", { className: C, children: n }), e[19] = n, e[20] = C, e[21] = _) : _ = e[21];
  let R;
  e[22] !== r || e[23] !== a ? (R = r && /* @__PURE__ */ b.jsx("div", { className: `${Mt.footer}${a ? "" : ` ${Mt.footerNoDivider}`}`, children: r }), e[22] = r, e[23] = a, e[24] = R) : R = e[24];
  let O;
  return e[25] !== w || e[26] !== E || e[27] !== S || e[28] !== _ || e[29] !== R ? (O = /* @__PURE__ */ b.jsxs("div", { className: w, children: [
    E,
    S,
    _,
    R
  ] }), e[25] = w, e[26] = E, e[27] = S, e[28] = _, e[29] = R, e[30] = O) : O = e[30], O;
}, td = q.createContext(null);
td.displayName = "SplitPaneCollapseContext";
const TL = () => q.useContext(td), vr = q.createContext(null);
vr.displayName = "SplitPaneInsetContext";
const T3 = typeof window < "u" ? q.useLayoutEffect : q.useEffect, IL = (t) => {
  const e = q.useContext(vr);
  T3(() => {
    if (e)
      return e(t), () => e(0);
  }, [e, t]);
}, I3 = "_root_z8tng_2", O3 = "_handleVisible_z8tng_7", M3 = "_handleHover_z8tng_65", P3 = "_handleNever_z8tng_118", A3 = "_handleDebug_z8tng_130", D3 = "_dividerStatic_z8tng_138", j3 = "_dividerStaticHidden_z8tng_146", L3 = "_rootStatic_z8tng_154", $3 = "_anchoredPane_z8tng_164", It = {
  root: I3,
  handleVisible: O3,
  handleHover: M3,
  handleNever: P3,
  handleDebug: A3,
  dividerStatic: D3,
  dividerStaticHidden: j3,
  rootStatic: L3,
  anchoredPane: $3
}, Dt = {
  /**
   * Build a stable fingerprint string from the ordered, resolved pane configs.
   * Order is significant — swapping two panes yields a different fingerprint.
   */
  fingerprint: (t) => t.map((e) => e.kind === "flex" ? `${e.id}:flex` : e.kind === "fixed" ? `${e.id}:fixed:${e.size ?? ""}` : e.kind === "iconRail" ? `${e.id}:iconRail` : `${e.id}:resizable:${e.defaultSize ?? ""}:${e.minSize ?? ""}:${e.maxSize ?? ""}`).join("|"),
  /**
   * Read persisted pixel sizes for the anchored (draggable) panes. Returns `null` when missing,
   * stale, or unparsable. Persisted values are clamped to each pane's `[minSize, maxSize]`.
   * Container-fit clamping happens in the component (not here).
   */
  read: ({
    fingerprint: t,
    panes: e,
    persistenceId: n
  }) => {
    const o = `app-layout-${n}`, r = Lt.getJSON(o);
    if (r === null) return null;
    if (typeof r != "object")
      return Lt.remove(o), null;
    const s = r;
    if (typeof s.fingerprint != "string" || typeof s.sizes != "object" || s.sizes === null || s.fingerprint !== t)
      return Lt.remove(o), null;
    const i = new Map(e.map((l) => [l.id, l])), a = {};
    for (const [l, c] of Object.entries(s.sizes)) {
      const u = i.get(l);
      !u || typeof c != "number" || !Number.isFinite(c) || (a[l] = Math.max(u.minSize, Math.min(u.maxSize, c)));
    }
    return Object.keys(a).length === 0 ? null : a;
  },
  /**
   * Read persisted collapse state. Returns null when nothing is persisted or when the stored
   * payload is malformed (and removes the malformed entry).
   */
  readCollapsed: (t) => {
    const e = xl(t), n = Lt.getJSON(e);
    if (n === null) return null;
    if (typeof n != "object")
      return Lt.remove(e), null;
    const o = n;
    return typeof o.left != "boolean" || typeof o.right != "boolean" ? (Lt.remove(e), null) : {
      left: o.left,
      right: o.right
    };
  },
  /**
   * Read the per-side content gutters last reported to this split. Returns null when nothing is persisted
   * or the payload is malformed (and removes the malformed entry).
   * Closes a first-paint gap, not a user preference: a rail-derived pane cannot know its content's gutter
   * until that content mounts and reports it, so until then it renders the bare token and the card inside
   * visibly squashes. Seeding from the last known value makes every reload after the first render true.
   */
  readInset: (t) => {
    const e = mp(t), n = Lt.getJSON(e);
    if (n === null) return null;
    if (typeof n != "object")
      return Lt.remove(e), null;
    const {
      left: o,
      right: r
    } = n;
    return typeof o != "number" || typeof r != "number" || !Number.isFinite(o) || !Number.isFinite(r) || o < 0 || r < 0 ? (Lt.remove(e), null) : {
      left: o,
      right: r
    };
  },
  /** Remove a persisted layout from localStorage. */
  remove: (t) => {
    Lt.remove(`app-layout-${t}`);
  },
  /** Remove persisted collapse state from localStorage. */
  removeCollapsed: (t) => {
    Lt.remove(xl(t));
  },
  /** Merge the supplied pixel sizes into the persisted record, retaining sizes for panes omitted from this call. */
  write: (t, e, n) => {
    const o = `app-layout-${t}`, r = Lt.getJSON(o);
    let s = {};
    if (typeof r == "object" && r !== null) {
      const a = r;
      a.fingerprint === n && typeof a.sizes == "object" && a.sizes !== null && (s = a.sizes);
    }
    const i = {
      ...s,
      ...e
    };
    Lt.setJSON(o, {
      fingerprint: n,
      sizes: i
    });
  },
  /** Write collapse state to localStorage. */
  writeCollapsed: (t, e) => {
    Lt.setJSON(xl(t), {
      left: e.left,
      right: e.right
    });
  },
  /** Write the per-side content gutters to localStorage (see `readInset`). */
  writeInset: (t, e) => {
    Lt.setJSON(mp(t), {
      left: e.left,
      right: e.right
    });
  }
}, xl = (t) => `app-layout-${t}:collapsed`, mp = (t) => `app-layout-${t}:inset`, rt = {
  /** Minimum px the absorbing (flex) pane must retain when clamping the anchored pane. */
  ABSORBING_MIN: 100,
  /** Px footprint of a drag handle along the split axis (was HANDLE_WIDTH / HANDLE_HEIGHT, both 11). */
  HANDLE_SIZE: 11,
  /**
   * How long the pointer must DWELL on a handle before its hover chrome is revealed. The 7px box sits under
   * every pointer trip between the panes, so a raw `pointerenter` flashed chrome at anyone merely crossing.
   * This measures intent, not animation — cancelled on leave and on pointer-down — and is distinct from the
   * ~150ms opacity transition in `_dragHandle.scss`, which runs only after it elapses.
   */
  HOVER_DELAY_MS: 400,
  /** Default max px for a resizable pane when its config omits maxSize. */
  MAX: 480,
  /** Default min px for a resizable pane when its config omits minSize. */
  MIN: 200,
  /**
   * Nominal rail width — the STANDARD density's `--density-icon-rail-width`, used where an approximation
   * is all that is wanted: the persisted-layout fingerprint (which must not change when the user switches
   * density, or every stored size is discarded) and `SplitTriple`'s static-sibling reserve (±7px at the
   * outer densities, absorbed by the centre pane's `ABSORBING_MIN`).
   * NOT the collapse-drag geometry — that needs the rail the pane actually renders at, which steps
   * 41 / 48 / 55px with the density, so it goes through `SplitRailWidth.px` instead. Using this constant
   * there put the drag's floor 7px inside the rail at spacious, squashing a collapsed card below its own
   * icon column.
   */
  RAIL_SIZE: 48,
  /** Default starting px for a resizable pane when its config omits defaultSize. */
  SIZE: 256,
  /**
   * How long the double-click snap-to-min glide runs. MUST mirror the `width` transition duration in
   * `Split{Vertical,Triple}.module.scss` — the JS side only uses it to decide when to disarm the
   * transition again, so a value shorter than the CSS would cut the animation off mid-glide.
   */
  SNAP_MS: 320
}, uo = {
  /**
   * Fold the superseded `showDivider` / `showDividers` boolean into the `divider` union: `true` → `always`
   * (hairline at rest), `false` → `hover` (grip only). Neither prop set falls through to `auto`, the default.
   */
  fromLegacy: ({
    divider: t,
    showDivider: e
  }) => t !== void 0 ? t : e === void 0 ? "auto" : e ? "always" : "hover",
  /**
   * Resolve `auto` from whether the pane's content floats as a card. A hairline is a seam between adjoining
   * regions; with a floating card there is no seam, just its gutter, and a line through it reads as debris.
   * So a pane reporting a gutter drops to `hover`, an edge-to-edge one keeps `always`.
   * @param input - The requested mode plus the adjacent pane's reported per-side gutter in px.
   */
  resolve: ({
    inset: t,
    mode: e
  }) => e !== "auto" ? e : t > 0 ? "hover" : "always"
}, is = {
  /**
   * Pixel size each pane is expected to occupy at its default layout. An `iconRail`'s true width is a CSS
   * token JS cannot read, so it reports the nominal rail constant the collapse snap math runs on —
   * accurate at standard density, ±7px at the outer presets.
   */
  expectedSize: (t) => t.kind === "fixed" ? t.size : t.kind === "iconRail" ? rt.RAIL_SIZE : t.defaultSize,
  /** Type guard for fixed-size panes — narrow, because callers use it to reach `.size`. */
  isFixed: (t) => t !== void 0 && t.kind === "fixed",
  /** Type guard for panes the user cannot drag — `fixed` AND `iconRail`. Unlike `isFixed`, carries no `.size`. */
  isStatic: (t) => t !== void 0 && (t.kind === "fixed" || t.kind === "iconRail"),
  /** Map a `PaneConfig` to the structural `PaneFingerprintInput` used by `LayoutStorage.fingerprint`. */
  toFingerprintInput: ({
    cfg: t,
    defaultMax: e,
    defaultMin: n,
    id: o
  }) => t.kind === "fixed" ? {
    id: o,
    kind: "fixed",
    size: t.size
  } : t.kind === "iconRail" ? {
    id: o,
    kind: "iconRail"
  } : {
    id: o,
    kind: "resizable",
    defaultSize: t.defaultSize,
    maxSize: t.maxSize ?? e,
    minSize: t.minSize ?? n
  }
}, Bi = {
  /**
   * @param options - The active density preset and the total content gutter.
   * @returns The px width the pane renders at when collapsed — exactly what `resolve` resolves to.
   */
  px: ({
    density: t,
    insetTotal: e
  }) => parseFloat(t_.presets[t].iconRailWidth) + Math.max(0, e),
  /**
   * @param insetTotal - Total px of content gutter along the split axis (BOTH sides, ie: 2 × the per-side
   * value from `useSplitPaneInset`). `0` returns the bare token, identical to pre-inset rendering.
   */
  resolve: (t) => t > 0 ? `calc(var(--density-icon-rail-width) + ${t}px)` : "var(--density-icon-rail-width)"
}, Hi = {
  /**
   * Resolve what a live drag size means for a collapse-to-rail pane. The pane TRACKS the pointer 1:1
   * across the whole travel — there is no dead zone where it sticks at `minSize` — and commits a state
   * change once the pointer crosses the MIDPOINT of the `[railSize, minSize]` band, so a state change
   * follows the drag's intent rather than requiring the pointer to be dragged the whole way to the far
   * endpoint (and reverting on release if it wasn't):
   * - **Expanded**, dragged inward: `resize` (render the shrinking size, even below `minSize`) until the
   *   pointer passes the midpoint, at which point → `collapse` — release anywhere past halfway commits
   *   the rail rather than springing back open.
   * - **Collapsed**, dragged outward: `resize` (render the growing size) until the pointer passes the
   *   midpoint, at which point → `expand` (the pane then settles up to a valid expanded width on release).
   * A single midpoint threshold means the same halfway line governs both directions, so a drag reads as
   * a toggle: cross it and let go, and the pane commits to the side you were heading toward.
   */
  resolve: ({
    collapsed: t,
    minSize: e,
    railSize: n,
    size: o
  }) => {
    const r = (n + e) / 2;
    return t ? o >= r ? {
      action: "expand",
      size: o
    } : {
      action: "resize",
      size: o
    } : o <= r ? {
      action: "collapse"
    } : {
      action: "resize",
      size: o
    };
  },
  /**
   * Resolve a double-click on the divider: the width to snap to, or `null` for "do nothing". A drag released
   * mid-band settles at `minSize`, so this is the shortcut to that same width. Deliberately one-way — wider
   * than `minSize` snaps down; already at `minSize` or collapsed to the rail does nothing, so this gesture
   * never grows a pane and never leaves a remembered width the user cannot see.
   */
  resolveDoubleClick: ({
    collapsed: t,
    minSize: e,
    size: n
  }) => !t && n > e ? e : null
}, Ui = (t) => {
  const e = ee.c(10), {
    persistenceId: n,
    side: o
  } = t;
  let r;
  e[0] !== n || e[1] !== o ? (r = () => n ? Dt.readInset(n)?.[o] ?? 0 : 0, e[0] = n, e[1] = o, e[2] = r) : r = e[2];
  const [s, i] = q.useState(r), a = q.useRef(s);
  let l, c;
  e[3] !== s || e[4] !== n || e[5] !== o ? (l = () => {
    if (!n || a.current === s)
      return;
    a.current = s;
    const d = Dt.readInset(n) ?? {
      left: 0,
      right: 0
    };
    Dt.writeInset(n, {
      ...d,
      [o]: s
    });
  }, c = [s, n, o], e[3] = s, e[4] = n, e[5] = o, e[6] = l, e[7] = c) : (l = e[6], c = e[7]), q.useEffect(l, c);
  let u;
  return e[8] !== s ? (u = [s, i], e[8] = s, e[9] = u) : u = e[9], u;
}, fc = ({
  cfg: t,
  children: e,
  className: n,
  onInsetChange: o,
  persistenceId: r,
  side: s
}) => {
  const [i, a] = Ui({
    persistenceId: r,
    side: s
  }), l = t.kind === "iconRail", c = l ? Bi.resolve(i * 2) : `${t.kind === "fixed" ? t.size : t.defaultSize}px`, u = q.useRef(o);
  return u.current = o, q.useEffect(() => {
    u.current?.(l ? i : 0);
  }, [i, l]), /* @__PURE__ */ b.jsx("div", { className: n, style: {
    flexShrink: 0,
    width: c
  }, children: /* @__PURE__ */ b.jsx(vr.Provider, { value: l ? a : null, children: e }) });
}, iv = () => {
  const t = ee.c(6), [e, n] = Fn(null), o = mn(null);
  let r;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = (d) => {
    o.current && (o.current.disconnect(), o.current = null), d && (n({
      width: d.clientWidth,
      height: d.clientHeight
    }), o.current = new ResizeObserver((p) => {
      const m = p[0];
      if (!m)
        return;
      const h = m.contentRect;
      n({
        width: h.width,
        height: h.height
      });
    }), o.current.observe(d));
  }, t[0] = r) : r = t[0];
  const s = r;
  let i, a;
  t[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = () => () => {
    o.current && o.current.disconnect();
  }, a = [], t[1] = i, t[2] = a) : (i = t[1], a = t[2]), $n(i, a);
  const l = e?.width ?? null, c = e?.height ?? null;
  let u;
  return t[3] !== l || t[4] !== c ? (u = {
    ref: s,
    width: l,
    height: c
  }, t[3] = l, t[4] = c, t[5] = u) : u = t[5], u;
}, pc = ({
  getBounds: t,
  getCurrentSize: e,
  invert: n = !1,
  onCommit: o,
  onDoubleClick: r,
  onDragStart: s,
  onSizeChange: i,
  orientation: a
}) => {
  const {
    setAppIsUnselectable: l
  } = QC(), [c, u] = q.useState(!1), [d, p] = q.useState(!1), m = q.useRef(null), h = q.useRef(null), g = q.useCallback(() => {
    h.current !== null && (clearTimeout(h.current), h.current = null);
  }, []), y = q.useRef({
    getBounds: t,
    getCurrentSize: e,
    invert: n,
    onCommit: o,
    onDragStart: s,
    onSizeChange: i,
    orientation: a
  });
  y.current = {
    getBounds: t,
    getCurrentSize: e,
    invert: n,
    onCommit: o,
    onDragStart: s,
    onSizeChange: i,
    orientation: a
  };
  const v = q.useCallback((S) => {
    if (S.button !== 0) return;
    S.preventDefault(), g(), p(!0);
    const C = y.current.orientation === "vertical" ? S.clientX : S.clientY, _ = y.current.getCurrentSize();
    let R = _;
    y.current.onDragStart?.(), u(!0), l(!0);
    const O = y.current.orientation === "vertical" ? "col-resize" : "row-resize", j = document.createElement("style");
    j.textContent = `*{cursor:${O}!important;}`, document.head.appendChild(j);
    const F = (L) => {
      const M = y.current.orientation === "vertical" ? L.clientX : L.clientY, {
        max: A,
        min: $
      } = y.current.getBounds(), k = (M - C) * (y.current.invert ? -1 : 1), H = Math.max($, Math.min(A, _ + k));
      R = H, y.current.onSizeChange(H);
    }, N = () => {
      j.remove(), window.removeEventListener("pointermove", F), window.removeEventListener("pointerup", T), window.removeEventListener("pointercancel", T), l(!1);
    }, T = () => {
      N(), y.current.onCommit(R), u(!1), m.current = null;
    };
    window.addEventListener("pointermove", F), window.addEventListener("pointerup", T), window.addEventListener("pointercancel", T), m.current = N;
  }, [g, l]);
  q.useEffect(() => () => {
    m.current?.(), h.current !== null && clearTimeout(h.current);
  }, []);
  const x = q.useCallback(() => {
    g(), h.current = setTimeout(() => {
      h.current = null, p(!0);
    }, rt.HOVER_DELAY_MS);
  }, [g]), w = q.useCallback(() => {
    g(), p(!1);
  }, [g]), E = c ? "active" : d ? "hover" : void 0;
  return {
    handleProps: {
      onPointerDown: v,
      onPointerEnter: x,
      onPointerLeave: w,
      ...r ? {
        onDoubleClick: r
      } : {},
      ...E ? {
        "data-separator": E
      } : {}
    },
    isDragging: c
  };
}, ja = (t) => {
  const e = ee.c(5), {
    hasCustomLayout: n,
    resetLayout: o
  } = t, r = q.useId();
  let s, i;
  e[0] !== n || e[1] !== o || e[2] !== r ? (s = () => (Vf.register(r, {
    hasCustomLayout: n,
    resetLayout: o
  }), () => Vf.unregister(r)), i = [r, n, o], e[0] = n, e[1] = o, e[2] = r, e[3] = s, e[4] = i) : (s = e[3], i = e[4]), q.useEffect(s, i);
}, av = () => {
  const t = ee.c(2), [e, n] = q.useState(!1);
  let o, r;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = () => {
    if (typeof requestAnimationFrame != "function") {
      const a = setTimeout(() => n(!0), 0);
      return () => clearTimeout(a);
    }
    let s = 0;
    const i = requestAnimationFrame(() => {
      s = requestAnimationFrame(() => n(!0));
    });
    return () => {
      cancelAnimationFrame(i), cancelAnimationFrame(s);
    };
  }, r = [], t[0] = o, t[1] = r) : (o = t[0], r = t[1]), q.useEffect(o, r), e;
}, Br = "split-left", Hr = "split-right", OL = q.forwardRef(function({
  center: e,
  className: n,
  defaultLeftCollapsed: o = !1,
  defaultRightCollapsed: r = !1,
  divider: s,
  left: i,
  leftPane: a,
  onCollapsedChange: l,
  persistenceId: c,
  right: u,
  rightPane: d,
  showDividers: p
}, m) {
  const h = uo.fromLegacy({
    divider: s,
    showDivider: p
  }), g = q.useMemo(() => a ?? {
    defaultSize: rt.SIZE,
    kind: "resizable"
  }, [a]), y = q.useMemo(() => d ?? {
    defaultSize: rt.SIZE,
    kind: "resizable"
  }, [d]), [v, x] = q.useState(() => {
    const N = c ? Dt.readCollapsed(c) : null;
    return N || {
      left: o,
      right: r
    };
  }), w = q.useRef(v);
  w.current = v;
  const E = q.useRef(l);
  E.current = l;
  const S = q.useCallback((N) => {
    w.current = N, x(N), c && Dt.writeCollapsed(c, N), E.current?.({
      leftCollapsed: N.left,
      rightCollapsed: N.right
    });
  }, [c]), C = q.useCallback((N) => {
    w.current.left !== N && S({
      left: N,
      right: w.current.right
    });
  }, [S]), _ = q.useCallback((N) => {
    w.current.right !== N && S({
      left: w.current.left,
      right: N
    });
  }, [S]), R = q.useCallback(() => {
    S({
      left: !w.current.left,
      right: w.current.right
    });
  }, [S]), O = q.useCallback(() => {
    S({
      left: w.current.left,
      right: !w.current.right
    });
  }, [S]);
  q.useImperativeHandle(m, () => ({
    leftCollapsed: v.left,
    rightCollapsed: v.right,
    setLeftCollapsed: C,
    setRightCollapsed: _,
    toggleLeft: R,
    toggleRight: O
  }), [v.left, v.right, C, _, R, O]), q.useEffect(() => {
    E.current?.({
      leftCollapsed: w.current.left,
      rightCollapsed: w.current.right
    });
  }, []);
  const j = n ? `${It.root} ${n}` : It.root;
  return B3(g, y, v.left, v.right).kind === "all-static" ? /* @__PURE__ */ b.jsx(F3, { center: e, divider: h, left: i, leftCollapsed: v.left, persistenceId: c, resolvedLeft: g, resolvedRight: y, right: u, rightCollapsed: v.right, rootClass: j }) : /* @__PURE__ */ b.jsx(V3, { center: e, divider: h, left: i, leftCollapsed: v.left, persistenceId: c, resolvedLeft: g, resolvedRight: y, right: u, rightCollapsed: v.right, rootClass: j });
}), F3 = (t) => {
  const e = ee.c(33), {
    center: n,
    divider: o,
    left: r,
    leftCollapsed: s,
    persistenceId: i,
    resolvedLeft: a,
    resolvedRight: l,
    right: c,
    rightCollapsed: u,
    rootClass: d
  } = t;
  let p;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = {
    hasCustomLayout: !1,
    resetLayout: null
  }, e[0] = p) : p = e[0], ja(p);
  const [m, h] = q.useState(0), [g, y] = q.useState(0);
  let v;
  e[1] !== o || e[2] !== m ? (v = uo.resolve({
    inset: m,
    mode: o
  }), e[1] = o, e[2] = m, e[3] = v) : v = e[3];
  const x = v === "always";
  let w;
  e[4] !== o || e[5] !== g ? (w = uo.resolve({
    inset: g,
    mode: o
  }), e[4] = o, e[5] = g, e[6] = w) : w = e[6];
  const E = w === "always", S = `${d} ${It.rootStatic}`;
  let C;
  e[7] !== r || e[8] !== s || e[9] !== i || e[10] !== a ? (C = !s && /* @__PURE__ */ b.jsx(fc, { cfg: a, onInsetChange: h, persistenceId: i, side: "left", children: r }), e[7] = r, e[8] = s, e[9] = i, e[10] = a, e[11] = C) : C = e[11];
  let _;
  e[12] !== s || e[13] !== x ? (_ = !s && /* @__PURE__ */ b.jsx("div", { className: x ? It.dividerStatic : It.dividerStaticHidden }), e[12] = s, e[13] = x, e[14] = _) : _ = e[14];
  let R;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (R = {
    flex: 1,
    minWidth: 0
  }, e[15] = R) : R = e[15];
  let O;
  e[16] !== n ? (O = /* @__PURE__ */ b.jsx("div", { style: R, children: n }), e[16] = n, e[17] = O) : O = e[17];
  let j;
  e[18] !== u || e[19] !== E ? (j = !u && /* @__PURE__ */ b.jsx("div", { className: E ? It.dividerStatic : It.dividerStaticHidden }), e[18] = u, e[19] = E, e[20] = j) : j = e[20];
  let F;
  e[21] !== i || e[22] !== l || e[23] !== c || e[24] !== u ? (F = !u && /* @__PURE__ */ b.jsx(fc, { cfg: l, onInsetChange: y, persistenceId: i, side: "right", children: c }), e[21] = i, e[22] = l, e[23] = c, e[24] = u, e[25] = F) : F = e[25];
  let N;
  return e[26] !== F || e[27] !== S || e[28] !== C || e[29] !== _ || e[30] !== O || e[31] !== j ? (N = /* @__PURE__ */ b.jsxs("div", { className: S, children: [
    C,
    _,
    O,
    j,
    F
  ] }), e[26] = F, e[27] = S, e[28] = C, e[29] = _, e[30] = O, e[31] = j, e[32] = N) : N = e[32], N;
}, V3 = ({
  center: t,
  divider: e,
  left: n,
  leftCollapsed: o,
  persistenceId: r,
  resolvedLeft: s,
  resolvedRight: i,
  right: a,
  rightCollapsed: l,
  rootClass: c
}) => {
  const {
    isDebug: u
  } = cu(), d = av(), {
    ref: p,
    width: m
  } = iv(), [h, g] = Ui({
    persistenceId: r,
    side: "left"
  }), [y, v] = Ui({
    persistenceId: r,
    side: "right"
  }), x = !o, w = !l, E = x && s.kind === "resizable", S = w && i.kind === "resizable", C = q.useMemo(() => {
    const ie = [is.toFingerprintInput({
      cfg: s,
      defaultMax: rt.MAX,
      defaultMin: rt.MIN,
      id: Br
    }), {
      id: "split-center",
      kind: "flex"
    }, is.toFingerprintInput({
      cfg: i,
      defaultMax: rt.MAX,
      defaultMin: rt.MIN,
      id: Hr
    })];
    return Dt.fingerprint(ie);
  }, [s, i]), _ = q.useMemo(() => gp(s), [s]), R = q.useMemo(() => gp(i), [i]), [O, j] = q.useState(0), F = q.useMemo(() => {
    if (!r) return;
    const ie = [];
    if (E && ie.push({
      id: Br,
      ..._
    }), S && ie.push({
      id: Hr,
      ...R
    }), ie.length !== 0)
      return Dt.read({
        fingerprint: C,
        panes: ie,
        persistenceId: r
      }) ?? void 0;
  }, [r, O, C, _, R, E, S]), [N, T] = q.useState(F?.[Br] ?? _.defaultSize), [L, M] = q.useState(F?.[Hr] ?? R.defaultSize), A = q.useRef(N);
  A.current = N;
  const $ = q.useRef(L);
  $.current = L, q.useEffect(() => {
    T(F?.[Br] ?? _.defaultSize), M(F?.[Hr] ?? R.defaultSize);
  }, [F, _.defaultSize, R.defaultSize]);
  const k = q.useCallback((ie, de) => {
    const le = ie === "left" ? _ : R;
    if (m == null) return Math.max(le.minSize, Math.min(le.maxSize, de));
    const te = ie === "left" ? S ? L : 0 : E ? N : 0, pe = ie === "left" ? ni(i, w, y * 2) : ni(s, x, h * 2), ue = (x ? rt.HANDLE_SIZE : 0) + (w ? rt.HANDLE_SIZE : 0), ye = m - te - pe - rt.ABSORBING_MIN - ue, ge = Math.min(le.maxSize, Math.max(le.minSize, ye));
    return Math.max(le.minSize, Math.min(ge, de));
  }, [m, _, R, N, L, h, y, E, S, s, i, x, w]), H = E ? k("left", N) : 0, B = S ? k("right", L) : 0, P = q.useRef(H);
  P.current = H;
  const V = q.useRef(B);
  V.current = B;
  const I = q.useCallback(() => {
    const ie = _;
    if (m == null) return {
      max: ie.maxSize,
      min: ie.minSize
    };
    const de = S ? $.current : 0, le = ni(i, w, y * 2), te = (x ? rt.HANDLE_SIZE : 0) + (w ? rt.HANDLE_SIZE : 0), pe = m - de - le - rt.ABSORBING_MIN - te;
    return {
      max: Math.min(ie.maxSize, Math.max(ie.minSize, pe)),
      min: ie.minSize
    };
  }, [m, _, y, S, i, x, w]), D = q.useCallback(() => {
    const ie = R;
    if (m == null) return {
      max: ie.maxSize,
      min: ie.minSize
    };
    const de = E ? A.current : 0, le = ni(s, x, h * 2), te = (x ? rt.HANDLE_SIZE : 0) + (w ? rt.HANDLE_SIZE : 0), pe = m - de - le - rt.ABSORBING_MIN - te;
    return {
      max: Math.min(ie.maxSize, Math.max(ie.minSize, pe)),
      min: ie.minSize
    };
  }, [m, R, h, E, s, x, w]), z = E && N !== _.defaultSize || S && L !== R.defaultSize, U = q.useCallback(() => {
    r && Dt.remove(r), T(_.defaultSize), M(R.defaultSize), j((ie) => ie + 1);
  }, [r, _.defaultSize, R.defaultSize]);
  ja({
    hasCustomLayout: z,
    resetLayout: r ? U : null
  });
  const G = q.useCallback(() => {
    if (!r) return;
    const ie = {};
    E && (ie[Br] = A.current), S && (ie[Hr] = $.current), Dt.write(r, ie, C);
  }, [r, E, S, C]), J = q.useCallback(() => P.current, []), se = q.useCallback(() => V.current, []), Q = q.useCallback(() => G(), [G]), ce = q.useCallback(() => {
    const ie = Hi.resolveDoubleClick({
      collapsed: !1,
      minSize: _.minSize,
      size: P.current
    });
    ie !== null && (A.current = ie, T(ie), G());
  }, [_.minSize, G]), W = q.useCallback(() => {
    const ie = Hi.resolveDoubleClick({
      collapsed: !1,
      minSize: R.minSize,
      size: V.current
    });
    ie !== null && ($.current = ie, M(ie), G());
  }, [R.minSize, G]), {
    handleProps: oe,
    isDragging: Y
  } = pc({
    getBounds: I,
    getCurrentSize: J,
    onCommit: Q,
    onDoubleClick: ce,
    onSizeChange: T,
    orientation: "vertical"
  }), {
    handleProps: Z,
    isDragging: K
  } = pc({
    getBounds: D,
    getCurrentSize: se,
    invert: !0,
    onCommit: Q,
    onDoubleClick: W,
    onSizeChange: M,
    orientation: "vertical"
  }), X = uo.resolve({
    inset: h,
    mode: e
  }), ne = uo.resolve({
    inset: y,
    mode: e
  }), re = u && /* @__PURE__ */ b.jsx("span", { className: It.handleDebug });
  return /* @__PURE__ */ b.jsxs("div", { ref: p, className: `${c} ${It.rootStatic}`, children: [
    x && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
      /* @__PURE__ */ b.jsx(
        "div",
        {
          className: It.anchoredPane,
          "data-armed": d || void 0,
          "data-dragging": Y || void 0,
          style: {
            flexShrink: 0,
            width: E ? `${H}px` : bp(s, h * 2)
          },
          children: /* @__PURE__ */ b.jsx(vr.Provider, { value: g, children: n })
        }
      ),
      E ? /* @__PURE__ */ b.jsx("div", { className: hp(X), style: z3(X, h), ...oe, children: re }) : /* @__PURE__ */ b.jsx("div", { className: X === "always" ? It.dividerStatic : It.dividerStaticHidden })
    ] }),
    /* @__PURE__ */ b.jsx("div", { style: {
      flex: 1,
      minWidth: 0
    }, children: t }),
    w && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
      S ? (
        /** No gutter var: this handle's card sits to its RIGHT, and the box already overhangs that way
         *  by its whole trailing 6px, so there is little worth widening into. */
        /* @__PURE__ */ b.jsx("div", { className: hp(ne), ...Z, children: re })
      ) : /* @__PURE__ */ b.jsx("div", { className: ne === "always" ? It.dividerStatic : It.dividerStaticHidden }),
      /* @__PURE__ */ b.jsx("div", { className: It.anchoredPane, "data-armed": d || void 0, "data-dragging": K || void 0, style: {
        flexShrink: 0,
        width: S ? `${B}px` : bp(i, y * 2)
      }, children: /* @__PURE__ */ b.jsx(vr.Provider, { value: v, children: a }) })
    ] })
  ] });
}, hp = (t) => t === "always" ? It.handleVisible : t === "hover" ? It.handleHover : It.handleNever, z3 = (t, e) => t === "hover" && e > 0 ? {
  "--split-handle-gutter": `${e}px`
} : void 0, gp = (t) => t.kind === "fixed" ? {
  defaultSize: t.size,
  maxSize: t.size,
  minSize: t.size
} : t.kind === "iconRail" ? {
  defaultSize: rt.RAIL_SIZE,
  maxSize: rt.RAIL_SIZE,
  minSize: rt.RAIL_SIZE
} : {
  defaultSize: t.defaultSize,
  maxSize: t.maxSize ?? rt.MAX,
  minSize: t.minSize ?? rt.MIN
}, B3 = (t, e, n, o) => {
  const r = n || is.isStatic(t), s = o || is.isStatic(e);
  return r && s ? {
    kind: "all-static"
  } : {
    kind: "all-draggable"
  };
}, bp = (t, e) => t.kind === "fixed" ? `${t.size}px` : t.kind === "iconRail" ? Bi.resolve(e) : `${t.defaultSize}px`, ni = (t, e, n) => e ? t.kind === "fixed" ? t.size : t.kind === "iconRail" ? rt.RAIL_SIZE + n : 0 : 0, H3 = "_root_1f2ln_1", U3 = "_handleVisible_1f2ln_6", W3 = "_handleHover_1f2ln_64", G3 = "_handleNever_1f2ln_117", K3 = "_handleDebug_1f2ln_129", Y3 = "_dividerStatic_1f2ln_137", q3 = "_dividerStaticHidden_1f2ln_145", X3 = "_rootStatic_1f2ln_153", Z3 = "_anchoredPane_1f2ln_165", J3 = "_snappablePane_1f2ln_179", an = {
  root: H3,
  handleVisible: U3,
  handleHover: W3,
  handleNever: G3,
  handleDebug: K3,
  dividerStatic: Y3,
  dividerStaticHidden: q3,
  rootStatic: X3,
  anchoredPane: Z3,
  snappablePane: J3
}, Q3 = ({
  absorbingId: t,
  anchorId: e,
  collapse: n,
  config: o,
  orientation: r,
  persistenceId: s,
  railInset: i = 0
}) => {
  const {
    height: a,
    ref: l,
    width: c
  } = iv(), u = r === "vertical" ? c : a, d = q.useContext(pg)?.density ?? "standard", p = Bi.px({
    density: d,
    insetTotal: i
  }), m = o.minSize ?? rt.MIN, h = o.maxSize ?? rt.MAX, g = o.defaultSize, y = q.useMemo(() => Dt.fingerprint([is.toFingerprintInput({
    cfg: o,
    defaultMax: rt.MAX,
    defaultMin: rt.MIN,
    id: e
  }), {
    id: t,
    kind: "flex"
  }]), [o, e, t]), [v, x] = q.useState(0), w = q.useMemo(() => s ? Dt.read({
    fingerprint: y,
    panes: [{
      defaultSize: g,
      id: e,
      maxSize: h,
      minSize: m
    }],
    persistenceId: s
  })?.[e] : void 0, [s, v, y, g, m, h, e]), [E, S] = q.useState(w ?? g);
  q.useEffect(() => {
    S(w ?? g);
  }, [w, g]);
  const C = q.useMemo(() => u == null ? h : Math.min(h, Math.max(m, u - rt.ABSORBING_MIN - rt.HANDLE_SIZE)), [u, m, h]), _ = Math.max(m, Math.min(C, E)), R = q.useRef(_);
  R.current = _;
  const O = n ? Math.min(m, p) : m, j = q.useCallback(() => ({
    max: C,
    min: O
  }), [C, O]), F = E !== g, N = q.useCallback(() => {
    s && Dt.remove(s), S(g), x((G) => G + 1);
  }, [s, g]);
  ja({
    hasCustomLayout: F,
    resetLayout: s ? N : null
  });
  const T = q.useCallback(() => n?.collapsed ? p : R.current, [n?.collapsed, p]), L = q.useCallback((G) => {
    if (!n) {
      s && Dt.write(s, {
        [e]: G
      }, y);
      return;
    }
    if (n.collapsed) return;
    const J = Math.max(m, Math.min(C, G));
    S(J), s && Dt.write(s, {
      [e]: J
    }, y);
  }, [n, s, y, e, m, C]), [M, A] = q.useState(!1), $ = q.useRef(null);
  q.useEffect(() => () => {
    $.current && clearTimeout($.current);
  }, []);
  const k = q.useCallback(() => {
    const G = Hi.resolveDoubleClick({
      collapsed: n?.collapsed ?? !1,
      minSize: m,
      size: R.current
    });
    G !== null && (S(G), s && Dt.write(s, {
      [e]: G
    }, y), A(!0), $.current && clearTimeout($.current), $.current = setTimeout(() => {
      $.current = null, A(!1);
    }, rt.SNAP_MS));
  }, [n?.collapsed, m, s, e, y]), H = (G) => {
    if (!n) {
      S(G);
      return;
    }
    const J = Hi.resolve({
      collapsed: n.collapsed,
      minSize: m,
      railSize: p,
      size: G
    });
    J.action === "collapse" ? (n.collapsed || n.onCollapsedChange(!0), S(G)) : (J.action === "expand" && n.collapsed && n.onCollapsedChange(!1), S(J.size));
  }, {
    handleProps: B,
    isDragging: P
  } = pc({
    getBounds: j,
    getCurrentSize: T,
    onCommit: L,
    onDoubleClick: k,
    /** Snap the live `size` to the drag's exact start value — `getCurrentSize()` — in the same batch that
     *  flips `isDragging` on, so the FIRST drag frame renders precisely the idle width and never jumps.
     *  `size` can legitimately drift out of view between drags: the idle render clamps it up to `minSize`
     *  (when expanded) or shows the rail token (when collapsed), while the state itself may still hold a
     *  smaller value left over from a prior collapse. Flipping `isDragging` on lowers the render's floor
     *  to the rail, which would otherwise expose that stale value for one frame — the jerk. Re-seeding
     *  `size` from `getCurrentSize` (rail when collapsed, the committed ≥ minSize width when expanded)
     *  makes idle-width and first-drag-frame identical for EVERY entry point: drag- or toggle-collapse,
     *  toggle-expand, or a plain resize. It also self-heals any clamp drift. The value is only realigned
     *  on grab, so a TOGGLE re-open still restores the untouched expanded width. */
    onDragStart: () => S(T()),
    onSizeChange: H,
    orientation: r
  }), I = Math.max(n && P ? O : m, Math.min(C, E)), D = (p + m) / 2, z = n && P ? Math.min(1, Math.max(0, n.collapsed ? (D - I) / (D - p) : (I - D) / (m - D))) : 1, U = n ? P ? Math.min(1, Math.max(0, (m - I) / (m - p))) : n.collapsed ? 1 : 0 : 0;
  return {
    collapseFade: z,
    collapseProgress: U,
    containerRef: l,
    effectiveSize: I,
    handleProps: B,
    hasCustomLayout: F,
    isDragging: P,
    isSnapping: M,
    railWidth: Bi.resolve(i),
    resetLayout: N
  };
}, e4 = "split-left", t4 = "split-right", ML = (t) => {
  const e = ee.c(31), {
    className: n,
    defaultLeftCollapsed: o,
    divider: r,
    left: s,
    leftCollapsed: i,
    leftCollapsible: a,
    leftPane: l,
    onLeftCollapsedChange: c,
    persistenceId: u,
    right: d,
    showDivider: p
  } = t, m = a === void 0 ? !1 : a;
  let h;
  e[0] !== r || e[1] !== p ? (h = uo.fromLegacy({
    divider: r,
    showDivider: p
  }), e[0] = r, e[1] = p, e[2] = h) : h = e[2];
  const g = h;
  let y;
  e[3] !== l ? (y = l ?? {
    defaultSize: rt.SIZE,
    kind: "resizable"
  }, e[3] = l, e[4] = y) : y = e[4];
  const v = y;
  let x;
  e[5] !== o || e[6] !== u ? (x = () => (u ? Dt.readCollapsed(u)?.left : void 0) ?? o ?? !1, e[5] = o, e[6] = u, e[7] = x) : x = e[7];
  const [w, E] = q.useState(x), S = i !== void 0, C = S ? i : w;
  let _;
  e[8] !== S || e[9] !== c || e[10] !== u ? (_ = (T) => {
    S || E(T), u && Dt.writeCollapsed(u, {
      left: T,
      right: !1
    }), c?.(T);
  }, e[8] = S, e[9] = c, e[10] = u, e[11] = _) : _ = e[11];
  const R = _, O = n ? `${an.root} ${n}` : an.root;
  if (v.kind === "fixed" || v.kind === "iconRail") {
    let T;
    return e[12] !== g || e[13] !== s || e[14] !== u || e[15] !== v || e[16] !== d || e[17] !== O ? (T = /* @__PURE__ */ b.jsx(n4, { divider: g, left: s, persistenceId: u, resolvedLeft: v, right: d, rootClass: O }), e[12] = g, e[13] = s, e[14] = u, e[15] = v, e[16] = d, e[17] = O, e[18] = T) : T = e[18], T;
  }
  let j;
  e[19] !== C || e[20] !== m || e[21] !== R ? (j = m ? {
    collapsed: C,
    onCollapsedChange: R
  } : void 0, e[19] = C, e[20] = m, e[21] = R, e[22] = j) : j = e[22];
  const F = j;
  let N;
  return e[23] !== F || e[24] !== g || e[25] !== s || e[26] !== u || e[27] !== v || e[28] !== d || e[29] !== O ? (N = /* @__PURE__ */ b.jsx(o4, { collapse: F, divider: g, left: s, persistenceId: u, resolvedLeft: v, right: d, rootClass: O }), e[23] = F, e[24] = g, e[25] = s, e[26] = u, e[27] = v, e[28] = d, e[29] = O, e[30] = N) : N = e[30], N;
}, n4 = (t) => {
  const e = ee.c(15), {
    divider: n,
    left: o,
    persistenceId: r,
    resolvedLeft: s,
    right: i,
    rootClass: a
  } = t;
  let l;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = {
    hasCustomLayout: !1,
    resetLayout: null
  }, e[0] = l) : l = e[0], ja(l);
  const [c, u] = q.useState(0), d = uo.resolve({
    inset: c,
    mode: n
  }) === "always", p = `${a} ${an.rootStatic}`;
  let m;
  e[1] !== o || e[2] !== r || e[3] !== s ? (m = /* @__PURE__ */ b.jsx(fc, { cfg: s, onInsetChange: u, persistenceId: r, side: "left", children: o }), e[1] = o, e[2] = r, e[3] = s, e[4] = m) : m = e[4];
  const h = d ? an.dividerStatic : an.dividerStaticHidden;
  let g;
  e[5] !== h ? (g = /* @__PURE__ */ b.jsx("div", { className: h }), e[5] = h, e[6] = g) : g = e[6];
  let y;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = {
    flex: 1,
    minWidth: 0,
    position: "relative"
  }, e[7] = y) : y = e[7];
  let v;
  e[8] !== i ? (v = /* @__PURE__ */ b.jsx("div", { style: y, children: i }), e[8] = i, e[9] = v) : v = e[9];
  let x;
  return e[10] !== p || e[11] !== m || e[12] !== g || e[13] !== v ? (x = /* @__PURE__ */ b.jsxs("div", { className: p, children: [
    m,
    g,
    v
  ] }), e[10] = p, e[11] = m, e[12] = g, e[13] = v, e[14] = x) : x = e[14], x;
}, o4 = (t) => {
  const e = ee.c(40), {
    collapse: n,
    divider: o,
    left: r,
    persistenceId: s,
    resolvedLeft: i,
    right: a,
    rootClass: l
  } = t, {
    isDebug: c
  } = cu(), u = av();
  let d;
  e[0] !== s ? (d = {
    persistenceId: s,
    side: "left"
  }, e[0] = s, e[1] = d) : d = e[1];
  const [p, m] = Ui(d), h = n ? p * 2 : 0, g = uo.resolve({
    inset: p,
    mode: o
  });
  let y;
  e[2] !== n || e[3] !== s || e[4] !== h || e[5] !== i ? (y = {
    absorbingId: t4,
    anchorId: e4,
    collapse: n,
    config: i,
    orientation: "vertical",
    persistenceId: s,
    railInset: h
  }, e[2] = n, e[3] = s, e[4] = h, e[5] = i, e[6] = y) : y = e[6];
  const {
    collapseFade: v,
    collapseProgress: x,
    containerRef: w,
    effectiveSize: E,
    handleProps: S,
    isDragging: C,
    isSnapping: _,
    railWidth: R
  } = Q3(y), O = r4(g), j = n?.collapsed && !C ? R : `${E}px`, F = `${l} ${an.rootStatic}`, N = n ? an.anchoredPane : an.snappablePane, T = u || void 0, L = n ? C : void 0, M = _ || void 0;
  let A;
  e[7] !== v || e[8] !== x || e[9] !== j ? (A = {
    "--split-pane-collapse": x,
    "--split-pane-fade": v,
    flexShrink: 0,
    width: j
  }, e[7] = v, e[8] = x, e[9] = j, e[10] = A) : A = e[10];
  const $ = A, k = n ?? null;
  let H;
  e[11] !== r || e[12] !== k ? (H = /* @__PURE__ */ b.jsx(td.Provider, { value: k, children: r }), e[11] = r, e[12] = k, e[13] = H) : H = e[13];
  let B;
  e[14] !== m || e[15] !== H ? (B = /* @__PURE__ */ b.jsx(vr.Provider, { value: m, children: H }), e[14] = m, e[15] = H, e[16] = B) : B = e[16];
  let P;
  e[17] !== B || e[18] !== N || e[19] !== T || e[20] !== L || e[21] !== M || e[22] !== $ ? (P = /* @__PURE__ */ b.jsx("div", { className: N, "data-armed": T, "data-dragging": L, "data-snapping": M, style: $, children: B }), e[17] = B, e[18] = N, e[19] = T, e[20] = L, e[21] = M, e[22] = $, e[23] = P) : P = e[23];
  const V = s4(g, p);
  let I;
  e[24] !== c ? (I = c && /* @__PURE__ */ b.jsx("span", { className: an.handleDebug }), e[24] = c, e[25] = I) : I = e[25];
  let D;
  e[26] !== O || e[27] !== S || e[28] !== V || e[29] !== I ? (D = /* @__PURE__ */ b.jsx("div", { className: O, style: V, ...S, children: I }), e[26] = O, e[27] = S, e[28] = V, e[29] = I, e[30] = D) : D = e[30];
  let z;
  e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (z = {
    flex: 1,
    minWidth: 0,
    position: "relative"
  }, e[31] = z) : z = e[31];
  let U;
  e[32] !== a ? (U = /* @__PURE__ */ b.jsx("div", { style: z, children: a }), e[32] = a, e[33] = U) : U = e[33];
  let G;
  return e[34] !== w || e[35] !== P || e[36] !== D || e[37] !== U || e[38] !== F ? (G = /* @__PURE__ */ b.jsxs("div", { ref: w, className: F, children: [
    P,
    D,
    U
  ] }), e[34] = w, e[35] = P, e[36] = D, e[37] = U, e[38] = F, e[39] = G) : G = e[39], G;
}, r4 = (t) => t === "always" ? an.handleVisible : t === "hover" ? an.handleHover : an.handleNever, s4 = (t, e) => t === "hover" && e > 0 ? {
  "--split-handle-gutter": `${e}px`
} : void 0, oi = "The server did not return a usable reason. Try again in a moment.", i4 = "The server took too long to respond and the request timed out. Try again in a moment.", a4 = "TimeoutError", PL = {
  /**
   * Report a refresh failure. The raw payload always reaches the console AND telemetry; the toast is fired
   * only when there is data on screen, and a repeat failure for the same label REPLACES the live toast
   * (sonner keys on the stable `id`) rather than stacking a second one.
   * @param options - The failure to report.
   * @param options.error - The failure as the query layer surfaced it. A falsy value is a no-op.
   * @param options.hasData - Whether the surface currently has data on screen.
   * @param options.label - The surface's own nav/page label.
   */
  show(t) {
    const {
      error: e,
      hasData: n,
      label: o
    } = t;
    e && (c4(e, o), n && Zr.error(`Couldn't refresh ${o}`, {
      description: l4(e),
      id: `blufin.refresh-failure.${o}`
    }));
  }
}, l4 = (t) => {
  if (t.name === a4) return i4;
  if (!t.message) return oi;
  let e;
  try {
    e = JSON.parse(t.message);
  } catch {
    return oi;
  }
  if (typeof e != "object" || e === null) return oi;
  const n = e;
  return typeof n.message == "string" && n.message ? n.message : typeof n.data?.message == "string" && n.data.message ? n.data.message : oi;
}, c4 = (t, e) => {
  const n = t.message ?? t.name ?? "Unknown failure";
  try {
    console.error("[refresh-failure]", e, n);
    const o = Ai.getAgent();
    if (!o) return;
    o.log({
      data: {
        surface: e
      },
      event: "app.refresh.failed",
      level: lu.ERROR,
      message: n
    });
  } catch {
  }
}, AL = {
  demo2ColGrid: {
    alignItems: "center",
    display: "grid",
    gap: "0.75rem 1.5rem",
    gridTemplateColumns: "calc(var(--field-width-lg) + 1.6rem + 2px) 1fr"
  },
  demoMonoLabel: {
    color: "var(--text-secondary)",
    fontFamily: "var(--font-mono)",
    fontSize: "0.7rem",
    letterSpacing: "0.05em",
    textTransform: "uppercase"
  }
}, u4 = "_popup_1c3ta_1", d4 = "_item_1c3ta_20", f4 = "_shortcut_1c3ta_39", p4 = "_itemDestructive_1c3ta_72", m4 = "_iconSlot_1c3ta_91", h4 = "_chevron_1c3ta_97", g4 = "_label_1c3ta_101", b4 = "_separator_1c3ta_117", Xt = {
  popup: u4,
  item: d4,
  shortcut: f4,
  itemDestructive: p4,
  iconSlot: m4,
  chevron: h4,
  label: g4,
  separator: b4
}, v4 = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m12 19l-7-7l7-7m7 7H5"/>'
}, y4 = v4, x4 = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14m-7-7l7 7l-7 7"/>'
}, w4 = x4, S4 = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m9 10l-5 5l5 5"/><path d="M20 4v7a4 4 0 0 1-4 4H4"/></g>'
}, E4 = S4, nn = (t) => {
  const e = ee.c(4);
  let n;
  return e[0] !== t.children || e[1] !== t.className || e[2] !== t.name ? (n = /* @__PURE__ */ b.jsx("svg", { "aria-hidden": !0, "data-glyph": t.name, viewBox: "0 0 16 16", width: "1em", height: "1em", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: t.className, children: t.children }), e[0] = t.children, e[1] = t.className, e[2] = t.name, e[3] = n) : n = e[3], n;
}, C4 = (t) => {
  const e = ee.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("path", { d: "M9 12h5" }), o = /* @__PURE__ */ b.jsx("path", { d: "M2 4h3l4 8" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t.className ? (r = /* @__PURE__ */ b.jsxs(nn, { name: "alt", className: t.className, children: [
    n,
    o
  ] }), e[2] = t.className, e[3] = r) : r = e[3], r;
}, _4 = (t) => {
  const e = ee.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("path", { d: "M14.5 2.5H6L1 8l5 5.5h8.5Z" }), o = /* @__PURE__ */ b.jsx("path", { d: "m8 6 4 4M12 6l-4 4" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t.className ? (r = /* @__PURE__ */ b.jsxs(nn, { name: "backspace", className: t.className, children: [
    n,
    o
  ] }), e[2] = t.className, e[3] = r) : r = e[3], r;
}, vp = (t) => {
  const e = ee.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("path", { d: "M12 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2H4a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2V4a2 2 0 0 0-2-2 2 2 0 0 0-2 2 2 2 0 0 0 2 2h8a2 2 0 0 0 2-2 2 2 0 0 0-2-2z" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t.className ? (o = /* @__PURE__ */ b.jsx(nn, { name: "cmd", className: t.className, children: n }), e[1] = t.className, e[2] = o) : o = e[2], o;
}, R4 = (t) => {
  const e = ee.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("polyline", { points: "3,10 8,5 13,10" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t.className ? (o = /* @__PURE__ */ b.jsx(nn, { name: "ctrl", className: t.className, children: n }), e[1] = t.className, e[2] = o) : o = e[2], o;
}, N4 = (t) => {
  const e = ee.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("path", { d: "M1.5 2.5H10L15 8l-5 5.5H1.5Z" }), o = /* @__PURE__ */ b.jsx("path", { d: "m4 6 4 4M8 6l-4 4" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t.className ? (r = /* @__PURE__ */ b.jsxs(nn, { name: "delete", className: t.className, children: [
    n,
    o
  ] }), e[2] = t.className, e[3] = r) : r = e[3], r;
}, k4 = (t) => {
  const e = ee.c(5);
  let n, o, r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("path", { d: "M3 13h10" }), o = /* @__PURE__ */ b.jsx("path", { d: "M8 3v7" }), r = /* @__PURE__ */ b.jsx("polyline", { points: "5,7 8,10 11,7" }), e[0] = n, e[1] = o, e[2] = r) : (n = e[0], o = e[1], r = e[2]);
  let s;
  return e[3] !== t.className ? (s = /* @__PURE__ */ b.jsxs(nn, { name: "end", className: t.className, children: [
    n,
    o,
    r
  ] }), e[3] = t.className, e[4] = s) : s = e[4], s;
}, T4 = (t) => {
  const e = ee.c(5);
  let n, o, r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("path", { d: "M13 13 4 4" }), o = /* @__PURE__ */ b.jsx("path", { d: "M4 4h5" }), r = /* @__PURE__ */ b.jsx("path", { d: "M4 4v5" }), e[0] = n, e[1] = o, e[2] = r) : (n = e[0], o = e[1], r = e[2]);
  let s;
  return e[3] !== t.className ? (s = /* @__PURE__ */ b.jsxs(nn, { name: "escape", className: t.className, children: [
    n,
    o,
    r
  ] }), e[3] = t.className, e[4] = s) : s = e[4], s;
}, I4 = (t) => {
  const e = ee.c(5);
  let n, o, r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("path", { d: "M3 3h10" }), o = /* @__PURE__ */ b.jsx("path", { d: "M8 13V6" }), r = /* @__PURE__ */ b.jsx("polyline", { points: "5,9 8,6 11,9" }), e[0] = n, e[1] = o, e[2] = r) : (n = e[0], o = e[1], r = e[2]);
  let s;
  return e[3] !== t.className ? (s = /* @__PURE__ */ b.jsxs(nn, { name: "home", className: t.className, children: [
    n,
    o,
    r
  ] }), e[3] = t.className, e[4] = s) : s = e[4], s;
}, O4 = (t) => {
  const e = ee.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("polyline", { points: "3,3 8,8 13,3" }), o = /* @__PURE__ */ b.jsx("polyline", { points: "3,8 8,13 13,8" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t.className ? (r = /* @__PURE__ */ b.jsxs(nn, { name: "page-down", className: t.className, children: [
    n,
    o
  ] }), e[2] = t.className, e[3] = r) : r = e[3], r;
}, M4 = (t) => {
  const e = ee.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("polyline", { points: "3,8 8,3 13,8" }), o = /* @__PURE__ */ b.jsx("polyline", { points: "3,13 8,8 13,13" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t.className ? (r = /* @__PURE__ */ b.jsxs(nn, { name: "page-up", className: t.className, children: [
    n,
    o
  ] }), e[2] = t.className, e[3] = r) : r = e[3], r;
}, P4 = (t) => {
  const e = ee.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("path", { d: "M8 2.5 14 8.5h-3v4H5v-4H2L8 2.5Z" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t.className ? (o = /* @__PURE__ */ b.jsx(nn, { name: "shift", className: t.className, children: n }), e[1] = t.className, e[2] = o) : o = e[2], o;
}, A4 = (t) => {
  const e = ee.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("polyline", { points: "3,7 3,11 13,11 13,7" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t.className ? (o = /* @__PURE__ */ b.jsx(nn, { name: "space", className: t.className, children: n }), e[1] = t.className, e[2] = o) : o = e[2], o;
}, D4 = (t) => {
  const e = ee.c(5);
  let n, o, r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ b.jsx("path", { d: "M2 8h9" }), o = /* @__PURE__ */ b.jsx("polyline", { points: "8,5 11,8 8,11" }), r = /* @__PURE__ */ b.jsx("path", { d: "M13 4v8" }), e[0] = n, e[1] = o, e[2] = r) : (n = e[0], o = e[1], r = e[2]);
  let s;
  return e[3] !== t.className ? (s = /* @__PURE__ */ b.jsxs(nn, { name: "tab", className: t.className, children: [
    n,
    o,
    r
  ] }), e[3] = t.className, e[4] = s) : s = e[4], s;
}, j4 = {
  Alt: /* @__PURE__ */ b.jsx(C4, {}),
  Control: /* @__PURE__ */ b.jsx(R4, {}),
  Meta: /* @__PURE__ */ b.jsx(vp, {}),
  Mod: /* @__PURE__ */ b.jsx(vp, {}),
  Shift: /* @__PURE__ */ b.jsx(P4, {})
}, L4 = {
  ArrowDown: /* @__PURE__ */ b.jsx(no, { icon: Cg, size: 13 }),
  ArrowLeft: /* @__PURE__ */ b.jsx(no, { icon: y4, size: 13 }),
  ArrowRight: /* @__PURE__ */ b.jsx(no, { icon: w4, size: 13 }),
  ArrowUp: /* @__PURE__ */ b.jsx(no, { icon: _g, size: 13 }),
  Backspace: /* @__PURE__ */ b.jsx(_4, {}),
  Delete: /* @__PURE__ */ b.jsx(N4, {}),
  End: /* @__PURE__ */ b.jsx(k4, {}),
  Enter: /* @__PURE__ */ b.jsx(no, { icon: E4, size: 13 }),
  Escape: /* @__PURE__ */ b.jsx(T4, {}),
  Home: /* @__PURE__ */ b.jsx(I4, {}),
  PageDown: /* @__PURE__ */ b.jsx(O4, {}),
  PageUp: /* @__PURE__ */ b.jsx(M4, {}),
  Space: /* @__PURE__ */ b.jsx(A4, {}),
  Tab: /* @__PURE__ */ b.jsx(D4, {})
}, lv = "pointer-events-none inline-flex select-none items-center font-mono font-medium text-[13px]", nd = (t) => {
  const e = ee.c(10), {
    parsed: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = _n.isMacOS(), e[0] = o) : o = e[0];
  const r = o, s = n.modifiers;
  let i, a;
  if (e[1] !== n.key || e[2] !== n.modifiers) {
    a = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      let u;
      e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = (v) => v === "Mod" ? r ? "Meta" : "Control" : v, e[5] = u) : u = e[5];
      const d = s.map(u);
      if (r) {
        const v = ["Control", "Alt", "Shift", "Meta"], x = [...d].sort((S, C) => v.indexOf(S) - v.indexOf(C)), w = L4[n.key], E = [...x.map($4), w ?? n.key.toUpperCase()];
        a = /* @__PURE__ */ b.jsx("span", { className: "flex items-center gap-0.5", children: E.map(F4) });
        break e;
      }
      let p;
      e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = ["Control", "Alt", "Shift", "Meta"], e[6] = p) : p = e[6];
      const m = p;
      let h;
      e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = (v, x) => m.indexOf(v) - m.indexOf(x), e[7] = h) : h = e[7], i = [...[...d].sort(h).map(V4), n.key];
    }
    e[1] = n.key, e[2] = n.modifiers, e[3] = i, e[4] = a;
  } else
    i = e[3], a = e[4];
  if (a !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return a;
  const l = i;
  let c;
  return e[8] !== l ? (c = /* @__PURE__ */ b.jsx("span", { className: "flex items-center gap-0.5", children: l.map(z4) }), e[8] = l, e[9] = c) : c = e[9], c;
};
function $4(t) {
  return j4[t] ?? t;
}
function F4(t, e) {
  return /* @__PURE__ */ b.jsx("kbd", { className: lv, children: t }, e);
}
function V4(t) {
  return t === "Control" ? "Ctrl" : t;
}
function z4(t, e) {
  return /* @__PURE__ */ b.jsxs(f.Fragment, { children: [
    e > 0 && "+",
    /* @__PURE__ */ b.jsx("kbd", { className: lv, children: t })
  ] }, e);
}
const B4 = (t) => typeof t == "object" && t !== null && typeof t.body == "string", cv = /* @__PURE__ */ new Set(["close-press", "escape-key", "imperative-action", "item-press", "outside-press", "sibling-open"]), H4 = (t, e) => {
  t || cv.has(e.reason) || e.cancel();
}, yp = 280, U4 = (t) => {
  const e = ee.c(46), {
    items: n,
    onClose: o,
    onSelect: r,
    open: s,
    position: i
  } = t;
  let a, l, c, u, d, p, m, h, g, y, v, x, w, E;
  if (e[0] !== n || e[1] !== o || e[2] !== r || e[3] !== s || e[4] !== i) {
    const O = [];
    let j = [], F = null;
    for (const M of n)
      M.scopeTypeId !== F && (j.length > 0 && O.push(j), j = [], F = M.scopeTypeId), j.push(M);
    j.length > 0 && O.push(j);
    let N;
    e[19] !== i.x || e[20] !== i.y ? (N = {
      getBoundingClientRect: () => ({
        bottom: i.y,
        height: 0,
        left: i.x,
        right: i.x,
        top: i.y,
        width: 0,
        x: i.x,
        y: i.y
      })
    }, e[19] = i.x, e[20] = i.y, e[21] = N) : N = e[21];
    const T = N, L = (M, A) => {
      const $ = B4(M.icon) ? M.icon : null, k = M.iconColor ? {
        color: `var(${M.iconColor})`
      } : void 0, H = $ ? /* @__PURE__ */ b.jsx(Ve, { className: Xt.iconSlot, icon: $, style: k }) : /* @__PURE__ */ b.jsx("span", { "aria-hidden": !0, className: Xt.iconSlot }), B = /* @__PURE__ */ b.jsx("span", { className: Xt.label, children: M.label });
      if (M.children)
        return /* @__PURE__ */ b.jsxs(eb, { onOpenChange: H4, children: [
          /* @__PURE__ */ b.jsxs(ku, { className: Xt.item, children: [
            H,
            B,
            /* @__PURE__ */ b.jsx(Ve, { className: `${Xt.iconSlot} ${Xt.chevron}`, icon: Ra })
          ] }),
          /* @__PURE__ */ b.jsx(ss, { children: /* @__PURE__ */ b.jsx($i, { side: "right", align: "start", sideOffset: 0, alignOffset: -4, children: /* @__PURE__ */ b.jsx(Li, { "data-slot": "action-menu-sub", className: Xt.popup, style: {
            width: yp
          }, children: M.children.map((D, z) => L(D, z)) }) }) })
        ] }, `${M.action.id}-${A}`);
      const P = M.shortcut ? lo.parse(M.shortcut) : null, V = M.destructive ? `${Xt.item} ${Xt.itemDestructive}` : Xt.item, I = M.destructive ? void 0 : M.selected ? "" : void 0;
      return /* @__PURE__ */ b.jsxs(xu, { disabled: M.disabled, onClick: () => r(M), className: V, "data-selected": I, children: [
        H,
        B,
        P ? /* @__PURE__ */ b.jsx("span", { className: Xt.shortcut, children: /* @__PURE__ */ b.jsx(nd, { parsed: P }) }) : null
      ] }, `${M.action.id}-${A}`);
    };
    u = Nu, w = s, e[22] !== o ? (E = (M, A) => {
      if (!M) {
        if (!cv.has(A.reason)) {
          A.cancel();
          return;
        }
        o();
      }
    }, e[22] = o, e[23] = E) : E = e[23], c = ss, l = $i, g = T, y = "bottom", v = "start", x = 2, a = Li, d = "action-menu", p = Xt.popup, e[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = {
      width: yp
    }, e[24] = m) : m = e[24], h = O.map((M, A) => /* @__PURE__ */ b.jsxs(f.Fragment, { children: [
      A > 0 ? /* @__PURE__ */ b.jsx(Cs, { className: Xt.separator }) : null,
      M.map(($, k) => L($, k))
    ] }, `${M[0].scopeTypeId}-${A}`)), e[0] = n, e[1] = o, e[2] = r, e[3] = s, e[4] = i, e[5] = a, e[6] = l, e[7] = c, e[8] = u, e[9] = d, e[10] = p, e[11] = m, e[12] = h, e[13] = g, e[14] = y, e[15] = v, e[16] = x, e[17] = w, e[18] = E;
  } else
    a = e[5], l = e[6], c = e[7], u = e[8], d = e[9], p = e[10], m = e[11], h = e[12], g = e[13], y = e[14], v = e[15], x = e[16], w = e[17], E = e[18];
  let S;
  e[25] !== a || e[26] !== d || e[27] !== p || e[28] !== m || e[29] !== h ? (S = /* @__PURE__ */ b.jsx(a, { "data-slot": d, className: p, style: m, children: h }), e[25] = a, e[26] = d, e[27] = p, e[28] = m, e[29] = h, e[30] = S) : S = e[30];
  let C;
  e[31] !== l || e[32] !== S || e[33] !== g || e[34] !== y || e[35] !== v || e[36] !== x ? (C = /* @__PURE__ */ b.jsx(l, { anchor: g, side: y, align: v, sideOffset: x, children: S }), e[31] = l, e[32] = S, e[33] = g, e[34] = y, e[35] = v, e[36] = x, e[37] = C) : C = e[37];
  let _;
  e[38] !== c || e[39] !== C ? (_ = /* @__PURE__ */ b.jsx(c, { children: C }), e[38] = c, e[39] = C, e[40] = _) : _ = e[40];
  let R;
  return e[41] !== u || e[42] !== _ || e[43] !== w || e[44] !== E ? (R = /* @__PURE__ */ b.jsx(u, { open: w, onOpenChange: E, children: _ }), e[41] = u, e[42] = _, e[43] = w, e[44] = E, e[45] = R) : R = e[45], R;
};
var xp = 1, W4 = 0.9, G4 = 0.8, K4 = 0.17, wl = 0.1, Sl = 0.999, Y4 = 0.9999, q4 = 0.99, X4 = /[\\\/_+.#"@\[\(\{&]/, Z4 = /[\\\/_+.#"@\[\(\{&]/g, J4 = /[\s-]/, uv = /[\s-]/g;
function mc(t, e, n, o, r, s, i) {
  if (s === e.length) return r === t.length ? xp : q4;
  var a = `${r},${s}`;
  if (i[a] !== void 0) return i[a];
  for (var l = o.charAt(s), c = n.indexOf(l, r), u = 0, d, p, m, h; c >= 0; ) d = mc(t, e, n, o, c + 1, s + 1, i), d > u && (c === r ? d *= xp : X4.test(t.charAt(c - 1)) ? (d *= G4, m = t.slice(r, c - 1).match(Z4), m && r > 0 && (d *= Math.pow(Sl, m.length))) : J4.test(t.charAt(c - 1)) ? (d *= W4, h = t.slice(r, c - 1).match(uv), h && r > 0 && (d *= Math.pow(Sl, h.length))) : (d *= K4, r > 0 && (d *= Math.pow(Sl, c - r))), t.charAt(c) !== e.charAt(s) && (d *= Y4)), (d < wl && n.charAt(c - 1) === o.charAt(s + 1) || o.charAt(s + 1) === o.charAt(s) && n.charAt(c - 1) !== o.charAt(s)) && (p = mc(t, e, n, o, c + 1, s + 2, i), p * wl > d && (d = p * wl)), d > u && (u = d), c = n.indexOf(l, c + 1);
  return i[a] = u, u;
}
function wp(t) {
  return t.toLowerCase().replace(uv, " ");
}
function Q4(t, e, n) {
  return t = n && n.length > 0 ? `${t + " " + n.join(" ")}` : t, mc(t, e, wp(t), wp(e), 0, 0, {});
}
function co(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (t?.(r), n === !1 || !r.defaultPrevented)
      return e?.(r);
  };
}
function Sp(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function fo(...t) {
  return (e) => {
    let n = !1;
    const o = t.map((r) => {
      const s = Sp(r, e);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const s = o[r];
          typeof s == "function" ? s() : Sp(t[r], null);
        }
      };
  };
}
function Bo(...t) {
  return f.useCallback(fo(...t), t);
}
function eA(t, e) {
  const n = f.createContext(e), o = (s) => {
    const { children: i, ...a } = s, l = f.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ b.jsx(n.Provider, { value: l, children: i });
  };
  o.displayName = t + "Provider";
  function r(s) {
    const i = f.useContext(n);
    if (i) return i;
    if (e !== void 0) return e;
    throw new Error(`\`${s}\` must be used within \`${t}\``);
  }
  return [o, r];
}
function tA(t, e = []) {
  let n = [];
  function o(s, i) {
    const a = f.createContext(i), l = n.length;
    n = [...n, i];
    const c = (d) => {
      const { scope: p, children: m, ...h } = d, g = p?.[t]?.[l] || a, y = f.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ b.jsx(g.Provider, { value: y, children: m });
    };
    c.displayName = s + "Provider";
    function u(d, p) {
      const m = p?.[t]?.[l] || a, h = f.useContext(m);
      if (h) return h;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${s}\``);
    }
    return [c, u];
  }
  const r = () => {
    const s = n.map((i) => f.createContext(i));
    return function(a) {
      const l = a?.[t] || s;
      return f.useMemo(
        () => ({ [`__scope${t}`]: { ...a, [t]: l } }),
        [a, l]
      );
    };
  };
  return r.scopeName = t, [o, nA(r, ...e)];
}
function nA(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const o = t.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(s) {
      const i = o.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(s)[`__scope${c}`];
        return { ...a, ...d };
      }, {});
      return f.useMemo(() => ({ [`__scope${e.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
var as = globalThis?.document ? f.useLayoutEffect : () => {
}, oA = f[" useId ".trim().toString()] || (() => {
}), rA = 0;
function Vn(t) {
  const [e, n] = f.useState(oA());
  return as(() => {
    n((o) => o ?? String(rA++));
  }, [t]), e ? `radix-${e}` : "";
}
var sA = f[" useInsertionEffect ".trim().toString()] || as;
function iA({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  },
  caller: o
}) {
  const [r, s, i] = aA({
    defaultProp: e,
    onChange: n
  }), a = t !== void 0, l = a ? t : r;
  {
    const u = f.useRef(t !== void 0);
    f.useEffect(() => {
      const d = u.current;
      d !== a && console.warn(
        `${o} is changing from ${d ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = a;
    }, [a, o]);
  }
  const c = f.useCallback(
    (u) => {
      if (a) {
        const d = lA(u) ? u(t) : u;
        d !== t && i.current?.(d);
      } else
        s(u);
    },
    [a, t, s, i]
  );
  return [l, c];
}
function aA({
  defaultProp: t,
  onChange: e
}) {
  const [n, o] = f.useState(t), r = f.useRef(n), s = f.useRef(e);
  return sA(() => {
    s.current = e;
  }, [e]), f.useEffect(() => {
    r.current !== n && (s.current?.(n), r.current = n);
  }, [n, r]), [n, o, s];
}
function lA(t) {
  return typeof t == "function";
}
// @__NO_SIDE_EFFECTS__
function dv(t) {
  const e = /* @__PURE__ */ cA(t), n = f.forwardRef((o, r) => {
    const { children: s, ...i } = o, a = f.Children.toArray(s), l = a.find(dA);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ b.jsx(e, { ...i, ref: r, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ b.jsx(e, { ...i, ref: r, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function cA(t) {
  const e = f.forwardRef((n, o) => {
    const { children: r, ...s } = n;
    if (f.isValidElement(r)) {
      const i = pA(r), a = fA(s, r.props);
      return r.type !== f.Fragment && (a.ref = o ? fo(o, i) : i), f.cloneElement(r, a);
    }
    return f.Children.count(r) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var uA = /* @__PURE__ */ Symbol("radix.slottable");
function dA(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === uA;
}
function fA(t, e) {
  const n = { ...e };
  for (const o in e) {
    const r = t[o], s = e[o];
    /^on[A-Z]/.test(o) ? r && s ? n[o] = (...a) => {
      const l = s(...a);
      return r(...a), l;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...s } : o === "className" && (n[o] = [r, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function pA(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var mA = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Zn = mA.reduce((t, e) => {
  const n = /* @__PURE__ */ dv(`Primitive.${e}`), o = f.forwardRef((r, s) => {
    const { asChild: i, ...a } = r, l = i ? n : e;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ b.jsx(l, { ...a, ref: s });
  });
  return o.displayName = `Primitive.${e}`, { ...t, [e]: o };
}, {});
function hA(t, e) {
  t && Vt.flushSync(() => t.dispatchEvent(e));
}
function ls(t) {
  const e = f.useRef(t);
  return f.useEffect(() => {
    e.current = t;
  }), f.useMemo(() => (...n) => e.current?.(...n), []);
}
function gA(t, e = globalThis?.document) {
  const n = ls(t);
  f.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return e.addEventListener("keydown", o, { capture: !0 }), () => e.removeEventListener("keydown", o, { capture: !0 });
  }, [n, e]);
}
var bA = "DismissableLayer", hc = "dismissableLayer.update", vA = "dismissableLayer.pointerDownOutside", yA = "dismissableLayer.focusOutside", Ep, fv = f.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), pv = f.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: s,
      onInteractOutside: i,
      onDismiss: a,
      ...l
    } = t, c = f.useContext(fv), [u, d] = f.useState(null), p = u?.ownerDocument ?? globalThis?.document, [, m] = f.useState({}), h = Bo(e, (_) => d(_)), g = Array.from(c.layers), [y] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), v = g.indexOf(y), x = u ? g.indexOf(u) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, E = x >= v, S = SA((_) => {
      const R = _.target, O = [...c.branches].some((j) => j.contains(R));
      !E || O || (r?.(_), i?.(_), _.defaultPrevented || a?.());
    }, p), C = EA((_) => {
      const R = _.target;
      [...c.branches].some((j) => j.contains(R)) || (s?.(_), i?.(_), _.defaultPrevented || a?.());
    }, p);
    return gA((_) => {
      x === c.layers.size - 1 && (o?.(_), !_.defaultPrevented && a && (_.preventDefault(), a()));
    }, p), f.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Ep = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Cp(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = Ep);
        };
    }, [u, p, n, c]), f.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Cp());
    }, [u, c]), f.useEffect(() => {
      const _ = () => m({});
      return document.addEventListener(hc, _), () => document.removeEventListener(hc, _);
    }, []), /* @__PURE__ */ b.jsx(
      Zn.div,
      {
        ...l,
        ref: h,
        style: {
          pointerEvents: w ? E ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: co(t.onFocusCapture, C.onFocusCapture),
        onBlurCapture: co(t.onBlurCapture, C.onBlurCapture),
        onPointerDownCapture: co(
          t.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
pv.displayName = bA;
var xA = "DismissableLayerBranch", wA = f.forwardRef((t, e) => {
  const n = f.useContext(fv), o = f.useRef(null), r = Bo(e, o);
  return f.useEffect(() => {
    const s = o.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ b.jsx(Zn.div, { ...t, ref: r });
});
wA.displayName = xA;
function SA(t, e = globalThis?.document) {
  const n = ls(t), o = f.useRef(!1), r = f.useRef(() => {
  });
  return f.useEffect(() => {
    const s = (a) => {
      if (a.target && !o.current) {
        let l = function() {
          mv(
            vA,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: a };
        a.pointerType === "touch" ? (e.removeEventListener("click", r.current), r.current = l, e.addEventListener("click", r.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", r.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      e.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(i), e.removeEventListener("pointerdown", s), e.removeEventListener("click", r.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function EA(t, e = globalThis?.document) {
  const n = ls(t), o = f.useRef(!1);
  return f.useEffect(() => {
    const r = (s) => {
      s.target && !o.current && mv(yA, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", r), () => e.removeEventListener("focusin", r);
  }, [e, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Cp() {
  const t = new CustomEvent(hc);
  document.dispatchEvent(t);
}
function mv(t, e, n, { discrete: o }) {
  const r = n.originalEvent.target, s = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && r.addEventListener(t, e, { once: !0 }), o ? hA(r, s) : r.dispatchEvent(s);
}
var El = "focusScope.autoFocusOnMount", Cl = "focusScope.autoFocusOnUnmount", _p = { bubbles: !1, cancelable: !0 }, CA = "FocusScope", hv = f.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: s,
    ...i
  } = t, [a, l] = f.useState(null), c = ls(r), u = ls(s), d = f.useRef(null), p = Bo(e, (g) => l(g)), m = f.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  f.useEffect(() => {
    if (o) {
      let g = function(w) {
        if (m.paused || !a) return;
        const E = w.target;
        a.contains(E) ? d.current = E : to(d.current, { select: !0 });
      }, y = function(w) {
        if (m.paused || !a) return;
        const E = w.relatedTarget;
        E !== null && (a.contains(E) || to(d.current, { select: !0 }));
      }, v = function(w) {
        if (document.activeElement === document.body)
          for (const S of w)
            S.removedNodes.length > 0 && to(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", y);
      const x = new MutationObserver(v);
      return a && x.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", y), x.disconnect();
      };
    }
  }, [o, a, m.paused]), f.useEffect(() => {
    if (a) {
      Np.add(m);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const v = new CustomEvent(El, _p);
        a.addEventListener(El, c), a.dispatchEvent(v), v.defaultPrevented || (_A(IA(gv(a)), { select: !0 }), document.activeElement === g && to(a));
      }
      return () => {
        a.removeEventListener(El, c), setTimeout(() => {
          const v = new CustomEvent(Cl, _p);
          a.addEventListener(Cl, u), a.dispatchEvent(v), v.defaultPrevented || to(g ?? document.body, { select: !0 }), a.removeEventListener(Cl, u), Np.remove(m);
        }, 0);
      };
    }
  }, [a, c, u, m]);
  const h = f.useCallback(
    (g) => {
      if (!n && !o || m.paused) return;
      const y = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, v = document.activeElement;
      if (y && v) {
        const x = g.currentTarget, [w, E] = RA(x);
        w && E ? !g.shiftKey && v === E ? (g.preventDefault(), n && to(w, { select: !0 })) : g.shiftKey && v === w && (g.preventDefault(), n && to(E, { select: !0 })) : v === x && g.preventDefault();
      }
    },
    [n, o, m.paused]
  );
  return /* @__PURE__ */ b.jsx(Zn.div, { tabIndex: -1, ...i, ref: p, onKeyDown: h });
});
hv.displayName = CA;
function _A(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const o of t)
    if (to(o, { select: e }), document.activeElement !== n) return;
}
function RA(t) {
  const e = gv(t), n = Rp(e, t), o = Rp(e.reverse(), t);
  return [n, o];
}
function gv(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function Rp(t, e) {
  for (const n of t)
    if (!NA(n, { upTo: e })) return n;
}
function NA(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function kA(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function to(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && kA(t) && e && t.select();
  }
}
var Np = TA();
function TA() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && n?.pause(), t = kp(t, e), t.unshift(e);
    },
    remove(e) {
      t = kp(t, e), t[0]?.resume();
    }
  };
}
function kp(t, e) {
  const n = [...t], o = n.indexOf(e);
  return o !== -1 && n.splice(o, 1), n;
}
function IA(t) {
  return t.filter((e) => e.tagName !== "A");
}
var OA = "Portal", bv = f.forwardRef((t, e) => {
  const { container: n, ...o } = t, [r, s] = f.useState(!1);
  as(() => s(!0), []);
  const i = n || r && globalThis?.document?.body;
  return i ? $p.createPortal(/* @__PURE__ */ b.jsx(Zn.div, { ...o, ref: e }), i) : null;
});
bv.displayName = OA;
function MA(t, e) {
  return f.useReducer((n, o) => e[n][o] ?? n, t);
}
var La = (t) => {
  const { present: e, children: n } = t, o = PA(e), r = typeof n == "function" ? n({ present: o.isPresent }) : f.Children.only(n), s = Bo(o.ref, AA(r));
  return typeof n == "function" || o.isPresent ? f.cloneElement(r, { ref: s }) : null;
};
La.displayName = "Presence";
function PA(t) {
  const [e, n] = f.useState(), o = f.useRef(null), r = f.useRef(t), s = f.useRef("none"), i = t ? "mounted" : "unmounted", [a, l] = MA(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return f.useEffect(() => {
    const c = ri(o.current);
    s.current = a === "mounted" ? c : "none";
  }, [a]), as(() => {
    const c = o.current, u = r.current;
    if (u !== t) {
      const p = s.current, m = ri(c);
      t ? l("MOUNT") : m === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && p !== m ? "ANIMATION_OUT" : "UNMOUNT"), r.current = t;
    }
  }, [t, l]), as(() => {
    if (e) {
      let c;
      const u = e.ownerDocument.defaultView ?? window, d = (m) => {
        const g = ri(o.current).includes(CSS.escape(m.animationName));
        if (m.target === e && g && (l("ANIMATION_END"), !r.current)) {
          const y = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = y);
          });
        }
      }, p = (m) => {
        m.target === e && (s.current = ri(o.current));
      };
      return e.addEventListener("animationstart", p), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        u.clearTimeout(c), e.removeEventListener("animationstart", p), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: f.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function ri(t) {
  return t?.animationName || "none";
}
function AA(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var _l = 0;
function DA() {
  f.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? Tp()), document.body.insertAdjacentElement("beforeend", t[1] ?? Tp()), _l++, () => {
      _l === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), _l--;
    };
  }, []);
}
function Tp() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var Cn = function() {
  return Cn = Object.assign || function(e) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, Cn.apply(this, arguments);
};
function vv(t, e) {
  var n = {};
  for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(t); r < o.length; r++)
      e.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[r]) && (n[o[r]] = t[o[r]]);
  return n;
}
function jA(t, e, n) {
  if (n || arguments.length === 2) for (var o = 0, r = e.length, s; o < r; o++)
    (s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
  return t.concat(s || Array.prototype.slice.call(e));
}
var yi = "right-scroll-bar-position", xi = "width-before-scroll-bar", LA = "with-scroll-bars-hidden", $A = "--removed-body-scroll-bar-size";
function Rl(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function FA(t, e) {
  var n = Fn(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
var VA = typeof window < "u" ? f.useLayoutEffect : f.useEffect, Ip = /* @__PURE__ */ new WeakMap();
function zA(t, e) {
  var n = FA(null, function(o) {
    return t.forEach(function(r) {
      return Rl(r, o);
    });
  });
  return VA(function() {
    var o = Ip.get(n);
    if (o) {
      var r = new Set(o), s = new Set(t), i = n.current;
      r.forEach(function(a) {
        s.has(a) || Rl(a, null);
      }), s.forEach(function(a) {
        r.has(a) || Rl(a, i);
      });
    }
    Ip.set(n, t);
  }, [t]), n;
}
function BA(t) {
  return t;
}
function HA(t, e) {
  e === void 0 && (e = BA);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(s) {
      var i = e(s, o);
      return n.push(i), function() {
        n = n.filter(function(a) {
          return a !== i;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (o = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(s);
      }
      n = {
        push: function(a) {
          return s(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      o = !0;
      var i = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(s), i = n;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(s);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return r;
}
function UA(t) {
  t === void 0 && (t = {});
  var e = HA(null);
  return e.options = Cn({ async: !0, ssr: !1 }, t), e;
}
var yv = function(t) {
  var e = t.sideCar, n = vv(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = e.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return f.createElement(o, Cn({}, n));
};
yv.isSideCarExport = !0;
function WA(t, e) {
  return t.useMedium(e), yv;
}
var xv = UA(), Nl = function() {
}, $a = f.forwardRef(function(t, e) {
  var n = f.useRef(null), o = f.useState({
    onScrollCapture: Nl,
    onWheelCapture: Nl,
    onTouchMoveCapture: Nl
  }), r = o[0], s = o[1], i = t.forwardProps, a = t.children, l = t.className, c = t.removeScrollBar, u = t.enabled, d = t.shards, p = t.sideCar, m = t.noRelative, h = t.noIsolation, g = t.inert, y = t.allowPinchZoom, v = t.as, x = v === void 0 ? "div" : v, w = t.gapMode, E = vv(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = p, C = zA([n, e]), _ = Cn(Cn({}, E), r);
  return f.createElement(
    f.Fragment,
    null,
    u && f.createElement(S, { sideCar: xv, removeScrollBar: c, shards: d, noRelative: m, noIsolation: h, inert: g, setCallbacks: s, allowPinchZoom: !!y, lockRef: n, gapMode: w }),
    i ? f.cloneElement(f.Children.only(a), Cn(Cn({}, _), { ref: C })) : f.createElement(x, Cn({}, _, { className: l, ref: C }), a)
  );
});
$a.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
$a.classNames = {
  fullWidth: xi,
  zeroRight: yi
};
var GA = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function KA() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = GA();
  return e && t.setAttribute("nonce", e), t;
}
function YA(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function qA(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var XA = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = KA()) && (YA(e, n), qA(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, ZA = function() {
  var t = XA();
  return function(e, n) {
    f.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, wv = function() {
  var t = ZA(), e = function(n) {
    var o = n.styles, r = n.dynamic;
    return t(o, r), null;
  };
  return e;
}, JA = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, kl = function(t) {
  return parseInt(t || "", 10) || 0;
}, QA = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], o = e[t === "padding" ? "paddingTop" : "marginTop"], r = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [kl(n), kl(o), kl(r)];
}, e5 = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return JA;
  var e = QA(t), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, o - n + e[2] - e[0])
  };
}, t5 = wv(), dr = "data-scroll-locked", n5 = function(t, e, n, o) {
  var r = t.left, s = t.top, i = t.right, a = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(LA, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(a, "px ").concat(o, `;
  }
  body[`).concat(dr, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(yi, ` {
    right: `).concat(a, "px ").concat(o, `;
  }
  
  .`).concat(xi, ` {
    margin-right: `).concat(a, "px ").concat(o, `;
  }
  
  .`).concat(yi, " .").concat(yi, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(xi, " .").concat(xi, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(dr, `] {
    `).concat($A, ": ").concat(a, `px;
  }
`);
}, Op = function() {
  var t = parseInt(document.body.getAttribute(dr) || "0", 10);
  return isFinite(t) ? t : 0;
}, o5 = function() {
  f.useEffect(function() {
    return document.body.setAttribute(dr, (Op() + 1).toString()), function() {
      var t = Op() - 1;
      t <= 0 ? document.body.removeAttribute(dr) : document.body.setAttribute(dr, t.toString());
    };
  }, []);
}, r5 = function(t) {
  var e = t.noRelative, n = t.noImportant, o = t.gapMode, r = o === void 0 ? "margin" : o;
  o5();
  var s = f.useMemo(function() {
    return e5(r);
  }, [r]);
  return f.createElement(t5, { styles: n5(s, !e, r, n ? "" : "!important") });
}, gc = !1;
if (typeof window < "u")
  try {
    var si = Object.defineProperty({}, "passive", {
      get: function() {
        return gc = !0, !0;
      }
    });
    window.addEventListener("test", si, si), window.removeEventListener("test", si, si);
  } catch {
    gc = !1;
  }
var Zo = gc ? { passive: !1 } : !1, s5 = function(t) {
  return t.tagName === "TEXTAREA";
}, Sv = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !s5(t) && n[e] === "visible")
  );
}, i5 = function(t) {
  return Sv(t, "overflowY");
}, a5 = function(t) {
  return Sv(t, "overflowX");
}, Mp = function(t, e) {
  var n = e.ownerDocument, o = e;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = Ev(t, o);
    if (r) {
      var s = Cv(t, o), i = s[1], a = s[2];
      if (i > a)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, l5 = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, o = t.clientHeight;
  return [
    e,
    n,
    o
  ];
}, c5 = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, o = t.clientWidth;
  return [
    e,
    n,
    o
  ];
}, Ev = function(t, e) {
  return t === "v" ? i5(e) : a5(e);
}, Cv = function(t, e) {
  return t === "v" ? l5(e) : c5(e);
}, u5 = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, d5 = function(t, e, n, o, r) {
  var s = u5(t, window.getComputedStyle(e).direction), i = s * o, a = n.target, l = e.contains(a), c = !1, u = i > 0, d = 0, p = 0;
  do {
    if (!a)
      break;
    var m = Cv(t, a), h = m[0], g = m[1], y = m[2], v = g - y - s * h;
    (h || v) && Ev(t, a) && (d += v, p += h);
    var x = a.parentNode;
    a = x && x.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? x.host : x;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (e.contains(a) || e === a)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(p) < 1) && (c = !0), c;
}, ii = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, Pp = function(t) {
  return [t.deltaX, t.deltaY];
}, Ap = function(t) {
  return t && "current" in t ? t.current : t;
}, f5 = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, p5 = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, m5 = 0, Jo = [];
function h5(t) {
  var e = f.useRef([]), n = f.useRef([0, 0]), o = f.useRef(), r = f.useState(m5++)[0], s = f.useState(wv)[0], i = f.useRef(t);
  f.useEffect(function() {
    i.current = t;
  }, [t]), f.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var g = jA([t.lockRef.current], (t.shards || []).map(Ap), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var a = f.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !i.current.allowPinchZoom;
    var v = ii(g), x = n.current, w = "deltaX" in g ? g.deltaX : x[0] - v[0], E = "deltaY" in g ? g.deltaY : x[1] - v[1], S, C = g.target, _ = Math.abs(w) > Math.abs(E) ? "h" : "v";
    if ("touches" in g && _ === "h" && C.type === "range")
      return !1;
    var R = window.getSelection(), O = R && R.anchorNode, j = O ? O === C || O.contains(C) : !1;
    if (j)
      return !1;
    var F = Mp(_, C);
    if (!F)
      return !0;
    if (F ? S = _ : (S = _ === "v" ? "h" : "v", F = Mp(_, C)), !F)
      return !1;
    if (!o.current && "changedTouches" in g && (w || E) && (o.current = S), !S)
      return !0;
    var N = o.current || S;
    return d5(N, y, g, N === "h" ? w : E);
  }, []), l = f.useCallback(function(g) {
    var y = g;
    if (!(!Jo.length || Jo[Jo.length - 1] !== s)) {
      var v = "deltaY" in y ? Pp(y) : ii(y), x = e.current.filter(function(S) {
        return S.name === y.type && (S.target === y.target || y.target === S.shadowParent) && f5(S.delta, v);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var w = (i.current.shards || []).map(Ap).filter(Boolean).filter(function(S) {
          return S.contains(y.target);
        }), E = w.length > 0 ? a(y, w[0]) : !i.current.noIsolation;
        E && y.cancelable && y.preventDefault();
      }
    }
  }, []), c = f.useCallback(function(g, y, v, x) {
    var w = { name: g, delta: y, target: v, should: x, shadowParent: g5(v) };
    e.current.push(w), setTimeout(function() {
      e.current = e.current.filter(function(E) {
        return E !== w;
      });
    }, 1);
  }, []), u = f.useCallback(function(g) {
    n.current = ii(g), o.current = void 0;
  }, []), d = f.useCallback(function(g) {
    c(g.type, Pp(g), g.target, a(g, t.lockRef.current));
  }, []), p = f.useCallback(function(g) {
    c(g.type, ii(g), g.target, a(g, t.lockRef.current));
  }, []);
  f.useEffect(function() {
    return Jo.push(s), t.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", l, Zo), document.addEventListener("touchmove", l, Zo), document.addEventListener("touchstart", u, Zo), function() {
      Jo = Jo.filter(function(g) {
        return g !== s;
      }), document.removeEventListener("wheel", l, Zo), document.removeEventListener("touchmove", l, Zo), document.removeEventListener("touchstart", u, Zo);
    };
  }, []);
  var m = t.removeScrollBar, h = t.inert;
  return f.createElement(
    f.Fragment,
    null,
    h ? f.createElement(s, { styles: p5(r) }) : null,
    m ? f.createElement(r5, { noRelative: t.noRelative, gapMode: t.gapMode }) : null
  );
}
function g5(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const b5 = WA(xv, h5);
var _v = f.forwardRef(function(t, e) {
  return f.createElement($a, Cn({}, t, { ref: e, sideCar: b5 }));
});
_v.classNames = $a.classNames;
var v5 = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, Qo = /* @__PURE__ */ new WeakMap(), ai = /* @__PURE__ */ new WeakMap(), li = {}, Tl = 0, Rv = function(t) {
  return t && (t.host || Rv(t.parentNode));
}, y5 = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var o = Rv(n);
    return o && t.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, x5 = function(t, e, n, o) {
  var r = y5(e, Array.isArray(t) ? t : [t]);
  li[n] || (li[n] = /* @__PURE__ */ new WeakMap());
  var s = li[n], i = [], a = /* @__PURE__ */ new Set(), l = new Set(r), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  r.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(p) {
      if (a.has(p))
        u(p);
      else
        try {
          var m = p.getAttribute(o), h = m !== null && m !== "false", g = (Qo.get(p) || 0) + 1, y = (s.get(p) || 0) + 1;
          Qo.set(p, g), s.set(p, y), i.push(p), g === 1 && h && ai.set(p, !0), y === 1 && p.setAttribute(n, "true"), h || p.setAttribute(o, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", p, v);
        }
    });
  };
  return u(e), a.clear(), Tl++, function() {
    i.forEach(function(d) {
      var p = Qo.get(d) - 1, m = s.get(d) - 1;
      Qo.set(d, p), s.set(d, m), p || (ai.has(d) || d.removeAttribute(o), ai.delete(d)), m || d.removeAttribute(n);
    }), Tl--, Tl || (Qo = /* @__PURE__ */ new WeakMap(), Qo = /* @__PURE__ */ new WeakMap(), ai = /* @__PURE__ */ new WeakMap(), li = {});
  };
}, w5 = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(t) ? t : [t]), r = v5(t);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live], script"))), x5(o, r, n, "aria-hidden")) : function() {
    return null;
  };
}, Fa = "Dialog", [Nv] = tA(Fa), [S5, yn] = Nv(Fa), kv = (t) => {
  const {
    __scopeDialog: e,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: s,
    modal: i = !0
  } = t, a = f.useRef(null), l = f.useRef(null), [c, u] = iA({
    prop: o,
    defaultProp: r ?? !1,
    onChange: s,
    caller: Fa
  });
  return /* @__PURE__ */ b.jsx(
    S5,
    {
      scope: e,
      triggerRef: a,
      contentRef: l,
      contentId: Vn(),
      titleId: Vn(),
      descriptionId: Vn(),
      open: c,
      onOpenChange: u,
      onOpenToggle: f.useCallback(() => u((d) => !d), [u]),
      modal: i,
      children: n
    }
  );
};
kv.displayName = Fa;
var Tv = "DialogTrigger", E5 = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...o } = t, r = yn(Tv, n), s = Bo(e, r.triggerRef);
    return /* @__PURE__ */ b.jsx(
      Zn.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": sd(r.open),
        ...o,
        ref: s,
        onClick: co(t.onClick, r.onOpenToggle)
      }
    );
  }
);
E5.displayName = Tv;
var od = "DialogPortal", [C5, Iv] = Nv(od, {
  forceMount: void 0
}), Ov = (t) => {
  const { __scopeDialog: e, forceMount: n, children: o, container: r } = t, s = yn(od, e);
  return /* @__PURE__ */ b.jsx(C5, { scope: e, forceMount: n, children: f.Children.map(o, (i) => /* @__PURE__ */ b.jsx(La, { present: n || s.open, children: /* @__PURE__ */ b.jsx(bv, { asChild: !0, container: r, children: i }) })) });
};
Ov.displayName = od;
var Wi = "DialogOverlay", Mv = f.forwardRef(
  (t, e) => {
    const n = Iv(Wi, t.__scopeDialog), { forceMount: o = n.forceMount, ...r } = t, s = yn(Wi, t.__scopeDialog);
    return s.modal ? /* @__PURE__ */ b.jsx(La, { present: o || s.open, children: /* @__PURE__ */ b.jsx(R5, { ...r, ref: e }) }) : null;
  }
);
Mv.displayName = Wi;
var _5 = /* @__PURE__ */ dv("DialogOverlay.RemoveScroll"), R5 = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...o } = t, r = yn(Wi, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ b.jsx(_v, { as: _5, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ b.jsx(
        Zn.div,
        {
          "data-state": sd(r.open),
          ...o,
          ref: e,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), Ao = "DialogContent", Pv = f.forwardRef(
  (t, e) => {
    const n = Iv(Ao, t.__scopeDialog), { forceMount: o = n.forceMount, ...r } = t, s = yn(Ao, t.__scopeDialog);
    return /* @__PURE__ */ b.jsx(La, { present: o || s.open, children: s.modal ? /* @__PURE__ */ b.jsx(N5, { ...r, ref: e }) : /* @__PURE__ */ b.jsx(k5, { ...r, ref: e }) });
  }
);
Pv.displayName = Ao;
var N5 = f.forwardRef(
  (t, e) => {
    const n = yn(Ao, t.__scopeDialog), o = f.useRef(null), r = Bo(e, n.contentRef, o);
    return f.useEffect(() => {
      const s = o.current;
      if (s) return w5(s);
    }, []), /* @__PURE__ */ b.jsx(
      Av,
      {
        ...t,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: co(t.onCloseAutoFocus, (s) => {
          s.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: co(t.onPointerDownOutside, (s) => {
          const i = s.detail.originalEvent, a = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || a) && s.preventDefault();
        }),
        onFocusOutside: co(
          t.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), k5 = f.forwardRef(
  (t, e) => {
    const n = yn(Ao, t.__scopeDialog), o = f.useRef(!1), r = f.useRef(!1);
    return /* @__PURE__ */ b.jsx(
      Av,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          t.onCloseAutoFocus?.(s), s.defaultPrevented || (o.current || n.triggerRef.current?.focus(), s.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (s) => {
          t.onInteractOutside?.(s), s.defaultPrevented || (o.current = !0, s.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = s.target;
          n.triggerRef.current?.contains(i) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && r.current && s.preventDefault();
        }
      }
    );
  }
), Av = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: s, ...i } = t, a = yn(Ao, n), l = f.useRef(null), c = Bo(e, l);
    return DA(), /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
      /* @__PURE__ */ b.jsx(
        hv,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: r,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ b.jsx(
            pv,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": sd(a.open),
              ...i,
              ref: c,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
        /* @__PURE__ */ b.jsx(M5, { titleId: a.titleId }),
        /* @__PURE__ */ b.jsx(A5, { contentRef: l, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), rd = "DialogTitle", T5 = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...o } = t, r = yn(rd, n);
    return /* @__PURE__ */ b.jsx(Zn.h2, { id: r.titleId, ...o, ref: e });
  }
);
T5.displayName = rd;
var Dv = "DialogDescription", I5 = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...o } = t, r = yn(Dv, n);
    return /* @__PURE__ */ b.jsx(Zn.p, { id: r.descriptionId, ...o, ref: e });
  }
);
I5.displayName = Dv;
var jv = "DialogClose", O5 = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...o } = t, r = yn(jv, n);
    return /* @__PURE__ */ b.jsx(
      Zn.button,
      {
        type: "button",
        ...o,
        ref: e,
        onClick: co(t.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
O5.displayName = jv;
function sd(t) {
  return t ? "open" : "closed";
}
var Lv = "DialogTitleWarning", [DL, $v] = eA(Lv, {
  contentName: Ao,
  titleName: rd,
  docsSlug: "dialog"
}), M5 = ({ titleId: t }) => {
  const e = $v(Lv), n = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return f.useEffect(() => {
    t && (document.getElementById(t) || console.error(n));
  }, [n, t]), null;
}, P5 = "DialogDescriptionWarning", A5 = ({ contentRef: t, descriptionId: e }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${$v(P5).contentName}}.`;
  return f.useEffect(() => {
    const r = t.current?.getAttribute("aria-describedby");
    e && r && (document.getElementById(e) || console.warn(o));
  }, [o, t, e]), null;
}, D5 = kv, j5 = Ov, L5 = Mv, $5 = Pv, F5 = /* @__PURE__ */ Symbol.for("react.lazy"), Gi = f[" use ".trim().toString()];
function V5(t) {
  return typeof t == "object" && t !== null && "then" in t;
}
function Fv(t) {
  return t != null && typeof t == "object" && "$$typeof" in t && t.$$typeof === F5 && "_payload" in t && V5(t._payload);
}
// @__NO_SIDE_EFFECTS__
function z5(t) {
  const e = /* @__PURE__ */ B5(t), n = f.forwardRef((o, r) => {
    let { children: s, ...i } = o;
    Fv(s) && typeof Gi == "function" && (s = Gi(s._payload));
    const a = f.Children.toArray(s), l = a.find(U5);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ b.jsx(e, { ...i, ref: r, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ b.jsx(e, { ...i, ref: r, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function B5(t) {
  const e = f.forwardRef((n, o) => {
    let { children: r, ...s } = n;
    if (Fv(r) && typeof Gi == "function" && (r = Gi(r._payload)), f.isValidElement(r)) {
      const i = G5(r), a = W5(s, r.props);
      return r.type !== f.Fragment && (a.ref = o ? fo(o, i) : i), f.cloneElement(r, a);
    }
    return f.Children.count(r) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var H5 = /* @__PURE__ */ Symbol("radix.slottable");
function U5(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === H5;
}
function W5(t, e) {
  const n = { ...e };
  for (const o in e) {
    const r = t[o], s = e[o];
    /^on[A-Z]/.test(o) ? r && s ? n[o] = (...a) => {
      const l = s(...a);
      return r(...a), l;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...s } : o === "className" && (n[o] = [r, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function G5(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var K5 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], xo = K5.reduce((t, e) => {
  const n = /* @__PURE__ */ z5(`Primitive.${e}`), o = f.forwardRef((r, s) => {
    const { asChild: i, ...a } = r, l = i ? n : e;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ b.jsx(l, { ...a, ref: s });
  });
  return o.displayName = `Primitive.${e}`, { ...t, [e]: o };
}, {}), Ur = '[cmdk-group=""]', Il = '[cmdk-group-items=""]', Y5 = '[cmdk-group-heading=""]', Vv = '[cmdk-item=""]', Dp = `${Vv}:not([aria-disabled="true"])`, bc = "cmdk-item-select", tr = "data-value", q5 = (t, e, n) => Q4(t, e, n), zv = f.createContext(void 0), Ns = () => f.useContext(zv), Bv = f.createContext(void 0), id = () => f.useContext(Bv), Hv = f.createContext(void 0), Uv = f.forwardRef((t, e) => {
  let n = nr(() => {
    var V, I;
    return { search: "", value: (I = (V = t.value) != null ? V : t.defaultValue) != null ? I : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), o = nr(() => /* @__PURE__ */ new Set()), r = nr(() => /* @__PURE__ */ new Map()), s = nr(() => /* @__PURE__ */ new Map()), i = nr(() => /* @__PURE__ */ new Set()), a = Wv(t), { label: l, children: c, value: u, onValueChange: d, filter: p, shouldFilter: m, loop: h, disablePointerSelection: g = !1, vimBindings: y = !0, ...v } = t, x = Vn(), w = Vn(), E = Vn(), S = f.useRef(null), C = iD();
  Do(() => {
    if (u !== void 0) {
      let V = u.trim();
      n.current.value = V, _.emit();
    }
  }, [u]), Do(() => {
    C(6, T);
  }, []);
  let _ = f.useMemo(() => ({ subscribe: (V) => (i.current.add(V), () => i.current.delete(V)), snapshot: () => n.current, setState: (V, I, D) => {
    var z, U, G, J;
    if (!Object.is(n.current[V], I)) {
      if (n.current[V] = I, V === "search") N(), j(), C(1, F);
      else if (V === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let se = document.getElementById(E);
          se ? se.focus() : (z = document.getElementById(x)) == null || z.focus();
        }
        if (C(7, () => {
          var se;
          n.current.selectedItemId = (se = L()) == null ? void 0 : se.id, _.emit();
        }), D || C(5, T), ((U = a.current) == null ? void 0 : U.value) !== void 0) {
          let se = I ?? "";
          (J = (G = a.current).onValueChange) == null || J.call(G, se);
          return;
        }
      }
      _.emit();
    }
  }, emit: () => {
    i.current.forEach((V) => V());
  } }), []), R = f.useMemo(() => ({ value: (V, I, D) => {
    var z;
    I !== ((z = s.current.get(V)) == null ? void 0 : z.value) && (s.current.set(V, { value: I, keywords: D }), n.current.filtered.items.set(V, O(I, D)), C(2, () => {
      j(), _.emit();
    }));
  }, item: (V, I) => (o.current.add(V), I && (r.current.has(I) ? r.current.get(I).add(V) : r.current.set(I, /* @__PURE__ */ new Set([V]))), C(3, () => {
    N(), j(), n.current.value || F(), _.emit();
  }), () => {
    s.current.delete(V), o.current.delete(V), n.current.filtered.items.delete(V);
    let D = L();
    C(4, () => {
      N(), D?.getAttribute("id") === V && F(), _.emit();
    });
  }), group: (V) => (r.current.has(V) || r.current.set(V, /* @__PURE__ */ new Set()), () => {
    s.current.delete(V), r.current.delete(V);
  }), filter: () => a.current.shouldFilter, label: l || t["aria-label"], getDisablePointerSelection: () => a.current.disablePointerSelection, listId: x, inputId: E, labelId: w, listInnerRef: S }), []);
  function O(V, I) {
    var D, z;
    let U = (z = (D = a.current) == null ? void 0 : D.filter) != null ? z : q5;
    return V ? U(V, n.current.search, I) : 0;
  }
  function j() {
    if (!n.current.search || a.current.shouldFilter === !1) return;
    let V = n.current.filtered.items, I = [];
    n.current.filtered.groups.forEach((z) => {
      let U = r.current.get(z), G = 0;
      U.forEach((J) => {
        let se = V.get(J);
        G = Math.max(se, G);
      }), I.push([z, G]);
    });
    let D = S.current;
    M().sort((z, U) => {
      var G, J;
      let se = z.getAttribute("id"), Q = U.getAttribute("id");
      return ((G = V.get(Q)) != null ? G : 0) - ((J = V.get(se)) != null ? J : 0);
    }).forEach((z) => {
      let U = z.closest(Il);
      U ? U.appendChild(z.parentElement === U ? z : z.closest(`${Il} > *`)) : D.appendChild(z.parentElement === D ? z : z.closest(`${Il} > *`));
    }), I.sort((z, U) => U[1] - z[1]).forEach((z) => {
      var U;
      let G = (U = S.current) == null ? void 0 : U.querySelector(`${Ur}[${tr}="${encodeURIComponent(z[0])}"]`);
      G?.parentElement.appendChild(G);
    });
  }
  function F() {
    let V = M().find((D) => D.getAttribute("aria-disabled") !== "true"), I = V?.getAttribute(tr);
    _.setState("value", I || void 0);
  }
  function N() {
    var V, I, D, z;
    if (!n.current.search || a.current.shouldFilter === !1) {
      n.current.filtered.count = o.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let U = 0;
    for (let G of o.current) {
      let J = (I = (V = s.current.get(G)) == null ? void 0 : V.value) != null ? I : "", se = (z = (D = s.current.get(G)) == null ? void 0 : D.keywords) != null ? z : [], Q = O(J, se);
      n.current.filtered.items.set(G, Q), Q > 0 && U++;
    }
    for (let [G, J] of r.current) for (let se of J) if (n.current.filtered.items.get(se) > 0) {
      n.current.filtered.groups.add(G);
      break;
    }
    n.current.filtered.count = U;
  }
  function T() {
    var V, I, D;
    let z = L();
    z && (((V = z.parentElement) == null ? void 0 : V.firstChild) === z && ((D = (I = z.closest(Ur)) == null ? void 0 : I.querySelector(Y5)) == null || D.scrollIntoView({ block: "nearest" })), z.scrollIntoView({ block: "nearest" }));
  }
  function L() {
    var V;
    return (V = S.current) == null ? void 0 : V.querySelector(`${Vv}[aria-selected="true"]`);
  }
  function M() {
    var V;
    return Array.from(((V = S.current) == null ? void 0 : V.querySelectorAll(Dp)) || []);
  }
  function A(V) {
    let I = M()[V];
    I && _.setState("value", I.getAttribute(tr));
  }
  function $(V) {
    var I;
    let D = L(), z = M(), U = z.findIndex((J) => J === D), G = z[U + V];
    (I = a.current) != null && I.loop && (G = U + V < 0 ? z[z.length - 1] : U + V === z.length ? z[0] : z[U + V]), G && _.setState("value", G.getAttribute(tr));
  }
  function k(V) {
    let I = L(), D = I?.closest(Ur), z;
    for (; D && !z; ) D = V > 0 ? rD(D, Ur) : sD(D, Ur), z = D?.querySelector(Dp);
    z ? _.setState("value", z.getAttribute(tr)) : $(V);
  }
  let H = () => A(M().length - 1), B = (V) => {
    V.preventDefault(), V.metaKey ? H() : V.altKey ? k(1) : $(1);
  }, P = (V) => {
    V.preventDefault(), V.metaKey ? A(0) : V.altKey ? k(-1) : $(-1);
  };
  return f.createElement(xo.div, { ref: e, tabIndex: -1, ...v, "cmdk-root": "", onKeyDown: (V) => {
    var I;
    (I = v.onKeyDown) == null || I.call(v, V);
    let D = V.nativeEvent.isComposing || V.keyCode === 229;
    if (!(V.defaultPrevented || D)) switch (V.key) {
      case "n":
      case "j": {
        y && V.ctrlKey && B(V);
        break;
      }
      case "ArrowDown": {
        B(V);
        break;
      }
      case "p":
      case "k": {
        y && V.ctrlKey && P(V);
        break;
      }
      case "ArrowUp": {
        P(V);
        break;
      }
      case "Home": {
        V.preventDefault(), A(0);
        break;
      }
      case "End": {
        V.preventDefault(), H();
        break;
      }
      case "Enter": {
        V.preventDefault();
        let z = L();
        if (z) {
          let U = new Event(bc);
          z.dispatchEvent(U);
        }
      }
    }
  } }, f.createElement("label", { "cmdk-label": "", htmlFor: R.inputId, id: R.labelId, style: lD }, l), Va(t, (V) => f.createElement(Bv.Provider, { value: _ }, f.createElement(zv.Provider, { value: R }, V))));
}), X5 = f.forwardRef((t, e) => {
  var n, o;
  let r = Vn(), s = f.useRef(null), i = f.useContext(Hv), a = Ns(), l = Wv(t), c = (o = (n = l.current) == null ? void 0 : n.forceMount) != null ? o : i?.forceMount;
  Do(() => {
    if (!c) return a.item(r, i?.id);
  }, [c]);
  let u = Gv(r, s, [t.value, t.children, s], t.keywords), d = id(), p = po((C) => C.value && C.value === u.current), m = po((C) => c || a.filter() === !1 ? !0 : C.search ? C.filtered.items.get(r) > 0 : !0);
  f.useEffect(() => {
    let C = s.current;
    if (!(!C || t.disabled)) return C.addEventListener(bc, h), () => C.removeEventListener(bc, h);
  }, [m, t.onSelect, t.disabled]);
  function h() {
    var C, _;
    g(), (_ = (C = l.current).onSelect) == null || _.call(C, u.current);
  }
  function g() {
    d.setState("value", u.current, !0);
  }
  if (!m) return null;
  let { disabled: y, value: v, onSelect: x, forceMount: w, keywords: E, ...S } = t;
  return f.createElement(xo.div, { ref: fo(s, e), ...S, id: r, "cmdk-item": "", role: "option", "aria-disabled": !!y, "aria-selected": !!p, "data-disabled": !!y, "data-selected": !!p, onPointerMove: y || a.getDisablePointerSelection() ? void 0 : g, onClick: y ? void 0 : h }, t.children);
}), Z5 = f.forwardRef((t, e) => {
  let { heading: n, children: o, forceMount: r, ...s } = t, i = Vn(), a = f.useRef(null), l = f.useRef(null), c = Vn(), u = Ns(), d = po((m) => r || u.filter() === !1 ? !0 : m.search ? m.filtered.groups.has(i) : !0);
  Do(() => u.group(i), []), Gv(i, a, [t.value, t.heading, l]);
  let p = f.useMemo(() => ({ id: i, forceMount: r }), [r]);
  return f.createElement(xo.div, { ref: fo(a, e), ...s, "cmdk-group": "", role: "presentation", hidden: d ? void 0 : !0 }, n && f.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), Va(t, (m) => f.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, f.createElement(Hv.Provider, { value: p }, m))));
}), J5 = f.forwardRef((t, e) => {
  let { alwaysRender: n, ...o } = t, r = f.useRef(null), s = po((i) => !i.search);
  return !n && !s ? null : f.createElement(xo.div, { ref: fo(r, e), ...o, "cmdk-separator": "", role: "separator" });
}), Q5 = f.forwardRef((t, e) => {
  let { onValueChange: n, ...o } = t, r = t.value != null, s = id(), i = po((c) => c.search), a = po((c) => c.selectedItemId), l = Ns();
  return f.useEffect(() => {
    t.value != null && s.setState("search", t.value);
  }, [t.value]), f.createElement(xo.input, { ref: e, ...o, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": a, id: l.inputId, type: "text", value: r ? t.value : i, onChange: (c) => {
    r || s.setState("search", c.target.value), n?.(c.target.value);
  } });
}), eD = f.forwardRef((t, e) => {
  let { children: n, label: o = "Suggestions", ...r } = t, s = f.useRef(null), i = f.useRef(null), a = po((c) => c.selectedItemId), l = Ns();
  return f.useEffect(() => {
    if (i.current && s.current) {
      let c = i.current, u = s.current, d, p = new ResizeObserver(() => {
        d = requestAnimationFrame(() => {
          let m = c.offsetHeight;
          u.style.setProperty("--cmdk-list-height", m.toFixed(1) + "px");
        });
      });
      return p.observe(c), () => {
        cancelAnimationFrame(d), p.unobserve(c);
      };
    }
  }, []), f.createElement(xo.div, { ref: fo(s, e), ...r, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": a, "aria-label": o, id: l.listId }, Va(t, (c) => f.createElement("div", { ref: fo(i, l.listInnerRef), "cmdk-list-sizer": "" }, c)));
}), tD = f.forwardRef((t, e) => {
  let { open: n, onOpenChange: o, overlayClassName: r, contentClassName: s, container: i, ...a } = t;
  return f.createElement(D5, { open: n, onOpenChange: o }, f.createElement(j5, { container: i }, f.createElement(L5, { "cmdk-overlay": "", className: r }), f.createElement($5, { "aria-label": t.label, "cmdk-dialog": "", className: s }, f.createElement(Uv, { ref: e, ...a }))));
}), nD = f.forwardRef((t, e) => po((n) => n.filtered.count === 0) ? f.createElement(xo.div, { ref: e, ...t, "cmdk-empty": "", role: "presentation" }) : null), oD = f.forwardRef((t, e) => {
  let { progress: n, children: o, label: r = "Loading...", ...s } = t;
  return f.createElement(xo.div, { ref: e, ...s, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": r }, Va(t, (i) => f.createElement("div", { "aria-hidden": !0 }, i)));
}), Wr = Object.assign(Uv, { List: eD, Item: X5, Input: Q5, Group: Z5, Separator: J5, Dialog: tD, Empty: nD, Loading: oD });
function rD(t, e) {
  let n = t.nextElementSibling;
  for (; n; ) {
    if (n.matches(e)) return n;
    n = n.nextElementSibling;
  }
}
function sD(t, e) {
  let n = t.previousElementSibling;
  for (; n; ) {
    if (n.matches(e)) return n;
    n = n.previousElementSibling;
  }
}
function Wv(t) {
  let e = f.useRef(t);
  return Do(() => {
    e.current = t;
  }), e;
}
var Do = typeof window > "u" ? f.useEffect : f.useLayoutEffect;
function nr(t) {
  let e = f.useRef();
  return e.current === void 0 && (e.current = t()), e;
}
function po(t) {
  let e = id(), n = () => t(e.snapshot());
  return f.useSyncExternalStore(e.subscribe, n, n);
}
function Gv(t, e, n, o = []) {
  let r = f.useRef(), s = Ns();
  return Do(() => {
    var i;
    let a = (() => {
      var c;
      for (let u of n) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (c = u.current.textContent) == null ? void 0 : c.trim() : r.current;
      }
    })(), l = o.map((c) => c.trim());
    s.value(t, a, l), (i = e.current) == null || i.setAttribute(tr, a), r.current = a;
  }), r;
}
var iD = () => {
  let [t, e] = f.useState(), n = nr(() => /* @__PURE__ */ new Map());
  return Do(() => {
    n.current.forEach((o) => o()), n.current = /* @__PURE__ */ new Map();
  }, [t]), (o, r) => {
    n.current.set(o, r), e({});
  };
};
function aD(t) {
  let e = t.type;
  return typeof e == "function" ? e(t.props) : "render" in e ? e.render(t.props) : t;
}
function Va({ asChild: t, children: e }, n) {
  return t && f.isValidElement(e) ? f.cloneElement(aD(e), { ref: e.ref }, n(e.props.children)) : n(e);
}
var lD = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const cD = (t) => typeof t == "object" && t !== null && typeof t.body == "string", uD = () => new AbortController().signal, dD = () => Promise.resolve(!1), fD = () => Promise.resolve(), pD = () => {
}, mD = (t) => {
  const e = ee.c(23), {
    open: n,
    onClose: o
  } = t, r = Ki(Ss), s = ag();
  let i;
  e: {
    if (!n) {
      let S;
      e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = [], e[0] = S) : S = e[0], i = S;
      break e;
    }
    const x = r ? r.confirm : dD, w = r ? r.dispatch : fD;
    let E;
    if (e[1] !== s || e[2] !== r || e[3] !== x || e[4] !== w) {
      const S = {
        chain: s,
        confirm: x,
        dispatch: w,
        selection: [],
        signal: uD(),
        toast: r ? r.toast : pD
      };
      E = [], Bt.actionsById.forEach((C, _) => {
        const R = C.action, O = hD(s, C.scopeTypeId);
        if (R.hidden && R.hidden(O, S))
          return;
        const j = typeof R.label == "function" ? R.label(O, S) : R.label;
        let F = R.icon;
        typeof R.icon == "function" && R.icon.length === 2 && (F = R.icon(O, S)), E.push({
          action: {
            ...R,
            id: _
          },
          icon: F,
          label: j,
          payload: O,
          scopeTypeId: C.scopeTypeId,
          shortcut: R.shortcut
        });
      }), e[1] = s, e[2] = r, e[3] = x, e[4] = w, e[5] = E;
    } else
      E = e[5];
    i = E;
  }
  const a = i;
  let l;
  e[6] !== r || e[7] !== o ? (l = (x) => {
    o(), r && r.dispatch(x.action.id, x.payload, "palette").catch(gD);
  }, e[6] = r, e[7] = o, e[8] = l) : l = e[8];
  const c = l;
  let u;
  e[9] !== o ? (u = (x) => {
    x || o();
  }, e[9] = o, e[10] = u) : u = e[10];
  let d, p;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = /* @__PURE__ */ b.jsx(pu, { className: "sr-only", children: "Command palette" }), p = /* @__PURE__ */ b.jsx(mu, { className: "sr-only", children: "Search and run a command. Use the arrow keys to navigate." }), e[11] = d, e[12] = p) : (d = e[11], p = e[12]);
  let m;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = ae("flex w-full flex-col gap-1 p-2 text-sm"), e[13] = m) : m = e[13];
  let h;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = /* @__PURE__ */ b.jsx(Wr.Input, { placeholder: "Type a command…", className: ae("border-default bg-transparent text-primary placeholder:text-muted", "h-9 rounded-md border px-3 outline-none focus:border-ring-focus") }), e[14] = h) : h = e[14];
  let g;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ b.jsx(Wr.Empty, { className: "text-muted py-6 text-center text-sm", children: "No results found." }), e[15] = g) : g = e[15];
  let y;
  e[16] !== a || e[17] !== c ? (y = /* @__PURE__ */ b.jsxs(fu, { showCloseButton: !1, size: "lg", padded: !1, className: "overflow-hidden", "data-slot": "command-palette", children: [
    d,
    p,
    /* @__PURE__ */ b.jsxs(Wr, { label: "Command palette", className: m, children: [
      h,
      /* @__PURE__ */ b.jsxs(Wr.List, { className: "max-h-80 overflow-y-auto py-1", children: [
        g,
        a.map((x) => {
          const w = cD(x.icon) ? x.icon : null, E = x.shortcut ? lo.parse(x.shortcut) : null;
          return /* @__PURE__ */ b.jsxs(Wr.Item, { value: `${x.label} ${x.action.id} ${x.scopeTypeId}`, onSelect: () => c(x), className: ae("data-[selected=true]:bg-action-secondary data-[selected=true]:text-primary", "flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 outline-none"), children: [
            w ? /* @__PURE__ */ b.jsx(Ve, { className: "size-4 shrink-0", icon: w }) : null,
            /* @__PURE__ */ b.jsx("span", { className: "grow truncate", children: x.label }),
            /* @__PURE__ */ b.jsx("span", { className: "text-muted text-xs", children: x.scopeTypeId }),
            E ? /* @__PURE__ */ b.jsx("span", { className: "text-muted ml-1", children: /* @__PURE__ */ b.jsx(nd, { parsed: E }) }) : null
          ] }, x.action.id);
        })
      ] })
    ] })
  ] }), e[16] = a, e[17] = c, e[18] = y) : y = e[18];
  let v;
  return e[19] !== n || e[20] !== u || e[21] !== y ? (v = /* @__PURE__ */ b.jsx(du, { open: n, onOpenChange: u, children: y }), e[19] = n, e[20] = u, e[21] = y, e[22] = v) : v = e[22], v;
}, hD = (t, e) => {
  for (const n of t)
    if (n.scopeTypeId === e) return n.payload;
  return {};
};
function gD() {
}
const bD = (t) => {
  const e = ee.c(24), {
    body: n,
    cancelLabel: o,
    confirmLabel: r,
    destructive: s,
    onCancel: i,
    onConfirm: a,
    open: l,
    title: c
  } = t, u = o === void 0 ? "Cancel" : o, d = r === void 0 ? "Confirm" : r;
  let p;
  e[0] !== i ? (p = (S) => {
    S || i();
  }, e[0] = i, e[1] = p) : p = e[1];
  let m;
  e[2] !== c ? (m = c ? /* @__PURE__ */ b.jsx(Fg, { children: /* @__PURE__ */ b.jsx(pu, { children: c }) }) : null, e[2] = c, e[3] = m) : m = e[3];
  let h;
  e[4] !== n ? (h = /* @__PURE__ */ b.jsx(mu, { children: n }), e[4] = n, e[5] = h) : h = e[5];
  let g;
  e[6] !== u || e[7] !== i ? (g = /* @__PURE__ */ b.jsx(kt, { variant: "outline", onClick: i, children: u }), e[6] = u, e[7] = i, e[8] = g) : g = e[8];
  const y = s ? "destructive" : "primary";
  let v;
  e[9] !== d || e[10] !== a || e[11] !== y ? (v = /* @__PURE__ */ b.jsx(kt, { variant: y, onClick: a, children: d }), e[9] = d, e[10] = a, e[11] = y, e[12] = v) : v = e[12];
  let x;
  e[13] !== g || e[14] !== v ? (x = /* @__PURE__ */ b.jsxs(iT, { children: [
    g,
    v
  ] }), e[13] = g, e[14] = v, e[15] = x) : x = e[15];
  let w;
  e[16] !== m || e[17] !== h || e[18] !== x ? (w = /* @__PURE__ */ b.jsxs(fu, { showCloseButton: !1, children: [
    m,
    h,
    x
  ] }), e[16] = m, e[17] = h, e[18] = x, e[19] = w) : w = e[19];
  let E;
  return e[20] !== l || e[21] !== p || e[22] !== w ? (E = /* @__PURE__ */ b.jsx(du, { open: l, onOpenChange: p, children: w }), e[20] = l, e[21] = p, e[22] = w, e[23] = E) : E = e[23], E;
}, vD = (t) => {
  const e = ee.c(14), {
    open: n,
    onClose: o
  } = t, r = ag();
  let s;
  e: {
    if (!n) {
      let m;
      e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = [], e[0] = m) : m = e[0], s = m;
      break e;
    }
    let p;
    if (e[1] !== r) {
      const m = /* @__PURE__ */ new Map(), h = [];
      Bt.actionsById.forEach((g, y) => {
        const {
          action: v
        } = g;
        if (!v.shortcut)
          return;
        const x = lo.parse(v.shortcut);
        if (!x)
          return;
        const w = typeof v.label == "function" ? y : v.label;
        h.push({
          entry: {
            action: {
              ...v,
              id: y
            },
            label: w,
            parsed: x,
            shadowedBy: null,
            shortcut: v.shortcut
          },
          scopeTypeId: g.scopeTypeId
        });
      });
      for (const g of h) {
        g.entry.shadowedBy = yD(r, h, g.scopeTypeId, g.entry.parsed);
        const y = m.get(g.scopeTypeId) ?? [];
        y.push(g.entry), m.set(g.scopeTypeId, y);
      }
      p = Array.from(m.entries()).map(wD).sort(SD), e[1] = r, e[2] = p;
    } else
      p = e[2];
    s = p;
  }
  const i = s;
  let a;
  e[3] !== o ? (a = (p) => {
    p || o();
  }, e[3] = o, e[4] = a) : a = e[4];
  let l;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ b.jsxs(Fg, { children: [
    /* @__PURE__ */ b.jsx(pu, { children: "Keyboard shortcuts" }),
    /* @__PURE__ */ b.jsx(mu, { children: "Bindings active for the current scope chain." })
  ] }), e[5] = l) : l = e[5];
  let c;
  e[6] !== i ? (c = i.length === 0 ? /* @__PURE__ */ b.jsx("p", { className: "text-muted py-4 text-center text-sm", children: "No shortcuts registered." }) : i.map(CD), e[6] = i, e[7] = c) : c = e[7];
  let u;
  e[8] !== c ? (u = /* @__PURE__ */ b.jsxs(fu, { showCloseButton: !0, "data-slot": "shortcut-help", size: "md", children: [
    l,
    /* @__PURE__ */ b.jsx("div", { className: "max-h-96 overflow-y-auto pr-1", children: c })
  ] }), e[8] = c, e[9] = u) : u = e[9];
  let d;
  return e[10] !== n || e[11] !== a || e[12] !== u ? (d = /* @__PURE__ */ b.jsx(du, { open: n, onOpenChange: a, children: u }), e[10] = n, e[11] = a, e[12] = u, e[13] = d) : d = e[13], d;
}, yD = (t, e, n, o) => {
  const r = t.findIndex((s) => s.scopeTypeId === n);
  if (r < 0) return null;
  for (let s = r + 1; s < t.length; s++) {
    const i = t[s].scopeTypeId;
    if (i === n) continue;
    if (e.some((l) => l.scopeTypeId === i && xD(l.entry.parsed, o))) return i;
  }
  return null;
}, xD = (t, e) => {
  if (t.key !== e.key || t.modifiers.length !== e.modifiers.length) return !1;
  for (let n = 0; n < t.modifiers.length; n++) if (t.modifiers[n] !== e.modifiers[n]) return !1;
  return !0;
};
function wD(t) {
  const [e, n] = t;
  return {
    entries: n,
    scopeTypeId: e
  };
}
function SD(t, e) {
  return t.scopeTypeId.localeCompare(e.scopeTypeId);
}
function ED(t) {
  return /* @__PURE__ */ b.jsxs("li", { "data-shadowed": t.shadowedBy ? "" : void 0, title: t.shadowedBy ? `Shadowed by scope '${t.shadowedBy}'` : void 0, className: ae("flex items-center justify-between gap-2 rounded-md px-2 py-1 text-sm", t.shadowedBy ? "text-muted line-through" : ""), children: [
    /* @__PURE__ */ b.jsx("span", { className: "grow truncate", children: t.label }),
    /* @__PURE__ */ b.jsx("span", { className: "text-muted", children: /* @__PURE__ */ b.jsx(nd, { parsed: t.parsed }) })
  ] }, t.action.id);
}
function CD(t) {
  return /* @__PURE__ */ b.jsxs("section", { className: "mb-4", children: [
    /* @__PURE__ */ b.jsx("h3", { className: "text-muted mb-1 text-xs font-medium uppercase tracking-wide", children: t.scopeTypeId }),
    /* @__PURE__ */ b.jsx("ul", { className: "flex flex-col gap-1", children: t.entries.map(ED) })
  ] }, t.scopeTypeId);
}
const _D = (t, e) => {
  switch (e?.variant) {
    case "success":
      Zr.success(t, {
        duration: e.duration
      });
      break;
    case "error":
      Zr.error(t, {
        duration: e.duration
      });
      break;
    case "warning":
      Zr.warning(t, {
        duration: e.duration
      });
      break;
    default:
      Zr(t, {
        duration: e?.duration
      });
  }
}, RD = (t) => {
  const e = ee.c(9), n = Ki(Ss);
  if (!n)
    return null;
  let o;
  e[0] !== n || e[1] !== t.commandPalette ? (o = t.commandPalette ? /* @__PURE__ */ b.jsx(mD, { open: n.paletteOpen, onClose: () => n.setPaletteOpen(!1) }) : null, e[0] = n, e[1] = t.commandPalette, e[2] = o) : o = e[2];
  let r;
  e[3] !== n || e[4] !== t.shortcutHelp ? (r = t.shortcutHelp ? /* @__PURE__ */ b.jsx(vD, { open: n.helpOpen, onClose: () => n.setHelpOpen(!1) }) : null, e[3] = n, e[4] = t.shortcutHelp, e[5] = r) : r = e[5];
  let s;
  return e[6] !== o || e[7] !== r ? (s = /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    o,
    r
  ] }), e[6] = o, e[7] = r, e[8] = s) : s = e[8], s;
}, jL = (t) => {
  const e = ee.c(18);
  let n, o, r, s, i;
  e[0] !== t ? ({
    children: n,
    toaster: r,
    commandPalette: s,
    shortcutHelp: i,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = s, e[5] = i) : (n = e[1], o = e[2], r = e[3], s = e[4], i = e[5]);
  const a = r === void 0 ? !1 : r, l = s === void 0 ? !0 : s, c = i === void 0 ? !0 : i;
  let u;
  e[6] !== l || e[7] !== c ? (u = /* @__PURE__ */ b.jsx(RD, { commandPalette: l, shortcutHelp: c }), e[6] = l, e[7] = c, e[8] = u) : u = e[8];
  let d;
  e[9] !== a ? (d = a ? /* @__PURE__ */ b.jsx(WP, {}) : null, e[9] = a, e[10] = d) : d = e[10];
  let p;
  return e[11] !== n || e[12] !== l || e[13] !== o || e[14] !== c || e[15] !== u || e[16] !== d ? (p = /* @__PURE__ */ b.jsxs(bC, { ConfirmDialog: bD, Menu: U4, toast: _D, commandPalette: l, shortcutHelp: c, ...o, children: [
    n,
    u,
    d
  ] }), e[11] = n, e[12] = l, e[13] = o, e[14] = c, e[15] = u, e[16] = d, e[17] = p) : p = e[17], p;
};
export {
  ID as Accordion,
  PD as AccordionContent,
  OD as AccordionItem,
  MD as AccordionTrigger,
  U4 as ActionMenu,
  jL as ActionRoot,
  AD as Alert,
  LD as AlertAction,
  jD as AlertDescription,
  $D as AlertDialog,
  GD as AlertDialogAction,
  KD as AlertDialogCancel,
  VD as AlertDialogContent,
  WD as AlertDialogDescription,
  BD as AlertDialogFooter,
  zD as AlertDialogHeader,
  HD as AlertDialogMedia,
  ME as AlertDialogOverlay,
  OE as AlertDialogPortal,
  UD as AlertDialogTitle,
  FD as AlertDialogTrigger,
  DD as AlertTitle,
  kL as AppLayoutBeta,
  YD as Avatar,
  ZD as AvatarBadge,
  XD as AvatarFallback,
  JD as AvatarGroup,
  QD as AvatarGroupCount,
  qD as AvatarImage,
  ej as Badge,
  tj as Breadcrumb,
  aj as BreadcrumbEllipsis,
  oj as BreadcrumbItem,
  rj as BreadcrumbLink,
  nj as BreadcrumbList,
  sj as BreadcrumbPage,
  ij as BreadcrumbSeparator,
  kt as Button,
  Ak as Caption,
  lj as Card,
  fj as CardAction,
  pj as CardContent,
  dj as CardDescription,
  mj as CardFooter,
  cj as CardHeader,
  uj as CardTitle,
  Po as Checkbox,
  bj as ChoiceList,
  vj as Collapsible,
  xj as CollapsibleContent,
  yj as CollapsibleTrigger,
  mD as CommandPalette,
  xg as CopyButton,
  wj as DataTable,
  bD as DefaultConfirmDialog,
  du as Dialog,
  Cj as DialogBody,
  Ej as DialogClose,
  fu as DialogContent,
  mu as DialogDescription,
  iT as DialogFooter,
  Fg as DialogHeader,
  sT as DialogOverlay,
  rT as DialogPortal,
  pu as DialogTitle,
  Sj as DialogTrigger,
  _j as DropdownMenu,
  Aj as DropdownMenuCheckboxItem,
  PT as DropdownMenuContent,
  kj as DropdownMenuGroup,
  Ij as DropdownMenuItem,
  Tj as DropdownMenuLabel,
  Rj as DropdownMenuPortal,
  Dj as DropdownMenuRadioGroup,
  jj as DropdownMenuRadioItem,
  Lj as DropdownMenuSeparator,
  $j as DropdownMenuShortcut,
  Oj as DropdownMenuSub,
  Pj as DropdownMenuSubContent,
  Mj as DropdownMenuSubTrigger,
  Nj as DropdownMenuTrigger,
  hj as ErrorBoundaryAlpha,
  XC as ErrorBoundaryAlphaFallback,
  qC as ErrorBoundaryAlphaInternals,
  Bj as Field,
  Hj as FieldContent,
  Gj as FieldDescription,
  Yj as FieldError,
  zj as FieldGroup,
  Uj as FieldLabel,
  Vj as FieldLegend,
  Kj as FieldSeparator,
  Fj as FieldSet,
  Wj as FieldTitle,
  qj as FormMultiSelect,
  Xj as HeaderMultiSelectFilter,
  Zj as HeaderRadioFilter,
  no as Icon,
  Tg as Input,
  Jj as InputOTP,
  Qj as InputOTPGroup,
  tL as InputOTPSeparator,
  eL as InputOTPSlot,
  AT as Label,
  CN as LayoutResetButton,
  AL as MdxLayout,
  yN as Modal,
  nL as NativeSelect,
  rL as NativeSelectOptGroup,
  oL as NativeSelectOption,
  Og as OverlayDragRegion,
  L_ as ProgressBar,
  sL as RadioGroup,
  iL as RadioGroupItem,
  PL as RefreshFailureToast,
  TN as ReorderGrip,
  C2 as ResizeHandle,
  i2 as Scrollable,
  aL as SegmentedControl,
  lL as Select,
  fL as SelectContent,
  cL as SelectGroup,
  mL as SelectItem,
  pL as SelectLabel,
  SM as SelectScrollDownButton,
  wM as SelectScrollUpButton,
  hL as SelectSeparator,
  dL as SelectTrigger,
  uL as SelectValue,
  DT as Separator,
  nd as ShortcutGlyphs,
  vD as ShortcutHelp,
  zN as Skeleton,
  gL as Slider,
  O2 as SortIndicator,
  bL as Spinner,
  td as SplitPaneCollapseContext,
  vr as SplitPaneInsetContext,
  OL as SplitTriple,
  ML as SplitVertical,
  wN as Switch,
  bl as TBody,
  Pk as THead,
  Mk as Table,
  JN as TableBulkActions,
  Z2 as TableEmptyState,
  BN as TableSkeletonRows,
  vL as Tabs,
  wL as TabsContent,
  yL as TabsList,
  xL as TabsTrigger,
  qs as Td,
  SL as Textarea,
  Jf as Th,
  WP as Toaster,
  EL as Tooltip,
  _L as TooltipContent,
  l3 as TooltipProvider,
  CL as TooltipTrigger,
  Ys as Tr,
  z0 as alertVariants,
  AE as badgeVariants,
  HM as tabsListVariants,
  Zr as toast,
  RL as useClientTableQuery,
  a2 as useColumnLayout,
  gj as useIsMobile,
  d2 as usePagination,
  m2 as useRowSelection,
  NL as useServerTableQuery,
  b2 as useSort,
  TL as useSplitPaneCollapse,
  IL as useSplitPaneInset
};
